const destinos = [
    {
        "destinoId": 0,
        titulo: "Hoteles en Cancún y Riviera Maya",
        destino: "Playa del Carmen",
        hoteles: [
            { name: "Hotel Xcaret Mexico All Parks All Fun Inclusive" }]
    },
    {
        "destinoId": 1,
        titulo: "Hoteles en Cancún y Riviera Maya",
        destino: "Cancún",
        hoteles: [
            { name: "Residence Inn by Marriott Cancun Hotel Zone" },
            { name: "Aloft Cancún" },
            { name: "Dreams Vista Cancun Golf & Spa Resort" },
            { name: "Riu Lupita All Inclusive" },
            { name: "Club Hotel Riu Tequila" },
            { name: "Riu Yucatán All Inclusive" },
            { name: "Riu Dunamar All Inclusive" },
            { name: "Riu Playacar" },
            { name: "Occidental Costa Cancún" },
            { name: "All Ritmo Cancún Resort & Waterpark" },
            { name: "The Royal Sands All Suites Resort & Spa" },
            { name: "Grand Oasis Palm Cancún" },
            { name: "Cancun Bay All Inclusive Hotel" },
            { name: "Wyndham Alltra Cancun All Inclusive Resort" },
            { name: "Dreams Sands Cancún Resort & Spa" },
            { name: "Hotel Xcaret Mexico All Parks All Fun Inclusive" },
            { name: "Grand Park Royal Cancún" },
            { name: "Moon Palace Cancún" },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El Deli Market & Coffee Shop está abierto de 07:00 a 23:00 hrs. El servicio a la habitación no están incluidos."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Restaurantes: Cúa, Sunset Grill y Bacoli (especialidad italiana a la carta), Legacy (Sports bar), 2 Pool Bar, 1 Beach Bar.\r\n\r\nHorarios: desayuno de 7:00 a 12:00 hrs., almuerzo de 13:00 a 17:00 hrs. y cena de 18:00 a 23:00 hrs."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    }
                ],
                "description": "Emporio Cancún es un hotel de playa con tres planes de alimentos ideal para familias, con un diseño arquitectónico contemporáneo mexicano. En la propiedad hay cinco piscinas, dos son para niños y una tipo infinity exclusiva para adultos; además hay un centro de actividades deportivas. También posee tres restaurantes, uno donde se ofrece servicio buffet asistido, otro de comida mexicana y otro de especialidades italianas. Además, brinda acceso a internet inalámbrico. \r\n\r\nEste hotel en Cancún cuenta con centro de negocios, mesa de tours, gimnasio abierto las 24 horas y servicios de spa. También ofrece 464 habitaciones y suites con balcón, vista al mar, aire acondicionado y televisión de pantalla plana. \r\n\r\nEl Museo Maya de Cancún se encuentra a menos de 500 metros, la Zona Arqueológica El Rey está a 2 kilómetros y el centro comercial La Isla, que tiene un diseño inspirado en los canales de Venecia, se ubica a 5 kilómetros. El Aeropuerto Internacional de Cancún (CUN) se halla a 16 kilómetros de distancia. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $76.00 MXN o $4.50 USD por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/e9e1a1fc32888b9ad11f4cb8527f3fe0e1aa67e7d9459d8aabcb4974bf60a4f5_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con acceso directo a la piscina - Frente al mar - Solo adultos",
                        "cloudUri": "https://img.cdnpth.com/media/157062/7eb6ebc0fb2df8ca1dc2b8b137b7e89f9c34db5426f48565027b9c9e829fa323.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/a232bfcf4fe7ba8cd53715ce6f1770b1430f591c7a133361af2c5f19d2c82daf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/32c17cc92bda6685eefd86156a235b93ebf1f3d2aedc3fba17017895ab25909c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/21340bfd83596ee0060d1f988c0a7cff120779a0d17c53ab8a9d5311c2821155.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/c072cd08cd948750b1aa6ec9a81419069703ed00591cdbb08360d37e6a33adc2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe con vistas parciales al mar ",
                        "cloudUri": "https://img.cdnpth.com/media/157062/efef11f0297ee58305c64bc8aad7749ae90746cfed7a8cbdbf0e63eaa0f0f69c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/7040318170ff976e20127fcf8237adc3fcb95821e5e7704b57b941fbaf66247d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/00ce8d32a55f0c2dba4d6d3d40c35ca5783b0ac77c4dd4e97d0ace6da8235690.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/eaef0d6d2107c80cb64fa919dbab644c63f2d8d05acbc30c6d48a17ef52ef3d5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/6215a9a4ee941ab0646c396e2179b2e2ebd0f556a1940a4fa0d94c7d5f279df6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/dcdb6ede2dee4a3254a9e747f42169ea56bec63aed64fd6e26141cdf3642cfc0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/62ed1036467d3aa3ec4e1f0cc034cf76f40b1a410dc979d7729870710dacf4d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/1d162ae35d035ca5160893d91daa2dd7a7cbc977ee5504db5d32c24991c73783.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/f2d143e3d5db18663fbf305e8c05e144e5c970860c5c36af77b12d4962b8847e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/05145eeab86ae81a2e38f40cdfa171e44d7825144d9674c970de1f5ac3bd7f10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/c8ee24344b0a6d33ec048551f995b015a2924dc1aebaf47cd7c059b6c41579db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/abce6d62d87c60f5dc36c1b33798b1f68318ce9c10275382d98628f513be85a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/546f22a3412a5f482d18a69a747c90c547db3d1433f2b3e83855cd7f26053aa6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/234b80c70df28fdb4b6cfa29b3b11abe008393de643c51a456d0368a40c3c32e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/126de308d213d5946a69b9559cd262dc933ca4c0683641f4d58531b0d4c60866.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/4492e1e1489a98f83ff7737d38106cd0cc7d26ff00d260c899fa77ee4d341e75.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/ed3c6761a020f1a1b5f9eecef054ff4eda260700abe5b1c56084e0252089727d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/12477902d25fcd65fb3306ea994df8762b4bd93b17c275ea692f49fb6387688f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/0b4c76675722f64b0422fc8ee3ade4e6ba06626931c5c47d25b8de2b5ccefbfb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/87132293ea7c7faed319e325695bd288bdf26227145caadd1a184e4bba2ec573.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/87e92df2e5d33e008226603c3d639775f6c6fc140bcb295032b611f9c2f63aac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/c8a3fd932e996b4ce55bb92d39611136ca34302d73a28696d4a708dee9a2aa76.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/aa55a79301e357f2d3f0cfad34992b09c6952682ae9c9ab8f14ad7c29e43354a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/3edb3acf905c6114e61844fcfcc76afd25ac32b6b29c139571780486272af13d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/d97c1aa4ee9a9ea53d0e573c115d862167818903382da092a1e0ae3f31219b2d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/c55e0a3a067edf9d8e2d5d2b9529ca69f5d0f1766d1be86c48e8eff975143f11.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/51f4b396e8ae3f882077227e3210561b486c868f0e2792da83005ab5df4fdd61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/d5a1b365d628de17bcd65909627b923cd830a90a65e4b28066a382b9818a468e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/3327041aafe4a3a631c0a166ead303625f44f1c130fc5b82b94b9dbee67ef79d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/441f2f8dca136f62fac1665d66e209171443cc5683b156263412d31f1be89337.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/10033beabb0d6b763477b897f2b4b1daead18a2d5c810c2d65910e9f57cd0e30.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/794a64f605edba64187938e285ed526fac4d0c5cb2cd7ade60034167d94079e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/6356fe671be48c16c1ee983100c72dd92f472ddeec533dbcad9510bb615b2f40.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Deluxe - Cama extragrande - Frente al océano",
                        "cloudUri": "https://img.cdnpth.com/media/157062/60ab7834e3fd4402eb4a28906497490508b5358b46249be6ad0b1865f110fc05.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/a5dddd9c3c73be7388523835923554716fd4f5560141905e802d4c252475a813.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/1e8fc4c251743ad1de7db8f2e28f3f930065afd9935a94cd029a61e5bc456a1e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/157062/eac1f3abf7e03caa67905c4e95317e94b7002601a8986f6bf8f5cfb09df92985.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con acceso directo a la piscina - Frente al mar - Solo adultos",
                        "cloudUri": "https://img.cdnpth.com/media/157062/a7f0d9827dce45ca54a02913c7bae5637037f30a0b17e605ae12a00540ce8abd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con acceso directo a la piscina - Frente al mar - Solo adultos",
                        "cloudUri": "https://img.cdnpth.com/media/157062/7acc809dfb16504b6dad0166b8903c22ecc1d60869c97630cea9982528f81250.png"
                    }
                ],
                "hotelID": 157062,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Tres piscinas de agua dulce y una piscina para niños"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.07353812702457",
                    "longitude": "-86.77656412124634",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcán, Ret Cucumatz km 17 L 49, Segunda Etapa, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Emporio Cancun - with Optional All Inclusive",
                "placeContainers": [
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10,
                        "code": "CUN"
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18,
                        "code": "QROO"
                    },
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6,
                        "code": "26"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Sunset Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar de Piscina",
                        "type": "Bar"
                    },
                    {
                        "name": "Bácoli",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar de Playa",
                        "type": "Bar"
                    },
                    {
                        "name": "Deli Market & Coffee Shop",
                        "type": "Restaurante"
                    },
                    {
                        "name": "CúA",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Legacy Sports bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9268690,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590250,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590271,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590295,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590317,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590339,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590361,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590381,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590402,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590417,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590431,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590449,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590465,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590479,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590494,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590516,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590537,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590554,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590569,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590586,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590603,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590622,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590639,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590655,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590672,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590690,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590709,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590728,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590747,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590764,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590781,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590799,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590819,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590839,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590859,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590882,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590904,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590923,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590944,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590965,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590987,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591010,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591034,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591056,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591080,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591104,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591126,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591149,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591171,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591195,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591218,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591240,
                        "kidsFreeTo": 0,
                        "name": "Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591262,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591287,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591311,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591334,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591358,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591381,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591406,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591431,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591455,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591478,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591502,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591525,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591549,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591572,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591596,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591619,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591644,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591667,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591691,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591716,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591740,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591764,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591787,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591815,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591839,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591864,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591891,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591915,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591940,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591966,
                        "kidsFreeTo": 0,
                        "name": "Suite Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591995,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592023,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592051,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592077,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592102,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592129,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592155,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592180,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592208,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592236,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592263,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592291,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592319,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592347,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592372,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592401,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592429,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592455,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592481,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674517,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674534,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674551,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674568,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4112936,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe doble",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas de casal",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4542593,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/hnBbNGp1rz54zdXlOGiTdB3mRe4=/720x480/03/02/66/03026607.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/hnBbNGp1rz54zdXlOGiTdB3mRe4=/720x480/03/02/66/03026607.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4542594,
                        "kidsFreeTo": 5,
                        "name": "Suite de lujo king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/765KjOkV2l6i1I0mwLD-UcBglvc=/720x480/03/02/66/03026605.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/765KjOkV2l6i1I0mwLD-UcBglvc=/720x480/03/02/66/03026605.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas de casal",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4542595,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4542596,
                        "kidsFreeTo": 5,
                        "name": "Suite de lujo king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Sofá cama",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4728826,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe, 1 cama de matrimonio grande con sofá cama",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4736050,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe doble, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4736051,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe, 1 cama de matrimonio grande con sofá cama, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Ironing set",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Smoke detector",
                            "Televisión",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4831824,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Terrace",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4831826,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Ironing set",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Terrace",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5015705,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas de casal",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7836841,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7836842,
                        "kidsFreeTo": 5,
                        "name": "Suite de lujo king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Rociadores",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono en el baño",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas de casal",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7836843,
                        "kidsFreeTo": 0,
                        "name": "Doble swim-up frente al mar",
                        "isActive": true,
                        "view": "Alberca",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81Kyt6PSFdfNmyPlTyaKvOOeWKw=/720x480/03/02/66/03026608.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7836844,
                        "kidsFreeTo": 0,
                        "name": "King swim-up frente al mar",
                        "isActive": true,
                        "view": "Alberca",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/c1MvduXje8OUiaGbkRztS-BouqQ=/720x480/03/02/66/03026606.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7855799,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Doble Room Oceanfront",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Piscina privada",
                            "Piscina rodeada por una valla",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7855800,
                        "kidsFreeTo": 0,
                        "name": "Swim up Double Oceanfront Only Adults",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Piscina privada",
                            "Piscina rodeada por una valla",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7855801,
                        "kidsFreeTo": 0,
                        "name": "Swim up King Oceanfront Only Adults",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Artículos de higiene personal ecológicos",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Conexión a Internet wifi",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones",
                            "Sofá cama",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7855802,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite, 1 King Bed with Sofa Bed, Oceanfront",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bathtub",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Ironing set",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7859158,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcony",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Smoke detector",
                            "Televisión",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7859160,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bathtub",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Ironing set",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Terrace",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7859161,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Ironing set",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Smoke detector",
                            "Televisión",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10773623,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Desk",
                            "Direct dial telephone",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Ironing set",
                            "Make-up mirror",
                            "Microwave",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Smoke detector",
                            "Televisión",
                            "Toiletries",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10773632,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088994,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Sea Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088997,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088999,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089001,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089002,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089009,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089012,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089017,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089022,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089023,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089026,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089029,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089032,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089033,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089036,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089038,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089042,
                        "kidsFreeTo": 0,
                        "name": "Double Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089045,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089052,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089056,
                        "kidsFreeTo": 0,
                        "name": "Triple Ocean Front King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089059,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089062,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089066,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089068,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089072,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089075,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089076,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089078,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089079,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089081,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089083,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089084,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089086,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089089,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089090,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089091,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089092,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089093,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089094,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089097,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089101,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089103,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377352,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377353,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969465,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969469,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969475,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969476,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 5",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969479,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969481,
                        "kidsFreeTo": 0,
                        "name": "Suite Queen Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969483,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969484,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969487,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969489,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969490,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969491,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969492,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Premium Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969495,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969497,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969501,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969504,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969506,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969508,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969510,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969512,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969514,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969516,
                        "kidsFreeTo": 0,
                        "name": "Single With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969518,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969520,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 6",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969521,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969522,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969524,
                        "kidsFreeTo": 0,
                        "name": "Single Premium Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969525,
                        "kidsFreeTo": 0,
                        "name": "Single Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218977,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218982,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218988,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218994,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218999,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219004,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219011,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219017,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Beach Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219023,
                        "kidsFreeTo": 0,
                        "name": "Single Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219029,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219034,
                        "kidsFreeTo": 0,
                        "name": "Room Premium With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219040,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219046,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219053,
                        "kidsFreeTo": 0,
                        "name": "Single Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219060,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219068,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219076,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219082,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219088,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Beach Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219094,
                        "kidsFreeTo": 0,
                        "name": "Single Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219100,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219105,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219110,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219114,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219117,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219121,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219125,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219131,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219136,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219142,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219147,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190103,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190105,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Children share the bed with parents",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Microwave",
                            "Number of bedrooms",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190108,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190110,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190112,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190114,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190117,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190120,
                        "kidsFreeTo": 0,
                        "name": "Room Beach Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299876,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18302642,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18332475,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18332476,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482611,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587821,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587844,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587868,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587890,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587912,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587935,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587959,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587984,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588007,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588031,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588055,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588079,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588103,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588131,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588156,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588181,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588207,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588234,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588260,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588287,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588313,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588336,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588362,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588389,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588415,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588442,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588469,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588495,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588520,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588544,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588566,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588588,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588610,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588632,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588651,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588671,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588696,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588720,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588745,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588768,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588792,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588817,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588844,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588867,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588890,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588914,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588937,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588960,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588985,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589009,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589035,
                        "kidsFreeTo": 0,
                        "name": "Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589060,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589086,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589110,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589134,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589158,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589183,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589210,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589238,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589264,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589291,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589318,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589345,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589373,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589401,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589429,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589456,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589482,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589507,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589533,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589559,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589584,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589610,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589637,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589662,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589688,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589712,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589736,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589760,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589785,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589810,
                        "kidsFreeTo": 0,
                        "name": "Suite Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589835,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589860,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589881,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589904,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589926,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589947,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589969,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589990,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590011,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590031,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590051,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590071,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590092,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590112,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590134,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590155,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590178,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590200,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590222,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647516,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Reloj despertador",
                            "Secador",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647517,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "5 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bicicletas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Minisúper",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.9,
                    "totalSurveys": 1203,
                    "valuesAverage": [
                        4.4
                    ]
                },
                "title": "Hotel de playa todo incluido para familias en Cancún con tres piscinas",
                "uri": "emporio-cancun",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Villas, condominios y departamentos"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores incluyendo Jazzercise, aerobics y aquaerobics. El programa varía diariamente."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno, almuerzo y cena, incluyendo el restaurante de especialidades La Palapa y el snack-bar, así como bebidas nacionales."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye entretenimiento nocturno y dos veces por semana. El programa varia diariamente."
                    },
                    {
                        "title": "Deportes acuáticos",
                        "description": "Incluye actividades acuáticas como snorkel, bote de pedales y kayaks."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol y fútbol de playa, ping pong y juegos de mesa."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las bebidas importadas están disponibles con cargo extra."
                    }
                ],
                "description": "Aquamarina Beach es un hotel todo incluido frente al mar con diversión tanto para familias como para parejas o amigos. La propiedad cuenta con dos piscinas, dos restaurantes, un snack bar junto a la piscina y dos bares. Para el entretenimiento ofrece deportes acuáticos no motorizados en cortesía, espectáculos nocturnos y programa de actividades diarias.\r\n\r\nPara los pequeños, este hotel en Cancún, tiene una piscina para niños, área de juegos infantiles y diversas actividades para su diversión. Por otro lado, sus 169 habitaciones y suites disponen de balcón con vista parcial o total al mar, caja de seguridad, televisión y wifi, con cargo extra. Las junior suites cuentan además con área de descanso con sofá cama y cocineta.\r\n\r\nAquamarina Beach se localiza en la Zona Hotelera de Cancún, frente a la Iglesia de Cristo Resucitado. A menos de 1 kilómetro están la Marina Chac Chi, que alberga la estación de ferry a Isla Mujeres y el Teatro de Cancún, donde se presentan diversas obras y eventos artísticos. El centro de la ciudad se encuentra a 4 kilómetros con opciones de restaurantes, centros comerciales y mercados de artesanías. El Aeropuerto Internacional de Cancún (CUN) se sitúa a 24 kilómetros de distancia.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $72.65 MXN por habitación, por noche, a pagar directamente en el establecimiento.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.\r\n\r\n***La tarifa publicada en pesos mexicanos (MXN) es solo para mexicanos. Si no eres mexicano, deberás pagar una diferencia en dólares americanos (USD) directamente en el hotel.",
                "gallery": [
                    {
                        "photoID": 4861834,
                        "description": "Aquamarina Beach",
                        "cloudUri": "https://img.cdnpth.com/media/h0GQBxbZWS8SAPGWS1NqsxEk-Ag=/720x480/04/86/18/04861834.jpg"
                    },
                    {
                        "photoID": 4861837,
                        "description": "Muelle",
                        "cloudUri": "https://img.cdnpth.com/media/5wT3ygIZZETRf9FdxTZDBcuEy7Y=/720x480/04/86/18/04861837.jpg"
                    },
                    {
                        "photoID": 4861850,
                        "description": "Playa",
                        "cloudUri": "https://img.cdnpth.com/media/Wzsz1oMhzGu-YBHz2dKNJ6qq-08=/720x480/04/86/18/04861850.jpg"
                    },
                    {
                        "photoID": 4861836,
                        "description": "Vista desde la calle",
                        "cloudUri": "https://img.cdnpth.com/media/YTQglFxzn8y42tAO00ra3aASIWg=/720x480/04/86/18/04861836.jpg"
                    },
                    {
                        "photoID": 4861861,
                        "description": "Piscina de actividades",
                        "cloudUri": "https://img.cdnpth.com/media/h1L1KX3uhzdzUKZxnaT5MvEWFFo=/720x480/04/86/18/04861861.jpg"
                    },
                    {
                        "photoID": 4861856,
                        "description": "Áreas de descanso para tomar el sol",
                        "cloudUri": "https://img.cdnpth.com/media/Hy4wDyLvM39O5S9DUfquLQFio5w=/720x480/04/86/18/04861856.jpg"
                    },
                    {
                        "photoID": 4861857,
                        "description": "Vista nocturna de la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/Ktma2uZuh4LklOU8R0ZtLBFDsUA=/720x480/04/86/18/04861857.jpg"
                    },
                    {
                        "photoID": 4861858,
                        "description": "Vista nocturna",
                        "cloudUri": "https://img.cdnpth.com/media/KTNMgO5o1fg01TCvOZX6dThY9_8=/720x480/04/86/18/04861858.jpg"
                    },
                    {
                        "photoID": 4861860,
                        "description": "Piscina de relajación",
                        "cloudUri": "https://img.cdnpth.com/media/X_mOr9vS_b4jyKbYkHev0Wybdj0=/720x480/04/86/18/04861860.jpg"
                    },
                    {
                        "photoID": 4861862,
                        "description": "Piscina de relajación",
                        "cloudUri": "https://img.cdnpth.com/media/u6g0JQWL33PT0ml4-iJOhWlTw1Q=/720x480/04/86/18/04861862.jpg"
                    },
                    {
                        "photoID": 4861851,
                        "description": "Miniparque acuático",
                        "cloudUri": "https://img.cdnpth.com/media/xLMS5ZYzZhglGW7U6lttVOi27xk=/720x480/04/86/18/04861851.jpg"
                    },
                    {
                        "photoID": 4861840,
                        "description": "Jacuzzi",
                        "cloudUri": "https://img.cdnpth.com/media/Swc7Nrvdrf8ZnKp2XpytYe33DOg=/720x480/04/86/18/04861840.jpg"
                    },
                    {
                        "photoID": 4861843,
                        "description": "Jacuzzi",
                        "cloudUri": "https://img.cdnpth.com/media/u4d4QytlQoV2PgP4dsup8OPM1cE=/720x480/04/86/18/04861843.jpg"
                    },
                    {
                        "photoID": 4861855,
                        "description": "Área de jacuzzi",
                        "cloudUri": "https://img.cdnpth.com/media/M2p0D6frL7ajxr3dYQyXTtifMX8=/720x480/04/86/18/04861855.jpg"
                    },
                    {
                        "photoID": 4861833,
                        "description": "Solárium",
                        "cloudUri": "https://img.cdnpth.com/media/QQ6HganLE8ck1Lju5MFXriXDLr8=/720x480/04/86/18/04861833.jpg"
                    },
                    {
                        "photoID": 4861846,
                        "description": "Entrada",
                        "cloudUri": "https://img.cdnpth.com/media/4pUTWofaEAYIgq6aR3jEGJU_668=/720x480/04/86/18/04861846.jpeg"
                    },
                    {
                        "photoID": 4861839,
                        "description": "Recepción",
                        "cloudUri": "https://img.cdnpth.com/media/j7Fu3DDG696JbXc8wL63jNMOL5w=/720x480/04/86/18/04861839.jpg"
                    },
                    {
                        "photoID": 4861847,
                        "description": "Lobby",
                        "cloudUri": "https://img.cdnpth.com/media/I6nMO1qxE_btKQ0Zwa2CD2NJh54=/720x480/04/86/18/04861847.jpeg"
                    },
                    {
                        "photoID": 4861848,
                        "description": "Lobby bar",
                        "cloudUri": "https://img.cdnpth.com/media/JDZy1rnNco5C2Tcy_puTiYq-poA=/720x480/04/86/18/04861848.jpg"
                    },
                    {
                        "photoID": 4861835,
                        "description": "Bar de la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/8N_JkY0D6PBJ432jSICzZjplBzM=/720x480/04/86/18/04861835.jpeg"
                    },
                    {
                        "photoID": 4861852,
                        "description": "Snack",
                        "cloudUri": "https://img.cdnpth.com/media/wffvEviqM2Ir1eS4jkozn--5_dE=/720x480/04/86/18/04861852.jpg"
                    },
                    {
                        "photoID": 4861844,
                        "description": "Restaurante La Palapa",
                        "cloudUri": "https://img.cdnpth.com/media/hl73CYON0tPHhlHU7FNFKGlQYNc=/720x480/04/86/18/04861844.jpeg"
                    },
                    {
                        "photoID": 4861842,
                        "description": "Bufet del restaurante La Palapa",
                        "cloudUri": "https://img.cdnpth.com/media/NwdC0YX56Ds7JDdwVWIU2-44umc=/720x480/04/86/18/04861842.jpeg"
                    },
                    {
                        "photoID": 4861845,
                        "description": "Restaurante Las Perlas",
                        "cloudUri": "https://img.cdnpth.com/media/jM6KzLl10TeXaRZL2dQZeWVuiVg=/720x480/04/86/18/04861845.jpg"
                    },
                    {
                        "photoID": 4861849,
                        "description": "Montaje del bufet del restaurante Las Perlas",
                        "cloudUri": "https://img.cdnpth.com/media/EA_GciJYu4gJj1pZA29RG2o39mo=/720x480/04/86/18/04861849.jpg"
                    },
                    {
                        "photoID": 4861838,
                        "description": "Gimnasio",
                        "cloudUri": "https://img.cdnpth.com/media/8dZ1slr3s4LtuffXrHPGkPgkVlY=/720x480/04/86/18/04861838.jpg"
                    },
                    {
                        "photoID": 4861853,
                        "description": "Salón de eventos",
                        "cloudUri": "https://img.cdnpth.com/media/E4JaScJeOMWC3I2a_xq15C5fb5c=/720x480/04/86/18/04861853.jpeg"
                    },
                    {
                        "photoID": 4861859,
                        "description": "Habitación estándar king",
                        "cloudUri": "https://img.cdnpth.com/media/1iJlyZywZ2818UEmvKFhMRxXu4w=/720x480/04/86/18/04861859.jpeg"
                    },
                    {
                        "photoID": 4861854,
                        "description": "Habitación estándar con dos camas",
                        "cloudUri": "https://img.cdnpth.com/media/sIFJD59y8aRyzcWj6QF2O8z-QMw=/720x480/04/86/18/04861854.jpeg"
                    },
                    {
                        "photoID": 4861841,
                        "description": "Junior suite con sofá",
                        "cloudUri": "https://img.cdnpth.com/media/yvdVxwEMJAzUwuOZxUfz8gI_Wuk=/720x480/04/86/18/04861841.jpg"
                    },
                    {
                        "photoID": 4963373,
                        "description": "El hotel tiene penthouse",
                        "cloudUri": "https://img.cdnpth.com/media/KtjfpyoAsnzTwutQBQ3x7BWy8SQ=/720x480/04/96/33/04963373.jpg"
                    },
                    {
                        "photoID": 4963374,
                        "description": "El penthouse tiene vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/_6xwPuPwo_73XFUZDnRZ1wi2n8Y=/720x480/04/96/33/04963374.jpg"
                    }
                ],
                "hotelID": 100010,
                "importantFacilities": [
                    "Alto estándar de limpieza ",
                    "Gimnasio",
                    "Internet wifi",
                    "Miniparque acuático",
                    "Solárium con jacuzzis"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.146537512859727",
                    "longitude": "-86.79060280323029",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcán km 4.5, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Aquamarina Beach",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6,
                        "code": "26"
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10,
                        "code": "CUN"
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18,
                        "code": "QROO"
                    }
                ],
                "restaurants": [
                    {
                        "name": "El Ancla",
                        "type": "Bar"
                    },
                    {
                        "name": "El Timón",
                        "type": "Bar"
                    },
                    {
                        "name": "La Palapa",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack Grill La Parrilla",
                        "type": "Bar"
                    },
                    {
                        "name": "Las Perlas",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436743,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436746,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436749,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436752,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436755,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436759,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436763,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436767,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436771,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436773,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436778,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436781,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436785,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436789,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436793,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436797,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436801,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436805,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436811,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436815,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436819,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436823,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436828,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436830,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436833,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436836,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436839,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436842,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436844,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436847,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436850,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436853,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436855,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436858,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436861,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436864,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436867,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436870,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436873,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436876,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436879,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436882,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436885,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436888,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436891,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436894,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436897,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436900,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436903,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436906,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436909,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436912,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436915,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436917,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436920,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436922,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436924,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436926,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436929,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436931,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436933,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436934,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436937,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436938,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436940,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436942,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436944,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436946,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436949,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436951,
                        "kidsFreeTo": 0,
                        "name": "Design",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436953,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lake View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436955,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436957,
                        "kidsFreeTo": 0,
                        "name": "Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436959,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436961,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436963,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436965,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436967,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436970,
                        "kidsFreeTo": 0,
                        "name": "King Bed 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436973,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436977,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436980,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436983,
                        "kidsFreeTo": 0,
                        "name": "Lateral View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436986,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436989,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436992,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436995,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13436998,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437001,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437003,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437006,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437009,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437012,
                        "kidsFreeTo": 0,
                        "name": "Vintage",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437015,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437018,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437021,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437023,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437026,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437029,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 13437032,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408579,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Internet inalámbrico",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000647,
                        "kidsFreeTo": 6,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Parcial al mar o Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dnisTCEgdyVZU_IiQeg-KzBDSig=/720x480/04/86/18/04861865.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dnisTCEgdyVZU_IiQeg-KzBDSig=/720x480/04/86/18/04861865.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Internet inalámbrico",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Espejo",
                            "Estufa",
                            "Minirefrigerador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000648,
                        "kidsFreeTo": 6,
                        "name": "Junior suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/xtyaKHwaQ6TX8Ixd-MvBnXnicfA=/720x480/04/86/18/04861866.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/xtyaKHwaQ6TX8Ixd-MvBnXnicfA=/720x480/04/86/18/04861866.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minicocina",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 24",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996282,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, balcón",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minicocina",
                            "Nevera",
                            "Placa de cocina",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 24",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996283,
                        "kidsFreeTo": 0,
                        "name": "Suite junior, balcón",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4198203,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8426536,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8426543,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8426554,
                        "kidsFreeTo": 0,
                        "name": "Triple Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Closet",
                            "Cocineta",
                            "Refrigerador",
                            "Sofá cama",
                            "TV de pantalla plana",
                            "Utensilios de cocina"
                        ],
                        "bedding": "4 Matrimoniales",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 14194085,
                        "kidsFreeTo": 6,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/qWSjvkrXWD6fc0ErQFz5jTzbhdg=/720x480/04/96/33/04963372.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/qWSjvkrXWD6fc0ErQFz5jTzbhdg=/720x480/04/96/33/04963372.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16042548,
                        "kidsFreeTo": 6,
                        "name": "Estándar vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dnisTCEgdyVZU_IiQeg-KzBDSig=/720x480/04/86/18/04861865.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dnisTCEgdyVZU_IiQeg-KzBDSig=/720x480/04/86/18/04861865.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076065,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076069,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076072,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076074,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076078,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076082,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076089,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076093,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076097,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076104,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076105,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076109,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076111,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076113,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16427972,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16557925,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16557928,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215666,
                        "kidsFreeTo": 0,
                        "name": "Individual Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215668,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215673,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215678,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215684,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215690,
                        "kidsFreeTo": 0,
                        "name": "Individual Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215698,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215707,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215715,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215720,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215725,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215729,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215734,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215738,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215877,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18237667,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18237668,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18324408,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18324409,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18324410,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364713,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364715,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364717,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364719,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18399987,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532423,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18614616,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800891,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800893,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18890471,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18890472,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408494,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408502,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408509,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408515,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408523,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408530,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408537,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408540,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408545,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408550,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408554,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408558,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408562,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408566,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408572,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408577,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408600,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408606,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408616,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408621,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408628,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408633,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408637,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408640,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408644,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408647,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408650,
                        "kidsFreeTo": 0,
                        "name": "Triple Dos Camas Dobles Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300465,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300468,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300471,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300474,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300477,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300480,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300482,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300484,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300486,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300488,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300490,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300492,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300494,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300496,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 jacuzzis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Actividades para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.5,
                    "totalSurveys": 796,
                    "valuesAverage": [
                        4.3,
                        4.2
                    ]
                },
                "title": "Hotel todo incluido frente al mar en la zona hotelera",
                "uri": "aquamarina-beach",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección y uso de la caja de seguridad en la habitación."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección y uso de la caja de seguridad en la habitación."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen tenis, voleibol, bochas, tenis de mesa, bádminton y dardos."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 11 años, supervisado por adultos. Abierto diariamente de 9:00 a 17:00 hrs."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno y almuerzo bufet, cena a elegir entre bufet o a la carta, aperitivos y bebidas nacionales. El minibar es resurtido diariamente con jugos, bebidas gaseosas, agua, cerveza y aperitivos."
                    },
                    {
                        "title": "Deportes acuáticos",
                        "description": "Incluye actividades acuáticas tales como waterpolo y una lección de buceo en la piscina. También comprende uso de botes de pedales y equipo para windsurf en la marina Aquaworld."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El transporte a la marina Aquaworld no está incluido. No incluye servicio a la habitación."
                    }
                ],
                "description": "Occidental Tucancún es un hotel de playa todo incluido en la zona hotelera de Cancún. Este resort ofrece un gimnasio, club de niños, zona comercial, terraza para fumadores y un establecimiento para degustar aperitivos las 24 horas. Asimismo dentro del complejo hay tres piscinas, cancha de tenis, servicios de spa y salón para eventos. Los restaurantes sirven bufets temáticos, especialidades italianas, mexicanas y mariscos. \r\n\r\nEste hotel se compone de 336 habitaciones y suites de estilo mexicano contemporáneo. Se ofrecen habitaciones con balcón y vista al mar (sujetas a disponibilidad), las habitaciones familiares cuentan con dos dormitorios y suites con área de descanso. Las habitaciones Club Premium tienen beneficios especiales, incluyendo el acceso a un salón donde hay servicio de alimentos y bebidas, y acceso a internet en cortesía. \r\n\r\nEl resort está entre las aguas turquesa del mar Caribe y el centro comercial Kukulcán Plaza, que alberga tiendas de marcas reconocidas internacionalmente. La plaza comercial con acuario La Isla Shopping Village está a menos de 1 kilómetro y la marina Aquaworld se encuentra a 3 kilómetros. El Aeropuerto Internacional de Cancún (CUN) se ubica a 19 kilómetros. \r\n\r\n***Las bebidas alcohólicas se ofrecen en un horario de 12:00 a 00:00 hrs. \r\n\r\n***De acuerdo a la Ley General para el Control del Tabaco, esta propiedad cuenta con una zona exclusiva para fumar al aire libre para evitar el contacto con el resto del público.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto de saneamiento ambiental $76.00 MXN por habitación, por noche, a pagar directamente en el establecimiento.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/f5e4927f21efc2dfad9d38ed4591e4461a52da1e6aefb77c29b6e35089ea6203_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/bec75e28745edf798812f56a5f37487f04560ad9641f84cbb92c054508a9ded7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/76fb8325728a9fc4ebae9f740c74730fb01a370502edd2e8c0afc86c948d2215.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/24a248728713ccae59a34d5cc6c421bc5999a4da727326e0a76d1d198ea8cf60.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/4aa735f5372fc8418871c5214266f5d3cf5861aae60b925d99991b7bddbc5492.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - Frente al océano",
                        "cloudUri": "https://img.cdnpth.com/media/100038/d7efd3440cee0e37feba6cd1e4da628832633c4ce7ac561d08af8e6cc7d9ea78.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/e929a9f0c7a258a0b3be0720a8ea48aef60422bcab676dc30cca61a6732b3cc0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/f888342edb65c60b8d60c3b3193c0ffad8f3357c7261d104e2943fe6b253af36.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/02876b50bf8301e3d7ced7635948c40441986a5d135b9a5a0d644e5b77aefe92.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/04be9b961e76eaef5d31ef0278a78d8910b2d8611e29b720c14b954a8e76ffbc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/127eeec9d1981c4ae8e05620687750b4955b69fd6a8cb8dbd3beef3524d1637f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/92fe2660740865b6783d39bce6937a1d8cd18d8d78b40e0bf1c0c03847d7a6f5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/89473b0b59ae4011d3440204e86cb4e5184cf12577de19e8bef67777aa8729a6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/bae77abaca4f289f1ce2d1c1cfc86942dc08937f9691d5ed00b5ccf0e26c8f33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/df3c3bf0e3f20536d7b1eb0db84113a4a0f0445b3de721360befbae9213d1095.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/7ae46127e3595a9d4ac02536af5f7a1e0c6b85fa3d99795a9c1f8d97e0d8d7a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/863759bab3195da722f08ea968bca3b41c232340b3fb00fb9cd2f43f8698a844.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/6b694ce6f45c23babb364f00db3b55cf85e39f0e6d47c45301e8aa570e020379.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/ac27ce04d90eeac93c46348da610717eaa54f038d4a2a58a1a81f34f41b0499e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/04bed9eecbc2834fc4c920cff6d941e41065e096ca45d16a07a13b749cdf74c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/5cb127c15020794320f85b9cd427f4483ee91d96e5f377efebcdc2abd8fa46a1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/78ded32abc7e18ac230c6f21d8df63e6bc3fb9179f381d00f8f0a2d22af1fbc0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/019f7a931dfea5c9b7cd04e78665b5ba6979f2e979b061b70dac1b084f9e9281.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/08d6bb8d8d9945e958bc8bf6f8ef1dff0b39ccc94e9031664ad3b37155eb30c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/2f02ee2ab097dc662341d5b9e2ef3a10142d64f9f7e4a9d853d45a6ba656cb18.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/1157ed5f4a1530169f30a3116d05cb561f39bd1c7d98054642d7c80c52d87ece.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/cd15729f99b62550e6a67ec509719c096af6d91f7184a5ec4f2d0014dd980f90.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/a3a859e38be061316b6c062dc6bd7a041aeeb0da7fbbe7a757a23c1afb16b656.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/2ea834d61a27bf34a6943decc914c983cfd7d28d6b18be5ff7af8191a8d71b05.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/11bb33d74e3fe3f27db31eafc634e86b25cd5b98d978ff044bf03c93d892ceb1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/26f9fbb283ada8de92f6f66438cf12b5df3a1838d9497505b5ddbae0208997e4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/c48e396c776f01e705cc74ba34d27c60add87c4c557ed8020ee77d822264908c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/2d196c93fb092a90b0ad8f328fef9862acbd258479bff0b3537eec62f75067b7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/3ad58406d74cacc5b987231867b43ee4d68889326071098118512564a7cf0f33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/35386556789663d12ea683cefb77598d85c545fa4149c264a4143902fcf2b118.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/9f56f42702ca4a4a80cd38d1114193c4338e474914dfd2e7276c711cf9c57e06.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/934d1581c24123d555f132a87cc60bf80b610f79d5af6046c9a33a91ce6f6eb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/bdaf494cbd8408b15a839cde1a3f51621d966ff74bdd61d8dce0db61fe890a34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/761cfe46aaeed216f2c57e7e1d1d82ed5e96f282ef30ace94d63c46b55695d77.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/7eb71b4c72dd9896f8f121fec573703021eb15303222bfa0d5f768948e0c2e50.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/8d93e145cb552cfc817e8b794c57e042b4e078532e96827b3127e1c4116ee0f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/973d769bc74f319acaf8e3c20fba9250002a74cc74563a5da9dd1fef9b77711a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/1f9e108ff8ab584ed650a5a962350579d5db3906a379c0974dfa8fb04792a6c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/3e895928aface90ab9cb0f8ab3a562d71e2055a430cd76c0efd3afc28141b438.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100038/b2a0819c6ac94d66fdf4431a1810ebf3c5e425ac4ac013f378afd435b2de37e5.png"
                    }
                ],
                "hotelID": 100038,
                "importantFacilities": [
                    "Acceso ilimitado a restaurantes a la carta",
                    "Alto estándar de limpieza",
                    "Cerca de los centros comerciales Luxury Avenue y Plaza la Isla "
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.101106657809108",
                    "longitude": "-86.7648696899414",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcán km 13.5, L 24, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Occidental Tucancun",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "La Claraboya",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "La Trattoria",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Guacamaya",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "El Mirador",
                        "type": "Restaurante"
                    },
                    {
                        "name": "México Lindo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Albatros",
                        "type": "Bar"
                    },
                    {
                        "name": "Snack Corner",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000782,
                        "kidsFreeTo": 1,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000783,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953086,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar Premium Level",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953087,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar Premium Level - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Descuento en el spa",
                            "Entrada y salida privadas",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Preferencia para entrar al restaurante de especialidad",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Servicio de concierge",
                            "Teléfono",
                            "Toallas de playa",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3995496,
                        "kidsFreeTo": 0,
                        "name": "Doble vista al mar - Club Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/v-wUQrbymNAm_HCKQN0kT7Ur4V0=/720x480/04/94/14/04941416.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 TVs de plasma",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cocina",
                            "Cortesía nocturna",
                            "Descuento en el spa",
                            "Entrada y salida privadas",
                            "Horno de microondas",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Mesa de trabajo",
                            "Mesa y sillas",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Preferencia para entrar al restaurante de especialidad",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Servicio de concierge",
                            "Sofá",
                            "Teléfono",
                            "Toallas de playa",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3995499,
                        "kidsFreeTo": 0,
                        "name": "Familiar vista al mar - Club Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fc49eNTDKwm1l3tjaYz4RqxujzY=/720x480/03/08/46/03084650.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fc49eNTDKwm1l3tjaYz4RqxujzY=/720x480/03/08/46/03084650.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2TVs de plasma",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cocina",
                            "Cortesía nocturna",
                            "Descuento en el spa",
                            "Entrada y salida privadas",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Mesa de trabajo",
                            "Mesa y sillas",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Preferencia para entrar al restaurante de especialidad",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Servicio de concierge",
                            "Sofá",
                            "Teléfono",
                            "Toallas de playa",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3995500,
                        "kidsFreeTo": 0,
                        "name": "Suite vista al mar - Club Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/F2TphtVEHBUVJgFKsh3omqbc6ME=/720x480/03/08/46/03084652.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/F2TphtVEHBUVJgFKsh3omqbc6ME=/720x480/03/08/46/03084652.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cocina equipada",
                            "Horno de microondas",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Refrigerador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4959141,
                        "kidsFreeTo": 1,
                        "name": "Familiar frente al mar Premium Level",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lPItAsCwPJR5VebP51hcyCjUZmQ=/720x480/04/94/14/04941417.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lPItAsCwPJR5VebP51hcyCjUZmQ=/720x480/04/94/14/04941417.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cocina equipada",
                            "Horno de microondas",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Refrigerador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4959142,
                        "kidsFreeTo": 1,
                        "name": "Familiar frente al mar Premium Level - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lPItAsCwPJR5VebP51hcyCjUZmQ=/720x480/04/94/14/04941417.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lPItAsCwPJR5VebP51hcyCjUZmQ=/720x480/04/94/14/04941417.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cocina equipada",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Refrigerador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4959149,
                        "kidsFreeTo": 1,
                        "name": "Suite frente al mar Premium Level",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/A0kq6Rv-f42g9WkKuugvsnXQR6I=/720x480/04/94/14/04941418.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/A0kq6Rv-f42g9WkKuugvsnXQR6I=/720x480/04/94/14/04941418.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "25% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Barra premium de bebidas",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cocina equipada",
                            "Internet inalámbrico",
                            "Llamadas locales gratis",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Refrigerador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Teléfono",
                            "Toallas de piscina",
                            "TV LED"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4959150,
                        "kidsFreeTo": 1,
                        "name": "Suite frente al mar Premium Level - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/A0kq6Rv-f42g9WkKuugvsnXQR6I=/720x480/04/94/14/04941418.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/A0kq6Rv-f42g9WkKuugvsnXQR6I=/720x480/04/94/14/04941418.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7154687,
                        "kidsFreeTo": 1,
                        "name": "Doble - especial menores",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7154688,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar - especial menores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7833289,
                        "kidsFreeTo": 1,
                        "name": "Doble - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/NTHdnTLijjzk_XHIid-qNlo1wDE=/720x480/03/08/46/03084651.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7833290,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cwBMXqqlFc6fcnqgN1G5TWujEbc=/720x480/03/08/46/03084646.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Entrada con dispositivo móvil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8413063,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium, vistas al mar (Level)",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Entrada con dispositivo móvil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8413064,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Entrada con dispositivo móvil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8413066,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Entrada con dispositivo móvil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Minicocina",
                            "Nevera",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8413067,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar, frente al mar (Premium Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8428821,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 10187223,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11581571,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11581573,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16095353,
                        "kidsFreeTo": 0,
                        "name": "Doble Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16095357,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16095360,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16095372,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175716,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Entrada con dispositivo móvil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Minicocina",
                            "Nevera",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16406659,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, frente al mar (Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974295,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974297,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974299,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974301,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974303,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974305,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974307,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974309,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974311,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974313,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974315,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974317,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974319,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974321,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974323,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974325,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974327,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974329,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974331,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974333,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974335,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974337,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974339,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974341,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974343,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974345,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974347,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974349,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974351,
                        "kidsFreeTo": 0,
                        "name": "2 Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974353,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974355,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974357,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974359,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974361,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974363,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974365,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974367,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974369,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974371,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974373,
                        "kidsFreeTo": 0,
                        "name": "Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974375,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974377,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974379,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974381,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974383,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974385,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974387,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974389,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974391,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974393,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974395,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974397,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974399,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974401,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974403,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974405,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974407,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974409,
                        "kidsFreeTo": 0,
                        "name": "Without Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974411,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974413,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974415,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974417,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974420,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974423,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974426,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974429,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974432,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974435,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974438,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974441,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974444,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974447,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974451,
                        "kidsFreeTo": 0,
                        "name": "Double Room Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974454,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974457,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974460,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974464,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974467,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974470,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974473,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974477,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974479,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974482,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974485,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974488,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974492,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974494,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974496,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974498,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974499,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974500,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974501,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974502,
                        "kidsFreeTo": 0,
                        "name": "Ground Floor Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974503,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974504,
                        "kidsFreeTo": 0,
                        "name": "Quintuple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974505,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974506,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974507,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974508,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16974509,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17079424,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17079425,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216361,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216369,
                        "kidsFreeTo": 0,
                        "name": "Individual Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216376,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216383,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216390,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216399,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216406,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216412,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216418,
                        "kidsFreeTo": 0,
                        "name": "Individual Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216423,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216428,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216434,
                        "kidsFreeTo": 0,
                        "name": "Individual Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216442,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216449,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216455,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216464,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216471,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216476,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216481,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947267,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947268,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18515419,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18531792,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18700950,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18740431,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800294,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size No Fumadores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800295,
                        "kidsFreeTo": 0,
                        "name": "Individual Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18883792,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18883793,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18883794,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18883795,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18890678,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas No Fumadores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18905727,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18905730,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951072,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cocina",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Moqueta",
                            "Nevera",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Tostadora",
                            "TV por cable",
                            "TV vía satélite ",
                            "Utensilios de cocina, platos y tazas",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951076,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300221,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300224,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300227,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300231,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300234,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20300237,
                        "kidsFreeTo": 0,
                        "name": "Habitación Promo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "3 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Aeróbicos acuáticos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para fumadores",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bádminton",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Basquetbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cancha de usos múltiples",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de niños  (4-11 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Computadoras con internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jet ski",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tiendas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Traslados al aeropuerto",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 1339,
                    "valuesAverage": [
                        4.4,
                        4.6
                    ]
                },
                "title": "Hotel de playa familiar y todo incluido a espaldas de Kukulcán Plaza",
                "uri": "occidental-tucancun",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Hotel Kavia, ubicado en la zona centro de la ciudad turística de Cancún, es ideal para familias y amigos. Ofrece 62 habitaciones libres de humo con acceso a internet y aire acondicionado, todas cuentan con televisión por cable, teléfono y caja de seguridad. La propiedad dispone de dos piscinas, centro de negocios y un restaurante (ambos con cargo extra.) \r\n\r\nEl hotel está a una cuadra del parque Las Palapas y a 3 cuadras de la terminal de autobuses ADO. A 12 kilómetros de distancia se encuentra el Centro de Convenciones de Cancún, lugar de negocios y reuniones, y a 19 kilómetros el Aeropuerto Internacional de Cancún (CUN). La Playa Delfines, categoría bandera azul por la calidad de sus servicios y vista panorámica del mar Caribe, está a 20 kilómetros de la propiedad. \r\n\r\nPor disposición del municipio local, el hotel cobrará un impuesto obligatorio de $67.42 MXN por habitación, por noche, a pagar directamente en el establecimiento. Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/fb076081e8d3796122a79a18f44538944b77237553e8ee508567e541054c127b_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/3f790c3ca7038c3346c82fc151b53486460c163ec12046cc4d4643b3023ecb6d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/1067855bb0bb70c0d4419455592c8131fbdd00da2f241f3c7cbb70f4b9100ffa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/bbd060fd2cfed2cea6a9ce8dde59e61d2d6c7aed74b3dcb2b59622cc5d3de5aa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/af87374ea972b5c5f1c611bb178afef15ecab7dcd9861bf8c9d00ac10b31bfd6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/cc06d67d4180837a11a5d7adbafd47a3a4c762c08aa813fea5062d5e845474cf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/746c490b2f15bdd1121204c589928f6080bd7694c4135741b4b3bd31e72cdec3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/9ba0b46eaa5e212100165dbe63ea5111638373c6bf3ce293d0b42089fda782bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/5f24d9d81bf73ed782ad23f8e4903d9b3799c43227e8924871bf6d6bfba6d50f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/6428ffc9ecf76514ac0ea3445356051d41ef6755a89a268a8336c46bed0db692.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/50531dd2fc4054908619044f69d704b5f8994d5623c20c35c14ba2ce53b7543f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/403bd29a1dbe1b46c96eb806033e642e670c87e63c74da2a68bdf17a62111b9d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/4b810fcf46e9879f76d7d15656df2f24e409b64404df5f07b84a23381a916783.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/c3a9173c8ea7c963337b94b25ea697368a64f83fb3a63d0e21e8cece9f29241a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/e622fcac448675b906cfa8e44e2a23f903f20546854068a39ba86ae77bec08c3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/ccd176f6c1706c023b4c3dee80f3fd04ee82265dfb3207b587fd1de527a5362b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/3e6086652c14b890c22449579f83b15015d9fb9a295521795b8928afaab0f8dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/87408a69f82335f5fe59e9af29baa235a32e20da446a4f3cf24eb3f12356a065.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/6ff0d3fffd332b7ac4fd26944bae21c5dd8ddc1c7db2e8370a27951ca5ad4dbd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/626c2f91f60bb24eb23ee1faa0fc4110f08e1e14d7703056222fc7d9d12ae097.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/a0696072f4c99b27cccdc3e65d53a451831be7ab99d005e272d58ab2c6391d88.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/2f2ba470d2feec4b81c46083a4f6a67e8305a65356e20ddb8b6286b989bfcd8a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/95d99a1aa51aa4718ebd2c9f3f6f11c468ef26a943595592fc6fb8c3d588a29e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/0b27a79d190a254e13ce6bae62a171d8a1aadee252bf2ee17270baa107debede.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/95908344b637427b605f2721e4cd1751d84f64182b54b8d09a9d55830e73140e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319036/41db4b4443c9f4449df064cdb93523249b992b21a571ba846a3e7d88737c1d6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/e2b1ba1da09eacd1b3e4939f8565fb43b5012af8949d3ad1e8148506e9ec1668.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/5d54e25af68849bf979ef391005919c354095977e3b0f8a74976dda92597dc2a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/f11120eb0d8ae9e4940a5322f35739b274440f303252331110ae6275d3fac744.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas",
                        "cloudUri": "https://img.cdnpth.com/media/319036/aa811275df1644c72ccd1dec634d581e51bcc9fd61f4148371582e69b97a4f52.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/2fe3615d722042161dc2b78aba4551cccb76ee1b751fa88984c0fe7d32dfde8c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/a4dca801296a17622db740235a39138b27ab53b1587be0612b39fe9fb57ca9a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/856269d3cc45338a7a4e802446f48b767ec385191c0e2b729e652a7040ab1c46.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/0cc08f0ab2b8220b5f32d8533e81d3e72f0a9373430fe619d8113735a6358e97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/64cb6876c2e051e98bd5df24e33a78181561194266ca96c04e6af0e3eaa44e20.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/82c45f3597897e6a7ab225944bc50c3af47f60e2ada3386eb31b66ac167c3840.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/21de9172b98684fe732d1f57f448f55a886db2cba870bfd76de6e02a9c5d40a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/80083eb3acc546cbc2028970403c31f8bb9904327bc2e36a63d3503eee25141d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/1abaf896225c6b75a5fc51b9712b6b5e506e8437203cf35bec61d8cd631d1d3d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/519beb44b1c3a6816560bacdddfd23dd0bd00cb928eda648a859995b8db87f71.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/828b19c7e2d6cd1841e7eda78d6825d5551a55858bcd8c43358d42d4af812545.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/22ac70856c05539b3a56974c0b16db03f47b9b2c6a109398cc71ecca279db1bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/b70e29ba981c6709f85e20cc1d56c4766d5e20ed72139b7069131a6626ca0a48.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/ccc99768f22bed1256e56a086a99d1b70bc123a6fb270ee25a05e48ad7fcddd0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319036/6ed844ac02a014dd2a030dda5a97481ee08ff712f9da3f52f881988a208c58f8.png"
                    }
                ],
                "hotelID": 319036,
                "importantFacilities": [
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.160448208582352",
                    "longitude": "-86.8266436457634",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Claveles, SM 22 M 4 L 7 y 9, Col Centro",
                    "countryCode": "MX"
                },
                "name": "Hotel Kavia",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Restaurante",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9543651,
                        "kidsFreeTo": 0,
                        "name": "Double room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263235,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263237,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263239,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263241,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263243,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263246,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263249,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263250,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263256,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263258,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263259,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263261,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263263,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263265,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263267,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263269,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263271,
                        "kidsFreeTo": 0,
                        "name": "City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263273,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263275,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263277,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263279,
                        "kidsFreeTo": 0,
                        "name": "Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263281,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263283,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263285,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263287,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263289,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263291,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263293,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263295,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263297,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263299,
                        "kidsFreeTo": 0,
                        "name": "Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263301,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263303,
                        "kidsFreeTo": 0,
                        "name": "Double Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263305,
                        "kidsFreeTo": 0,
                        "name": "Single Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263306,
                        "kidsFreeTo": 0,
                        "name": "Double Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263308,
                        "kidsFreeTo": 0,
                        "name": "Triple Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263310,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263312,
                        "kidsFreeTo": 0,
                        "name": "King Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263314,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263316,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263318,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263320,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263322,
                        "kidsFreeTo": 0,
                        "name": "2 Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263324,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263326,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263328,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263330,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263332,
                        "kidsFreeTo": 0,
                        "name": "Shared Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263334,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263335,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263337,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263339,
                        "kidsFreeTo": 0,
                        "name": "City View Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263341,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263344,
                        "kidsFreeTo": 0,
                        "name": "Double Room Ensuite City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263346,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263347,
                        "kidsFreeTo": 0,
                        "name": "Double Room Ensuite King Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263349,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263351,
                        "kidsFreeTo": 0,
                        "name": "Family City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263353,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263355,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263357,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263359,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263361,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263363,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263365,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263367,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263370,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Double Bed City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263372,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263373,
                        "kidsFreeTo": 0,
                        "name": "Double Room Ensuite King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263374,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263375,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 King Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263376,
                        "kidsFreeTo": 0,
                        "name": "Superior Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263377,
                        "kidsFreeTo": 0,
                        "name": "Family Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263378,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263379,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263380,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263381,
                        "kidsFreeTo": 0,
                        "name": "Superior High Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263382,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds High Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263383,
                        "kidsFreeTo": 0,
                        "name": "Superior High Floor With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263384,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 King Beds High Floor With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263385,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263386,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263387,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263388,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263389,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263390,
                        "kidsFreeTo": 0,
                        "name": "Double Bed 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263391,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263392,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263393,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263394,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263395,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263396,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263397,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263398,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263399,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263400,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263401,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds Double Bed 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263402,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds High Floor With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263403,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14263404,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5353900,
                        "kidsFreeTo": 0,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4FqN2n0uOnKFvj9HNvI9UMYaQE8=/720x480/04/29/98/04299877.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4FqN2n0uOnKFvj9HNvI9UMYaQE8=/720x480/04/29/98/04299877.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Escritorio",
                            "Habitación separada",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5390136,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 1 cama de matrimonio grande, baño privado, vistas a la ciudad",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Escritorio",
                            "Habitación separada",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5390137,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 2 camas dobles, baño privado, vistas a la ciudad",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Escritorio",
                            "Habitación separada",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5393459,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, balcón, en una planta alta",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5910845,
                        "kidsFreeTo": 0,
                        "name": "Estándar king",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/HxMc7r6igIGq8Vix-1SJzHDnRuI=/720x480/04/29/98/04299896.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/HxMc7r6igIGq8Vix-1SJzHDnRuI=/720x480/04/29/98/04299896.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Kings",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5910846,
                        "kidsFreeTo": 0,
                        "name": "Superior king",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jPCgKwgd9RehDQuaSWtIsIAbBpg=/720x480/04/29/99/04299913.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jPCgKwgd9RehDQuaSWtIsIAbBpg=/720x480/04/29/99/04299913.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7947774,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7947775,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7947776,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8352332,
                        "kidsFreeTo": 0,
                        "name": "Double Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8352345,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8352354,
                        "kidsFreeTo": 0,
                        "name": "Double Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8352363,
                        "kidsFreeTo": 0,
                        "name": "Double City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8352375,
                        "kidsFreeTo": 0,
                        "name": "Room City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438516,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438517,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory City View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438518,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "SI Accesible para minusválidos",
                            "SI Baño para minusválidos",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438520,
                        "kidsFreeTo": 0,
                        "name": "Single King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728905,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728910,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728913,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Sala de estar",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728916,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728922,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728927,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Ciudad Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728931,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728934,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728937,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728944,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728949,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Sala de estar",
                            "Televisión",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728955,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10728961,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Ciudad Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11636033,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11636034,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11636035,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074746,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074748,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074750,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074753,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074755,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074756,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074757,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074759,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074760,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074761,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074762,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074763,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953842,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953845,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953847,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953849,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953851,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953877,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953880,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954138,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954141,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954143,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954148,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954153,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954156,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954160,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954165,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Ciudad Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954168,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954175,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954178,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954183,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18954186,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20071110,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20071114,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20071119,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20071122,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20071126,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359518,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359521,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359523,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359525,
                        "kidsFreeTo": 0,
                        "name": "Habitación Business",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359527,
                        "kidsFreeTo": 0,
                        "name": "Suite Una Cama",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 531,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel en la zona centro de la ciudad",
                "uri": "hotel-kavia",
                "tags": [],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Hotel and Spa Xbalamqué Cancún Centro está ubicado en una de las calles más famosas y con más ambiente. La propiedad está decorada con murales, esculturas y cuadros que reflejan la cultura, la mitología y el misticismo maya. Rodeada de bares, restaurantes y hoteles, se encuentra a 2 kilómetros del Centro Comercial Las Américas y el Malecón Cancún. La entrada a la Zona Hotelera queda a 1 kilómetro de distancia y el Aeropuerto Internacional de Cancún (CUN), a 17 kilómetros. \r\n\r\nEste hotel en Cancún cuenta con 90 habitaciones. Cada una cuenta con aire acondicionado, baño privado con ducha, teléfono de marcado directo y plancha a solicitud. \r\n\r\nLa propiedad ofrece dos restaurantes, una cafetería y un bar que sirven comida mexicana e internacional. Si deseas relajarte puedes visitar el spa y regalarte un masaje, entrar al temascal o vaciar la mente con una sesión de yoga. El hotel también ofrece clases de salsa, así como un salón de eventos para 150 personas y una piscina exterior. Los huéspedes cuentan con internet inalámbrico en las áreas públicas, servicio a la habitación y estacionamiento (sujeto a disponibilidad). \r\n\r\nLas habitaciones con desayuno solo lo incluyen para adultos y niños de 12 años en adelante que hayan pagado tarifa de adultos. \r\n\r\nEl desayuno para menores de 0 a 11 años NO está incluido en la tarifa y se deberá pagar el extra directamente en el establecimiento. \r\n\r\nPor disposición del municipio local, el hotel cobrará un impuesto obligatorio de $67.42 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\nAntes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/891d184129650840c7aeaa954471e2d2e4af1d2e39f319af38dbe25f1c379312_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/3b0b0e38470411dfdb712c99143a9d2f427a288fe9ef9bd9452d3b329b3db922.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/36a43346f91e47b037bbe43dd3951e7b6aa6cec6751663b7d2a6c1a4e60eb977.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/2cf4908c6716f5b17ea5e9d84c53d3ed87e32ec78754ec87e3738517eb6db146.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/25dcebaf3f85106dbd2d36896f9e1d0b2a9772c2a0bf623b780a50319f2a38cf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/54f99205dbc4b78ea350435f9df6c8319e951f46e83e9bf20fc778dc76e73b7c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/1a32b5905a7f6de4bc36c9e99e509f90ad44c982ae8c7e8d07cb59b984f109d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/df8ea9a438b14813dfff6f3bd233eb96783a9919ff108f427bdd3981a236ef77.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100626/6e6895a0d94904eb45d292cd920607480548591151e3ab78f43d0c3b19509e8f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/c2acdf7c2644be04ea0cec3dbf9aaf92a5a72d4c148a437e9430fafbb1b5ec33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/57f67afce8bf28ce001b9e59ec4ad0cc607cded9425f7e4c48c7b985a417eedb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/429ca3ac4c560ce56b6c84a1f607d7e99d5f8e4ba84c52cda5be107424f35d72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/d47dee65d1675c17455ae8087625eaee7ae7bf9ac9716d5068b91373fe24cae6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/289ea6594f513eba9989a39d73cd3b3e6948d29ddab8d3cc4440ab0e0c3d7ac8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/8e2a74fcd99d16ced66ea28c438ce35fda4b8f31329c405e1dfd7be0dd9d432d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/bc57a6fbe4baa76059b14c7a636fbc4c05aa433b4d3a2060bfa4ae13ea147f36.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/b41d8cabf0ce687fe8954ef9905f13ea960227bbb52f9914abbe466b81d3fd71.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/7aca1bb953fc907e1db5a3a8a8159fbaf4226169be2e0f75efce708546a775ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/77c2f526afc265bda3cfffe1ff6bb65b21e7ffd0c1db112eef06b251adaa1d7c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/7f9c677967b6ec114bfc2175ff6205881b14cf4673b57d7d45e1a0b73e2e4e9f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/2aa87fd58c088ed3d06ba5fd67009a9857a5288063593f46964c4c8922bb4358.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/4189e24d4022dd7f06382b6423997a1b37bb9798c2798975138430a6eff8d3fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/80c83bca5ab5337fed9f18b9ee8093a20506d5effa18c0b8dcd800c0b3d1f8e2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/e8c6920bb7d137351d3a533c83fa0e585bf9b59b4804717975dd2f3139681264.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/8409c1e9f6ca5b7c5a54284dbb8ebf5817836c333d41f105dbe75701716be0d0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/e24df9896673c2c5781c9c85a43902aaedbc9b109b96d24c5df4879bd603d80f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/44ee46474f064323053930ad60082315f4ac8e8282fe4e451dc54296f1a5cd37.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/b2fb551bb086ec182dadc063bccb3f52259e5aa1200e8e827e1c22e44fef7a0f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/f03bf2d6f0766229d6e3e4a8306f9ca3f38d6fbed60d137cd5a00466ef449ccb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/60c572ad5a3e0bb1ddb487a3341a77a4ae59ef787e36fbc06cd82b4bff1b5107.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/007c9f493dc5841dd6090cf9c53a54054cbf8d8ea501c6d4490313f6248758fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/ce92510bf9d597877b14e3f04be2139bed70c2f2890ef062c5483d7ee46f0372.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/36fed5906231e891ac5f7604ae5a483e0ae013ac44fe4b984349eb66943b9ab4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/aa9fd9a78508a1f593ac6a85fe735964390e191060c752486cd16488a24ad7cb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/252e5c1a7803b51be5b03dcf313d5816438b41507537a9b0aec49b734cd194e9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/56a0690358ed063375ac306e8f2b1fe44d23555b0c9d0b412640a76ea2ccafbc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/44f1657a5930a6d441efa984800482553d912ff13293725ab83e3df89cdf6dfe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/0b111599a0599d3b1d0fd17eecb0299a96dc02be74dc797ef650064b1e422281.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/1643e86c4e9ae9a281bda8f8c34ff9a45d9b549cff8a36dda77c30b2c20fcf14.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/7ca032068472728dd4cbef3f20d0fb7139d41cd73d4efd3b189237ec86271903.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/a63065f873e1fd53589db287376f4ad9ce8b49385a4319b5f2e55e81440236de.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/9d4c78be455a6833e3f581c9aadb67ea2d2b5b1545bbeedb4f2331f117c627b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100626/562227567bb4110bb18d83cd1a584b3e7fb660ed6edf0bea83343c2e8c5afdaf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/100626/f96b4f255411dbb36e2c02c047918fadf58ca16641705dc1ca2123733879bdec.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/100626/3ed88c8ac4f53d4f0f7b0489a37d3d2218a37d2dd7a8be80fd7f605f84cc171c.png"
                    }
                ],
                "hotelID": 100626,
                "importantFacilities": [
                    "Estacionamiento",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.161591323986237",
                    "longitude": "-86.82909786701202",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Av Yaxchilán 31, SM 22 M 18",
                    "countryCode": "MX"
                },
                "name": "Hotel & Spa Xbalamqué Cancún Centro",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Bounissimo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Los Cuatro Elementos",
                        "type": "Bar"
                    },
                    {
                        "name": "La Adelita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Pabilo",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Mesa de trabajo",
                            "Plancha a solicitud",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000967,
                        "kidsFreeTo": 11,
                        "name": "Estándar 2 dobles",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AG8u0Q30gGtJu-rKDdjb1rIbZEE=/720x480/04/81/73/04817330.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AG8u0Q30gGtJu-rKDdjb1rIbZEE=/720x480/04/81/73/04817330.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Mesa de trabajo",
                            "Plancha a solicitud",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Matrimonial",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 2208237,
                        "kidsFreeTo": 0,
                        "name": "Estándar 1 doble",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/94RuVM_qZ9ZilrqsyuLvDIiB5Qo=/720x480/04/81/73/04817331.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/94RuVM_qZ9ZilrqsyuLvDIiB5Qo=/720x480/04/81/73/04817331.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Plancha y tabla de planchar",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3693551,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uwMhtCz9IK4kx-dc3m1sXyQYSq4=/720x480/04/81/73/04817339.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uwMhtCz9IK4kx-dc3m1sXyQYSq4=/720x480/04/81/73/04817339.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Armario o ropero",
                            "Baño privado",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "1 Matrimonial",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3954143,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama doble",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Armario o ropero",
                            "Baño privado",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3954144,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 2 camas dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Albornoces",
                            "Armario o ropero",
                            "Baño privado",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7889191,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589918,
                        "kidsFreeTo": 0,
                        "name": "Double Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589922,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589926,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589933,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589938,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Children share the bed with parents",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589942,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589944,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589947,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Children share the bed with parents",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589950,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589951,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10589955,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583396,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583398,
                        "kidsFreeTo": 0,
                        "name": "Suite City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583400,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583405,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11716705,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086588,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377389,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory With Shared Bathroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16386944,
                        "kidsFreeTo": 0,
                        "name": "Room Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17201999,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17202001,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17202002,
                        "kidsFreeTo": 0,
                        "name": "Apartment Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17202004,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886849,
                        "kidsFreeTo": 0,
                        "name": "Double One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886850,
                        "kidsFreeTo": 0,
                        "name": "Double Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886851,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886852,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886853,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Plancha de pantalones",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886854,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de baile",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Temascal",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.4,
                    "totalSurveys": 969,
                    "valuesAverage": [
                        4.1,
                        3.8
                    ]
                },
                "title": "Hotel con spa en el centro de Cancún",
                "uri": "hotel-spa-xbalamque-cancun-centro",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Gay & lesbian friendly"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 2 y 12 años, supervisado por adultos y con tres divisiones por edades. Abierto de 10:00 a 17:00 hrs."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno y almuerzo bufet, y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Deportes en Tierra",
                        "description": "Los deportes en tierra incluyen dos canchas de tenis, ping pong y el uso del gimnasio."
                    },
                    {
                        "title": "Deportes Acuáticos",
                        "description": "Incluye equipo de snorkel y voleibol en la piscina."
                    },
                    {
                        "title": "Restricciones",
                        "description": "No incluye el servicio a la habitación y uso del sauna y baño de vapor. Las bebidas Premium no están incluidas. Tampoco están incluidas las cenas románticas en la playa."
                    }
                ],
                "description": "BlueBay Grand Esmeralda se extiende en 180 hectáreas rodeadas de selva y manglares, con una playa exclusiva de 500 metros. Este hotel todo incluido en la Riviera Maya tiene un diseño contemporáneo con toques mayas y es ideal para familias. El complejo comprende tres piscinas con áreas de poca profundidad para los más pequeños, un club de niños y opciones para practicar deportes acuáticos. También tiene varios restaurantes, uno de ellos de comida mexicana gourmet, y ofrece cenas románticas en la playa con costo adicional.\r\n\r\nEste hotel dispone de gimnasio, dos canchas de tenis, una zona con tiendas, tres salones para eventos y un teatro con capacidad para 650 personas. Sus 979 habitaciones y suites poseen vista al mar o a los jardines, balcón o terraza, minibar y cafetera. También cuentan con acceso a internet inalámbrico gratuito, y en la televisión con cargo adicional. Se ofrece entrada anticipada y salida tardía, ambos con costo adicional.\r\n\r\nEl club de golf Mayakoba, que es sede de un torneo del PGA Tour, está a 4 kilómetros, el centro de Playa del Carmen se encuentra a 13 kilómetros y el parque temático Xcaret se ubica a 21 kilómetros. El Aeropuerto Internacional de Cancún (CUN) se localiza a 48 kilómetros de distancia.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio entre $28.00 a $35.00 MXN o $1.50 a $2.00 USD por habitación, por noche, a pagar directamente en el establecimiento.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/86f0252359f6ffee9fa6861f8eb9977f7b83689666633edef4c0da70de929c44_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/903943417d20401bbb30bd38031c7502fbf25ebf181cb1c13a55fd2db9838d8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/98057f7525f06a627186923388dd195959c4d5313aee4edc615b7edca4920ead.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1e0a9d319d146f11c97abbc6f6333c505363f2da253836402d2a6e596bc04320.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/adf87b815ef2f78ca87da2938eb5202eca471e5d6d66e4c3f5e2782bf1a33ce1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/4e50217463e13ebe94c6364ecfbee8f083b08fba9443ec6ea36f396229f5b13c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/cfe6c8fead41f2ad703a9f70a0d01f7c0ae8ef74ab7fef77042cc3f7d576d0b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/50cbba6fedbf67fc3a4686a570ecb1260765376afe4405830546663902b09ccd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1faf823121ff32d8ffb7c501f7e30d363653fe1d67c858083c0512068848717a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/b050e719bec79fd72f48f89c58f4fa3474c68abd67cf621f192a9248b74ca35b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1a78fcaede054a8feabd7f5e606f807f57acb1acba2ac66aa5927f385bb7d37f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/275b49a6791e14adc2747b3477eebe4d8fbffa044eca8c9e7fcbcf4c249a621e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/c8ca6d38ce71b89ca5f31ec5a2ee048192f4b0362785c5318cab177c8b596a65.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/0adf79d4aad7d027988dfdb818574f87f416ea711214a8c407fa439eaa00434a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1dd84f34e39eec0d9ac77f06103f983e6ce6879baaae9aa8366cd3fcd28ce6f0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/0df092960464b0c5d6ea76cad98d3abc8ff30726164e3e868ec53b68ce5215a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/cde421dd479ea3e893ed7d71787b70a9dff74fde69ba1d1da08a5c41c0114840.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/b841cfe10e0e55fbeef242b42fcb69f5805e35a58bda202cc0a2d896b6b0e6dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/8e037fb615aa1d051617227261036d83a4ffad36999d3c3581d99a25b82dbd72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/05ae82785973905d3f5deee561416c87e02c6348f5d7dfd53c355448835a150f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/813d00e7faf98f6c8554eb1059c46ab7e745f1deacee0f3783ade46af5395195.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/f7267b93bc3d08550ff6acc995843e393add7f6c73cdd74b3f75a034ef15b628.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/e375186f046e12d6dcce282e1863c611648f64757b3e8e5785b926acfd5913db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/98485bfa91b7e932a640d4353db93cf6349f15b045c17ef10322e719a72cd290.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/6b2bb6f16402c6fa8bd8dcf1b427728fb85cefb8d4b748e49da5e7fcc4e111f2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/2d0758898476314123b1241d02c52d5124cc055232b1b403aa885b8c4401cc20.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/18478257f03e39cf049a0a1327cc1901e88544676b15add7bbd7bfa1b18d0795.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/9ef68062b102bc18ed5cf0d97005813399e8fe0370baed5feeb2debc35845de6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/b780636baaca9dc18a484723281887f52b1c7eda3f011ea5e4dc666a02b72ee5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/7ade1065e8ae7b3b1594bdbaea0b85e16049d45c0dc4506b4f57c4be223febc5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/85829de87f47146c025641411b40ce01ab39326c19d2d067c78f3d26af1e4f77.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/a5d662db82a35bafbd6e47a0f5e2ff1fe4a31999f12f18a28d3f83dd5685590c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/b78d5cba3f47956c1523d61c46a8810df00690d2cc42f9089675a9b918db532e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/a4c14e9c3995d7a2a420af01eae09da681f8cbeb998c13bb250ee5338b66f45e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1771fcdf1802f0bf553fa91f0f393223ae633d84452312b7e5940c022e83ea22.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/1458c44e00b3f817ece10855f2b7fe69d037d95d768f84db47211c72b2936e54.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/2173b133829d917269325b456b713c1f9fd9221febd109a97119a0c5766ed534.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/905f118c9a347f5f8336654ad8da45507b58fcae43a1d4361ad8442ad61465da.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/9bcdb86a7e1716cad299fb744677bed53e01ecd6aa30ba1b26714dde7efae673.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/01658860fbf20f7d369490341642e78b7ea1492c0467d80c25dff293eb347c55.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/2f555f1b530caabb748d6c67eaa39054f4ae5f6a1a1b5b6e10789572280feaf8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/a42673ece591a5a3c4c68623e881847d7ad15ae402cb720c15ce0debdf198012.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/8ff1100933d89576780a439d8b8fa92da4ed3f5c62a2b3934d25023fe769c2a8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100230/964cca8c7f60197a4d38aa0f0312c31eadb90599e3a4687d87e3eb8515bd252f.png"
                    }
                ],
                "hotelID": 100230,
                "importantFacilities": [
                    "Entretenimiento para toda la familia",
                    "Resort todo incluido a pie de playa",
                    "Wifi y estacionamiento gratuito"
                ],
                "location": {
                    "city": "Playa del Carmen - Riviera Maya",
                    "country": "Mexico",
                    "latitude": "20.7000368223886",
                    "longitude": "-87.0126736164093",
                    "postalCode": "77710",
                    "state": "Quintana Roo",
                    "street": "Carr Federal Chetumal-Puerto Juárez km 300",
                    "countryCode": "MX"
                },
                "name": "BlueBay Grand Esmeralda",
                "placeContainers": [
                    {
                        "id": 76001,
                        "uri": "playa-del-carmen",
                        "displayText": "Playa del Carmen, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 76965,
                        "uri": "riviera-maya",
                        "displayText": "Riviera Maya, Quintana Roo, México",
                        "type": 3
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Don Isi",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Il Cuore di Rossi",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Jaal-Ha",
                        "type": "Restaurante"
                    },
                    {
                        "name": "L'Atelier",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Terraza",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sports Bar",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Sea Food",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Festival",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Steak House",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Night Club",
                        "type": "Club Nocturno"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587463,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587489,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587515,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587540,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587565,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587590,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587617,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587643,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587665,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587688,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587712,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587736,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587758,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587781,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587802,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587825,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587848,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587872,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587894,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587917,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587940,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587966,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587990,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588013,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588037,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588061,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588085,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588110,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588138,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588162,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588187,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588212,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588239,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588265,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588292,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588318,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588341,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588366,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588393,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588419,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588446,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588473,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588499,
                        "kidsFreeTo": 0,
                        "name": "Double Room Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588523,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588547,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588569,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588591,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588612,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588633,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588652,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588672,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588698,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588722,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588747,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588770,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588794,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588819,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588846,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588869,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588892,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588916,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588938,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588961,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588986,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589010,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589034,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589059,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589085,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589108,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589132,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589157,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589182,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589209,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool Access",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589237,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589263,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589290,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589317,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589343,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Diamond Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589371,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589399,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589426,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589453,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589479,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589505,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589531,
                        "kidsFreeTo": 0,
                        "name": "Suite W Bathtub",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589558,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589583,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589609,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589636,
                        "kidsFreeTo": 0,
                        "name": "Superior Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589661,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589687,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589710,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589734,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589758,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589783,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589808,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589833,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589858,
                        "kidsFreeTo": 0,
                        "name": "Superior Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589880,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589903,
                        "kidsFreeTo": 0,
                        "name": "Superior Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629082,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629091,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629100,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629111,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629121,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629131,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629142,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629152,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629162,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629172,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629182,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629192,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629203,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629213,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629223,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629233,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629243,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629254,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629265,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629275,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629286,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629297,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629308,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629320,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629331,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629342,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629352,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629362,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629371,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629380,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629389,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629399,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629410,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629420,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629431,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629442,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629454,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629465,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629475,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629484,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629493,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629500,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629508,
                        "kidsFreeTo": 0,
                        "name": "Double Room Bunk Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629516,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629524,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629532,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629541,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629549,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629557,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629565,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629572,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629580,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629587,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629596,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629602,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629608,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629614,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629620,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629626,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629633,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629639,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629646,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18629654,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103821,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103828,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103829,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103830,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103831,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103833,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103834,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103835,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103836,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103837,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "($)TV con internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001114,
                        "kidsFreeTo": 2,
                        "name": "De lujo vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CXlJmcOKrRk_huHjZcCm8qrJPaU=/720x480/04/86/82/04868200.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CXlJmcOKrRk_huHjZcCm8qrJPaU=/720x480/04/86/82/04868200.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "($)TV con internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001115,
                        "kidsFreeTo": 2,
                        "name": "De lujo vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GAsPGm9SWsG2DxHO6RVcpJGLuw8=/720x480/04/86/82/04868201.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GAsPGm9SWsG2DxHO6RVcpJGLuw8=/720x480/04/86/82/04868201.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "($)TV con internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4787355,
                        "kidsFreeTo": 2,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Fp2XRrNgKkDLS_j7Wd93O_0rKMk=/720x480/04/86/81/04868199.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Fp2XRrNgKkDLS_j7Wd93O_0rKMk=/720x480/04/86/81/04868199.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 0",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7728409,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BmsYyUzgzrVJdF0eXtFhJjzd3Xo=/720x480/00/00/17/00001717.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BmsYyUzgzrVJdF0eXtFhJjzd3Xo=/720x480/00/00/17/00001717.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Diván cama",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 0",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7728413,
                        "kidsFreeTo": 0,
                        "name": "Suite, 1 cama de matrimonio grande, bañera de hidromasaje (Emerald)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SR7RcCjYLE5pEXUYxG5Q7BDyqYI=/720x480/00/00/17/00001719.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SR7RcCjYLE5pEXUYxG5Q7BDyqYI=/720x480/00/00/17/00001719.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Diván cama",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 0",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7728414,
                        "kidsFreeTo": 0,
                        "name": "Suite, acceso a la piscina, vistas al jardín (Emerald)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SR7RcCjYLE5pEXUYxG5Q7BDyqYI=/720x480/00/00/17/00001719.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SR7RcCjYLE5pEXUYxG5Q7BDyqYI=/720x480/00/00/17/00001719.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 0",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7728415,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pttnPcHG0g0_2h6GV2xZkKYMvKk=/720x480/00/00/17/00001718.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pttnPcHG0g0_2h6GV2xZkKYMvKk=/720x480/00/00/17/00001718.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 0",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7728416,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pttnPcHG0g0_2h6GV2xZkKYMvKk=/720x480/00/00/17/00001718.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pttnPcHG0g0_2h6GV2xZkKYMvKk=/720x480/00/00/17/00001718.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11725635,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11725652,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079836,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079839,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079840,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079841,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079842,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079843,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Superior Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079844,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079845,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079846,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079847,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079849,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079850,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079851,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079852,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079859,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079862,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079865,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079868,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079870,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079873,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079875,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079878,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079882,
                        "kidsFreeTo": 0,
                        "name": "Habitación Accesible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079883,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079884,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079885,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079886,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079887,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079888,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079889,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079890,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079893,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079895,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079897,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079904,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079906,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16356524,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16428104,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16428105,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16428106,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16554478,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16554479,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16558759,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16701027,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219416,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219417,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219420,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219423,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219426,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219430,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219434,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219438,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219442,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219447,
                        "kidsFreeTo": 0,
                        "name": "Habitación Comfort",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219451,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219454,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219458,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219461,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219464,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219467,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219470,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219472,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219478,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219481,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219485,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219489,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219492,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219675,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17814172,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514675,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585167,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585190,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585213,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585235,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585261,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585285,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585306,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585327,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585348,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585369,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585394,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585417,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585438,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585459,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585481,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585502,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585522,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585542,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585565,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585591,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585615,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585641,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585667,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585691,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585715,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585739,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585761,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585785,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585808,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585831,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585855,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585878,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585900,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585924,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585946,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585969,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585992,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586017,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586041,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586090,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586112,
                        "kidsFreeTo": 0,
                        "name": "Double Room Bunk Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586138,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586161,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586184,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586207,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586231,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586254,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586275,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586295,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586316,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586338,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586358,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586377,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586398,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586420,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586442,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586463,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586485,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586507,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586552,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586575,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586597,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586617,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586637,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586657,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586679,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586703,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586748,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586773,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool Access",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586797,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586821,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586845,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586868,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586918,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586940,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586965,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586991,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587015,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587039,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587064,
                        "kidsFreeTo": 0,
                        "name": "Suite W Bathtub",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587089,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587136,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587161,
                        "kidsFreeTo": 0,
                        "name": "Superior Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587186,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587208,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587230,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587253,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587276,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587300,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587323,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18614068,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18628517,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18628531,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18628545,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834891,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834892,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834893,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834894,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834895,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898912,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898913,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898914,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "($)TV con internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19604937,
                        "kidsFreeTo": 2,
                        "name": "De lujo vista al jardín - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CXlJmcOKrRk_huHjZcCm8qrJPaU=/720x480/04/86/82/04868200.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CXlJmcOKrRk_huHjZcCm8qrJPaU=/720x480/04/86/82/04868200.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "($)TV con internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19604999,
                        "kidsFreeTo": 2,
                        "name": "De lujo vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Fp2XRrNgKkDLS_j7Wd93O_0rKMk=/720x480/04/86/81/04868199.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Fp2XRrNgKkDLS_j7Wd93O_0rKMk=/720x480/04/86/81/04868199.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103824,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Living room",
                            "Terrace",
                            "Wheelchair-accessible"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20103838,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños  (2-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entrada anticipada",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Karaoke",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salida tardía",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de periódicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tiendas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Velero",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Windsurf",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.2,
                    "totalSurveys": 902,
                    "valuesAverage": [
                        4.3
                    ]
                },
                "title": "Hotel de playa todo incluido en la Riviera Maya ideal para familias",
                "uri": "bluebay-grand-esmeralda",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente. Yoga, pilates y zumba."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente. Entretenimiento, bebidas y antojitos al aire libre en El Zócalo."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno y comida bufet, y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 5 y 12 años, supervisado por adultos. Abierto diariamente de 09:00 a 17:00 hrs."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como voleibol en la piscina, aeróbicos acuáticos, etc."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol y fútbol de playa, cuerda de equilibrio, tiro con arco y tenis."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Los restaurantes Dos Lunas y Bahía requieren reservación para la cena. El restaurante Cocoa Grill & Seafood es solo para adultos. Fontain Cigar Corner es solo para adultos y tiene cargo extra. Coyote Loco y Kinky Night Club son solo para adultos. La sección VIP del Oasis Beach Club tiene cargo adicional. Cocoa Beach Club tiene costo adicional."
                    }
                ],
                "description": "Grand Oasis es un hotel de playa todo incluido en Cancún, con un programa de entretenimiento único. En el complejo hay espectáculos en vivo, box, conciertos, festivales, fiestas temáticas y números inesperados como los que se presentan en el área de la piscina de 400 metros de largo, que es las más grande del destino. Entre sus restaurantes y bares se sirven especialidades japonesas, mexicanas,\r\nitalianas, asiáticas y mariscos. También cuenta con clubes de playa con camas balinesas, camastros, piscinas y servicio a alimentos.\r\n\r\nEste hotel se compone de una estructura piramidal con dos edificios a los lados, en los que se distribuyen 1,231 habitaciones y suites. Todas ellas tienen decoración mexicana de tendencia minimalista, balcón o terraza, minibar y cafetera. Algunas habitaciones tienen capacidad hasta 3 menores y 2 niños gratis todo el año. En la propiedad también hay casino, spa con temascal, salones para eventos, tiendas, gimnasio, cancha de usos múltiples y marina. \r\n\r\nEl Museo Maya de Cancún está a 550 metros, la Zona Arqueológica El Rey se encuentra a 2 kilómetros y el centro comercial La Isla, que es el más famoso en el área, está a 4 kilómetros. El Aeropuerto Internacional de Cancún (CUN) se localiza a 16 kilómetros. \r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva.\r\n\r\n***El hotel cobrará al momento del registro un cargo por servicio de $112.00 MXN por habitación por noche.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $73.00 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Los estudiantes y jóvenes viajeros de 18 a 25 años, viajando sin padre o tutor legal, deberán pagar al momento de registro una póliza obligatoria no reembolsable de $30.00 USD por persona en la temporada de Spring Break, durante los meses de febrero a abril.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/f813e9f9f36b100e7c7709af2b50be5d1dcd38018d2b63bd699e6180dab49a63_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Grand con vistas al océano ",
                        "cloudUri": "https://img.cdnpth.com/media/100231/1fbaf09dde2d8e08a4c8d5d9bc8b4a7d6649ea73cae160729c6cba1fc0e0bff8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/c5ce1e47e327cfd311a9dd163f9579d9dd81ed29e347a507a68a58df91d00f7c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/ceebfb00ce61f2bf9f878d331476a54b005b27f7f3938d4a4cc7096ec991e2fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/028980d36dfe082dad414f148dbfcd0449bc55964cab49cb99820984ee8b31be.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Grand con vistas al océano ",
                        "cloudUri": "https://img.cdnpth.com/media/100231/82c2e87a8766573b35925229a7ae5905c4f5083b4e259a4f8389f64719d8974b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/a5690188133532b1df5c8f6633beeb3118fe8762170184e5077c3759fd9082b9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/af09da2cbfc696c1f9c92e4c57ea0f0180ca7277d6fc9581e859b1be328377d1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/3818e2ced0b783414bd46c4360e38f188d8d2f3c490c6f880ad3fbdbaf69ce6d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/45282372085c98a5d3b927ccdcb411995ebe3700922b6b631b5fb1f5d13bcc1f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/f1e7d3583eaee614bd9f4bccfb10cbc0ae969412e0e857ed4fbb5c6181355032.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/e894fba72c9e0efdf24a31769635b056599b18a65c5033d37bb3aaddb778d791.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/2e54417817a33ab17a33bdf06115823652b079ea21f4f95956c6a70ca6194c0b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/2fbffc7ea7390ae14be7835f77c16ae7eb10bb2302ab9d247b58af1c786db5bf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/cd07d083df4fcf2e254cb660edb915de0b77dea551be6c075cd5d9b84f0a851e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/d547e7967a67d7f623ce04ddf10cfbe34cfcc459a940cad165a5e4620e413f81.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/1ac2a04b5eed3194a8bb6fee36e9cf6e363bc16338e548c600c2339ca589a6b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/61c30a7b5aa6226dcebefc2761b07ba753d48a2d8b5638411596adc2e717c4ea.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/f2a6de7840e1f12cee629a65d7b368966a658ff17f60908d1fe814b2c77214b9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/e23c9c0653ca3513ad3253215e38eddbaedd83147ab0670b1012e609e100b859.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/df4c608be5117e9947e79395bf46f19da0276bb79c2ca01b90eca42ba6d9a239.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/c5db39f6ba7718004a8429d090bd9fa0975e8ea54a65580f44249c6c64c1f3a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/bdcff907c4b6eee52dfbab32a6fcd5db7c38e6070725990ea2ced0b2001a023f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/8e6c9b472815e246bff5a5edcc8793358ff6f1c00bc7a4268f3f8db51e7041cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/f0f8c06699f07f781b64988cf7f4c6f4a11926c3b00ff410f1ec89f4aa9365f2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/514b8a8bcd666a09ba4b909da4d4d036a9e3e478c5e01df72ded0def24660780.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Grand con vistas a la puesta de sol",
                        "cloudUri": "https://img.cdnpth.com/media/100231/6dd82180bad3f88f0de83af7ce65bbc124867450b3f2448d5a579cbd18f7d0fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Grand con vistas a la puesta de sol",
                        "cloudUri": "https://img.cdnpth.com/media/100231/7701a5dd959b180f068f1d9fcd790eb69b209c9e8031910ab06ae9e62abf652d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/c0837181942079c62feed3e12218daee7ba02a1b33e958f915c47021ff2db944.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/e8480f2b4851db7a818ed8223efb4f32b7b344567676d8fc6cabe2d98d17a946.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/f2a46ab667f766dd2dd8a0a66711b23c454b492b40e76837edd6b3c9468e6e1a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/ef783e833c139176a5131ae326519fcf30125a20937c055acb59821fb3a5faf8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/c8d37b2f17473d7e1c6ab00b6b403e5e7fddfcf3756fdf70ed499740cd2f74ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/83c11968149589554d93765696cab38cbd3cd097ecf5e980603995e840492460.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/db3c98ad665d67527abcfa789a0cbe8cf12777888875b125f2ab61b94b9433b8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/fd19d4c28cd52e89dcedc427b7d740274958e0d8056223095a04d91fc99199e3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/6e82138631935f7e2d14bc0d028be560341de3ce81c4734cf727525809a0aeb0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/40e95499e92bce82ef256a2d8b4c538dccd09f2f039454de8c8160127751cb9b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/e66155173c016caa4467f2f06db0248c614254acd13862250871149430dad071.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/14590ca6d7b2e775db02c6d9437ae03cc70aa48a0b7e0498b1ae7a0c15d59da7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/95211a15571aa0135e292a2eaabcdbf3affa44dd8877c9285048cf8967285898.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/75cce68533dd01a2473ee28bafcf90f5b0438c8b4ce693de5bc1d883d5f5125a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/1b0126c127938675cf7ee3183b06c110ea5f156c1f7f66b4c83f8a17d119be9b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/59065527e4488d3d189683b21d9ea2a18829384c6a38ee89c8a539d16b94c39d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100231/d8941f54de5a5d74128ae57e87751a96e8988a052b8f7d18880cb13f85ea71b3.png"
                    }
                ],
                "hotelID": 100231,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.0778028746619",
                    "longitude": "-86.77476972341537",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcán km 16.5, L 45, 46 y 47, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Grand Oasis Cancún",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Makitaco",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Il Forno Dos Lunas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Kinky Night Club",
                        "type": "Bar"
                    },
                    {
                        "name": "Bahía Steak House",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Tun Kul",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Hacienda Sarape",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Dos Lunas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Placita Sarape",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Coyote Loco",
                        "type": "Bar"
                    },
                    {
                        "name": "Havana Sport Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Agaves La Cantina",
                        "type": "Bar"
                    },
                    {
                        "name": "Hippie Chic",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Placita Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Coffee & Me",
                        "type": "Cafetería"
                    },
                    {
                        "name": "Hippie Chic Beach Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Akeru Cocina Fusión",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Trattoria",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Tatish Buffet Internacional",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Cocoa Grill & Seafood",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Hacienda Sarape Wet Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Gecko Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Cocoa Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "El Mirador",
                        "type": "Bar"
                    },
                    {
                        "name": "Dos Lunas Terraza Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Dos Lunas Wet Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Fontain Cigar Corner ($)",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594003,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594045,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594087,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594131,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594154,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594175,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594197,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594218,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594242,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594264,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594287,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594309,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594331,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594351,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594373,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594416,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594439,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594462,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594484,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594506,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594530,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594552,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594575,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594598,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594621,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594645,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594667,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594689,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594712,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594735,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594782,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594805,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594857,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594904,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594931,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594955,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594978,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595001,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595027,
                        "kidsFreeTo": 0,
                        "name": "Executive Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595052,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595075,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595099,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595124,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595149,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18595172,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594024,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594066,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594109,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594395,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594759,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594831,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18594880,
                        "kidsFreeTo": 0,
                        "name": "Business Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "($)Internet inalámbrico",
                            "($)Películas de pago por evento",
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cortinas oscuras",
                            "Detectores de humo",
                            "Minibar",
                            "Plancha a solicitud",
                            "Puerto USB",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de plasma de 42 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001865,
                        "kidsFreeTo": 0,
                        "name": "Grand vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zQfgLjOu4tTsq1awu1pMLj90O68=/720x480/05/10/62/05106235.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zQfgLjOu4tTsq1awu1pMLj90O68=/720x480/05/10/62/05106235.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "($)Internet inalámbrico",
                            "($)Películas de pago por evento",
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cortinas oscuras",
                            "Detectores de humo",
                            "Minibar",
                            "Plancha a solicitud",
                            "Puerto USB",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de plasma de 42 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001866,
                        "kidsFreeTo": 0,
                        "name": "Grand estándar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jvqFQBPNZICAYoPKpI8Vv1Jr3U8=/720x480/05/10/62/05106236.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jvqFQBPNZICAYoPKpI8Vv1Jr3U8=/720x480/05/10/62/05106236.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "($)Internet inalámbrico",
                            "($)Películas de pago por evento",
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cortinas oscuras",
                            "Detectores de humo",
                            "Minibar",
                            "Plancha a solicitud",
                            "Puerto USB",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de plasma de 42 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4932807,
                        "kidsFreeTo": 0,
                        "name": "Grand estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jvqFQBPNZICAYoPKpI8Vv1Jr3U8=/720x480/05/10/62/05106236.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jvqFQBPNZICAYoPKpI8Vv1Jr3U8=/720x480/05/10/62/05106236.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "($)Internet inalámbrico",
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Detectores de humo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Puerto USB",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6983036,
                        "kidsFreeTo": 0,
                        "name": "Grand vista al atardecer",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gUliOzZPwnzzoe9IfknluK0m4No=/720x480/05/10/62/05106234.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gUliOzZPwnzzoe9IfknluK0m4No=/720x480/05/10/62/05106234.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Alarm clock",
                            "Balcony",
                            "Baño",
                            "Bathtub",
                            "Cable TV",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable heating",
                            "Living room",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Radio",
                            "Room size (sqm)",
                            "Satellite / cable TV",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi",
                            "YES Disability-friendly bathroom",
                            "YES Wheelchair-accessible"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7744075,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Alarm clock",
                            "Balcony",
                            "Baño",
                            "Bathtub",
                            "Cable TV",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable heating",
                            "Living room",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Radio",
                            "Room size (sqm)",
                            "Satellite / cable TV",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi",
                            "YES Disability-friendly bathroom",
                            "YES Wheelchair-accessible"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7744078,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Double bed",
                            "Extra beds on demand",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating",
                            "Internet access",
                            "King-size bed 150-183 width",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Radio",
                            "Room size (sqm)",
                            "Safe",
                            "Satellite / cable TV",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi",
                            "YES Disability-friendly bathroom",
                            "YES Wheelchair-accessible"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8098503,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Double bed",
                            "Extra beds on demand",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating",
                            "Internet access",
                            "King-size bed 150-183 width",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Radio",
                            "Room size (sqm)",
                            "Safe",
                            "Satellite / cable TV",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi",
                            "YES Disability-friendly bathroom",
                            "YES Wheelchair-accessible"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335980,
                        "kidsFreeTo": 0,
                        "name": "Room Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085524,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085526,
                        "kidsFreeTo": 0,
                        "name": "Twin With Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085528,
                        "kidsFreeTo": 0,
                        "name": "Double Classic Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085529,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085530,
                        "kidsFreeTo": 0,
                        "name": "Room Comfort",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085533,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085537,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085539,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085540,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085541,
                        "kidsFreeTo": 0,
                        "name": "Double Capacity 3",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085542,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085544,
                        "kidsFreeTo": 0,
                        "name": "Triple Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085546,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176450,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 3",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176454,
                        "kidsFreeTo": 0,
                        "name": "Single Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176457,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176461,
                        "kidsFreeTo": 0,
                        "name": "Double Golf View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176467,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176469,
                        "kidsFreeTo": 0,
                        "name": "Room Lake View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176471,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176474,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176477,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176479,
                        "kidsFreeTo": 0,
                        "name": "Double Executive",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176482,
                        "kidsFreeTo": 0,
                        "name": "Room Grand Deluxe",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176485,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085522,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085521,
                        "kidsFreeTo": 0,
                        "name": "Double With Terrace",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085519,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176487,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176490,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176492,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176494,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176500,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176501,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176504,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176507,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176509,
                        "kidsFreeTo": 0,
                        "name": "Room Club",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176512,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176515,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176519,
                        "kidsFreeTo": 0,
                        "name": "Room Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176522,
                        "kidsFreeTo": 0,
                        "name": "Single Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176524,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176527,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176531,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176537,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176541,
                        "kidsFreeTo": 0,
                        "name": "Double With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176550,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176553,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176557,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Capacity 4",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176563,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176567,
                        "kidsFreeTo": 0,
                        "name": "Room Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (de pago)",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cunas o camas infantiles gratis",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "2 camas dobles o 1 Cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406766,
                        "kidsFreeTo": 0,
                        "name": "Grand Sunset View",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (de pago)",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cunas o camas infantiles gratis",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "2 camas dobles o 1 Cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406767,
                        "kidsFreeTo": 0,
                        "name": "Grand Ocean View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (de pago)",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cunas o camas infantiles gratis",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "2 camas dobles o 1 Cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406768,
                        "kidsFreeTo": 0,
                        "name": "Grand Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16557946,
                        "kidsFreeTo": 0,
                        "name": "Apartment Capacity 3",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (de pago)",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cunas o camas infantiles gratis",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "2 camas dobles o 1 Cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16736984,
                        "kidsFreeTo": 0,
                        "name": "Habitación (Grand Standard, Non Refundable)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Alarm clock",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930887,
                        "kidsFreeTo": 0,
                        "name": "Triple Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930888,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930889,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930890,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930891,
                        "kidsFreeTo": 0,
                        "name": "Room Pool View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930892,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930893,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930894,
                        "kidsFreeTo": 0,
                        "name": "Triple With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930895,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930896,
                        "kidsFreeTo": 0,
                        "name": "Room Classic",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930897,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16930898,
                        "kidsFreeTo": 0,
                        "name": "Room With Terrace",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16990068,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 4",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16990069,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 1",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16990070,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229294,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229296,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229298,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229300,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229302,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229304,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Garden View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229306,
                        "kidsFreeTo": 0,
                        "name": "Twin Sea View Capacity 3",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988233,
                        "kidsFreeTo": 0,
                        "name": "Room Grand With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988234,
                        "kidsFreeTo": 0,
                        "name": "Triple Lake View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wake-up service",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988235,
                        "kidsFreeTo": 0,
                        "name": "Single Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988236,
                        "kidsFreeTo": 0,
                        "name": "Single With Views",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988237,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988238,
                        "kidsFreeTo": 0,
                        "name": "Twin Grand",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364732,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364734,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364735,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Lake View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364736,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364737,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421599,
                        "kidsFreeTo": 0,
                        "name": "Single Lake View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421603,
                        "kidsFreeTo": 0,
                        "name": "Single Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421607,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482520,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482523,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482525,
                        "kidsFreeTo": 0,
                        "name": "Single Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482527,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482528,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482529,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482530,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482531,
                        "kidsFreeTo": 0,
                        "name": "Triple Ocean View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482533,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482534,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482535,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482538,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528880,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528881,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591628,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591652,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591676,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591700,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591724,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591748,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591772,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591798,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591823,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591873,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591900,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591925,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591950,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18591977,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592005,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592034,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592063,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592088,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592113,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592140,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592166,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592194,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592249,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592277,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592305,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592334,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592361,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592388,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592416,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592444,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592470,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592496,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592520,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592545,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592572,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592597,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592623,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592649,
                        "kidsFreeTo": 0,
                        "name": "Business Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592698,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592724,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592749,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592796,
                        "kidsFreeTo": 0,
                        "name": "Executive Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592821,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592871,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592896,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592921,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592948,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592972,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592995,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593016,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593083,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593149,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593170,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593213,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593235,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593282,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593304,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593349,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593372,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593391,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593412,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593453,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593472,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593493,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593514,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593534,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593556,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593579,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593622,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593644,
                        "kidsFreeTo": 0,
                        "name": "Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593664,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593684,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593327,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592845,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18592222,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593862,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593767,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593906,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593927,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593950,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593971,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593748,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593727,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593706,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593434,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593805,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593259,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593191,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593128,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593039,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593842,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18593883,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Actividades al aire libre",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Actividades para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Aeróbicos acuáticos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para fumadores",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Beach Club Premium",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cancha de usos múltiples",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Casino",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de niños (5-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cocoa Beach Club",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entrada exprés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entretenimiento en vivo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Fútbol de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico básico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico de alta velocidad",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Karaoke",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Oasis Beach Club",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Pilates",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salida exprés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de videojuegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Temascal",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tiro con arco",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": null,
                "title": "Hotel de playa todo incluido con espectáculos",
                "uri": "grand-oasis-cancun",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye shows nocturnos, conciertos, presentaciones musicales en vivo, concursos, espectáculos y fiestas."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños de entre 4 y 12 años."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen basquetbol, tenis y voleibol."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y almuerzo y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": null
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Restricciones",
                        "description": "No están incluidos los deportes acuáticos motorizados."
                    },
                    {
                        "title": "Otros",
                        "description": "Internet inalámbrico y llamadas ilimitadas a México, Estados Unidos y Canadá (aplican restricciones)."
                    }
                ],
                "description": "Hard Rock es un hotel familiar y todo incluido localizado frente a la playa en la Zona Hotelera de Cancún. Esta propiedad con temática de rock ofrece actividades para toda la familia, así como un laboratorio de música donde se pueden tomar clases de guitarra o batería. Para divertirse, en las habitaciones hay un menú con 20 guitarras eléctricas Fender®. Además hay cuatro piscinas, una de ellas en forma de laguna y una para niños con juegos. También tiene cinco restaurantes de comida internacional gourmet, de especialidad mexicana y asiática, y siete bares y lounges donde se sirven bebidas, cocteles y vinos nacionales e importados. La cancha de tenis, el gimnasio y el spa son otras opciones para recreación y esparcimiento. \r\n\r\nLas 600 lujosas habitaciones y suites ofrecen televisión de pantalla plana de 42 pulgadas, un minibar surtido con refrescos, jugos, agua y cerveza nacional, y una máquina de café expreso. Los baños tienen bañera de hidromasaje y amenidades Rock Spa®. Adicionalmente las suites cuentan con vista al mar o a la laguna desde sus balcones privados. El hotel proporciona además wifi gratuito, servicios de asistencia personalizada y servicio a la habitación las 24 horas. Los niños se pueden divertir en The Hard Rock Roxity Kids Club™, un área interactiva equipada con instrumentos musicales y un minicine, mientras que para los jóvenes está el área de juegos mecánicos y de videojuegos. \r\n\r\nLa propiedad se localiza en la Zona Hotelera de Cancún, y brinda fácil acceso a la playa del mar Caribe. A tan solo 2 kilómetros se encuentra Plaza Kukulcán, la cual cuenta con varias tiendas de prestigio y joyerías, así como una sección llamada Luxury Avenue. A 3 kilómetros está el centro comercial La Isla, uno de los más visitados de la ciudad. A 6 kilómetros se ubican Coco Bongo y The City, además de los centros comerciales Plaza Forum y Plaza Caracol. El Aeropuerto Internacional de Cancún (CUN) se sitúa a 18 kilómetros de distancia.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $67.42 MXN por habitación, por noche, a pagar directamente en el establecimiento.\r\n\r\n***Se aceptan máximo dos mascotas de hasta 22.5 kilos por habitación, solo perros y gatos (aplican cargos, restricciones y categorías específicas). \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/184e7f1bfbd5e0824ab576dc5ab4c0827e1ade2158e3c82df9de0a025fa5f7cc_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/eb31ffadf6efd0e42fb16b3ea800447596fdafca9b8e094cb6f83f0454c30af4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/2b43b0a17b15203b8ffb4950d349aa1cc0e09bf056272ebdbc48cc18465b7df6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/e954721b24cbf401c0d67eaf985afdd33635b0b2de87b14b3a21a71cf69bede6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/ef80ca81ced39a1b032475c8737f4474e879bbec12a11d136cae51bb1ea0f098.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe con vistas a la laguna - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100111/af83456ad981369dac1b08e707f014af643043f39a54450f462057b011b5fae1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/95a4b59074fb54838f838ab307ebd5db8a07e3c3d28106e818b32698d8d4198b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/74aa59e06ffcc5653d574c748438160f92e38051a4ce3f22917c579f34f1c577.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe con 2 dormitorios y vistas a la laguna",
                        "cloudUri": "https://img.cdnpth.com/media/100111/e1bb7909516b5257afd1b8aae692d935b0a7e66267f45abcee77cf540f1169cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/edd4e48e6d0fd1ceb6368b18e4400af3fd329aafc7409b1712eb5538627fb93a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/12e0c6711d81be7a0722bc10e271e9177a3895be55fdca70e362879c712902fb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/e96cee14ea201c4fc339511a0f2008e23837eee6a2887166e4cddc7f0b6224b0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/7d84a06b3a85b3758a371d6a83a119955b8d1092aac3592ac9cc1279a7f814ae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/e6856d3dea994560a8cacad42da73c52bcca960c09e59537511660969d4df4ae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/d9fa3dc92efee51e596bf410acfe34d9cee01889a742a3ecae9eebd713ddacae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/0402c6b55655160a2d510d5beef1ad9ccf7cdb698936254cc2fc7ff260931b72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/d08be53c5aded6c87564c6c32119cd7fd9ed9fa4f65cffdd30d0cc506a3495a8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/941f1a2c24688bebba0a396cc9ba283ef3e1dc1532bf1fbba4456242a676bc4b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/ed65ff61b73fc4020e255f12b40732519118a9e331961880eb6a29c35c156b4b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/53fc1fb73c9da5aa6405d94c9a1ce95b4965dccd40dc74d99af1e82b3dd42ad0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/89f4423f5710fa3ae76c4b16325745d57be1ab1439bf2bca616c6c7c2261b4d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/291ea4801ad45f2f926e68f51ca1c45f3994a1df9714b3eab0b32adebcb1d9fd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/c51e9d82b31f33b9a4e7cb5529bd82bcfedc68e1ab2b2d30405a98068845291d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/8da74e9f153fe6a8c75ac0ff4aa212fe922c4a43dcdc851d177a5f2343eac545.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/0b9be8d60452f1bf13eb9964a8c9f4536e7a3490b517602ff20dba4b0134606a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/99ae9f8aa514b0f7f859c0e04b27cfb4cae22add9fa9b6fa4fd79c158fdf6e96.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/6faf96615db3a5b8a339f1ff9265c2fcdddbab03538a702b5a53f8a65a4497ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/f761af00c5e052c207ca9156bb326760649302cdce0fac82225a100e48485bbf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/ad948405ad23343e8af7a8a484fd92643a4b8aea1acd207bf22bb37e01863605.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/dbe219447ab0b338800f83ade0b06e6636129a487c1b84d43a2fbeec84c297a9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/470f4708d0ce3bce4fa2a22ffd33c95140fea07afe5f1e2856e2c8c04ea8d6ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/dc36e05872d51c8fa73ba750db627416d0c9efc6d8bd8848f2269a4cd90aecba.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/dd0963ae4d858d595546b91443a1be44654470bff4aeb5cb9c07c806c6ddc201.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/b75df51e594aef5456a7271613f21ff3e55a3a3581c4e6ab4b260a1f5e77ec90.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/0c642bf5024f25de91704133adb6c7ee1196363a9f5c9d88371bd6e47cff037f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Diamond con cama extragrande y vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100111/fab6d42dcef15f55e1f788761baa266f276801a2ef635be54aa60ae219c7313f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/287aaa11a31ded30ce0d62d3e2bef0e4f1bdfc68b8da45ef4de7548b44e8aa40.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/3c245e4c9cca3e4fcd9d8ffc55f4c58b7e5aabe069ef510eca3a5bb334c299c9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/d663ba5defedb2d5fc8770b3f2b5d1d71dfbde98ad6f59fb4febcfefdde55de8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/a8b77af6d7186c373cce5eef2611a97e5753d8e0bbade0981d17660104b6ef3c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/0c3af0d6ed2336c6f4fc73f215aa34aaca2e4af9d53dc99acbdc6b6900a5d365.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/d1e75b3f3b7d0bd353d99d1c817e471e1bfed0a01dcafd481667de3a5f405b7c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/adb2a00761f175304cf34a8013a45502aa27d0d91fae34f517f45bbd4d27482a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100111/b3dddfd12c248972d630b0f54eb72f2efcb9d2ffe9ae54c8bcdfb5f2e0a9f551.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Deluxe con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100111/ecf6baa4b16c0da7ffe82564932768756a5ae02fdfb9c10d4dbc6fc0bc54a333.png"
                    }
                ],
                "hotelID": 100111,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.089325090288785",
                    "longitude": "-86.76999807357788",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcan km 14.5, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Hard Rock Hotel Cancún",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Splash",
                        "type": "Bar"
                    },
                    {
                        "name": "Pizzeto",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Ciao",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Smash",
                        "type": "Bar"
                    },
                    {
                        "name": "Zen",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Dive",
                        "type": "Bar"
                    },
                    {
                        "name": "Toro Steakhouse",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Float",
                        "type": "Bar"
                    },
                    {
                        "name": "The Show",
                        "type": "Bar"
                    },
                    {
                        "name": "Frida",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Diego",
                        "type": "Bar"
                    },
                    {
                        "name": "Cafetto",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473028,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473051,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473075,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473101,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473126,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473150,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473174,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473200,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473223,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473247,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473270,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473295,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473318,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473340,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473360,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473377,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473395,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473415,
                        "kidsFreeTo": 0,
                        "name": "Royal Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473433,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473450,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473467,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473483,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473498,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473513,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473529,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473543,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473561,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473579,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473597,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473616,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18473639,
                        "kidsFreeTo": 0,
                        "name": "Platinum Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cortesía nocturna",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa para café",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1004379,
                        "kidsFreeTo": 3,
                        "name": "De lujo king",
                        "isActive": true,
                        "view": "Obstruida",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/DjPMcmcxbDiMqOAm04mJK344AjM=/720x480/04/81/28/04812859.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/DjPMcmcxbDiMqOAm04mJK344AjM=/720x480/04/81/28/04812859.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Juguetes de playa para niños",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1053501,
                        "kidsFreeTo": 3,
                        "name": "De lujo familiar vista al mar (2 habitaciones)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6saH_hHIrkdbazYQY1S9jY0N_ds=/720x480/05/11/62/05116242.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6saH_hHIrkdbazYQY1S9jY0N_ds=/720x480/05/11/62/05116242.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Juguetes de playa para niños",
                            "Llave electrónica",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "4 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3928879,
                        "kidsFreeTo": 3,
                        "name": "De lujo familiar doble vista al mar (2 habitaciones)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6saH_hHIrkdbazYQY1S9jY0N_ds=/720x480/05/11/62/05116242.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6saH_hHIrkdbazYQY1S9jY0N_ds=/720x480/05/11/62/05116242.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 masaje de 25 minutos en pareja",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas a solicitud",
                            "Bolsa de tela",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cortesía nocturna a solicitud",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Llave electrónica",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Mini repostería de bienvenida",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama matrimonial",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3942879,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock vista al mar (1 habitación)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ox5OH7yfT9u4f_UAO4NZW6jgxbE=/720x480/05/11/62/05116243.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ox5OH7yfT9u4f_UAO4NZW6jgxbE=/720x480/05/11/62/05116243.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198336,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zEwUHSXl3zlaF_uDOkoi28JFAaw=/720x480/02/07/86/02078684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zEwUHSXl3zlaF_uDOkoi28JFAaw=/720x480/02/07/86/02078684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715176,
                        "kidsFreeTo": 3,
                        "name": "De lujo doble",
                        "isActive": true,
                        "view": "Obstruida",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Q95H01gaqcjGBZtyX79nKAIutHI=/720x480/01/76/46/01764651.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Q95H01gaqcjGBZtyX79nKAIutHI=/720x480/01/76/46/01764651.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Bolsa de tela",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Desayuno (previa solicitud)",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD (previa solicitud)",
                            "Secadora de cabello",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715178,
                        "kidsFreeTo": 0,
                        "name": "Diamond king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/R5mIS5lGGyVuzlvkELMIKbiAo4A=/720x480/01/76/46/01764652.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/R5mIS5lGGyVuzlvkELMIKbiAo4A=/720x480/01/76/46/01764652.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 King",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715179,
                        "kidsFreeTo": 3,
                        "name": "Familiar de lujo de dos dormitorios vista a la laguna",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/QHu8LRo_wHXfoRyRxUlhNiU3iMo=/720x480/01/76/46/01764653.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/QHu8LRo_wHXfoRyRxUlhNiU3iMo=/720x480/01/76/46/01764653.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715180,
                        "kidsFreeTo": 3,
                        "name": "De lujo doble vista a la laguna",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/56ciMiq1AHtHuoRxJcFfecX2jy8=/720x480/01/76/46/01764654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/56ciMiq1AHtHuoRxJcFfecX2jy8=/720x480/01/76/46/01764654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715181,
                        "kidsFreeTo": 3,
                        "name": "De lujo king vista a la laguna",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zEwUHSXl3zlaF_uDOkoi28JFAaw=/720x480/02/07/86/02078684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zEwUHSXl3zlaF_uDOkoi28JFAaw=/720x480/02/07/86/02078684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715184,
                        "kidsFreeTo": 3,
                        "name": "De lujo doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/xQh_s8HMRsavb-PKvsWIBTXZtJc=/720x480/02/07/86/02078685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/xQh_s8HMRsavb-PKvsWIBTXZtJc=/720x480/02/07/86/02078685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715185,
                        "kidsFreeTo": 3,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EulVo7o09clf3_2nQkUE3LITUUM=/720x480/01/76/46/01764657.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EulVo7o09clf3_2nQkUE3LITUUM=/720x480/01/76/46/01764657.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 masaje de 25 minutos por persona",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Bolsa de tela",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Check in y check out privados",
                            "Control individual del clima",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Servicio de concierge",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715186,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty Vista al Mar King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EulVo7o09clf3_2nQkUE3LITUUM=/720x480/01/76/46/01764657.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EulVo7o09clf3_2nQkUE3LITUUM=/720x480/01/76/46/01764657.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Bolsa de tela",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Comedor",
                            "Control individual del clima",
                            "Cortesía nocturna (previa solicitud)",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV de pantalla LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4715188,
                        "kidsFreeTo": 3,
                        "name": "Rock Suite Vista al Mar - Dos habitaciones",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BoDA6KwnQcpXjkbvW1_v9epc154=/720x480/01/76/46/01764658.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BoDA6KwnQcpXjkbvW1_v9epc154=/720x480/01/76/46/01764658.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6865843,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Sofá cama",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165987,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean View (Two Bedroom)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165989,
                        "kidsFreeTo": 0,
                        "name": "Diamond Vista al Mar King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Sofá cama",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165990,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean view (One Bedroom)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165991,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165992,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165993,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas a la laguna",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165994,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Vista al Mar Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Asiento de inodoro elevado",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Barra de apoyo en la ducha",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha adaptada",
                            "Ducha efecto lluvia",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165996,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe doble, vistas a la laguna",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165997,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Vista a la Laguna ( Dos Habitaciones)",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165998,
                        "kidsFreeTo": 0,
                        "name": "Deluxe cama king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10165999,
                        "kidsFreeTo": 0,
                        "name": "Deluxe camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073920,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073922,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073923,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073924,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073925,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073927,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073928,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Comunicada",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073931,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073933,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073934,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073936,
                        "kidsFreeTo": 0,
                        "name": "Doble Business",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073937,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073938,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073940,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073941,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073942,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073944,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073946,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073948,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073950,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073952,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073953,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073956,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073957,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Luxury Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073959,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073962,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073963,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073966,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073967,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073972,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175838,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175842,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Un Dormitorio",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175843,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175844,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175845,
                        "kidsFreeTo": 0,
                        "name": "Habitación Business",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175846,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Living room",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175847,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Two Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175848,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175849,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175850,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175851,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175852,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175854,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175855,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175856,
                        "kidsFreeTo": 0,
                        "name": "Habitación Business Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175857,
                        "kidsFreeTo": 0,
                        "name": "Tienda Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175858,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175859,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175860,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175861,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175863,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175864,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175865,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175866,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175867,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175868,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175869,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175870,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175871,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175873,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175874,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175875,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175876,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175877,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16175878,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16258600,
                        "kidsFreeTo": 0,
                        "name": "Family Room Ocean View Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16301471,
                        "kidsFreeTo": 0,
                        "name": "Habitación Interior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16404284,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16404285,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16404286,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16404287,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406673,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Ocean View - Two Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Bañera de hidromasaje privada (cubierta)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (indoor)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406674,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Ocean View Double Beds - Two Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969421,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969422,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969423,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969424,
                        "kidsFreeTo": 0,
                        "name": "Habitación Comfort",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969425,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Balcón",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969427,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969428,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969429,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969430,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969431,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969432,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969433,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969434,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969435,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969436,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969437,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969438,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969439,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969440,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969441,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969442,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969443,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969444,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16969445,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216896,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216898,
                        "kidsFreeTo": 0,
                        "name": "Individual Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216899,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 1",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216900,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 1",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216901,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216902,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216903,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216904,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216906,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 3 Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216912,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216916,
                        "kidsFreeTo": 0,
                        "name": "Doble Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216920,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216924,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216927,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas Queen Size Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216934,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 3",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216946,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216953,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216963,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216974,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 4 Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216984,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216993,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217001,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217010,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217019,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217028,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217036,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 2 Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217045,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 4",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217052,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217057,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217062,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217069,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17510901,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17906360,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Dormitorios Con Vistas",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18007438,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18189793,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18189800,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Cama King Size Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18189807,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421730,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421731,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421733,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421734,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Lago",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421735,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421736,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421737,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421738,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18421739,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18441030,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470394,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470428,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470462,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470495,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470528,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470561,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470594,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470626,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470658,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470690,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470719,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470749,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470781,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470812,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470843,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470873,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470902,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470930,
                        "kidsFreeTo": 0,
                        "name": "Royal Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470960,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18470988,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471016,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471044,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471071,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471100,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471126,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471153,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471180,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471207,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471235,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471263,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471291,
                        "kidsFreeTo": 0,
                        "name": "Platinum Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471320,
                        "kidsFreeTo": 0,
                        "name": "Platinum",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471347,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471374,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471400,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471427,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471453,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471481,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471509,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471537,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471565,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471593,
                        "kidsFreeTo": 0,
                        "name": "Business Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471620,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471647,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471672,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471699,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471725,
                        "kidsFreeTo": 0,
                        "name": "Business",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471751,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471777,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471803,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471829,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471856,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471881,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471906,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471930,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471956,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18471982,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472006,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472031,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472055,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472079,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472103,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472127,
                        "kidsFreeTo": 0,
                        "name": "3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472150,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472173,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472201,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472227,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472252,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472278,
                        "kidsFreeTo": 0,
                        "name": "Golden Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472304,
                        "kidsFreeTo": 0,
                        "name": "Golden",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472330,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472354,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472378,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472402,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472427,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472450,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472473,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472496,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472519,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472540,
                        "kidsFreeTo": 0,
                        "name": "Double Room Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472562,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472583,
                        "kidsFreeTo": 0,
                        "name": "Double Room No Window",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472605,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472627,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472649,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472671,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472693,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472716,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472738,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472760,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472782,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472805,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472829,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472852,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472877,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472900,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472923,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472946,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18472970,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824488,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824494,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824500,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824506,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824510,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824514,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824518,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Oceano Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824522,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Una Cama",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824526,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824531,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824533,
                        "kidsFreeTo": 0,
                        "name": "Villa Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824534,
                        "kidsFreeTo": 0,
                        "name": "Villa Tres Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890950,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247097,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247098,
                        "kidsFreeTo": 0,
                        "name": "Doble Interior",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247099,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Lago",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247100,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247101,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247102,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247103,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247104,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247105,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247106,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247108,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247110,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247111,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247112,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247113,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Cafetera / Tetera",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247114,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247115,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247117,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247118,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247120,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247121,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247122,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247123,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247124,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247125,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247127,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247151,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247152,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247153,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247154,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Lago",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247155,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed One Bedroom",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19247156,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Garden view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Basquetbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Equipo para snorkel",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbolito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Guitarras Fender y tocadiscos Crosley",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hockey de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de póker",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de videojuegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tour de Memorabilia",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Traslados al aeropuerto",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 856,
                    "valuesAverage": [
                        4.7,
                        4.6
                    ]
                },
                "title": "Hotel todo incluido con temática de rock y familiar frente a la playa",
                "uri": "hard-rock-hotel-cancun",
                "tags": [
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    }
                ],
                "description": "Altitude at Krystal Grand Cancun - All Inclusive es un hotel de playa todo incluido en Punta Cancún, con vistas increíbles del mar Caribe, a unos pasos de centros comerciales y de los más conocidos clubes nocturnos y bares, así como del centro de convenciones Cancún Center. El Aeropuerto Internacional de Cancún (CUN) se sitúa a 23 kilómetros de distancia. \r\n\r\nLa propiedad se compone de 100 habitaciones exclusivas para huéspedes de Club Altitude con vista al mar y a la laguna Nichupté. Todas están equipadas con aire acondicionado, teléfono, televisión de pantalla plana, balcón privado, minibar, caja de seguridad y baño privado con regadera y lujosas amenidades. Las habitaciones y suites Altitude incluyen acceso a un lounge privado y una piscina infinita solo para adultos. \r\n\r\nCuenta con tres piscinas, incluyendo un chapoteadero para los más pequeños, gimnasio y un spa. Además, entre su servicios ofrece concierge, resguardo de equipaje, club para niños y adolescentes y servicio a la habitación las 24 horas. También tiene disponibles varios salones de eventos, el mayor con capacidad para 180 invitados. Por otro lado, la experiencia gastronómica ofrece restaurantes de especialidad, un buffet internacional, y cinco bares, incluyendo uno en el área de terraza con vista al mar y donde se puede disfrutar de una puesta del sol. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $72.62 MXN o $3.75 USD por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/747e18732e10e7f7773f728f0d20f2fff01512cbb076b66992e20124f6af988c_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/a3a5a54d7d68617f744f28b47a358df3c32b2ca7fb74f628d433b49806595f6e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/a43fd5b0e3e951fc8e749f6d7d53ba31e51ef5f26e4b777d7d7b74781ea2e9ad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/3f980a8b46b18f866daafd7750f34b469d8b68b62daddd2fed4727acbb082bf2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/3570ecf1f730ec17ae818a69f5c49a96a4ba0ece9ae675f09f6a11cea6145836.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/15a88fbf82b85ecbd2d64083afd1c19c44f3696116c56dce5fd7a1fc58e9519d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/b711e29fd495db9dd24d22033545e972ff90f1caca2d62842cb424de8b2942b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/6cccd5f4c437ad475c2198e6cf30294788107ddde191b2e84696ecdafd5a1182.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/33e4ee56451128e9c0cbaaaf951a9a236a6e485793fb4238e379409151bacd40.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/abe089cf81b3b49915f5c7c7edd1089872c69773744092425415d9c6463f5a6b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/029121e122aca590b21f38efbbe9149344e6f8235ddcc79e83df0ebb30deef53.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/27896894e62cffb4cfd104094a35ff3d4f4b9b4b2e664e8cb21b470435f069dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/49c91df23d618e4d334faf2f89ac41bed6e9fe3376ad4bd8ee5e840ede0f6c55.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/47500c2284b42ae15fba2ce93a6feab017c8e438d6aac047b7f06f7afb3fcfdb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/36459b81b80ebd342121fb24c19ef5f825db34e81a9684be2849437413597b3d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/bfdc84d0b5b4030d96ff33a36e0fc3bfba606c18eebf0ed717dba5ff80f10276.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/134538014969e4d3bc479192b04fe6533479983432ed1c3956616ace89fb03d7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/dc86225aafe4ee658242e68c3fc8c05022d7f98106d3caaa7359ca9a8d544f3e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/572e4c5776bf1f66decaed8177818a9331e9e9e27ba1e2c3253b1a9b91b4d7b1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/1115dd9cf4aea13aeb00da5ccfda3b28ba482aa812d494bed33e6b1733c5ca69.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/a1bdeeb71667804635c545795bed95aea52364a124cf69155d4d39802446ceae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/6457e99f53574b766c3a36e6ef226a084e5f6e18995c32d40d7fa992ecf519da.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/39b792585ad1d1def4721717c153da6e1d22fdd4344d5da0950fa653ba7ec434.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/0b0c9aba33091ff216b307cc955ef325318278af1ec48ca69f010fbb32fc1ebd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/62b4f7956bbabd3008d5af595d30db008eb363759992c8a4f8aaf4a645b49a10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/c6ca46753b4f35057b6e2582aac92a3958960453e172d342f0fa79cb4670dc50.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/eec66f7fddd087fda7c298e6933fcc091c8c264944ed27c8df802c056bc70454.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/faf737a8d399b9401e1d5393bf60d39ea4cc16fd98fc3ef8fbdb0eefb6553d57.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/b0779554faef3ae763ad08a75a1d5170c3ac0ef519911f94ea3825b301409a51.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/43b95d904df74d3ee8e588569abeffca248fa22a4ba6a71e182be499fbbaf821.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/fe7bf3eef132553cb66696938ab2de21de4e15ebcbccfe505875e11d38c6b2e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/8deccedf82c2a40d82cbd9d0b1500a447f0fb151f83693d85646538ea0c0da10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/35b2982794584fe4773d5c452385c4406f7d1a7dd0ff7ba93223105862520542.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/ceb6eee3b4c09e8ccef4ad4e4b9ebde40d373c8bc6716f0e9c857a854739155a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/cbd610d548e8a8bff42d281c3add13013318afd21c5d8e3b4ca340898291c1ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/3d0e04ffe57b82c4d975374c8cded689dbc13b853befed02465be1094b1aaabc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/96e0cb00dc36e2576358979046c29553d70dbbb23ef236ce70ddf6d6f813f210.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/8c0115ff27551332c5ec050f981f2161aa6821d0843a5aaef9bc8965c26a65f5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/032ae4da4dc7fa6677f9714bf88ae21c1bde81c81307a93426f56e8680400ec3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/5babb8f7d1d62be873386139626b4737eb7bdcc59b75948375cafafecdc95460.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/d427cfab613c72da48da3f75a177e562105a4affb65070c87cedd9531d745a88.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/f05fe36acb6a0bca8ce905f723f5d499ce4e334d22c1c85871878a6baf00cc2e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/4b9d184485646c068108693f53455c635bed20daee5e29bade53046527abba01.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/800f701239a1700671728038ee1f091f343e978efdd08ae26c0c5a9538e280b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/466640/3867514ec0e75d5d4d515ad2966c618426b537a2310e72daba630f5f95bfe685.png"
                    }
                ],
                "hotelID": 466640,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.134789574475654",
                    "longitude": "-86.74324572086334",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcan km 8.5, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Altitude at Krystal Grand Cancun - All Inclusive",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "O",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Coco Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Risotto",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Ayami",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Lounge & Terraces",
                        "type": "Bar"
                    },
                    {
                        "name": "The Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "The Beach Bar & Grill",
                        "type": "Restaurante Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663376,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude doble",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/nFKG5zG88_oGNn9UDEmhGY84QOU=/720x480/05/01/95/05019587.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/nFKG5zG88_oGNn9UDEmhGY84QOU=/720x480/05/01/95/05019587.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663377,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude king",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/nFKG5zG88_oGNn9UDEmhGY84QOU=/720x480/05/01/95/05019587.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/nFKG5zG88_oGNn9UDEmhGY84QOU=/720x480/05/01/95/05019587.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 Cama",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663378,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/rHsaP9OOMa3CPizpUNleOf_x0Tk=/720x480/05/01/95/05019586.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/rHsaP9OOMa3CPizpUNleOf_x0Tk=/720x480/05/01/95/05019586.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 Cama",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663379,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude en esquina vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AdSmznlIJC66duPwt3Bq8mHyNQk=/720x480/05/01/95/05019590.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AdSmznlIJC66duPwt3Bq8mHyNQk=/720x480/05/01/95/05019590.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 Cama",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663380,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude en esquina vista frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9vCH5o381I6ETWtR3PRMsa_mnlk=/720x480/05/01/95/05019589.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9vCH5o381I6ETWtR3PRMsa_mnlk=/720x480/05/01/95/05019589.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 Cama y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663381,
                        "kidsFreeTo": 3,
                        "name": "Master suite Altitude frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/bVibS5ZvelNmNcdMP2qjWjZxt80=/720x480/05/01/95/05019588.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/bVibS5ZvelNmNcdMP2qjWjZxt80=/720x480/05/01/95/05019588.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Reproductor de CD",
                            "Reproductor de MP3",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor con espejo de vanidad"
                        ],
                        "bedding": "1 Cama",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15663382,
                        "kidsFreeTo": 3,
                        "name": "Suite Altitude familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CgmdfP-0xEkNAbz5Uww2a7dSPJ8=/720x480/05/01/95/05019591.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CgmdfP-0xEkNAbz5Uww2a7dSPJ8=/720x480/05/01/95/05019591.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cargadores o adaptadores eléctricos",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15677664,
                        "kidsFreeTo": 0,
                        "name": "Altitude Suite Double",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cargadores o adaptadores eléctricos",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15677665,
                        "kidsFreeTo": 0,
                        "name": "Altitude Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cargadores o adaptadores eléctricos",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15677666,
                        "kidsFreeTo": 0,
                        "name": "Altitude Corner Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cargadores o adaptadores eléctricos",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 15677667,
                        "kidsFreeTo": 0,
                        "name": "Altitude Master Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cargadores o adaptadores eléctricos",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16406360,
                        "kidsFreeTo": 0,
                        "name": "Altitude Corner Suite Partial View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salida exprés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 487,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel frente al mar todo incluido con beneficios especiales",
                "uri": "altitude-by-krystal-grand-cancun-all-inclusive",
                "tags": [
                    {
                        "name": "Alto estándar de limpieza"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Familiar"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Actividades",
                        "description": "Incluye juegos de mesa."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno, almuerzo y cena bufet o a la carta, así como aperitivos y bebidas nacionales de 10:00 a 22:00 hrs."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol de playa y futbol de playa."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": null
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El servicio a la habitación incluye los alimentos, pero aplica un cargo de $5.00 USD por persona, por servicio, a pagar directamente en el hotel al momento de ordenar."
                    }
                ],
                "description": "Flamingo Cancun All Inclusive es un hotel familiar ubicado frente al mar en la Zona Hotelera de Cancún. Cuenta con dos piscinas, solárium, gimnasio, cajero automático y estacionamiento. Para los pequeños dispone de un club de niños y servicio de niñera, mientras que para la relajación de los papás, ofrece servicio de masajes y temazcal. Además, tiene dos restaurantes, tres bares y un salón de eventos con capacidad para 110 invitados. \r\n\r\nLas 249 habitaciones están equipadas con balcón o terraza, aire acondicionado, baño privado con ducha o bañera, televisión por cable y secadora de cabello. Adicionalmente, las habitaciones de lujo tienen minibar y gozan de acceso a una sala de hospitalidad con computadoras con wifi en cortesía, sala de lectura y servicio de café. \r\n\r\nEl hotel está ubicado en la famosa Zona Hotelera de Cancún, frente al centro comercial Plaza Flamingo. A menos de 2 kilómetros están el Centro de Convenciones y discotecas como Coco Bongo y The City, con lo mejor de la diversión nocturna. El centro de la ciudad, con restaurantes, centros comerciales y mercados de artesanías, se localiza a 12 kilómetros y el Aeropuerto Internacional de Cancún (CUN) a 21 kilómetros de distancia. \r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones grupales. \r\n\r\n***Toda reservación a partir de 5 habitaciones deberá contar con el nombre de los titulares. \r\n\r\n***Por disposición del Congreso del Estado de Quintana Roo, los turistas extranjeros que salgan del estado a partir del 01 de abril de 2021, deberán pagar el impuesto VISITAX de $224.00 MXN por persona. El pago se puede realizar antes de la llegada, al ingresar o durante la estancia, ya que la verificación se realiza a la salida del estado. Deberás llenar un formulario y registrarte para efectuar dicho pago, encontrarás más información en tu itinerario una vez confirmada tu reserva. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $73.00 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Al momento del registro el hotel cobrará directamente un depósito de $100.00 USD o $2,000.00 MXN, que se reembolsará siempre y cuando la habitación no sufra daños, se requiera de limpieza adicional o exista algún consumo adicional. Este cargo es por habitación, por estancia. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/0b1a7c158a864f11dfae1850285826202d0d7045586b3f88ee07362ebc110414_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100207/1ba77c64bd0e9c155ad9cb5eac18d4f5a61591454a222988e59ec2e09804bc83.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/00becf478e23bb2c4ce1f22131751d4c5f8ddcff581fc39d3c57488bcf5b7052.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/e301d6412ca13484f8ae7421157a67569fe763b73d9c3f721e4e7642c4299a26.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar con vistas al océano",
                        "cloudUri": "https://img.cdnpth.com/media/100207/0c688b9200fc19b7635941b21e97ae7e14002859b82e7fad6a588c84d96e1177.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/337e5b7f1cd7f2fd1c6097c3c2579f311ce3d01f87cf5965946dbd9b842628eb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/095188f3e20f0e40e63ee56f5870e795be416ad3f7fc3f7715722b827daa6476.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/489af419cf4cb775a9843e3ad115bf0feb554ba2c6c680f5ee3ab5e80a693b86.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/f40c9e813ef6b9ab2672e6616e9b23ed26ab1af5cde36d18db5c95d188721f90.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100207/173c4acc27f49412ab9b6b0e8db14a4af6a52b91501e1a03b3274d684565b412.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/471d630f8dc9a717aa035e70379aacf24ca3588a7954fc25a21163e872362bda.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/6ad0668455499ef816443937411b2ea9d15229b21ca9dd05e45b99e8f7515345.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/864d6f46afbe1bae46a19231b4ffdf9f2ac6b9fa5b0f4577efcb4608067576c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/17190ae79b2dd1ede3344e699f7d8ba0174a495593247d89f37eabd8ab61a167.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100207/1cd22eaeeccb09b0d58ff331ae61ae2adb8d0ebbf310f4ef0937abb4fff7223c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Deluxe con vista al océano",
                        "cloudUri": "https://img.cdnpth.com/media/100207/40bf1184c348ae6ef862828987143ba572bdefa02b1c9b7695d8b5f01d8e414d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/e7c2dcd12ae2b0298d16856a7244755556a56e69f22c0072a0023c3923f879fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/26db3c4ce16ba40d0a135913124d61de8561693ab60b96afc31365c2b14ca039.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/0a39640037970ffff5cdc3b2c5e537b7e4d2c7204723dbc464250f197c4186a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/6c39fc5fbaaf7b69ec0ab69a37ace3da73ec2693cc9c3e5f02279397f5c3ac59.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/8958a6a8a1b58c6826e47028ef5f005ec799cf361dc86c23de0d957298b1bf54.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/7ad543f549b22f78fd08bdf5298d660e1dc762389d0f3ecd5416658622e27d8f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/3994c5cb894078b76bbfd7d1a10cd2b68904de38b86cfa98d180bfce2c76c718.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/81398a6805273ad8da754a9da1adb87405109cd3f6512147a4f4006f8df2f8bf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/819e3dc6e8ab7c9845b9f7145437c5de7480529a0d5ca0c324bbdcc6c18a1e94.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/6ec477a62fe58ec3d8ee267f093bbc97d40b7fd38c276af9053e2336a3e4015b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/1382d922f7b9159b6b725337f1fad01b063b9d5c8e6e99ab719c2ece587b3827.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/46d668f652245a817b1a077f682428867d9e678062bbc0a8873c29bbe605ea2d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/676d72a4abcc4ab72c9f7919665997eb875770a0fc8798f91dea17b2bcdf642f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100207/c73cfd40639cec62d23c5678a0c15acca91d26698b0c96accf03d818b4065f8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/cff3f818ace200a2cbbd51d874797b30e46e3b843feaba6312f8c9dc3bda31a9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/df204ec2173d40fd0a52caf60baf3a386eb624a5bba2c13f924c22608528fcaf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/18d772f907993584b2bb214c054726dc4d9d57e4be920b20b86fb08abfebfe7f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/ad95389cf10cab9232651a384313871e9e7bd42b2d487276d34272c005ef6c33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/a9e87b1b9b5f5fa5f54bd6c95f3f05331d606f3ce31c9971ae6b521b9cb548e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con acceso directo a la piscina - Solo adultos ",
                        "cloudUri": "https://img.cdnpth.com/media/100207/bd052041032cea75062ddc4f37db0185f68bf5af7319da178fd44ca349e978b0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/eaac1fc356a2d494b13695d7e1b200300848da4acdd475500cb00b0a76ce38c4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/1cc1e6877d9734e8f1ac7d3ec941af7e6f64508af36b18b0f376b30a2a810ef6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/f7da446a898b0d6bb1d4a4a0f9e578a7fa69a18ab7a30dd08f780f1a84d050f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/490bc36603eaa53d4a76cda8de96e7631e1fb2829348efe74cc8782d101d44f7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/65606889b6b304a263fc621ef620e71f89ca58411c303bb9ff3f28bda687b2d0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/93f93ae3b0d3384014c70cdd473bfede04801516a0d04acd78953833cfbc5759.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100207/0dd84a4f974f5404bb108ae23d066f97a126b57c56fd72fb796a190d4dec9756.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar con vistas al océano",
                        "cloudUri": "https://img.cdnpth.com/media/100207/5e5c8fa27fac1e917b0058f1ad9b8af95895d7455a8e8e33a467509535628c48.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Deluxe con vista al océano",
                        "cloudUri": "https://img.cdnpth.com/media/100207/de65f12b6fbccf23118e2545d83ea100091da4ddc0035a41adb4719814957a73.png"
                    }
                ],
                "hotelID": 100207,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.117623802179175",
                    "longitude": "-86.75659239292145",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcan km 11 , Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Flamingo Cancun All Inclusive",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Albatros",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "La Fuente",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Las Palmas",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Palenque",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378730,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378758,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378786,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378815,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378843,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378871,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378899,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378927,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378955,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378984,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379013,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379041,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379068,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379095,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379122,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379149,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379176,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379203,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379229,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379254,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379278,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379302,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379325,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379348,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379370,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379394,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379419,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379444,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379469,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379494,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379519,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379544,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379569,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379594,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379619,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379644,
                        "kidsFreeTo": 0,
                        "name": "Leisure 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379669,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379696,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379723,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379750,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379776,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379801,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379826,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379849,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379872,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379895,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379918,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379941,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379963,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18379986,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380010,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380034,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380058,
                        "kidsFreeTo": 0,
                        "name": "Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380084,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380109,
                        "kidsFreeTo": 0,
                        "name": "Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380135,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380160,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380185,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380210,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380235,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380259,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380284,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380308,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380333,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380358,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380383,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380409,
                        "kidsFreeTo": 0,
                        "name": "Double Room Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380436,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380461,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380487,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380514,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380540,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380567,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380593,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380620,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380647,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380673,
                        "kidsFreeTo": 0,
                        "name": "Leisure Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380700,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380727,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380753,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380778,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380804,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380830,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380856,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18380882,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000988,
                        "kidsFreeTo": 5,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Laguna o Jardín o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000990,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la laguna",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1007099,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1009078,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1010009,
                        "kidsFreeTo": 5,
                        "name": "Familiar",
                        "isActive": true,
                        "view": "Jardín o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or patio",
                            "Bañera o ducha",
                            "Bathtub or shower",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Cortinas opacas",
                            "Daily housekeeping",
                            "Deep soaking bathtub",
                            "Flat-panel TV",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Free WiFi",
                            "Habitaciones insonorizadas",
                            "In-room safe",
                            "Iron/ironing board (on request)",
                            "No fumadores",
                            "Non-Smoking",
                            "Phone",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Raised toilet seat",
                            "Room service (limited hours)",
                            "Satellite TV service",
                            "Soundproofed rooms",
                            "Televisión por satélite",
                            "Towels provided",
                            "Wardrobe or closet",
                            "Wheelchair accessible"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996312,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UYtXg0WonUFeWZTXohOHOTV1-lM=/720x480/02/17/37/02173795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UYtXg0WonUFeWZTXohOHOTV1-lM=/720x480/02/17/37/02173795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Asiento de inodoro elevado",
                            "Bañera o ducha",
                            "Bañera profunda",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Habitación en planta ejecutiva",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996314,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room Lagoon View",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JpW8D-iohk4SoKfH_mvr3FF73WU=/720x480/02/17/37/02173793.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JpW8D-iohk4SoKfH_mvr3FF73WU=/720x480/02/17/37/02173793.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Asiento de inodoro elevado",
                            "Bañera o ducha",
                            "Bañera profunda",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Patio",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996316,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZYNX9o-a5HzxcyQ2jO_iXBnh0_g=/720x480/02/17/37/02173791.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZYNX9o-a5HzxcyQ2jO_iXBnh0_g=/720x480/02/17/37/02173791.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Asiento de inodoro elevado",
                            "Balcony",
                            "Bathtub or shower",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Camas supletorias gratuitas",
                            "Daily housekeeping",
                            "Deep soaking bathtub",
                            "Flat-panel TV",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Free WiFi",
                            "Hair dryer",
                            "Iron/ironing board (on request)",
                            "Non-Smoking",
                            "Private bathroom",
                            "Rollaway/extra beds (free)",
                            "Room service (limited hours)",
                            "Satellite TV service",
                            "Se proporcionan sábanas",
                            "Soundproofed rooms",
                            "Toallas",
                            "Wardrobe or closet",
                            "Wheelchair accessible"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996317,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/FyGDKJ-kJLkzpvZt0HU-j9zFGRc=/720x480/02/17/37/02173796.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/FyGDKJ-kJLkzpvZt0HU-j9zFGRc=/720x480/02/17/37/02173796.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Asiento de inodoro elevado",
                            "Balcón",
                            "Bañera o ducha",
                            "Bañera profunda",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Habitación en planta ejecutiva",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996318,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/sHpNF3RLVLjOuqICoU4PcAbAczM=/720x480/02/17/37/02173794.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/sHpNF3RLVLjOuqICoU4PcAbAczM=/720x480/02/17/37/02173794.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Asiento de inodoro elevado",
                            "Bañera o ducha",
                            "Bañera profunda",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Patio",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de champán",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3996319,
                        "kidsFreeTo": 0,
                        "name": "Suite junior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UYtXg0WonUFeWZTXohOHOTV1-lM=/720x480/02/17/37/02173795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UYtXg0WonUFeWZTXohOHOTV1-lM=/720x480/02/17/37/02173795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198517,
                        "kidsFreeTo": 5,
                        "name": "Estándar - no reembolsable",
                        "isActive": true,
                        "view": "Calle o Jardín o Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198518,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198519,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la laguna - no reembolsable",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198520,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7752636,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7752638,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7752639,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7752640,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Asiento de inodoro elevado",
                            "Bañera o ducha",
                            "Bañera profunda",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Patio",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7753442,
                        "kidsFreeTo": 0,
                        "name": "Swim-up Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7878907,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7878908,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe-Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7878909,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877240,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877242,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877248,
                        "kidsFreeTo": 0,
                        "name": "Triple Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877268,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877294,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877305,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877315,
                        "kidsFreeTo": 0,
                        "name": "Room With Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877337,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877349,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12877364,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16043237,
                        "kidsFreeTo": 12,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078404,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078413,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078423,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078431,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078439,
                        "kidsFreeTo": 0,
                        "name": "Family Room Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078447,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078450,
                        "kidsFreeTo": 0,
                        "name": "Family Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078453,
                        "kidsFreeTo": 0,
                        "name": "Double Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078454,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078457,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078459,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078460,
                        "kidsFreeTo": 0,
                        "name": "Family Room With Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078461,
                        "kidsFreeTo": 0,
                        "name": "Family Room Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078462,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078465,
                        "kidsFreeTo": 0,
                        "name": "Room Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078466,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078467,
                        "kidsFreeTo": 0,
                        "name": "Suite With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078468,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078470,
                        "kidsFreeTo": 0,
                        "name": "Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078471,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078474,
                        "kidsFreeTo": 0,
                        "name": "Double Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078476,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078479,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078482,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078484,
                        "kidsFreeTo": 0,
                        "name": "Family Room Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078486,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078488,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078491,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078496,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Bay View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078499,
                        "kidsFreeTo": 0,
                        "name": "Double Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078503,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078505,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078509,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078513,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078514,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078515,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078518,
                        "kidsFreeTo": 0,
                        "name": "Double Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078522,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078525,
                        "kidsFreeTo": 0,
                        "name": "Double Premier",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078529,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078532,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078535,
                        "kidsFreeTo": 0,
                        "name": "Room Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078539,
                        "kidsFreeTo": 0,
                        "name": "Room Comfort",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078543,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078549,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078552,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use With Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078555,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory With Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078557,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078559,
                        "kidsFreeTo": 0,
                        "name": "Room Bay View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078560,
                        "kidsFreeTo": 0,
                        "name": "Single Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078562,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078564,
                        "kidsFreeTo": 0,
                        "name": "Room Harbour View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078565,
                        "kidsFreeTo": 0,
                        "name": "Double Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078566,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078567,
                        "kidsFreeTo": 0,
                        "name": "Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078568,
                        "kidsFreeTo": 0,
                        "name": "Double Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078571,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078573,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078575,
                        "kidsFreeTo": 0,
                        "name": "Room Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078577,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078581,
                        "kidsFreeTo": 0,
                        "name": "Double Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078582,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078586,
                        "kidsFreeTo": 0,
                        "name": "Double With Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078591,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078596,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078601,
                        "kidsFreeTo": 0,
                        "name": "Suite Harbour View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078606,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078612,
                        "kidsFreeTo": 0,
                        "name": "Double Premier Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078619,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078632,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078637,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078641,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078646,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078651,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078655,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078658,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078661,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078672,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078676,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078681,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078684,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078685,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078687,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078690,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078691,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078692,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Lake View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078694,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078696,
                        "kidsFreeTo": 0,
                        "name": "Family Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078699,
                        "kidsFreeTo": 0,
                        "name": "Family Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16078702,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176318,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176319,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Side Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176320,
                        "kidsFreeTo": 0,
                        "name": "Villa Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176321,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176322,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176323,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176324,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176325,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176327,
                        "kidsFreeTo": 0,
                        "name": "Double Capacity 5",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176328,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176329,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Side Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176330,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176331,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176334,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176336,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176339,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176341,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16176343,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16405872,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16405873,
                        "kidsFreeTo": 0,
                        "name": "Family Room Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16405875,
                        "kidsFreeTo": 0,
                        "name": "Room Executive Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16420982,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16712279,
                        "kidsFreeTo": 0,
                        "name": "Room Lake View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723477,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723478,
                        "kidsFreeTo": 0,
                        "name": "Double Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723479,
                        "kidsFreeTo": 0,
                        "name": "Double Bay View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060796,
                        "kidsFreeTo": 5,
                        "name": "Estándar Al",
                        "isActive": true,
                        "view": "Calle o Jardín o Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060797,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar Al",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060798,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la laguna Al",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060799,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar Al",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060800,
                        "kidsFreeTo": 5,
                        "name": "Familiar Al",
                        "isActive": true,
                        "view": "Calle o Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060801,
                        "kidsFreeTo": 5,
                        "name": "Estándar EP",
                        "isActive": true,
                        "view": "Calle o Jardín o Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060802,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar EP",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060803,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la laguna EP",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060804,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar EP",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060805,
                        "kidsFreeTo": 5,
                        "name": "Familiar EP",
                        "isActive": true,
                        "view": "Calle o Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060806,
                        "kidsFreeTo": 5,
                        "name": "Estándar BB",
                        "isActive": true,
                        "view": "Calle o Jardín o Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/AlA9SaDKV6FoeE7Mqpm1lumWBcM=/720x480/02/93/02/02930266.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060807,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar BB",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dpyhmcRn9HhzAl9ct3pDh1LnbYk=/720x480/02/93/02/02930265.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060808,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la laguna BB",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_vlP1ways0-NSQnw8bEWOhHsuMQ=/720x480/02/93/02/02930263.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060809,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar BB",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3doKxf5gABBvowFTafrBIRBMlsY=/720x480/02/93/02/02930262.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17060810,
                        "kidsFreeTo": 5,
                        "name": "Familiar BB",
                        "isActive": true,
                        "view": "Calle o Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9BelcOJJrdqunqbrnxvYXg3tcYc=/720x480/02/93/02/02930268.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227686,
                        "kidsFreeTo": 0,
                        "name": "House Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227687,
                        "kidsFreeTo": 0,
                        "name": "Room Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227688,
                        "kidsFreeTo": 0,
                        "name": "Room Superior With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227689,
                        "kidsFreeTo": 0,
                        "name": "Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227692,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227693,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227695,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Queen Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227699,
                        "kidsFreeTo": 0,
                        "name": "Room Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227701,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227703,
                        "kidsFreeTo": 0,
                        "name": "Family Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227705,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227707,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949988,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949991,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View Capacity 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949992,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949995,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949996,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949997,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303301,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303302,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375547,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375571,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375595,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375619,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375646,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375674,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375705,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375738,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375770,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375801,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375834,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375865,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375899,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375933,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18375967,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376003,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376037,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376071,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376105,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376138,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376171,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376204,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376237,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376271,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376304,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376337,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376370,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376403,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376436,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376472,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376507,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376544,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376579,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376613,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376648,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376683,
                        "kidsFreeTo": 0,
                        "name": "Leisure 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376719,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376754,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376789,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376825,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376859,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376892,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376927,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376962,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18376997,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377032,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377068,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377103,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377137,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377173,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377206,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377240,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377273,
                        "kidsFreeTo": 0,
                        "name": "Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377307,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377340,
                        "kidsFreeTo": 0,
                        "name": "Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377372,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377404,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377436,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377468,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377499,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377530,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377561,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377590,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377619,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377648,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377677,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377706,
                        "kidsFreeTo": 0,
                        "name": "Double Room Duplex",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377735,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377765,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377794,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377824,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377854,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377885,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377914,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377944,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18377975,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378008,
                        "kidsFreeTo": 0,
                        "name": "Leisure Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378039,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378071,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378101,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378132,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18378163,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento sujeto a disponibilidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Máquina de hielo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de masajes",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Temascal",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.2,
                    "totalSurveys": 1057,
                    "valuesAverage": [
                        4.3,
                        4.6
                    ]
                },
                "title": "Hotel en la zona hotelera con temascal",
                "uri": "flamingo-cancun-resort",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Las propinas están incluidas. Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $72.62 MXN por habitación, por noche, a pagar directamente en el establecimiento. En el caso de hacer el pago en USD, se cobrará al tipo de cambio que se tenga en ese momento."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye todas las comidas, bebidas y botanas en cualquiera de los dos restaurantes y tres bares. Desayuno bufet de 07:00 a 11:00 hrs., comida bufet de 12:30 a 15:30 hrs. y cena bufet o a la carta de 18:30 a 23:00 hrs. Las botanas están disponibles de 10:30 a 18:30 hrs."
                    },
                    {
                        "title": "Actividades",
                        "description": "El hotel ofrece programas de actividades diarios para adultos y para niños y también algunas actividades para la noche."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Los restaurantes a la carta Frida y Andiamo requieren reservación previa. Los restaurantes de especialidades requieren código de vestir elegante casual. El bar Ekinox es solo para mayores de 18 años."
                    },
                    {
                        "title": "Parque acuático",
                        "description": "El parque acuático está abierto de 08:00 a 20:00 hrs."
                    }
                ],
                "description": "Park Royal Beach Cancún es un hotel familiar de playa en la zona hotelera, frente al centro comercial la Isla. El centro de convenciones Cancún Center está a 3 kilómetros y el centro de la ciudad a 12 kilómetros. El Aeropuerto Internacional (CUN) se encuentra a 20 kilómetros de distancia. \r\n\r\nEste hotel en Cancún dispone de 289 habitaciones. Todas tienen amenidades como aire acondicionado, baño privado con ducha, secador de pelo, televisión por cable y caja de seguridad. \r\n\r\nEl hotel todo incluido tiene cinco restaurantes, uno tipo bufet y cuatro a la carta, tres bares que ofrecen bebidas nacionales e importadas y una terraza que sirve botanas. Este hotel ofrece acceso a internet inalámbrico gratuito en sus áreas públicas. También hay dos piscinas exteriores y piscina para niños. Algunas actividades de recreación disponibles son clases de spinning, aeróbicos acuáticos, voleibol en la piscina y de playa.\r\n\r\n***Hotel 100 % libre de humo de tabaco.\r\n\r\n***Park Royal Hotels and Resorts obtuvo el Distintivo ESR ®. Park Royal Beach Cancún obtuvo la Certificación Rain Forest Alliance, el Distintivo H y el Certificado SST. \r\n\r\n***Certificación Cristal International Standards por sus estándares de calidad, seguridad e higiene.\r\n\r\n***Compromiso Global Tourism Plastics Initiative para la disminución y/o eliminación de plásticos de un solo uso.\r\n\r\n***Certificación Preferred by Nature por sus prácticas sustentables.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $76.00 MXN por habitación, por noche, a pagar directamente en el establecimiento. En el caso de hacer el pago en USD, se cobrará al tipo de cambio que se tenga en ese momento. \r\n\r\n***Pueden existir cargos determinados por el hotel que son obligatorios y deben pagarse directamente en el establecimiento al momento del registro. \r\n\r\n***Para remplazar el uso de botellas plásticas de agua, el hotel implementa dispensadores de agua purificada en las áreas comunes y coloca un contenedor de agua por persona (mayores de 12 años) en cada habitación.\r\n\r\n***Toda reservación de 5 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva. \r\n\r\n***Para registrarse en el hotel todos los huéspedes deberán presentar una identificación oficial de su país, INE o pasaporte vigente. Para los menores de edad es necesario presentar acta de nacimiento, CURP o credencial de estudiante con foto. \r\n\r\n***Park Royal Hotels and Resorts no acepta reservaciones “bloqueo” bajo el mismo nombre o bajo las mismas fechas que puedan reflejarse claramente como “bloqueo”. En caso de recibir cancelaciones de dichas reservaciones “bloqueo”, existirá la penalidad del 100% de la estancia en cualquier temporada.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/cd00c727515231f9f0aa1da16cecc3aa26f97ca42636f773ee3e349f3e0bee77_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/bdf0e74e1fc6d620135f4081169d03482d9ca08310181397e3f0282583e7f220.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/3f1dac91a33ef26ac92b54f2b01d69dd1e19ebac73d550b678792139a99279ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/56e3e195a2aad4ce5fe1e553cd750b0239080e621a80873c613c893426d7a17d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100459/11ef6d85694bb88f00951acef87d352587781e2b3e0ee89401ddc1036f5b67e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/8772e52fa503d2a00e57a700cd188d299c4740f5ac972879db996941180c839e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/f8acf3c24defefac8772e8b039ce7e496a305df39ecd8e95219a502b19548347.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/fa0cd89c4d62544e6547cccadc350d9aa33f1702b0eecc08aa093e021bbbea1e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/a1d4b245faa651c34e4f8a92683ffce83a4f01dbdb84e2b41b525b364e095fd3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/ad60aecae62b0f623f0496f53e77eae9e298bff6048f3f7f4453ab04f1026812.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/ccd3ed94e706c83cb567ca557304a2d733482d01e4ca953099035ade85f126b0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/03dd83bced767f507d6614de372cbdde260916be5b8816501ed02a45407c3b27.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/805638711893b71ea0a5cf803eef4a97cac6990e9eaf0e76c2cce28159694d2f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/4f7f59cad469e28d1d4def5a187f33c8fe7d888b20577ca8e4f9fd69bb58db36.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100459/b2772fcf9f6615e67d7cec1fd630fe6ae603cd131e5436833e4306cf20ded32e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100459/feb2eced49bbc44c0e79e10f6c7584a26b3114cffb87c0e1365ad4bc36a54b3b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100459/752230e0afa24bf470938ff9faf3081e26c5b203740d530373b31167750aa48d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100459/15258c5c0b47d783d1519cfb83f68894102220a8d1651eacca16dc034194ed6f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe ",
                        "cloudUri": "https://img.cdnpth.com/media/100459/33758adc8c878424dcb9f04ccd747830e1e08d164fb79d72164ec2e852a1025b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe ",
                        "cloudUri": "https://img.cdnpth.com/media/100459/84b5aa9e78abcd9c8c4a560b0c0a6240c2277d244d938970167d90065bc54eed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/c4aaf6aa211150ce6765d51e6b02d06d86ef2d6df618d434847c95aee6bc5f6f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/a5c166aa1b037fb05b9e1b9e3c9bc4a3e6e12a060c2342b60f5d4083658e0325.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/90fc9d9bfbb9aa8971686b59b51e46716f760a08c27c64e9f27f5603c9287cd6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/49972287a9ef575c617dea373135965f145d37c8fbf2d06ada16f6935f206aa1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/268f9bb780b748d46dea75850af19edb50c3ee2dabc45d08fd36eb03e1a0a1cf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/573375a754e7f34782e4ac89a0800179c3c2d1861e3c7e6fdb95c0b68fd79ddc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/68e1318f7de3edacc5c44f192c94fe06c3e03b05e5822ba37898a53e5ebb1917.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe ",
                        "cloudUri": "https://img.cdnpth.com/media/100459/c493b044c9f657a02691565a29e7e13e4e4eb3afe66912f7e495bedd97464c86.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/d354f9bc8689295dfa300a62105c76e760451af1df9018f290517417c25e17f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/93b87a56c40bbfa00fc91eadfc01054c2f6c62ac3868f1cf541c23b2122dcc42.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/0c6017c779a8ea030724131ac3c42533495b508b250adfa780030e1f677f13a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/baa819f211b893be6d172129267467a11a37f5bace0fb54a65249b723844cfab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/9abba7f4bd5ddfa2f1fab89a4eb4ff775fd92562fdf623879180ff268e35bfe1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/2874f4234c2d9a8d8e3a154800cb4786472b2e7f9c23dfcbd3c69ddaa8455105.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/4cc27d843351465f08111a39ffa53f206a5875089ea4a8d0f7c3e4d8c5151c4f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe ",
                        "cloudUri": "https://img.cdnpth.com/media/100459/9e3878d6f39cc3dafd2c4ad2f335c1f0d4b6e19d93b28ad06bde258805c2ea47.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/f32c58080b6f045ed5e044f6e2b32b5b645bc92077ea996321a48220596be032.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/378482aaed024d106c416680ef34930e72d378fe6dcab0c2c39c15cbeb1bc53b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/0b07e5e2522049802c013ab1982a1c9a5568c2c5d7d6d160961f3e089aa6108e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/3f850347498480aa36fc28284669993dfa965c7880ea111b3fc4dad26bd2fe00.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/2803c9236e5d02a28daef3086ebc6420f117cf017f0e73bb7da44ca40fe09d33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/9ad13209db8bc8fdd832eabeb039675a5360ef208d0529850b21784498ec6a62.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe ",
                        "cloudUri": "https://img.cdnpth.com/media/100459/2aab0bf40403d4113695a6ee0fe60022a8f4a5b4a750f1b68b4cd4053ae34b6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/4f2e2712b6c81604d2dd9eba24ef9bcab935a630e0c61da8b0c4907db3a38554.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100459/a6ca395fa5a798d8f0b8219b1798b055ae85f15d958258c698b3751baed87304.png"
                    }
                ],
                "hotelID": 100459,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.111225847576964",
                    "longitude": "-86.76072835922241",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcan km 12.5 , Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Park Royal Beach Cancun",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Veranda",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Pescador",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Frida",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Adiamo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Munchies",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Duna Beach Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Coco Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Ekinox Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198604,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198605,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198607,
                        "kidsFreeTo": 0,
                        "name": "Room Prestige",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198608,
                        "kidsFreeTo": 0,
                        "name": "Suite Three Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198610,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198611,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198613,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198614,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198616,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198617,
                        "kidsFreeTo": 0,
                        "name": "Family Room Prestige",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198619,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198620,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198621,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198623,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198624,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198625,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198627,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198628,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198629,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198631,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198635,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198638,
                        "kidsFreeTo": 0,
                        "name": "Room Club Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198639,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198641,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198643,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198644,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198645,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198647,
                        "kidsFreeTo": 0,
                        "name": "Suite Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198648,
                        "kidsFreeTo": 0,
                        "name": "Family Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198650,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198653,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198654,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198656,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198657,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198658,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198659,
                        "kidsFreeTo": 0,
                        "name": "Room Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198660,
                        "kidsFreeTo": 0,
                        "name": "Studio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198661,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198662,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198663,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198664,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198665,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198666,
                        "kidsFreeTo": 0,
                        "name": "Suite With Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198667,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198668,
                        "kidsFreeTo": 0,
                        "name": "Suite With Terrace",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198669,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198670,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198671,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198672,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198673,
                        "kidsFreeTo": 0,
                        "name": "Suite With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198674,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198675,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198676,
                        "kidsFreeTo": 0,
                        "name": "Suite Three Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198677,
                        "kidsFreeTo": 0,
                        "name": "Suite Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198678,
                        "kidsFreeTo": 0,
                        "name": "Bungalow Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198679,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Bay View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198680,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198681,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198682,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198683,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198684,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198685,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198687,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198688,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198689,
                        "kidsFreeTo": 0,
                        "name": "Suite Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198690,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198691,
                        "kidsFreeTo": 0,
                        "name": "Room Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456934,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456958,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456982,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457005,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457028,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457051,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457076,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457099,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457121,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457143,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457166,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457190,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457214,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457238,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457262,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457285,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457308,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457333,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457357,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457381,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457403,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457427,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457448,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457470,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457492,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457514,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457538,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457562,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457587,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457612,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457637,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457663,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457689,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457716,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457743,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457768,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457794,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457820,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457845,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457870,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457894,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457918,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457941,
                        "kidsFreeTo": 0,
                        "name": "4 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457964,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18457991,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458014,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458038,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458062,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458085,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458109,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458135,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458160,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458186,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458210,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458235,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458260,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458286,
                        "kidsFreeTo": 0,
                        "name": "Without Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458312,
                        "kidsFreeTo": 0,
                        "name": "Presidential Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458338,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458364,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458392,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18458420,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504564,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504587,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504609,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504631,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504652,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504675,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504697,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504719,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504738,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504759,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504783,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504806,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504828,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504851,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504874,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504898,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504922,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504946,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504970,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504993,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505016,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Llave electrónica",
                            "Minibar",
                            "Rociadores",
                            "Teléfono",
                            "Teléfono de marcado directo",
                            "TV LED de 40 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000578,
                        "kidsFreeTo": 6,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Comedor",
                            "Detectores de humo",
                            "Jacuzzi",
                            "Llave electrónica",
                            "Minibar",
                            "Rociadores",
                            "Teléfono de marcado directo",
                            "TV LED de 40 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 Sofá cama matrimonial",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000580,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar con terraza",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PbeDmGGVslUsc4m7ch9TMS20ycc=/720x480/04/46/01/04460157.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PbeDmGGVslUsc4m7ch9TMS20ycc=/720x480/04/46/01/04460157.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Llave electrónica",
                            "Minibar",
                            "Rociadores",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1456502,
                        "kidsFreeTo": 6,
                        "name": "De lujo - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Comedor",
                            "Detectores de humo",
                            "Jacuzzi",
                            "Llave electrónica",
                            "Minibar",
                            "Rociadores",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 Sofá cama matrimonial",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1456503,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar con terraza - no reembolsable",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PbeDmGGVslUsc4m7ch9TMS20ycc=/720x480/04/46/01/04460157.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PbeDmGGVslUsc4m7ch9TMS20ycc=/720x480/04/46/01/04460157.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Acceso a internet",
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Minibar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 Sofá cama matrimonial",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1456504,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KNbJ0WzvOguFxwIv-O0J3QMo6PM=/720x480/04/46/01/04460158.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KNbJ0WzvOguFxwIv-O0J3QMo6PM=/720x480/04/46/01/04460158.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño privado",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Cargadores o adaptadores eléctricos",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Sofá cama",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952642,
                        "kidsFreeTo": 0,
                        "name": "Family Suite with Terrace",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952643,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968506,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Acceso a internet",
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Minibar",
                            "Secadora de cabello",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 Sofá cama matrimonial",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6231180,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KNbJ0WzvOguFxwIv-O0J3QMo6PM=/720x480/04/46/01/04460158.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KNbJ0WzvOguFxwIv-O0J3QMo6PM=/720x480/04/46/01/04460158.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Llave electrónica",
                            "Minibar",
                            "Rociadores",
                            "Teléfono",
                            "Teléfono de marcado directo",
                            "TV LED de 40 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6928365,
                        "kidsFreeTo": 6,
                        "name": "Super saver",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/G7KhIFZXF5nK5IUhmXumnrmAWaI=/720x480/04/46/01/04460154.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Cargadores o adaptadores eléctricos",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Sofá cama",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6994146,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Living room",
                            "Mini fridge",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Telephone in the bathroom",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12401299,
                        "kidsFreeTo": 0,
                        "name": "Double Prestige",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Telephone in the bathroom",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198632,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198636,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Cable TV",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198651,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Living room",
                            "Mini fridge",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Telephone in the bathroom",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198686,
                        "kidsFreeTo": 0,
                        "name": "Suite With Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Telephone in the bathroom",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16198692,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454627,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454646,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454665,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454684,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454704,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454724,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454743,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454762,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454783,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454804,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454825,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454848,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454870,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454892,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454914,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454937,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454959,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18454983,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455007,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455030,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455052,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455073,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455094,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455115,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455137,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455159,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455181,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455203,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455227,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455253,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455278,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455304,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455330,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455355,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455380,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455405,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455431,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455454,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455478,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455503,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455525,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455549,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455572,
                        "kidsFreeTo": 0,
                        "name": "4 Beds",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455595,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455618,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455642,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455666,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455689,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455713,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455736,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455759,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455782,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455804,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455826,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455848,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455870,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455892,
                        "kidsFreeTo": 0,
                        "name": "Without Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455913,
                        "kidsFreeTo": 0,
                        "name": "Presidential Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455934,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455955,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Villa",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455977,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18455997,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456018,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456038,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456058,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456078,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456098,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456119,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456141,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456162,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456183,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456204,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456225,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456245,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456266,
                        "kidsFreeTo": 0,
                        "name": "Prestige Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456287,
                        "kidsFreeTo": 0,
                        "name": "Royal",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456308,
                        "kidsFreeTo": 0,
                        "name": "Double Room Casal",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456329,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456351,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456377,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456402,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456430,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456457,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456484,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456511,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456537,
                        "kidsFreeTo": 0,
                        "name": "Villa",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456565,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456593,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456620,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456646,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456672,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456699,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456724,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456750,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456776,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456802,
                        "kidsFreeTo": 0,
                        "name": "Prestige",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456828,
                        "kidsFreeTo": 0,
                        "name": "Ambassador Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456853,
                        "kidsFreeTo": 0,
                        "name": "Ambassador Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456878,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18456902,
                        "kidsFreeTo": 0,
                        "name": "Premium Club",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Aeróbicos acuáticos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Recepción 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spinning",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.6,
                    "totalSurveys": 913,
                    "valuesAverage": [
                        4.5,
                        4.4,
                        4.2
                    ]
                },
                "title": "Hotel familiar todo incluido frente a la playa",
                "uri": "park-royal-beach-cancun",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. También comprende minibar reabastecido diariamente y servicio a la habitación de 07:00 a 23:00 hrs."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen gimnasio, cancha de usos múltiples y para los menores mini golf y tirolesa."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños, supervisado por adultos."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El hotel aplica un cargo por servicio de alimentos a la habitación de $10.00 USD."
                    }
                ],
                "description": "Seadust Cancún Family Resort se sitúa en las envidiables playas de fina arena blanca de la Zona Hotelera de Cancún, gozando de impresionantes vistas al característico mar color turquesa y a la laguna Nichupté, creando la sensación de estar navegando en un crucero completamente rodeado por aguas cristalinas. Este resort todo incluido, envuelto por las bellezas del Caribe mexicano, invita a saborear la cocina y las bebidas en sus 19 centros de consumo, mientras los niños disfrutan de una gran cantidad de actividades llenas de diversión en un club especial para bebés, niños y adolescentes.\r\n\r\nEn este hotel en Cancún hay cuatro piscinas con vista al mar para relajarse y un emocionante parque acuático, donde los niños se divertirán deslizándose por sus toboganes, así como un spa para consentirse con un masaje cerca del mar o un tratamiento en pareja. Adicionalmente, se puede elegir entre todas las actividades e instalaciones preparadas para el entretenimiento de toda la familia en las cancha de uso múltiple o en el campo de minigolf. Por si fuera poco, todas sus suites con balcón ofrecen vista frontal o parcial al Caribe mexicano o a la laguna. \r\n\r\nFrente al hotel se encuentra playa Delfines, la cual posee el distintivo Blue Flag, a 6 kilómetros se puede visitar el centro comercial La Isla Shopping Village, que alberga boutiques, tiendas de marcas reconocidas y salas de cine, y a 9 kilómetros Ventura Park. El Aeropuerto Internacional de Cancún (CUN) se sitúa a 15 kilómetros. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $72.62 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Las tarifas mostradas no aplican para bodas, grupos o eventos especiales. \r\n\r\n***Política de nombres en Reservas:\r\n*Al momento de la reserva se deberán incluir los nombres de todos los huéspedes.\r\n*No se permitirán cambios de nombre en reservas existentes (no grupales).\r\n*Esta política no se aplica a las correcciones de nombre necesarias.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/c14631a34e3f41c7bde91a9e08296ab855c1a301e496738c5058997fc574399f_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/104935912ec162320b2b93a28782d86260837e2a1f0b2dfa23b4f53afed04755.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Grand Luxe con jacuzzi - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100653/d04931e04416d119ce7a75be998a14a8a50c957c1f3f507e502db519d63af6c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/673c40ca01197ffa33f1e1edcad24a23dc02339eeea2509be33789cc090d0da0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/b85c13a60de9a8fdb5f1efea51308ceb654b18a7d4afa07f7b225a84cc0096dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/8b47eeafb6037de852cd6d25e8f40b70c15124b08c43aab33d19b7bd0a8bacbf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/12364166fe523d746da3517cae69f156908a3f711293725eec8649e76c2b078c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/d2e4277ef3a4432ffc76d046f9f3b7c68eef4aa4281e980766cd6a462780c25c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/b79f13fd59458762a77e1d6041b702e058d74b1236140a35b5610b85f5605953.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/3337ec5eb0605e442bf691b1c0d63f73ac3c9efd30c611ab2edd487f29757f3f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/c33f34700e9287d3a29f4878639c83a2181b56c8186f13355a7b259b1411b44d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/356a32f4278b14c30b59acff145b8d16acb880389b6d3db9f4357f1fddbf379a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/d23588d6c563c2990509dd45009e20a2595bc2ecb75d3a6884fd4d46f4787d76.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/311e3757e765c7bdb6eba77642db516b892ed62989d64a7fedb4d0276e4e6176.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/c0cfbb504ba1b8fcae7a8a7634c8aadf2684b78d483fb90672f11eec6c27ae2a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/9e59fed52941f4107d18949a16589893d84474b0b0818f916147f437f67b445e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/a1c1a0b3d805f52f395836511a6fd73ec783270d4e98b4df38be144117d90acf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/e6dd74a30bef33107acc46d973229169526526fc94e6cd498b59e28cf5a67400.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Familiar - 2 camas dobles ",
                        "cloudUri": "https://img.cdnpth.com/media/100653/608223816482383acc9a358f1312cfdfd838c4a2c4e444a18f4848d7fbb5f2a8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/27899c5cde260d00148e070ee59241163d1fb8548929a8e176529a8abb8890dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/dba76da5fa08aee15aa782452ddb9832f46f2cc756d583a57f60ee263eae622e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/22ae58df11c9091ba97456898dfd132c4b7ca4af3bfab6dde6eafca42671b8b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/f94cd4558811a0c05373f5fbb7f951513be3cf7a96a4ad757cd927ef67dc2f39.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/783ec05b9c900608b390355b26befc1dc8e0052f29249831acf6e9e18a9c78ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/ddafb1995ba08eddebcaa467da835b54a0bce16fa3c9601b569ef5732289baba.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/e509d35fdb05815098a9b6f032003c5e52e0e8b18632c549b80db05970505def.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/2dec22847ad348c75a2b015dacf3b4206cf072fd3c3862893b12038af49a1113.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/6ce666fa5e2f756d505b747b7afa812ace6875a523cff616a81e75fdd7423cb4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/7df4c2d86ea92de66847bb8a6a183d79ba039c20ad60136edb3d4d50f2d09a45.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/e0eae064ef8e2da24be4958ec87a5b5c6bb9c3fda648f0277d4f3dbcd683c904.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/9f88e14a9747f42c389b43160adefd301c98898ce32381afa90ebe1d42f15452.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/f9d2d0e4b6d1426cef29e687e0d96c3062c69b58b95f0a811fe1c3e69a15ec0b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/47f84b41a85325c7d04d1d4c1d5555606d33f93184777b9455b2ad706e7570d5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/2ce0ee1b46c0891a341a4adc90535aced6d3533f222bfa2470fe7cdbcf579f9c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/5305ee3719c8a36f9038d88e5e1a3a48e9d74dfb5827d2c5940ffd1b71a65c01.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/e091640bed8746e963362556dbb929ad58066371960f563515e1af5602c2d562.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/88fb88f68f5892b71c15ff131b246fee556163923b68f9098d86c470ac156f08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/a31447aff78125dfee8f0cec72c421ef06e9d47157dd2b598f957a295154df68.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/801ce4c5f4ee7fba469d62cb567f8796a8039c18d2c031726b77b72d47005ee1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/1ae62ef472d7ff793e8e12cb5ee33e0506ce4b853222ff59697ff3fed3ceefe4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/af904300b78289c240dc94f24312ab2141c2dc8d829c7c8ec4c2c867d94aae03.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/da02deb0966fbeae1f2e3325e416746b0bb50eb1a8a9ac3a3aa8caa294674e8a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/dfc48dcc524345e6d6c1eee28182ac12e07bd7c93b89b9e15b0bc3ca92ad6eb8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/68ebaf4309802132f20a1587ded8e2260f26fe248762cf2678f592aee69aef23.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100653/52eb659c5c9420804cec505368fbfcb3bfe963b8ef3bb80499a18af85959777c.png"
                    }
                ],
                "hotelID": 100653,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.068843265743197",
                    "longitude": "-86.78047831117158",
                    "postalCode": "77550",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulkán km 16.9 L 52-04, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Seadust Cancun Family Resort",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Food Gallery  (Buffet Internacional)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Florencia (Italiana)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Grillhouse (Carnes)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Samurai (Japonesa)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Maguey (Mexicana)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lighthouse (Mediterránea)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Manhattan (Americana)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Creperie (Café, Pastelería)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Waves Poolside Snack Bar",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Gelato Via Veneto",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Fun & Sports Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Club Caribe (bar solo para adultos)",
                        "type": "Bar"
                    },
                    {
                        "name": "Sea bar (solo para adultos)",
                        "type": "Bar"
                    },
                    {
                        "name": "La Barra bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Midway bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Splash bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Squalo bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Kilimanjaro bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Bongo bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10103265,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407070,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407374,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477473,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477506,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477538,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477568,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477600,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477635,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477666,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477697,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477728,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477762,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477796,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477832,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477869,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477905,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477938,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18477972,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478004,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478036,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478068,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478098,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478129,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478162,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478194,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478225,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478257,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478290,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478321,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478350,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478383,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478416,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478447,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478478,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478511,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478544,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478579,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478611,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478641,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478671,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478702,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478737,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478768,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478799,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478829,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18478859,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001411,
                        "kidsFreeTo": 3,
                        "name": "Luxury suite 2 doubles",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama nido y 1 King y 1 Litera",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001415,
                        "kidsFreeTo": 2,
                        "name": "Suite familiar king",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pXFlCM7Q81DryLnXT22f5kSyVI4=/720x480/06/03/41/06034167.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pXFlCM7Q81DryLnXT22f5kSyVI4=/720x480/06/03/41/06034167.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001417,
                        "kidsFreeTo": 2,
                        "name": "Suite de lujo king",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XmIoKIuQ1dkjtOnl9OgKNyfpxsg=/720x480/06/03/41/06034168.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XmIoKIuQ1dkjtOnl9OgKNyfpxsg=/720x480/06/03/41/06034168.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001418,
                        "kidsFreeTo": 2,
                        "name": "Suite king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BQvVq78SMkCnAorlM4QVZOiYD6I=/720x480/06/03/41/06034169.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BQvVq78SMkCnAorlM4QVZOiYD6I=/720x480/06/03/41/06034169.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con jacuzzi y área de descanso",
                            "Balcón con sillas",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1006761,
                        "kidsFreeTo": 3,
                        "name": "Sunset suite 2 doubles  - nonrefundable",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con jacuzzi y área de descanso",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4037469,
                        "kidsFreeTo": 0,
                        "name": "Ocean front suite 2 doubles - nonrefundable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4063906,
                        "kidsFreeTo": 3,
                        "name": "Luxury suite king",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4063907,
                        "kidsFreeTo": 3,
                        "name": "Luxury suite king  - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama nido y 1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4063908,
                        "kidsFreeTo": 2,
                        "name": "Suite familiar doble",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9oz_d74_HveJ3scq9Z2rqJJStm4=/720x480/06/03/41/06034166.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9oz_d74_HveJ3scq9Z2rqJJStm4=/720x480/06/03/41/06034166.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4199151,
                        "kidsFreeTo": 2,
                        "name": "Estándar suite doble",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UoGz1ZHhwouyY-T1pIoap-4f77E=/720x480/06/03/41/06034159.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UoGz1ZHhwouyY-T1pIoap-4f77E=/720x480/06/03/41/06034159.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4199152,
                        "kidsFreeTo": 2,
                        "name": "Estándar suite king",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/tfE5vC_UQ_0I7L8kE2nGYitBQbU=/720x480/06/03/41/06034160.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/tfE5vC_UQ_0I7L8kE2nGYitBQbU=/720x480/06/03/41/06034160.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4199153,
                        "kidsFreeTo": 2,
                        "name": "Premium suite doble",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oLh6tRjwpScoYuA39jDHNgY_3Uk=/720x480/06/03/41/06034162.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oLh6tRjwpScoYuA39jDHNgY_3Uk=/720x480/06/03/41/06034162.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4199154,
                        "kidsFreeTo": 2,
                        "name": "Premium suite king",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/K8o6dBGAqK0icAMHMIGgCL_XKCw=/720x480/06/03/41/06034163.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/K8o6dBGAqK0icAMHMIGgCL_XKCw=/720x480/06/03/41/06034163.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4199155,
                        "kidsFreeTo": 2,
                        "name": "Gran master suite king vista sunset",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4tOL92I87qp7D7D6LDdzK58nYqc=/720x480/06/03/41/06034161.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4tOL92I87qp7D7D6LDdzK58nYqc=/720x480/06/03/41/06034161.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4597250,
                        "kidsFreeTo": 3,
                        "name": "Family suite 2 doubles - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con sillas",
                            "Baño privado",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Jacuzzi interior",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4629559,
                        "kidsFreeTo": 3,
                        "name": "Grand Luxe suite with jacuzzi king",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con sillas",
                            "Baño privado",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Jacuzzi interior",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4629561,
                        "kidsFreeTo": 3,
                        "name": "Grand Luxe suite with jacuzzi king - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4629563,
                        "kidsFreeTo": 2,
                        "name": "Suite de lujo doble",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n5uOs1ItW66qe6aIWEBvkxeNC-g=/720x480/06/03/41/06034164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n5uOs1ItW66qe6aIWEBvkxeNC-g=/720x480/06/03/41/06034164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4629564,
                        "kidsFreeTo": 2,
                        "name": "Suite doble frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yKhEU7zayyY4BBUxXE8JAu1IgrM=/720x480/06/03/41/06034165.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yKhEU7zayyY4BBUxXE8JAu1IgrM=/720x480/06/03/41/06034165.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5984105,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031045,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6851224,
                        "kidsFreeTo": 3,
                        "name": "Family suite king - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6851255,
                        "kidsFreeTo": 3,
                        "name": "Luxury suite 2 doubles - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7613961,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con jacuzzi y área de descanso",
                            "Balcón con sillas",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7619865,
                        "kidsFreeTo": 3,
                        "name": "Sunset suite king - nonrefundable",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con jacuzzi y área de descanso",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Internet de alta velocidad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7619866,
                        "kidsFreeTo": 0,
                        "name": "Ocean front suite king - nonrefundable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con sillas",
                            "Baño privado",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Jacuzzi interior",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7686883,
                        "kidsFreeTo": 3,
                        "name": "Grand Luxe suite with jacuzzi 2 doubles",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón con sillas",
                            "Baño privado",
                            "Batas",
                            "Botella de vino",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet de alta velocidad",
                            "Jacuzzi interior",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio a la habitación las 24 horas",
                            "Teléfono",
                            "TV interactiva",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7687635,
                        "kidsFreeTo": 3,
                        "name": "Grand Luxe suite with jacuzzi 2 doubles - nonrefundable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7720367,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7720371,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8353042,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10599065,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10599074,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10599083,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10599086,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079008,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079010,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Laguna",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079013,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079017,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079019,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079022,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079031,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079035,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079037,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079042,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079045,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079047,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Con Literas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079049,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079056,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079059,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079062,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079065,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079073,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079077,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079081,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079084,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079089,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079095,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Lago",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079097,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079101,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079104,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079108,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079112,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079118,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079124,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079131,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079136,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Laguna",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079145,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079154,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079157,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079161,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079166,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079168,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079172,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079175,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079179,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079183,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079188,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079191,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079197,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079207,
                        "kidsFreeTo": 0,
                        "name": "Habitación Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079212,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079219,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079224,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079226,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079229,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079231,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079233,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16104011,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16104012,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149785,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, varias camas (Double)",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149786,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand, 1 cama de matrimonio grande (Master, Sunset View)",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Sofá cama",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149787,
                        "kidsFreeTo": 0,
                        "name": "Suite estándar, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149789,
                        "kidsFreeTo": 0,
                        "name": "Suite estándar, 2 camas dobles",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149791,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149794,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149796,
                        "kidsFreeTo": 0,
                        "name": "Suite, 1 cama de matrimonio grande, frente al mar",
                        "isActive": true,
                        "view": "Vistas a la colina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149798,
                        "kidsFreeTo": 0,
                        "name": "Suite, 2 camas dobles, frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149799,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, 2 camas dobles",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149802,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, varias camas (King)",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Filtros de té y café reutilizables",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de salas de estar",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicio de limpieza a petición",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable o satélite",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149804,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe (Double)",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16372650,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16376027,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16376028,
                        "kidsFreeTo": 0,
                        "name": "Habitación Accesible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377396,
                        "kidsFreeTo": 0,
                        "name": "Tienda Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377397,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Capacidad 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409979,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409980,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409981,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409982,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409983,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409984,
                        "kidsFreeTo": 0,
                        "name": "Suite Premier",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama nido y 1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043606,
                        "kidsFreeTo": 2,
                        "name": "Family suite double - FAMD",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9oz_d74_HveJ3scq9Z2rqJJStm4=/720x480/06/03/41/06034166.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9oz_d74_HveJ3scq9Z2rqJJStm4=/720x480/06/03/41/06034166.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama nido y 1 King y 1 Litera",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043607,
                        "kidsFreeTo": 2,
                        "name": "Family suite king - FAMK",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pXFlCM7Q81DryLnXT22f5kSyVI4=/720x480/06/03/41/06034167.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pXFlCM7Q81DryLnXT22f5kSyVI4=/720x480/06/03/41/06034167.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043608,
                        "kidsFreeTo": 2,
                        "name": "Grand master suite sunset view king - MAST",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4tOL92I87qp7D7D6LDdzK58nYqc=/720x480/06/03/41/06034161.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4tOL92I87qp7D7D6LDdzK58nYqc=/720x480/06/03/41/06034161.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043609,
                        "kidsFreeTo": 2,
                        "name": "Ocean front suite double - STFD",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yKhEU7zayyY4BBUxXE8JAu1IgrM=/720x480/06/03/41/06034165.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yKhEU7zayyY4BBUxXE8JAu1IgrM=/720x480/06/03/41/06034165.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043610,
                        "kidsFreeTo": 2,
                        "name": "Ocean front suite king - STFK",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BQvVq78SMkCnAorlM4QVZOiYD6I=/720x480/06/03/41/06034169.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BQvVq78SMkCnAorlM4QVZOiYD6I=/720x480/06/03/41/06034169.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043611,
                        "kidsFreeTo": 2,
                        "name": "Premium suite double - CLBD",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oLh6tRjwpScoYuA39jDHNgY_3Uk=/720x480/06/03/41/06034162.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oLh6tRjwpScoYuA39jDHNgY_3Uk=/720x480/06/03/41/06034162.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043612,
                        "kidsFreeTo": 2,
                        "name": "Premium suite king - CLBK",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/K8o6dBGAqK0icAMHMIGgCL_XKCw=/720x480/06/03/41/06034163.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/K8o6dBGAqK0icAMHMIGgCL_XKCw=/720x480/06/03/41/06034163.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043613,
                        "kidsFreeTo": 2,
                        "name": "Standard suite double - STDD",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UoGz1ZHhwouyY-T1pIoap-4f77E=/720x480/06/03/41/06034159.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UoGz1ZHhwouyY-T1pIoap-4f77E=/720x480/06/03/41/06034159.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043614,
                        "kidsFreeTo": 2,
                        "name": "Standard suite king - STDK",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/tfE5vC_UQ_0I7L8kE2nGYitBQbU=/720x480/06/03/41/06034160.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/tfE5vC_UQ_0I7L8kE2nGYitBQbU=/720x480/06/03/41/06034160.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043615,
                        "kidsFreeTo": 2,
                        "name": "Deluxe Suite Double - STSD",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n5uOs1ItW66qe6aIWEBvkxeNC-g=/720x480/06/03/41/06034164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n5uOs1ItW66qe6aIWEBvkxeNC-g=/720x480/06/03/41/06034164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17043616,
                        "kidsFreeTo": 2,
                        "name": "Deluxe Suite King - STSK",
                        "isActive": true,
                        "view": "Laguna o Jungla",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XmIoKIuQ1dkjtOnl9OgKNyfpxsg=/720x480/06/03/41/06034168.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XmIoKIuQ1dkjtOnl9OgKNyfpxsg=/720x480/06/03/41/06034168.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299070,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299071,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299072,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299077,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299081,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299082,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299083,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18406864,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18406900,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18406934,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18406968,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407002,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407036,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407200,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407226,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407264,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407300,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407337,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407420,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407464,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407501,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407538,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407574,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407610,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407646,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407682,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407717,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407751,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407786,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407820,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407854,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407887,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407920,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407954,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407988,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408022,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408056,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408090,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408124,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408158,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408192,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408226,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408260,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408293,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408327,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408361,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408395,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408429,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408463,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408497,
                        "kidsFreeTo": 0,
                        "name": "3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408532,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408565,
                        "kidsFreeTo": 0,
                        "name": "Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408599,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408632,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408665,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408697,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408729,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408761,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408793,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408824,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408854,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408885,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408916,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408948,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408980,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409012,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409043,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409074,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409105,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409135,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409165,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409195,
                        "kidsFreeTo": 0,
                        "name": "Villa Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409224,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409253,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409282,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409311,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409345,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409371,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409397,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409424,
                        "kidsFreeTo": 0,
                        "name": "Premium 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409451,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409478,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409504,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409531,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409556,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409581,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409608,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409636,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409661,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409686,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409712,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409739,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409766,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409794,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409822,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409850,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409878,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409906,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409934,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409961,
                        "kidsFreeTo": 0,
                        "name": "Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409987,
                        "kidsFreeTo": 0,
                        "name": "Club Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410011,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410034,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410067,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410087,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410111,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410135,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410159,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410183,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410207,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410229,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410252,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410276,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410300,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410323,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410347,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410370,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410393,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410418,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410442,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410466,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410488,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410509,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410530,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410550,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410570,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410591,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410611,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410631,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410652,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410672,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410693,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410714,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410735,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410755,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410775,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410794,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410814,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410835,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410853,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410871,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410907,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410925,
                        "kidsFreeTo": 0,
                        "name": "3 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410943,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410961,
                        "kidsFreeTo": 0,
                        "name": "Bunk Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410979,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410997,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411015,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411033,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411051,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411070,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411089,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411108,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411126,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411144,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411163,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411181,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411199,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411217,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411236,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411254,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411272,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411289,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411305,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411322,
                        "kidsFreeTo": 0,
                        "name": "Villa Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411339,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411356,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411372,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411387,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411404,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411437,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411469,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475733,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475759,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475784,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475809,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475834,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475859,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475882,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475907,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475931,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475958,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18475984,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476012,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476038,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476067,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476096,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476125,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476153,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476182,
                        "kidsFreeTo": 0,
                        "name": "Economic Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476212,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476242,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476271,
                        "kidsFreeTo": 0,
                        "name": "Corner",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476302,
                        "kidsFreeTo": 0,
                        "name": "Accessibility",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476335,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476365,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Grand Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18476394,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18883926,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351900,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351905,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351911,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351916,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351922,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19351927,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352092,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352093,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Balcón",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352094,
                        "kidsFreeTo": 0,
                        "name": "Suite Executive",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352095,
                        "kidsFreeTo": 0,
                        "name": "Suite Guest Room",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352096,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352097,
                        "kidsFreeTo": 0,
                        "name": "Suite Interior",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Number of bedrooms",
                            "Pay movies",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19352098,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "4 Piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cancha de usos múltiples",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de bebés (18 meses - 4 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de jóvenes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (5-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Fotógrafo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Golfito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet de alta velocidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Juegos interactivos para bebés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Recepción 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de masajes",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tirolesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Todo incluido",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.9,
                    "totalSurveys": 1500,
                    "valuesAverage": [
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido en playa Delfines con parque acuático",
                "uri": "seadust-cancun-family-resort",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. También incluye minibar reabastecido diariamente y servicio a la habitación las 24 horas."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Otros",
                        "description": "Incluye acceso a internet inalámbrico en todo el hotel y green fees de golf (aplican restricciones). También se incluyen clases de cocina, cocteles y baile."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como kayaks, hobie cats, waterpolo y veleros."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen tenis y voleibol de playa."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las llamadas telefónicas tienen un cargo adicional."
                    }
                ],
                "description": "Secrets Playa Mujeres Golf &amp; Spa Resort es un hotel de lujo sólo para adultos ubicado en Playa Mujeres, dentro del Campo de Golf Playa Mujeres de 18 hoyos diseñado por Greg Norman. Este hotel frente a las playas de Cancún que ofrece plan todo incluido se sitúa a 9 kilómetros de Isla Mujeres y a 11 kilómetros de la Zona Hotelera, donde está la laguna Nichupté y varios centros de entretenimiento nocturno. El Aeropuerto Internacional de Cancún (CUN) se sitúa a 27 kilómetros del hotel. \r\n\r\nEste hotel en Playa Mujeres cuenta con 424 elegantes suites con vistas al mar, a la alberca o el jardín. Todas están equipadas con balcón o terraza con mesa y sillas, tina de hidromasaje en el baño, base para iPod® y minibar. Las suites de la sección Preferred Club incluyen además servicio de concierge, entrada y salida privadas con atención personalizada, postres y licores finos, entrega de periódico diariamente en inglés o español y acceso al Club Lounge. La suite presidencial adicionalmente cuenta con acceso directo a la playa y alberca privada. La propiedad acepta perros de máximo 10 kg en las habitaciones y ofrece amenidades especiales para ellos (aplican cargos y restricciones). \r\n\r\nSecrets Playa Mujeres Golf &amp; Spa Resort tiene dos albercas, cuatro jacuzzis y la posibilidad de realizar diversas actividades en la playa como noches temáticas y fiestas, kayaks, velero, windsurf, entre otros. Además en sus instalaciones hay una cancha de tenis y un teatro, mesa de ping pong, billar y clases de cocina, baile o aeróbicos acuáticos. Cuenta con salones de eventos con capacidad para 560 personas. Para los momentos de relajación ofrece un completo spa con área de hidroterapia y tratamientos corporales y de belleza. Como parte de los servicios de este hotel está Unlimited Connectivity, una aplicación para teléfonos celulares inteligentes que permite al huésped tener acceso a internet inalámbrico sin costo, hacer reservaciones en el spa, revisar menús de los restaurantes y servicios del hotel, entre muchos otros beneficios. Dentro de las opciones gastronómicas del Secrets Playa Mujeres Golf &amp; Spa Resort hay nueve restaurantes de distintas especialidades que no requieren reservación, así como diversos bares ubicados en el área de la playa, la alberca o en sus edificios. Otro beneficio que ofrece este hotel de playa solo para adultos es el Sip, Savor &amp; See, que incluye cenas en los restaurantes de los hoteles Secrets, Dreams y Now de la Riviera Maya y Cancún. \r\n\r\n***Secrets Playa Mujeres Golf &amp; Spa Resort - Solo Adultos ha sido catalogado por las asociaciones AAA de Estados Unidos con Cuatro Diamantes. \r\n\r\n***Certificación de sustentabilidad ambiental Rainforest Alliance. \r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva. \r\n\r\n***El hotel acepta perros de hasta 10 kilos (aplican restricciones y sujetas a tipo de habitación, contacte al hotel para mayor información). \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $67.42 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\nAntes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/2ff7d3266469db17c788df60cbad28fcfa29cb7276f36073b06363c02d7c92ce_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/8a1117e389118df42f7d81bf661814adc7470ac9711ee8ae0ba5038317ab6031.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/13baa59125a4d94a1d6d9f3280b4f5ea1905f0f3500c89aa559b4cf5ad8c7219.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/c6737c6d7eb9780918a214c5c7ac7cfcb61adcc02dbf0b9d529fcb1b46a263a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/45999f2aeaaf1ba1ac600525ed8d53d2b28aada2fcebe4a7a7a19b65aa411cfe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/4881af3004fa67b66d840db9ec68309a9e7390bbc0e0677f9708ecf430fbbb13.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/113522f71030b69dbb80b6c7ad6f54fe300552e8c964b89ff733c27aeee57bc4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/18c48f9f5dc76d0bbcee6f6746d13a745b53fe77121320dcb1d99de712ee166b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/a2cd0987a6a741bab38ae481a88160ba23ed5583e989dac56ecbb079a53543e0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/c53563d2043f4158d18e53e8b184145867ff303b1f22a72b1df13fb0922f139b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/289031b04f46e5ca41377d00b1202769f4e7ee0cc2baab5f198d1894af2bd9c4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/cc857a603b153f3adce30a39570d3a3e7b9246572ce1c56b20c26f6e7ec79b94.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/94bc45575cbdf5f9e014b91288a7cec8b8119cd6973d5a8141c9320fa4fdb83b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/f76def96332459bbb246a9ed8b0b77eb99fd2a94a4093a5939de7b3831f02969.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/83dfce73e1f5681084aa89bff1f0428b64c96e063c2d820e2bf7098bbc682c5a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/7b2b3652ed2eb5348baeea47563812c0ed902c3adb892c70dd1135ead9c9fb5d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/df969c5a3326166f91b15c500c3a4bb8c0639fd108e6f4580d25540f78d15d2b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/003a06e2a05b85d176e0127aebcf20d6f826fc815e5f46d81d3bbfb8a8ca1cd7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/793599e95ad833ade627ac088c228016d6147d5e17db5f8f32d6068dcc710d04.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/056844ae96b826112143a964e02ad9a8779aab446248650ba9bfb39f4ca8b745.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/6a6b29a94a30557a765d5146bb93f8f7289bdce5ce3007a23ef2b831d17f494a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/cc165cbc44abaf07b1f1b0dff359fe1281ccc0f076cf3b4725b451786776b688.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/08dd1c6b2f0ff26ab92eb042a45f8ccb0ca7442c7f337d6aaae6b50fadcf0b09.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/b5402218bacd9d79125d1a8360ca1743d40e5ee07ad084bf37681a29fe53d465.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/c12d5af6e382dda05369ab08169100cf96e0098c299871faae81f4f197e26d98.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/3cba7fb4258cbee09e2bb7634cdd467b5f4ffe3bca2fd909f5d944f276dcd7fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/617038f5dd189d101b3bc16e1bbbf02e233b1e9f0b6bbb29d74bbfbab0cab90e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/9e3c40f38ae81c39ffc7b58f09f02d9b2bfd231d83fc08b3f02680e4392cbb8d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/952d2b3172acfa852bfeac6788ee52f52464f5d8a49578fff2aec1e4fc859372.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/b4701f96fae611cdf74a9460a25f65d1ac8b028eee199ea096fa93d72548f89a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/0bb3d0729f5cfbb184638657afb8489754bf44bb04e4124d84244b7949712862.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/629f47253f4a752f9e87ba17a64271eaa6be29c1567aa750acd129b9c051680e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/11ae7f06521e41f05b035927f53735a7d47c493653071097239610b08dc8714a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/7b476e7a2cc0b1f0a708e6fe81ff3117744151c8177361f32ffcbbe198947b6d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/ad41b45ca7a38ee049fefae4b71e674a02bbec1a26bb99c3f63dc24295ad0bc9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/9d0d24346b2e33da240c79552c7af85f663a98f22f2e466cde45241f22378eb4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/351d7e6e27fefde4148cf4b6e1e2c3426a3bce9b7cd2bef2430bb175e98b5f43.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/7c55df2e2424efb60e2fc8908cc45ef70dd6a13d1eb9734f57257fd414961875.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/c2be35cc14a0d1005302180d9726a3e4cb56ef4f6bbadca37cc63fb56765e9b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/46ec07b1734156af132582897134d5f4c60921ab4556974e79382221de9325f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/03d783e5f6cb63504ce678180381ecb105b761cfe3e161794d1fc1c7a262bb25.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/0df537024a5d71d13d4a4648784f5c7bdec4b837356c20ac79c112564d4ec177.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/a336479f342b40ee667262ad591f67a5daf23e73be19b2f14503ecba0a102c95.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/e24d8eeb1b5d86e534d5df6fa6ce77e547c1dc1f6e63c8b3b32fc6bec7cea215.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/209082/70e1fe61fb08d348946a1a1763ec5a68a1ad20a55967caa42a3b729dc7f59266.png"
                    }
                ],
                "hotelID": 209082,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.232662233521282",
                    "longitude": "-86.80383145809174",
                    "postalCode": "77400",
                    "state": "Quintana Roo",
                    "street": "Lote 1 M1 SM3",
                    "countryCode": "MX"
                },
                "name": "Secrets Playa Mujeres Golf & Resort - Solo Adultos",
                "placeContainers": [
                    {
                        "id": 647435,
                        "uri": "isla-mujeres",
                        "displayText": "Isla Mujeres, Quintana Roo, México.",
                        "type": 6
                    },
                    {
                        "id": 89585,
                        "uri": "playa-mujeres-quintana-roo-mexico",
                        "displayText": "Playa Mujeres, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 69475,
                        "uri": "punta-sam-quintana-roo-mexico",
                        "displayText": "Punta Sam, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 398659,
                        "uri": "isj-isla-mujeres-quintana-roo-mexico-aeropuerto-isla-mujeres",
                        "displayText": "ISJ Isla Mujeres, Quintana Roo, México - Aeropuerto Isla Mujeres",
                        "type": 11
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Market Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Patio",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Himitsu",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Seaside Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Oceana",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Portofino",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bordeaux",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Barefoot Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Coco Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Rendezvous",
                        "type": "Bar"
                    },
                    {
                        "name": "Manatees",
                        "type": "Bar"
                    },
                    {
                        "name": "Barracuda",
                        "type": "Bar"
                    },
                    {
                        "name": "Desires",
                        "type": "Bar"
                    },
                    {
                        "name": "Sugar Reef",
                        "type": "Bar"
                    },
                    {
                        "name": "Showtime",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9527706,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9527707,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9527708,
                        "kidsFreeTo": 0,
                        "name": "Double room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563058,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662807,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662817,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662827,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662838,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662848,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662859,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662870,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662882,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662892,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662902,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662912,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662921,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662930,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662939,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662948,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662956,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662964,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662974,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662983,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662992,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663002,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663011,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663021,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663031,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663043,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663056,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663069,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663082,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663095,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663108,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663123,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663137,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663152,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663167,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663182,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663197,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663212,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663228,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663246,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663264,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663281,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663298,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663315,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663332,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663349,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663366,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663383,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663401,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663419,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663437,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663456,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663474,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18663490,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4201494,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitación insonorizada",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4201495,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4201496,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4201497,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Con Piscina Privada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/YpKKc-eaTpKJklse7e7l7i7YFNc=/720x480/02/96/47/02964757.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/YpKKc-eaTpKJklse7e7l7i7YFNc=/720x480/02/96/47/02964757.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4201498,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitación insonorizada",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971840,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitación insonorizada",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971841,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CwVx-05wP0-VLUSLgQMdwCY8o60=/720x480/04/97/50/04975075.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CwVx-05wP0-VLUSLgQMdwCY8o60=/720x480/04/97/50/04975075.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971842,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CwVx-05wP0-VLUSLgQMdwCY8o60=/720x480/04/97/50/04975075.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CwVx-05wP0-VLUSLgQMdwCY8o60=/720x480/04/97/50/04975075.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971843,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971845,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971846,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Dos Camas Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971848,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971850,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7165628,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7167461,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7964253,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335053,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335062,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335065,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335067,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335069,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335079,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335084,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335085,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335088,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335090,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335091,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335094,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335097,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335098,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitación insonorizada",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Piscina privada",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335100,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335101,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335102,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335104,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335106,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335107,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335108,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335109,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335110,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335111,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335112,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335114,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8335117,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8354166,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8354193,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8383106,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8383107,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437961,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437965,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437972,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437975,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437977,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437986,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437991,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente A La Playa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8437992,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438000,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438005,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438008,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438009,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438012,
                        "kidsFreeTo": 0,
                        "name": "Villa Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438014,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438023,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438032,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438037,
                        "kidsFreeTo": 0,
                        "name": "Villa Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187216,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187245,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187248,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187251,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187413,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187415,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Piscina Privada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187416,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187419,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Piscina Privada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187422,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187425,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187427,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187436,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187438,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187447,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Piscina Privada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187457,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197359,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197362,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197364,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197366,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768862,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768881,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768893,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768905,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768920,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768935,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768948,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768960,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10768993,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11625032,
                        "kidsFreeTo": 0,
                        "name": "Villa Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11625033,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075731,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075737,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075745,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075752,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075754,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075755,
                        "kidsFreeTo": 0,
                        "name": "Habitación Presidencial",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075761,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075767,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075777,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16106918,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Piscina Privada Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16106920,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409878,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación apta para mascotas",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782708,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View - King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782709,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean View Swim Out - Double",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782710,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean View Swim Out - King",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitación separada",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Piscina privada",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782711,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Ocean Front Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782712,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Swim Out - Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782713,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Swim Out - King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782714,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean Front - King Bed",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Bidet",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782715,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782716,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite - King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782717,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View - Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782718,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Ocean View - King",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Bañera de hidromasaje privada",
                            "Bañera de hidromasaje privada (exterior)",
                            "Baño privado",
                            "Bidet",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitación separada",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782719,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782720,
                        "kidsFreeTo": 0,
                        "name": "Deal of the Day",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782721,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite - Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782722,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View - King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Bañera de hidromasaje privada",
                            "Bañera de hidromasaje privada (exterior)",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitación separada",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782723,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tableta",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782724,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean Front - Double Beds",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón o patio amueblado",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Habitación apta para mascotas",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782725,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View - Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Báscula",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213035,
                        "kidsFreeTo": 0,
                        "name": "Oferta del día",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Báscula",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213038,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Báscula",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213039,
                        "kidsFreeTo": 0,
                        "name": "Junior suite doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oAyBY1OE2Pm4X5hISuvrwH2tzwU=/720x480/04/97/50/04975073.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oAyBY1OE2Pm4X5hISuvrwH2tzwU=/720x480/04/97/50/04975073.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Báscula",
                            "Batas",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Teléfono en el baño"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213122,
                        "kidsFreeTo": 0,
                        "name": "Junior suite doble vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oAyBY1OE2Pm4X5hISuvrwH2tzwU=/720x480/04/97/50/04975073.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oAyBY1OE2Pm4X5hISuvrwH2tzwU=/720x480/04/97/50/04975073.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Báscula",
                            "Batas",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Teléfono en el baño"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213124,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213125,
                        "kidsFreeTo": 0,
                        "name": "Junior suite doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/tCSKABzNZeminuiz9wgf0168aXQ=/720x480/11/72/72/11727280.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/tCSKABzNZeminuiz9wgf0168aXQ=/720x480/11/72/72/11727280.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213126,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vbNUoeYDqp6aAmqXnQgBHagznow=/720x480/02/98/20/02982045.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vbNUoeYDqp6aAmqXnQgBHagznow=/720x480/02/98/20/02982045.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Báscula",
                            "Batas",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Teléfono en el baño"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213146,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9VlM46tVMNhTG6D-_iXFDT_nI5o=/720x480/04/97/50/04975074.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213149,
                        "kidsFreeTo": 0,
                        "name": "Junior suite doble swim out",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KUyjfNpI0dl0NnmUQkwUKmbJhiM=/720x480/11/72/75/11727590.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KUyjfNpI0dl0NnmUQkwUKmbJhiM=/720x480/11/72/75/11727590.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213150,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king swim out",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jz9OpqSi1hyx-LI21rmr1-NaBeM=/720x480/11/72/70/11727047.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con tina de hidromasaje y regadera ",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213157,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club junior suite doble frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6m06bKf-609IDhJucMtYOlIWMuU=/720x480/03/06/75/03067528.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6m06bKf-609IDhJucMtYOlIWMuU=/720x480/03/06/75/03067528.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con tina de hidromasaje y regadera ",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213158,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club junior suite king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/aMLyRpdcMXA-tqIwujCfKc-0K80=/720x480/02/96/47/02964754.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con tina de hidromasaje y regadera ",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213159,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club junior suite vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vbNUoeYDqp6aAmqXnQgBHagznow=/720x480/02/98/20/02982045.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vbNUoeYDqp6aAmqXnQgBHagznow=/720x480/02/98/20/02982045.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso gratis al spa",
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213170,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club junior suite doble swim out vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6m06bKf-609IDhJucMtYOlIWMuU=/720x480/03/06/75/03067528.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6m06bKf-609IDhJucMtYOlIWMuU=/720x480/03/06/75/03067528.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso gratis al spa",
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213171,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club junior suite king swim out vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3RMKntbded1ua4k0P45W9MOcSWc=/720x480/03/06/75/03067531.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3RMKntbded1ua4k0P45W9MOcSWc=/720x480/03/06/75/03067531.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 TVs",
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213172,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club master suite frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/QPseKQ28lboySrk9aZece4W_6Q4=/720x480/02/98/47/02984723.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/QPseKQ28lboySrk9aZece4W_6Q4=/720x480/02/98/47/02984723.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 TVs",
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Alberca privada",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213173,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club master suite con piscina privada frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BmEFZI_0oOpUg2uJ3ihCIwq_RJc=/720x480/02/98/47/02984711.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BmEFZI_0oOpUg2uJ3ihCIwq_RJc=/720x480/02/98/47/02984711.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 TVs",
                            "20% de descuento en tratamientos del spa",
                            "Acceso al salón ejecutivo",
                            "Acceso gratis al spa",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza con sillas",
                            "Baño privado con tina de hidromasaje y regadera ",
                            "Base para iPod",
                            "Batas",
                            "Cafetera Nespresso®",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Cortinas oscuras",
                            "Desayuno completo",
                            "Doble lavabo",
                            "Entrada y salida privadas",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Registro privado",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213174,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club master suite vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_cJsehpMDc43wNLjJHvhENNMBso=/720x480/02/98/47/02984710.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_cJsehpMDc43wNLjJHvhENNMBso=/720x480/02/98/47/02984710.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561307,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561333,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561360,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561388,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561414,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561440,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561467,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561492,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561518,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561543,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561565,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561588,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561610,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561633,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561656,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561680,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561702,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561724,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561747,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561769,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561792,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561815,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561837,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561859,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561881,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561903,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561925,
                        "kidsFreeTo": 0,
                        "name": "Suite With Swimming Pool",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561950,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561974,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18561998,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562023,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562046,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562068,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562090,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562112,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562135,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562156,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562177,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562197,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562220,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562240,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562261,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562281,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562303,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562325,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562345,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562365,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562385,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562404,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562423,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562442,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562461,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562479,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562498,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562517,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562536,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562554,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562572,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562590,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562610,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562629,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562647,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562665,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562683,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562701,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562719,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562737,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562754,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562772,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562787,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562801,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562817,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562833,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562848,
                        "kidsFreeTo": 0,
                        "name": "King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562862,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562876,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562890,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562904,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562918,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562932,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562944,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562957,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562969,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562981,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18562992,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563003,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563016,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563031,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563044,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563070,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563077,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563082,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563087,
                        "kidsFreeTo": 0,
                        "name": "Villa 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563092,
                        "kidsFreeTo": 0,
                        "name": "Club Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563097,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563102,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563108,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563113,
                        "kidsFreeTo": 0,
                        "name": "Club Junior Suite",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563118,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool Access",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18563344,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084130,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084132,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084133,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Piscina Privada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084137,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084140,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084143,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084144,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084145,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Piscina Dos Camas Dobles",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084146,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas Queen Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084147,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior Con Balcón",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084148,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Cama King Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084149,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Cama Doble",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084150,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Piscina Cama King Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084151,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama Queen Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084152,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084153,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084154,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084155,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Con Vistas",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084156,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "CD player ",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "DVD player",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Hydro-massage bath",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pillow menu",
                            "Radio",
                            "Safe",
                            "Satellite TV ",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Telephone in the bathroom",
                            "Terrace",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20084157,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "4 jacuzzis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Aeróbicos acuáticos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Bicicletas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de baile",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de cocina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Equipo para snorkel",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Fiestas temáticas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Todo incluido",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Velero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Windsurf",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4.3,
                    "totalSurveys": 879,
                    "valuesAverage": [
                        4.5,
                        4.7,
                        4.6
                    ]
                },
                "title": "Hotel de lujo todo incluido solo para adultos en Cancún",
                "uri": "secrets-playa-mujeres-golf-and-spa-resort-solo-adultos",
                "tags": [
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Solo adultos"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": null
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 1 y 3 años, 4 y 12 años  supervisado por adultos."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las actividades en el Centro de Tenis Rafa Nadal pueden general cargos adicionales. En Chic Cabaret & Restaurant aplica un cargo extra por servicio y se precisa pantalón largo y camisa o camiseta de mangas para los caballeros."
                    }
                ],
                "description": "Grand Palladium Costa Mujeres Resort &amp; Spa - All Inclusive es un hotel de playa todo incluido ubicado en la parte continental de Isla Mujeres, en Quintana Roo. Cuenta con club de playa, cuatro piscinas, siete restaurantes de especialidad, tres bares, cafetería, y centro de convenciones. Además, el resort es sede de un Rafa Nadal Tennis Centre que ofrece programas para que los huéspedes puedan jugar y recibir clases de tenis con instructores certificados. El complejo también posee gimnasio, capilla, spa, teatro y estacionamiento. \r\n\r\nLas 670 habitaciones en sus diferentes categorías y capacidades, disponen de aire acondicionado, caja de seguridad, sofá cama, balcón, mesa de trabajo y baño privado con ducha y bañeras de hidromasaje. También poseen televisión de pantalla plana de 50 pulgadas, internet inalámbrico y teléfono (con cargo extra). Las habitaciones de tipo Family Selection disponen además de servicios exclusivos como minibar personalizado, servicio de lavandería (2 piezas por persona), reservas preferenciales en los restaurantes del hotel y amenidades especiales para niños. \r\n\r\nA 2 kilómetros de la propiedad está el club de golf de Playa Mujeres y a 9 kilómetros se localiza la zona arqueológica de El Meco. Isla Mujeres se halla a 15 kilómetros, incluido el viaje en ferry. El centro de Cancún está a 16 kilómetros mientras que el Aeropuerto Internacional de Cancún (CUN) se sitúa a 32 kilómetros de distancia. \r\n\r\nPor disposición del municipio local, el hotel cobrará un impuesto obligatorio de $67.42 MXN por habitación, por noche, a pagar directamente en el establecimiento. Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/6a7c574673e32bfbab6cd6f64a389aa6fd9245eb284c0bb187632c8f62b58032_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/d08fd7887fc9770c23a3db6a2a920d124e724d22e296b7f82f7a50929b8e8060.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/a93ce852cd1aa4c02c77e36b497ab4756df82156279e4339e12cc004e8cfab81.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/40faadd53cac8f577bb870061ba19fb8ca162cd8dfc23686da98cf718edbea99.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/f661f2e5df6d0959fa0413c74437cd78484f8a12ff5629fe976b0843d4f1c1dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/3f807a2cba93a19dd7da98fd0853f5cbfb62a47a192fd4887f00e883620b64c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/0ec3a2a9697601fe1d78163ea9e77db398c1690d38e8d81ac1b3c5506160d33b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/9f8b92fcd38ace66ea2167e413960ef61571e82de9d0aa4bc69398c6d28c392e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/c472de1438d077462dffbc62468b2e9cd304262ea923e87fda29a773157f04d2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/83a5771b463af3c69a504e7ed62b217efa97065e05caf9f67930e5f5f4aabed5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/b77474aff2cec5cfdefe835dfd51a4f89e9844330abda1d164f35c9960f2684f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/f25a72f8bee9ffc3c2edcbcac989b9360dea4e51378e05ee9f7d0bcf17249fd7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/1404bafdceaccf8c2c2be810297e265f477ecdc588e7984e18de9f5d1f9588cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/e69ce3724f696850d4f5be6e6e4f863af985ed79a8287f79ae3bf1da006a1422.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/b5f71cc4db685d366ea8496539553ed528fc064db3a1ce702982941dfbcf250a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/19e1576aff531a1ccc60fa6fbd2d1652afb0aeaffe72269d1e92f4429aafffc4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/b7145be37fa0b3a4fe5c11fb7dc16c05231511d146cef8ed5b659207f12d7a22.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/17f3d742c32703ef5f826cac5ccf4e6e188eb1b028101cef74347c76d8b4ba43.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/15dbdf7686068492d1b5b6d4f41265291fe37141452df0a3c9f594f1162da1a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/6b4ffbb58c20ada175c30f32acde8a485ff757411dc6bfb68ec01025645401aa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/2985351555741cc5d2ad47e885ead200a29514050f1acd1b0c866b8802537fe3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/367e319ef0f6b0993aff24707ad02e4263e581586d44128eddc6b314d101a64f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/26c1999b7bf1343d555fe0b2649cb4991aeebf2cdcb397e8936bba3868fa7a24.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/81caec40a865f7a76582db61fd2f409bca241702d94ca614cc3cb59a76f26aa5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/5126f1af0da5e53b5fdefbdbf5ef40c1722862d22b787484fb25679910b541ae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/6092218cf4c15b49e33ee1aefb1f69264e017c0b26eb5d0614f45375bdad4860.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/c2d868c87a020067eae8185962bba7d379ec8c7030a36a9f5138bf4d0b4dd873.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/a434b90128ed5a200396e5052812b3e57c24fa65cea2393c5bda6ead4fba2844.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/6ee61767e28bbd2baf00d506cce3875a621fdd3f4c0cca3f5ba6870951b1ec5a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/923be42ec3767e780b8de57462c5f74a0bd8bd5f591ce766e10ddf52f897fefc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/d81f823736ea6f1a91cd7f0b8c380a490869f34dea5b25d81d3559a23d02da5d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/19d99484cd87236fe3303a15387bd58e598cd958e2497a5b00153e5348dee6d5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/39ec355e5ed9d7140de48c0233c12742de4bbb5a5fc5dccfec670f2ea6fc01d2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/474c8330ad1f4a2ed56163a9d3e56e00c2672d181941c4009b7cb3659ccc0b5e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/bbc83f4b62ea0c1045d280d8139896381775b17244e87ee8a3f6867838f8b356.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/ea6dd068cd15b2484e5ade09102fd7b9878ea5ded5c51c481dd9f3dc5af3deb0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/415d3eecb5dd715439afea78a1f20b429fc11284a524afc58d190267b4a51728.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/6d5a1add9d89f84408dfc2efbf54fc41366da1ea45ed7fcb0d4eba50b87d0ad9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/600fb5629b71735d6e3ce64cfc35e9e6f74df9f0bfaba8924b7ffd39e50567fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/be4bc580eda2ccd422a7fa3e1e3d179ff052e173e7c02810be910786df81e5a0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/4868b002644af505be86d0a194060de715bbe395ed59eaf79ba39d2821127acd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/b258c8bdff72ea1f36e7e91c6cf948852f86d1ed7f539ced615e8f29a9b97dd9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/7b4aeca1e227d6413cf68a346795dad7f39e787a0d0d7a61f033d35ee07e4721.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/288f76a3018cfa47c4a50a4738477f4f3cafa012bee2d7d858fc2c5535f1cd13.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/318762/614ebc0cc16da6d136b98aece15aae8ade42097851dab1d062c0967a88bc8875.png"
                    }
                ],
                "hotelID": 318762,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.265720297333136",
                    "longitude": "-86.81793987751007",
                    "postalCode": "77400",
                    "state": "Quintana Roo",
                    "street": "Vialidad Paseo Mujeres",
                    "countryCode": "MX"
                },
                "name": "Grand Palladium Costa Mujeres Resort & Spa - All Inclusive",
                "placeContainers": [
                    {
                        "id": 647435,
                        "uri": "isla-mujeres",
                        "displayText": "Isla Mujeres, Quintana Roo, México.",
                        "type": 6
                    },
                    {
                        "id": 89585,
                        "uri": "playa-mujeres-quintana-roo-mexico",
                        "displayText": "Playa Mujeres, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 398659,
                        "uri": "isj-isla-mujeres-quintana-roo-mexico-aeropuerto-isla-mujeres",
                        "displayText": "ISJ Isla Mujeres, Quintana Roo, México - Aeropuerto Isla Mujeres",
                        "type": 11
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Chang Thai",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Portofino",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Dorado",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sumptuori",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Boghali",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Chic Cabaret & Restaurant ($)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Adelita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Xtra Time Sports Bar",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Champagne",
                        "type": "Bar"
                    },
                    {
                        "name": "Coffee Shop",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sky Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Healthy Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Beach Club Poseidon",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355142,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8383482,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8383490,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8428654,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11494906,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11494908,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580474,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580475,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580476,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580477,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580479,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580485,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580490,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580495,
                        "kidsFreeTo": 0,
                        "name": "Triple Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580496,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580497,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580498,
                        "kidsFreeTo": 0,
                        "name": "Suite Executive",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580500,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580501,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11580504,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087193,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087194,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087196,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087198,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087199,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087200,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087280,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beach Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087281,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beach Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114012,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229630,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229631,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229632,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229633,
                        "kidsFreeTo": 0,
                        "name": "Suite Lagoon View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229634,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229635,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229636,
                        "kidsFreeTo": 0,
                        "name": "Suite With Terrace",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229637,
                        "kidsFreeTo": 0,
                        "name": "Family Room Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229638,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lagoon View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229640,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229642,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229644,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229646,
                        "kidsFreeTo": 0,
                        "name": "Suite Connecting Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229648,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229650,
                        "kidsFreeTo": 0,
                        "name": "Family Room Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229654,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229657,
                        "kidsFreeTo": 0,
                        "name": "Single Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229660,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229662,
                        "kidsFreeTo": 0,
                        "name": "Room Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229665,
                        "kidsFreeTo": 0,
                        "name": "Double Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229667,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229670,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229672,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Bay View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229674,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229676,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229678,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229680,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229682,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lagoon View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229685,
                        "kidsFreeTo": 0,
                        "name": "Family Room With Terrace",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229688,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229691,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229694,
                        "kidsFreeTo": 0,
                        "name": "Family Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229697,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229699,
                        "kidsFreeTo": 0,
                        "name": "Suite Connecting Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229702,
                        "kidsFreeTo": 0,
                        "name": "Room Loft",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229705,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229707,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229711,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229714,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17229718,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17949930,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18364634,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583568,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583585,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583601,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583617,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583634,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583652,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583668,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583688,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583710,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583727,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583743,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583759,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583774,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583793,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583812,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583832,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583851,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583868,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583887,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583907,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583925,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583940,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583959,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583977,
                        "kidsFreeTo": 0,
                        "name": "Business Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583997,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584017,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584038,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584062,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584085,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584107,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584131,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584155,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584178,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584202,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584225,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584249,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584276,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584300,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584326,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584353,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584379,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584405,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584430,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584457,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584482,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584505,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584529,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584555,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584579,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584604,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584628,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584652,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584676,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584699,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584723,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584746,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584770,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584795,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584819,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584841,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584867,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584888,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584907,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584927,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584949,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584972,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584995,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585018,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585040,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585064,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585088,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585111,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585134,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585156,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585179,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585201,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585224,
                        "kidsFreeTo": 0,
                        "name": "Suite Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585247,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585271,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585294,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585314,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585335,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585356,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585378,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585402,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585425,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585446,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585467,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585488,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585510,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585529,
                        "kidsFreeTo": 0,
                        "name": "Penthouse Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585551,
                        "kidsFreeTo": 0,
                        "name": "Executive Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585575,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585601,
                        "kidsFreeTo": 0,
                        "name": "Penthouse With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585624,
                        "kidsFreeTo": 0,
                        "name": "Family Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585650,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585677,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585701,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585723,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585747,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898904,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898905,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994209,
                        "kidsFreeTo": 17,
                        "name": "Family Selection Junior Suite Beachside Ocean View 2 adultos y 2 niños",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994214,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Ocean View 3 adultos y 1 niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994221,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View",
                        "isActive": true,
                        "view": "Mar|Panorámica",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994224,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View 3 adultos",
                        "isActive": true,
                        "view": "Mar|Panorámica",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994228,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View 2 adultos y 1 niño",
                        "isActive": true,
                        "view": "Mar|Panorámica",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994229,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994238,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Garden View 3 Adultos",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994239,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Garden View 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994240,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994241,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994244,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View 2 adultos y 2 niños",
                        "isActive": true,
                        "view": "Mar|Panorámica",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994245,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View 3 adultos y 1 niño",
                        "isActive": true,
                        "view": "Mar|Panorámica",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994254,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994255,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside 3 Adultos",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994256,
                        "kidsFreeTo": 17,
                        "name": "Family Selection Junior Suite Beachside 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994263,
                        "kidsFreeTo": 17,
                        "name": "Family Selection Junior Suite Beachside 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4994266,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5390107,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5390110,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5390113,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View Single Use",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7013719,
                        "kidsFreeTo": 2,
                        "name": "Junior suite",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "2 niveles",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza con jacuzzi",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7013720,
                        "kidsFreeTo": 2,
                        "name": "Loft suite",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/I6odPaSdW81A36PfdH-hG1wuL9w=/720x480/03/12/41/03124119.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/I6odPaSdW81A36PfdH-hG1wuL9w=/720x480/03/12/41/03124119.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Servicio de niñera en la habitación (bajo petición)",
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7013721,
                        "kidsFreeTo": 2,
                        "name": "Junior suite Family Selection",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Servicio de niñera en la habitación (bajo petición)",
                            "($)Teléfono",
                            "2 niveles",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Balcón o terraza con jacuzzi",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Servicio de lavandería ",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7013722,
                        "kidsFreeTo": 2,
                        "name": "Loft suite Family Selection",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2Q-34KrYCOlVrtvmEqiNJZqA1Pw=/720x480/03/12/40/03124016.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2Q-34KrYCOlVrtvmEqiNJZqA1Pw=/720x480/03/12/40/03124016.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977007,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977008,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977009,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977010,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside 3 Adultos",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977011,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977013,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977014,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside Ocean View 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977015,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside Ocean View 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977016,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Poolside Ocean View 3 Adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977017,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside Ocean View 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977019,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977020,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977021,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beachside 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977022,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside 3 Adultos",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977023,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beachside 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977025,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977026,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside Ocean View 2 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977027,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beachside Ocean View 2 Adultos 2 Niños",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977028,
                        "kidsFreeTo": 2,
                        "name": "Junior Suite Beachside Ocean View 3 Adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977029,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Beachside Ocean View 3 Adultos 1 Niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977030,
                        "kidsFreeTo": 0,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 1 adulto",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977031,
                        "kidsFreeTo": 0,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 2 adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977032,
                        "kidsFreeTo": 2,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 2 adultos y 1 niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977033,
                        "kidsFreeTo": 2,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 2 adultos y 2 niños",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977034,
                        "kidsFreeTo": 0,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 3 adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Doble lavabo",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977035,
                        "kidsFreeTo": 2,
                        "name": "Junior suite frente a la playa vista al mar panorámica - 3 adultos y 1 niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7982144,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355083,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355168,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355257,
                        "kidsFreeTo": 0,
                        "name": "Family Room Beach Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355271,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10164354,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10164356,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10164357,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View Single Use",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "Netflix",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Servicios de streaming",
                            "Smart TV",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "2 camas dobles o 1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10164358,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Poolside",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12488814,
                        "kidsFreeTo": 2,
                        "name": "Family Selection Junior Suite Beachside Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12488815,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside Ocean View 3 adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "Aire acondicionado",
                            "Alto estándar de limpieza",
                            "Amenidades especiales para niños",
                            "Amenidades para el baño",
                            "Área de playa privada",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Decoración especial de bañera de hidromasaje",
                            "Desayunos, comidas y cenas a la carta",
                            "Doble lavabo",
                            "Empaque y desempaque de equipaje",
                            "Espejo completo",
                            "Espejo de vanidad",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar personalizado",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Toallas de piscina",
                            "TV de pantalla plana de 50 pulgadas"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12488816,
                        "kidsFreeTo": 17,
                        "name": "Family Selection Junior Suite Beachside Ocean View 2 adultos y 1 niño",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p9CzqZjRh-KWmroYgjZ6P2p53no=/720x480/03/22/69/03226987.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087195,
                        "kidsFreeTo": 0,
                        "name": "Family Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Shower",
                            "Slippers",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087197,
                        "kidsFreeTo": 0,
                        "name": "Family Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16147223,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside Ocean View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón o patio amueblado",
                            "Bañera accesible",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Colchón de espuma viscoelástica",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 5",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 55",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Tetera eléctrica",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16147224,
                        "kidsFreeTo": 0,
                        "name": "Family Selection Junior Suite Beachside Panoramic Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581565,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581584,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581603,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581623,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581644,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581664,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581685,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581706,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581728,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581750,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581773,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581796,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581817,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581838,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581860,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581883,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581905,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581927,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581949,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581970,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18581991,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582012,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582035,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582057,
                        "kidsFreeTo": 0,
                        "name": "Business Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582079,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582104,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582127,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582150,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582172,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582194,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582216,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582237,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582258,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582280,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582300,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582319,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582338,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582357,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582376,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582395,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582415,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582434,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582453,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582474,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582494,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582514,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582532,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582552,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582570,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582589,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582607,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582627,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582646,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582664,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582682,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582700,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582719,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582737,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582756,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582775,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582793,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582812,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582832,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582853,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582873,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582894,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582915,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582934,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582952,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582970,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18582987,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583005,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583023,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583041,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583060,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583079,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583098,
                        "kidsFreeTo": 0,
                        "name": "Suite Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583116,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583134,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583153,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583173,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583192,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583211,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583230,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583249,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583271,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583292,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583313,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583333,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583352,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583372,
                        "kidsFreeTo": 0,
                        "name": "Penthouse Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583389,
                        "kidsFreeTo": 0,
                        "name": "Executive Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583412,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583430,
                        "kidsFreeTo": 0,
                        "name": "Penthouse With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583447,
                        "kidsFreeTo": 0,
                        "name": "Family Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583464,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583488,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583507,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583525,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583542,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "4 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Capilla",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de tenis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños  (1-3 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños  (4-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4.1,
                    "totalSurveys": 923,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel de playa todo incluido con 4 piscinas 7 restaurantes y 3 bares",
                "uri": "grand-palladium-costa-mujeres-resort-spa-all-inclusive",
                "tags": [
                    {
                        "name": "Alto estándar de limpieza"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. Aperitivos disponibles las 24 hrs. Las bebidas son nacionales e importadas y el minibar y dispensador de licor de la habitación es reabastecido regularmente."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como kayak, barco de pedales y snorkel. También se incluye una lección introductoria de buceo en la piscina"
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Algunos restaurantes requieren código de vestimenta para la cena."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos."
                    },
                    {
                        "title": "Otros",
                        "description": "Entrada y bebidas en la discoteca."
                    }
                ],
                "description": "Riu Dunamar es un hotel familiar de playa todo incluido las 24 horas, ubicado en Playa Mujeres, al norte de Cancún. Dispone de wifi gratis, 740 habitaciones y suites con minibar, dispensador de bebidas y balcón o terraza, cinco piscinas y una piscina para niños con toboganes. Además, se pueden realizar deportes acuáticos como kayak, bote de pedales, snorkel y una clase de buceo en la piscina en cortesía. Diariamente hay actividades tanto diurnas como nocturnas y para los pequeños, toda la diversión está en el club de niños. Asimismo, puedes disfrutar de la Riu Get Together Party, fiesta en la piscina exclusiva para adultos (viernes alternos).\r\n\r\nLa propiedad posee un spa con salón de belleza, peluquería y variedad de masajes. Cuenta con cinco restaurantes tanto a la carta como bufet que van desde comida internacional hasta italiana y asiática, seis bares, dos de ellos en las piscinas y un club nocturno. También se puede hacer uso del jacuzzi, baño de vapor y gimnasio. Las habitaciones también disponen de wifi gratis, aire acondicionado, televisión de pantalla plana con canales por cable, caja de seguridad, doble lavabo y baño privado con ducha. El Aeropuerto Internacional de Cancún (CUN) está a 36 kilómetros. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $32.57 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 3058120,
                        "description": "Riu Dunamar - All Inclusive",
                        "cloudUri": "https://img.cdnpth.com/media/VedKI1KqfMs_05BP5BVLPPnAVr0=/720x480/03/05/81/03058120.jpg"
                    },
                    {
                        "photoID": 3058121,
                        "description": "Fachada del hotel",
                        "cloudUri": "https://img.cdnpth.com/media/ke_WOlDhg3J29bT_PNvGUAu4ZrM=/720x480/03/05/81/03058121.jpg"
                    },
                    {
                        "photoID": 3058124,
                        "description": "Lobby de la propiedad",
                        "cloudUri": "https://img.cdnpth.com/media/2JoQyLEX7jaxv3Y7mn9IdbROmnA=/720x480/03/05/81/03058124.jpg"
                    },
                    {
                        "photoID": 3058137,
                        "description": "Lobby bar",
                        "cloudUri": "https://img.cdnpth.com/media/4K9xht6DDlOImgTRhYHgNioJ1Fs=/720x480/03/05/81/03058137.jpg"
                    },
                    {
                        "photoID": 3058126,
                        "description": "El complejo cuenta con varias piscinas",
                        "cloudUri": "https://img.cdnpth.com/media/xD46_jkFaZ0tfC10PREhnEregCk=/720x480/03/05/81/03058126.jpg"
                    },
                    {
                        "photoID": 3058127,
                        "description": "Piscina para niños",
                        "cloudUri": "https://img.cdnpth.com/media/mmbAEAb22aeN6u5ScIWFNNBFPyA=/720x480/03/05/81/03058127.jpg"
                    },
                    {
                        "photoID": 3058128,
                        "description": "Bar en la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/FK8Fj6fNq9XEsYOtAuOjSZifxnU=/720x480/03/05/81/03058128.jpg"
                    },
                    {
                        "photoID": 3058129,
                        "description": "Toboganes en la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/N9BdyVMMp4SH9oAU9VscQNVwwck=/720x480/03/05/81/03058129.jpg"
                    },
                    {
                        "photoID": 3058130,
                        "description": "El hotel cuenta con varios restaurantes",
                        "cloudUri": "https://img.cdnpth.com/media/PWmSMLqQacRspEmChkr6S2WfZVA=/720x480/03/05/81/03058130.jpg"
                    },
                    {
                        "photoID": 3058131,
                        "description": "Restaurante asiático",
                        "cloudUri": "https://img.cdnpth.com/media/4aS9g75575JDG8lkJokUNC6slTo=/720x480/03/05/81/03058131.jpg"
                    },
                    {
                        "photoID": 3058132,
                        "description": "Restaurante Kulinarium",
                        "cloudUri": "https://img.cdnpth.com/media/X9BZ1w32X4-QzFvFzpM5ZbQr-rE=/720x480/03/05/81/03058132.jpg"
                    },
                    {
                        "photoID": 3058135,
                        "description": "Sport bar",
                        "cloudUri": "https://img.cdnpth.com/media/Tzq1TdIblpmIhtOpnHm0R7mxJo0=/720x480/03/05/81/03058135.jpg"
                    },
                    {
                        "photoID": 3058136,
                        "description": "Bar Plaza",
                        "cloudUri": "https://img.cdnpth.com/media/Kbsqzlrm1s50OSWO1d1BKBuxAcE=/720x480/03/05/81/03058136.jpg"
                    },
                    {
                        "photoID": 3058138,
                        "description": "Gimnasio equipado",
                        "cloudUri": "https://img.cdnpth.com/media/PFUCdiHz1FGDpVOKJzUqAIO1wS0=/720x480/03/05/81/03058138.jpg"
                    },
                    {
                        "photoID": 3058140,
                        "description": "Club de niños",
                        "cloudUri": "https://img.cdnpth.com/media/6IJ229RXHzto0-7qWiJYR9HfLYQ=/720x480/03/05/81/03058140.jpg"
                    },
                    {
                        "photoID": 3058141,
                        "description": "Spa de la propiedad",
                        "cloudUri": "https://img.cdnpth.com/media/FTCzXUtDXh0bl5LZBBcuKj5NyW4=/720x480/03/05/81/03058141.jpg"
                    },
                    {
                        "photoID": 3058142,
                        "description": "Salón de reuniones",
                        "cloudUri": "https://img.cdnpth.com/media/UQQRS65hjgtoO_5fN12ITFcxD2Y=/720x480/03/05/81/03058142.jpg"
                    },
                    {
                        "photoID": 3058143,
                        "description": "El complejo cuenta con actividades diarias en el RiuFIt",
                        "cloudUri": "https://img.cdnpth.com/media/C-kdpPfyo6_yUrZ7FQzOtGYmQtQ=/720x480/03/05/81/03058143.jpg"
                    },
                    {
                        "photoID": 3058144,
                        "description": "Habitación doble",
                        "cloudUri": "https://img.cdnpth.com/media/9-XN-LD6hwdVwLw8a1WQUo6wcnM=/720x480/03/05/81/03058144.jpg"
                    },
                    {
                        "photoID": 3058145,
                        "description": "Habitación doble con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/pkwoI6hHtEEWFaPhhw199pVoPV0=/720x480/03/05/81/03058145.jpg"
                    },
                    {
                        "photoID": 3058147,
                        "description": "Habitación familiar",
                        "cloudUri": "https://img.cdnpth.com/media/e4yJI-KY9cbd8fSZgJ-JCLoA8x8=/720x480/03/05/81/03058147.jpg"
                    },
                    {
                        "photoID": 3058148,
                        "description": "Suite con jacuzzi",
                        "cloudUri": "https://img.cdnpth.com/media/cU3XaPhXjPttU25u40sqExenwPM=/720x480/03/05/81/03058148.jpg"
                    },
                    {
                        "photoID": 3058149,
                        "description": "Interior de la suite",
                        "cloudUri": "https://img.cdnpth.com/media/kdtntl1FEFTXLzLasD1t8575VKc=/720x480/03/05/81/03058149.jpg"
                    },
                    {
                        "photoID": 3058150,
                        "description": "Baño de una de las habitaciones",
                        "cloudUri": "https://img.cdnpth.com/media/gqDYl8iTh-bULQv5osE2sPcXlGw=/720x480/03/05/81/03058150.jpg"
                    }
                ],
                "hotelID": 311084,
                "importantFacilities": [
                    "Acceso gratuito a otros hoteles Riu del destino (aplican restricciones, la información se proporciona al momento del registro)",
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.304577902735442",
                    "longitude": "-86.81364364922047",
                    "postalCode": "77400",
                    "state": "Quintana Roo",
                    "street": "Blvr Costa Mujeres, Playa Mujeres, zona continental de Isla Mujeres",
                    "countryCode": "MX"
                },
                "name": "Riu Dunamar - All Inclusive",
                "placeContainers": [
                    {
                        "id": 647435,
                        "uri": "isla-mujeres",
                        "displayText": "Isla Mujeres, Quintana Roo, México.",
                        "type": 6
                    },
                    {
                        "id": 89585,
                        "uri": "playa-mujeres-quintana-roo-mexico",
                        "displayText": "Playa Mujeres, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Principal",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Discoteca",
                        "type": "Club Nocturno"
                    },
                    {
                        "name": "Italiano",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Asiático",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Kulinarium",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Steakhouse",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lounge Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Sports Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Bar de la Piscina",
                        "type": "Bar"
                    },
                    {
                        "name": "Plaza",
                        "type": "Bar"
                    },
                    {
                        "name": "Swim-up Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259401,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303821,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303834,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303808,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303860,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303796,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303886,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303899,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303783,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303925,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303938,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303950,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303961,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303971,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303982,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303994,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304005,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304015,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303770,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303757,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304043,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303744,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303720,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304070,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304079,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304088,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304097,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303708,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303684,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304124,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303847,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303873,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304154,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304164,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303912,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304183,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304191,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304199,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304207,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304214,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304221,
                        "kidsFreeTo": 0,
                        "name": "Classic Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304228,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304235,
                        "kidsFreeTo": 0,
                        "name": "Double Twin With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304242,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304249,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304256,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304263,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304269,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304275,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304281,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304287,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304293,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304299,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304306,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304313,
                        "kidsFreeTo": 0,
                        "name": "Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304319,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304325,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304331,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304336,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304342,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304348,
                        "kidsFreeTo": 0,
                        "name": "Double Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304354,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304360,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304366,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304373,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304380,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304386,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304025,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304034,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304052,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304061,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303732,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17303696,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304144,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304174,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304106,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304115,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304134,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17304393,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Sofá o sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4558523,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TM34ilPAwOuPp9ZoTSagPGgmiqI=/720x480/04/43/29/04432921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TM34ilPAwOuPp9ZoTSagPGgmiqI=/720x480/04/43/29/04432921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Sofá o sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4558530,
                        "kidsFreeTo": 2,
                        "name": "Doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Sofá o sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4558531,
                        "kidsFreeTo": 2,
                        "name": "Doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8rVDP3b3zRTUJONmDBEUK2Q5aT4=/720x480/04/43/29/04432922.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8rVDP3b3zRTUJONmDBEUK2Q5aT4=/720x480/04/43/29/04432922.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4558533,
                        "kidsFreeTo": 2,
                        "name": "Suite familiar de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Sofá",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4558534,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719139,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (E)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719140,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (E)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719144,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (L)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719145,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (L)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719146,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, vistas al mar (L)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719147,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar (L)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719148,
                        "kidsFreeTo": 0,
                        "name": "Suite (L)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719149,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (M)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719150,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (M)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719151,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar (M)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719152,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, 2 habitaciones (M)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719153,
                        "kidsFreeTo": 0,
                        "name": "Suite (M)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719154,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1gdxDFB9udnoGGQyCzC8vuMyy0k=/720x480/03/05/81/03058115.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719155,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/clCBvSWhYiLlaJ0S9SQJbywXSkA=/720x480/03/05/81/03058118.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719156,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wT60ni85_cKIGpDuA2ICyNQgWoc=/720x480/03/05/81/03058116.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719157,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, 2 habitaciones (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WvASG9_QnayDlvaIp_mzCeUx67I=/720x480/03/05/81/03058119.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4719158,
                        "kidsFreeTo": 0,
                        "name": "Suite (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JbweuXxML38LM2Bvspae7HDrm58=/720x480/03/05/81/03058114.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561583,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561584,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561585,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561586,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, 2 habitaciones (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561587,
                        "kidsFreeTo": 0,
                        "name": "Suite (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Ducha adaptada",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561588,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, frente al mar (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7561589,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, frente al mar (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7659317,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7738573,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7738574,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7738576,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7738577,
                        "kidsFreeTo": 2,
                        "name": "Familiar de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Espejo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7738578,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355155,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355226,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355284,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8355319,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374342,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374345,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374351,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374355,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374365,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374370,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374373,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacity 4 Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374375,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8374377,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438823,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438826,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8438828,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8796500,
                        "kidsFreeTo": 0,
                        "name": "Double Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9067107,
                        "kidsFreeTo": 0,
                        "name": "Suite Four Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9091930,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199694,
                        "kidsFreeTo": 0,
                        "name": "Family Room Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199695,
                        "kidsFreeTo": 0,
                        "name": "Double Classic Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199696,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199697,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Bathroom",
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199726,
                        "kidsFreeTo": 0,
                        "name": "Family Room Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199727,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199728,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199730,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199732,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199735,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Hydro-massage bath",
                            "Internet access",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199738,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199742,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199743,
                        "kidsFreeTo": 0,
                        "name": "Family Room Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199744,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413303,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413305,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413307,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413309,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413311,
                        "kidsFreeTo": 0,
                        "name": "Room Classic Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413313,
                        "kidsFreeTo": 0,
                        "name": "Room Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413315,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413318,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413347,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413348,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413349,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413350,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Hydro-massage bath",
                            "Internet access",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413351,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413352,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11646266,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11646334,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11646335,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047278,
                        "kidsFreeTo": 0,
                        "name": "Doble frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047279,
                        "kidsFreeTo": 1,
                        "name": "Doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yapSYEJOTGNMTZO_ssslQLzwQ34=/720x480/04/43/22/04432256.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047280,
                        "kidsFreeTo": 1,
                        "name": "Doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047281,
                        "kidsFreeTo": 1,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047282,
                        "kidsFreeTo": 1,
                        "name": "Suite familiar de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Doble lavabo",
                            "Espejo",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16047283,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/w8G0Hb1jkVavkDO1UUT56_qX4Hg=/720x480/04/43/22/04432258.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087786,
                        "kidsFreeTo": 0,
                        "name": "Family Room Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087788,
                        "kidsFreeTo": 0,
                        "name": "Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087789,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087790,
                        "kidsFreeTo": 0,
                        "name": "Family Room Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087791,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087792,
                        "kidsFreeTo": 0,
                        "name": "Room Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087794,
                        "kidsFreeTo": 0,
                        "name": "Room Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16117321,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16427936,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227272,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227276,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227280,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227284,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227288,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227292,
                        "kidsFreeTo": 0,
                        "name": "Double With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227296,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227300,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227304,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227309,
                        "kidsFreeTo": 0,
                        "name": "Single Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227313,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227316,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227320,
                        "kidsFreeTo": 0,
                        "name": "Single Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227324,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227328,
                        "kidsFreeTo": 0,
                        "name": "Single Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227332,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227335,
                        "kidsFreeTo": 0,
                        "name": "Double Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227338,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227342,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17227501,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259262,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259266,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259270,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259274,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259278,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259282,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259285,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259288,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259291,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259294,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259297,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259300,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259303,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259306,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259309,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259312,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259315,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259318,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259321,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259324,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259328,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259331,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259335,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259339,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259343,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259347,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259351,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259354,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259357,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259360,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259363,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259366,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259369,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259372,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259375,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259378,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259381,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259385,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259389,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259393,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259397,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259406,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259410,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259414,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259418,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259422,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259426,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259430,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259434,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259438,
                        "kidsFreeTo": 0,
                        "name": "Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259442,
                        "kidsFreeTo": 0,
                        "name": "Classic Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259446,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259450,
                        "kidsFreeTo": 0,
                        "name": "Double Twin With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259454,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259458,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259462,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259466,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259470,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259474,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259477,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259480,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259483,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259486,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259489,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259492,
                        "kidsFreeTo": 0,
                        "name": "Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259495,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259498,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259501,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259504,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259507,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259510,
                        "kidsFreeTo": 0,
                        "name": "Double Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259513,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259516,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259519,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259522,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259525,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259528,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259531,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259534,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259537,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259540,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259544,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lateral View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259547,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony With Shower",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259550,
                        "kidsFreeTo": 0,
                        "name": "Family Suite King Bed 2 Beds 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259553,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259556,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259559,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259562,
                        "kidsFreeTo": 0,
                        "name": "Superior With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259565,
                        "kidsFreeTo": 0,
                        "name": "Suite Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259568,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259571,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259574,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259577,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259580,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259583,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259586,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259588,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259590,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259592,
                        "kidsFreeTo": 0,
                        "name": "Family Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17259767,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890726,
                        "kidsFreeTo": 0,
                        "name": "Double Classic With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890728,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890730,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890732,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890734,
                        "kidsFreeTo": 0,
                        "name": "Room Accessible",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890736,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890738,
                        "kidsFreeTo": 0,
                        "name": "Suite Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890740,
                        "kidsFreeTo": 0,
                        "name": "Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914675,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, habitaciones comunicadas (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914676,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, 2 habitaciones (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914677,
                        "kidsFreeTo": 0,
                        "name": "Suite (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914678,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914679,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914680,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (C)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18914681,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 2 habitaciones (U)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18957130,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar, 2 habitaciones (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18957131,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, habitaciones comunicadas (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18957132,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18957133,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas parciales al mar (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19306836,
                        "kidsFreeTo": 0,
                        "name": "Suite (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19306837,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, vistas al mar (B2C-CAN)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón o patio",
                            "Baño parcialmente abierto",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Cambio de toallas (previa solicitud)",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Dispositivos de ahorro de energía",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 6",
                            "Número de salas de estar",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19426416,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 2 habitaciones (B2C-US)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20164098,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZPhMPlq5qmIGlOR8uNjADjx6zlo=/720x480/04/43/22/04432254.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20164099,
                        "kidsFreeTo": 0,
                        "name": "Estándar doble vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d7ZXe_TUbskSx6Q327KcBQhuEUc=/720x480/04/43/22/04432255.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Kings o 4 Individuales o 2 Individuales y 1 King",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20164100,
                        "kidsFreeTo": 2,
                        "name": "Estándar doble conectada",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/k1IYRoORQCmvaWHHRcRrXFILYj0=/720x480/13/23/63/13236354.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/k1IYRoORQCmvaWHHRcRrXFILYj0=/720x480/13/23/63/13236354.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Individuales y 1 King",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20164103,
                        "kidsFreeTo": 2,
                        "name": "Familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4PAAsUIxqQVMwVPl9VK4IVYCg9s=/720x480/04/43/22/04432257.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Dispensador de licor",
                            "Internet inalámbrico",
                            "Minibar",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales o 2 Kings o 4 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18975736,
                        "kidsFreeTo": 1,
                        "name": "Estándar doble de 2 dormitorios",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/k1IYRoORQCmvaWHHRcRrXFILYj0=/720x480/13/23/63/13236354.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/k1IYRoORQCmvaWHHRcRrXFILYj0=/720x480/13/23/63/13236354.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "5 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para fumadores",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bote de pedales",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entretenimiento en vivo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Equipo para snorkel",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 1280,
                    "valuesAverage": [
                        4,
                        4.5,
                        4.4
                    ]
                },
                "title": "Hotel familiar de playa todo incluido con 5 piscinas y spa",
                "uri": "riu-dunamar",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños, supervisado por adultos. También incluye un lounge para jóvenes de 13 a 19 años."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como kayak, veleo y surf de remo en la laguna artificial."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    }
                ],
                "description": "AVA Resort Cancún está ideado como un oasis en constante evolución para ofrecer experiencias únicas con vistas al mar, diversión, bienestar y placeres culinarios para todos. Este hotel familiar todo incluido tiene una singular laguna artificial con tecnología sustentable Crystal Lagoon®, un auténtico paraíso de agua salada de 11,450 metros cuadrados donde se puede nadar, jugar en el parque acuático, hacer surf de remo, pasear en kayak o velero y relajarse en la cabañas flotantes. Idealmente, cada una de sus 1,622 habitaciones y suites disfruta el paisaje de las aguas cristalinas del Caribe mexicano. Todas disponen de jacuzzi en la terraza, diseño minimalista de inspiración náutica, Smart TV, minibar, cafetera Nespresso®, batas y pantuflas. Además, en la propiedad hay una seleccionada oferta culinaria con restaurantes de alta cocina, casuales centros de consumo y múltiples bares.\r\n\r\nEste resort invita a vivir aventuras, explorar, conectar y divertirse durante el día y hasta el amanecer. Sus instalaciones incluyen una piscina solo para adultos, piscina exterior, piscina interior, playa, club nocturno animado por Dj´s, un espacio dedicado al entretenimiento en vivo, club para niños con toboganes en el interior y un lounge para que los jóvenes tengan la libertad de hacer nuevas amistades. También hay un spa de 2,000 metros cuadrados con circuito de hidroterapia, tratamientos holísticos para el cuerpo y la mente, y un gimnasio donde se ofrecen clases grupales. Adicionalmente, dispone de tiendas; así como salones para todo tipo de eventos y celebraciones privadas.\r\n\r\nEl resort se encuentra a solo 9 kilómetros del Aeropuerto Internacional de Cancún (CUN), enmarcado por el campo de golf Riviera Cancún Golf &amp; Resorts y la zona de Punta Nizuc. El parque acuático Ventura Park se halla a 3 kilómetros y la playa Delfines con su mirador está a 10 kilómetros.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/4cbd2ac36a05318cf8745e18aa6ef9980bcd5b35547398279197fb02bc247b3e_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/999c0bf0d168a9b3f917e9be8ef65049d28cf00faafdc6e496f35b0fe94f9bcf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/30b47f5de380545c2c8140a3894a84432f10a7ed976ea3ca96e651011e6f0318.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0448432817680c66326e8e143921201af1659d95c2c2eabf4d2e7f1bc58c0a07.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0988da701c0c6a6af9af3930e5d797a50aeb8b7c99eaffc30956f76b101747bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/5f771b695574b6f0ab72db2312118f4db7b230fe5b174c75bb2697eb9f41debf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/fadefd3fae5e157e16e0c4e81efa0e83421065a96c173d1af18952d2b1d74e60.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/f42cd8b42878ff633d15826f24ca266de4fe9bd162c0ee41112f681f8957dd82.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/f63fb7869ad9aedbfac0a5da4fb5a97f55d00e448c9f021883cbdef8c2874e55.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/8acc019214da025bdd8cc39222b590aed9e4c6e79c16d33f4f1532abebc43733.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/ed4139ba81c81c7722c93c7cfd10bc6b4e21f33057df4a610c9a096ccb9b16a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/e60a9d6bb474824aa5d62894d4e3f074938db742ad02e44b7fec133cd09eebfb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/a6d63ba6dcf5ad00ebba514291e72ab05845ef34b08ab4075bcd0868f6014193.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/5ac72290659bd8fae0f108c5f69b52aef159a60c6af0f7f79d1dd54118b525fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/9557e4eaec78076b2a3fc512430118640ec616b25f89942045687bf1ad16e8f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/ca03423499f95cbafbe480745448b3309bbdca7520d00b4d54f85e4b3cd94c30.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/877246989bc6114118cdac76f32121f1152d64c5ba19f3ab0a1eaf08e27db7be.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0cdf0b85d124f7cac91e10d9f74e7761d1ea208a66e1cb2c5cf2e52cd310d4fd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0f43d2bf8eb30a042a5388f298f6b693d2e261c815ecdb17ae1bfafa4e9afba6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/1f718726177e993c46b16093b7534b3569b0b92d76f783cc118582c1b98523d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/ca58aa56dcf2220d4320b98865b6efdd44daf8863e5f6754c010517b7fa954bc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0a42ade0c85328b80779cbea0bc0675f0939b9056c63d54680d7cbd5162dde8d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/927de89776d121253ea5e32bb21deb7c300742bf44fabfd1f992fc396c26e197.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/4936152ce165a81e3981e7a35c3b17eac8556ae6de4cc5474f4559c7ee88ef3a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/5b905c365d0b7554c2d40881fa6a3ad50ee6c7fe694f936f50edf5dd86dc7b93.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/7dfff4d0a5101d31b3846c09bbdd383474c95963c5fe8f58fea56b4624a1e908.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/e3a798a8b823c3261cc28ed3d67448ac34f6978280ab2d188a785b0d05f5a3e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/36534434571788fc2cdd01f43ead42a344caddcffd13c102d4023c5422bb45d6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/22133a23bc8f16a6db4471a173ad094fddd2a65e941faece4b92e935c2d351e6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/ff7bd9b23a4fe5338ca2b2e5acefaa1a478f2a7c303889c73f6009a94580abac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/9b5ce86685f83ce2fec87effcf1a623e09b085619d774c069a7ec095a1e25aee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/8a351e63cd00a65451cbe6d71d26129b521ee1ddd8acbcd80283e5da66f62952.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/ad3890c933c68e4864c95fdf9d1d1029687c0041d3ba4bb45b8d9990331024eb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/2716d6eea6fd7db1f68c32a2efecbd9242fcd32ff8b805ca4cac232a7e18e5c6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/c7de90066636b9849df813b882121bd72a4ad570b4517e4af8ad11892824cd82.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/c4a871f641b1cc7e041c396ab6b5513a9643ee5d5aa28456c69ab42bea863601.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/da9dfd36f52c16b6412d6a26f78f4c2d92abd679eee144d9e9702cb769488347.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/053d7ada33d549a7d1624fb6f019aa206df11da024816542bbbb9b157027f0ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/4dd0247053c1c6780a9aecd54bcbe271e47eee9e65e1d0065226383ae9a9d17f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/4321cadda13e8424897e8cd955abfa492235990ff277860c2b7a7e1690cf7d86.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/73acb70a00365590bf145a13e2c5c52e49ff43f688755f190e161f5c6aa1914c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/2bf100a168b61c862996fc77ad3c519d6e7728da928ded5faf01070a9b6e976e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/b3be1beb936d79312745dafe448f7642b52cbcc13ed7c38ef4f10746a59d502c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/5f1f12616d1a818d66f8715b53bf8e766a22f590cb5cd0c125c4210f74f9e89b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/507756/0faa3a7344db95a3f7c7d424599e0c625894dff1086155a5a2c4e292ad026612.png"
                    }
                ],
                "hotelID": 507756,
                "importantFacilities": [
                    "Laguna artificial"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.01040356739503",
                    "longitude": "-86.81884109973907",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcán km 25.3, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "AVA Resort Cancun",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Aji",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Black Iron",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Chez Moi",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Livo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Veranda",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Copal",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Food District",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Plaza MX",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Aroma Café & Bakery",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Kita North and Minami South",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Pods",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Konos Ice Cream",
                        "type": "Restaurante"
                    },
                    {
                        "name": "5 Snacks",
                        "type": "Restaurante"
                    },
                    {
                        "name": "DEZ - Nightclub",
                        "type": "Bar"
                    },
                    {
                        "name": "Digit - NFT Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Handome Harry",
                        "type": "Bar"
                    },
                    {
                        "name": "Kantina 1953",
                        "type": "Bar"
                    },
                    {
                        "name": "The Cocktail Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Swim-up Bars",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Smart TV de 65 pulgadas",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114570,
                        "kidsFreeTo": 3,
                        "name": "King frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/YqoDUzU9HKLFseiE27G6o8w2D5M=/720x480/11/88/22/11882216.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/YqoDUzU9HKLFseiE27G6o8w2D5M=/720x480/11/88/22/11882216.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Smart TV de 65 pulgadas",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114622,
                        "kidsFreeTo": 3,
                        "name": "Queen frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/912Rjl94cOwtMCojkYwrCEYlRwg=/720x480/11/88/22/11882217.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/912Rjl94cOwtMCojkYwrCEYlRwg=/720x480/11/88/22/11882217.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Smart TV de 65 pulgadas",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114623,
                        "kidsFreeTo": 0,
                        "name": "Para parejas frente al mar - solo adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/R7rRvTAdzIPYNxSkTp9ikbNXeKI=/720x480/11/88/22/11882213.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/R7rRvTAdzIPYNxSkTp9ikbNXeKI=/720x480/11/88/22/11882213.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Alberca de inmersión",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa y sillas para 4",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Smart TV de 65 pulgadas",
                            "Sofá",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114625,
                        "kidsFreeTo": 0,
                        "name": "Central frente al mar - solo adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u6FSqoLWK_-osi48rKHoOLmrR64=/720x480/11/88/22/11882210.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u6FSqoLWK_-osi48rKHoOLmrR64=/720x480/11/88/22/11882210.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King y 2 Sofás cama",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114629,
                        "kidsFreeTo": 3,
                        "name": "F&F frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/11oTnqIr3CZegr2zXoig9PcAqtU=/720x480/11/88/22/11882214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/11oTnqIr3CZegr2zXoig9PcAqtU=/720x480/11/88/22/11882214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Smart TV de 65 pulgadas",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King y 2 Sofás cama",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114635,
                        "kidsFreeTo": 3,
                        "name": "Suite F&F sundeck",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_I6dsFrxIKt0tvcTgjwxJ5u8KLE=/720x480/11/88/22/11882211.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_I6dsFrxIKt0tvcTgjwxJ5u8KLE=/720x480/11/88/22/11882211.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa de trabajo",
                            "Mesa y sillas para 6",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114640,
                        "kidsFreeTo": 0,
                        "name": "Suite Gala de 1 dormitorio frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vksbKWlmiEj-ABrZ4-iOy_VY8H4=/720x480/11/88/22/11882212.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vksbKWlmiEj-ABrZ4-iOy_VY8H4=/720x480/11/88/22/11882212.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "3 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa de trabajo",
                            "Mesa y sillas para 6",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "1 King y 2 Queens y 1 Sofá cama",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114641,
                        "kidsFreeTo": 3,
                        "name": "Suite Gala de 2 dormitorios frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/R7rRvTAdzIPYNxSkTp9ikbNXeKI=/720x480/11/88/22/11882213.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/R7rRvTAdzIPYNxSkTp9ikbNXeKI=/720x480/11/88/22/11882213.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 terrazas",
                            "3 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Hamaca",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "2 Kings",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114642,
                        "kidsFreeTo": 0,
                        "name": "Suite panorámica de 2 dormitorios king & king - solo adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2RcBmOcC-1pqteOsNKbaXshMHJ8=/720x480/10/52/95/10529597.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2RcBmOcC-1pqteOsNKbaXshMHJ8=/720x480/10/52/95/10529597.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "2 terrazas",
                            "3 baños",
                            "3 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Hamaca",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "1 King y 2 Queens y 1 Sofá cama",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114643,
                        "kidsFreeTo": 3,
                        "name": "Suite panorámica de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2RcBmOcC-1pqteOsNKbaXshMHJ8=/720x480/10/52/95/10529597.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2RcBmOcC-1pqteOsNKbaXshMHJ8=/720x480/10/52/95/10529597.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 terrazas",
                            "3 baños",
                            "3 recámaras",
                            "4 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Hamaca",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "2 Kings y 2 Queens y 1 Sofá cama",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114645,
                        "kidsFreeTo": 3,
                        "name": "Suite panorámica de 3 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zEecKAH2vvD-PGZ0AtM4h0Olwho=/720x480/11/88/22/11882219.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zEecKAH2vvD-PGZ0AtM4h0Olwho=/720x480/11/88/22/11882219.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 terrazas",
                            "3 baños",
                            "4 recámaras",
                            "4 Smart TV's de 65 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Hamaca",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "2 Kings y 4 Queens y 1 Sofá cama",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114646,
                        "kidsFreeTo": 3,
                        "name": "Suite panorámica de 4 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/80AlNLughEDUKt1xdPwwtWNJq3g=/720x480/11/88/22/11882218.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/80AlNLughEDUKt1xdPwwtWNJq3g=/720x480/11/88/22/11882218.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 terrazas",
                            "3 Smart TV's de 75 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114647,
                        "kidsFreeTo": 3,
                        "name": "Suite Central frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/QPhZOaQSUM2-enstNQNH-3P54fM=/720x480/11/88/22/11882215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/QPhZOaQSUM2-enstNQNH-3P54fM=/720x480/11/88/22/11882215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 baños",
                            "2 terrazas",
                            "3 Smart TV's de 75 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114648,
                        "kidsFreeTo": 3,
                        "name": "Suite penthouse de 1 dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/MHElPKDVV7Hjfd-5IL9z8GUomW8=/720x480/11/88/22/11882220.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/MHElPKDVV7Hjfd-5IL9z8GUomW8=/720x480/11/88/22/11882220.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 terrazas",
                            "3 Smart TV's de 75 pulgadas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Cocineta",
                            "Detectores de humo",
                            "Doble lavabo",
                            "Ducha de mano",
                            "Espejo de tocador",
                            "Estacion para audio por Bluetooth",
                            "Internet inalámbrico de alta velocidad",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa de trabajo",
                            "Mesa y sillas para 8",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Sofá",
                            "Tableta",
                            "Teléfono de marcado directo",
                            "Vestidor"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17114649,
                        "kidsFreeTo": 3,
                        "name": "Suite penthouse de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cVd4HJiATh8rBNzwiBm5c_kf5JQ=/720x480/11/88/22/11882221.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cVd4HJiATh8rBNzwiBm5c_kf5JQ=/720x480/11/88/22/11882221.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974943,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974944,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974945,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974946,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974947,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974948,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974949,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974950,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974951,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974952,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974953,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974954,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974955,
                        "kidsFreeTo": 0,
                        "name": "Suite Tres Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974956,
                        "kidsFreeTo": 0,
                        "name": "Suite Cuatro Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18974957,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Basquetbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boliche",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cabañas junto a la piscina",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de jóvenes (13-19 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Galería de tiendas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico de alta velocidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Laguna artificial",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Llamadas gratuitas a EEUU y Canadá",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Pilates",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina exterior",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina interior",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Recepción 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de videojuegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Todo incluido",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Velero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 5,
                "surveyAverage": null,
                "title": "Hotel familiar todo incluido con laguna artificial",
                "uri": "ava-resort-cancun",
                "tags": [
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Actividades",
                        "description": "Incluye clases de español, bailes latinos y de estiramientos y acuaeróbics así como desfiles de moda y concursos de belleza."
                    },
                    {
                        "title": "Club de Niños y Área para Bebés",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos. Abierto diariamente de 09:30 a 18:00 hrs. El área para bebés es para niños de 0 a 4 años."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye todos los alimentos y botanas, comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. Incluye bebidas alcohólicas y no alcohólicas nacionales y un minibar en la habitación con cerveza, refrescos y agua.\r\n Sujeto a disponibilidad."
                    },
                    {
                        "title": "Deportes en Tierra",
                        "description": "Los deportes en tierra incluyen tenis, ping pong, uso del gimnasio y voleibol de playa."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Se requiere reservación y código de vestir en los restaurantes Zai y Marco Polo."
                    }
                ],
                "description": "GR Solaris Cancún Resort and Spa All Inclusive es un complejo hotelero ubicado en una de las franjas de arenas blancas más hermosas de Cancún, en la Zona Hotelera, frente a las cristalinas aguas turquesas del Mar Caribe. El hotel se encuentra a 7 kilómetros del Centro Comercial La Isla y a 10 kilómetros del Centro de Convenciones de Cancún y de la zona de bares y discotecas, como las conocidas Coco Bongo y The City. El aeropuerto internacional de Cancún (CUN) está a 15 kilómetros de distancia. \r\n\r\nEste hotel de playa cuenta con 306 habitaciones con vista a la laguna o al mar. Todas cuentan con aire acondicionado, baño privado con ducha y acceso a internet inalámbrico. También hay habitaciones con jacuzzi. \r\n\r\nGR Solaris Cancún Resort and Spa All Inclusive tiene cuatro restaurantes, dos bares, un deli, una pizzería y ofrece bebidas ilimitadas y servicio a la habitación las 24 horas del día, además de cenas temáticas mexicanas con espectáculo en la terraza principal, sujeto a programación. El hotel ofrece además, actividades diarias para todas las edades, actividades en la piscina, noches temáticas y un área para bebés de 0 a 4 años disponible las 24 horas. Asimismo cuenta con canchas de tenis con iluminación nocturna, gimnasio completamente equipado, piscina de relajación para adultos, jacuzzi y spa. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $76.00 MXN por habitación, por noche, a pagar directamente en el establecimiento. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/2689fd47defe69c4f30824ab676c89df059b34178b1ca2608a5133971040f9ca_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/0d8ab83c3d7caf1636e6379a31549a6cf7aec8019d79a41caef1684cd66a4ad2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/79bae6f832da01cc839d8ac93b774fa6314c5d93bc7173eb7c17818d91e6cce1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/e08504234108d89184cd9788dff131b38ecb68e19d635ec9d9d1ed30e15d0053.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/3d4822986666236fe875e41e5e4c12ebc400a0d49a095a36d036323e716bdef1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/c7c30eb574d1f552278bb5bb0059c12da93a0c78ae0575722aa225aa4c2db8d2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/542eb3cb1ea590458569ac4eebe322f8b692b097c446f876090ab6fb1d018e44.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/e6d8e91e3d7191809385de85a2401ef7a2597e64831591fbbd5b6de8fa96e8ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/d3ce30a6c04e816acbec7f9887d01c4b069ca248ee72986b429e40f89e639435.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/f8d481655dfd845af078b089318d633cd394c441948c976c083f44e0592d6344.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/d3c75c75b65fb1112f9fd8c39708c2d3459bc7fdb2fe8c63f1775e1540f24d2a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/42615cceacefd8a1e1ea90a9c0079b79097b6e109d4640d2e4ba5295639c08c9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/caf3e68445e5ff718ef6e4feb771c64e1c3366cd67852aa242f1b783c2179756.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/548a4934458e10e876984ea2939fe59a0126a2810e76dd16ad2882e258e36939.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/a031e1598a8e6bc7eeb4338dc05e43c8110f1304fd677b4a631581fbc01fdcd5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/77a73d6c304dbaf4f23e0c40f266641b98daffe29bdb65a81bdb4f53ad4c4776.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/ddbf3cdc95d6883fc00aeb39067cd4347949e18dce1795f31c8dff0fd498a224.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/2d629c6cbdb5103f4260ca3e41e28927d114088a7b3a6d57bd9623cc95fc5926.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/d948c9c933ef6736a8233571f7edf9d6822430ed2cb4418ee679015f0911515a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/a2f071c7f546aecb71ca906bf7a40699acc3a32d7d7e261e964960df6563e743.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/bd8a823fd918f69aa48ceea94b9522dcc3940a8c039dd210b49bee38f9226bf4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/39da12bb275ce5b1852ae35f6dc5c4d69f6f7d653241984548b56509e5bba0bc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/b1d4f50e02391bd3622ff3293cb50dffdac85c7b22d4ee33c73184786ca766b6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/c748d295e7981e7286ac7798feb0c20d0d2b4594796e0132ed9fbea370dee92b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/ba7a0c73d577bfa382846b247021596e4655624fa114db8bea8443aa8e382e2c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/0ef0a1a6dadf6365186f9d1b4ff1acf97a2273a7b91b719b29cec79bc163c475.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/66774e24c0cc75d787e407fe7987b4fca5ddbef3d7855df1ef9beecf9add64a1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe Ocean View Room  ",
                        "cloudUri": "https://img.cdnpth.com/media/100220/5df01df549944f98c5c4cd5ac3f51e20e58d0154093164dfc9399aa9f814d1ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe Ocean View Room  ",
                        "cloudUri": "https://img.cdnpth.com/media/100220/5374012406f81fe38cea54523c3f7dbeb094dfb975ed26d927e6519ac618d119.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe Ocean View Room  ",
                        "cloudUri": "https://img.cdnpth.com/media/100220/ed8768f576a4d8779c715495a1ef8f25136478a92c739e3dbd086688c3771c88.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Deluxe Room",
                        "cloudUri": "https://img.cdnpth.com/media/100220/97b33e4262d33d02492e5cca2c3fb466e46e111e9c020c8158492c4500f2fe31.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/9b4165168c4d831dadbe4d870a5b22cf4b7a3d8b28ae074c050e7f4082a31710.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/75f6fee9e4f8880c53335b164b57084d71739648a645f6f602a7598ce2080463.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/a87284469e0bfdbb98d85f7a32e9f0bda14498483e7bbb448886156d23f67233.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/9a9c68f61e7fa8c503b6dc23cab8041698f897a0ade751db9767dc24bbfb3c08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/b249edf1f8735332a65de31e7cc9a0915de56f9c250a61af027e646240ce7f1a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/74c9fcc55216f8cca4221dc0cd488f8b9fa547f55f428322f723fdb321756168.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/65381761687309d5e546e831e9d4ad983535414ffc19449b14816e0dea6e8b12.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/7b721c884db8ff5df2d8daa2bdbbb83be2e072d6f56bdf1daae6cc5d4b2f9801.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/413f6bf40b67030115903851d49c293f99a1ae38ad82b56c67925f86e3ed954f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/bfbeef69334f016b582e2ae76072f1ca1643d91ebf51d87b05788c6d4ba49c51.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/3b215f0d27d3bd03548def2c5e36e43889d085d5f6d535cf58c1c0ef7bb91f3d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/6c66c5338db95ccfb87a540f535c70524d9606142af2bfbafe1a4386048693d1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/636cd8b6b1d646b2fc224febe362f642bb2b7cc484162b9b45fa54694c6325e0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Gallery image of this property",
                        "cloudUri": "https://img.cdnpth.com/media/100220/9dfdc9d95d8dd9c164e2c1731acbbb2ddfe0ea91958857a170cc26264788ae75.png"
                    }
                ],
                "hotelID": 100220,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Wifi en cortesía"
                ],
                "location": {
                    "city": "Cancún",
                    "country": "Mexico",
                    "latitude": "21.055066153178305",
                    "longitude": "-86.78227186203003",
                    "postalCode": "77500",
                    "state": "Quintana Roo",
                    "street": "Blvr Kukulcan km 19.5 L 59-2 2a etapa Sección A, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "GR Solaris Cancun Resort & Spa All Inclusive",
                "placeContainers": [
                    {
                        "id": 54455,
                        "uri": "cancun",
                        "displayText": "Cancún, Quintana Roo, México",
                        "type": 6
                    },
                    {
                        "id": 404580,
                        "uri": "cun-cancun-quintana-roo-mexico-aeropuerto-internacional-cancun-rng",
                        "displayText": "CUN Cancún, Quintana Roo, México - Aeropuerto Internacional Cancun",
                        "type": 10
                    },
                    {
                        "id": 732128,
                        "uri": "qroo-tulum-y-alrededores-mexico-todos-los-aeropuertos",
                        "displayText": "QROO, Tulum y alrededores, México - Todos los aeropuertos",
                        "type": 18
                    }
                ],
                "restaurants": [
                    {
                        "name": "Café Solaris",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Deli",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Rosmarinus",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Le Cinque Terre Pizza",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Marco Polo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Zai",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6890344,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7922042,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7922043,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7922045,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352596,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352614,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352630,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352642,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352668,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352672,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352705,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352782,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8352797,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583568,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583574,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583583,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583586,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 15797753,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176037,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176039,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176041,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Frente A La Playa",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176043,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176044,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176046,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Frente A La Playa",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176050,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176051,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176053,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176054,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176055,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176056,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176057,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176067,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176069,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176074,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176075,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176076,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176079,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16222373,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16521837,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16521838,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723119,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Frente A La Playa",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227873,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227875,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227876,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227877,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227878,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227879,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 4",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227880,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227881,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227882,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227884,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227885,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227886,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227887,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227888,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Club",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227889,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227890,
                        "kidsFreeTo": 0,
                        "name": "Apartment Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227891,
                        "kidsFreeTo": 0,
                        "name": "Room Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227892,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Lake View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227893,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227894,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227895,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227896,
                        "kidsFreeTo": 0,
                        "name": "Apartment One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227897,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227898,
                        "kidsFreeTo": 0,
                        "name": "Room With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227899,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227900,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227901,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227903,
                        "kidsFreeTo": 0,
                        "name": "Room King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227904,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 1",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227906,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227915,
                        "kidsFreeTo": 0,
                        "name": "Room Lagoon View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17227916,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949978,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949979,
                        "kidsFreeTo": 0,
                        "name": "Single Honeymoon",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949980,
                        "kidsFreeTo": 0,
                        "name": "Double Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949981,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949982,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949983,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949984,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949985,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18404033,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18404064,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18404094,
                        "kidsFreeTo": 0,
                        "name": "Double Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18404125,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18404156,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Lake View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503388,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503409,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503430,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503451,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503472,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503496,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503517,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503539,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503563,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503585,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503607,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503629,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503650,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503672,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503692,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503713,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503734,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503755,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503776,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503798,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503820,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503840,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503861,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503881,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503900,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503919,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503938,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503956,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503973,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503991,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504010,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504029,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504048,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504067,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504085,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504103,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504121,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504139,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504159,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504178,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504198,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504217,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504236,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504256,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504276,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504296,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504316,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504335,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504353,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504370,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504389,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504408,
                        "kidsFreeTo": 0,
                        "name": "Suite Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504426,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504444,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504462,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18504481,
                        "kidsFreeTo": 0,
                        "name": "Premium 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827149,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827151,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827152,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827153,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827154,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827155,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834953,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18886732,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951046,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951050,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Lago",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951054,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951056,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951057,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951059,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951061,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951063,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951065,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951066,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951067,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951068,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951069,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000808,
                        "kidsFreeTo": 4,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zSSo1daJT0TUbxlw7vLqvaeRu4g=/720x480/13/34/53/13345374.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zSSo1daJT0TUbxlw7vLqvaeRu4g=/720x480/13/34/53/13345374.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000809,
                        "kidsFreeTo": 4,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/MunxNQGI8SetcG3cvIkIzOK48Z4=/720x480/13/34/53/13345373.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/MunxNQGI8SetcG3cvIkIzOK48Z4=/720x480/13/34/53/13345373.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de vino nacional",
                            "Cafetera",
                            "Cena romántica a la luz de las velas",
                            "Decoración especial",
                            "Internet inalámbrico",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1001224,
                        "kidsFreeTo": 1,
                        "name": "Romance",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZVEZwdnIxUy4nAKfw9SevH6Ysic=/720x480/13/34/53/13345375.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZVEZwdnIxUy4nAKfw9SevH6Ysic=/720x480/13/34/53/13345375.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1001225,
                        "kidsFreeTo": 0,
                        "name": "De lujo vista al mar con jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yHxItXhR9OtgAqVnyEiDaYBgOt8=/720x480/13/34/53/13345370.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yHxItXhR9OtgAqVnyEiDaYBgOt8=/720x480/13/34/53/13345370.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1005630,
                        "kidsFreeTo": 0,
                        "name": "De lujo con vista panorámica al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3k8oBCps8yAUQxP44WWRbI3DUOY=/720x480/13/34/53/13345372.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3k8oBCps8yAUQxP44WWRbI3DUOY=/720x480/13/34/53/13345372.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3910891,
                        "kidsFreeTo": 4,
                        "name": "De lujo vista a la laguna",
                        "isActive": true,
                        "view": "Laguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/e1Qm6q6ezzKnMdWLM2GZiFYXBWo=/720x480/13/34/53/13345369.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/e1Qm6q6ezzKnMdWLM2GZiFYXBWo=/720x480/13/34/53/13345369.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3945616,
                        "kidsFreeTo": 4,
                        "name": "De lujo vista frontal al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/hRzdHUGPdPaYyLTrn86MhXcefSA=/720x480/13/34/53/13345371.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/hRzdHUGPdPaYyLTrn86MhXcefSA=/720x480/13/34/53/13345371.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996322,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996323,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony Ocean View",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cable TV service",
                            "Cable/satellite TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Iron/ironing board",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, algunos artículos gratis)",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Rollaway/extra beds (free)",
                            "Room service (24 hours)",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996324,
                        "kidsFreeTo": 0,
                        "name": "Panoramic room, Balcony Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996328,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3996329,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony Lagoon View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4198550,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4198551,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Estéreo",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 5968133,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6862841,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas A La Laguna",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7607837,
                        "kidsFreeTo": 4,
                        "name": "De lujo - no reembolsable",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zSSo1daJT0TUbxlw7vLqvaeRu4g=/720x480/13/34/53/13345374.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zSSo1daJT0TUbxlw7vLqvaeRu4g=/720x480/13/34/53/13345374.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Albornoces",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 15797739,
                        "kidsFreeTo": 0,
                        "name": "Romantic Room, Balcony Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 15797740,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony 1 King Bed, Jetted Tub, Oceanfront",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16176048,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501007,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501033,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501059,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501085,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501111,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501137,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501163,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501189,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501215,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501241,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501268,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501295,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501321,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501347,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501373,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501399,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501425,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501451,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501478,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501505,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501532,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501560,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501588,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501616,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501645,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501674,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501703,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501731,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501758,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501786,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501813,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501840,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501867,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501893,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501919,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501945,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501971,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18501997,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502023,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502049,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502076,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502102,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502129,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502156,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502184,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502211,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502238,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502265,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502292,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502319,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502346,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502373,
                        "kidsFreeTo": 0,
                        "name": "Suite Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502401,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502428,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502454,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502480,
                        "kidsFreeTo": 0,
                        "name": "Premium 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502506,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502531,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502556,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502581,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502606,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502630,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502654,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502678,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502702,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502725,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502748,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502770,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502791,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502812,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502833,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502853,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502874,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502895,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502915,
                        "kidsFreeTo": 0,
                        "name": "Deluxe City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502934,
                        "kidsFreeTo": 0,
                        "name": "Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502953,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502971,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18502988,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503005,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503022,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503039,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503056,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503072,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503087,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503102,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503118,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503134,
                        "kidsFreeTo": 0,
                        "name": "Single Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503150,
                        "kidsFreeTo": 0,
                        "name": "Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503165,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503181,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503197,
                        "kidsFreeTo": 0,
                        "name": "Double Room Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503214,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503230,
                        "kidsFreeTo": 0,
                        "name": "Superior Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503250,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503270,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503290,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503312,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18503334,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, algunos artículos gratis)",
                            "No fumadores",
                            "Número de camas - 3",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20110162,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe (Deal of the Day)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para bebés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra (sujetas a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas (sujetas a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entretenimiento en vivo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de café en el lobby",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 3376,
                    "valuesAverage": [
                        4.5
                    ]
                },
                "title": "Hotel familiar todo incluido en la Zona Hotelera de Cancún",
                "uri": "gr-solaris-cancun-resort-spa-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }

        ]
    },
    {
        titulo: "Hoteles en Acapulco",
        "destinoId": 2,
        destino: "Acapulco",
        hoteles: [
                        { name: "Hacienda Maria Eugenia" },
                        { name: "Hotel Mirador" },
                        { name: "Hotel Copacabana" },
                        { name: "Ramada By Wyndham Acapulco Hotel and Suites" },

            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "One Acapulco Costera se ubica a dos cuadras de la playa, en la llamada Zona Dorada, sobre la principal avenida del destino donde se concentra la actividad turística. Este hotel en Acapulco es completamente libre de humo y cuenta con piscina al aire libre y 126 habitaciones de diseño moderno con aire acondicionado. Para los viajeros ejecutivos dispone de sala de reuniones, centro de negocios y acceso a internet inalámbrico gratis.\r\n\r\nLa propiedad ofrece desayunos, aperitivos y bebidas durante el día. También, dispone de traslados al aeropuerto y mesa de trabajo en todas las habitaciones. El hotel acepta animales de servicio.\r\n\r\n\r\nA 500 metros está el parque acuático El Rollo y a 1 kilómetro el Centro Internacional Acapulco, sede de convenciones y eventos culturales. La Quebrada, con sus tradicionales espectáculos de clavados, se halla a 8 kilómetros y el Aeropuerto Internacional General Juan N Álvarez (ACA) se sitúa a 19 kilómetros.  **Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/11b9a08767bbb5700115cfec92ff6502ad88031f21b8474d3ad119213eb872ec_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/92da693586f6e52bc61dc25487941cf5c7c82c4a4e6a3173d54bf5d25118878e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/808cc42c528056007ca8dad2e3a06bb557f778133df53954d76d8b8d34573ac3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a1ea5d9a195fecbe2d15852518cdd84f758b550a3609c5d5e41cd0393cbb5be0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/f7ae89958220e840954c5d4718c98c05c308c32a74dc20c83dbf6aa64577a769.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/ce854ce71bd287c9f8a166136876da6f7909d182e07cc3bb4a82dac30c9615e3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/f0c7b02255656b8a23a9f7d87e0527753ee431689de865977fa3015b7a1326dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/6a2c66013d627327feef5563fe658218dcd9a1406092667a133242fd18e395af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/5f09c8bb55939725583c6b342ec10692f6d5f1ad9e76a52fb7a08676013cd5f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/c606c04df02cc3453e90fed87c638bb66f5ee3f2488097f96e5f106eee07aeab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/7c74cf3d7a619cf83470819d8e1658ed47ced20869a2e6bafee723e0f05d40c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/e720b2dc0f52e9bdae3492114dd00d181220c510610aa8be78c7f7d9cf29ad2c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a0f5e12680f8654a39f68f2c73e2d7aa2de9000910fe92c8316f242966087c10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/3eae4ab8354fceb4fb025bf5bf2c851d57a6e2434ba3600b7984164d16537e61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/6b5585c6f149e1ed4604d9af091684a44c11eea66306d48c6ede21499dd2ae47.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/ee1bd8b83b19ac915eaa294b0249b0f265a74c3e32bb52ee0522962e5db6564e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/eda9eaa1260d7a30f92a257f1d7f3716f9882f2e47648c964d4fe036298ede09.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/cc57c60fc0545fe91e6c597e81a5cae286ab2fcc39ea2ecdb2d803a5121e2c2f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/62ffe825e98b3fdd21b6e407289d10e2c91ac29804ef165c0ef5bccf85784f34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/246c64c167253ad989641aeb72a9df23e4dd76af88583355517d3e84273871fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/e71315ea9fc4233e9af9cc2d73b36ae9003fadae49799abd14abb149a83d29dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/8fb618c2b0ada7f9049d6a9abbeeef4eadb825c6005ef56830ad69a9d27f1c3c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a419f01c0471116e629b2fc044754be1289b964fdc5df381cfbbe6ed514edd65.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/5a49e3e8de7e4f44299a32ae450492b55f974d9c0119f2c6d2db4b40947eb97d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/e6dbaa02f7c3f8002b3738036ff5da15babd2203e259a301485eeb951c6aabe7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/3e58762309ec84de6d4a9546cf3f701d0638366239eb637e7b3990b97bba02d0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/247d7893c0a93d724e1f3f54c358caebf9bdf3c89dd5a6c44eaff44fd9af0388.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a89ce609a87a3f4f2c2f0cae6ffb199532607f517781a5dc6aae060197bf99c3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/47d4ff30d17b0dbc71ff24220f7f1cec238dd39bfa61107c7aea3c1938de19ac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/736fb71208295cd6ab084d1f561333368e314ec68b934034c4547f839a76db7d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/8dd12dc9d087311c57d49a04509a78b0d844975bb4dc4a001db61d07f8179f8c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/c1b7a7227e5a7034d7e8e3e9b5124758c554625448263092ac9b78090a257428.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/466919260b843fd1a99012d74895b8b8b9c29a1f3fea0d312d03b161dd6b08e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a2e9e755d8570a356b72d56059ea9648cb92bac02e0628a048bb3b950351a388.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/522b50be8b00a655a7c02824f700d5f2f68562bd6c8a8fbc75ba75db9019d39e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/6e6f88331eb8c446973fd42ca0d75b64262c4b83264fd4b19d8d5c515c6743f9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/75d103b03b563e6e8af02a6b0140658610032367e9fe387eabf611282235c263.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/8065f496651fcb31d38bdf0d85826ecbac7e97e089e330ba0a6ffb955f22f710.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/9c9b4acc7c36767c7659e2b37b60603543057fd483b5dd86801ce45726d347ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/74085ed07f87b6fba392c8275fa1d9549f15f524f0cdce70f71c56281fa1e259.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior - 1 cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/101736/851f0d5cc0170724119d40f6c2b8b87bcda0bebbf4d2fe13e1e11f5a8003a98d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/d13bad4d714eca56b77700d4640f221a4a04ad9e71fa674a8e7fb1fc2f243a1c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/4932259238161c4185d55ae3b64d175e3edb6b4b4f1d188975616f0dea9f2a87.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/101736/a798a3f18bf9805bc305dc212becfa53a2937b82892deaef97dfea5ca359ed76.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101736/bf3c30cc4990d8c4045813663616bee4dc46a1eafe3c4b543f698d283ce65cba.png"
                    }
                ],
                "hotelID": 101736,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "El hotel acepta animales de servicio",
                    "La tarifa incluye el desayuno"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.84614559501996",
                    "longitude": "-99.8497661948204",
                    "postalCode": "39850",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 16, Col Costa Azul",
                    "countryCode": "MX"
                },
                "name": "One Acapulco Costera",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Salón de Desayunos",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518106,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518129,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518150,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518173,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518196,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518218,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518239,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518260,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518282,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518305,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518327,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518348,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518370,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518392,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518414,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518436,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518458,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518481,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518503,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518524,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518546,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518568,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518588,
                        "kidsFreeTo": 0,
                        "name": "Single Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564187,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564208,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564229,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564250,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564272,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564294,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564316,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564338,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564359,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564380,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564402,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564424,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564446,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564467,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564488,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564510,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564532,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564556,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564580,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564602,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564624,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564648,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564681,
                        "kidsFreeTo": 0,
                        "name": "Single Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564709,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564736,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564763,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564789,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564815,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564840,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564865,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564889,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564913,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564937,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564961,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18564985,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565010,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565035,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565061,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565087,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565113,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565139,
                        "kidsFreeTo": 0,
                        "name": "Family Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565166,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565192,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565219,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565247,
                        "kidsFreeTo": 0,
                        "name": "Family Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565275,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565302,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565329,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565357,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565384,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565411,
                        "kidsFreeTo": 0,
                        "name": "Double Room Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565439,
                        "kidsFreeTo": 0,
                        "name": "Superior Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565467,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565494,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565524,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565552,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565581,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565609,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565637,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565667,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565697,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565727,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565756,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565780,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565805,
                        "kidsFreeTo": 0,
                        "name": "Double Twin 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565834,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565863,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565892,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565920,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565948,
                        "kidsFreeTo": 0,
                        "name": "Superior Family Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18565976,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674790,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674805,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674820,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674836,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674851,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674865,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674879,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674893,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674907,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674921,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674936,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674950,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674965,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674980,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18674996,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675012,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675028,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675044,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675059,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675074,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675091,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675107,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675124,
                        "kidsFreeTo": 0,
                        "name": "Single Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675141,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675158,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675175,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675192,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675210,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675228,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675247,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675265,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675283,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675301,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675318,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675335,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675351,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675367,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675383,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675400,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Family",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675417,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675435,
                        "kidsFreeTo": 0,
                        "name": "Family Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675453,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675472,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675488,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675503,
                        "kidsFreeTo": 0,
                        "name": "Family Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675518,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675531,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675545,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675558,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675571,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675584,
                        "kidsFreeTo": 0,
                        "name": "Double Room Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675596,
                        "kidsFreeTo": 0,
                        "name": "Superior Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675609,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675622,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675635,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675650,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675664,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675679,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed Extrabed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675694,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675708,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675721,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675734,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675747,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675761,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675775,
                        "kidsFreeTo": 0,
                        "name": "Double Twin 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675788,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675802,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675817,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675832,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675847,
                        "kidsFreeTo": 0,
                        "name": "Superior Family Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675862,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bañera accesible",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Barra de apoyo en la ducha",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Tamaño del televisor: 55",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953617,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2zABDqh-JAjF3Vddlf8ep-T8i1k=/720x480/02/20/88/02208882.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2zABDqh-JAjF3Vddlf8ep-T8i1k=/720x480/02/20/88/02208882.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Barra de apoyo en la ducha",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Tamaño del televisor: 55",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953618,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 2 camas dobles",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/T5QWUc2jHWT4RJBhahsFAwA_dUM=/720x480/02/20/88/02208881.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/T5QWUc2jHWT4RJBhahsFAwA_dUM=/720x480/02/20/88/02208881.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo completo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Rociadores",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4623674,
                        "kidsFreeTo": 12,
                        "name": "Estándar queen",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2zABDqh-JAjF3Vddlf8ep-T8i1k=/720x480/02/20/88/02208882.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2zABDqh-JAjF3Vddlf8ep-T8i1k=/720x480/02/20/88/02208882.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo completo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Rociadores",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4623675,
                        "kidsFreeTo": 12,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wgaKsSQpa723uRLxEIC-gRiNNAk=/720x480/00/15/15/00151565.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wgaKsSQpa723uRLxEIC-gRiNNAk=/720x480/00/15/15/00151565.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Queen y 1 Twin",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7897478,
                        "kidsFreeTo": 12,
                        "name": "Superior 1 queen, 1 twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8ahWZTbdNhdTqfgAveTZBYPdnHA=/720x480/04/58/74/04587448.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8ahWZTbdNhdTqfgAveTZBYPdnHA=/720x480/04/58/74/04587448.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10593671,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo completo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Rociadores",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 1 Queen",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11440637,
                        "kidsFreeTo": 12,
                        "name": "2gether queen + doble",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JhO58NKgI_JEWNqFSwbwvSoUBEM=/720x480/04/84/67/04846782.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JhO58NKgI_JEWNqFSwbwvSoUBEM=/720x480/04/84/67/04846782.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar"
                        ],
                        "bedding": "1 Cama Queen size de 150 a 154 de ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16062077,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Superior Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama Queen size de 150 a 154 de ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16062080,
                        "kidsFreeTo": 0,
                        "name": "Habitación Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16094806,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16094807,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516380,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516413,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516447,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516481,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516514,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516547,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516584,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516618,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516649,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516679,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516709,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516738,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516768,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516798,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516828,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516856,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516885,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516912,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516938,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516964,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516989,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517014,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517037,
                        "kidsFreeTo": 0,
                        "name": "Single Room Queen Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517061,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517085,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517109,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517132,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517155,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517180,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517205,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517230,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517253,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517276,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517299,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517322,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517344,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517366,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517388,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517409,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Family",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517431,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517452,
                        "kidsFreeTo": 0,
                        "name": "Family Queen Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517473,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517495,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517517,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517540,
                        "kidsFreeTo": 0,
                        "name": "Family Double Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517563,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517584,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517605,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517625,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517644,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517663,
                        "kidsFreeTo": 0,
                        "name": "Double Room Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517682,
                        "kidsFreeTo": 0,
                        "name": "Superior Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517701,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517719,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517738,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517757,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen Bed 1 Twin Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517777,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Queen Bed 1 Twin Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517797,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed Extrabed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517817,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Double Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517838,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517861,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517882,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517902,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517922,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517944,
                        "kidsFreeTo": 0,
                        "name": "Double Twin 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517967,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517989,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518012,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518035,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518058,
                        "kidsFreeTo": 0,
                        "name": "Superior Family Queen Bed Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18518081,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801536,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801538,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Animales de servicio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Máquina expendedora",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina exterior climatizada",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Sala de reuniones",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salida exprés",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Traslados al aeropuerto",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 593,
                    "valuesAverage": [
                        4.3,
                        4.2
                    ]
                },
                "title": "Hotel en la Zona Dorada cerca del parque acuático El Rollo",
                "uri": "one-acapulco-costera",
                "tags": [
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "We Hotel Acapulco se ubica sobre la Costera Miguel Alemán, a 100 metros de playa Hornos. El centro de la ciudad y el Museo Histórico de Acapulco Fuerte de San Diego están a 1 kilómetro de distancia, mientras que el Parque Papagayo se halla a 2 kilómetros. El Aeropuerto Internacional de Acapulco (ACA) se localiza a 24 kilómetros de distancia.\r\n\r\nEste hotel dispone de un bar lounge, piscina al aire libre, piscina para niños y camastros. También cuenta con estacionamiento sujeto a disponibilidad. Sus habitaciones están equipadas con TV con canales por cable, aire acondicionado, caja de seguridad y wifi. La suites adicionalmente tienen área de descanso.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/4c925947b509f0284606219e9f5028a31b049b6f3932624656bee47538d90560_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/bcda635385ec7be51a83b96ca5edfd83b9be23bacc4594a8fa4b9aac8595e7b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/82b9068ec025566353825d332ed5069f95d5cc1ae9a06e51d0dc3559df019dbb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/dd07a036763ac468307712d1eb466d93facee4cf96d04bbeb1bfe2e19fc49a92.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/b98045e863ae3d7a3c4568ec96f1ae2848f5d60baa7306dc5248cf5f4f6b3f9c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/321349/0c9c46da60cba6ac023482ddefd272a3216c50ca941388001027f2cbd58375cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/7e0ddaee1eb58b20169f45b322d31db804091d84c0dc97f7b098b4bd671f76b8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/d23c4577ea62566cf4b454bcb1e9a15c5e25383b3f5c4ec032e1751c70f2a136.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/26f262e92f3202b3f73821ce1f04a3bdb07fadd3ebceb6684ed0787328bde5c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/76b0b61fb0da1aa6aea27a30948da10c60b5e1931ddd676d786f7325d88a3ae6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/f7548d2582be957da71121d0cb859d67dd1612e9a614f5a4b77719042891b2e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/8586975a835f3df616aa668258f212240e4db7b9c79ce7a6438c9aa20f2dccac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/08b991dcc02b87cc706e246ac031ee3a14c5dadbe154e9a9a4eb82e566214108.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/144d34508cf8d940b758556054a10ce1e460c91b905164282e6c2f1edec2bcd3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/10b3431e14ea5630b7160ccb45f1716ac37f71bedb217fcb23624ec74b037dc6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/c351575560b0a4e918808db7f47a1e2eed48a031f894d9803aecc4d850579132.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/ef3eecfca026b9391c7ce16248288434fd7295fe3ac63b12856a05ad382e54e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/321349/64e4a3b7073ad77b1cf95a3418af732cba0e3a4dfd5110304f50a6410b51d020.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/321349/f017d311335421fb8e1361847209237380cf26ff99015717f8c3cbb1ed83badf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/3a390bfd4086d9c12abb444774eb8905daa55c06c8c0e17d1f9100d5ab46a87c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/7e84294e1c78c46cf83ff11e6da490ba3c13f4507322f10fc31398999ed9bf8c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/ad99eec8daf05d0898be1a7563d95b26c78e8046cb04274db767aef1bb8da350.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/a281ad05b78c33c39e263b79602c1498ee2776ffe6db5e40b414e12a82d9a28a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/c89c60f138bb4951fb4c7a76aea46c1b6f4cc896dfe779f70f7106b7024a534c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/0fa4ea8d5f2b8317123b12df1dcd66c61601267c2924d2559034fdc0953a0ff5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/08f6dc668d2264dff6df99fe92fd6ecdcfce61c0b62b27a9b84ea2318f79380c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/e6b4a5f034a30d80ccc4fb159caee1ac83f57added460a145e0fa2f0131ea216.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/38da6af8d0f7e31c77c044657d1b5aa6309039424bffdfa21fff0a3adb5fdd2c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/421eab5dd5732c4a3c279f798acce7f5c64cad93499492997447686b6f8ce97c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/06d26173cef7d19bd12f8f03b97fd0c7244be78e06467771d468400db3bbd307.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/c9c8f53b1d4df19aea7485e5cc8b078c60d1b0705adc211c4ecf0a5868445e0e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/c19d4b3314a805a379cf69430c6610aab317b94965b6b15b137b728b44098432.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/569ad6373aa6a6d0527b163f2558590384e52a79c929c4017b2b093f74b38cd9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/fd5358492f042718312e70f1cb37162a5e8fcb41fcc00b36192ce83c4d05c5d1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/3e24b16b70d1fbc308f8ce827e55486a52639df8da831d5e8e2e37cb79b3c9fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/5345d06414600375a952927bcf455310590a7b6b4297a33a6eb4e50c9af74e34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/1aed3fbe1eed45ee37f9527b3a946fc6193d588a2065cbfcaebb3899cf04d2a1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/7bf85fba311ab9cde290fdf50ff5b92f00930f587812647d54d650c297e7e536.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/4b76619cc12e4088d3b70c5de27a6aee8b2323c87a8346db916bdf3ca6cdbb29.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/f7ade6fe97ce65c1f0a1e85a60d723c8dae08570aa1e5dbf829e849b01996388.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/abad55c761263fdf1899f59d8cae8c5835e4a2425dbdbdd3bfd3d54ce2c7df9e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/cd5a0ecbae29f679a34a38c5a806d76f4648e8fe45cf4f0ca4c17d2482bf4987.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/a5bc772a20ecf2f0a93f63c4d8cd67d81045a934a9e9f84709051bb60a4c9e73.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/b665debd820a6bf8199e210f0342961ad85a4fc145693f8830dace0d7c794a91.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/321349/f683f987f84e75c9fa8ccdd153641827a375a047c6ade8f54adabfdc179b662b.png"
                    }
                ],
                "hotelID": 321349,
                "importantFacilities": [
                    "Estacionamiento",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.857217198240356",
                    "longitude": "-99.89367127416159",
                    "postalCode": "39355",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 248, Fracc Hornos",
                    "countryCode": "MX"
                },
                "name": "We Hotel Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Lounge Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5613344,
                        "kidsFreeTo": 0,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5613345,
                        "kidsFreeTo": 0,
                        "name": "Sencilla king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169620,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble (ADA)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169621,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble (Internal View)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169622,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble (with Window)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Balcón",
                            "Balcón o patio",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169623,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169624,
                        "kidsFreeTo": 0,
                        "name": "Habitación (King, Pool)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169625,
                        "kidsFreeTo": 0,
                        "name": "Habitación (king with Window)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169626,
                        "kidsFreeTo": 0,
                        "name": "Habitación (King Costera)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169627,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099629,
                        "kidsFreeTo": 0,
                        "name": "King con ventana vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099641,
                        "kidsFreeTo": 0,
                        "name": "King matrimonial con ventana vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189365,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189366,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189367,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189368,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189369,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189370,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189371,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189372,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189373,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189374,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189375,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189376,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189377,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189378,
                        "kidsFreeTo": 0,
                        "name": "Habitación Accesible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189379,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189380,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189381,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189382,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189383,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Los niños comparten la cama con sus padres",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20189384,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099627,
                        "kidsFreeTo": 0,
                        "name": "Suite king matrimonial con ventana",
                        "isActive": true,
                        "view": "Costa",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099626,
                        "kidsFreeTo": 0,
                        "name": "King matrimonial vista a la costera",
                        "isActive": true,
                        "view": "Costa",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099622,
                        "kidsFreeTo": 0,
                        "name": "2 matrimoniales con ventana",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "3 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099621,
                        "kidsFreeTo": 0,
                        "name": "Triple matrimoniales con balcón vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099620,
                        "kidsFreeTo": 0,
                        "name": "2 matrimoniales con balcón vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099619,
                        "kidsFreeTo": 0,
                        "name": "2 matrimoniales con balcón vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099618,
                        "kidsFreeTo": 0,
                        "name": "2 matrimoniales sin balcón y sin ventana",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17099607,
                        "kidsFreeTo": 0,
                        "name": "King con salida a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6bhTaSXlwrtA2DwYvpXZbMc2--c=/720x480/06/05/00/06050057.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Balcón",
                            "Balcón o patio",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169619,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble, balcón, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet alta velocidad",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10169618,
                        "kidsFreeTo": 0,
                        "name": "Suite junior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EIKAxtU1XYVGleUPqlhCljDAVE4=/720x480/05/11/25/05112548.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Llamadas locales gratis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina exterior",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 4.2,
                    "totalSurveys": 129,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel sobre la Costera Miguel Alemán a 100 metros de playa Hornos",
                "uri": "we-hotel-acapulco",
                "tags": [],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Hotel Nilo es un hotel con un diseño moderno en Acapulco, a solo 1 cuadra de la Costera Miguel Alemán. A 1 kilómetro puedes ir a la playa Icacos, a 2 kilómetros se encuentra el Centro de Convenciones de Acapulco, a 7 kilómetros está el Fuerte de San Diego y a 8 kilómetros la Catedral de Acapulco. Asimismo, el Aeropuerto Internacional de Acapulco (ACA) está a 18 kilómetros de distancia.\r\n\r\nEste hotel en Acapulco cuenta con 36 habitaciones con aire acondicionado, área de descanso, baño privado con regadera, mesa de trabajo, televisión con canales por cable o satélite y acceso a internet inalámbrico. Algunas habitaciones del Hotel Nilo cuentan con balcón o terraza.\r\n\r\nEl Hotel Nilo tiene una alberca en la terraza que ofrece una hermosa vista del puerto de Acapulco. Además, este hotel en Acapulco brinda acceso a internet inalámbrico, llamadas locales gratis y salida exprés.  **Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/501e1fb52d47200c99366096f2a1aa22997727008c5d402ebd23ff66a3eaf313_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/e96386d512e914deb6a650bc40c83de6ce46cd0638be785eeec9d73b805c516e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/211585/d3002a2ea56136aa94a98945cdef2d3b8c914855bd5f2e35937962a5058e5df1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/5bf8030051a64e5f9a8abc673c8cbd98b2b115b824cf6644a29f739bae4ff2ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/2f06162d7d81a7b2b5d16169561106849385bf2e5cf23508c3f765ab74cbb046.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/4cbd35e3152b8388a04d2b814b1af18843367d434d8012212215547db555b15f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/211585/89e6b6cdfcffc28a8e9ab1368d8a36fc1e3087650f7a11951dab358e0bef79c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/211585/f82483fdaab73c4c9ec001543cd05da234ad022abe01bfa9e42db148d9f8f2be.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/43811f1a424766648059acababaca409bfb473319b2d5785eb4d56ec92d801c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/211585/8800577abb373c089e74d5e48f00e9312bb31b3c929eab2440c20d889a05ee22.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/b48fda5ec7b32e850911865781def36520c83eac29743a4f5702737fb4932894.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/eff794cbac90345ecaff4fef8d83ac20043536bf264ad985d733595cf5f07396.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/211585/6d7e74271bdede226bca7e06dfb50b8a69b724f0fca3f198d9bce1b9570adf50.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/e370e1dd5630969386210ba8dd00067b8d8a9144ee83e0bb06b44d93fb82c229.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/6e08127b04cb98ccbe390d3908ea18b7e39780648017fcdd9c42179c78bd79d6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/f25ee1a209d4d3aa92bc5707701c9b45d5d9ea9b0b263060fbb966b6c4684136.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/d692b51472eb2bd8b8749b5c2bc004c8a5b62e9f05a43fdc64a19d2f38ced603.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Cuádruple Superior",
                        "cloudUri": "https://img.cdnpth.com/media/211585/4de8b5229ef3d888e71137b007ca615af3b15bc41c64a73920149b2877aa3bbd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Cuádruple Superior",
                        "cloudUri": "https://img.cdnpth.com/media/211585/014644754d3fdd1c6e70503c3374f194710aede1cd806a5d18a1e8040d5d1183.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/88407c60f8c85fd90af4ccbfd206e5dea42693c7db14ebd9d424b66f6a0bdad5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/427a2a4ce740ec9fbee68aaa2043d98d30bc371d1aed5a1931612ad9cb69012e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/5cad0ed31205a2f839ea697eebb9cd4730abcbaf7370dc0c640c40ff1a98b4f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/433b38b863ae78cd098cda769047ff80747b95292ad9b70ef02d9514b743d537.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/d3df0952c17d7990a30d6401fadd6258f95debb1b15d4319d13268c3994c0897.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Cuádruple Superior",
                        "cloudUri": "https://img.cdnpth.com/media/211585/71117b56f21c5c9ae38eef04d2b07e1f9970a58e4fc40b0563905248d7819fe2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/211585/8e72790f256e87a4b13781ad3610e6f58560cb253238c086a48a181081e354a1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/6fcc59501fcc62b904a26eafbf98e8aced49182a37b1e57880125ebe5c2689d0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/5052c6b28ef37f9aeb3d51032ab0558644c6f0ffc62cbaa0d68b0735c5420256.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Cuádruple Superior",
                        "cloudUri": "https://img.cdnpth.com/media/211585/9c329b2a67806db5575f35242dd9899f2c8e50dcbf434a58b9526d6a4e853791.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/211585/bc7d00e86eb37a2a9307d6803d5ab84f0210112397cf0aa68fd8e9dfc20d9858.png"
                    }
                ],
                "hotelID": 211585,
                "importantFacilities": [
                    "Llamadas locales gratis"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.843413743074674",
                    "longitude": "-99.84773386836184",
                    "postalCode": "39860",
                    "state": "Guerrero",
                    "street": "Calle 4 #105 esq Ortiz Monasterio, Col Icacos",
                    "countryCode": "MX"
                },
                "name": "Hotel Nilo",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085935,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 16085936,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 18731796,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 18731802,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 18745426,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite",
                            "Ventanas insonorizadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 2303339,
                        "kidsFreeTo": 0,
                        "name": "Sencilla",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/HOCW2_EFoNHrfjOM35AIMYF8T_k=/720x480/01/80/28/01802829.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/HOCW2_EFoNHrfjOM35AIMYF8T_k=/720x480/01/80/28/01802829.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 2303340,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/X-r9D8N41V8ZV935HcfZhAxJVbk=/720x480/13/24/88/13248848.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/X-r9D8N41V8ZV935HcfZhAxJVbk=/720x480/13/24/88/13248848.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama no disponible",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi (gratis)"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 3954785,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/HOCW2_EFoNHrfjOM35AIMYF8T_k=/720x480/01/80/28/01802829.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/HOCW2_EFoNHrfjOM35AIMYF8T_k=/720x480/01/80/28/01802829.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama no disponible",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi (gratis)"
                        ],
                        "bedding": "2 camas dobles",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 3954786,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/9QECd1DFKLC_5066QJw8e4BPuDQ=/720x480/01/80/28/01802827.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/9QECd1DFKLC_5066QJw8e4BPuDQ=/720x480/01/80/28/01802827.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama no disponible",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi (gratis)"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 4543497,
                        "kidsFreeTo": 0,
                        "name": "Suite exclusiva, microondas, vistas a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama no disponible",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi (gratis)"
                        ],
                        "bedding": "2 camas dobles y 1 futón doble",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 7055037,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "Escritorio",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 9418430,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "Escritorio",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 9418431,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Cortinas opacas",
                            "Escritorio",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Microondas",
                            "Nevera",
                            "No fumadores",
                            "Placa de cocina",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 9418432,
                        "kidsFreeTo": 0,
                        "name": "Habitación de lujo doble, microondas, vistas a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Cortinas opacas",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión LCD",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 5,
                        "checkInTime": "8:00",
                        "checkOutTime": "12:00",
                        "roomID": 9418433,
                        "kidsFreeTo": 0,
                        "name": "Habitación doble superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Llamadas locales gratis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salida exprés",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 4.3,
                    "totalSurveys": 215,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel con alberca en Acapulco a 1 cuadra de la Costera Miguel Alemán",
                "uri": "hotel-nilo",
                "tags": [
                    {
                        "name": "Familiar"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno americano, almuerzo y cena a la carta (sopa, plato fuerte a escoger, postre). Barra libre de bebidas de la casa de 10:00 a 22:00 hrs."
                    }
                ],
                "description": "Hotel Club del Sol Acapulco by NG Hoteles se localiza en la Zona Dorada, cerca de los principales centros comerciales, cines, bares y discotecas de la zona hotelera de Acapulco. El hotel se sitúa sobre la Costera Miguel Alemán, a sólo 250 metros de la playa y a 4 kilómetros del Zócalo y el centro de la ciudad. Adicionalmente, el Aeropuerto Internacional de Acapulco (ACA) se ubica a 25 kilómetros del hotel. \r\n\r\nEl hotel ofrece 240 habitaciones distribuidas en tres categorías en cuatro edificios de siete pisos. Las habitaciones están equipadas con aire acondicionado, televisión por cable, caja de seguridad, teléfono de marcado directo y baño privado con ducha.\r\n\r\nEntre las instalaciones destacan dos piscinas, piscina para niños, y una terraza lounge en el séptimo piso exclusiva para parejas y mayores de 18 años con dos piscinas pequeña, camas, tumbonas, música y servicio de bar. Asimismo, el hotel cuenta con salones y espacio para celebrar cualquier tipo de evento. Para tu comodidad, el hotel ofrece un restaurante, un lobby bar con música en vivo los fines de semana e internet inalámbrico en el lobby.\r\n\r\n***Al momento del registro el hotel solicitará una tarjeta de crédito para cubrir cargos en alimentos y bebidas en cualquier parte del hotel, ofreciendo un descuento especial de 10% o un depósito de $300 MXN en efectivo, que se reembolsará siempre y cuando la habitación, las toallas y el control de la televisión no sufran daños. Este depósito es por habitación, por estancia.  **Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/ac0016f04085e117f1fbb99fed391dd571b667a80082054809ac03d6b614b32d_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/de802092fc8596002cec9131b107d197920adae2e55e18b1fffc223528fa16e4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/76d703408133d215a6b8f1dc3c5d53b2b6f9d673adb11cd1c7177532991bfa8b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/e17f533f0e19affbd97dbdae7d7b151150b292758e6c28d2e85e406face7c98b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/210c6234545a9508a2070fe4d052aebda1fb3d85e3f545e48adda7ff120288cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/1fa035c9a7ac57f33815327066ab8a063debc038731f772ee394c2a3e22f5c1a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/f5a41a518f7c55a1492746967efe3a55ec551a16530f32d1372a33dcd710d670.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/34984553cac6f7500914a6ddf3a16f6fcb2435953db45dac8c62a25aa238157d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/30bb6a7eae6eb4880b8f201cb1186766e4cc5ce44d944bd70284415eab27908c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/12ff04420ccec88fe3f004cfb2cfda9003036274660162e22fd38fa8c85db7c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/bffde870a53e657f1a79e72640df1e6ab4cbdedca3bf7d12a825fe65a04c20cb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/a9dea18c815e44c636f46a46ba12d01cc2e43f7a3ef1ed4d4fbc15f501c6d7ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100139/6002b35c6cdefa245477c9f73a4635f8b80a97887467e8a71d8ffc0221fb5fc0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/a3c8f9a14705c6ef36191bffcaa08a3c9c399c7723d8a359f39cc9174a9e310b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/de2e1c65d71b3003f2aa8c4cf688055a9d5f164f05ebd7984e94cf5b31b8de2e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/131e33526ea865f1b39dff1aef25dfa83c6841754eb37ba77127b8e0aece1847.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/55133257c777eecf9fcfca3a1214c7ad4d77a4b07c1b175e4f7c357eee5d459e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/704d1ec114dce37df879e7697465c86f6d0573e169d5c92f27b99c3435bdd45f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/3826b3558825828a7081927aafea07797ba15652de6149059d68856031d94623.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/09450c0a16588b8fdb0f158d6a334c47e857290a182f9e6558da0889baff16b8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/2666d6b6ab7fbce4ba47c8bdde97624d58577bc734ea73ee2130427d187a27a1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/76a8cbc2580754b67d535b5bdf448c08527a2f72bb30f50a2a9e4d6355335390.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/8595ef8881dfb792893013f0cb0fc786cce3e1e22fca1cd140ff4cee0b3f718a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/86e0b86eceeed5f36bdc6bebf83cb23124a0f6e55277699b5d81e88847d22bb9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/994f0c58b9b8bcb3ffa71c140233848fa5c1d4b59625eae9e84b8083de871dde.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/d58775a922f821e1501325cbb5e6e925fe32b4b35057920b29536616508aa82d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/bb915e393a128a316bf09ac06a2bdcc3dec455017bca057f47a44e7416171da5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/b66b06a7500768ff482a41483e9b3ed8aa458c3e185a8d374a24cbb7c411f258.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/41e12d2e4ce29eb541409621b79dd7017de6f7eccf5e70d3a694ab6fc9af1545.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/f1505418690dbf1da68fb48dfaeef2cae46181cd05badee821647581d69e89e5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/7ebbc936d33470044513ad2e7e908258f33b4391d5ea4784973330728351d3f7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/b6bd4758904c3d032ade5af13cdb22cb3381f38a39786e7160b100af97cef52e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/937d28a099f1cf1e342ff8db8aea301534bc69f4a917c46fbe6233b67f9f6c6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/7573168ecaa1f54af9585529b2d80c7ce5a5d44aeb173f2154d7cf3dafbf616c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/2ab75b42f98e8d0f1f486221e47b523381dc245922604ddf3a421b7b1427f398.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/c2666b9979d3b609d9544fd34bcf43cbfb595efcfa47510eb0a9102a2ec2c496.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/4fea5558449f0389ceac1991db66ff00d4540f8b59e05ddcb5b23ba6a5dc7d9c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/cb9ee75f5ce7592575d6e16beacb664ea57af51ce625545f612956cb6f01cc4c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/ba04f1c55dce9565d9b9914467fb870867e97b8d00f1d127e16ca259310fd57b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/0657e67e23b4c664117705d0ad14e9056469ce3f440c04c8d4f693fe67795135.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/b4e94760c00cb3d710cb9123e537715aebca85373fbfb72b356af6def7114d23.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/ccf97f39469d2c0b7a170c30cb3146c04371f521a4857cc682dd206ce73e6397.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/bdf22e7cf3786afa037c0d37e44c80e926c8fd564ec86680672d17a944d21fe2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/3cd72c24a103dfca1eb6512b49c631b6a9c54e3680a6b611a2861bc23e17db7a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100139/450177066678089db66982bf785c51db8d11987f70710a55835d9b93b68127e4.png"
                    }
                ],
                "hotelID": 100139,
                "importantFacilities": [
                    "Estacionamiento"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.861827394171083",
                    "longitude": "-99.87777650356293",
                    "postalCode": "39670",
                    "state": "Guerrero",
                    "street": "Costera Miguel Alemán 1750, Fraccionamiento Magallanes",
                    "countryCode": "MX"
                },
                "name": "Hotel Club del Sol Acapulco by NG Hoteles",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Cafetería Arrecife",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby bar",
                        "type": "Lobby Bar"
                    },
                    {
                        "name": "Pelicanos",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Terraza Bar (con reservación, parejas, +18 años)",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8410678,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11625153,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077566,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077569,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077570,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077571,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077572,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077573,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077574,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16077575,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213225,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213226,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213227,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213228,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585028,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585050,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585075,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585099,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585122,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585143,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585164,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585187,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585209,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585232,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585257,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585281,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585302,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585322,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585343,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585364,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585388,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585411,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585433,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585454,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585476,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585496,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585517,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585537,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585559,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585585,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585609,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585634,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585659,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585685,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585709,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585732,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585755,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585778,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585801,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585824,
                        "kidsFreeTo": 0,
                        "name": "Superior Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585848,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585871,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585893,
                        "kidsFreeTo": 0,
                        "name": "Economic For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585915,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585939,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585961,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585983,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586007,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586031,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586055,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586080,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586102,
                        "kidsFreeTo": 0,
                        "name": "With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586128,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586151,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586174,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586197,
                        "kidsFreeTo": 0,
                        "name": "Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586220,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586243,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586264,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586287,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586308,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586329,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586349,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586369,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586390,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586411,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586433,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586453,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586474,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586496,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586518,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586539,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586561,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586583,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586604,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586624,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586643,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586663,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586686,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586710,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586731,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586753,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586779,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586803,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586827,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586851,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586874,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624393,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624404,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624414,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624425,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624436,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624448,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624459,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624470,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624482,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624493,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624506,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624517,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624528,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624538,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624547,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624558,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624568,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624578,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624587,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624596,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624606,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624615,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624623,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624631,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624640,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624649,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624658,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624667,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624676,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624686,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624695,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624704,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624713,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624722,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624731,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624739,
                        "kidsFreeTo": 0,
                        "name": "Superior Economic",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624748,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624756,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624764,
                        "kidsFreeTo": 0,
                        "name": "Economic For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624772,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624780,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624787,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624795,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624803,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624810,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624817,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624825,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624833,
                        "kidsFreeTo": 0,
                        "name": "With View Water View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624841,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624851,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624859,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624866,
                        "kidsFreeTo": 0,
                        "name": "Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624872,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Double Twin Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624880,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624887,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624894,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624900,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624908,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624915,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624921,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624927,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624933,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624940,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624948,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624955,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624964,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624973,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624980,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624986,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624992,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18624999,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625007,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625016,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625024,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la laguna",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625033,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625041,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625049,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625056,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625063,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625070,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625077,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625084,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625091,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18625099,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675808,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675823,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675837,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675852,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675867,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675881,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675895,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675909,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675923,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675937,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675950,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675963,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675976,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18675990,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676004,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676017,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676030,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676042,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676054,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676066,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676077,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676088,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676099,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676111,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676122,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676133,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676144,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676156,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676168,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676180,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676191,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676201,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676211,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676223,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18676234,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001033,
                        "kidsFreeTo": 3,
                        "name": "Superior Arrecife",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Wsrq2BLcJg0V7cWitCTJd-nbpKI=/720x480/04/80/96/04809632.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Wsrq2BLcJg0V7cWitCTJd-nbpKI=/720x480/04/80/96/04809632.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1005519,
                        "kidsFreeTo": 3,
                        "name": "Estándar Arrecife",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Mesa de trabajo",
                            "Teléfono",
                            "TV LCD",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1021615,
                        "kidsFreeTo": 3,
                        "name": "Torre Delfines",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fXVGDZ5zMILBhVCTiKWfosj6sxU=/720x480/03/34/99/03349979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fXVGDZ5zMILBhVCTiKWfosj6sxU=/720x480/03/34/99/03349979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Ventilador portátil"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4945132,
                        "kidsFreeTo": 0,
                        "name": "Habitación económica, 2 camas dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Ventilador portátil"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4945133,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 2 camas dobles, balcón",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5133986,
                        "kidsFreeTo": 3,
                        "name": "ECONÓMICA - Súper saver",
                        "isActive": true,
                        "view": "Interior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8692376,
                        "kidsFreeTo": 3,
                        "name": "Estándar - super saver",
                        "isActive": true,
                        "view": "Calle o Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n1-jZteF-jqvx9qG8fTGVTPCfwo=/720x480/04/80/96/04809633.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9353313,
                        "kidsFreeTo": 3,
                        "name": "Superior - super saver",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Wsrq2BLcJg0V7cWitCTJd-nbpKI=/720x480/04/80/96/04809632.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Wsrq2BLcJg0V7cWitCTJd-nbpKI=/720x480/04/80/96/04809632.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Ventilador portátil"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16148136,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas dobles, balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213229,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213230,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213231,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213232,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213233,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213234,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213235,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213236,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213237,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213238,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213239,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213240,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213241,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213242,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213243,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213244,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213245,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213246,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213247,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213248,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213249,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213250,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213251,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213252,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213253,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213254,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213255,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213256,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213257,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213258,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213259,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213260,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213261,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213262,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213273,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213275,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213277,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213279,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213281,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213283,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213285,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213286,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213287,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213289,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213290,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213291,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213292,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213293,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213294,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213295,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213296,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213297,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213298,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213300,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213301,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213303,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213304,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213306,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213307,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213308,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213309,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213310,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213311,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213312,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213314,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213315,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213316,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213317,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213318,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213319,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213320,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213321,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213322,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213323,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213324,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213325,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213326,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213327,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213328,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213329,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213330,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213331,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213332,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213333,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583259,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583281,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583304,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583323,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583342,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583361,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583379,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583400,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583420,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583437,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583453,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583470,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583494,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583513,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583531,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583550,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583566,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583583,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583599,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583615,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583632,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583650,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583667,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583687,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583709,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583726,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583742,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583758,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583773,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583791,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583810,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583831,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583850,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583867,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583886,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583906,
                        "kidsFreeTo": 0,
                        "name": "Superior Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583924,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583941,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583960,
                        "kidsFreeTo": 0,
                        "name": "Economic For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583978,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18583998,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584019,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584040,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584064,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584087,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584109,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584133,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584156,
                        "kidsFreeTo": 0,
                        "name": "With View Water View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584179,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584203,
                        "kidsFreeTo": 0,
                        "name": "Double Room Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584227,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584251,
                        "kidsFreeTo": 0,
                        "name": "Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584278,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Room Double Twin Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584302,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584328,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584355,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Twin Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584382,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584408,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584434,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584461,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584485,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584508,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584533,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584559,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584583,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584608,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584631,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584656,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584679,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584702,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584726,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584749,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584774,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584799,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584823,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584847,
                        "kidsFreeTo": 0,
                        "name": "Economic 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584871,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Quadruple Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584892,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584911,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 2 Double Beds With Balcony For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584931,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584953,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 1 Bed 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18584977,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room 2 Double Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585001,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Pool View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18623930,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "4 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 2.9,
                    "totalSurveys": 438,
                    "valuesAverage": [
                        4,
                        4.3,
                        3.8
                    ]
                },
                "title": "Hotel con amplias habitaciones en la Zona Hotelera de Acapulco",
                "uri": "hotel-club-del-sol-acapulco-by-ng-hoteles",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Amigos & parejas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "El hotel ofrece plan semi todo incluido que incluye: desayuno bufet o a la carta de 07:00 a 12:00 hrs, comida bufet o a la carta de 14:00 a 17:00 y cena a la carta de 18:00 a 22:30 hrs en el restaurante Bahía. También incluye hamburguesas, hot dogs, nachos y papas a la francesa en el Snack Bar, y bebidas nacionales e internacionales."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Restricciones",
                        "description": "No incluye servicio de alimentos a la habitación, ni platos de cortes finos. Algunos servicios pueden generar cargos adicionales."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    }
                ],
                "description": "Hotel Amares Acapulco goza de una ubicación privilegiada en plena Zona Dorada, sobre la tradicional costera, y se encuentra a pasos de bares, restaurantes, puntos de entretenimiento y cultura que distinguen a este legendario destino turístico. El esplendor de los años dorados de Acapulco renace en este hotel con 359 habitaciones, donde la nostalgia por el pasado se fusiona con la modernidad, en un homenaje al glamour y al encanto de un puerto que brilla con resplandor propio.\r\n\r\nSu representativa torre circular comprende sorprendentes y confortables espacios, y ofrece impresionantes vistas panorámicas del océano Pacífico y la ciudad con sus montañas. También invita a disfrutar de su extraordinario ambiente en la piscina frente al mar, en la playa y en el solárium, y deleitarse con los sabores de sus restaurantes y bares con la mejor vista a la bahía.\r\n\r\nEste hotel semi todo incluido en Acapulco, se localiza frente a la playa, El Club de Golf Acapulco está a menos de 500 metros y el Centro de Convenciones se ubica a 1.5 kilómetros. Adicionalmente, el Aeropuerto Internacional de Acapulco (ACA) está a 20 kilómetros del hotel. \r\n\r\n***Amares es un hotel totalmente nuevo en Acapulco y el primero en blindar todas sus ventanas y canceles con vidrios y estructuras que cumplen rigurosos estándares internacionales de resistencia a huracanes; brindando más seguridad a los huéspedes y reduciendo el riesgo en caso de huracán.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/c30d98f9f89c876ebd6a10140168ca33fd51796be1c760c618191bfd0e53d09f_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/d919bd237d65305f530df0e75e4dc982fee504f759fe07d6d53032033443e549.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/d617af3fb4537dc0249f6e5e84d4ce9f1fdcd74d56b003283ddd450fab61f8c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/0aae185ea05cf7b950cbe6a9c6e3490bcaca871148d34fc03d215b1e73609657.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/e4b539eb92bbc0f4699054560992943b9f85e3d111b503f1615a9278e34bae17.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/a46596200e312bf34707896c3ce0dba762415f1087da4fe1f61f11e4205faf13.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/0ed2d4ccf6c03fb64b4320d4b5daff515873a25178a2c8652eca0357a0233114.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/f93e4b5935be1958461b2453dcda5870ee8ecda10b5b8b1d1703d83997351d91.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Superior King Room Sea view",
                        "cloudUri": "https://img.cdnpth.com/media/100101/664612ded12930c1ac7aa874901a915c51ba9a32d37cec1188b05c82655676b7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/bece27d623fbb21104a722c88189e70f0874a391123fc3e59350132696b75a01.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/bf448db5704a02244a06a184d597f0c5d8215e61c69f7d870393949b56f428f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/9d7005b1dd0cd639dfa19a1eabb1b286114710843a81634e8c43864383bbd925.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/3428dd6b4990b18b2bbed789dd0cac2524d86bb62175553e0222f89e4e096848.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/26d3d2561d63bccee6cab3c4a1ce9948fbc64f2eb4fd63d3a9404f6f60590f17.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/5fe01d3c2cffe9479abd20e8a9a68968ffd7a6f1d95b20ade0ac6658e56799bf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Confort Standard Room with Mountain View",
                        "cloudUri": "https://img.cdnpth.com/media/100101/e0b45ca2bb323121cdebf4996679b82300e805ebc46251d0abeccffb1e0eacd0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/dfe73d380ef4db107eb5bf28066f086b8cc832bcca62ad088e0a799202549adf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Confort Standard Room with Sea View",
                        "cloudUri": "https://img.cdnpth.com/media/100101/0ffd53ff62378297d809c8f44eda4879ba0f6351312300ba4ec5fb5a21f8a58a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/f1224e6b4e6d8284ebc9c0b4c75f6cd844786ef4c260d576d3071acebb9ac0b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/efc61ff6c5e12a03792364da445903da1e9976c4f2e33b5a228f3d977deb47db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/b1c30b84f16f0d754f0c683f8645de3e611edadbc244eee334ccc4ed55b44015.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/51a0e1a636b33e76e4fc0b06de644be5a54318c98cadc1f9ccafd3ad634e3b31.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/c6a707d41dbab84baef12da611daedc4717add23fed8bdb69fc5e781ca42e66d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/5cb1bb1f77470bb8fdab949d63f15cd2c275bdfb523eaaf6e01cfbf0849a71e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/ffac7bcf8dc66d28da81e44afac09e784472b56a84fa521ea685e14a73cd1407.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/cd3a6fdd83f25e752f35b7ed4b8304272ae82125535883c63bfd5f365b28f366.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100101/bef9925a092428e115c14311d3b66a315929e5485e083279207d200ffae4f080.png"
                    }
                ],
                "hotelID": 100101,
                "importantFacilities": [
                    "Estacionamiento"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.855466526480733",
                    "longitude": "-99.86101269721985",
                    "postalCode": "39690",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 1260, Fracc Club Deportivo",
                    "countryCode": "MX"
                },
                "name": "Hotel Amares Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Bahía Revolcadero de Antojos",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Snack Bar Bahía",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264402,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264403,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264404,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264405,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264406,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264407,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264408,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264409,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264411,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264415,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264417,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264419,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264422,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264424,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264426,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264428,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264430,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264432,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264434,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264436,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264438,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264439,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264442,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264444,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264445,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264447,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264450,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264452,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264454,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264456,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264458,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264460,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264462,
                        "kidsFreeTo": 0,
                        "name": "Presidential Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264464,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264466,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264470,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264472,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264474,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/d1l1T94cgBKKXarOUBglsJ1pmz4=/720x480/05/10/26/05102652.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264476,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264478,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264480,
                        "kidsFreeTo": 0,
                        "name": "Double Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264482,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264484,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264486,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SF6zcLp6VteVQcXXIiOro_SN19s=/720x480/05/10/26/05102654.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264488,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264491,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264493,
                        "kidsFreeTo": 0,
                        "name": "Single Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XQOxOEdTYLB5aaYE9FOFTfQPKhE=/720x480/05/10/26/05102655.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XQOxOEdTYLB5aaYE9FOFTfQPKhE=/720x480/05/10/26/05102655.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264494,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 14264496,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 1000923,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista a la montaña",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 1000924,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 3416903,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista a la montaña - no reembolsable",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Conexión telefónica a Internet (de pago)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No hay cunas",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Rainfall showerhead",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Shower only",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Toallas",
                            "Towels provided",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 3952281,
                        "kidsFreeTo": 0,
                        "name": "Confort Double Mountain View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Conexión telefónica a Internet (de pago)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No hay cunas",
                            "Number of beds - 1",
                            "Phone",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Rainfall showerhead",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Shower only",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 3952282,
                        "kidsFreeTo": 0,
                        "name": "Confort Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 4996248,
                        "kidsFreeTo": 3,
                        "name": "Estándar king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ymk_EjVrJf4iXTtQLplkwYAYPTo=/720x480/03/14/00/03140037.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ymk_EjVrJf4iXTtQLplkwYAYPTo=/720x480/03/14/00/03140037.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 5645383,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista parcial",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 1",
                            "Phone",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Rainfall showerhead",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Shower only",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 5664507,
                        "kidsFreeTo": 0,
                        "name": "Confort Double Partial Ocean View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 6862404,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista parcial - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 7821290,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 7960256,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 8350768,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/94F4eJzTuX2bEYkr6V1o9uADd98=/720x480/12/89/76/12897627.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 11496059,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198490,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198491,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198492,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198495,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198496,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198497,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198498,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198499,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidencial",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198502,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198509,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198513,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198517,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0T0e6bec5nAnwPprNX-yfH9A35o=/720x480/12/83/99/12839932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198522,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198527,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198531,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XQOxOEdTYLB5aaYE9FOFTfQPKhE=/720x480/05/10/26/05102655.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XQOxOEdTYLB5aaYE9FOFTfQPKhE=/720x480/05/10/26/05102655.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16198536,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16377489,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 16818536,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061001,
                        "kidsFreeTo": 0,
                        "name": "Triple Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061002,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061003,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061004,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061005,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061006,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061007,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17061008,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17201158,
                        "kidsFreeTo": 3,
                        "name": "Confort doble vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Plancha a solicitud",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17201159,
                        "kidsFreeTo": 3,
                        "name": "Superior king vista mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206867,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite King Partial Ocean View",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/I0hVaatEaPHPU3eXAe3OThxnvW4=/720x480/12/89/76/12897688.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/I0hVaatEaPHPU3eXAe3OThxnvW4=/720x480/12/89/76/12897688.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206868,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Q_MQroUUD2ewzamrPShFwaBS9GM=/720x480/12/89/76/12897689.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Q_MQroUUD2ewzamrPShFwaBS9GM=/720x480/12/89/76/12897689.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206869,
                        "kidsFreeTo": 0,
                        "name": "Superior King Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206870,
                        "kidsFreeTo": 0,
                        "name": "Confort King Mountain View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206871,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite King Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/o7FFe7eHikHHbz-KLJ8xak58LI8=/720x480/12/89/76/12897691.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/o7FFe7eHikHHbz-KLJ8xak58LI8=/720x480/12/89/76/12897691.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Conexión telefónica a Internet",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206872,
                        "kidsFreeTo": 0,
                        "name": "Confort King Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206873,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206874,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206875,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206876,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206877,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/D5p6dTNhmB_WxW9FPXbC21ph_yo=/720x480/12/83/99/12839933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206878,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17206880,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fhWmtU1PWvWHNB7NgWvJ581aarw=/720x480/12/89/76/12897624.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17947269,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar Capacidad 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17947270,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17947271,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OQfg1B6Dqb-SBGiPimh-NuqBuaY=/720x480/12/89/76/12897626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 17947272,
                        "kidsFreeTo": 0,
                        "name": "Triple Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18740410,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18740412,
                        "kidsFreeTo": 0,
                        "name": "Doble Comfort",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gvhPHUyggLvrYpRP9uxtHS5CumA=/720x480/12/89/76/12897625.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18756097,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/m_wwOosvZyYUEabex7MepbEGctk=/720x480/12/89/76/12897684.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18805821,
                        "kidsFreeTo": 0,
                        "name": "Doble Comfort Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18805822,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18818712,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18870475,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18870476,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18890898,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 18890901,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Parciales Al Mar Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318663,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318664,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318665,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318666,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318668,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Ironing set",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318897,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Comfort",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Ironing set",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "13:00",
                        "roomID": 19318900,
                        "kidsFreeTo": 0,
                        "name": "Individual Comfort",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 5,
                "surveyAverage": null,
                "title": "Hotel frente a la playa con arquitectura original en la Zona Dorada",
                "uri": "hotel-calinda-beach-acapulco",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Ubicación del establecimientoHoliday Inn Acapulco La Isla, an IHG Hotel está en una fantástica zona de Acapulco (La Poza), a menos de cinco minutos en coche de Forum de Mundo Imperial y Centro Comercial La Isla. Además, este hotel para familias se encuentra a 16,2\u00A0km de Parque Papagayo y a 20,1\u00A0km de Acantilado La Quebrada. HabitacionesTe sentirás como en tu propia casa en cualquiera de las 101 habitaciones con aire acondicionado. Descansa como nunca en una cama con edredón de plumas y ropa de cama de alta calidad. La conexión a Internet wifi gratis te mantendrá en contacto con los tuyos; también podrás ver tu programa favorito en el televisor con canales por cable. El baño privado con ducha está provisto de artículos de higiene personal gratuitos y secadores de pelo. Servicios de negocios y otrosTendrás un centro de negocios, check-out exprés y tintorería a tu disposición. ¿Estás organizando un evento en Acapulco? En este hotel tienes a tu disposición 0 metros cuadrados de espacio con centro de conferencias. Hay un aparcamiento con asistencia gratuito disponible. \r\nLa edad mínima para realizar el check-in es de 18 años",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/5db0c7ae00ce295361259f22733a24968f2959cb1629ccdaf1056a9b1d15208b_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/ccda7df1bb311b55ff6ef854c5bacadd7ed1932dc072174aad61814504a07e63.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/9809a607e406824ae4257db378517e08c2dbe9b5bd38f073636f3dac21da43e9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/238072/a0b11b2bae9e0597498dd21200dbf6b31315059227f9c035eac56c6705b9b48e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/f5f02470c1a3105459dc7ec484d56a24bb8cf8a0b655ff67d0d9f47aac020d37.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - Cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/238072/510ce357768543a75658f40fe6038e75680ed50aca43da36098d1927ec7ffead.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/119f63e47e8761a5f6fe6ca876656668b74cc7a1344165edfd3f0ef6656fe937.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/238072/5033ff74e4015b622feb6447b0b9ee91f787ce70c6bea0e11cadaff3d3d6fb63.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/238072/843afc55c6a78d96c0a999527ff3828079ca1b410ef232c355b8df41e104a30e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Estándar - 2 camas grandes - Admite animales",
                        "cloudUri": "https://img.cdnpth.com/media/238072/71941986a76f78129bdc6815b098587d17a3611998fdc878b1d6d6603a7673bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar con cama extragrande - Planta superior",
                        "cloudUri": "https://img.cdnpth.com/media/238072/832e3ed21b2ea13edf8b6c4518b4e1747b7f4eadf18ee52d2c555b7b33b915e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/238072/4e8fda8bbfca8737849dda4239c4f039d2374472060fbafb870a3d1b2f653806.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/238072/e52145a59fa625c2929d8c6fb579007c3393ee65abec53df8c194abc20c95fd2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/71c77406286b42121f62ac7534744f47b9451cbdc143878eea7c02629e483f0c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/891e4ae7df96a8966e730dbf171534736028809d84d0d2a3e5865e8e326c7a2a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/a27b878a46f2ef1b78ad8e21b905b9c7655d6434a900afb592367c349d9aab4a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/9a86d21cbe2d53918d7128fc845cee0af9e5db4a126c5c9d37fa7113a0d2687f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/484d61cdcea261975a9c9dfe517a230556f0255d4bb7012cd0589734d23570e6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/42b39aef534d62b34cf4be1ab01521b1339a305814a2db4ea2c3ea6f1b3d8d6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/2772477f8392775c7d1f12ac05f6bc5da318bbed93b0991e4483d9c18fe260e0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/019bbf80376584068462444abc56d8e88819f5b3ec6448a1ac5d91d5b66fed7b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/c9a7a1d34f58ec593420979f713fd64d93b726590e7e4435955dcb466891d9bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/f145d3accce2ec03d8b176b3585419318589cd45244fc89b6e274da912a8d3e5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/b94d778afb98a9c69c9644b71b2ec0830554d6912ece2fa1f38e7c122e4f80bf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/07e5bc6bfa9ad244504a4de952e1b942ef93c2edd441aaa6dcb00af367bd7e31.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/6f19c2e05d1e904198f6afacc0d9f481127de38c6f3097447433d50c84655fca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/6afcbf0d8a0e603b2d5923b9a80ba036d09a21ee669835a92709d895198fde92.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/750817855f66661c5502c820dcd5198210875e13c6b7122e613544f1e77ce3b4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/25767e89219bb45f40e4a725e99620286871f18aa099288a61f2008eb9e1e456.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/dff67ab947fe7e424afa16f9ba3e3c8337c79f730d1b97298ee310a476f05b3a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/97e72f0cd76b5e11a79fdbffc85d31032f7c5a53f418efb35693a39f2e1a534f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/e0682d6222db628aa50aad83943317fed39fa4b1b3478ef948c6a2da9b69c7e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/f1b763b09d4caacc8b8c547f86e2107f3559a19f36119e38d74cc04755983bdf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/379e168d6db1172d8dc094ddf2e4a35f11b43933ad34ba9d950fc7078c57a87a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/d31dbda511cfec136aaed856d54faaa56efda79474934cb0dcf5ba42bb3b5567.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/9b384aaa23342c6a860e64786f4d6e54b1731ff77e8837949bf61b06c8f50d37.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/a4039a3f107520e9f803eae95f78b801611a1d002e2ddcb3c664e1f8fa6d6e03.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/ebc5f4a6061f890cdc18e8559ada5a49a5a3fec782f13aaa5c73b40137a6d686.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/0d0fc09a1b3a0c041d09fbb56de47097e8ec3fa9525c93262147e915a612b743.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238072/270b7918a4507ffd223beb5a7a05fcdcb8f2eb90a4e22f53ff7c62674e2416c6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/238072/f6c315f14b775bbc30f687b19d08a719f4369cc41bc0e39685050049a18f8e15.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/238072/41661039807b4ff2780b70167f9e84089234987c9770a974fb610f824ac01839.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Executive para no fumadores - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/238072/7b035248ebc791211225aa2c8a111fe6e4dd0bcd8d36f650ee8b77a7462d799c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar con 2 camas dobles grandes - Planta superior",
                        "cloudUri": "https://img.cdnpth.com/media/238072/abdc80f532f36255c5c11e92321e93d288645f6222117f517e4069bda40e7392.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar con 2 camas dobles grandes - Planta superior",
                        "cloudUri": "https://img.cdnpth.com/media/238072/df2684d7fea9c76a28ed109b154142556dbb5110e190e2f432cbe512f5ae7ba3.png"
                    }
                ],
                "hotelID": 238072,
                "importantFacilities": [
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.78875",
                    "longitude": "-99.79868",
                    "postalCode": "39907",
                    "state": "Guerrero",
                    "street": "Blvr De Las Naciones 2000, Col La Zanja",
                    "countryCode": "MX"
                },
                "name": "Holiday Inn Acapulco La Isla",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 398636,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 11
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Ten Breadmarket Cafe",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar Ten",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool Bar La Zanja",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12381691,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12381692,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12381693,
                        "kidsFreeTo": 0,
                        "name": "Standard Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647350,
                        "kidsFreeTo": 0,
                        "name": "Standard Room 1 King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647351,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard Top Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647352,
                        "kidsFreeTo": 0,
                        "name": "Standard Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647353,
                        "kidsFreeTo": 0,
                        "name": "Standard Room 2 Queen Beds Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647354,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Access",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647355,
                        "kidsFreeTo": 0,
                        "name": "Standard Room 1 King Bed Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12647356,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12776317,
                        "kidsFreeTo": 0,
                        "name": "Standard Room 1 King Bed (Top Floor)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12776318,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Top Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12776319,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Asiento de inodoro elevado",
                            "Asiento portátil para duchas",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Barra de apoyo en la ducha",
                            "Cabezal de ducha de mano",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cama a baja altura",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cerrojos/cerradura a baja altura",
                            "Cortinas opacas",
                            "Cuerda de emergencias en el baño",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha con asiento para personas con movilidad reducida",
                            "Edredón",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Escritorio a baja altura",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "Muebles de baño accesibles en silla de ruedas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puerta con mirilla a baja altura",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943792,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio, accesible para personas con discapacidad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Cunas o camas infantiles (de pago)",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943794,
                        "kidsFreeTo": 0,
                        "name": "Suite, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Cunas o camas infantiles (de pago)",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943795,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón o patio",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Cunas o camas infantiles (de pago)",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943796,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande, balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama individual",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943797,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943798,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón o patio",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 3943799,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio, balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886098,
                        "kidsFreeTo": 0,
                        "name": "2 queens - libre de humo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886099,
                        "kidsFreeTo": 0,
                        "name": "Leisure king - para fumadores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886102,
                        "kidsFreeTo": 0,
                        "name": "2 queens - para fumadores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens o 1 King",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886103,
                        "kidsFreeTo": 0,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886104,
                        "kidsFreeTo": 0,
                        "name": "Leisure king - libre de humo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Cafetera",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886105,
                        "kidsFreeTo": 0,
                        "name": "Suite king - libre de humo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Barras de sujeción",
                            "Cafetera",
                            "Ducha para silla de ruedas",
                            "En el plan con desayuno aplica sólo para 2 personas",
                            "Internet inalámbrico",
                            "Lavamanos de baja altura",
                            "Mesa de trabajo",
                            "Puertas anchas",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 5886107,
                        "kidsFreeTo": 0,
                        "name": "2 camas para personas con discapacidad - libre de humo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 7648166,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 7648181,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 8443599,
                        "kidsFreeTo": 0,
                        "name": "Twin Accessible",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 8443602,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 8443607,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Queen Beds Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860568,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Balcony",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 2,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860847,
                        "kidsFreeTo": 0,
                        "name": "Standard Room",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/77vxdbOYde9B4gaxEbSzOuehPHo=/720x480/13/56/49/13564944.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/77vxdbOYde9B4gaxEbSzOuehPHo=/720x480/13/56/49/13564944.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860848,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860849,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Accessible",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860850,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u1bABxFIHMByBU0RdaynAzxr_fQ=/720x480/13/56/49/13564945.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u1bABxFIHMByBU0RdaynAzxr_fQ=/720x480/13/56/49/13564945.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860852,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard Balcony",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Iron board",
                            "Private bath",
                            "Secadora de cabello",
                            "Smoke free",
                            "Teléfono de marcado directo con buzón de voz"
                        ],
                        "bedding": "1 King",
                        "capacity": 5,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 9860853,
                        "kidsFreeTo": 0,
                        "name": "1 King Suite",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 10191826,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 10198069,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 11625434,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 11650355,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 11650357,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 12365117,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible-Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Dining Area",
                            "Habitaciones para fumadores",
                            "Hairdryer",
                            "Living room",
                            "Number of bedrooms",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076295,
                        "kidsFreeTo": 0,
                        "name": "Double Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076296,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076297,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076352,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076356,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitación apta para mascotas",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148353,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio (Pet Friendly)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148355,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas de matrimonio (Top Floor)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Entrada con dispositivo móvil",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Mapas locales",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Ropa de cama hipoalergénica disponible",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148356,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande (Top Floor)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2ahXQ2hWyAuoKYo7--W_SbMIcKk=/720x480/12/80/74/12807473.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Closet",
                            "Coffeemaker",
                            "Direct dial telephone with voice mail",
                            "Hairdryer",
                            "In-room safe",
                            "Iron board",
                            "Private bath",
                            "Smoke free",
                            "Turndown service",
                            "Wireless internet access"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 17045600,
                        "kidsFreeTo": 0,
                        "name": "1 King Standard Top Floor",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ReZk8dvSQF4mz0FxqA51vyPgKDE=/720x480/13/56/49/13564942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ReZk8dvSQF4mz0FxqA51vyPgKDE=/720x480/13/56/49/13564942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Closet",
                            "Coffeemaker",
                            "Direct dial telephone with voice mail",
                            "Hairdryer",
                            "In-room safe",
                            "Iron board",
                            "Private bath",
                            "Smoke free",
                            "Turndown service",
                            "Wireless internet access"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 17045601,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Top Floor",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1cCTvPC1GEWx1tOZjnaTEyznDSE=/720x480/13/56/49/13564943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1cCTvPC1GEWx1tOZjnaTEyznDSE=/720x480/13/56/49/13564943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Closet",
                            "Coffeemaker",
                            "Direct dial telephone with voice mail",
                            "Hairdryer",
                            "In-room safe",
                            "Iron board",
                            "Private bath",
                            "Smoke free",
                            "Turndown service",
                            "Wireless internet access"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "18:00 - 11:00",
                        "checkOutTime": "11:00",
                        "roomID": 17045602,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Standard Pet Friendly",
                        "isActive": true,
                        "view": "Varía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/HcjrP6rsy2YKXFvf22fuOecMXQQ=/720x480/13/56/49/13564946.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/HcjrP6rsy2YKXFvf22fuOecMXQQ=/720x480/13/56/49/13564946.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Asistencia turística",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Computadoras con internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Periódicos en el lobby",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4.5,
                    "totalSurveys": 491,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": null,
                "uri": "holiday-inn-acapulco-la-isla",
                "tags": [
                    {
                        "name": "Negocios"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [
                    {
                        "alterId": 7397,
                        "priority": 100,
                        "startDate": "2022-03-08T06:00:00+00:00",
                        "endDate": "2024-12-31T06:00:00+00:00",
                        "title": "Cargo por servicio",
                        "description": "Todo servicio de hospedaje genera un cargo de $250.00 MXN por concepto de resort service por habitación por noche, que son obligatorios y deben pagarse directamente en el establecimiento al momento del registro o de la salida."
                    }
                ],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. Desayuno, comida y cena en restaurantes de consumo seleccionados en sus horarios establecidos, sujetos a disponibilidad y horarios de operación del hotel. Bebidas alcohólicas nacionales (para mayores de 18 años) de 11:00 a 23:00 hrs."
                    },
                    {
                        "title": "Otros",
                        "description": "Servicio a la habitación las 24 horas del día (aplica cargo por entrega de $200.00 MXN)."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Su paquete finaliza el día de su salida a las 12:00 hrs (medio día)."
                    }
                ],
                "description": "Hotel Palacio Mundo Imperial es un hotel en Acapulco ubicado en el complejo Mundo Imperial, el cual está formado por el Fórum Mundo Imperial, el paseo al aire libre Promenade y el centro de convenciones Expo Mundo Imperial. El hotel se localiza en la zona de Acapulco Diamante, a 700 metros del centro comercial La Isla Acapulco, a 2 kilómetros de la playa y a 3 kilómetros del Aeropuerto Internacional General Juan N Álvarez (ACA). La Costera Miguel Alemán se encuentra a 15 kilómetros de distancia.\r\n\r\nEl hotel posee 814 habitaciones y suites con pisos de mármol y muebles contemporáneos, distribuidas en dos torres independientes. Todas tienen televisión LCD de 46 pulgadas con canales por cable o satélite, acceso a internet inalámbrico, mesa de trabajo, radio reloj con base para iPod y balcón. Adicionalmente están equipadas con baño privado con ducha, secador de pelo, espejo de tocador, espejo completo y closet. Las habitaciones cuentan con ventilador de techo, teléfono en el baño y menú de almohadas. Algunas de las habitaciones tienen vista al paseo Promenade y a las piscinas. Las junior suites disponen de un dormitorio, área de descanso, así como baño privado de mármol con bañera, ducha y doble lavabo. El hotel también acepta hasta dos perros por habitación de menos de 9 kilos (aplican cargos y restricciones).\r\n\r\nEl hotel ofrece diferentes especialidades en sus siete restaurantes, incluyendo comida mexicana, tailandesa, internacional, cortes de carne y botanas. Además tiene cuatro bares, dos en el área de piscinas, uno en el lobby y una cantina. Este hotel en Acapulco tiene seis piscinas, una de ellas es de olas, otra es solo para adultos y una es para niños. De igual manera el hotel cuenta con un gimnasio equipado, un spa con masajes, tratamientos corporales, sauna y baño de vapor, y un salón de belleza. También se puede practicar tenis en sus tres canchas de arcilla, relajarse en la pista para correr o jugar en las canchas de voleibol playero. Este resort dispone de salones de eventos y bodas, centro de negocios, cajero automático, joyería, boutiques y tienda de regalos. Para familias, el hotel ofrece juegos de mesa, actividades diarias, un club de niños de 4 a 12 años y un club de jóvenes de 13 a 17 años. Entre otros servicios el hotel proporciona acceso a internet inalámbrico, niñera a solicitud y servicios médicos.\r\n\r\n***Todo servicio de hospedaje genera un cargo de $250.00 MXN por concepto de resort service por habitación por noche, son obligatorios y deben pagarse directamente en el establecimiento al momento del registro o de la salida. \r\n \r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 2084142,
                        "description": "Hotel Palacio Mundo Imperial",
                        "cloudUri": "https://img.cdnpth.com/media/nDdl9sjDoQD2xPYQuOZwJl6jdu4=/720x480/02/08/41/02084142.jpg"
                    },
                    {
                        "photoID": 2084150,
                        "description": "El hotel se ubica en Acapulco",
                        "cloudUri": "https://img.cdnpth.com/media/TcXZsmuuiOjsetDyBJ1T5e6ffig=/720x480/02/08/41/02084150.jpg"
                    },
                    {
                        "photoID": 2084152,
                        "description": "Hay seis piscinas en las instalaciones",
                        "cloudUri": "https://img.cdnpth.com/media/MTt6-b3VEtJ67XU6mXjcxH-yDFU=/720x480/02/08/41/02084152.jpg"
                    },
                    {
                        "photoID": 2846698,
                        "description": "Alrededor de las piscinas hay camas de playa plegables",
                        "cloudUri": "https://img.cdnpth.com/media/mr5zWimuPCLMnd-bPv98rQfmKhc=/720x480/02/84/66/02846698.jpg"
                    },
                    {
                        "photoID": 2084154,
                        "description": "Vista panorámica del área de piscinas",
                        "cloudUri": "https://img.cdnpth.com/media/73i4pY8yTFLk-FnMzT71xvZRuWk=/720x480/02/08/41/02084154.jpg"
                    },
                    {
                        "photoID": 2084148,
                        "description": "Jacuzzi exterior",
                        "cloudUri": "https://img.cdnpth.com/media/8oeXKnrhWcOFk64qAae-vMmzTDY=/720x480/02/08/41/02084148.jpg"
                    },
                    {
                        "photoID": 2084155,
                        "description": "Restaurante de comida internacional",
                        "cloudUri": "https://img.cdnpth.com/media/FDTK6psf6IZVZg_Pe3SKMztr1Vo=/720x480/02/08/41/02084155.jpg"
                    },
                    {
                        "photoID": 2846704,
                        "description": "Interior del restaurante Mizumi",
                        "cloudUri": "https://img.cdnpth.com/media/aOk9xLYF7_EhMV7mueU9lqdP5eQ=/720x480/02/84/67/02846704.jpg"
                    },
                    {
                        "photoID": 2846703,
                        "description": "Restaurante Marché, de comida internacional",
                        "cloudUri": "https://img.cdnpth.com/media/E38UiuS3KHlSlEQVB-1q9-bhks8=/720x480/02/84/67/02846703.jpg"
                    },
                    {
                        "photoID": 2084138,
                        "description": "Cantina La Barrita de En Medio",
                        "cloudUri": "https://img.cdnpth.com/media/t00lpvxpImquBneSdCkXO-7XzmA=/720x480/02/08/41/02084138.jpg"
                    },
                    {
                        "photoID": 2084149,
                        "description": "En el lobby hay disponible un bar",
                        "cloudUri": "https://img.cdnpth.com/media/-BqcJXWeP5VUWwTomv667JvHrsU=/720x480/02/08/41/02084149.jpg"
                    },
                    {
                        "photoID": 2084140,
                        "description": "Terraza de la propiedad",
                        "cloudUri": "https://img.cdnpth.com/media/KMUiEkHB_dc0QQZAjsMPjbdAzkM=/720x480/02/08/41/02084140.jpg"
                    },
                    {
                        "photoID": 2084144,
                        "description": "El gimnasio está equipado con variedad de máquinas cardiovasculares",
                        "cloudUri": "https://img.cdnpth.com/media/Vrd-X2OGUP8NIRRRzYkdDwCfK3s=/720x480/02/08/41/02084144.jpg"
                    },
                    {
                        "photoID": 2084139,
                        "description": "Hay un club de niños",
                        "cloudUri": "https://img.cdnpth.com/media/AkmVCFDcLhDpKrN45r2sND3y1GM=/720x480/02/08/41/02084139.jpg"
                    },
                    {
                        "photoID": 2084157,
                        "description": "El hotel posee tres canchas de tenis",
                        "cloudUri": "https://img.cdnpth.com/media/Xwp4JzO6jLwB_puCVA8QmID1X6c=/720x480/02/08/41/02084157.jpg"
                    },
                    {
                        "photoID": 2084143,
                        "description": "Decoración exterior",
                        "cloudUri": "https://img.cdnpth.com/media/VByk862A9eX8mX9E_nuiDe6O1tM=/720x480/02/08/41/02084143.jpg"
                    },
                    {
                        "photoID": 2084141,
                        "description": "Se llevan a cabo espectáculos nocturnos",
                        "cloudUri": "https://img.cdnpth.com/media/A78DJS1b4P_xvyq_TjlDHumajrU=/720x480/02/08/41/02084141.jpg"
                    },
                    {
                        "photoID": 2846687,
                        "description": "Habitación superior",
                        "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                    },
                    {
                        "photoID": 2846686,
                        "description": "Interior de una habitación de lujo",
                        "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                    },
                    {
                        "photoID": 2846690,
                        "description": "Las junior suite poseen baño privado con ducha y bañera",
                        "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                    },
                    {
                        "photoID": 2846685,
                        "description": "Las habitaciones Club 89 disponen de 2 camas matrimoniales",
                        "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                    },
                    {
                        "photoID": 2846692,
                        "description": "Las master suite ofrecen dos baños",
                        "cloudUri": "https://img.cdnpth.com/media/AJmsp4Fj2bgMZwBepot4GveEt0M=/720x480/02/84/66/02846692.jpg"
                    },
                    {
                        "photoID": 2846701,
                        "description": "Habitación premium suite",
                        "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                    },
                    {
                        "photoID": 2846696,
                        "description": "Dormitorio del penthouse",
                        "cloudUri": "https://img.cdnpth.com/media/kaFuuNBpkLwqxu3jREzWCYyp0UE=/720x480/02/84/66/02846696.jpg"
                    },
                    {
                        "photoID": 2846712,
                        "description": "Algunas suites tienen terraza con jacuzzi",
                        "cloudUri": "https://img.cdnpth.com/media/_wb4Ozzg_T-jfGhcVpyd3Zp65_s=/720x480/02/84/67/02846712.jpg"
                    },
                    {
                        "photoID": 2846688,
                        "description": "Baño de una habitación superior",
                        "cloudUri": "https://img.cdnpth.com/media/ERBYLCbW7I01ghB-jhyklisAacc=/720x480/02/84/66/02846688.jpg"
                    },
                    {
                        "photoID": 2846684,
                        "description": "Algunas suites cuentan con jacuzzi en el baño",
                        "cloudUri": "https://img.cdnpth.com/media/Y-gzVz33Z11dQOfbyXf8T8Xymms=/720x480/02/84/66/02846684.jpg"
                    }
                ],
                "hotelID": 210480,
                "importantFacilities": [
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.76891902305868",
                    "longitude": "-99.77440416812897",
                    "postalCode": "39931",
                    "state": "Guerrero",
                    "street": "Blvr de las Naciones 3 , Col Plan de los Amates",
                    "countryCode": "MX"
                },
                "name": "Hotel Palacio Mundo Imperial",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 398636,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 11
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Mizumi",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Marché",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Cantina La Barrita de En Medio",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Carnivore",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Acua",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Moda",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Serenity",
                        "type": "Bar"
                    },
                    {
                        "name": "Club 89",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Blue Lobby",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 14270109,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 14270112,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1503648,
                        "kidsFreeTo": 5,
                        "name": "Superior doble vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1503650,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al resort",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1503653,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al resort",
                        "isActive": true,
                        "view": "Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3945401,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3945402,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista al resort",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953750,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Beds Diamante View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953751,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Beds Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953752,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567040,
                        "kidsFreeTo": 0,
                        "name": "Superior king vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567051,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al resort",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567053,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567054,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista al resort",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567055,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista al resort",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567057,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567058,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567534,
                        "kidsFreeTo": 0,
                        "name": "Superior King Size Bed Diamante View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567535,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Size Bed Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567536,
                        "kidsFreeTo": 0,
                        "name": "Club 89 King Size Bed Diamante View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567537,
                        "kidsFreeTo": 0,
                        "name": "Club 89 Double Beds Diamante View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567538,
                        "kidsFreeTo": 0,
                        "name": "Club 89 King Bed Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567539,
                        "kidsFreeTo": 0,
                        "name": "Club 89 Double Beds Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567540,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed Diamante View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567541,
                        "kidsFreeTo": 0,
                        "name": "Master Suite King Size Bed Diamante View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567542,
                        "kidsFreeTo": 0,
                        "name": "Master Suite King Size Bed Resort View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Balcón",
                            "Baño parcialmente abierto",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Desk",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espresso maker",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Habitación en planta Club",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 46",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "TV size measurement: inch",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4567543,
                        "kidsFreeTo": 0,
                        "name": "One Bedroom Penthouse King Size Bed Diamante View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787531,
                        "kidsFreeTo": 5,
                        "name": "Superior doble vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787532,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787536,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787537,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787544,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Mesa y sillas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787545,
                        "kidsFreeTo": 0,
                        "name": "Penthouse de 1 dormitorio king vista a la Zona Diamante",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787546,
                        "kidsFreeTo": 0,
                        "name": "Superior king vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787547,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787548,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787549,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787550,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista al resort - todo incluido",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787551,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4787553,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 5971897,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 5971898,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6084425,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6084427,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7850408,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969948,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969949,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969950,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969951,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Ciudad Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969952,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969953,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977183,
                        "kidsFreeTo": 4,
                        "name": "Superior doble vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977184,
                        "kidsFreeTo": 4,
                        "name": "De lujo doble vista al resort - desayuno",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977185,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977186,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al resort - desayuno",
                        "isActive": true,
                        "view": "Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977187,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista al resort - desayuno",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Mesa y sillas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977188,
                        "kidsFreeTo": 0,
                        "name": "Penthouse de 1 dormitorio king vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977189,
                        "kidsFreeTo": 0,
                        "name": "Superior king vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ODeHOvpKYyB4icru1Fc9VP5775M=/720x480/02/84/66/02846687.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977190,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al resort - desayuno",
                        "isActive": true,
                        "view": "Alberca|Exterior|Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/pcy1o4J-WSyXbULAdJjclB6od6w=/720x480/02/84/66/02846686.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977191,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977192,
                        "kidsFreeTo": 0,
                        "name": "Club 89 king vista al resort - desayuno",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977193,
                        "kidsFreeTo": 4,
                        "name": "Club 89 doble vista al resort - desayuno",
                        "isActive": true,
                        "view": "Exterior o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/U6tbNJz5GlkLXC3BxZf092vlTiw=/720x480/02/84/66/02846685.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977194,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CHWC16Ac9nUxph_BmMWIVwbFbpQ=/720x480/02/84/66/02846690.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7977195,
                        "kidsFreeTo": 0,
                        "name": "Master suite king vista a la Zona Diamante - desayuno",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/GlQD8VDVGwPt4dCdFoCfyZjFFrw=/720x480/02/84/66/02846693.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351104,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351105,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351107,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351109,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351112,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351115,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351120,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351123,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351134,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351137,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351140,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8351142,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439735,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439741,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439743,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439752,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439754,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439758,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8439767,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Mesa y sillas",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicios exclusivos",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 9410208,
                        "kidsFreeTo": 0,
                        "name": "Penthouse de 1 dormitorio king vista a la Zona Diamante - todo incluido",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2XScirxkQV3xUrQno4UoWle0iUU=/720x480/02/84/67/02846701.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 10199788,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 10199789,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 10199790,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 10199791,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11634824,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11634836,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086464,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086465,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086466,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086467,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086468,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16086469,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16268434,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16268435,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16268436,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16655502,
                        "kidsFreeTo": 0,
                        "name": "Casa Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215551,
                        "kidsFreeTo": 0,
                        "name": "Habitación Penthouse Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215560,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215568,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215583,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215597,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215604,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215611,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215619,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364751,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364753,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364754,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364755,
                        "kidsFreeTo": 0,
                        "name": "Habitación Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364756,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364757,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364759,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18364760,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482576,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482577,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482578,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482579,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482582,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482583,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482584,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482585,
                        "kidsFreeTo": 0,
                        "name": "Individual Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482586,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482587,
                        "kidsFreeTo": 0,
                        "name": "Individual Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482588,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482590,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482591,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482592,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482593,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482595,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482597,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18482598,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18734223,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18886777,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983041,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983042,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983043,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983044,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983045,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983046,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983047,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983048,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983049,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983050,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983051,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983052,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983053,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983054,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983055,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983056,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983057,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983058,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983059,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Nevera",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983061,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983062,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983063,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983064,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983065,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983066,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983067,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Children share the bed with parents",
                            "Desk",
                            "Direct dial telephone",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Ironing set",
                            "Make-up mirror",
                            "Mini fridge",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "subject to availability",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983068,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed One Bedroom",
                        "isActive": true,
                        "view": "City view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Children share the bed with parents",
                            "Desk",
                            "Direct dial telephone",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Ironing set",
                            "Make-up mirror",
                            "Mini fridge",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 King-size bed 150-183 width",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18983069,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed One Bedroom",
                        "isActive": true,
                        "view": "City view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106969,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106971,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106973,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106974,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106976,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106978,
                        "kidsFreeTo": 0,
                        "name": "Habitación Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Mini nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20106980,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "6 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de jóvenes (13-17 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños  (4-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico hasta 4 dispositivos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Máquina de hielo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Pista para correr",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos (horario establecido)",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa (los horarios pueden variar)",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de periódicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transporte a hoteles hermanos (horarios establecidos)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol de playa",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 932,
                    "valuesAverage": [
                        4.4
                    ]
                },
                "title": "Hotel en Acapulco con seis albercas en el complejo Mundo Imperial",
                "uri": "hotel-palacio-mundo-imperial",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno en el restaurante Las Gaviotas (de 07:00 a 12:00 hrs), almuerzo en el restaurante bar El Morro (de 12:00 a 17:00 hrs), cena en el restaurante Las Gaviotas (de 18:00 a 22:30 hrs) y bebidas nacionales de 18:00 a 22:00 hrs."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores."
                    }
                ],
                "description": "Playa Suites Acapulco es un hotel frente a la playa localizado en la famosa Zona Dorada. El hotel se localiza a poca distancia de las principales atracciones turísticas, centros comerciales, restaurantes y vida nocturna.  Adicionalmente, el Aeropuerto Internacional de Acapulco (ACA) se ubica a 21 kilómetros del hotel.  \r\n\r\nPlaya Suites Acapulco ofrece 502 suites distribuidas en dos torres de 18 pisos. Las suites están equipadas con una sala con sofá cama, terraza privada, aire acondicionado, teléfono, caja de seguridad, televisión vía satélite, llave electrónica, así como baño privado con tina y regadera. Asimismo, las Suites bahía tienen una impresionante vista frontal al océano. \r\n\r\nEl hotel Playa Suites Acapulco cuenta con una piscina, un chapoteadero, un solárium, un club de niños, una agencia de viajes, tabaquería y acceso a internet inalámbrico en el lobby. El hotel también dispone de salones de eventos, fax, servicio de correo y banquetes. Además, Playa Suites Acapulco ofrece un plan todo incluido que comprende tu habitación, desayuno, comida, cena y barra abierta nacional con horario limitado.\r\n\r\n***Para las familias que viajan con niños es necesario presentar el CURP del menor para corroborar su edad al momento del registro.\r\n\r\n***Aplica exclusivamente para el paquete Todo Incluido Total, que inicia desde tu llegada al hotel (12:00 hrs. aprox.) y finaliza al momento de abordar la transportación de regreso (16:00 hrs. aprox) al termino de tu estancia.\r\n\r\n***El hotel no acepta mascotas. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/6934bbaae1eaa6fc1f4434496a7e54c90c9e63c6ab244a92f9943b0d11d68593_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100468/ca1ddb0df6cd5daf90376566449a55148155861eef81b47777c178f3b128fbc4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/9c2d3a5dbbd44ce4f7a1c83f3b0495e930213e568d42b4339ade836f402bf284.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/8fb9f4e52a26788ada67d8c17c923a6776bb4091c2e56efaf1a5590a69f8002f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/380a5916a8f4f83647e70d8f9146c8381eb4c6986261dd4be5544ae2d8338003.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (4 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/4dc881154a908a0456870acbbbfe73bce2cd280c36662df23661bb0ba82dd474.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/67ee7bef94ffaf22a42a1174580fc80fa99c661d67699b74876111f60cfa1fbb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/02625c6d003d977071b2b87953b0e3e31f09a767391299abeb62ae19ca3cdb60.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/d78759731464ce27f1a6ed7f906cc5ad81ad0203a045a0a47e85832b7ee820fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior (4 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/c342d3abab5298b34799b20d8a7c66d7ae698e0c996ef284bb3695c5555ba3cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior (4 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/dcfe0beb910c1532da56e442910da52712bf9ede11f5698cc8961b02ea46fb91.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/100468/38624c1d97b2d0cd97ad40aac876c0e9c6fac725e17b7bd2e3719db03b76c03c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/c853a439a8566363d586371c2b23dcd2a474f36e94c313fdb52a1fc2ef73d07f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/ed3a3a788782f7bf0ba38ab92ced9802a6b2bd7228b793c0937859dd702f78e9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/c05802c997b0567b830d0fe71b36dd9931a17b8ac949d5cf566d2df9d1dafa89.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/41f634d42a7bd43f042c6478c1977d83b1d381b88e5490488e9a9643fea75a6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/c2611f9401016ddc44041fc47687493823b40e7ed4b3a7d5f89a078b76622929.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/55d141aee8debb86ab164f6cf78971722c9577ffdbf16aaed99d2c97d28a0698.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/10706f420f25166b1e43f70a755c1d057e2e826597038416e7903f30914375a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/25c248cb15c78d9accf5e00fc1969537bdcb8a303fc5977e93c41a1d1224d1d7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/62eca068302f8a9c9755d4b03f5e0f8843303b4a6cb595e3061386ffe9ee1814.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/f3e9d9dd51d03c7af229907b95db6c75b04681f2787a437713f23d79b02a23a8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/8b9fc59f4e96abbf5bd08e07996a956fde89c0d7629589382ffea638743ad80e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/5ab6fe30747c08bf0857e40f1ceba41f358cd3fc9cbd3f2b3bf4ce163e9d3575.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/570a9e6263b36744f271681d403faa6c10ee0e29ec490fda5f6274ab1adf98a0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/56b43cb559d8a7ae4eea788768677a97874800970a1d58f79a6bd808dcad91e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (4 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/66c1e857b0ee6aa83f7f3f078a84abab865167c5a3afd4f974fc5435e68caba9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (4 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/d7f488f6281d5bbb8c3c13d170793dec62d299c37b363417e73e7c8efac0dca9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/1bb8a21d6367f166b870c15936f5e3b2f32c99d1b3ca15cd6e8b586c77f4e814.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/5c74036e2b22b17c843c8c6cfcf137ac3a564fe28304cbc6cae698cc5e31af20.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/6b0c614221f3ec3c4b4be146ac7020741e392fcd139ee18555136fb586a94992.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/58454d23759ea662f935151195b008570c6b36f22ec9f8eca5c7f5c300fdfaa9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/d74a619cbc1ef7c0e939c2caadcc10cc36f5bb1e32df0debaf29e3a73fe24d21.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/877e10b832ccfa0f5c9dae661e2e32fccaf5e9465c115d595dcbcdd0e00e43a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/48da0db0faa18b47664e48ef4fd6c2f07578d67e781c22baaed141d40519f7c0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100468/0c5f309bd4a3f1b218ddea9e681283204ee5a01cec69a21ffb4de24ac4106530.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/1674ab1f4dcc8a1c8ef44229301596de66c3bdf8b91a2aba2531a0d6a140aa26.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100468/ca3a9ef0b298152bbe9fb479a7e597474ec36544c04f001e294017c756e664ec.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/190e8e2fa9a0564c445ecc98e71b326fda5b56860e3d541fa977614e01aaecad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/511d1fd93d8fb3b3b591f0258e73b71c97a3686a916f03c6bec0096e602038f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100468/7baf229685ba18db408cca70d0e38b6a594becf477da9ffaf912570a39c8563a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100468/5ab05aa13294c1ce9ec148a381ed9786e2ee6c0c9c544ff7f61062b1a6b2eec1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior (3 adultos)",
                        "cloudUri": "https://img.cdnpth.com/media/100468/1bcd3c68478a802e334e888fc0f16583682a03407c9a0906c05cf072378f814b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/3d5f75b45faa9afae42ba459f5c3db148081dbb57bb5b50cc15921ac4cfb64b8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100468/281ebeff2f841f4816cc535881f25372cc35e88cedcf6ab64e440f82294fd676.png"
                    }
                ],
                "hotelID": 100468,
                "importantFacilities": [
                    "Estacionamiento",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.85999462373285",
                    "longitude": "-99.87563610076904",
                    "postalCode": "39670",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 123, Fracc Magallanes",
                    "countryCode": "MX"
                },
                "name": "Playa Suites Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Las Gaviotas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Morro",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Bahía",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Llave electrónica",
                            "Sala",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "Terraza",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000616,
                        "kidsFreeTo": 4,
                        "name": "Junior suite",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oxDBDduUhAkrQ7rNTYOtj4P0EXU=/720x480/04/67/82/04678244.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oxDBDduUhAkrQ7rNTYOtj4P0EXU=/720x480/04/67/82/04678244.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Llave electrónica",
                            "Sala",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "Terraza",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001369,
                        "kidsFreeTo": 4,
                        "name": "Suite Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/RRMKVtGTbQ-O2FVvYfYSO7lrZv0=/720x480/04/67/82/04678201.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RRMKVtGTbQ-O2FVvYfYSO7lrZv0=/720x480/04/67/82/04678201.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Llave electrónica",
                            "Sala",
                            "Teléfono de marcado directo",
                            "Terraza",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1008999,
                        "kidsFreeTo": 4,
                        "name": "Super saver",
                        "isActive": true,
                        "view": "Ninguna o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/14Dlz9VtpjzzEHkVh87hb7nsrq8=/720x480/04/67/82/04678267.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/14Dlz9VtpjzzEHkVh87hb7nsrq8=/720x480/04/67/82/04678267.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Armario o ropero",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cunas o camas infantiles gratis",
                            "Edredón",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Salón independiente",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de descubierta",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4009871,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Armario o ropero",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cunas o camas infantiles gratis",
                            "Edredón",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Salón independiente",
                            "Secador de pelo (previa solicitud)",
                            "Sofá cama",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4009872,
                        "kidsFreeTo": 0,
                        "name": "Bahia Suite",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Armario o ropero",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cunas o camas infantiles gratis",
                            "Edredón",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Salón independiente",
                            "Secador de pelo (previa solicitud)",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4009873,
                        "kidsFreeTo": 0,
                        "name": "Estandar Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4772605,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5062468,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Baño con ducha",
                            "Caja de seguridad",
                            "Llave electrónica",
                            "Sala",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7912009,
                        "kidsFreeTo": 4,
                        "name": "Penthouse junior suite",
                        "isActive": true,
                        "view": "Bahía parcial",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Rg8OmxHRJqwO56ev_4rxvQ9N5fw=/720x480/04/67/82/04678288.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Rg8OmxHRJqwO56ev_4rxvQ9N5fw=/720x480/04/67/82/04678288.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Baño con ducha",
                            "Caja de seguridad",
                            "Llave electrónica",
                            "Sala",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7913195,
                        "kidsFreeTo": 4,
                        "name": "Penthouse Bahía",
                        "isActive": true,
                        "view": "Bahía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CrZcxmSsZBDpYUvEqBvwWGQ_ce4=/720x480/05/02/61/05026139.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CrZcxmSsZBDpYUvEqBvwWGQ_ce4=/720x480/05/02/61/05026139.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7969915,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7969916,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645337,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645339,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645340,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645341,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645342,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645344,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645345,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645352,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente A La Playa",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645358,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645359,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645361,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645362,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645363,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645366,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645368,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645371,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645372,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645373,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645375,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645376,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645377,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645378,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645379,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051487,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051489,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051490,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051492,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051493,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Penthouse",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051494,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051495,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051496,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051497,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051499,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051500,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051501,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114046,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Vistas Laterales Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114047,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114049,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114051,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114052,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16114054,
                        "kidsFreeTo": 0,
                        "name": "Individual Frente Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16275749,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16377291,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Dos Dormitorios Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16499281,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747411,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747412,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747413,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747414,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747415,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747416,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747417,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747418,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747419,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747420,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747421,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747422,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747423,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747424,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747425,
                        "kidsFreeTo": 0,
                        "name": "Double Room Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747426,
                        "kidsFreeTo": 0,
                        "name": "Suite Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747427,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747428,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747429,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747430,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747431,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747432,
                        "kidsFreeTo": 0,
                        "name": "Apartment Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747433,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747434,
                        "kidsFreeTo": 0,
                        "name": "Apartment With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747435,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747436,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747437,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747438,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747439,
                        "kidsFreeTo": 0,
                        "name": "Suite Street View",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747440,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747441,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747442,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747443,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747444,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747445,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747446,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747447,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747448,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747449,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747450,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747451,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747452,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747453,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed Street View",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747454,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747455,
                        "kidsFreeTo": 0,
                        "name": "Suite Apartment Separate Rooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747456,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747457,
                        "kidsFreeTo": 0,
                        "name": "Suite Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747458,
                        "kidsFreeTo": 0,
                        "name": "House Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747459,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747460,
                        "kidsFreeTo": 0,
                        "name": "Apartment Separate Rooms Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747461,
                        "kidsFreeTo": 0,
                        "name": "Suite High Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747462,
                        "kidsFreeTo": 0,
                        "name": "Apartment Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747463,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747464,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747465,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747466,
                        "kidsFreeTo": 0,
                        "name": "Suite With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747467,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747468,
                        "kidsFreeTo": 0,
                        "name": "Suite Apartment Separate Rooms Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747469,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Double Beds Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747470,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747471,
                        "kidsFreeTo": 0,
                        "name": "Junior Apartment 2 Bedrooms With View Partial View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747472,
                        "kidsFreeTo": 0,
                        "name": "Triple Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747473,
                        "kidsFreeTo": 0,
                        "name": "Suite Apartment Separate Rooms With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747474,
                        "kidsFreeTo": 0,
                        "name": "Junior Apartment 2 Bedrooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747475,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Extrabed 2 Bedrooms Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747476,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747477,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747478,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747479,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Double Beds Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747480,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747481,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Family 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747482,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747483,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747484,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747485,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747486,
                        "kidsFreeTo": 0,
                        "name": "Junior Apartment 2 Bedrooms Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747487,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Extrabed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747488,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747489,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747490,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747491,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747492,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747493,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds 2 Twin Beds 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747494,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds 2 Twin Beds 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747495,
                        "kidsFreeTo": 0,
                        "name": "Studio 2 Bedrooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747496,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747497,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747498,
                        "kidsFreeTo": 0,
                        "name": "Suite With View Street View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747499,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747500,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747501,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747502,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747503,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747504,
                        "kidsFreeTo": 0,
                        "name": "Apartment Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747505,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747506,
                        "kidsFreeTo": 0,
                        "name": "High Floor",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747507,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747508,
                        "kidsFreeTo": 0,
                        "name": "Apartment Separate Rooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747509,
                        "kidsFreeTo": 0,
                        "name": "House Separate Rooms With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16747510,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061299,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218891,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218901,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218908,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Vistas Al Mar Un Dormitorio",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218914,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218919,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218923,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947457,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Parque",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947458,
                        "kidsFreeTo": 0,
                        "name": "Habitación Penthouse",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18637856,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18800179,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18800181,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size No Fumadores",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18800184,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18923027,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18923028,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18923029,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Kitchenette",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Bed o 2 Beds o 3 Beds o 4 Beds",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18923031,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas No Fumadores",
                        "isActive": true,
                        "view": "Pool view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Kitchenette",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Bed o 2 Beds o 3 Beds o 4 Beds",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18923032,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Dos Camas",
                        "isActive": true,
                        "view": "Pool view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Asoleadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (4-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Equipo para snorkel",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Esquí acuático",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Velero",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.3,
                    "totalSurveys": 975,
                    "valuesAverage": [
                        4.1,
                        4.5
                    ]
                },
                "title": "Hotel de suites cerca de Playa Condesa en la Zona Dorada de Acapulco",
                "uri": "playa-suites-acapulco",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno, comida y cena bufet."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 10 años, supervisado por adultos. Abierto diariamente de 09:30 a 13:00 hrs y de 14:00 a 17:00 hrs."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    }
                ],
                "description": "Ritz Acapulco All Inclusive es un hotel tradicional de la ciudad, el cual está localizado en una de las mejores playas de la bahía de Acapulco, cerca de toda una variedad de restaurantes y tiendas, y a tan sólo 25 minutos del aeropuerto internacional.\r\n\r\nRitz Acapulco All Inclusive ofrece 240 habitaciones decoradas en estilo moderno todas con vista al mar y con servicios y amenidades que incluyen acceso a internet, aire acondicionado, sistema contra incendio, sofá cama y teléfono entre otros.  \r\n\r\nRitz Acapulco All Inclusive el único hotel dentro de la bahía que opera exclusivamente bajo el concepto todo incluido, ofreciendo todos los días desayuno, comida y cena tipo buffet, barra de botanas calientes durante el día, barra libre de bebidas nacionales ilimitadas desde las 10:00 am hasta las 12 de la noche. Además ofrece equipo propio de animación para actividades recreativas durante el día y espectáculo nocturno en su salón teatro, un club de niños, área de playa, dos restaurantes, dos bares y alberca con chapoteadero, todos ellos con una espectacular vista a la bahía.\r\n\r\n***Pueden existir cargos determinados por el hotel que son obligatorios y deben pagarse directamente en el establecimiento al momento del registro o de la salida.\r\n\r\n***Las reservaciones de seis habitaciones en adelante con el mismo nombre son consideradas como grupo y aplicarán reglas y políticas de grupo. Las tarifas promocionales no aplican para grupos.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/db5cd569474bf9fb014bccf842ef366b82b2aae0439e16dad67a14da5446b6ae_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/589d7cbef6547abacca18aec70eec20228bb4d97a0e095481b17649a91a63184.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/101755/69cee6eba11041c2f0855297f92fbab2d40bf52eb536ef17bf4ab66e3e8abea2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/50d4af7d661f3216b02d58723607df9542c5bfc18cf4f39115a609c10c11bfca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/101755/38976221c37fa25fde2ea558a94487123119c9ea2ea0e56330f7d12a3f2e217f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/101755/888b91c1cb4fe526d93e585cd2368cc3ec7c54d57cc81500d6bb17ac9ec4273c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/d4a6af697ca226f458662dc8b4f8a67f75b410f906f293993e4641783fb65012.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/ff9d76b199b88af76a4692805beb410acadbdeba506f419228c59ddc7022616e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/ed2d91e356dec739b1725f46a3f521dbb86f2048835751a7f9acafefb245d424.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/80242ac02481cf0fb6272e6c8a73014fa10aed42cb17e845bcde870a95f82397.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/897b0d27588f551ed26de90625f191d9655683a82c5bda264e7cacad53b7da44.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/5da7651e6153f8083552eb0186f24fe376fed38ab550d7a2c12be4d06042dc50.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/b0e97d35e10b4de29c5d756ec828f863b0e16fef6c316e491675b73a88effdfe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/4634d26d6d1795a1ce5dcafb1129e470e652c5becb67ff0fde5a5ffbfac96bab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/eda180685b797d2abeab0ea99d6e0df5bca25c83d54dcdc0d209e9aef8155807.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/1af0ed780f0d99be539fcfe796e83324bd2f4763b41e76a272529f9280211590.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/2e933916639b4eb9a6c2f850895485d1fbabbf3e253384304f7238b19e717c84.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/59664422ec4b0d3eec9870b1b6150f45e90c2cf986a0ffb289a2dff37a86c295.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/f9fadb1a6d7f9ddd914128e1c5d13f0896358cdbb3ed2c48d1320f83b53ba87b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/532a818432c53aa4890f1b80ae4dd6920a4110b8d86a10a089e7b7c01438d6b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/95fcce7567e68a20d9a5ed93bc01f13e8efe872b9be2572765b303096e1b818e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/6c443dd0151f6fc9b61b119976166397a9f3d86e6fc8249322f80b9cbbe830c3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/f38bc9bb9c9abf9ecdcf19b2f41c53b601396aaa6decf0fe8909a3b0e9b231f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/16bf3890388624903f824f4e3b25934c7b08b378f71d62722ad0c4ede5f1a182.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/4b37415c717303cc28233ac6958636cc3a14b5ec3a987fe3db2a4cc42a3d0631.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/5acda9f6a93f58e9e64a6e53833271cc1e32f5681f119d5fbaebba228f033a4b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/11e7f7122fbb9ba5f831870a8107feceffadfbf77ce882ef2e713852250a6703.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/bd49fbfc1d75c14941769a0abeee94ad77616624e9ab905f4da8389a36832e67.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/4bd48396b79dcfecfe0eab4a5855fa5f4a396714d216fc8c4d695322994c642b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/aa31b62435f981038c7af35beb863e564bc3bc84a9c872f49785984c6e70bc2c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/c16ad6ee9e8ea1439b886770664cce65ece4f612be452f7178320349cab100b6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/6eab01b94ed84f2206fac72887a1cb53df4f552164487b6c0f7ff5b2af0fa10d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/a86ced84656acf8c2744d7b00aea84813383ada7adfc7045947de323db8182c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/101755/3c70c74790ddbbce0e5cafa390a530391168a9bdf44e01b6542147ea5a180944.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101755/1d19ff3b1accd485bb02b03d758c89b7722869783a88ba2e81743210604a2181.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/0d40cc2c75f8ab4ec60c2b1aa88b0926c864f5bb3ff2db55a274474b930f06db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/23b7f21399d02ba225ed52908e59894d977ec89b2fe32d9113b8108e43fc494f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/4e207ffed3255a21916d4982c11c9bcb0bce9174e74acaffa632b099dd514d52.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/335f67c8446a9ad25279ea22a5aa35723c2394c165c9b125e01e605fb1ed74ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/250b3f95eb2f7e06f810bd72119f531dc72942590f186b8731c378f6620b73aa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/c4e62d3809b3adb88003095bf1bd1f4e749931817544d88788baafa67d00f504.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/6c0df93660ae1f4c3d554eacb1f3e9ed5e61d585a404cae43b1f56d3bad0afb9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/e323f23227cafae1c9c2e0d49177d0c145b5f7c3a786eb2a2d28175978411086.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/070fc64d191da021913bf599857d42e447eb99f9c4b5c73e5e8cdae7df17463b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/101755/9a3196ca293ffe2802a3af88e14f47e19cf4587febf3e41f8d97d4c0098e5475.png"
                    }
                ],
                "hotelID": 101755,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.86033345658122",
                    "longitude": "-99.88280296325683",
                    "postalCode": "39670",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 159, Fracc Magallanes",
                    "countryCode": "MX"
                },
                "name": "Hotel Ritz Acapulco All Inclusive",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Villalinda",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Fiesta",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar Margaritas",
                        "type": "Bar"
                    },
                    {
                        "name": "Bar de la piscina",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9543100,
                        "kidsFreeTo": 0,
                        "name": "Double room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070780,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Desk",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Non-Smoking",
                            "Number of beds - 1",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Plasma TV",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de descubierta",
                            "Televisión",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4009874,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble, 2 camas dobles, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 2",
                            "Phone",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Plasma TV",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de descubierta",
                            "Teléfono",
                            "Televisión",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4009875,
                        "kidsFreeTo": 0,
                        "name": "Habitación individual estándar, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5970358,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680847,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680848,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8332804,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8428082,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8798075,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9056522,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10187812,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624753,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624754,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 2",
                            "Phone",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Plasma TV",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de descubierta",
                            "Teléfono",
                            "Televisión",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16148171,
                        "kidsFreeTo": 0,
                        "name": "Suite estudio, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484393,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484394,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 1",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484395,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484396,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484399,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484400,
                        "kidsFreeTo": 0,
                        "name": "Estudio Dos Camas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/y09iLHDOMxi2qTZ8R51W-nxha3I=/720x480/06/02/67/06026727.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484401,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484402,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484403,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484404,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484405,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484406,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/10rAGfxqgz_MbMY-_7mbmwQLY-I=/720x480/06/02/67/06026728.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484408,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484409,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16484410,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WpCvkz4Apdd6Nddvc5IAtKV6ols=/720x480/06/02/67/06026726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16946101,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16946102,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16946103,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216847,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216855,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216860,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216864,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216868,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216872,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216876,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216880,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 3",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216884,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 3",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17604474,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17909339,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Servicio de descubierta",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17945607,
                        "kidsFreeTo": 0,
                        "name": "Suite estudio, 2 camas dobles, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988224,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 1",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17988225,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18731406,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18731410,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18731413,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740207,
                        "kidsFreeTo": 0,
                        "name": "Estándar doble - 1 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740208,
                        "kidsFreeTo": 0,
                        "name": "Estándar king - 1 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740209,
                        "kidsFreeTo": 0,
                        "name": "Suite doble - 1 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740210,
                        "kidsFreeTo": 0,
                        "name": "Suite king - 1 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742713,
                        "kidsFreeTo": 4,
                        "name": "Estándar doble - 2 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742716,
                        "kidsFreeTo": 4,
                        "name": "Estándar doble - 3 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/44ivfyKOJrVjLs3yEXR0eIObUoI=/720x480/13/40/71/13407105.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742720,
                        "kidsFreeTo": 4,
                        "name": "Estándar king - 2 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742724,
                        "kidsFreeTo": 4,
                        "name": "Estándar king - 3 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vIVtFyKkRWN4I8JQbtarcv6gbes=/720x480/13/40/71/13407143.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742725,
                        "kidsFreeTo": 4,
                        "name": "Suite doble - 2 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742727,
                        "kidsFreeTo": 4,
                        "name": "Suite doble - 3 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/g8DhhJlLOlM54_GfxUzyP2sysqY=/720x480/13/40/71/13407147.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742729,
                        "kidsFreeTo": 4,
                        "name": "Suite king - 2 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18742731,
                        "kidsFreeTo": 4,
                        "name": "Suite king - 3 pax",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PYBGf_8aNd6DCsXeUfW-AEq5U_E=/720x480/13/40/71/13407146.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870637,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18883756,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Cama Doble",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18883757,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18952678,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18952679,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18952680,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacidad 1",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18952681,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070779,
                        "kidsFreeTo": 0,
                        "name": "Doble Capacidad 1",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070791,
                        "kidsFreeTo": 0,
                        "name": "Double Capacity 1",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070797,
                        "kidsFreeTo": 0,
                        "name": "Double Capacity 2",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico (sin costo en áreas comunes)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Traslados al aeropuerto",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.9,
                    "totalSurveys": 871,
                    "valuesAverage": [
                        4.1,
                        4.5,
                        4.4
                    ]
                },
                "title": "Hotel tradicional en la mejor playa de la bahía de Acapulco",
                "uri": "hotel-ritz-acapulco-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [
                    {
                        "alterId": 8341,
                        "priority": 100,
                        "startDate": "2024-09-20T06:00:00+00:00",
                        "endDate": "2024-12-24T06:00:00+00:00",
                        "title": "Cena de Navidad incluida",
                        "description": "La Cena de Navidad está incluida para 2 personas el 24 de diciembre de 2024."
                    }
                ],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye alimentos bufet, botanas, bebidas alcohólicas nacionales, bebidas no alcohólicas y jugos, en el restaurante Aquamarina. Desayunos de 07:00 a 12:00 hrs, almuerzos de 13:00 a 17:00 hrs y cenas de 19:00 a 23:00 hrs."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows dos veces por semana."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las bebidas importadas y de la carta no están incluidas. El consumo en los restaurantes Bahía y La Palapa tienen cargo extra. Algunos servicios pueden generar cargos extra."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 10 años, supervisado por adultos. Abierto diariamente de 10:00 a 16:30 hrs."
                    }
                ],
                "description": "Krystal Beach Acapulco es un hotel frente a la playa Hornos ubicado en la famosa Zona Dorada de Acapulco, en el corazón de la bahía Santa Lucía. Este hotel todo incluido se localiza justo enfrente del parque de diversiones Papagayo, a 800 metros del centro de la ciudad y a sólo pocos minutos de centros comerciales, restaurantes, marinas, campos de golf y la vida nocturna. Adicionalmente, el Aeropuerto Internacional de Acapulco (ACA) se encuentra a 25 kilómetros del hotel. \r\n\r\nKrystal Beach Acapulco ofrece 400 amplias habitaciones distribuidas a lo largo de un edificio de 19 pisos. Las habitaciones están equipadas con aire acondicionado, caja de seguridad, televisión por cable, teléfono con puerto de datos, baño privado, secador de pelo y balcón con vista a las montañas de la Sierra Madre, a la ciudad o la bahía de Acapulco. La propiedad cuenta con habitaciones para personas con discapacidades.\r\n\r\nKrystal Beach Acapulco dispone de piscina y piscina para niños con tobogán, palapas en la playa, actividades para niños, jacuzzi y deportes acuáticos. Cuenta también con acceso a internet inalámbrico gratuito en todas las áreas, un centro de negocios con acceso a internet, renta de equipo audiovisual  y salones de eventos. Asimismo, Krystal Beach Acapulco ofrece tres restaurantes con platillos de la cocina mexicana e internacional, tres bares y servicio a la habitación (con cargo extra).\r\n\r\n***Los restaurantes y bares no aceptan pagos en efectivo, solo con tarjetas de crédito o débito. Los pagos en efectivo deberán realizarse en la recepción.\r\n\r\n***Al detectar reservas bloqueo de varias habitaciones se considerará como grupo por lo que se solicitará garantía y aplicará condiciones y suplementos adicionales.  En caso de cancelación dentro de los 21 días antes de la llegada se cobrará el 100% de la estancia.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/9ec150376feeff599b93eccdc70437fd01e8a308063732a665451b30ae08fd66_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100013/2e1a216192488ea07f756dc65abfcebc689993ffd083095887171e4f0abc337a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/c0d2c5ae3dd526d42f3336a1e45097d8dbd47f43b332eaeab7f8fe07e47beeb6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/f02360309d1a847a70bfd4044b8e1ed98bdd958b442c7021c13e24e6ad35fb94.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/579d11d47b0335c54fbfad3d5ea1e4dcb350964bb25fdddfebd94e891cd05726.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas a la montaña - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/100013/0687d9288bb00dd3f056da3544a5c6019f4eae31f9aba8427d3178821ea53d4d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/1c50314f04fe3c361a6acaf517f2172b726fa2e2f9e5f6f1c37fd2d6008853a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/b09af224f579e99ae56f782b56edc0e411e07814f870078484bcfdfff1b54c83.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/d98c5c1d43b12597f7ff450c95c393cade0e02835bc8b3e5a58de6fc84e98b3a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/3c8c8153c53cbc730dd808c0ff4b1a99da7653a06b18db4432b8b5970c3434f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/f50d0aed4b8b1ab1c308b58ed5c18a19b36d819ac37f3da9fbcc158554347b84.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/986e9337e2e61628d7bbc97b5f92c275754c192a2d273b2e735bf4f99f2fb881.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100013/09c3c7144e4849281747ce9e88b0a961a9a0fb41bd1663e12bd15d29cf1218f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/d50e2d26bf418b7cc20aaa7541d209716a1b4ee40525517756d0672cdf6a15a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/72983109f8bcb5b1bf1f2901ba606c6927f7044d46ef04b59d20122658c99975.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas a la montaña - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/100013/1d173d56cf4ff265d3a7b3b1836894974b17844d813ca6aebfa84896c42cda92.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/fbac53b5bd410620ca249ca814e950cf7445947a348e7cfb93ce9c6f564dfec6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas a la montaña - 2 camas dobles",
                        "cloudUri": "https://img.cdnpth.com/media/100013/4383429b790aa0fe15a71df97348915c977ef0a49a25893bd9bd4c22856b4d1c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/31ea635dd1963a9e75638c3c585a9d52dcb79d87226a4682fc930ae07e4d424d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/5d8682cb8005e239aac2a22985a3a3cb57f1ae058862764d2873c9ae43bf0c35.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/cc2e8bc246c2a8614f5c877a62812c2d1bf9097bfdfea5f0c89363a032869848.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/3a405f954e8c3fe8c7ff8ec1cf1fc3b18ab28b6921f7e02c638e7a90ce9dd738.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/1dafeac9e5a490dc4c839d22953c3d1f9e516f60daac2719c921fd5b6f1302d6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/a8486a99421710bf3534bc336732d61ac2da30fcfffc1f81cbe5815add35de7e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/035fa5dda80b16cd47bf9feb0baea1135a840d3decc9205c667fd9d5f262cd23.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/7161760cd5ba5ec21d53043aba95e0c7889ce3587e53a56b683c33a2629d717c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/ec76b2a7eaa45de8c5a93e7a4122af2f217d5f0fa396058a2f40dcae5388fa9a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/b3459b8fdcbf7fc31fc935b4b35b771b670470e252497f771ca774c21f761e60.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/2dd608b55b7e4e4cba657544cc8d976b5b7fcc9d89a876d19f273691417733a6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/7e999092d299a6ca668446130f14d4f633a19c9b0fb2ad432fd93826f5f375c0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/6fd410bf1a5bd6cab3f558804eb2b61c4b5755b0e6f689c7d9d4f4d07f262c9a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/25efdbacfee0ef802c7dcf2eb2394fa37074dd2b680724dfa927859f5c6c14c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/9d9762e009c071acb271784cebdb192ed738fee02b3e81066fd2fa8f981ea738.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/3336b1d14d772f16eacbf11cfc5372b9eadf3e1dac534808900210367c59f82b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/ad1709041fda334d99021a63abe281fe2d6125bdfcd274fba39ec24e39cdced6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/ec425dab109660c12d7c5095ebc629a03c8a5d44f815b6e2ed134315db923762.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100013/8f3ef0f76fab6e62795b472069aa1f86d5c00469766763048ecf81f352e4ffd8.png"
                    }
                ],
                "hotelID": 100013,
                "importantFacilities": [
                    "Estacionamiento",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.860035694413472",
                    "longitude": "-99.88381147384644",
                    "postalCode": "39670",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 163 , Fracc Magallanes",
                    "countryCode": "MX"
                },
                "name": "Krystal Beach Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Aquamarina",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bahía ($)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Palapa ($)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Bar de Piscina",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9527933,
                        "kidsFreeTo": 0,
                        "name": "Double room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260035,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260037,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260039,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260041,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260043,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260045,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260047,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260049,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260051,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260053,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260055,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260057,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260059,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260061,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260063,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260065,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260068,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260070,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260072,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260074,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260076,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260078,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260080,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260082,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260084,
                        "kidsFreeTo": 0,
                        "name": "Casal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260086,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260088,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260090,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260091,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260093,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260095,
                        "kidsFreeTo": 0,
                        "name": "King Bed 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260097,
                        "kidsFreeTo": 0,
                        "name": "Park View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260099,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260101,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260103,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260105,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260107,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260109,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260111,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260113,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260115,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260117,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260119,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260121,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260122,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260125,
                        "kidsFreeTo": 0,
                        "name": "Double Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260126,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260128,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260130,
                        "kidsFreeTo": 0,
                        "name": "King Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260133,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260135,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260137,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260139,
                        "kidsFreeTo": 0,
                        "name": "Single Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260140,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260143,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260145,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260146,
                        "kidsFreeTo": 0,
                        "name": "Double Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260148,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260150,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260152,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260154,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260156,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260158,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260159,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260161,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260163,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260165,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260166,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260168,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260170,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260172,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260174,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260176,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260178,
                        "kidsFreeTo": 0,
                        "name": "Mountain View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260180,
                        "kidsFreeTo": 0,
                        "name": "Family With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260182,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260185,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260188,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260191,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260194,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260197,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260200,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260203,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260205,
                        "kidsFreeTo": 0,
                        "name": "Family Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260209,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260212,
                        "kidsFreeTo": 0,
                        "name": "Superior Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260216,
                        "kidsFreeTo": 0,
                        "name": "Double Room Mountain View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260219,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260222,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260225,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260227,
                        "kidsFreeTo": 0,
                        "name": "With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260230,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260233,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260236,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260239,
                        "kidsFreeTo": 0,
                        "name": "Family Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260242,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260245,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260248,
                        "kidsFreeTo": 0,
                        "name": "Family King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260251,
                        "kidsFreeTo": 0,
                        "name": "Family Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260254,
                        "kidsFreeTo": 0,
                        "name": "Family Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18531907,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18609776,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646048,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646052,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646055,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646059,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646062,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646065,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646069,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646071,
                        "kidsFreeTo": 0,
                        "name": "Triple Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801140,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801142,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801143,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801145,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801148,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891455,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891457,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891461,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891462,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891523,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Puerto de datos",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000469,
                        "kidsFreeTo": 5,
                        "name": "Estandar doble vista a la montaña",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yGSbh932uzmpFAwAhg3m3YesEz8=/720x480/02/07/69/02076919.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yGSbh932uzmpFAwAhg3m3YesEz8=/720x480/02/07/69/02076919.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Puerto de datos",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000470,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Puerto de datos",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1034070,
                        "kidsFreeTo": 0,
                        "name": "Estándar king vista a la montaña",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/NppW3NxVTJdaYh5Il8dqhdzABM4=/720x480/02/07/69/02076921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/NppW3NxVTJdaYh5Il8dqhdzABM4=/720x480/02/07/69/02076921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953032,
                        "kidsFreeTo": 0,
                        "name": "Hab. estándar, vistas al océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953033,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas dobles, vistas a la montaña",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yGSbh932uzmpFAwAhg3m3YesEz8=/720x480/02/07/69/02076919.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yGSbh932uzmpFAwAhg3m3YesEz8=/720x480/02/07/69/02076919.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953038,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande, vistas a la montaña",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/NppW3NxVTJdaYh5Il8dqhdzABM4=/720x480/02/07/69/02076921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/NppW3NxVTJdaYh5Il8dqhdzABM4=/720x480/02/07/69/02076921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198217,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5967784,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10196993,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Puerto de datos",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12672413,
                        "kidsFreeTo": 0,
                        "name": "Estándar king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/eqeSVfAx13CzwbDz1mKo_nDWGyg=/720x480/02/09/09/02090903.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16093755,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16093757,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16093761,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16093766,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Edredón",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16147944,
                        "kidsFreeTo": 0,
                        "name": "Standard Room,1 King Bed, Ocean View",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16455190,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216060,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17604470,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (4-10 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.3,
                    "totalSurveys": 972,
                    "valuesAverage": [
                        4,
                        4.1,
                        4.3
                    ]
                },
                "title": "Hotel frente al mar todo incluido con actividades divertidas para niño",
                "uri": "krystal-beach-acapulco",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos",
                        "description": "Todos los impuestos y servicios están incluidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye desayuno, almuerzo y cena buffet, así como bebidas nacionales sin límite de 11:00 a 23:00 hrs dentro de las instalaciones del hotel. El plan inicia con la comida del día de llegada y termina con el desayuno del día de salida."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades divertidas diarias conducidas por el equipo de animadores."
                    },
                    {
                        "title": "Otros",
                        "description": "Incluye la entrada a un club de playa con servicio de dos sillas, y una sombrilla por habitación de 10:00 a 17:00 hrs, cervezas y bebidas nacionales (sin coctelería) de 13:00 a 17:00 hrs, bebidas gaseosas de 11:00 a 17:00 hrs y snacks como hot-dogs, hamburguesas y fruta de 13:00 a 17:00 hrs.  Transporte gratuito hotel-club de playa-hotel cada hora de las 10:00 a las 17:00 hrs."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye tres cenas tema por semana."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El titular de la reserva deberá presentar una identificación oficial al momento del registro. No se permite el acceso a huéspedes sin equipaje. Los servicios no especificados en el club de playa Plaza Gran Bretaña no están incluidos."
                    }
                ],
                "description": "Real Bananas ACA - Todo Incluido es un hotel todo incluido ideal para familias, localizado en la famosa Zona Dorada. El hotel se ubica a poca distancia del Centro de Convenciones de Acapulco, a 1 kilómetro de la playa Tamarindos y del Parque Acuático El Rollo. Adicionalmente, la central de autobuses está a 4 kilómetros, mientras que el Aeropuerto Internacional de Acapulco (ACA) se ubica a 20 kilómetros del hotel. \r\n\r\nLa propiedad ofrece 116 habitaciones distribuidas a lo largo de un edificio de nueve pisos. Las habitaciones están equipadas con aire acondicionado, balcón, teléfono de marcado directo, televisión por cable y baño privado con ducha.\r\n\r\nLas instalaciones del Real Bananas incluyen una piscina, piscina para niños, solárium y estacionamiento. Para tu diversión, el hotel cuenta con un staff de entretenimiento que organiza actividades divertidas cerca de la piscina. También ofrece transporte ida y vuelta en cortesía, y acceso al club de playa con servicio de bebidas y botanas, sillas plegables y sombrillas. Asimismo, este hotel todo incluido ofrece dos bares, un restaurante internacional y un restaurante italiano.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 226269,
                        "description": "La propiedad se encuentra en la Zona Dorada de Acapulco",
                        "cloudUri": "https://img.cdnpth.com/media/vG60DbwsZ1kYuJuqzTkPOvx71GU=/720x480/00/22/62/00226269.jpg"
                    },
                    {
                        "photoID": 226268,
                        "description": "Real Bananas ACA - Todo Incluido",
                        "cloudUri": "https://img.cdnpth.com/media/mq58I96cFdrJX6LjdHzwtKXFBds=/720x480/00/22/62/00226268.jpg"
                    },
                    {
                        "photoID": 226271,
                        "description": "El hotel es ideal para viajes en familia",
                        "cloudUri": "https://img.cdnpth.com/media/E8cXQb1z2XLL57iBgFHoIW1Whlg=/720x480/00/22/62/00226271.jpg"
                    },
                    {
                        "photoID": 226264,
                        "description": "Piscina para niños en la terraza",
                        "cloudUri": "https://img.cdnpth.com/media/l6TizxW0MxEzzybGC44qb_kMr94=/720x480/00/22/62/00226264.jpg"
                    },
                    {
                        "photoID": 226259,
                        "description": "La piscina cuenta con área de descanso",
                        "cloudUri": "https://img.cdnpth.com/media/6MZdvTXTjKqFfjQxxKMmnH5JVQY=/720x480/00/22/62/00226259.jpg"
                    },
                    {
                        "photoID": 226260,
                        "description": "La piscina está disponible para realizar banquetes",
                        "cloudUri": "https://img.cdnpth.com/media/ONe1MXA_2SSV317yeDtsxO-lWGQ=/720x480/00/22/62/00226260.jpg"
                    },
                    {
                        "photoID": 226266,
                        "description": "El restaurante Dominico's sirve comida bufet",
                        "cloudUri": "https://img.cdnpth.com/media/R3v4ro6Ar5jzl8yEAFaT2F-CTps=/720x480/00/22/62/00226266.jpg"
                    },
                    {
                        "photoID": 226272,
                        "description": "El hotel cuenta con dos restaurantes y dos bares",
                        "cloudUri": "https://img.cdnpth.com/media/JoHBIBoAjE8mxxnirRo8RUBG39I=/720x480/00/22/62/00226272.jpg"
                    },
                    {
                        "photoID": 226263,
                        "description": "Comida bufet junto a la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/QHe6YZNfA6QFfCAV6XubZEvcWBI=/720x480/00/22/62/00226263.jpg"
                    },
                    {
                        "photoID": 226262,
                        "description": "El bar ofrece bebidas nacionales",
                        "cloudUri": "https://img.cdnpth.com/media/rrrjsocc7KKE7o3GkBuGqiAD4KE=/720x480/00/22/62/00226262.jpg"
                    },
                    {
                        "photoID": 226270,
                        "description": "El bar Salsa se ubica en la terraza",
                        "cloudUri": "https://img.cdnpth.com/media/Ap5XpbeBp54M_8XwTCEjho76RDs=/720x480/00/22/62/00226270.jpg"
                    },
                    {
                        "photoID": 226265,
                        "description": "El club de playa tiene camas plegables y sombrillas",
                        "cloudUri": "https://img.cdnpth.com/media/xOxJAGYZ4UtPCKHx0PtUw6Xx0Bw=/720x480/00/22/62/00226265.jpg"
                    },
                    {
                        "photoID": 226276,
                        "description": "El hotel brinda transporte al club de playa",
                        "cloudUri": "https://img.cdnpth.com/media/awexEa3zsumaHiMC4XDs8UFKkY0=/720x480/00/22/62/00226276.jpg"
                    },
                    {
                        "photoID": 226267,
                        "description": "El programa de entretenimiento ofrece espectáculos nocturnos",
                        "cloudUri": "https://img.cdnpth.com/media/6TuByJIIACwbr1gVtGPoTK-Zf7k=/720x480/00/22/62/00226267.jpg"
                    },
                    {
                        "photoID": 4863560,
                        "description": "Vista de una habitación",
                        "cloudUri": "https://img.cdnpth.com/media/eFzFaBr_JPrFdUePlJEvG1GrGzI=/720x480/04/86/35/04863560.jpg"
                    },
                    {
                        "photoID": 4863561,
                        "description": "Habitación estándar",
                        "cloudUri": "https://img.cdnpth.com/media/YfK_bXlWBvnN7Wwnx05PlUXvUEk=/720x480/04/86/35/04863561.jpg"
                    },
                    {
                        "photoID": 4863562,
                        "description": "Habitación con dos camas",
                        "cloudUri": "https://img.cdnpth.com/media/83Tf33A21lmU93PIlNwjzO2RI6E=/720x480/04/86/35/04863562.jpg"
                    },
                    {
                        "photoID": 4863563,
                        "description": "Balcón de una habitación",
                        "cloudUri": "https://img.cdnpth.com/media/LjxomfLdCOt7m2s8UiIHf9ENvng=/720x480/04/86/35/04863563.jpg"
                    },
                    {
                        "photoID": 226274,
                        "description": "Baño de una habitación estándar",
                        "cloudUri": "https://img.cdnpth.com/media/XZwO4g30eNSFUHhyffGfSB9Pj2c=/720x480/00/22/62/00226274.jpg"
                    }
                ],
                "hotelID": 100137,
                "importantFacilities": [
                    "Estacionamiento"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.857414853725363",
                    "longitude": "-99.85305726528168",
                    "postalCode": "39690",
                    "state": "Guerrero",
                    "street": "Av Monterrey 195, Fracc Club Deportivo",
                    "countryCode": "MX"
                },
                "name": "Real Bananas ACA - Todo Incluido",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Bananas Daiquiri",
                        "type": "Bar"
                    },
                    {
                        "name": "Dominicos",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Platanar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Salsa Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1001030,
                        "kidsFreeTo": 6,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/rWujLvcELYF-fzFNkq-5j09hwYg=/720x480/04/86/35/04863559.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/rWujLvcELYF-fzFNkq-5j09hwYg=/720x480/04/86/35/04863559.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8350555,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/rWujLvcELYF-fzFNkq-5j09hwYg=/720x480/04/86/35/04863559.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/rWujLvcELYF-fzFNkq-5j09hwYg=/720x480/04/86/35/04863559.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073259,
                        "kidsFreeTo": 0,
                        "name": "Villa Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073261,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16073263,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16350349,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218483,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218533,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218540,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218547,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218556,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Transporte al club de playa en horarios establecidos",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4.3,
                    "totalSurveys": 327,
                    "valuesAverage": [
                        4.1,
                        4.5
                    ]
                },
                "title": "Hotel familiar en la Zona Dorada de Acapulco con entretenimiento",
                "uri": "real-bananas-aca-todo-incluido",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [
                    {
                        "alterId": 6639,
                        "priority": 100,
                        "startDate": "2020-12-11T06:00:00+00:00",
                        "endDate": "2025-12-31T06:00:00+00:00",
                        "title": "Estacionamiento",
                        "description": "El servicio de estacionamiento tiene un costo de $190.00 MXN por noche, por vehículo, a pagar directamente en el establecimiento."
                    },
                    {
                        "alterId": 8246,
                        "priority": 100,
                        "startDate": "2024-06-14T06:00:00+00:00",
                        "endDate": "2024-12-31T06:00:00+00:00",
                        "title": "Aviso",
                        "description": "El acceso a las cabañas de la playa tiene un costo extra. El acceso a la piscina Infinity tiene un costo de $500.00 MXN reembolsables en alimentos y bebidas."
                    }
                ],
                "allInclusivePlan": [],
                "description": "Hotel Emporio Acapulco es un hotel frente a la playa con arquitectura moderna y estilo minimalista. El hotel se localiza en la Zona Dorada de Acapulco, a sólo 200 metros de la playa Condesa, a 2 kilómetros del Centro de Convenciones de Acapulco y del Parque Acuático Cici. Adicionalmente, el Aeropuerto Internacional de Acapulco (ACA) se sitúa  a 17 kilómetros del hotel. \r\n\r\nEmporio Acapulco ofrece 422 habitaciones, todas ellas con balcón y vista al mar. Las habitaciones están equipadas con aire acondicionado, teléfono de marcado directo con buzón de voz, caja de seguridad, cafetera y acceso a internet inalámbrico. Además, los huéspedes Privilege club tienen amenidades especiales dentro de la habitación y acceso al lounge ejecutivo, donde se ofrece desayuno continental, así como canapés dulces y salados acompañados con una copa de vino, refrescos o té. \r\n\r\nHotel Emporio Acapulco cuenta con acceso directo a la playa y tres piscinas, una de ellas la más grande de la bahía de Acapulco. El hotel tiene además un spa, sauna, jacuzzi en el solárium, gimnasio y actividades supervisadas para niños (servicios temporalmente fuera de servicio). Para viajeros de negocios, ofrece un centro de negocios, acceso a internet inalámbrico y salones de eventos con capacidad para 800 personas. Asimismo, Emporio Acapulco cuenta con un restaurante de platillos mexicanos e internacionales y un bar.\r\n\r\n***El hotel es 100% libre de humo de tabaco.\r\n\r\n***El acceso a las cabañas de la playa tiene un costo extra.\r\n\r\n***El acceso a la piscina Infinity tiene un costo de $500.00 MXN reembolsables en alimentos y bebidas.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/c9b13d58b4f1ae37a886b0ebdb6ab1f72e900e5d4cf80c9e9d2e3884816535b2_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d47d71dd3a9c1749235fe108eb4f6ebfeecd5c91b85a993b6e9eb286e6625636.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/416b9fb04eb6bb4690707534664660cd5ed1e9e8f30312128f52704ae21314bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/6b23bab0571dc548ca57765936238353393f2ebf52e812de9a2a774dcadc6f46.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/9a074ebaecf37de4a1fe34d717bca649fd31a794b9bd9550b56a568dc0860c40.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/6e53c6e080b810273116d7d438ae1a2136e6bac1f638c10f79d2f649425f064b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/0b3cd46adb2ec1c1091d88e3ff82d54151a84c9b21429987950a6fe2a9f0290e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/2880f7f009636489d6c23c7ba79c100a98f918e1ecea3c94ec3f4d613bfd6343.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d913c27f153433a0032744942f4bd718782603221c82b3802521888352b1b63d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/c0bf5844155355bc1b76c3e55a620ee015f35afe25731a6bfb3ec625681fb618.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/577afbf240aa3e9909e3ca11620dc7bfb1494a19c2066793c4ac801cd78d936b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/8efc279ad4c9e007727a520bc56c92112b2db87eeba84e260d9e6e9a4d85a53e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/2a385101622d79c7e6a8c01ecd4d76103b6c0ed5870cbdc20888fdff458c9db5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/6fa382359cb5feaafd3828fb24a3d337944294d4465b80f6a8b2ba0fd19b0f10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/23d74596c0e31b2ebf60f424425c16212fe98151d27ddeadb0519359d005d3fd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/4dcb150834725e999f7f4b17814c4343d1921d051fb94e97862ef3f6eea4857d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/cb375ff2ffccc94b08fb45073b1aaf793895e999d66076099f8c0506576bb8d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/0f0e2f73eb8f4fc5bc1559feb60f8d412193ffd5a327245c11b7137bc473de7b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/b480f2a6514e6308c36a6cccd44a44914310746008b583fc2eae74068325e6c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/ed4f975f0e7e9ff691cb1548132130175e37a4659e363819b364a36a13269e17.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/fdd6995512653a8da2cfc9942b2baa0277851a40234e33eb206242dd20c33fc0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/b111a9839f0be91657482ee565a7adb6527396e90e5f2badd038547960f815ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/b7dcf3dcaa39a300006c8573bfea068f6287ef247e7b995ce99ca009192dd281.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/22daaacba77c0b92cbb9c44f8a6ed94077a1ddeb6fff671aad1118ef03245ef3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d634ccf1e7af7e9c43b792ae9f35bc867a1878d46f865693234a4248bc2a0369.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/a225bafee25e5820597c183bd181401fcf4d7e81954fe849f29b7ff8717045db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/b2673a7c8586ba29309614b3d195abfbe9f8198ece6a357b2f05a636b253ce7a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/94a8862e902631577652ecd458a2fa348f151b70c6b54dd2a0813a2f1023815d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d9c9188a7152fc0e9f59d3f58510dfd699ad85dcd33ce6eaa748d0ec587ee047.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/be8f83ed1c991f862f638afb3172213b058feeeb9637cde78d7fffa5ac83f0b1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/1726a08d892ce3d3ccc4b8ef370e343ecbb06585a85c0408a90b20f415b416d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama grande y vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100269/71ad3b3b6061d0e35cd493546828ae1c5baf1f6ad3ce0dd136c25e4a493f7756.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/0660d55ee44c9a0ddd9a45f7deb60077b9fbd1d77d897f8bab7d5cab553be88b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100269/cfe84102ef656c926a3ac7d2914f395406863abb8df0d88b7dd87f063f99ecb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/3623718bbb15fc207491d191d5ebdcdaae0a8e9b48afc052d65207eb801b2824.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d1bbb44c620035bfdea737abbd857be18e2292f954188045485a27d7f6434d58.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100269/1bf68a8e59b04963dee612ee32621e9391e0619545e4757ed0023e288d7eea34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/b72167822cdb7202c3288f1681cd27ab9e4e3f09b2fd65270a0c0d0411ac552c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/f4b9e61bc85c2e05ba0a1ab4079d5a77bf222f31d83b61663468b51e4a03492e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/9c6d86c70e29df0ceb5bef0a81f8c96c1ddc84d6a0e753d5342c5f266814993f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/f03b9b52df098da0488f612f3937c2b253fda58c7ab7eeae5d2197264b68da42.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/625f4602d95f862991106d878f13a6610c6b6ba249b9cc569ad0478c15bd5b1e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/7dee52a69078c4d3e72dec6fd2b86070f9aa7c7c0f3d7c40f37df5764bfec465.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d750a64215c6124087158b10aa9e0272ac0e13c05824da28343e3eea96b93290.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Club Privilege con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100269/d2b9f36acac99ae118161fff96dc9e334c2bd265b4d822d29592a9b45d8fede6.png"
                    }
                ],
                "hotelID": 100269,
                "importantFacilities": [
                    "Alberca más grande de la bahía",
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.85896785381738",
                    "longitude": "-99.87383365631104",
                    "postalCode": "39670",
                    "state": "Guerrero",
                    "street": "Av Costera Miguel Alemán 121, Fracc Magallanes",
                    "countryCode": "MX"
                },
                "name": "Hotel Emporio Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Condimento",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Isla",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276864,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276866,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276867,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276869,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276871,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276873,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276875,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276877,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276879,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276881,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276883,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276885,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276887,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276889,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276891,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276893,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276895,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276897,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276899,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276901,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276903,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276906,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276908,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276910,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276912,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276913,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276915,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276917,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14276919,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303396,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303397,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303399,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18303400,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18332454,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429710,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645950,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18701339,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18745493,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870481,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18919979,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19318362,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19921537,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Radio reloj despertador",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000138,
                        "kidsFreeTo": 3,
                        "name": "Superior doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/mBxPrzqF0pjR7ZrF-LOtZHiDiMw=/720x480/04/82/08/04820887.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/mBxPrzqF0pjR7ZrF-LOtZHiDiMw=/720x480/04/82/08/04820887.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000140,
                        "kidsFreeTo": 3,
                        "name": "Privilege club king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/prEhqofH-GcUt9HK4N_BLYhviPg=/720x480/04/82/08/04820877.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/prEhqofH-GcUt9HK4N_BLYhviPg=/720x480/04/82/08/04820877.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Room service (24 hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952916,
                        "kidsFreeTo": 0,
                        "name": "Superior Queen with ocean view",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/6vUITdQh_B970-4wr5_-1IncgCA=/720x480/04/82/08/04820888.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/6vUITdQh_B970-4wr5_-1IncgCA=/720x480/04/82/08/04820888.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Albornoces",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Habitación en planta ejecutiva",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952917,
                        "kidsFreeTo": 0,
                        "name": "Suite Privilege Club King Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/prEhqofH-GcUt9HK4N_BLYhviPg=/720x480/04/82/08/04820877.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/prEhqofH-GcUt9HK4N_BLYhviPg=/720x480/04/82/08/04820877.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968247,
                        "kidsFreeTo": 3,
                        "name": "Privilege club doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IUeEYoCRN55Rj1ZLR6u1sgk2ww4=/720x480/06/16/80/06168040.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IUeEYoCRN55Rj1ZLR6u1sgk2ww4=/720x480/06/16/80/06168040.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Fan",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Ironing set",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8347091,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8351016,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Radio reloj despertador",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10160026,
                        "kidsFreeTo": 3,
                        "name": "Superior queen - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Q_ELFvyaVcjlqSKjb97wD-DskNw=/720x480/04/82/08/04820889.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Q_ELFvyaVcjlqSKjb97wD-DskNw=/720x480/04/82/08/04820889.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581176,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079682,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079686,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079689,
                        "kidsFreeTo": 0,
                        "name": "Triple Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079691,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079694,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079699,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079700,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079702,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079703,
                        "kidsFreeTo": 0,
                        "name": "Estudio Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079705,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079707,
                        "kidsFreeTo": 0,
                        "name": "Estudio Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079709,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079710,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079712,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079713,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079715,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079717,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079718,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079721,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079723,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079725,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079727,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079730,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079732,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079735,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079736,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079742,
                        "kidsFreeTo": 0,
                        "name": "Individual Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079743,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079746,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079749,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079752,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16079755,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16268467,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16268468,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16268469,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Number of beds - 2",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16405886,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16710676,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16710677,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061796,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061797,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061798,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061799,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061800,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217893,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217900,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17217904,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV LCD de 42 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17489570,
                        "kidsFreeTo": 3,
                        "name": "Superior king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/LZdPDL2mMS3vYiuebGGujCOHucQ=/720x480/11/88/02/11880220.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/LZdPDL2mMS3vYiuebGGujCOHucQ=/720x480/11/88/02/11880220.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV LCD de 42 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17490536,
                        "kidsFreeTo": 3,
                        "name": "Junior suite 2 dobles vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/mBxPrzqF0pjR7ZrF-LOtZHiDiMw=/720x480/04/82/08/04820887.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/mBxPrzqF0pjR7ZrF-LOtZHiDiMw=/720x480/04/82/08/04820887.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17511128,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17604739,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17950058,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17950059,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18003688,
                        "kidsFreeTo": 0,
                        "name": "Suite Privilege Club Doble Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18003689,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Double Beds Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18003690,
                        "kidsFreeTo": 0,
                        "name": "Superior King Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Horno de microondas",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "TV de pantalla plana"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18328250,
                        "kidsFreeTo": 3,
                        "name": "Estándar king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/i-sr1UuhgtpazsT5xcqxaZLQkz4=/720x480/12/43/14/12431453.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/i-sr1UuhgtpazsT5xcqxaZLQkz4=/720x480/12/43/14/12431453.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Horno de microondas",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "TV de pantalla plana"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18328251,
                        "kidsFreeTo": 3,
                        "name": "Estándar doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zmWFROFKv8NBN2nzNemztlOOolA=/720x480/12/43/14/12431452.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zmWFROFKv8NBN2nzNemztlOOolA=/720x480/12/43/14/12431452.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18422114,
                        "kidsFreeTo": 0,
                        "name": "Standard Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18422115,
                        "kidsFreeTo": 0,
                        "name": "Standard King Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Caja fuerte",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Servicio de limpieza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482612,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482613,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Servicio de limpieza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482614,
                        "kidsFreeTo": 0,
                        "name": "Habitación Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18919985,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Cafetera / Tetera",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19921538,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cabañas en el área de playa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 890,
                    "valuesAverage": [
                        4.4,
                        4.7
                    ]
                },
                "title": "Hotel contemporáneo y minimalista en la Zona Dorada",
                "uri": "hotel-emporio-acapulco",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "One Acapulco Diamante es un práctico hotel a 500 metros del centro de espectáculos Forum Mundo Imperial. La propiedad está a 13 kilómetros de la Costera Miguel Alemán, que ofrece una amplia variedad de restaurantes, bares y discotecas. El aeropuerto internacional de Acapulco (ACA) se sitúa a 2 kilómetros de distancia.\r\n\r\nEste hotel cuenta con 126 habitaciones en las que ofrecen wifi gratuito, baño con ducha y aire acondicionado. Sus instalaciones disponen de salón de desayunos, una barra deli y estacionamiento. Además, tienen área para trabajar, sala de reuniones e internet inalámbrico de alta velocidad.  **Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/8f3fa8c1e5171f1a013fb27a3c670354f84f1bd9bc5605b271e32e5c9df619fa_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/319364/985b5adc8b8f9df3738feec0259ba75655fd42474b1eb5cfb8a01c86f5b114b8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/b03580570d1d319955ac6dfb540b97275b53f957d6993f7847dbb588bea6eaab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/347cfba2bb8f91110777cb7d0b8dbbefa8f7b1ed2f7ed4f8d22ff81e5a8202c4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/6af6fdea91f6715d63ee9579b900e810b2e63251e397224bfb56ee404e059b58.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/36f2e62f65cfe7de1ff9f4c7230a7c555be884e1566e180a0620ae8d00dcfdb5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/54824843c1525128ee432f1386d6eb2108a3b581c2a5e6a2872d4e9bc1a304a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/8e063d9c17183c79a708bb68cc894710c9e5c2fb59b210c37ef94a9129bf1089.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/6e853ef0572b1bb55b992df2d1da6ea425139de0e89135500917f9967cb9b3f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/9e5fa4a6ebc1e3eb30add666b96e91b42af10fe6cf91e9c7c4259016e06b7e5c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/a5649f02e03305717057befae9c276374fb3a5e9bc389b2103cc2585d80757c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/591e2869a1440c37ea0f0d6bcef3ae445dbe25b80a5e4cc8a42fc87177ef2cc7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/53f63fe7e116cb865937278fa7c8f79aca5ff7f9c33d239b0dd4745f6ce813e5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/d934ab4851a3d7ca2ac0331ff2de63bd000dfeb66227703308eb531cf6a02729.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/e5cdd8f2d04956593a5b157d8b4ce6f8584531e8a072d00ef2db06413792f79d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/0558e23f06e9e9f6a3771e6334329bb65f63cd3c2a7f88301d6df11c064bfbc1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/f3034810c2198924ce7573e876053103fe24f762a3422683d9b6dc803de0fc5e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/99babd162b2bd4b010748b5118687dcc5121a124e79d8b2ac0738dd619b765cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/76992dadcc685ccce883196b6c3ccf4c1ccca71d3f624f5b3ca9d1aecc9839ec.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/b9512ceb048af9039b16b30de27821780de089dda4affda129aa0214a5f7b094.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/5b0c884e5589bec9fa4994b939b20e9f2f94b3894e00ae4482af94686de60725.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/741b1087c2082ce9452ab6d077a9683e13e366824963a60947af21bc5d652884.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/8fa86e8c8005301dd5e94055b9dc49faa3852882bfdb194f0b4f188b77e7016a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/d8c22290d03b290c5c0d2aa8d323646594a2abbc8f8f217b406de62e1391a407.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/2c91281dde172a74f3cc1f118d6cb515298d3ceedf5c1afa936f04564eb02cf9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/17fbc3c6cb5c834e33fe78b4acfb9f46e86d3c6251ad6fd9616b548e6a1b7035.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/319364/98eab66a30fc079398712e79f5233f4774da3f2834d8527df607428283e59cb1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/c7e35556cf49dd3d7fbf3883e340fb5af7ea54c9831b9c5ee1f6b5e311410f08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/4e1d937639db7606e13799041f5aaa517bf4daa69bd77580422cd45cdbcd4632.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/683628d27123c949912216da2597399e956285353760738c82bc2631df18b277.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/5c2c97b5b6dd35528a6c34890822ddca36cd0fd0b700a026bc2b62c337cc6350.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/762cc2585e019ba9f101f06c96fa26997513b0e69c6f32d5ab5fd398aa5abf97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/cde06914f1afe6110e551674acdee6c3a8fa6718ffb513b459d44bee62607ae4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/5c1af040c5bf2fb3cffbaead498659bc041e2129cd2e00080f3c7a291dc2aec4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/1730d5efca3901f442edfc7bcff08a0c9b7ccd792ad24888ec314f94f33c4cb8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/51c0aa742ec330ad51f9037fcf079bd5690727957ea94fa1cc57978036cd6ccd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Estándar - 1 cama grande ",
                        "cloudUri": "https://img.cdnpth.com/media/319364/d68af06ca783a61705e5895fe098a67196be87dbe01c13e42cc4232cbf3d3610.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/add237c82053150afde0eab04fb28e94f815788950976b27a28dc84e8dbe430d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/f94dd1db9d670dc62dde9a60a57e095780e6a2375e05613cbdf6e748f12ecdac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/2d71a097aa11c323c7ae80c965301a796795c556e1ca514178d455295603772e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/45287d163b42e480c72b7aa5c73a971710858cf1a209b85070d283e9536d2739.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/1a392f65923ad7e9c0c3d71ff3f9c83d89ff56f79b2aba0ba52e3eb52ad640c4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/15a7ccb96072a332df3f70f2d9c7b337a485b075cf8076bb48fc0c5e94aca1fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/9aca375db6638850538decc8f60d592ff412cbabb6b802fa7cc7067fd6a3ef6d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319364/824b913b90fe3fcde33a10851275c4966cc34440fa3b5f0cb9699d5127133ab0.png"
                    }
                ],
                "hotelID": 319364,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.771189255123353",
                    "longitude": "-99.77177023887634",
                    "postalCode": "39931",
                    "state": "Guerrero",
                    "street": "Blvr de las Naciones 10, UH Vicente Guerrero 200",
                    "countryCode": "MX"
                },
                "name": "One Acapulco Diamante",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 398636,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 11
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Salón de Desayunos",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12338012,
                        "kidsFreeTo": 0,
                        "name": "Superior Room, 1 Queen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747480,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 2 Double Beds Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747481,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 1 Queen Bed Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747482,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 2 Double - Room Only",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747483,
                        "kidsFreeTo": 0,
                        "name": "Superior Room, 1 Queen - Room Only",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747484,
                        "kidsFreeTo": 0,
                        "name": "Superior Room, 1 Queen - Bed And Breakfast",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747485,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 2 Double - Bed And Breakfast",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747486,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 1 Queen Bed Non Smoking Queenbed - Bed And Breakfast",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747487,
                        "kidsFreeTo": 0,
                        "name": "Superior Room 2 Double Beds Non Smoking Fullbed - Bed And Breakfast",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747488,
                        "kidsFreeTo": 0,
                        "name": "Double/Double - Superior - Room Only",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12747489,
                        "kidsFreeTo": 0,
                        "name": "Double Room - Superior - Room Only",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5408065,
                        "kidsFreeTo": 5,
                        "name": "Superior 2 dobles",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/WVIttzgXfTBNB6YyL8QNWn7G75s=/720x480/03/30/61/03306120.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/WVIttzgXfTBNB6YyL8QNWn7G75s=/720x480/03/30/61/03306120.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5408066,
                        "kidsFreeTo": 5,
                        "name": "Superior queen",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OPVU05R4MgUYtn39GTycTEWTVoc=/720x480/03/30/61/03306133.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OPVU05R4MgUYtn39GTycTEWTVoc=/720x480/03/30/61/03306133.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cabezal de ducha de mano",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "No fumadores",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6033214,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 1 cama de matrimonio, no fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Cabezal de ducha de mano",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "No fumadores",
                            "Sábanas no disponibles",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "2 camas de matrimonio y 2 camas dobles",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6033215,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 2 camas dobles, no fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8350615,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8350648,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439197,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439203,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439206,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439213,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439219,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439224,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439227,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439231,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8795788,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730423,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730430,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730435,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730441,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730445,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730451,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730459,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Housekeeping",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730463,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Los niños comparten la cama con sus padres",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Cama sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10730466,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Animales de servicio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Lavandería de autoservicio",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Sala de reuniones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 4.1,
                    "totalSurveys": 447,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel de negocios a 2 kilómetros del aeropuerto",
                "uri": "one-acapulco-diamante",
                "tags": [
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }, {
                "isActive": true,
                "alerts": [
                    {
                        "alterId": 7398,
                        "priority": 100,
                        "startDate": "2022-03-08T06:00:00+00:00",
                        "endDate": "2024-12-31T06:00:00+00:00",
                        "title": "Cargo por servicio",
                        "description": "Todo servicio de hospedaje genera un cargo de $250.00 MXN por concepto de resort service por habitación por noche, que son obligatorios y deben pagarse directamente en el establecimiento al momento del registro o de la salida."
                    }
                ],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno, almuerzo y cena en restaurantes participantes (sujetos a disponibilidad de operación). También comprende una selección bebidas alcohólicas solo para mayores de 18 años de 11:00 hrs a 23:00 hrs  (sujetas a disponibilidad)."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Los beneficios de todo incluido vencen en la fecha de salida a las 12:00 hrs (medio día). El servicio a la habitación aplica un cargo por entrega de $200.00 MXN."
                    }
                ],
                "description": "El resort Princess Mundo Imperial Riviera Diamante Acapulco se localiza en un escenario de 194 hectáreas en Playa Revolcadero en Acapulco Diamante. El hotel está en frente de las arenas doradas de la costa del Pacífico y está rodeado de una laguna con agua salada y jardines frondosos habitados por cisnes, flamencos y aves tropicales. El resort está ubicado a 13 kilómetros de las atracciones de la famosa Zona Dorada y a 8 kilómetros del Aeropuerto Internacional de Acapulco (ACA). \r\n\r\nEste hotel dispone de 200 habitaciones, cada habitación tiene una terraza privada con vistas al Océano Pacífico y a los jardines. Las habitaciones cuentan con aire acondicionado, piso de mármol, amplio clóset, televisión de pantalla plana con canales por cable, caja de seguridad, teléfono de marcado directo con buzón de voz y un espacioso baño. El hotel acepta máximo dos perros por habitación cuyo peso no exceda los 9 kilogramos (aplican cargos y restricciones).\r\n\r\nLas instalaciones incluyen tres piscinas y gimnasio. El hotel dispone de un bar en la piscina y dos restaurantes que sirven comida internacional y especialidades mexicanas. Se ofrece acceso a internet en las áreas públicas.\r\n\r\n***Todo servicio de hospedaje genera un cargo de $250.00 MXN por concepto de resort service por habitación por noche, son obligatorios y deben pagarse directamente en el establecimiento al momento del registro o de la salida. \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/013bec1fa609028f37b7dc7c5b4da2ff66fbfc27247d0372b80c549ed847b736_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/79d35db84be5b251a5b3f53754cdd1ad87ff5b689eef71af95516278b44cc8dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/3e2df723463b1f64e58255eaa4fbd4435437fcd9beacdaf57d685fd4e4ec2295.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con vistas al océano ",
                        "cloudUri": "https://img.cdnpth.com/media/101212/dd7fcf587861bb3350d26282af3f71e4a4466f6cc68687e6f2c04de6f82becea.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/c0def3fa9473f6236442077efc857896a67054e3a0a315d1069f30749e2e8a9b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/9866f75ff264bda76f6841a21fc45203cd15dc98e92e182f3c2e79d2c274991c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/fc3283986f02f4e63099bc317ca3d171d3fd17f5217fdd671c7f6c202e4d3d9c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/bee36a5f8db5e0a10df85e2159317844ef2a5b82e2f78f5d2e7fcce16fdf168c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/1a62f6f1ebeaae6419c460db1eb17220065d1f4cf8507591c6bccebed86fd029.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/1db0141b8c2d6c9a79e29930822034009ebe7aea6cc47981f489715a59e10e10.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con vistas al océano ",
                        "cloudUri": "https://img.cdnpth.com/media/101212/9190a16cb6eb0af6b48a14f95ed73c35c531eb70124e9d9ff4bb5e16e43839bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/02bb9a7aa7443ed5d892281e79bdd63b5870b3e9357e5ef57ae7712c3073912a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior Pirámide con vistas al océano",
                        "cloudUri": "https://img.cdnpth.com/media/101212/b64d5baa5f6199489607e5cf5c66a355691cabf7598bb02c4599497b24f269a6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/8baa06646ba525f89be8ad7037d1b6ec93baedb87c10ebc22613de4a0936031f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/686efa0661eb51b4c109b2c3cf68c1d9e789031b71abccb752b9d130c556cab0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/328e520d536e6ee00e03a869ad98b58c18746bf7d9ee8fef1336b3f04d8b3ea5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/28261152cb1eb519e3fd78ae98253e38d47452248c5849f4cf7d7787230ddfc3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/e8d491d0dd720e2c6e56c8e495ae78ae6dc00519128f9c70cd72aa8bb78afe3e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/9ac98b494c913832a754508a45a15565f1d6acdcdf28687c1d23d6d4cfb794a5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/3198713568014c50edd117fd8747ae68f4d3e6db72ea113b4358ab7a227eb75e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/85c2bd0a1f76d4e483851c1443eb85d5ae4e79b5918f71e90761fed872a03364.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/4461d05d0806e9be46c10b66c159e8ec2ce4cefa6d72171e14d4bee649d6f492.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/fb42be59bff70107ac6df929c5b7e2e3db9dfb250bd36cd363d4b72a7cdd0849.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/c5712497567a271b657e7fdc2d8f85b356afc6f254056ed7268820274c2510c0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/6ae6c1961a837e1fbc4dc083286cfc8b24e1c8fae3a0c3148cfa5b26ad6643f0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/b72f43ea04e18a75f061dd3546681bfe2fa69984ee2a2dba28972c4c1a033666.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/af818eb91fbff1613e8156f4b408393564bf0abd527f1d05b76098879de49ff3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/6cb53b1fec3aac7bbcc554e27613e90fa18147b95d816e06fa52c9429fb25ba6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/1c40341969e3ff101a6eb0932ce06615856b4c8b33bfe9f43470518d580354cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/bae959d1b2ec3aa0d8623045cee616b2b215553267f05b215477869c624f833a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/a28f80b59c025676672cca07fcdb913b370d41b07486d4c27c7016eb17faff0f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/db26cca239fa5b168841153302de2d3af076a4697443f83e9bd1b76a91822aad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/0375463d3330fab2410f4aee06f867c0e3bd2495ae8a97e8de94acb34a70274c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/bf724f067c81aa38cb66c577f88507947f990d55535056f1b1fffb83835b1fcd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/0d51e855d15a4d5b5804159cfb97d800d2e0cf86e5021d056eccc485aa7d0d7d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/6e3e883b98a048cda7e81dad6620d28524e8f0cd661f8722cf2682e2c3232a8d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/afd81340276f0c3953d0e9ebf5b9df8d8c4e13a0bc5dd245ba3b7c9a5f02c822.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/fc395c01f562b7491ab9b05a5a03d1fafa63813301dab14b4950641a02d99821.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/eaac410f179b1a64cd4314a68c91c4eda6425d2ca8a5ecb1337c3cee7813c5ea.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/4a4de49fd5b0e739f8b767a71102021de08957fc197f490b5f5246fe72f90190.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/4ebeef2a62a850eab5a560eb383459993123e4e4c2ab15c64384c66f487535c2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/6fe38f20c4f9a5c280ee3ac77eae656bbfdf0468773bae6d18fbad3d0855929e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/a437a42744a21a55a39ffc04d1adc9aa65d8b8140c5f0a7d23a1ce4a625fc187.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/37633e3b25077efad4ab24f1e997bb36b32e5c8542835ca04ce309011d05d237.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/101212/6c214bf548ca4f7bc6c9ce83a1db41513f9e7306583236fcfaafc8c40f009eab.png"
                    }
                ],
                "hotelID": 101212,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Acapulco",
                    "country": "Mexico",
                    "latitude": "16.78926796342859",
                    "longitude": "-99.81453537940979",
                    "postalCode": "39890",
                    "state": "Guerrero",
                    "street": "Playa Revolcadero s/n , Col Granjas del Marqués",
                    "countryCode": "MX"
                },
                "name": "Princess Mundo Imperial Riviera Diamante Acapulco",
                "placeContainers": [
                    {
                        "id": 53862,
                        "uri": "acapulco",
                        "displayText": "Acapulco de Juárez, Guerrero, México",
                        "type": 6
                    },
                    {
                        "id": 69360,
                        "uri": "acapulco-area",
                        "displayText": "Acapulco (y alrededores), Guerrero, México",
                        "type": 3
                    },
                    {
                        "id": 398636,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 11
                    },
                    {
                        "id": 404518,
                        "uri": "aca-acapulco-de-juarez-guerrero-mexico-aeropuerto-internacional-general-juan-n-alvarez-rng",
                        "displayText": "ACA Acapulco de Juárez, Guerrero, México - Aeropuerto Internacional General Juan N Alvarez",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Beach Club",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Azul",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476290,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476322,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476354,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476384,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476414,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476441,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476468,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476496,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476523,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476550,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476577,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476605,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476633,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476664,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476695,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476725,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476752,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476775,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476798,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476824,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476850,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476875,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476901,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476927,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476954,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476981,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477009,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477035,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477060,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477087,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477115,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477147,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477176,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477204,
                        "kidsFreeTo": 0,
                        "name": "King Bed Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477230,
                        "kidsFreeTo": 0,
                        "name": "Suite Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477256,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477284,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477314,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477343,
                        "kidsFreeTo": 0,
                        "name": "Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477373,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477404,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477437,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477469,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477501,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477534,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477564,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477596,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477630,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477662,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477693,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477724,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477757,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477789,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477826,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477863,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477899,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477933,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477967,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477999,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478031,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478063,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478094,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478125,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478158,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478190,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478221,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478253,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478286,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478317,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478346,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478378,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478411,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478442,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478473,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478506,
                        "kidsFreeTo": 0,
                        "name": "Courtyard View",
                        "isActive": true,
                        "view": "Patio interior",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478538,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478573,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478605,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478634,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478664,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478695,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478729,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478761,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478792,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478822,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478852,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478883,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478913,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478942,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478971,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479000,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479030,
                        "kidsFreeTo": 0,
                        "name": "Inside Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479060,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479088,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479116,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479143,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479174,
                        "kidsFreeTo": 0,
                        "name": "Princess",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479204,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479233,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003069,
                        "kidsFreeTo": 5,
                        "name": "Princesa doble sin vista",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003071,
                        "kidsFreeTo": 5,
                        "name": "Princesa vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003073,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al campo de golf",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003074,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1006659,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1006660,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039027,
                        "kidsFreeTo": 0,
                        "name": "Princesa Doble, sin vista",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039028,
                        "kidsFreeTo": 0,
                        "name": "Habitación, vistas al mar (Princesa)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Fumadores y no fumadores",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039029,
                        "kidsFreeTo": 0,
                        "name": "Suite junior, vistas al campo de golf (Pirámide)",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039030,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View Doble",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039031,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean View Double",
                        "isActive": true,
                        "view": "Vistas al campo de golf o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4144442,
                        "kidsFreeTo": 0,
                        "name": "Habitación, vistas al campo de golf (Piramide)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4144443,
                        "kidsFreeTo": 0,
                        "name": "Habitación, vistas al mar (Piramide)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama doble o 1 cama doble y 1 cama individual grande",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4144445,
                        "kidsFreeTo": 0,
                        "name": "Suite junior, vistas al mar (Piramide)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama doble o 1 cama doble y 1 cama individual grande",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4144447,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite, Ocean View",
                        "isActive": true,
                        "view": "Vistas al campo de golf o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Bedsheets provided",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Daily housekeeping",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Television",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama doble o 1 cama doble y 1 cama individual grande",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4144448,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite, Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4542262,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al campo de golf",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4542263,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4542264,
                        "kidsFreeTo": 0,
                        "name": "Junior suite vista al campo de golf",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4542265,
                        "kidsFreeTo": 0,
                        "name": "Junior suite vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586309,
                        "kidsFreeTo": 0,
                        "name": "Habitación, vistas al campo de golf (King Pirámide)",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586310,
                        "kidsFreeTo": 0,
                        "name": "Habitación, vistas al mar (King Pirámide)",
                        "isActive": true,
                        "view": "Vistas al campo de golf o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586311,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586312,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de centro",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586472,
                        "kidsFreeTo": 0,
                        "name": "Princesa king sin vista",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586473,
                        "kidsFreeTo": 0,
                        "name": "Princesa king vista al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586475,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586476,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586485,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al campo de golf",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4586486,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4596649,
                        "kidsFreeTo": 0,
                        "name": "Princesa King, sin vista",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Barra de apoyo cerca del inodoro",
                            "Caja fuerte en la habitación",
                            "Camas supletorias (de pago)",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión a Internet por cable (recargo)",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Estación de conexión MP3",
                            "Habitación apta para mascotas",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Mosquiteras",
                            "No fumadores",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Tirador de emergencia en el baño",
                            "Toallas",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4596650,
                        "kidsFreeTo": 0,
                        "name": "Princesa Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996984,
                        "kidsFreeTo": 5,
                        "name": "Princesa doble sin vista - desayuno",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996985,
                        "kidsFreeTo": 5,
                        "name": "Princesa vista al mar - desayuno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996986,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al campo de golf - desayuno",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996987,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al mar - desayuno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996988,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al jardín - desayuno",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996989,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista parcial al mar - desayuno",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996990,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al campo de golf - desayuno",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996991,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al mar - desayuno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996992,
                        "kidsFreeTo": 0,
                        "name": "Junior suite vista al campo de golf - desayuno",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996993,
                        "kidsFreeTo": 0,
                        "name": "Junior suite vista al mar - desayuno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de centro",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996994,
                        "kidsFreeTo": 0,
                        "name": "Princesa king sin vista - desayuno",
                        "isActive": true,
                        "view": "Ninguna",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996995,
                        "kidsFreeTo": 0,
                        "name": "Princesa king vista al mar - desayuno",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996996,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al jardín - desayuno",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996997,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista parcial al mar - desayuno",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996998,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al campo de golf - desayuno",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4996999,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al mar - desayuno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710740,
                        "kidsFreeTo": 5,
                        "name": "Princesa vista al jardín - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710741,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al jardín - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710742,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista parcial al mar - todo incluido",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710743,
                        "kidsFreeTo": 5,
                        "name": "Princesa vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710744,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al campo de golf - todo incluido",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/InTYc6_FwecmjjbidjKu-LEfPcE=/720x480/02/91/77/02917753.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso separada",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710745,
                        "kidsFreeTo": 0,
                        "name": "Pirámide junior suite vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ry8Kmj1swufZ8R4DGePixiMT1ko=/720x480/02/85/59/02855967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710746,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al campo de golf - todo incluido",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710747,
                        "kidsFreeTo": 5,
                        "name": "Pirámide vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710748,
                        "kidsFreeTo": 0,
                        "name": "Junior suite vista al campo de golf - todo incluido",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KyBL95lxUY0slAxFLs_zOOkEa8o=/720x480/02/91/77/02917748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "TV de 40 pulgadas",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710749,
                        "kidsFreeTo": 0,
                        "name": "Junior suite ocean view - all inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Cridl8tQhsYgryE-q5zYjyaGXSk=/720x480/02/91/77/02917750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de centro",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710750,
                        "kidsFreeTo": 0,
                        "name": "Princesa king vista al jardín - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710751,
                        "kidsFreeTo": 0,
                        "name": "Princesa king vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/f0-4a13L342TPNsaRkgM8ueXOf4=/720x480/02/85/59/02855979.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710752,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al jardín - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SZGbQOgknTGoutTVdCQHTlQhiTo=/720x480/02/85/59/02855966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Canales premium",
                            "($)Minibar",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Caja de seguridad",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710753,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista parcial al mar - todo incluido",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3oCXIWDioZwkiF6dk5X5n8OQHcs=/720x480/02/91/77/02917751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710754,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al campo de golf - todo incluido",
                        "isActive": true,
                        "view": "Campo de golf",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dLDE5h4ba58JBDxzbWEWrz16fPg=/720x480/02/91/77/02917752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Cortinas oscuras",
                            "Mesa de trabajo",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vestidor"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7710755,
                        "kidsFreeTo": 0,
                        "name": "Pirámide king vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/TL3_Jc8TTNXM-6TF_NFsh816HQI=/720x480/02/91/77/02917755.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969892,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969893,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969894,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969895,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969896,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969897,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969899,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969900,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969901,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969902,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7969903,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8350564,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8350723,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8350743,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8350754,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446699,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446702,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446714,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446727,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446731,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8446739,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 9056377,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583761,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583762,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583764,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583765,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583766,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583768,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583770,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583772,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583774,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583775,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583776,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583779,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583783,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583787,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11583792,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078266,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Balcón",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198714,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198715,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198716,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198717,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198718,
                        "kidsFreeTo": 0,
                        "name": "Doble Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198719,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198720,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198721,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198722,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198723,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198724,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198725,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198726,
                        "kidsFreeTo": 0,
                        "name": "Habitación Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198728,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198730,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198731,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198732,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198733,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198734,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198735,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198736,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16198737,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16349901,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229700,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229703,
                        "kidsFreeTo": 0,
                        "name": "Individual Interior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229706,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229709,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229712,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229715,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229719,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229723,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229725,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 4",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229727,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229728,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229729,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229730,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229731,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229732,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 1",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229733,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229734,
                        "kidsFreeTo": 0,
                        "name": "Habitación Capacidad 3",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229735,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17229783,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18211801,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18211802,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299890,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299891,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299892,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299893,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299894,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299895,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299896,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299897,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299898,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18473941,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18473962,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18473984,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474005,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474025,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474048,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474071,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474094,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474117,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474138,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474161,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474181,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474202,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474222,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474241,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474258,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474274,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474294,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474313,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474333,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474353,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474377,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474399,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474418,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474437,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474455,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474473,
                        "kidsFreeTo": 0,
                        "name": "Leisure",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474492,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474510,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474528,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474546,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474565,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474586,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474608,
                        "kidsFreeTo": 0,
                        "name": "King Bed Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474629,
                        "kidsFreeTo": 0,
                        "name": "Suite Golf View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474650,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474673,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474695,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474717,
                        "kidsFreeTo": 0,
                        "name": "Golf View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474740,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474761,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474782,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474804,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474826,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474847,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474867,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474888,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474908,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474928,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474948,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474971,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474993,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475016,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475039,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475062,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475089,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475116,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475143,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475171,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475199,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475228,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475257,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475283,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475312,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475339,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475366,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475394,
                        "kidsFreeTo": 0,
                        "name": "Economic Triple Room",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475421,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475445,
                        "kidsFreeTo": 0,
                        "name": "Economic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475470,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475494,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475520,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475547,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475576,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475601,
                        "kidsFreeTo": 0,
                        "name": "Courtyard View",
                        "isActive": true,
                        "view": "Patio interior",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475627,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475653,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475676,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475698,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475721,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475747,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475771,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475796,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475821,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475847,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475870,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475894,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475918,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475944,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475972,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475998,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476025,
                        "kidsFreeTo": 0,
                        "name": "Inside Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476054,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476082,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476111,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476139,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476167,
                        "kidsFreeTo": 0,
                        "name": "Princess",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476196,
                        "kidsFreeTo": 0,
                        "name": "Triple Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476226,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476256,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824543,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824546,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824549,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824552,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824555,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824557,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824559,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824561,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824563,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824565,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824567,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824569,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824572,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Cama King Size",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824575,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824577,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824579,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824581,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824583,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824585,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824587,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824589,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824591,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824593,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824595,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824597,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824599,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824601,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824603,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824605,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Luxury",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824607,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18890830,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923000,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923001,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923002,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923003,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923004,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923005,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923006,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923007,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923008,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923009,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923010,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923011,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923012,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923013,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923015,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923016,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923017,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923018,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923019,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923020,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923021,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923022,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Satellite TV ",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Bed o 2 Beds o 3 Beds o 4 Beds",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923024,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Ocean view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Number of bedrooms",
                            "Pay movies",
                            "Safe",
                            "Satellite TV ",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Bed o 2 Beds o 3 Beds o 4 Beds",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18923025,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Ocean view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951211,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al campo de golf",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/piW00taa9d_LISdTKFbVcKK52hA=/720x480/13/13/11/13131176.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/piW00taa9d_LISdTKFbVcKK52hA=/720x480/13/13/11/13131176.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951212,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al campo de golf",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951219,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista frente al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_A7HaufdWKCChY5jG2E8oO2eiQA=/720x480/13/13/11/13131175.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_A7HaufdWKCChY5jG2E8oO2eiQA=/720x480/13/13/11/13131175.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951220,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista frente al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951221,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_A7HaufdWKCChY5jG2E8oO2eiQA=/720x480/13/13/11/13131175.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_A7HaufdWKCChY5jG2E8oO2eiQA=/720x480/13/13/11/13131175.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951222,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951223,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al campo de golf",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u5qRbAhhP_aCS4dJuMLqW9w6DG0=/720x480/13/13/11/13131178.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u5qRbAhhP_aCS4dJuMLqW9w6DG0=/720x480/13/13/11/13131178.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951224,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista frente al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-fIjcHLN2_YobkioXckm-ih3ddo=/720x480/13/13/11/13131179.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-fIjcHLN2_YobkioXckm-ih3ddo=/720x480/13/13/11/13131179.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18951225,
                        "kidsFreeTo": 0,
                        "name": "Junior suite king vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2WaKculNAVohIurDhEKH2AtTP0s=/720x480/13/13/11/13131177.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico hasta 4 dispositivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 939,
                    "valuesAverage": [
                        4.4,
                        4.6
                    ]
                },
                "title": "Resort frente a la playa en Acapulco Diamante",
                "uri": "princess-mundo-imperial-riviera-diamante-acapulco",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            }


        ]
    },
    {
        "destinoId": 3,
        titulo: "Hoteles en Los Cabos",
        destino: "Los Cabos",
        hoteles: [
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Hard Rock Hotel Los Cabos se encuentra a las orillas de Cabo San Lucas, en el fraccionamiento Diamante. Este hotel de lujo todo incluido ofrece cinco piscinas con bar, seis restaurantes y espacio para eventos. Además de un spa, gimnasio, área para niños y jóvenes, boliche y la icónica tienda de regalos.\r\n\r\nLa propiedad ofrece vista al océano Pacífico y está frente a 1 kilómetro de playa. El centro de Cabo está 9 kilómetros de distancia, el famoso Arco de Cabo San Lucas a 15 kilómetros y el centro de la ciudad hermana de San José del Cabo a 41 kilómetros. El Aeropuerto Internacional de Los Cabos (SJD) se localiza a 54 kilómetros del hotel.\r\n\r\n***La playa del hotel no es segura para que naden los huéspedes, debido a las fuertes corrientes que podrían llevar incluso a los nadadores más experimentados a condiciones peligrosas. El hotel recomienda ampliamente a los huéspedes mantenerse alejados de la orilla.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino. \r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $36.31 MXN o $1.90 USD por habitación, por noche, a pagar directamente en el establecimiento.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/e062d853c3884431cb6fa4db35ed20f5e8e58a68becdaa02c38c019344fb0ffe_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/af178f169062f4db3fa09c3d099f68d8ef5ede2bf2bcc9e4dc8a84e4423c23de.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior Doble con cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/319659/ba6b372ad37f4a239eea027bcd89df0457ef223188a2f786f94596f24547b727.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/c064b76a02a694428033fe544b8ee627326d9892260abc12200e1ec6d2d414bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/cf85439c0e1d5d97d76520031b710704e9a4d16eb4191489c8181487db9c83c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/79d13c5697679db6ea01c32f41258e86abdd1bc8cb1aa4ed2fddfb0f2a3fb991.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/b5a0fe0c925ba3fffbe43f8f8e8bb9a81f7222b897bda496a9b0e9ad74e94874.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/29dd2c76b7902bafa810901023ca1943aa51d3d6843a4762137362a65915f22b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/351f371b6e34f43bddd5c5956b574f035a215970a9e2f6c3fbd02a4643edd7bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/d69e95504295dae44cda8fbe3b31abdcffec1a813f80aff9af9f19bf120c2dd5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/f28613e0df03763c453ac9e3e9b304da108749124d3248a70356938f83bf825a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/f5b4a7bd8069c0cc4cb364804f79e10191dd2a53e7e21b7f17c4642f259c9d85.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/d94ff3f4c3d6db146044feff34a2803a1a704f42dbfd938ec49b9b639a8d8c87.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/dac7e5390291acf584e463bca76523807c75370274bca179be32cb3544f5c2d0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/e0d66ffbcfa87b9c17e967394ef46a417674b92062e9337c662d46d8009a06ef.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/ed274b62859a3bf47163e0e8bfe6c86754ce47dff2fb607feb5a823dab26cb7f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/319659/ec48b97e24611f43e6de0fe4c433e489baff0b71c55cf52e09da9034018a3fbc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/319659/b048e29d698de8869e115f719e774182fc5f91e861f4c72ad7130e58ce7b6146.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/319659/8fc93454d087593245ba675d526713353ddebf7393b13d237731b5941ab8fe8a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/319659/23a50d7a4e23a94a454b42908a8630a96576b63938cda6e875572c2f83782371.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/319659/9fb1926523600a713139d5c70eee3422e3c2b1e7ff7ad71f6b2095e72a8888b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/9342ebc7073f3bb284012b444f2d1eb620a32b2b98cd313836dae5dd528c92ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/2af4f3bb56ba794f6d1f2179cd44d330d42b4627dfef201217819dd295f10c9a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior Doble con cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/319659/9a9106687b277f512701a0a9f9cf4c16e56bfe845a6f045e7cf302e69c2aa34b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior Doble con cama grande",
                        "cloudUri": "https://img.cdnpth.com/media/319659/7b2ce713224e2ddce136d3480d34db444ac0db51069bf966d05a55935dd68659.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/eeee659b34a4a9192802b13a4e13db68d8f06a3fc5a8d6a356734dd41ac2ab1f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Platinum Deluxe Rock Royalty con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319659/474c0cc1bd1e50f52b3c87b291c760e1a5588d2ac560e445a0764ca5ad284d78.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Platinum Deluxe con cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/319659/d649c8061ee1c998b6753aefacd44d34bcaa2889d541dafa8ef8b8909a72b252.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/84fd685ad1d949d20b5f38d9f3206d11c460b09251106920e4285102d0e9cbb9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Deluxe Platinum - 2 camas grandes",
                        "cloudUri": "https://img.cdnpth.com/media/319659/1a5a88a15a0ecbe8076388efaf077caed807232f7a4bd749fa372ea94011794e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/f2e864b4e65e7ac200439a2ae77f80831668af9dee8de020512226a3a8bebf11.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319659/05c002dc679457ded746b64378253535b39b8401baadae6df9067028c8dc3958.png"
                    }
                ],
                "hotelID": 319659,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Cabo San Lucas",
                    "country": "Mexico",
                    "latitude": "22.883084510034966",
                    "longitude": "-109.98234254218971",
                    "postalCode": "23473",
                    "state": "Baja California Sur",
                    "street": "Polígono 1 Fracción D, Fracc Diamante",
                    "countryCode": "MX"
                },
                "name": "Hard Rock Hotel Los Cabos",
                "placeContainers": [
                    {
                        "id": 62709,
                        "uri": "cabo-san-lucas",
                        "displayText": "Cabo San Lucas, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 69398,
                        "uri": "los-cabos",
                        "displayText": "Los Cabos, Baja California Sur, México",
                        "type": 3
                    },
                    {
                        "id": 404546,
                        "uri": "lap-baja-california-sur-mexico-aeropuerto-internacional-general-manuel-marquez-de-leon-rng",
                        "displayText": "LAP La Paz, Baja California Sur, México - Aeropuerto Internacional Manuel Márquez de León",
                        "type": 10
                    },
                    {
                        "id": 404570,
                        "uri": "sjd-san-jose-del-cabo-baja-california-sur-mexico-aeropuerto-internacional-los-cabos-rng",
                        "displayText": "SJD Los Cabos, San José del Cabo, BCS, México - Aeropuerto Internacional de Los Cabos",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "6 Restaurantes",
                        "type": "Restaurante"
                    },
                    {
                        "name": "5 Bares de Piscina",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588008,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588032,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588056,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588080,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588105,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588132,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588157,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588182,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588208,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588235,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588261,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588288,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588314,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588337,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588361,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588388,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588414,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588441,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588468,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588494,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588518,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588542,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588564,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588586,
                        "kidsFreeTo": 0,
                        "name": "Platinum",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588607,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588628,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588648,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588668,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588693,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588717,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588743,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588766,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588791,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588816,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588843,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588866,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588889,
                        "kidsFreeTo": 0,
                        "name": "Classic Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588913,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588936,
                        "kidsFreeTo": 0,
                        "name": "Classic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588959,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18588984,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589008,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589033,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589057,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589083,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589107,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589131,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589156,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589181,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589208,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589236,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589262,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589289,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589316,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589342,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589370,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589398,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589425,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589452,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589478,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589503,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589528,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589555,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589580,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589606,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589633,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589658,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589684,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589708,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589732,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589756,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589781,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589806,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589830,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589856,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589878,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589901,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589924,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589945,
                        "kidsFreeTo": 0,
                        "name": "Royal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589967,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18589988,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590009,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590029,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590049,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590069,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590089,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590111,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590133,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590154,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590177,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590199,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590221,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590243,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590264,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590288,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590309,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590331,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool Access",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590353,
                        "kidsFreeTo": 0,
                        "name": "Royal Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590373,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18590395,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670025,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670051,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670077,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670103,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670129,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670154,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670179,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670204,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670229,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670254,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670279,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670304,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670329,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670354,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670379,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670404,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670428,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670452,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670476,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670500,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670525,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670550,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670575,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670600,
                        "kidsFreeTo": 0,
                        "name": "Platinum",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670625,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670649,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18670673,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5438592,
                        "kidsFreeTo": 3,
                        "name": "De lujo PURE WELLNESS® king",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CdmoSJWkPUk1tmDx4eBqOGmtb6k=/720x480/04/34/49/04344919.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CdmoSJWkPUk1tmDx4eBqOGmtb6k=/720x480/04/34/49/04344919.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452760,
                        "kidsFreeTo": 3,
                        "name": "De lujo king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452761,
                        "kidsFreeTo": 3,
                        "name": "De lujo 2 queens vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Zz0p5KEVRNg9KfmaKoxvQHjM3ds=/720x480/04/34/49/04344930.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Zz0p5KEVRNg9KfmaKoxvQHjM3ds=/720x480/04/34/49/04344930.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452762,
                        "kidsFreeTo": 3,
                        "name": "De lujo king swim-up",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452763,
                        "kidsFreeTo": 3,
                        "name": "Rock Royalty de lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XipFN41Zf8AqZ9erzalo_tkKrEs=/720x480/04/34/49/04344932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XipFN41Zf8AqZ9erzalo_tkKrEs=/720x480/04/34/49/04344932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452765,
                        "kidsFreeTo": 3,
                        "name": "Junior suite king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dXeIBuWrlUZH_A9Zx8rea_xfoHQ=/720x480/04/34/49/04344931.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dXeIBuWrlUZH_A9Zx8rea_xfoHQ=/720x480/04/34/49/04344931.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452766,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452767,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452768,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452769,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Alberca semiprivada",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452771,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio swim-up frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Alberca semiprivada",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452772,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios swim-up frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Prioridad para reservar camas balinesas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Bar",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Masaje de 25 minutos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452773,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock Star",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8pJOw0LRXPR4usa8h8OrLNLoTQs=/720x480/04/34/49/04344933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8pJOw0LRXPR4usa8h8OrLNLoTQs=/720x480/04/34/49/04344933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5452776,
                        "kidsFreeTo": 3,
                        "name": "De lujo familiar",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6089190,
                        "kidsFreeTo": 3,
                        "name": "De lujo PURE WELLNESS® doble",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7649148,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7659259,
                        "kidsFreeTo": 0,
                        "name": "Double Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7659260,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7659261,
                        "kidsFreeTo": 0,
                        "name": "Double Classic Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7659262,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Bolsa de tela",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7801391,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty 2 queens vista la mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1wtfQQ8EQJZSuq_nIzweM7DvIYw=/720x480/04/97/22/04972244.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1wtfQQ8EQJZSuq_nIzweM7DvIYw=/720x480/04/97/22/04972244.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7927443,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7927444,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7964632,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7964633,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361566,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361644,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361682,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361707,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361732,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8361759,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439473,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439477,
                        "kidsFreeTo": 0,
                        "name": "Single Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439481,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439487,
                        "kidsFreeTo": 0,
                        "name": "Single Classic Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439494,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439502,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439508,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439515,
                        "kidsFreeTo": 0,
                        "name": "Triple Classic Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439521,
                        "kidsFreeTo": 0,
                        "name": "Single Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439530,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452189,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452193,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452194,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean View King",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452195,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Swim Up King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452196,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pure® Wellness King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452197,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean View Two Queens Beds",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452203,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Gold Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9452204,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean View ( Two Bedroom ) with Personal Assistant",
                        "isActive": true,
                        "view": "Vista al mar o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10146266,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty Ocean View 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188340,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188341,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188342,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188343,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188346,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188350,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188353,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188362,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188366,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Number of bedrooms",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10188369,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581199,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581202,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581206,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581208,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581209,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581210,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581213,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581219,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581221,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581223,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581226,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581230,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Two Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581232,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581233,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581236,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581237,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581244,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11608164,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11608165,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11608166,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11618582,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11618585,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149178,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Swim-up Ocean Front (One Bedroom) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149179,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Rooftop Terrace Ocean View (One Bedroom) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149180,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean Front ( One Bedroom ) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149181,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean View ( One Bedroom ) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149182,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Two Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149183,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Rooftop Terrace Ocean View (Two Bedroom) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149184,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Swim-up Ocean Front (Two Bedroom) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149185,
                        "kidsFreeTo": 0,
                        "name": "Rock Suite Ocean Front ( Two Bedroom ) with Personal Assistant",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411695,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411696,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411697,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411698,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411699,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411700,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front One Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411701,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411703,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16411706,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16421537,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Chimenea",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Electricidad 220V",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16421539,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Prensa planchapantalones",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Smart TV",
                            "Teléfono de marcado directo",
                            "Terraza con jacuzzi y área de descanso",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16722825,
                        "kidsFreeTo": 3,
                        "name": "De lujo Gold king",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/RbNTOIQIBezKEp9IlDd4GF5lAjY=/720x480/05/44/17/05441743.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RbNTOIQIBezKEp9IlDd4GF5lAjY=/720x480/05/44/17/05441743.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Prensa planchapantalones",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Smart TV",
                            "Teléfono de marcado directo",
                            "Terraza con jacuzzi y área de descanso",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16722826,
                        "kidsFreeTo": 3,
                        "name": "De lujo Gold 2 queens",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ygG24-77c54jv78j-vfT1RBXnK0=/720x480/05/44/17/05441744.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ygG24-77c54jv78j-vfT1RBXnK0=/720x480/05/44/17/05441744.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Prensa planchapantalones",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Smart TV",
                            "Teléfono de marcado directo",
                            "Terraza con jacuzzi y área de descanso",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723487,
                        "kidsFreeTo": 3,
                        "name": "De lujo Gold king - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/RbNTOIQIBezKEp9IlDd4GF5lAjY=/720x480/05/44/17/05441743.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RbNTOIQIBezKEp9IlDd4GF5lAjY=/720x480/05/44/17/05441743.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Prensa planchapantalones",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Smart TV",
                            "Teléfono de marcado directo",
                            "Terraza con jacuzzi y área de descanso",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723488,
                        "kidsFreeTo": 3,
                        "name": "De lujo Gold 2 queens - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ygG24-77c54jv78j-vfT1RBXnK0=/720x480/05/44/17/05441744.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ygG24-77c54jv78j-vfT1RBXnK0=/720x480/05/44/17/05441744.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723605,
                        "kidsFreeTo": 3,
                        "name": "De lujo PURE WELLNESS® king - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CdmoSJWkPUk1tmDx4eBqOGmtb6k=/720x480/04/34/49/04344919.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CdmoSJWkPUk1tmDx4eBqOGmtb6k=/720x480/04/34/49/04344919.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723606,
                        "kidsFreeTo": 3,
                        "name": "De lujo king vista parcial al mar - no reembolsable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723607,
                        "kidsFreeTo": 3,
                        "name": "De lujo 2 queens vista parcial al mar - no reembolsable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Zz0p5KEVRNg9KfmaKoxvQHjM3ds=/720x480/04/34/49/04344930.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Zz0p5KEVRNg9KfmaKoxvQHjM3ds=/720x480/04/34/49/04344930.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723608,
                        "kidsFreeTo": 3,
                        "name": "De lujo king swim-up - no reembolsable",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/faZWkoWVAREjJ8QtAkyCUaco10A=/720x480/04/34/49/04344929.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723609,
                        "kidsFreeTo": 3,
                        "name": "Rock Royalty de lujo vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XipFN41Zf8AqZ9erzalo_tkKrEs=/720x480/04/34/49/04344932.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XipFN41Zf8AqZ9erzalo_tkKrEs=/720x480/04/34/49/04344932.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723610,
                        "kidsFreeTo": 3,
                        "name": "Junior suite king - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dXeIBuWrlUZH_A9Zx8rea_xfoHQ=/720x480/04/34/49/04344931.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dXeIBuWrlUZH_A9Zx8rea_xfoHQ=/720x480/04/34/49/04344931.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723611,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723612,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723613,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723614,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BcXHTs_JD2LeCJNUPEMR53U8JT8=/720x480/04/34/49/04344934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Alberca semiprivada",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723615,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 1 dormitorio swim-up frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Prioridad para reservar camas balinesas",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Bar",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Masaje de 25 minutos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723616,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock Star - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8pJOw0LRXPR4usa8h8OrLNLoTQs=/720x480/04/34/49/04344933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8pJOw0LRXPR4usa8h8OrLNLoTQs=/720x480/04/34/49/04344933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Alberca semiprivada",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Lustrado de zapatos",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Ropa de cama de lujo",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de planchado (2 artículos por persona / por estadía)",
                            "Set de aromaterapia",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723618,
                        "kidsFreeTo": 3,
                        "name": "Suite Rock de 2 dormitorios swim-up frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CBHlO9-wCN9S-K02uDGqgAm4aw0=/720x480/04/34/49/04344935.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Queens",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723619,
                        "kidsFreeTo": 3,
                        "name": "De lujo familiar - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/B_wJhTceV6Br9EVb3HgI1ekJqe4=/720x480/04/34/49/04344928.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Báscula",
                            "Batas",
                            "Bolsa de tela",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Control individual del clima",
                            "Cortesía nocturna",
                            "Doble lavabo",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa y sillas",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723620,
                        "kidsFreeTo": 0,
                        "name": "Rock Royalty 2 queens vista la mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1wtfQQ8EQJZSuq_nIzweM7DvIYw=/720x480/04/97/22/04972244.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1wtfQQ8EQJZSuq_nIzweM7DvIYw=/720x480/04/97/22/04972244.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Bañera o ducha",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Edredón",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Llamadas de larga distancia gratuitas",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Sábanas de algodón egipcio",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16737337,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande con sofá cama (Gold)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585658,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585678,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585703,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585726,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585750,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585773,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585796,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585819,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585844,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585867,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585889,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585911,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585935,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585957,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18585980,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586003,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586026,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586050,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586077,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586101,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586126,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586150,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586173,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586196,
                        "kidsFreeTo": 0,
                        "name": "Platinum",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586219,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586242,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586265,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586288,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586309,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586330,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586350,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586370,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586391,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586412,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586434,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586454,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586476,
                        "kidsFreeTo": 0,
                        "name": "Classic Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586498,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586520,
                        "kidsFreeTo": 0,
                        "name": "Classic Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586543,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586565,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586587,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586607,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586627,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586646,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586666,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586690,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586713,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586735,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586757,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586783,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586808,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586832,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586856,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586879,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586904,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586928,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586951,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18586977,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587001,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587025,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587050,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587076,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587101,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587124,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587148,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587174,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587197,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587220,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sofa Bed",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587243,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Queen Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587265,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587288,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587311,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587335,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587361,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587386,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587412,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587441,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587470,
                        "kidsFreeTo": 0,
                        "name": "Royal",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587497,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587523,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587548,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587572,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587600,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587626,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587650,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Golden",
                        "isActive": true,
                        "view": "Vistas al valle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587674,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587697,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas al valle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587721,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587745,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587767,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas al valle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587790,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587813,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587837,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587861,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587884,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587906,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool Access",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18587928,
                        "kidsFreeTo": 0,
                        "name": "Royal Single Room",
                        "isActive": true,
                        "view": "Vistas al puerto",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18669641,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18669643,
                        "kidsFreeTo": 0,
                        "name": "Double Room Queen Bed Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boliche",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de jóvenes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Todo incluido",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 875,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel de lujo todo incluido en el fraccionamiento Diamante",
                "uri": "hard-rock-hotel-los-cabos",
                "tags": [
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Deportes Acuáticos",
                        "description": "Los deportes acuáticos incluyen voleibol en la alberca."
                    },
                    {
                        "title": "Actividades",
                        "description": "Las actividades diarias incluyen yoga, clases de cocina y coctelería, lanzamiento de herraduras, billar, dardos, ajedrez gigante, películas en la playa y bingo."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 3 y 12 años, supervisado por adultos. Una vez por semana el Explorer's Club ofrece un campamento de aventura en la playa."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen ping pong, baloncesto, tiro con arco,  fútbol, badminton, croquet, tenis, bocha, y voleibol playero."
                    },
                    {
                        "title": "Otros",
                        "description": "Servicio a la habitación las 24 horas."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas de marcas premium ilimitadas. Pueden aplicar restricciones."
                    }
                ],
                "description": "Dreams Los Cabos Suites Golf Resort &amp; Spa es un hotel todo incluido, localizado en el Corredor Turístico de Los Cabos, frente al Mar de Cortés. El hotel está convenientemente ubicado frente a la playa, cerca de 8 campos de golf de campeonato y a sólo 24 kilómetros del Aeropuerto Internacional de Los Cabos (SJD). \r\n\r\nEste hotel Los Cabos dispone de 230 espaciosas suites con vista al mar. Cada suites está equipada con terraza privada, minibar reabastecido diariamente, televisión vía satélite con películas de pago por evento, radio reloj con base para MP3, cafetera, batas y pantuflas, kit de planchado, aire acondicionado con control individual, escritorio, caja de seguridad y baño privado con pisos de mármol y amenidades de lujo. Adicionalmente las habitaciones Prererred ofrecen acceso al salón ejecutivo y check in privado. La propiedad acepta perros de máximo 10 kg en las habitaciones y ofrece amenidades especiales para ellos (aplican cargos y restricciones).\r\n\r\nDreams Los Cabos Suites Golf Resort &amp; Spa ofrece instalaciones para parejas, familias y grupos de amigos. Las amenidades del hotel incluyen tres albercas, un club de niños supervisado, un spa de servicio completo, gimnasio, putting green, una espectacular variedad de actividades de día y de noche, así como servicio a la habitación y concierge las 24 horas. Para deleitar tu paladar, el resort ofrece siete diferentes restaurantes y cuatro bares.\r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva. \r\n\r\n***Dreams Los Cabos Suites Golf Resort &amp; Spa ha sido catalogado por la asociación AAA de los Estados Unidos con Cuatro Diamantes.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 2141939,
                        "description": "Dreams Los Cabos Suites Golf Resort & Spa",
                        "cloudUri": "https://img.cdnpth.com/media/Nb7DR30KHdwAFSgFdOUEEba0NOM=/720x480/02/14/19/02141939.jpg"
                    },
                    {
                        "photoID": 2141940,
                        "description": "Las instalaciones son ideales para parejas, familias y grupos de amigos",
                        "cloudUri": "https://img.cdnpth.com/media/qQl73SVYzTX2yJeIJKGrJwXvJ7U=/720x480/02/14/19/02141940.jpg"
                    },
                    {
                        "photoID": 2141929,
                        "description": "La propiedad ofrece acceso a la playa",
                        "cloudUri": "https://img.cdnpth.com/media/dCQ-i8s7uqGIykPMGTb_RZixYLw=/720x480/02/14/19/02141929.jpg"
                    },
                    {
                        "photoID": 2141941,
                        "description": "Hotel situado en el Corredor Turístico de Los Cabos",
                        "cloudUri": "https://img.cdnpth.com/media/j6kOL9qWMrJ-zpXozv8Uv60Yleo=/720x480/02/14/19/02141941.jpg"
                    },
                    {
                        "photoID": 3347811,
                        "description": "Piscina infinity con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/evtPhIcUzqjKZcfUWibvD-Ou0xs=/720x480/03/34/78/03347811.jpg"
                    },
                    {
                        "photoID": 2141927,
                        "description": "Piscina para niños",
                        "cloudUri": "https://img.cdnpth.com/media/cRFG2Nzawtcm0X2sWpWJ4Kxugco=/720x480/02/14/19/02141927.jpg"
                    },
                    {
                        "photoID": 3347810,
                        "description": "Área para niños",
                        "cloudUri": "https://img.cdnpth.com/media/HfCbiHzQIvcQioyp9aAavl-VfYA=/720x480/03/34/78/03347810.jpg"
                    },
                    {
                        "photoID": 2141926,
                        "description": "El hotel tiene una piscina exclusiva para adultos",
                        "cloudUri": "https://img.cdnpth.com/media/ElNiNB3LEsWffPCP4-1ybB5UHFA=/720x480/02/14/19/02141926.jpg"
                    },
                    {
                        "photoID": 2141930,
                        "description": "Disfruta de bebidas en el bar junto a la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/clbgmydZk33zzVOvSXMyTw3TKfU=/720x480/02/14/19/02141930.jpg"
                    },
                    {
                        "photoID": 2141931,
                        "description": "Dentro del hotel hay una gran variedad de restaurantes gourmet",
                        "cloudUri": "https://img.cdnpth.com/media/Sx_VUP5tYO2suYDbK9cObEflHNU=/720x480/02/14/19/02141931.jpg"
                    },
                    {
                        "photoID": 2141932,
                        "description": "Servicio de alimentos",
                        "cloudUri": "https://img.cdnpth.com/media/VdtRLmc3gB4j5wBFM5I2ZU11-X4=/720x480/02/14/19/02141932.jpg"
                    },
                    {
                        "photoID": 2141911,
                        "description": "Hay menús especiales en algunos de los restaurantes",
                        "cloudUri": "https://img.cdnpth.com/media/DSRHPAX6ILhlUxc2zZ0SzNAOfOQ=/720x480/02/14/19/02141911.jpg"
                    },
                    {
                        "photoID": 2141925,
                        "description": "Restaurante con terraza y vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/9JcGANnqpDo1AdXOJHAFTt0agg8=/720x480/02/14/19/02141925.jpg"
                    },
                    {
                        "photoID": 2141924,
                        "description": "Club Lounge Preferred de acceso excluisvo",
                        "cloudUri": "https://img.cdnpth.com/media/pTTOw_OgxYcNkLvhYONg77ZM1B0=/720x480/02/14/19/02141924.jpg"
                    },
                    {
                        "photoID": 2141908,
                        "description": "Vista interior de uno de los bares del hotel",
                        "cloudUri": "https://img.cdnpth.com/media/Qi5vIoeu0U9Atn8ohkh2XgPlw-k=/720x480/02/14/19/02141908.jpg"
                    },
                    {
                        "photoID": 2141910,
                        "description": "En este hotel se realizan bodas en la playa",
                        "cloudUri": "https://img.cdnpth.com/media/2pv-EgvD1YYbdryNScIBH9WXnBM=/720x480/02/14/19/02141910.jpg"
                    },
                    {
                        "photoID": 2141935,
                        "description": "Vista de uno de los salones para eventos",
                        "cloudUri": "https://img.cdnpth.com/media/FSP8k9A9AJ_uupgFOdro2VdHUKk=/720x480/02/14/19/02141935.jpg"
                    },
                    {
                        "photoID": 2141912,
                        "description": "Hay un centro de negocios en la propiedad",
                        "cloudUri": "https://img.cdnpth.com/media/5trfsP1_xAH0eRX9o3H_rFF_SPY=/720x480/02/14/19/02141912.jpg"
                    },
                    {
                        "photoID": 2141938,
                        "description": "El spa cuenta con tratamientos para niños y adultos",
                        "cloudUri": "https://img.cdnpth.com/media/YbR6C-pAkrtA9WBCpJJVIiQJP2U=/720x480/02/14/19/02141938.jpg"
                    },
                    {
                        "photoID": 2141919,
                        "description": "Jacuzzi interior del spa",
                        "cloudUri": "https://img.cdnpth.com/media/MKeOpmiKLpTlhpMzZHwyQGXsCvY=/720x480/02/14/19/02141919.jpg"
                    },
                    {
                        "photoID": 2141906,
                        "description": "Se ofrecen diferentes actividades de recreación dentro del hotel",
                        "cloudUri": "https://img.cdnpth.com/media/K8PtmJi59DctadhHEwdtai68n2o=/720x480/02/14/19/02141906.jpg"
                    },
                    {
                        "photoID": 2141913,
                        "description": "El club de niños cuenta con personal de supervisión",
                        "cloudUri": "https://img.cdnpth.com/media/pqqcdg2flsEn1AKOFbdUnw-3wBY=/720x480/02/14/19/02141913.jpg"
                    },
                    {
                        "photoID": 2141921,
                        "description": "El hotel tiene 230 suites",
                        "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                    },
                    {
                        "photoID": 2141920,
                        "description": "Las suites están decoradas al estilo colonial mexicano",
                        "cloudUri": "https://img.cdnpth.com/media/z6M1XREfU02ENrxtIVofU3jCGlQ=/720x480/02/14/19/02141920.jpg"
                    },
                    {
                        "photoID": 2141933,
                        "description": "Suite lunamielera",
                        "cloudUri": "https://img.cdnpth.com/media/otM0WuU5hRHBPfvp6zZhZ-OVpeA=/720x480/02/14/19/02141933.jpg"
                    },
                    {
                        "photoID": 2141922,
                        "description": "Algunas suites ofrecen vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/lNZ9v3abGrWLBmJ4E58B6afdtrA=/720x480/02/14/19/02141922.jpg"
                    }
                ],
                "hotelID": 100175,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio"
                ],
                "location": {
                    "city": "San Jose del Cabo, Los Cabos",
                    "country": "Mexico",
                    "latitude": "22.975226064577587",
                    "longitude": "-109.7768497467041",
                    "postalCode": "23400",
                    "state": "Baja California Sur",
                    "street": "Carr Transpeninsular km 18.5",
                    "countryCode": "MX"
                },
                "name": "Dreams Los Cabos Suites Golf Resort & Spa",
                "placeContainers": [
                    {
                        "id": 87097,
                        "uri": "corredor-turistico-baja-california-sur-mexico",
                        "displayText": "Corredor Turístico, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 61763,
                        "uri": "san-jose-del-cabo",
                        "displayText": "San José del Cabo, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 219184,
                        "uri": "el-bledito-san-jose-del-cabo-baja-california-sur-mexico",
                        "displayText": "El Bledito, San José del Cabo, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 69398,
                        "uri": "los-cabos",
                        "displayText": "Los Cabos, Baja California Sur, México",
                        "type": 3
                    },
                    {
                        "id": 404546,
                        "uri": "lap-baja-california-sur-mexico-aeropuerto-internacional-general-manuel-marquez-de-leon-rng",
                        "displayText": "LAP La Paz, Baja California Sur, México - Aeropuerto Internacional Manuel Márquez de León",
                        "type": 10
                    },
                    {
                        "id": 404570,
                        "uri": "sjd-san-jose-del-cabo-baja-california-sur-mexico-aeropuerto-internacional-los-cabos-rng",
                        "displayText": "SJD Los Cabos, San José del Cabo, BCS, México - Aeropuerto Internacional de Los Cabos",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Barefoot",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bourdeaux",
                        "type": "Restaurante"
                    },
                    {
                        "name": "World Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Manatees",
                        "type": "Bar"
                    },
                    {
                        "name": "Marlin swim-up bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Portofino",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Rendezvous",
                        "type": "Bar"
                    },
                    {
                        "name": "Coco Cafe",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Desires",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968013,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Dos Camas Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/otM0WuU5hRHBPfvp6zZhZ-OVpeA=/720x480/02/14/19/02141933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/otM0WuU5hRHBPfvp6zZhZ-OVpeA=/720x480/02/14/19/02141933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono en el cuarto de baño",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968014,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/otM0WuU5hRHBPfvp6zZhZ-OVpeA=/720x480/02/14/19/02141933.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/otM0WuU5hRHBPfvp6zZhZ-OVpeA=/720x480/02/14/19/02141933.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968021,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5968023,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/z6M1XREfU02ENrxtIVofU3jCGlQ=/720x480/02/14/19/02141920.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/z6M1XREfU02ENrxtIVofU3jCGlQ=/720x480/02/14/19/02141920.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6862773,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8362209,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8362233,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10190611,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10190744,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10190750,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197913,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197914,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10599774,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11413846,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11419496,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11468105,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidencial",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11470694,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086543,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086545,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086546,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086549,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086555,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086558,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086573,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Al Mar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086579,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086597,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086601,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16134862,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206977,
                        "kidsFreeTo": 2,
                        "name": "Oferta del día",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Base para MP3",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206978,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Base para MP3",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206979,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IfQNlY_mSxARJZTWQzemDg9BmOo=/720x480/04/81/29/04812969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206980,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/z6M1XREfU02ENrxtIVofU3jCGlQ=/720x480/02/14/19/02141920.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/z6M1XREfU02ENrxtIVofU3jCGlQ=/720x480/02/14/19/02141920.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206981,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "1 recámara",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala separada",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206982,
                        "kidsFreeTo": 2,
                        "name": "Suite de 1 dormitorio vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206983,
                        "kidsFreeTo": 2,
                        "name": "Junior suite familiar vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206984,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206985,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/q44Z5NPzkR3e5WGG6JJwRJVB8Ik=/720x480/02/14/19/02141921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 masaje de 20 minutos",
                            "Acceso al circuito de hidroterapia del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Base para MP3",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Hors d'oeuvres",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente a solicitud",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206986,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king frente al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1Xl6BNcXD2KP-g7CrnlqVF3447M=/720x480/04/81/29/04812970.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1Xl6BNcXD2KP-g7CrnlqVF3447M=/720x480/04/81/29/04812970.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 masaje de 20 minutos",
                            "Acceso al circuito de hidroterapia del spa",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Base para MP3",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Hors d'oeuvres",
                            "Internet inalámbrico",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente a solicitud",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206987,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble frente al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IanoADAdxWxYxFOSR0PzF0aSoU8=/720x480/04/81/29/04812971.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IanoADAdxWxYxFOSR0PzF0aSoU8=/720x480/04/81/29/04812971.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "1 recámara",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala separada",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206988,
                        "kidsFreeTo": 2,
                        "name": "Suite de 1 dormitorio doble vista al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "1 recámara",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala separada",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206989,
                        "kidsFreeTo": 2,
                        "name": "Suite de 1 dormitorio king vista al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "2 recámaras",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala separada",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206990,
                        "kidsFreeTo": 2,
                        "name": "Master suite familiar de 2 dormitorios frente al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Películas de pago por evento",
                            "1 recámara",
                            "Acceso a internet",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para MP3",
                            "Batas",
                            "Cafetera/ tetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Periódico diariamente",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Sala separada",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17206991,
                        "kidsFreeTo": 2,
                        "name": "Suite Presidencial frente al mar - Club Preferred",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Pfkqf_f2CaVNLK4Ey0E7j34UyTA=/720x480/02/14/19/02141934.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215847,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215849,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215852,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215855,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215858,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215860,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215862,
                        "kidsFreeTo": 0,
                        "name": "Room Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215864,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215869,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215883,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215892,
                        "kidsFreeTo": 0,
                        "name": "Studio Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215901,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215912,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215920,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215928,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215935,
                        "kidsFreeTo": 0,
                        "name": "Suite One Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215942,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215951,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215960,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215968,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215973,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215980,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215988,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215995,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216003,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216010,
                        "kidsFreeTo": 0,
                        "name": "Single Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17216453,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272275,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272279,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272282,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272285,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272288,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272291,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272294,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272297,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272300,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272304,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272308,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272312,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272316,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272320,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272324,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272328,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272332,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272336,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272340,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272344,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272348,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272352,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272356,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272360,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272364,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272368,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272372,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272376,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272380,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272384,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272388,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272392,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272396,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272400,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272404,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272408,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272412,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272416,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272420,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272424,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272428,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272432,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272436,
                        "kidsFreeTo": 0,
                        "name": "3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272440,
                        "kidsFreeTo": 0,
                        "name": "4 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272444,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272448,
                        "kidsFreeTo": 0,
                        "name": "Executive Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272451,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272454,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272457,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272460,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272463,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272466,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272469,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272472,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272475,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272478,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272481,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272484,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272486,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272488,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272490,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272492,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272494,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272496,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272498,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272500,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272502,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272504,
                        "kidsFreeTo": 0,
                        "name": "Suite Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272506,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272508,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272510,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272512,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272514,
                        "kidsFreeTo": 0,
                        "name": "5 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272516,
                        "kidsFreeTo": 0,
                        "name": "Royal Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272518,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272520,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272522,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272524,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272526,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272527,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272528,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272529,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272530,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272531,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272532,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272533,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272534,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272535,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272536,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272537,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272538,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272539,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272540,
                        "kidsFreeTo": 0,
                        "name": "Superior Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272541,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272542,
                        "kidsFreeTo": 0,
                        "name": "Preferred Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272543,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272544,
                        "kidsFreeTo": 0,
                        "name": "Club Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272545,
                        "kidsFreeTo": 0,
                        "name": "Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272546,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17272547,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890474,
                        "kidsFreeTo": 0,
                        "name": "Apartment Luxury One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890475,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890476,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890477,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890478,
                        "kidsFreeTo": 0,
                        "name": "Double Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890479,
                        "kidsFreeTo": 0,
                        "name": "Double Club King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890480,
                        "kidsFreeTo": 0,
                        "name": "Double Club Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890482,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890483,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890484,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890485,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890486,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890487,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890488,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890489,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890490,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890491,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890492,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890493,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890494,
                        "kidsFreeTo": 0,
                        "name": "Family Room Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890496,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890497,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890498,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890499,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890500,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890501,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890502,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890503,
                        "kidsFreeTo": 0,
                        "name": "Single Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890505,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890506,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890507,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890508,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890509,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890511,
                        "kidsFreeTo": 0,
                        "name": "Suite Executive",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890512,
                        "kidsFreeTo": 0,
                        "name": "Suite Executive Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890513,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890514,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890515,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890516,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890517,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890520,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070702,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070707,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070711,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070714,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV vía satélite ",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070720,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070723,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070729,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070800,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Smoking rooms",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20070808,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds One Bedroom",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bádminton",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bochas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Green de práctica",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping-pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tiro con arco",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4.3,
                    "totalSurveys": 22,
                    "valuesAverage": [
                        4.1,
                        4.5,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido en los Cabos frente a la playa",
                "uri": "dreams-los-cabos-suites-golf-resort-and-spa",
                "tags": [
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye todos los alimentos y botanas, comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta. Incluye todas las bebidas."
                    },
                    {
                        "title": "Clases",
                        "description": "Incluye estiramiento y acuaeróbics, clases de cocina, bailes latinos y curso de español."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 11 años, supervisado por adultos."
                    }
                ],
                "description": "Royal Solaris Los Cabos Resort and Spa All Inclusive está ubicado en San José del Cabo, en las costas del Mar de Cortés, con impresionantes vistas del Océano Pacífico. Este hotel estilo hacienda mexicana se encuentra a 2 kilómetros del centro de San José del Cabo y a 14 kilómetros del aeropuerto internacional de Los Cabos (SJD).\r\n\r\nEste hotel familiar, todo incluido, cuenta con 400 habitaciones de lujo con grandes terrazas o balcones. Todas incluyen aire acondicionado, baño privado con regadera y televisión con canales premium.\r\n\r\nRoyal Solaris Los Cabos Resort and Spa All Inclusive ofrece tres bares y cinco restaurantes. Disfruta la mejor comida mexicana e internacional. Relájate en cualquiera de las piscinas con tu bebida favorita, pasea por la playa, ejercítate en el gimnasio, juega un partido de tenis o usa el wifi gratis. Tus hijos disfrutarán del parque acuático infantil así como de los toboganes de agua y el club de niños. Si vienes a relajarte, visita el spa y disfruta de una terapia completa de masajes. Royal Solaris Los Cabos Resort organiza actividades y entretenimientos de día y de noche.\r\n\r\n***Por disposición del municipio local, el hotel cobrará un impuesto obligatorio de $36.31 MXN por habitación, por noche, a pagar directamente en el establecimiento.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/acc62d8161021fabd813bf848c0f5c5577d12b7eb84d1ac313fa9d5ef46c3832_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/c0230ab2595ff07e12c135229bb5ee01f78d345e6ab06ee57aac2cb7e2211db7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/8a4f4503005dbcb151b5b7d496641b69b279315f288a358d63f9062381489985.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/8be18e5d76e537f85f35002d8f86e1a93f7c1e3b8a816162b0dba756dab4db41.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/011974e42de52fe6181ce0cc7fd797a34dcd782002d53b39977a1141ac9dbc26.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/91a105006a0b8b934703804ee5a8d78c27c2a34c70bcf6f86ae696fe94d90160.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/a35d505626266a5065110a3011811bf6be75a2e29e51bb30cbc1499512c905ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/f5a434a4bb6b7adc5e5b4b3f57251d31a2c2f18ece85d3fcb3d5f05c43533ebc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/4a54534d8c2175be5a4af819f992d5f5e5ec4eadf2cbabe1bb0480674a3d9bcc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/6e2874bf07d3c3ae7e0c9376ed1f640c3aad80e6b717e13649587083c9e92e61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/3b820949251555f42941d1370103cb3e3ef254a1c651e7fb85dc2e54d3f53615.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/3c180330eb8cee526fec17bd8d26afd0382f26b6e371ba2f6f03d3204d486d13.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/81cefd686b5fc896bfa5bd680d45dfdf5908043d31bf35b52ae76de48c4b789f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/3f7d6270eead7be33dbbea6299f1d500fc3095a5975da216dd8a099d046b3f97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/61a3b07f98f680be8f4eb1479b0845c19d82796ba0598b9fc2a87643ec30f483.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/7a622c5cefe5d6f0e4588c29885ae3da0f4f82901f04c218fe8738f02af11734.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/1b2d9f0bd40ef5930acf796c319456bf23efd01d2c58864bbbbd6e0988fef55e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/6c4d34ca150266d0e5d88f62ea50fbfafffdf6f3c5147b549d1192ee679f2752.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/9d704af861b36dce88e9ff8b34f36a1b8c01d46cadf71330bee8cfaa85c20528.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/8bdc6a34dcda22c5458027dce7ea67c12d4a684e34549c1ff847a47cff1b04db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/37b05411d0679e14cfa18504d6adab9c5cad05cda266df5b4ace29be1143ffe9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/a1be706ee4a8fb44e6a21a4ceac2a6491828080fbc2aa781376af64fc2674256.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/5f5458d16cc445d8052d6510eeca41d40d0fb176789ba261d951d3801095a0b6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/d1645d3833fd2ecbba341c0e592596ec830a82db4f4eeb2983fb8f2cf33e138e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/6fe0ff29ca3e735c11276d600e68c4659c4ba3672e128ea94355ebf5cc04dc65.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/48197f3f6ba3b7b3e6b814b5f3ddba817add32217f389dd9a6a2bb6d4ea75950.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/5753bc437a0f97deda8e62c2693bdba9300f8ed971e1fdf26adb7d0d8b35e0da.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/a9b1dc1c739413371d6abb11987b7c8110e8cef963a07e70885e998b17bc7942.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/cca17f5229e6614b4be2dd0125221461b0aa3211617ae02f159509ddbe3176c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/e49a334d3a7d54cf6ce74daca3352efea15923b6be20d2a44ee457ce768130aa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/6016a500d2f7e6609d0d46537fe37f91128b436d63a0f0a76e9f28d6878598c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/dc14b373e132ac3f43afbfd32134b2d6c91600b4b0fbd8d04fdf53cb116b26ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/02c43460c03110ebd0b9742a8458cceeffebd36c21235cb17bd8f57de449ab94.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/8cc34a20bdb3b0464ffd37c6c32ace621780772ce1884de09ef450cee67978e6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/1a1badf83b8cb85856b9225639c3369bae3e29c69538e417966e57cce640ecf8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/1c29d19927fdf394f213f577f790d10585f7647427276a232fcc6bd2b3070cdd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/1ebd3a606f0d610058e79e206aeb508dc7bea9df70793c11a65f96579f631516.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/260093543c33959e815c40f0e168697196ffeaad3deff0c0590cdaab136eb807.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/7667bd4b9ad4b6264b7f363559f44b9dd396bfccb8166b3c65338d61538e48cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/94ff45a614c6a760216622f9ced84c37ee90e4bb08e7c6fa16f0d5abf577034e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/8d64996f8b361472e6b7026536a95a9f1f9655032c47abc52bb389bdd65766f3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/b8c758a4ec2e8eb9b21fff0d481758b5a9f205977c141babd85131055a61ae5e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/5ac120816ebdd01d106ce35bbbe67a1fb0ccfea34286a164457d6a4b1fe49c78.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/3a5724f68d59aa8fe11e8d6c9a5648f835c81998701fdc0ecbe40b2d0fbf2ad3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100539/c4f360c2205a8400b22208c3c14572e8d42882615b820ff38119046989941e16.png"
                    }
                ],
                "hotelID": 100539,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "San Jose del Cabo, Los Cabos",
                    "country": "Mexico",
                    "latitude": "23.04546827400136",
                    "longitude": "-109.69576120376587",
                    "postalCode": "23400",
                    "state": "Baja California Sur",
                    "street": "Blvr San José M 22 L 10, Campo de Golf",
                    "countryCode": "MX"
                },
                "name": "Royal Solaris Los Cabos Resort & Spa All Inclusive",
                "placeContainers": [
                    {
                        "id": 61763,
                        "uri": "san-jose-del-cabo",
                        "displayText": "San José del Cabo, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 219273,
                        "uri": "plaza-costa-azul-san-jose-del-cabo-baja-california-sur-mexico",
                        "displayText": "Plaza Costa Azul, San José del Cabo, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 69398,
                        "uri": "los-cabos",
                        "displayText": "Los Cabos, Baja California Sur, México",
                        "type": 3
                    },
                    {
                        "id": 404546,
                        "uri": "lap-baja-california-sur-mexico-aeropuerto-internacional-general-manuel-marquez-de-leon-rng",
                        "displayText": "LAP La Paz, Baja California Sur, México - Aeropuerto Internacional Manuel Márquez de León",
                        "type": 10
                    },
                    {
                        "id": 404570,
                        "uri": "sjd-san-jose-del-cabo-baja-california-sur-mexico-aeropuerto-internacional-los-cabos-rng",
                        "displayText": "SJD Los Cabos, San José del Cabo, BCS, México - Aeropuerto Internacional de Los Cabos",
                        "type": 10
                    }
                ],
                "restaurants": [
                    {
                        "name": "Café Solaris",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Marco Polo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Pancho's",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Rosmarinus",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Snack Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Pizzalíssima",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Zaí",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456474,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456500,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456527,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456554,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456583,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456610,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456636,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456662,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456688,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456713,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456738,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456764,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456788,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456814,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456839,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456864,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456888,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456912,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456936,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456960,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456984,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457007,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457030,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457053,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457078,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457101,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457124,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457146,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457169,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457193,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457217,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457241,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457265,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457288,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457311,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457336,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457360,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457383,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457407,
                        "kidsFreeTo": 0,
                        "name": "Executive Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457430,
                        "kidsFreeTo": 0,
                        "name": "Executive Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457452,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457474,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457496,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457516,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457540,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457564,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457589,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457614,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457639,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457665,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457690,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457717,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457744,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457770,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457796,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457822,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457847,
                        "kidsFreeTo": 0,
                        "name": "Executive Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457871,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457895,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457919,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457942,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457965,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18457992,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458015,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458039,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458063,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458087,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458111,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458137,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458162,
                        "kidsFreeTo": 0,
                        "name": "Suite Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458188,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458213,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458237,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458261,
                        "kidsFreeTo": 0,
                        "name": "Executive Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458287,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458313,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458339,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458365,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458393,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458421,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458450,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458471,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458493,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458510,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458526,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458543,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458561,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458578,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458594,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458611,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458627,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458643,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458659,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458675,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458695,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458713,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458726,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458740,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458754,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18458767,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canales premium",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000821,
                        "kidsFreeTo": 4,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Jardín o Ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canales premium",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000822,
                        "kidsFreeTo": 4,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canales premium",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcación directa con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003355,
                        "kidsFreeTo": 4,
                        "name": "De lujo - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canales premium",
                            "Jacuzzi exterior",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1005629,
                        "kidsFreeTo": 0,
                        "name": "De lujo vista al mar con jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión telefónica a Internet",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Internet access (surcharge)",
                            "LED TV",
                            "Limpieza de habitaciones diaria",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Reusable coffee/tea filters",
                            "Rollaway/extra beds (free)",
                            "Room and bed type depend on availability check-in",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Shower only",
                            "Teléfono",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4029651,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony Free Wi-Fi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión telefónica a Internet",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Internet access (surcharge)",
                            "LED TV",
                            "Limpieza de habitaciones diaria",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Reusable coffee/tea filters",
                            "Rollaway/extra beds (free)",
                            "Room and bed type depend on availability check-in",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Shower only",
                            "Teléfono",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4029652,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony, Ocean View Free Wi-Fi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Albornoces",
                            "Bañera con hidromasaje",
                            "Baño privado",
                            "Bathrobes",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Conexión telefónica a Internet",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Internet access (surcharge)",
                            "Jetted bathtub",
                            "LED TV",
                            "Limpieza de habitaciones diaria",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Reusable coffee/tea filters",
                            "Rollaway/extra beds (free)",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Shower only",
                            "Slippers",
                            "Teléfono",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4029654,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room Balcony, 1 King Bed, Jetted Tub, Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión telefónica a Internet",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Internet access (surcharge)",
                            "LED TV",
                            "Limpieza de habitaciones diaria",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Reusable coffee/tea filters",
                            "Rollaway/extra beds (free)",
                            "Room and bed type depend on availability check-in",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Shower only",
                            "Teléfono",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4029655,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room, Balcony, Oceanfront",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canales premium",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4036391,
                        "kidsFreeTo": 4,
                        "name": "De lujo vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Conexión telefónica a Internet",
                            "Escritorio",
                            "Free bottled water",
                            "Free cribs/infant beds",
                            "Free toiletries",
                            "Hair dryer",
                            "Housekeeping on request",
                            "In-room safe",
                            "Internet access (surcharge)",
                            "LED TV",
                            "Limpieza de habitaciones diaria",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Reusable coffee/tea filters",
                            "Rollaway/extra beds (free)",
                            "Room and bed type depend on availability check-in",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Shower only",
                            "Teléfono",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4040017,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Balcony Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina o Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558003,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558007,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558008,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558009,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558010,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558011,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7558013,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7625255,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7648119,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7669702,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7814901,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7850085,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7918006,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8361861,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8361936,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8361961,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362015,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362091,
                        "kidsFreeTo": 0,
                        "name": "Habitación Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Internet access",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362168,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362183,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362193,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8362208,
                        "kidsFreeTo": 0,
                        "name": "Studio Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433704,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433733,
                        "kidsFreeTo": 0,
                        "name": "Family Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433777,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433787,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433791,
                        "kidsFreeTo": 0,
                        "name": "Studio Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433800,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433806,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8433826,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797739,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797740,
                        "kidsFreeTo": 0,
                        "name": "Double Premier Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797741,
                        "kidsFreeTo": 0,
                        "name": "Double Premium Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797742,
                        "kidsFreeTo": 0,
                        "name": "Double Presidential",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797743,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797744,
                        "kidsFreeTo": 0,
                        "name": "Double Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 8797745,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 9067604,
                        "kidsFreeTo": 0,
                        "name": "Double Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11496942,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078361,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078362,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078363,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078364,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078365,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078366,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078368,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Cable TV",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078370,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078374,
                        "kidsFreeTo": 0,
                        "name": "Triple Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078375,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078376,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078377,
                        "kidsFreeTo": 0,
                        "name": "Room Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078378,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078379,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078380,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078381,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078382,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078384,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078386,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078389,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078390,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078393,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078394,
                        "kidsFreeTo": 0,
                        "name": "Room Premier",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078396,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078397,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VaKV1n0sQuBD-x4AKzOO852L0EY=/720x480/05/11/59/05115969.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078399,
                        "kidsFreeTo": 0,
                        "name": "Room With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/n2KCc2nLPixvonqrHl740Rr9N_8=/720x480/05/11/59/05115967.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078400,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078407,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078408,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078409,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078412,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078414,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078417,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078418,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078421,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078424,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fF5Vm3k18YCJEa03HQKHuwG7AtQ=/720x480/05/11/59/05115966.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16078425,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/P9viBhUEdB3EWY6h2-fvFvFPfsE=/720x480/05/11/59/05115968.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175743,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175744,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175746,
                        "kidsFreeTo": 0,
                        "name": "Studio King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175747,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175748,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16175749,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16420728,
                        "kidsFreeTo": 0,
                        "name": "Single Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16516220,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16557452,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059730,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059731,
                        "kidsFreeTo": 0,
                        "name": "Single Premier",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059732,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059733,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059734,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059735,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059736,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059737,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059738,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059739,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059740,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059741,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059742,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059743,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059745,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059746,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059747,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059748,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059750,
                        "kidsFreeTo": 0,
                        "name": "Room Premier Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059751,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059752,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17059753,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213700,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213707,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213717,
                        "kidsFreeTo": 0,
                        "name": "Apartment Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213727,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213735,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213744,
                        "kidsFreeTo": 0,
                        "name": "Single Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213752,
                        "kidsFreeTo": 0,
                        "name": "Apartment One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213760,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17213767,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17988115,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17988116,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18255779,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299915,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299916,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18299917,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18429845,
                        "kidsFreeTo": 0,
                        "name": "Double Premier",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454266,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454291,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454314,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454336,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454358,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454380,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454402,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454424,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454446,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454467,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454487,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454507,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454527,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454546,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454565,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454584,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454602,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454621,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454640,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454659,
                        "kidsFreeTo": 0,
                        "name": "Executive",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454677,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454696,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454716,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454735,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454754,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454774,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454794,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454815,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454838,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454860,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454882,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454904,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454927,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454949,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454972,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18454996,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455019,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455041,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455062,
                        "kidsFreeTo": 0,
                        "name": "Executive Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455082,
                        "kidsFreeTo": 0,
                        "name": "Executive Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455102,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455123,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455145,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455167,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455188,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455211,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455236,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455262,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455287,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455313,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455339,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455364,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455389,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455415,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455440,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455464,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455488,
                        "kidsFreeTo": 0,
                        "name": "Executive Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455511,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455533,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455557,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455580,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455603,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455626,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455650,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455674,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455697,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455720,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455743,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455766,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455789,
                        "kidsFreeTo": 0,
                        "name": "Suite Studio",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455811,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455833,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455855,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455877,
                        "kidsFreeTo": 0,
                        "name": "Executive Deluxe",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455899,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455921,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455942,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455964,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18455985,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456006,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456026,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456046,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456066,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456086,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456106,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456127,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456148,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456169,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456190,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456211,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456231,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456251,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456272,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456293,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456314,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456336,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456358,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456383,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18456410,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532467,
                        "kidsFreeTo": 0,
                        "name": "Single Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532468,
                        "kidsFreeTo": 0,
                        "name": "Single Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532469,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532470,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575136,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824484,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824490,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18824497,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Two Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071047,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071052,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071055,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071059,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071061,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Plancha con tabla"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071065,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Ironing set"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071117,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Un Dormitorio",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Ironing set"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071121,
                        "kidsFreeTo": 0,
                        "name": "Habitación Executive",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Ironing set"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071124,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Ironing set"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071127,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds One Bedroom",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Ironing set"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20071130,
                        "kidsFreeTo": 0,
                        "name": "Triple Executive",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entretenimiento en vivo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Máquina de hielo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático infantil",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salida tardía",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de café en el lobby",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de fotos y videos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de periódicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 1578,
                    "valuesAverage": [
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido con parque acuático en Los Cabos",
                "uri": "royal-solaris-los-cabos-resort-spa-all-inclusive",
                "tags": [
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Ubicación del establecimiento \r\nSi decides alojarte en Waldorf Astoria Los Cabos Pedregal, te encontrarás en una fantástica zona de Cabo San Lucas (Pedregal), apenas te separarán cinco minutos en coche de El Arco y Finisterra. Además, este complejo de 5 estrellas se encuentra a 1,9\u00A0km de Playa del Amor y a 3,5\u00A0km de Playa El Médano.Habitaciones \r\nEn las 113 habitaciones climatizadas, equipadas con chimenea y piscina de inmersión privada, te espera una estancia inolvidable. Las habitaciones disponen de balcón o patio. La conexión a Internet wifi gratis te mantendrá en contacto con los tuyos; también podrás ver tu programa favorito en el televisor con canales por cable. El baño privado con bañera y ducha independientes está provisto de bañera profunda y cabezal de ducha tipo lluvia.Servicios \r\nPara un relax sin igual, nada como una visita al spa, que ofrece masajes, tratamientos corporales y tratamientos faciales. La diversión está asegurada en este establecimiento, que ofrece 4 piscinas al aire libre, una pista de tenis al aire libre y una sauna. Se ofrece además conexión a Internet wifi gratis, servicios de conserjería y servicio de canguro (de pago).Para comer \r\nDegusta algo de marisco en El Farallon, uno de los 4 restaurantes de este complejo. El alojamiento también te ofrece servicio de habitaciones las 24 horas y una cafetería. Relájate con un refresco del bar junto a la piscina o de uno de los 2 bares con salón. Se ofrece un desayuno bufé todos los días de 7:00 a 11:00 con un coste adicional.Servicios de negocios y otros \r\nTendrás un centro de negocios, check-out exprés y periódicos gratuitos en el vestíbulo a tu disposición. Pagando un pequeño suplemento podrás aprovechar prestaciones como servicio de transporte al aeropuerto (ida y vuelta) (disponible las 24 horas) y aparcamiento con asistencia gratuito. \r\nLa edad mínima para realizar el check-in es de 18 años",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/cbbacd96ddd7973a1dce13dc739908c7e0fc7506bda0b496d07975d03d1d48e2_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/aa282d2d5cff4f348884ca4ee8e481894c95527b237f79221f5ced014af7c0b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/abddd86b712103f3d2873ce3f96732523bddb778d56a529ca33887d0fb37620e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/d7e7845392fccbc5c6a0251a2bc87bf6080734509e4af96211a3cf81cd644944.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/5f3c951be92f8e19366d4a6daa74663d977d412fbd2bec9774fd7e62d997c56e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/24f3c1dd22666392e0ad8de3dbe7f93694f734261ec13ab1f1f39876ec54d233.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/479b2cc8cd15fe29d27bcab66035646c6e230aaf3f577ae5d10052d4901e1f81.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/a7bafee86fbcecfe9da94fa1535d21f064dba3bfea55b1dd6dc790486e3360c2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/acc06f84a7d6b70e2768824a7509a067f5da2970c275460ba108b85694c2ee39.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/f79828bd170a9117e9d724470a39c6c93969681bc226c192d7d2a0f06d9d1710.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/642a491de911848ccafdf6bbdcd739879f55019d5faaed52cd4af3ae81ccf7ad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/6de06f9a9b4d7825dd759d3a570bb221238ec1685ba9d7cebd40bef892d870ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/0ea730be5ba4e7cc61fd0dac087abddd502aa67cf76b9713e693bb938e3e258d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/b53dd0b9e53e67b46a222b2c35f5e6c28a54e7b8e2e1fd0c1c5377d1cf8c4b99.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/25d5786a744a809cc66584bddb7c324fdad3b0fca713bc49e96d004452f78c98.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/f5c3be93ca7f3fc469d6215fc4a9b388ec1483a42eef280612ec58864631747e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/ff0cb00a90fee40460cf3eeb58ff561df932d91852d1d4adbd331d68344ebfc3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/7ba51ebeb566b5f81512e2cba0ddd53d611820b76ccd641f51c75000671cd2a5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/71cb28571ab6f8873b278fabcbcf58cb54f036245b12bf9631e71ca8cbf40544.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/7d0cfb0e60abbccc19ef79794ebe91fa0ebdb10e51d42b633697128063524100.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/887a2eaf47d2edad036eca46b8028da20b24b7a2f158bb61f3f8dcd1020be83b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/77b98bac5e6529301783fcfdc731a5103c978ea7ce8eb5b2cf0220db1a862b0e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/4bd1d3d5c1a60a666ccf356d6f7b05db0e64e2883da3d545dc0c75b9748b8ac5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/89605bda8b7e8b568a98cd0f77061b0eaa6aa87cbd5fd3177ab36205501299a9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/04ddbac00268e51090974d7b8fcd7830921f81b0f940794b54980b4ac418a4af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/a4b73fe0a138787c7b2a2b418fa97d2706a43af426a9b17d4d2b5d15ddaf9b68.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/55930fa6aeba8decc124c10512f009e6ef7a24d2cf63ce73b9328aeaadbabed9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/d893b592909d0c10cbfaabd96111245e18e169ea18b44971cafcd5b05fd1a15b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/e2b2fb9e3d08056ff701bad330654236aab8deb96ab1aae24c156cd15d52c5b7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/8f3fa344db97f9ce1971c6c7750d27bcc54cd26a96ab54432d10181e698a01c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/d7043dbfb13044b09a8941ef71dbf7ce12ef642e29b6595d3ea9731eed763d68.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/a6d424774bd6a7bb67869eb6a0bb610b54dffc828ecd05afb73ecff15de57b6e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/30e161808ef5db9c18663fb64d18cd252af495efdd7ab45350b77c66f2751f4a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/59b886a9047bc5b12072edaf91eb8405d7134ef3b891d2b6f58180fd5a15aa97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/28e2a6d2c812a4b9329845907d8c01c88774133cf484d203b4c4f27fcc33ff8f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/1845fa2e42a287b60807af62b73f0f7bee741ba98aa81227f9066004f08d16a0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/e209b9a3e1ed0c2d21c1314b2e9d6bbc930c756a7730372f5f3ae6c513f38e49.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/269bdc6106bbe8a1e34760164aaa1de159411a3ccd3db596ad3450c7e9922f8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/4117225fa5287f0cadbe78484b9eed4bb99b8ae1cd2ab2759adf8ea870a2d483.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/dbf6242504b451c9d65660a21de0449347c1b59861c227ac09b35dec951a63bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/97be16dae459920e3980319b11bde84d88eaa813747e3146dea71adb421021e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/ee307a3f73597ebae62fcc5c4e39859b3bf52e8ae79ce50182ec3d87476d34fb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/55b92af6564d8de5f754b607f0ef9da1a3fb75420228a2c6172b63d22e19d3f7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/ce8f1016c43353b8d4e8a9e04a82ccbf13123901e744a86ef850808ed923c7ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238287/650d822e7b01a0447a1607d015f4dda134f27e19b78f9da4b92563a2f503052c.png"
                    }
                ],
                "hotelID": 238287,
                "importantFacilities": [
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Cabo San Lucas",
                    "country": "Mexico",
                    "latitude": "22.87507",
                    "longitude": "-109.91226",
                    "postalCode": "23455",
                    "state": "Baja California Sur",
                    "street": "Camino Del Mar  1",
                    "countryCode": "MX"
                },
                "name": "Waldorf Astoria Los Cabos Pedregal",
                "placeContainers": [
                    {
                        "id": 62709,
                        "uri": "cabo-san-lucas",
                        "displayText": "Cabo San Lucas, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 219207,
                        "uri": "pedregal-cabo-san-lucas-baja-california-sur-mexico",
                        "displayText": "Pedregal, Cabo San Lucas, Baja California Sur, México",
                        "type": 6
                    },
                    {
                        "id": 69398,
                        "uri": "los-cabos",
                        "displayText": "Los Cabos, Baja California Sur, México",
                        "type": 3
                    },
                    {
                        "id": 404546,
                        "uri": "lap-baja-california-sur-mexico-aeropuerto-internacional-general-manuel-marquez-de-leon-rng",
                        "displayText": "LAP La Paz, Baja California Sur, México - Aeropuerto Internacional Manuel Márquez de León",
                        "type": 10
                    },
                    {
                        "id": 404570,
                        "uri": "sjd-san-jose-del-cabo-baja-california-sur-mexico-aeropuerto-internacional-los-cabos-rng",
                        "displayText": "SJD Los Cabos, San José del Cabo, BCS, México - Aeropuerto Internacional de Los Cabos",
                        "type": 10
                    }
                ],
                "restaurants": [],
                "rooms": [
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Minibar",
                            "Movies",
                            "Pay-per-view movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Slippers",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284338,
                        "kidsFreeTo": 17,
                        "name": "King Ocean View King",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yvX-x1DNHGbNWsaytdTIO99b2Xk=/720x480/12/95/52/12955247.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yvX-x1DNHGbNWsaytdTIO99b2Xk=/720x480/12/95/52/12955247.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284346,
                        "kidsFreeTo": 17,
                        "name": "1King 1Bdrm Beachfront Ste",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284358,
                        "kidsFreeTo": 17,
                        "name": "2Bdrm Beachfront Suite",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cYwUqTcf7iqvfJwjxamuQcMoyuE=/720x480/12/95/47/12954777.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cYwUqTcf7iqvfJwjxamuQcMoyuE=/720x480/12/95/47/12954777.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Private bath with shower and tub",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Trouser press",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284362,
                        "kidsFreeTo": 17,
                        "name": "King Dos Mares Jr Suite",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Slippers",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284369,
                        "kidsFreeTo": 17,
                        "name": "King Pacific View",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/amZACwjg0AxgDN0O873pcS5dEv4=/720x480/12/95/48/12954858.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/amZACwjg0AxgDN0O873pcS5dEv4=/720x480/12/95/48/12954858.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "In-room safe",
                            "Iron board",
                            "Luxurious bed linens",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284375,
                        "kidsFreeTo": 17,
                        "name": "1King 1Bdrm Estrella Ste",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_iA7YnawOyTNgvjUWDeMSwhXdt4=/720x480/12/95/48/12954882.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_iA7YnawOyTNgvjUWDeMSwhXdt4=/720x480/12/95/48/12954882.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Alarm clock radio",
                            "Bath amenities",
                            "Black-out drapes",
                            "Cable/satellite TV",
                            "Desk with electrical outlet",
                            "Duvet",
                            "DVD player",
                            "Electrical current voltage",
                            "Ergonomic chair",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "High-speed internet access",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Luxurious bed linens",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284378,
                        "kidsFreeTo": 17,
                        "name": "Private Home 3 Bedrooms",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Bathrobes",
                            "Coffeemaker",
                            "Converters/ Voltage adaptors",
                            "Electrical current voltage",
                            "Ergonomic chair",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "High-speed internet access",
                            "Iron board",
                            "Luxurious bed linens",
                            "Minibar",
                            "Radio",
                            "Telephone"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 9,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284380,
                        "kidsFreeTo": 17,
                        "name": "Private Home 4 Bedrooms",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284386,
                        "kidsFreeTo": 17,
                        "name": "King Terraza Ocean View",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/hmro6hfAtI2s8v4eTfIgN1RGSaY=/720x480/12/95/50/12955028.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/hmro6hfAtI2s8v4eTfIgN1RGSaY=/720x480/12/95/50/12955028.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284393,
                        "kidsFreeTo": 17,
                        "name": "1King 1Bdrm Ocean View Ste",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZKPBJYsRk2klVTwynI9CzxuY6U8=/720x480/12/95/49/12954974.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZKPBJYsRk2klVTwynI9CzxuY6U8=/720x480/12/95/49/12954974.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Dishwasher",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284397,
                        "kidsFreeTo": 17,
                        "name": "2Bdrm Ocean View Villa",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2UVpt_3pjeZqx5n3hQt7DTMhKcY=/720x480/12/95/50/12955098.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2UVpt_3pjeZqx5n3hQt7DTMhKcY=/720x480/12/95/50/12955098.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Alarm clock radio",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Cable/satellite TV",
                            "Coffeemaker",
                            "Duvet",
                            "DVD player",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Luxurious bed linens",
                            "Newspaper",
                            "Radio",
                            "Sitting area with sofa bed",
                            "Smoke free",
                            "Sofa bed",
                            "Trouser press",
                            "Wet bar and sitting area"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284403,
                        "kidsFreeTo": 17,
                        "name": "Ocean View Deluxe 1 King",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Cable/satellite TV",
                            "Coffeemaker",
                            "Dishwasher",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "Iron board",
                            "Microwave",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284409,
                        "kidsFreeTo": 17,
                        "name": "2 Bdrm Resort Casita",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/5OQLxI6SI9ZamhkrREAGosHctlo=/720x480/12/95/51/12955138.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/5OQLxI6SI9ZamhkrREAGosHctlo=/720x480/12/95/51/12955138.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Dishwasher",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "In-room safe",
                            "Microwave",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "Table and chairs",
                            "Trouser press",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284416,
                        "kidsFreeTo": 17,
                        "name": "3 Bdrm Resort Casita",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/5OQLxI6SI9ZamhkrREAGosHctlo=/720x480/12/95/51/12955138.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/5OQLxI6SI9ZamhkrREAGosHctlo=/720x480/12/95/51/12955138.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Direct dial telephone with voice mail",
                            "Duvet",
                            "Fireplace",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284420,
                        "kidsFreeTo": 17,
                        "name": "2 Queen Deluxe Ocean View",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jAbMaSLiFhwOAIcYitISP4tWyL0=/720x480/12/95/50/12955064.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jAbMaSLiFhwOAIcYitISP4tWyL0=/720x480/12/95/50/12955064.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Iron and board",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Newspaper",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284423,
                        "kidsFreeTo": 17,
                        "name": "3 Bdrm Presidential Suite",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kdKhfdLr-4syRuEeFhd8MqgeoXw=/720x480/12/95/46/12954651.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kdKhfdLr-4syRuEeFhd8MqgeoXw=/720x480/12/95/46/12954651.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284428,
                        "kidsFreeTo": 17,
                        "name": "King Deluxe Ocean View",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/5dLGQrMUjlysrVMiccxUEMQPqWA=/720x480/12/95/51/12955196.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/5dLGQrMUjlysrVMiccxUEMQPqWA=/720x480/12/95/51/12955196.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bathrobes",
                            "Coffeemaker",
                            "Dishwasher",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "HD Flat-screen TV",
                            "In-room safe",
                            "Microwave",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Trouser press",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284434,
                        "kidsFreeTo": 17,
                        "name": "3Bdrm Ocean View Villa",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2UVpt_3pjeZqx5n3hQt7DTMhKcY=/720x480/12/95/50/12955098.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2UVpt_3pjeZqx5n3hQt7DTMhKcY=/720x480/12/95/50/12955098.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Microwave",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Slippers",
                            "Speaker phone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16284439,
                        "kidsFreeTo": 17,
                        "name": "King Ocean View Vista",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/2BSpYR0f4kw2VY77_K8-mIA-w_U=/720x480/12/95/52/12955216.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/2BSpYR0f4kw2VY77_K8-mIA-w_U=/720x480/12/95/52/12955216.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Iron board",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998197,
                        "kidsFreeTo": 17,
                        "name": "4Bdrm Panoramic Marina Hme",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "Iron board",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998199,
                        "kidsFreeTo": 17,
                        "name": "4 Bdrm Marina Private Home",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "HD Flat-screen TV",
                            "In-room safe",
                            "Iron board",
                            "Microwave",
                            "Minibar",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998201,
                        "kidsFreeTo": 17,
                        "name": "3Bdrm Panoramic Marina Hme",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Cable/satellite TV",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "Iron board",
                            "Microwave",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998203,
                        "kidsFreeTo": 17,
                        "name": "4Bdrm Mountain Private Hme",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Private bath with shower and tub",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998204,
                        "kidsFreeTo": 17,
                        "name": "3 Bedroom Private Home",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtix6EJIPooSqzV08f8pYL4GGq4=/720x480/12/95/49/12954923.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998206,
                        "kidsFreeTo": 17,
                        "name": "4 Bedroom Private Home",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Alarm clock radio",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "Iron board",
                            "Minibar",
                            "Private bathroom with separate shower",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Speaker phone",
                            "TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16998208,
                        "kidsFreeTo": 17,
                        "name": "3Bdrm Marina Private Home",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Bath amenities",
                            "Black-out drapes",
                            "Cable/satellite TV",
                            "Coffeemaker",
                            "Converters/ Voltage adaptors",
                            "Desk with electrical outlet",
                            "Direct dial telephone with voice mail",
                            "Dishwasher",
                            "Down pillow",
                            "Electrical current voltage",
                            "Ergonomic chair",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "High-speed internet access",
                            "Individual climate control",
                            "Iron board",
                            "Luxurious bed linens",
                            "Microwave",
                            "Refrigerator",
                            "Rollaway",
                            "Sitting area with sofa bed",
                            "Smoke free",
                            "Sofa bed",
                            "Table and chairs",
                            "Telephone",
                            "Trouser press"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17204447,
                        "kidsFreeTo": 0,
                        "name": "King Deluxe Ocean View",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lFwS7x4iYW-0xakyc71JUHeOuEA=/720x480/12/95/46/12954626.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Telephone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20112747,
                        "kidsFreeTo": 0,
                        "name": "Ocean View Premium King Bd",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Telephone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20112748,
                        "kidsFreeTo": 0,
                        "name": "3 Bdr Premium Ocean Vw Ste",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Telephone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20112749,
                        "kidsFreeTo": 0,
                        "name": "2 Bdr Premium Ocean Vw Ste",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Telephone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20112750,
                        "kidsFreeTo": 0,
                        "name": "3 Bedroom Premium Casita",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Air conditioning",
                            "Balcony or terrace",
                            "Bath amenities",
                            "Bathrobes",
                            "Black-out drapes",
                            "Coffeemaker",
                            "Duvet",
                            "Fireplace",
                            "Fully-equipped kitchen",
                            "Hairdryer",
                            "HD Flat-screen TV",
                            "Individual climate control",
                            "In-room safe",
                            "Iron board",
                            "Minibar",
                            "Movies",
                            "Private bathroom with separate shower",
                            "Refrigerator",
                            "Separate toilet area",
                            "Sitting area with sofa bed",
                            "Slippers",
                            "Smoke free",
                            "Speaker phone",
                            "Table and chairs",
                            "Telephone",
                            "TV",
                            "Wake up service"
                        ],
                        "bedding": "1 Cama o 2 Camas (sujeto a disponibilidad)",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20112751,
                        "kidsFreeTo": 0,
                        "name": "2 Bedroom Premium Casita",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wDEdYaxNX3kRlt6nVi7yBMzXqzA=/720x480/12/95/47/12954795.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Asistencia turística",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Computadoras con internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Periódicos en el lobby",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 5,
                "surveyAverage": null,
                "title": null,
                "uri": "waldorf-astoria-los-cabos-pedregal",
                "tags": [],
                "trace": null
            }
        ]
    },
    {
        "destinoId": 4,
        titulo: "Hoteles en Puerto Vallarta",
        destino: "Puerto Vallarta",
        hoteles: [
            { name: "Grand Decameron Complex, A Trademark All-Inclusive" },
            { name: "Samba Vallarta All Inclusive Beach Resort by Emporio Hotels" },
            { name: "Crown Paradise Club Puerto Vallarta" },
            {
                "hotelId": 100238,
                "firstRoomId": 10198124,
                "name": "Hacienda Buenaventura Hotel and Mexican Charm",
                "uri": "hacienda-buenaventura-hotel-and-mexican-charm",
                "title": "Hotel y spa todo incluido en la zona hotelera de Puerto Vallarta",
                "mainPhoto": {
                    "cloudUri": "https://img.cdnpth.com/media/100238/16380-ef9ad41d_z_main.jpg",
                    "idPhoto": 0
                },
                "locationInfo": {
                    "country": "Mexico",
                    "latitude": "20.65025400905051",
                    "longitude": "-105.24085879325867",
                    "city": "Puerto Vallarta",
                    "state": "Jalisco",
                    "countryCode": "MX"
                },
                "tags": [
                    {
                        "name": null
                    },
                    {
                        "name": null
                    },
                    {
                        "name": null
                    }
                ],
                "highlights": null,
                "stars": 3,
                "placeId": 0,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 953
                },
                "price": 3280.7737935,
                "rooms": 1,
                "isRequote": false,
                "measure": null,
                "taxes": {
                    "cancellationPolicies": {
                        "freeCancellationExpire": "2025-04-21T00:00:00",
                        "isCancelSort": 0,
                        "policies": []
                    },
                    "promotionId": 0,
                    "mealPlanCode": "I",
                    "name": "Double Standard",
                    "rooms": 1,
                    "collectType": 1,
                    "roomId": null,
                    "rateId": null,
                    "cancellationData": null,
                    "externalProvider": null,
                    "currentProcess": null,
                    "marginBrandData": null,
                    "rateKey": null,
                    "hasTaxes": true,
                    "totalRoomRate": 16403.8689675,
                    "totalRoomRateBeforePromo": 16403.8689675,
                    "totalRoomRateBeforePromoExclusive": 16403.8689675,
                    "totalRoomRatePerNight": 3280.7737935,
                    "totalRoomRateBeforePromoPerNight": 3280.7737935,
                    "totalAmountForPax": 5467.9563225,
                    "prePromotionAmountForPax": 5467.9563225,
                    "promotion": "",
                    "promotionValue": "",
                    "promotionType": 0,
                    "idException": 0,
                    "discount": 0,
                    "taxScheme": 5,
                    "totalTaxes": 0,
                    "taxPercentage": 0,
                    "totalTaxesPerRoomPerNight": 0,
                    "checkOutTotalRate": 16403.8689675,
                    "checkOutTotalRateBeforePromo": 16403.8689675,
                    "checkOutRateWoTaxes": 16403.8689675,
                    "checkOutRateBeforePromoWoTaxes": 16403.8689675,
                    "checkOutRateBeforePromoWoTaxesExclusive": 16403.8689675,
                    "checkOutHasTaxes": true,
                    "isOnRequest": false,
                    "breakdown": {
                        "amount": 0,
                        "breadDowns": [],
                        "breakDowns": []
                    }
                },
                "rates": [
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Double Standard",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "10198124",
                        "rateId": "77157647",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 30 de Marzo del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "31 de Marzo del 2025 a las 00:01 hrs",
                                    "description": "13695.57 MXN de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "100",
                        "currentProcess": {
                            "indexKey": "77157647",
                            "request": {
                                "hotelId": 100238,
                                "amount": 16403.8689675,
                                "communityId": 0,
                                "indexKey": "77157647",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "100",
                            "margin": 0.1651,
                            "serviceId": 100238,
                            "destinationId": 32
                        },
                        "rateKey": "77157647",
                        "hasTaxes": true,
                        "totalRoomRate": 16403.8689675,
                        "totalRoomRateBeforePromo": 16403.8689675,
                        "totalRoomRateBeforePromoExclusive": 16403.8689675,
                        "totalRoomRatePerNight": 3280.7737935,
                        "totalRoomRateBeforePromoPerNight": 3280.7737935,
                        "totalAmountForPax": 5467.9563225,
                        "prePromotionAmountForPax": 5467.9563225,
                        "promotion": "",
                        "promotionValue": "",
                        "promotionType": 0,
                        "idException": 0,
                        "discount": 0,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 16403.8689675,
                        "checkOutTotalRateBeforePromo": 16403.8689675,
                        "checkOutRateWoTaxes": 16403.8689675,
                        "checkOutRateBeforePromoWoTaxes": 16403.8689675,
                        "checkOutRateBeforePromoWoTaxesExclusive": 16403.8689675,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Estándar 2 dobles",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "1000253",
                        "rateId": "1663",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 31 de Marzo del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "1 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "1663",
                            "request": {
                                "hotelId": 100238,
                                "amount": 21306.5352,
                                "communityId": 0,
                                "indexKey": "1663",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.1651,
                            "serviceId": 100238,
                            "destinationId": 32
                        },
                        "rateKey": "1663",
                        "hasTaxes": true,
                        "totalRoomRate": 21306.5352,
                        "totalRoomRateBeforePromo": 20888.76,
                        "totalRoomRateBeforePromoExclusive": 20888.76,
                        "totalRoomRatePerNight": 4261.30704,
                        "totalRoomRateBeforePromoPerNight": 5013.3024,
                        "totalAmountForPax": 7102.1784,
                        "prePromotionAmountForPax": 8355.504,
                        "promotion": "Oferta de invierno",
                        "promotionValue": "",
                        "promotionType": 4,
                        "idException": 960899,
                        "discount": 15,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 21306.5352,
                        "checkOutTotalRateBeforePromo": 25066.512,
                        "checkOutRateWoTaxes": 17755.446,
                        "checkOutRateBeforePromoWoTaxes": 20888.76,
                        "checkOutRateBeforePromoWoTaxesExclusive": 20888.76,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Estándar doble e individual",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "1005297",
                        "rateId": "11620062",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 31 de Marzo del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "1 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "11620062",
                            "request": {
                                "hotelId": 100238,
                                "amount": 21306.5352,
                                "communityId": 0,
                                "indexKey": "11620062",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.1651,
                            "serviceId": 100238,
                            "destinationId": 32
                        },
                        "rateKey": "11620062",
                        "hasTaxes": true,
                        "totalRoomRate": 21306.5352,
                        "totalRoomRateBeforePromo": 20888.76,
                        "totalRoomRateBeforePromoExclusive": 20888.76,
                        "totalRoomRatePerNight": 4261.30704,
                        "totalRoomRateBeforePromoPerNight": 5013.3024,
                        "totalAmountForPax": 7102.1784,
                        "prePromotionAmountForPax": 8355.504,
                        "promotion": "Oferta de invierno",
                        "promotionValue": "",
                        "promotionType": 4,
                        "idException": 960899,
                        "discount": 15,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 21306.5352,
                        "checkOutTotalRateBeforePromo": 25066.512,
                        "checkOutRateWoTaxes": 17755.446,
                        "checkOutRateBeforePromoWoTaxes": 20888.76,
                        "checkOutRateBeforePromoWoTaxesExclusive": 20888.76,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Superior 2 dobles",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "1000254",
                        "rateId": "1671",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 31 de Marzo del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "1 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "1671",
                            "request": {
                                "hotelId": 100238,
                                "amount": 24499.257925788,
                                "communityId": 0,
                                "indexKey": "1671",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.1651,
                            "serviceId": 100238,
                            "destinationId": 32
                        },
                        "rateKey": "1671",
                        "hasTaxes": true,
                        "totalRoomRate": 24499.257925788,
                        "totalRoomRateBeforePromo": 24018.8803194,
                        "totalRoomRateBeforePromoExclusive": 24018.8803194,
                        "totalRoomRatePerNight": 4899.8515851576,
                        "totalRoomRateBeforePromoPerNight": 5764.531276656,
                        "totalAmountForPax": 8166.419308596,
                        "prePromotionAmountForPax": 9607.55212776,
                        "promotion": "Oferta de invierno",
                        "promotionValue": "",
                        "promotionType": 4,
                        "idException": 960899,
                        "discount": 15,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 24499.257925788,
                        "checkOutTotalRateBeforePromo": 28822.65638328,
                        "checkOutRateWoTaxes": 20416.04827149,
                        "checkOutRateBeforePromoWoTaxes": 24018.8803194,
                        "checkOutRateBeforePromoWoTaxesExclusive": 24018.8803194,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    }
                ],
                "filters": [
                    {
                        "id": 5,
                        "groupId": 1,
                        "display": "Familia",
                        "uri": "familia",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 7,
                        "groupId": 1,
                        "display": "Spa",
                        "uri": "spa",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 12,
                        "groupId": 2,
                        "display": "2 estrellas o más",
                        "uri": "2-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 13,
                        "groupId": 2,
                        "display": "3 estrellas o más",
                        "uri": "3-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 540,
                        "groupId": 2,
                        "display": "1 estrellas o más",
                        "uri": "1-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 17,
                        "groupId": 3,
                        "display": "Desayuno americano",
                        "uri": "desayuno-americano",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 18,
                        "groupId": 3,
                        "display": "Desayuno bufet",
                        "uri": "desayuno-bufet",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 19,
                        "groupId": 3,
                        "display": "Comida",
                        "uri": "comida",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 20,
                        "groupId": 3,
                        "display": "Solo alojamiento",
                        "uri": "solo-alojamiento",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 21,
                        "groupId": 3,
                        "display": "Desayuno y cena incluidos",
                        "uri": "desayuno-y-cena-incluidos",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 22,
                        "groupId": 3,
                        "display": "Desayuno, comida y cena",
                        "uri": "desayuno-comida-y-cena",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 24,
                        "groupId": 3,
                        "display": "Todo incluido",
                        "uri": "plan-todo-incluido",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 27,
                        "groupId": 3,
                        "display": "Desayuno continental",
                        "uri": "desayuno-continental",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 69,
                        "groupId": 3,
                        "display": "Sin alimentos",
                        "uri": "plan-europeo",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 70,
                        "groupId": 3,
                        "display": "Desayuno incluido",
                        "uri": "desayuno-incluido",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 47,
                        "groupId": 5,
                        "display": "Internet",
                        "uri": "amenidad-internet",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 52,
                        "groupId": 5,
                        "display": "Balcón o terraza",
                        "uri": "amenidad-balcon-o-terraza",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 53,
                        "groupId": 5,
                        "display": "Caja de seguridad",
                        "uri": "amenidad-caja-de-seguridad",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 56,
                        "groupId": 5,
                        "display": "Spa",
                        "uri": "amenidad-spa",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 60,
                        "groupId": 5,
                        "display": "Alberca",
                        "uri": "amenidad-alberca",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 66,
                        "groupId": 5,
                        "display": "Tabla de planchar",
                        "uri": "amenidad-tabla-planchar",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 67,
                        "groupId": 5,
                        "display": "Secadora de cabello",
                        "uri": "amenidad-secadora-de-cabello",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 79,
                        "groupId": 5,
                        "display": "Regadera",
                        "uri": "amenidad-regadera",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 80,
                        "groupId": 5,
                        "display": "Tina",
                        "uri": "amenidad-tina",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 542,
                        "groupId": 5,
                        "display": "Alto estándar de limpieza",
                        "uri": "alto-estandar-de-limpieza",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 536,
                        "groupId": 8,
                        "display": "3 estrellas",
                        "uri": "3-estrellas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 653009,
                        "groupId": 7,
                        "display": "Puerto Vallarta Aeropuerto Internacional, Jalisco, México",
                        "uri": "aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 77395,
                        "groupId": 7,
                        "display": "Zona hotelera del norte, Puerto Vallarta, Jalisco, México",
                        "uri": "zona-hotelera-del-norte-puerto-vallarta-jalisco-mexico",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 87212,
                        "groupId": 7,
                        "display": "Puerto Vallarta Zona Hotelera",
                        "uri": "zona-hotelera-puerto-vallarta-guadalajara-mexico",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    }
                ],
                "filtersHotels": [
                    "stars_3",
                    "interest_familia",
                    "interest_spa",
                    "amenities_amenidad-internet",
                    "amenities_amenidad-balcon-o-terraza",
                    "amenities_amenidad-caja-de-seguridad",
                    "amenities_amenidad-spa",
                    "amenities_amenidad-alberca",
                    "amenities_amenidad-tabla-planchar",
                    "amenities_amenidad-secadora-de-cabello",
                    "amenities_amenidad-regadera",
                    "amenities_amenidad-tina",
                    "amenities_alto-estandar-de-limpieza",
                    "zones_aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                    "zones_zona-hotelera-del-norte-puerto-vallarta-jalisco-mexico",
                    "zones_zona-hotelera-puerto-vallarta-guadalajara-mexico",
                    "familia",
                    "spa",
                    "2-estrellas-mas",
                    "3-estrellas-mas",
                    "1-estrellas-mas",
                    "desayuno-americano",
                    "desayuno-bufet",
                    "comida",
                    "solo-alojamiento",
                    "desayuno-y-cena-incluidos",
                    "desayuno-comida-y-cena",
                    "plan-todo-incluido",
                    "desayuno-continental",
                    "plan-europeo",
                    "desayuno-incluido",
                    "amenidad-internet",
                    "amenidad-balcon-o-terraza",
                    "amenidad-caja-de-seguridad",
                    "amenidad-spa",
                    "amenidad-alberca",
                    "amenidad-tabla-planchar",
                    "amenidad-secadora-de-cabello",
                    "amenidad-regadera",
                    "amenidad-tina",
                    "alto-estandar-de-limpieza",
                    "3-estrellas",
                    "aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                    "zona-hotelera-del-norte-puerto-vallarta-jalisco-mexico",
                    "zona-hotelera-puerto-vallarta-guadalajara-mexico",
                    "paylater_1",
                    "mealplans_I",
                    "freecancellation_allowed"
                ],
                "queryId": "ba2793cabfebdfe34f897b818ecb9c1c",
                "indexName": "searchHotelPlacesMX",
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Temascal",
                        "hasExtraChange": false
                    }
                ]
            },
            {
                "hotelId": 100208,
                "firstRoomId": 6955806,
                "name": "Flamingo Vallarta Hotel & Marina",
                "uri": "flamingo-vallarta-hotel-and-marina",
                "title": "Hotel confortable en la Marina de Puerto Vallarta",
                "mainPhoto": {
                    "cloudUri": "https://img.cdnpth.com/media/100208/545617-a79c162d_z_main.jpg",
                    "idPhoto": 0
                },
                "locationInfo": {
                    "country": "Mexico",
                    "latitude": "20.664670068209926",
                    "longitude": "-105.24825096130371",
                    "city": "Puerto Vallarta",
                    "state": "Jalisco",
                    "countryCode": "MX"
                },
                "tags": [
                    {
                        "name": null
                    },
                    {
                        "name": null
                    }
                ],
                "highlights": [
                    {
                        "info": "Gimnasio"
                    }
                ],
                "stars": 4,
                "placeId": 0,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 941
                },
                "price": 3847.3554848662834,
                "rooms": 1,
                "isRequote": false,
                "measure": null,
                "taxes": {
                    "cancellationPolicies": {
                        "freeCancellationExpire": "2025-04-21T00:00:00",
                        "isCancelSort": 0,
                        "policies": []
                    },
                    "promotionId": 0,
                    "mealPlanCode": "I",
                    "name": "Estándar 2 queens",
                    "rooms": 1,
                    "collectType": 1,
                    "roomId": null,
                    "rateId": null,
                    "cancellationData": null,
                    "externalProvider": null,
                    "currentProcess": null,
                    "marginBrandData": null,
                    "rateKey": null,
                    "hasTaxes": true,
                    "totalRoomRate": 19236.77742433142,
                    "totalRoomRateBeforePromo": 27639.0485,
                    "totalRoomRateBeforePromoExclusive": 27639.0485,
                    "totalRoomRatePerNight": 3847.3554848662834,
                    "totalRoomRateBeforePromoPerNight": 6633.37164,
                    "totalAmountForPax": 6412.259141443806,
                    "prePromotionAmountForPax": 11055.6194,
                    "promotion": "Descuento por reservación anticipada",
                    "promotionValue": "",
                    "promotionType": 16,
                    "idException": 1146890,
                    "discount": 42,
                    "taxScheme": 5,
                    "totalTaxes": 0,
                    "taxPercentage": 0,
                    "totalTaxesPerRoomPerNight": 0,
                    "checkOutTotalRate": 19236.77742433142,
                    "checkOutTotalRateBeforePromo": 33166.8582,
                    "checkOutRateWoTaxes": 16030.647853609515,
                    "checkOutRateBeforePromoWoTaxes": 27639.0485,
                    "checkOutRateBeforePromoWoTaxesExclusive": 27639.0485,
                    "checkOutHasTaxes": true,
                    "isOnRequest": false,
                    "breakdown": {
                        "amount": 0,
                        "breadDowns": [],
                        "breakDowns": []
                    }
                },
                "rates": [
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "E",
                        "name": "Estándar 2 queens",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "6955806",
                        "rateId": "59143644",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143644",
                            "request": {
                                "hotelId": 100208,
                                "amount": 9398.107163927329,
                                "communityId": 0,
                                "indexKey": "59143644",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143644",
                        "hasTaxes": true,
                        "totalRoomRate": 9398.107163927329,
                        "totalRoomRateBeforePromo": 13503.028,
                        "totalRoomRateBeforePromoExclusive": 13503.028,
                        "totalRoomRatePerNight": 1879.6214327854657,
                        "totalRoomRateBeforePromoPerNight": 3240.72672,
                        "totalAmountForPax": 3132.702387975776,
                        "prePromotionAmountForPax": 5401.2112,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 9398.107163927329,
                        "checkOutTotalRateBeforePromo": 16203.6336,
                        "checkOutRateWoTaxes": 7831.75596993944,
                        "checkOutRateBeforePromoWoTaxes": 13503.028,
                        "checkOutRateBeforePromoWoTaxesExclusive": 13503.028,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "E",
                        "name": "Vista a la marina 2 queens",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "6955808",
                        "rateId": "59143646",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143646",
                            "request": {
                                "hotelId": 100208,
                                "amount": 12859.663266281665,
                                "communityId": 0,
                                "indexKey": "59143646",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143646",
                        "hasTaxes": true,
                        "totalRoomRate": 12859.663266281665,
                        "totalRoomRateBeforePromo": 18476.528,
                        "totalRoomRateBeforePromoExclusive": 18476.528,
                        "totalRoomRatePerNight": 2571.9326532563327,
                        "totalRoomRateBeforePromoPerNight": 4434.36672,
                        "totalAmountForPax": 4286.554422093888,
                        "prePromotionAmountForPax": 7390.6112,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 12859.663266281665,
                        "checkOutTotalRateBeforePromo": 22171.8336,
                        "checkOutRateWoTaxes": 10716.38605523472,
                        "checkOutRateBeforePromoWoTaxes": 18476.528,
                        "checkOutRateBeforePromoWoTaxesExclusive": 18476.528,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "E",
                        "name": "De lujo 2 queens",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "6955813",
                        "rateId": "59143650",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143650",
                            "request": {
                                "hotelId": 100208,
                                "amount": 14877.755947486961,
                                "communityId": 0,
                                "indexKey": "59143650",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143650",
                        "hasTaxes": true,
                        "totalRoomRate": 14877.755947486961,
                        "totalRoomRateBeforePromo": 21376.0865,
                        "totalRoomRateBeforePromoExclusive": 21376.0865,
                        "totalRoomRatePerNight": 2975.5511894973924,
                        "totalRoomRateBeforePromoPerNight": 5130.26076,
                        "totalAmountForPax": 4959.251982495654,
                        "prePromotionAmountForPax": 8550.4346,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 14877.755947486961,
                        "checkOutTotalRateBeforePromo": 25651.3038,
                        "checkOutRateWoTaxes": 12398.129956239134,
                        "checkOutRateBeforePromoWoTaxes": 21376.0865,
                        "checkOutRateBeforePromoWoTaxesExclusive": 21376.0865,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Estándar 2 queens - todo incluido",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "7766698",
                        "rateId": "59143652",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143652",
                            "request": {
                                "hotelId": 100208,
                                "amount": 19236.77742433142,
                                "communityId": 0,
                                "indexKey": "59143652",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143652",
                        "hasTaxes": true,
                        "totalRoomRate": 19236.77742433142,
                        "totalRoomRateBeforePromo": 27639.0485,
                        "totalRoomRateBeforePromoExclusive": 27639.0485,
                        "totalRoomRatePerNight": 3847.3554848662834,
                        "totalRoomRateBeforePromoPerNight": 6633.37164,
                        "totalAmountForPax": 6412.259141443806,
                        "prePromotionAmountForPax": 11055.6194,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 19236.77742433142,
                        "checkOutTotalRateBeforePromo": 33166.8582,
                        "checkOutRateWoTaxes": 16030.647853609515,
                        "checkOutRateBeforePromoWoTaxes": 27639.0485,
                        "checkOutRateBeforePromoWoTaxesExclusive": 27639.0485,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Vista a la marina 2 queens - todo incluido",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "7766700",
                        "rateId": "59143654",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143654",
                            "request": {
                                "hotelId": 100208,
                                "amount": 22789.277595081414,
                                "communityId": 0,
                                "indexKey": "59143654",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143654",
                        "hasTaxes": true,
                        "totalRoomRate": 22789.277595081414,
                        "totalRoomRateBeforePromo": 32743.2155,
                        "totalRoomRateBeforePromoExclusive": 32743.2155,
                        "totalRoomRatePerNight": 4557.855519016282,
                        "totalRoomRateBeforePromoPerNight": 7858.37172,
                        "totalAmountForPax": 7596.425865027138,
                        "prePromotionAmountForPax": 13097.2862,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 22789.277595081414,
                        "checkOutTotalRateBeforePromo": 39291.8586,
                        "checkOutRateWoTaxes": 18991.064662567846,
                        "checkOutRateBeforePromoWoTaxes": 32743.2155,
                        "checkOutRateBeforePromoWoTaxesExclusive": 32743.2155,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "De lujo 2 queens - todo incluido",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "7766711",
                        "rateId": "59143658",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 16 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "17 de Abril del 2025 a las 00:01 hrs",
                                    "description": "100% de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "1",
                        "currentProcess": {
                            "indexKey": "59143658",
                            "request": {
                                "hotelId": 100208,
                                "amount": 24860.413908,
                                "communityId": 0,
                                "indexKey": "59143658",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "1",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "59143658",
                        "hasTaxes": true,
                        "totalRoomRate": 24860.413908,
                        "totalRoomRateBeforePromo": 35718.9855,
                        "totalRoomRateBeforePromoExclusive": 35718.9855,
                        "totalRoomRatePerNight": 4972.0827816,
                        "totalRoomRateBeforePromoPerNight": 8572.55652,
                        "totalAmountForPax": 8286.804636,
                        "prePromotionAmountForPax": 14287.5942,
                        "promotion": "Descuento por reservación anticipada",
                        "promotionValue": "",
                        "promotionType": 16,
                        "idException": 1146890,
                        "discount": 42,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 24860.413908,
                        "checkOutTotalRateBeforePromo": 42862.7826,
                        "checkOutRateWoTaxes": 20717.01159,
                        "checkOutRateBeforePromoWoTaxes": 35718.9855,
                        "checkOutRateBeforePromoWoTaxesExclusive": 35718.9855,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Triple Standard",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "7862481",
                        "rateId": "74163919",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 6 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "7 de Abril del 2025 a las 00:01 hrs",
                                    "description": "47164.72 MXN de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "100",
                        "currentProcess": {
                            "indexKey": "74163919",
                            "request": {
                                "hotelId": 100208,
                                "amount": 62886.293333333335,
                                "communityId": 0,
                                "indexKey": "74163919",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "100",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "74163919",
                        "hasTaxes": true,
                        "totalRoomRate": 62886.293333333335,
                        "totalRoomRateBeforePromo": 62886.293333333335,
                        "totalRoomRateBeforePromoExclusive": 62886.293333333335,
                        "totalRoomRatePerNight": 12577.258666666667,
                        "totalRoomRateBeforePromoPerNight": 12577.258666666667,
                        "totalAmountForPax": 20962.097777777777,
                        "prePromotionAmountForPax": 20962.097777777777,
                        "promotion": "",
                        "promotionValue": "",
                        "promotionType": 0,
                        "idException": 0,
                        "discount": 0,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 62886.293333333335,
                        "checkOutTotalRateBeforePromo": 62886.293333333335,
                        "checkOutRateWoTaxes": 62886.293333333335,
                        "checkOutRateBeforePromoWoTaxes": 62886.293333333335,
                        "checkOutRateBeforePromoWoTaxesExclusive": 62886.293333333335,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    },
                    {
                        "cancellationPolicies": null,
                        "promotionId": 0,
                        "mealPlanCode": "I",
                        "name": "Triple Marina View",
                        "rooms": 1,
                        "collectType": 1,
                        "roomId": "7897483",
                        "rateId": "74163951",
                        "cancellationData": {
                            "title": "Cancelación GRATIS",
                            "validUntil": "Hasta el 6 de Abril del 2025",
                            "policies": [
                                {
                                    "dateToApplyPolicy": "7 de Abril del 2025 a las 00:01 hrs",
                                    "description": "52648.33 MXN de penalidad "
                                }
                            ],
                            "cancellationPolicyClass": "free-cancel",
                            "isNonRefundable": false,
                            "cancellationPolicyType": 4
                        },
                        "externalProvider": "100",
                        "currentProcess": {
                            "indexKey": "74163951",
                            "request": {
                                "hotelId": 100208,
                                "amount": 70197.77333333333,
                                "communityId": 0,
                                "indexKey": "74163951",
                                "isPackage": false,
                                "productTypeId": 1
                            },
                            "hasData": true
                        },
                        "marginBrandData": {
                            "providerId": "100",
                            "margin": 0.25,
                            "serviceId": 100208,
                            "destinationId": 32
                        },
                        "rateKey": "74163951",
                        "hasTaxes": true,
                        "totalRoomRate": 70197.77333333333,
                        "totalRoomRateBeforePromo": 70197.77333333333,
                        "totalRoomRateBeforePromoExclusive": 70197.77333333333,
                        "totalRoomRatePerNight": 14039.554666666667,
                        "totalRoomRateBeforePromoPerNight": 14039.554666666667,
                        "totalAmountForPax": 23399.257777777777,
                        "prePromotionAmountForPax": 23399.257777777777,
                        "promotion": "",
                        "promotionValue": "",
                        "promotionType": 0,
                        "idException": 0,
                        "discount": 0,
                        "taxScheme": 5,
                        "totalTaxes": 0,
                        "taxPercentage": 0,
                        "totalTaxesPerRoomPerNight": 0,
                        "checkOutTotalRate": 70197.77333333333,
                        "checkOutTotalRateBeforePromo": 70197.77333333333,
                        "checkOutRateWoTaxes": 70197.77333333333,
                        "checkOutRateBeforePromoWoTaxes": 70197.77333333333,
                        "checkOutRateBeforePromoWoTaxesExclusive": 70197.77333333333,
                        "checkOutHasTaxes": true,
                        "isOnRequest": false,
                        "breakdown": {
                            "amount": 0,
                            "breadDowns": [],
                            "breakDowns": []
                        }
                    }
                ],
                "filters": [
                    {
                        "id": 5,
                        "groupId": 1,
                        "display": "Familia",
                        "uri": "familia",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 12,
                        "groupId": 2,
                        "display": "2 estrellas o más",
                        "uri": "2-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 13,
                        "groupId": 2,
                        "display": "3 estrellas o más",
                        "uri": "3-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 14,
                        "groupId": 2,
                        "display": "4 estrellas o más",
                        "uri": "4-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 540,
                        "groupId": 2,
                        "display": "1 estrellas o más",
                        "uri": "1-estrellas-mas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 17,
                        "groupId": 3,
                        "display": "Desayuno americano",
                        "uri": "desayuno-americano",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 18,
                        "groupId": 3,
                        "display": "Desayuno bufet",
                        "uri": "desayuno-bufet",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 19,
                        "groupId": 3,
                        "display": "Comida",
                        "uri": "comida",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 20,
                        "groupId": 3,
                        "display": "Solo alojamiento",
                        "uri": "solo-alojamiento",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 21,
                        "groupId": 3,
                        "display": "Desayuno y cena incluidos",
                        "uri": "desayuno-y-cena-incluidos",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 22,
                        "groupId": 3,
                        "display": "Desayuno, comida y cena",
                        "uri": "desayuno-comida-y-cena",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 24,
                        "groupId": 3,
                        "display": "Todo incluido",
                        "uri": "plan-todo-incluido",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 27,
                        "groupId": 3,
                        "display": "Desayuno continental",
                        "uri": "desayuno-continental",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 69,
                        "groupId": 3,
                        "display": "Sin alimentos",
                        "uri": "plan-europeo",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 70,
                        "groupId": 3,
                        "display": "Desayuno incluido",
                        "uri": "desayuno-incluido",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 47,
                        "groupId": 5,
                        "display": "Internet",
                        "uri": "amenidad-internet",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 52,
                        "groupId": 5,
                        "display": "Balcón o terraza",
                        "uri": "amenidad-balcon-o-terraza",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 53,
                        "groupId": 5,
                        "display": "Caja de seguridad",
                        "uri": "amenidad-caja-de-seguridad",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 55,
                        "groupId": 5,
                        "display": "Gimnasio",
                        "uri": "amenidad-gimnasio",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 60,
                        "groupId": 5,
                        "display": "Alberca",
                        "uri": "amenidad-alberca",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 66,
                        "groupId": 5,
                        "display": "Tabla de planchar",
                        "uri": "amenidad-tabla-planchar",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 67,
                        "groupId": 5,
                        "display": "Secadora de cabello",
                        "uri": "amenidad-secadora-de-cabello",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 79,
                        "groupId": 5,
                        "display": "Regadera",
                        "uri": "amenidad-regadera",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 81,
                        "groupId": 5,
                        "display": "Habitaciones para discapacitados",
                        "uri": "amenidad-habitaciones-discapacitados",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 542,
                        "groupId": 5,
                        "display": "Alto estándar de limpieza",
                        "uri": "alto-estandar-de-limpieza",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 536,
                        "groupId": 8,
                        "display": "3 estrellas",
                        "uri": "3-estrellas",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 653009,
                        "groupId": 7,
                        "display": "Puerto Vallarta Aeropuerto Internacional, Jalisco, México",
                        "uri": "aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    },
                    {
                        "id": 77396,
                        "groupId": 7,
                        "display": "Marina Vallarta, Puerto Vallarta, Jalisco, México",
                        "uri": "marina-vallarta-puerto-vallarta-jalisco-mexico",
                        "isSelected": false,
                        "categoryGuid": 0,
                        "guid": null,
                        "total": 0,
                        "translate": false
                    }
                ],
                "filtersHotels": [
                    "stars_4",
                    "interest_familia",
                    "amenities_amenidad-internet",
                    "amenities_amenidad-balcon-o-terraza",
                    "amenities_amenidad-caja-de-seguridad",
                    "amenities_amenidad-gimnasio",
                    "amenities_amenidad-alberca",
                    "amenities_amenidad-tabla-planchar",
                    "amenities_amenidad-secadora-de-cabello",
                    "amenities_amenidad-regadera",
                    "amenities_amenidad-habitaciones-discapacitados",
                    "amenities_alto-estandar-de-limpieza",
                    "zones_aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                    "zones_marina-vallarta-puerto-vallarta-jalisco-mexico",
                    "familia",
                    "2-estrellas-mas",
                    "3-estrellas-mas",
                    "4-estrellas-mas",
                    "1-estrellas-mas",
                    "desayuno-americano",
                    "desayuno-bufet",
                    "comida",
                    "solo-alojamiento",
                    "desayuno-y-cena-incluidos",
                    "desayuno-comida-y-cena",
                    "plan-todo-incluido",
                    "desayuno-continental",
                    "plan-europeo",
                    "desayuno-incluido",
                    "amenidad-internet",
                    "amenidad-balcon-o-terraza",
                    "amenidad-caja-de-seguridad",
                    "amenidad-gimnasio",
                    "amenidad-alberca",
                    "amenidad-tabla-planchar",
                    "amenidad-secadora-de-cabello",
                    "amenidad-regadera",
                    "amenidad-habitaciones-discapacitados",
                    "alto-estandar-de-limpieza",
                    "3-estrellas",
                    "aeropuerto-internacional-puerto-vallarta-pvr-jalisco-mexico",
                    "marina-vallarta-puerto-vallarta-jalisco-mexico",
                    "paylater_1",
                    "promotion_40-50",
                    "mealplans_E",
                    "mealplans_I",
                    "freecancellation_allowed"
                ],
                "queryId": "ba2793cabfebdfe34f897b818ecb9c1c",
                "indexName": "searchHotelPlacesMX",
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraChange": false
                    },
                    {
                        "name": "Transportación  a la playa (sujeto a disponibilidad)",
                        "hasExtraChange": false
                    }
                ]
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Programa de actividades (varía diariamente)."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Entretenimiento nocturno, música en vivo en el bar principal. Show nocturnos por parte del equipo de bailarines. Discoteca Nitro Club con bebidas incluidas hasta las 2 de la mañana."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Actividades supervisadas para niños de 18 meses a 12 años de edad. El Baby Club para niños de 18 meses a 3 años de edad y Kid's Club para niños de 4 a 12 años, el Teens Paradise organiza actividades para adolescentes en el hotel."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Cancha multifuncional. Uso de canchas de tenis (clases privadas con costo extra)."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Parque acuático con barco pirata y nueve toboganes. Deportes acuáticos no motorizados."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Todos los alimentos y bebidas, servicio 24 horas al día. Bebidas nacionales e importadas."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Algunos servicios pueden tener cargo. El acceso a los centro de consumo pueden requerir código de vestir o edad mínima."
                    }
                ],
                "description": "Crown Paradise Club Puerto Vallarta está ubicado en una playa en la Zona Hotelera Norte de Puerto Vallarta, junto al muelle de cruceros de la ciudad. El hotel está localizado 3.7 kilómetros al sur del aeropuerto internacional (PVR) y a 4 kilómetros del área del centro de la ciudad, el Malecón. Cerca del hotel encontrarás el centro comercial Galería Vallarta, a 950 metros del hotel, el Sam´s Club, a 850 metros, y varios restaurantes y bares. \r\n\r\nEste hotel familiar en Puerto Vallarta tiene 254 habitaciones. Todas las habitaciones cuentan con aire acondicionado, televisión por cable o satélite, plancha y tabla de planchar, cafetera, caja de seguridad, teléfono, reloj despertador, baño privado con regadera y un balcón.\r\n\r\nEn el hotel todo incluido Crown Paradise Club Puerto Vallarta encontrarás cuatro restaurantes que te ofrecen especialidades francesas, japonesas, italianas y además, uno de servicio bufet y también brinda servicio a la habitación las 24 horas. Adicionalmente, cuenta con varios bares en el hotel, incluyendo un bar sólo para adultos en una de las albercas. El hotel también ofrece varias opciones para el entretenimiento como deportes acuáticos no motorizados, deportes terrestres, un parque acuático, club para niños, y entretenimiento nocturno en su discoteca. Dentro del resort también encontrarás un spa, boutique y salón de belleza y gimnasio completamente equipados, así como cuatro salones de eventos con capacidad para 600 personas.\r\n\r\n***Reservaciones a partir de 10 habitaciones son consideradas grupo y les aplican políticas y condiciones especiales de grupo.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/f8859f29974585595ab2bbaed8ea9a4b14afc3ad3c7a5182248e8e978b7d9497_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/4fdd4c38012be05cbb7ec5f17b5b725dedaef303ed4ab1c8d30efebe5ed4bd0b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/143719251bd389b782070d6c252b1c836828c4a018a2769ea1718037cef2265c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/a6b1fd2ac0d2aca63f91ed963596d8ab3bf0834ba3e9a3e56798851ba0a971f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/c6daaebd2d9ed63c2c743c71bcb4e3ab7ee2523964e7f06406fc0164083f26a0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/e3504ac146a7c431ea0e53e143f39e742f0262e312e3a0eff7bdcf3313753e5e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/0c471f3deb2018543467522d713ced3b395ac11a763fc7b556c37c6226bbc3b4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/5aaf624264de01028791f7f2c0b436e7f91ad2e1e73ac5d5c7f6e679eee29465.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/3f5c55ca38aa7f967e3058fa619749c553b97f860d4fc437dae4cd0e857608b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/9b32c3a2605501e9ad15f9579a6c561302167455693553790fdfd5c7650d06fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/bbe856b3381798b57a87f148f90cc49a37cff15f50c371890c91fdd9fb7d3ed3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/85ee4b8f10c55ad8fd6dd69bcb67caee34bcd275def9e7c888a871b44b337968.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/debb24827cbdad6fa7358fb970d1894164d28579fc937e5c54a9ce349bc541b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/cb711d55af21c6b80207b959e9c3898df68766418faada8ea5a739fc7aa6e637.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/0dbf837ac91d17f457348358342ef0543720d45b235dac12258916ed09ac9610.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/72e7e6dc174734723e0e6e38ff15854ff725d1fe18a030b46cd4dbf32eefda11.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/577b453b3af58d0ac3bcbc0084c6ffe619c93a6539e98c7037082b3f256c8d63.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/2d34756113bf45774cdf13bca740d850e58fac4779f2ec2d1fcb5d60793b043f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/0d4b730a0366b683abe22c8167b6be3691a87c450604bded617aecf0154898b4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/efb67a71ee414147ec2ae5440b8e05f49ab49a2388dd2fe6974943af8be5b232.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/59e7da98f0060db2ba22d3571f4a74a9acbb051166b6f821896a906036ed507e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/973c8cea3bf61a5cc1138e49b389a6b5daa40990544809fe1c46c72042cb1f02.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/3f048f04a8f0e804b0ca010714e86d051ba44291399b128e1f349a255c232ad4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/5cea1d004cb2a743f6058e88f57d863d45c4f0b462d5c297e090b652bb2c3960.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/4e0d59bda8d58bc873619a3bb199768b30bd489f2f72856424918a301a767cf2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/d23b725c1ebef261136654d7bf430d186b9ccce09abf652b03015a1b9f48fb8f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/8594ca9f05547977205674245b648a697ec34e2420e2c838e8fc5369f53bc322.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/855f7e2809903a7054446ace9a22fc8904fe7aa8594c93bb52fd47edb8db4336.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/7114d978cfd8209e2559bf776a85759fae62e64d0921424b84f745e887d1d96f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/1de8aa0c393300f6706f837dfd497f9e0be4b9f38358f0f85f18a4a7ece2dfb0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/7845704b9fa742d6e754fd76c36efc25dd6a19746d1d87da8d240ca0881e3c2e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/d1e0d5af24a3f5d71881efcc8767dca0711a0365b0474ba20ee9bba0d6c8773f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/88aecf4d4970e4ffba52d5d4d8442c76d58a95ade0b10f6c5e15f74ede812546.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/6a0b4fa69c3427258023c39e32d69fe14481d58693a95cf8dc4f17b8ab7a4f47.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/539446bb8515dd0948d0102c54815eae848ea63b7340c3d0e33c2fdab5bc7f0c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/375d4c21981975189ed714764f2de7a068ffc6a69d211dc87c89ffbfec6954a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/104e484643fc787c564dcc1de5f0ae100d4446425b85618d7580237d5e3b3fc5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/2942f82b6e30040ecc7c91a159d551a5b447c23d177949bda86ff8e72326167f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/aaf68f91dce5ed63d8237a85de7662dd7f994cbfbd74cd4e4ba7e6d3d5f34784.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/208105eca7c8fa1ad694fbee202af4713fc4c4acf6f6903d5599103375fced3f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/1432bdc6190ebbc14ce427d1722ba73ac77e69dc05834a744f9c1ecbcaa5f2ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/c258c0e317e859e20f22cb1c412d6bfd2466274efe93e8363198d57b1b0f3abf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/c3652f324249796c0fc545b3d5e23198c10ebe4025700005ac85f8a5d676cb31.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/6506e41cac5dfa6b6d2e8345de33729743f4884a4520a89fe54021579d3cfea5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100166/24447cfd1f095da887cc9d5096e38cb41c78181e1c704b24197045cd6c730ac4.png"
                    }
                ],
                "hotelID": 100166,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Cuenta con un parque acuático con 9 toboganes",
                    "Internet inalámbrico gratuito",
                    "Rampas para silla de ruedas"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.65157921919169",
                    "longitude": "-105.24357318878174",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "Av de las Garzas s/n, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Crown Paradise Club Puerto Vallarta",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Club Caribe",
                        "type": "Bar"
                    },
                    {
                        "name": "Tiki Beach Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Fujiyama",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Piazza",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Club Nitro",
                        "type": "Club Nocturno"
                    },
                    {
                        "name": "La Palapa",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Sans Souçis",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack de playa",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Collage Sports Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Snack nocturno",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058444,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058446,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058447,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058449,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058450,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058451,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058452,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058453,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058454,
                        "kidsFreeTo": 0,
                        "name": "Suite City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058455,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058456,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058457,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058458,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058459,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058460,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058461,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058462,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058463,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058464,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058465,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058466,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058467,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058468,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058469,
                        "kidsFreeTo": 0,
                        "name": "Double Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058470,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058471,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058472,
                        "kidsFreeTo": 0,
                        "name": "Deluxe No View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058473,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058475,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058476,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058477,
                        "kidsFreeTo": 0,
                        "name": "Superior With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058478,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058480,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058482,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV LCD"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000005,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al jardín o a la alberca",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/z7ZLYAinVhygnt0ak5xIzxpAUJ8=/720x480/01/66/21/01662173.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/z7ZLYAinVhygnt0ak5xIzxpAUJ8=/720x480/01/66/21/01662173.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera a solicitud",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV LED",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Litera",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1002035,
                        "kidsFreeTo": 5,
                        "name": "Familiar",
                        "isActive": true,
                        "view": "Jardín o Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zhF-puxNkO1dWPaXlJITFneQW0c=/720x480/01/68/11/01681180.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zhF-puxNkO1dWPaXlJITFneQW0c=/720x480/01/68/11/01681180.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7879631,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7879632,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7879633,
                        "kidsFreeTo": 0,
                        "name": "Habitación de luna de miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Individually adjustable air conditioning",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7880113,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón con bañera de hidromasaje",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9394382,
                        "kidsFreeTo": 0,
                        "name": "Lunamielera",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/X6vOV9uWdmrShwEZRIxLhHX1yXA=/720x480/04/81/17/04811726.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/X6vOV9uWdmrShwEZRIxLhHX1yXA=/720x480/04/81/17/04811726.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253748,
                        "kidsFreeTo": 0,
                        "name": "Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253750,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253752,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253754,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Or Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253755,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253757,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253759,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253761,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Partial Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253765,
                        "kidsFreeTo": 0,
                        "name": "Garden View Private Garden",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253767,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253769,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Partial Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253771,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253773,
                        "kidsFreeTo": 0,
                        "name": "Family Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253775,
                        "kidsFreeTo": 0,
                        "name": "Family With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253777,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14253779,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051508,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051509,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051510,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051511,
                        "kidsFreeTo": 0,
                        "name": "Room Honeymoon",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051513,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051514,
                        "kidsFreeTo": 0,
                        "name": "Single With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051516,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051517,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051523,
                        "kidsFreeTo": 0,
                        "name": "Double Honeymoon",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051525,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051526,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051527,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051528,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051529,
                        "kidsFreeTo": 0,
                        "name": "Family Room Bunk Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214679,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214683,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214690,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214697,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214703,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214709,
                        "kidsFreeTo": 0,
                        "name": "Triple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214714,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214718,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214725,
                        "kidsFreeTo": 0,
                        "name": "Triple Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214732,
                        "kidsFreeTo": 0,
                        "name": "Family Room Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214740,
                        "kidsFreeTo": 0,
                        "name": "Family Room Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214748,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214753,
                        "kidsFreeTo": 0,
                        "name": "Twin With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214758,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214763,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214768,
                        "kidsFreeTo": 0,
                        "name": "Triple Two Double Beds With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214772,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214776,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058389,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058391,
                        "kidsFreeTo": 0,
                        "name": "Superior With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058393,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058395,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058397,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058640,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View With Swimming Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058642,
                        "kidsFreeTo": 0,
                        "name": "Family King Bed Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058644,
                        "kidsFreeTo": 0,
                        "name": "Classic Suite With View Street View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058646,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058648,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058650,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058651,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Extrabed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058653,
                        "kidsFreeTo": 0,
                        "name": "Bridal Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058655,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds Extrabed 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058658,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058661,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058665,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bed 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058668,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058671,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Double Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058674,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058678,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058681,
                        "kidsFreeTo": 0,
                        "name": "Double Room Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058684,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058687,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Double Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058690,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058694,
                        "kidsFreeTo": 0,
                        "name": "2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058697,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058700,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058704,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058707,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea And Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058710,
                        "kidsFreeTo": 0,
                        "name": "Classic Suite Street View",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058713,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room Double Bed 1 Single Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058716,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058720,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Partial Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058723,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058726,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058729,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058731,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058733,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058736,
                        "kidsFreeTo": 0,
                        "name": "Extrabed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058738,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Extrabed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058740,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058742,
                        "kidsFreeTo": 0,
                        "name": "Double Room Extrabed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058744,
                        "kidsFreeTo": 0,
                        "name": "Double Room Extrabed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058747,
                        "kidsFreeTo": 0,
                        "name": "Classic Street View",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058749,
                        "kidsFreeTo": 0,
                        "name": "Family Single Room King Bed Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058751,
                        "kidsFreeTo": 0,
                        "name": "Family King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058753,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058755,
                        "kidsFreeTo": 0,
                        "name": "Double Room Bunk Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058757,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058759,
                        "kidsFreeTo": 0,
                        "name": "Family Single Room Bunk Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058762,
                        "kidsFreeTo": 0,
                        "name": "Family Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058764,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058766,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058769,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058771,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058774,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058776,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058778,
                        "kidsFreeTo": 0,
                        "name": "Family Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058781,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058783,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058785,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058787,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058790,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058792,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058794,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058796,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058798,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058800,
                        "kidsFreeTo": 0,
                        "name": "Family Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058802,
                        "kidsFreeTo": 0,
                        "name": "Double Room Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058805,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058807,
                        "kidsFreeTo": 0,
                        "name": "Family King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058809,
                        "kidsFreeTo": 0,
                        "name": "Family Bunk Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058812,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058814,
                        "kidsFreeTo": 0,
                        "name": "With View Private Pool",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058816,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058818,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058820,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058822,
                        "kidsFreeTo": 0,
                        "name": "With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058825,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058827,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058829,
                        "kidsFreeTo": 0,
                        "name": "Family 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18058831,
                        "kidsFreeTo": 0,
                        "name": "Superior Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18189932,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647533,
                        "kidsFreeTo": 0,
                        "name": "Family Room Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior"
                        ],
                        "bedding": "",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18842150,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Bañera de hidromasaje privada",
                            "Bañera de hidromasaje privada (exterior)",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18842151,
                        "kidsFreeTo": 0,
                        "name": "Suite de lujo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886718,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18886719,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18925372,
                        "kidsFreeTo": 0,
                        "name": "Suite de lujo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Bañera de hidromasaje privada",
                            "Bañera de hidromasaje privada (exterior)",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Sábanas no disponibles",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18925373,
                        "kidsFreeTo": 0,
                        "name": "Suite familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 tirolesas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cancha de usos múltiples",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de baile",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (4 a 12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spinning",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.3,
                    "totalSurveys": 937,
                    "valuesAverage": [
                        4.1,
                        4.4,
                        4.3
                    ]
                },
                "title": "Resort y spa todo incluido con diversión para toda la familia",
                "uri": "crown-paradise-club-puerto-vallarta",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias en la piscina y playa, organizadas por el equipo de animación. Clases de baile, de cocina, de coctelería, etc."
                    },
                    {
                        "title": "Entretenimiento nocturno",
                        "description": "Incluye espectaculares shows nocturnos en el Teatro Meliá, disponibles de acuerdo al programa del hotel. Música en vivo, DJ, karaoke y juegos de casino en el Lobby Bar. El programa varía diariamente."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Actividades supervisadas para niños de 8 meses a 11 años de edad. Área de juegos tematizada con pared de escalada y salón de videojuegos."
                    },
                    {
                        "title": "Deportes",
                        "description": "Estiramientos de yoga, básquetbol, billar, futbol de playa, ping pong, juegos de mesa, futbolito, canchas de tenis, pared de escalada, jaula de bateo, tiro con arco y rifle, voleibol acuático y de playa, aeróbicos acuáticos, ciclopista para niños y golfito de 18 hoyos . También ofrece préstamo del equipo necesario para realizar algunas actividades."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las bebidas premium y el servicio a la habitación no están incluidos. Servicios e instalaciones sujetas a disponibilidad y horarios."
                    },
                    {
                        "title": "Otros",
                        "description": "Área de niños con clubes infantiles Kidsdom, lleno de actividades dinámicas, juegos, experimentos científicos, manualidades y sesiones temáticas."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    }
                ],
                "description": "Meliá Puerto Vallarta All Inclusive es un hotel en Puerto Vallarta ideal para parejas o familias. Está localizado en el área de la Marina y a sólo 2.5 kilómetros del aeropuerto internacional (PVR). El Club de Golf Marina Vallarta está a 900 metros del hotel, el Centro Internacional de Convenciones a 7 kilómetros y el centro de la ciudad, junto con el área del Malecón donde hay tiendas, restaurantes y bares, se encuentran a 8 kilómetros de distancia.\r\n\r\nEl hotel cuenta con 324 habitaciones libres de humo con balcón privado y vistas a los jardines tropicales o a la Bahía de Banderas. Todas equipadas con aire acondicionado, caja de seguridad digital, baño privado con ducha y/o bañera, minibar, balcón y acceso a internet inalámbrico (aplican restricciones de número de dispositivos incluidos por categoría). Adicional, las habitaciones premium brindan set de aromaterapia, cafetera y café en cortesía. La habitación familiar cuenta con litera y amenidades especiales para los pequeños como un regalo sorpresa, minibar con refrescos, agua, jugos y leche de sabores.\r\n\r\nLa propiedad tiene tres bares, un snack y tres restaurantes de los cuales uno es de bufet internacional temático y dos son a la carta; además se ofrece servicio a la habitación con cargo extra. Dentro del hotel encontrarás una piscina exterior con área para niños, gimnasio, tienda de regalos, estacionamiento gratuito, salón de belleza, y áreas para masajes en exteriores e interiores en el spa. Adicionalmente, en el hotel hay una amplia variedad de actividades disponibles, incluyendo tiro con arco y rifle, pared de escalada, canchas de tenis, deportes acuáticos no motorizados, yoga, clases de baile y de cocina. También puedes organizar eventos en uno de los espacios para reuniones del resort, que tienen capacidad para hasta 600 personas.\r\n\r\n***Todas las habitaciones son libres de humo. En caso de violar esta política, el hotel aplicará un cargo por limpieza de $200.00 USD.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/97abcb2f811c595db7aa48eadc13d1dd3ee220a70c3cab3474030446fe6c6573_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Premium de 1 dormitorio con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/5da2208f16fc8c4e1afdb8015f05518f3040f17da5e2ca9a5ec51da8eff05711.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/f4538641e2deda61fcdb6632b8d3df34e8315695fdee84722740b56ad8a685d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/28cdff0cf0fa6d22dc57c9bbbb9d39e1a7cb1e1a0300e7afdb4c7287bd91a3d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/e79d032ea7dc18162ec5c51d65029187741740f4870ea0f2e8965b4bb9249a0e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/eab15fb4d59175efd8acdbc602f354b8374c280d3e0320347342db4d07bd542d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/3bd1ebe691588d77d476f2c74325d785f31303deea15149947c7930b78b827dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/76d6789bfb516c806c9e80ae98bc83a6684da646e9e9732cb4a932c8a1627612.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior Prémium con vistas al jardín",
                        "cloudUri": "https://img.cdnpth.com/media/100384/bce7842418e450c93df0170670e07a15dbc38ca1372352a2adb968d0a840b09c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/f5721b98f64ebac5b1b4570c01a2262eb6bb39b5021ef452a897db1d0c2aeab4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Familiar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/60823a9a4398a3e585ab0e3c4404fa57e2a7cc11bd24b03d1376e6ae0fe5cbc3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Melia con vistas al mar ",
                        "cloudUri": "https://img.cdnpth.com/media/100384/fb901f97c427940bbba1a86b728ec34eea678e1ef244ccb6ed48ecc883dcb7bd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/f183e54af54d30a6d1f60814383a869a9df807cac6f58e1e98acb0a2194cc040.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/6730ff45946c39790ba741b82f1c9954ae451e07c636285d03c2c91ce15831a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/c919d1b4465bf27a4d71fa6a3f447a653b6f617c01d8e6f74547597a8c7b2472.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Master Premium de 1 dormitorio con vistas al jardín",
                        "cloudUri": "https://img.cdnpth.com/media/100384/62883f6f99da74e32304ca3db8e5dcfd3c964bda8485bc43dc401a66966b98ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/6f41dc8957c8aee542f0250359e5f7c675c51bf39d2a28279abc8029bdd1faa3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Melia con vistas al mar ",
                        "cloudUri": "https://img.cdnpth.com/media/100384/778a6a63c7c6287c2185293c197377b9362f49bc8a16fe09e7049b7e776063e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/43944c9ec78108ef0e3a815acff27baaaa9cd3fdc200d7c0372e9a909f7b0109.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/6b2258a45e6b5f001db31add34c362f88a60c798d3a400d8a97cdc3a5676b33d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/b1d168bfa6645e78c088fdc3185733d0484dccb3a3072cc76ab578d2f4ae18d1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/7f240943909b2a8a37aeda4a14fcae7756721f4f4df8ea31a9061f87f5a2fccb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/42031ad1c47e493881bd39a78f0c04fe4fca9c8f9875d4c1d9cfd7530459362a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/344a328fc579b1842f440bb836913a0ad6abac0917e6f8aa358eec780a8cec30.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/b921f6f013b1a9590e09d44ad09e7896dfbe479a25dc330a9cda7b890c7ad661.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/b7a4eed7145cf0c28e1e4dfae56402763119246c30fd10fd1c9fde2a166470a0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior con vistas al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100384/52c19e44cbadba34b481ebf0ec1a1c1915ec79fbdf3fa4915e114e014045e1fd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/4db779dbfc0e286b46ac6755c48020247d129134bec274c2a42bfc1eee067cdc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Premium frente al mar ",
                        "cloudUri": "https://img.cdnpth.com/media/100384/1844167f77c817a27635176183a6400f7749456ba7842f8f22275990da1d48e3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/7435f5b6b239ae4b96b1e694961b4100ba42302ec78de5e7d3a16383a5bf4032.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/e43e023a425e3919f19f1404367ff7d4bf626a55aea2160a6cc4dbda17819c57.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/d9ed24b0389c7263ce3a1a8e08946acb81221c9c96d6bb6950bf3383a9b5f116.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/fcacec5ea097c08de4447633545375fc4f5f3de7f8b37d8d6a0c0f81c94d1232.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/1c8faaeb445becde857ea78a20bc1c5af97faa83d14e4a6dccf8ec054faeeaed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/b2e9ebdf3cd4711e365c369caac04e966ceb48fe22f68abf133c207840cc9455.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/69ca6f9c1a748b83d0d892942e708de6c94597f593467b0fa79f27d35f12d000.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/0700d1a6b4544a3a0ec6c287970acb4bbefed3f4bbdb57b3a9e61d80b7430679.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/c3e12aa1afaf84ce1234fb75bfadc61132605d5519e067f15af57fa67e379f1a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/20617bb61e51095f04f9f707cccd6c9cd32b458d9e9ffeda4fb215e43fc3183b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/f3848d9b09a136a703c52c25b4b13aff06c291a1658f901045a6404b402d3fa9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/1691b6fa0a3b80c1994d821c44fef301e36b993fbbaf51ae7d4d0adea9e5acce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/61d644db3da33c50c8b583881988409f9a820eaf5eda5b426b51f0f1258d4ccc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/68546680064fdc070993367b941ce52d6aa9ee2366738c0d896521beea8d665c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/bedf39794f6439324fa9af4d5b23e1c57574422fe4e26f4561abb0b4037a9a72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100384/bf7379c040b4081ce38e1a3e2e4ed1afd455dd219552df67a925abeee405c93d.png"
                    }
                ],
                "hotelID": 100384,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Club de niños para bebés de 8 meses a niños de 11 años",
                    "Niños gratis (máximo 2 menores de 0 a 4 años, aplican restricciones)",
                    "Tarifas especiales para el Club de Golf Marina Vallarta"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.660840308456134",
                    "longitude": "-105.25271415710449",
                    "postalCode": "48354",
                    "state": "Jalisco",
                    "street": "Paseo de la Marina Sur 7, Marina Vallarta",
                    "countryCode": "MX"
                },
                "name": "Meliá Puerto Vallarta All Inclusive",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "La Palapita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Mole",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Picosito Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Mosaico",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Fish House",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195589,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195590,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195592,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195602,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195609,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195612,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195621,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195623,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195627,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ma7g99wrNvGPupWb_qwLRx6ygBU=/720x480/05/02/49/05024912.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ma7g99wrNvGPupWb_qwLRx6ygBU=/720x480/05/02/49/05024912.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195639,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195660,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195664,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195667,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195669,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195671,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195672,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195674,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Con Literas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195676,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195679,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195680,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195683,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195685,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195769,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195770,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195772,
                        "kidsFreeTo": 0,
                        "name": "Estudio Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195776,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195779,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645177,
                        "kidsFreeTo": 0,
                        "name": "Habitación Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074401,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074403,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074406,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074413,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074423,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Campo De Golf",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074433,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16275694,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16275883,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Ciudad",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17036344,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17036345,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218422,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218428,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218434,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218441,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218447,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218453,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218458,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218463,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17218469,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947454,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870700,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962824,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962828,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962833,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962835,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962837,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962838,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962839,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962841,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19482000,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19482003,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20300994,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20300997,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301000,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301003,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301004,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301008,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301013,
                        "kidsFreeTo": 0,
                        "name": "Individual Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301018,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301032,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301037,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301041,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301044,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301048,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301051,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301056,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301061,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301066,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301069,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301073,
                        "kidsFreeTo": 0,
                        "name": "Single King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301078,
                        "kidsFreeTo": 0,
                        "name": "Single Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301081,
                        "kidsFreeTo": 0,
                        "name": "Single Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000435,
                        "kidsFreeTo": 4,
                        "name": "Meliá Room vista jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3B6Of8mL0ckTYtD_j5dSCywUKdw=/720x480/04/91/62/04916226.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3B6Of8mL0ckTYtD_j5dSCywUKdw=/720x480/04/91/62/04916226.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Amueblada individualmente",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Bedsheets provided",
                            "Camas supletorias gratuitas",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Eco-friendly cleaning products provided",
                            "Eco-friendly toiletries",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Productos de higiene personal gratis",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Shampoo",
                            "Teléfono",
                            "Televisión",
                            "Toallas",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952404,
                        "kidsFreeTo": 0,
                        "name": "Melia Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3B6Of8mL0ckTYtD_j5dSCywUKdw=/720x480/04/91/62/04916226.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3B6Of8mL0ckTYtD_j5dSCywUKdw=/720x480/04/91/62/04916226.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Cable TV service",
                            "Cafetera y tetera",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Connecting/adjoining rooms available",
                            "Cortinas opacas",
                            "Eco-friendly cleaning products provided",
                            "Eco-friendly toiletries",
                            "Free cribs/infant beds",
                            "Guardería en habitación (de pago)",
                            "Individually furnished",
                            "In-room childcare (surcharge)",
                            "In-room climate control (air conditioning)",
                            "In-room safe",
                            "Iron/ironing board",
                            "Limpieza de habitaciones diaria",
                            "Minibar (stocked, free items)",
                            "No fumadores",
                            "Non-Smoking",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plasma TV",
                            "Rainfall showerhead",
                            "Room service (limited hours)",
                            "Shampoo",
                            "Shower/tub combination",
                            "Television",
                            "Televisión",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952405,
                        "kidsFreeTo": 0,
                        "name": "Melia Room, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar o Vistas al océano",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XIMr_tgPvhITlPMGSiH5lOJs82A=/720x480/05/02/48/05024898.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XIMr_tgPvhITlPMGSiH5lOJs82A=/720x480/05/02/48/05024898.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Cable TV service",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Connecting/adjoining rooms available",
                            "Cortinas opacas",
                            "Eco-friendly cleaning products provided",
                            "Eco-friendly toiletries",
                            "Free cribs/infant beds",
                            "Guardería en habitación (de pago)",
                            "Hair dryer",
                            "Individually furnished",
                            "In-room childcare (surcharge)",
                            "In-room climate control (air conditioning)",
                            "In-room safe",
                            "Iron/ironing board",
                            "Menú de almohadas",
                            "Minibar (stocked, free items)",
                            "No fumadores",
                            "Non-Smoking",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Pillow menu",
                            "Plasma TV",
                            "Rainfall showerhead",
                            "Room service (limited hours)",
                            "Servicio de descubierta",
                            "Shampoo",
                            "Shower/tub combination",
                            "Slippers",
                            "Television",
                            "Televisión",
                            "Turndown service",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952406,
                        "kidsFreeTo": 0,
                        "name": "Premium Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Amueblada individualmente",
                            "Balcony",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Cable TV service",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Connecting/adjoining rooms available",
                            "Cortinas opacas",
                            "Eco-friendly cleaning products provided",
                            "Eco-friendly toiletries",
                            "Free cribs/infant beds",
                            "Guardería en habitación (de pago)",
                            "Individually furnished",
                            "In-room childcare (surcharge)",
                            "In-room climate control (air conditioning)",
                            "In-room safe",
                            "Limpieza de habitaciones diaria",
                            "Minibar (stocked, free items)",
                            "No fumadores",
                            "Non-Smoking",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plasma TV",
                            "Rainfall showerhead",
                            "Room service (limited hours)",
                            "Shampoo",
                            "Shower only",
                            "Slippers",
                            "Television",
                            "Televisión",
                            "TV size measurement: inch"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952407,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198806,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198807,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4198808,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Amueblada individualmente",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (outdoor)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4564290,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, vistas al jardín (Junior)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Albornoces",
                            "Amueblada individualmente",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (outdoor)",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4564292,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, 1 habitación, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/rzEHEhG6IeB2_8km_WK8d_Vdj-4=/720x480/05/02/51/05025122.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/rzEHEhG6IeB2_8km_WK8d_Vdj-4=/720x480/05/02/51/05025122.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095743,
                        "kidsFreeTo": 4,
                        "name": "Meliá vista oceáno",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/XIMr_tgPvhITlPMGSiH5lOJs82A=/720x480/05/02/48/05024898.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/XIMr_tgPvhITlPMGSiH5lOJs82A=/720x480/05/02/48/05024898.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Servicio de niñera en la habitación",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Descuento en cena romántica ",
                            "Internet inalámbrico",
                            "Minibar",
                            "Pantuflas",
                            "Regalo sorpresa",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Servicio de concierge",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Litera y 2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095744,
                        "kidsFreeTo": 4,
                        "name": "Habitación Familiar",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera/ tetera",
                            "Centro de música",
                            "Cocina equipada",
                            "Comedor",
                            "Horno de microondas",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Plancha y tabla de planchar",
                            "Reproductor de CD",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Vajilla"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095745,
                        "kidsFreeTo": 4,
                        "name": "Premium One Bedroom Suite vista océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/rzEHEhG6IeB2_8km_WK8d_Vdj-4=/720x480/05/02/51/05025122.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/rzEHEhG6IeB2_8km_WK8d_Vdj-4=/720x480/05/02/51/05025122.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado con ducha",
                            "Internet inalámbrico"
                        ],
                        "bedding": "1 Cama o 2 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095747,
                        "kidsFreeTo": 4,
                        "name": "Premium 1 Bedroom Master Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kel31s3fCbx6-ky1yJjJdPjQBVA=/720x480/05/02/51/05025121.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kel31s3fCbx6-ky1yJjJdPjQBVA=/720x480/05/02/51/05025121.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Servicio de niñera en la habitación",
                            "10% de descuento en cena rimántica",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Café",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095749,
                        "kidsFreeTo": 4,
                        "name": "Premium ocean front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso con sofá cama",
                            "Baño privado con ducha",
                            "Cafetera/ tetera",
                            "Cocina equipada",
                            "Comedor",
                            "Internet inalámbrico",
                            "Minirefrigerador",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Terraza con jacuzzi",
                            "Tocador",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Vajilla"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095750,
                        "kidsFreeTo": 4,
                        "name": "Premium Junior Suite Vista Jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kel31s3fCbx6-ky1yJjJdPjQBVA=/720x480/05/02/51/05025121.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kel31s3fCbx6-ky1yJjJdPjQBVA=/720x480/05/02/51/05025121.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Café",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Secadora de cabello",
                            "Set de aromaterapia",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6095751,
                        "kidsFreeTo": 4,
                        "name": "Junior suite vista océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ma7g99wrNvGPupWb_qwLRx6ygBU=/720x480/05/02/49/05024912.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ma7g99wrNvGPupWb_qwLRx6ygBU=/720x480/05/02/49/05024912.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6919685,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6919690,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "SI Accesible para minusválidos",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8797486,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bañera",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195587,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195594,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195596,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195604,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "2 Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195605,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UDP0VR4kjvLymK_BBo_f8CkaO9U=/720x480/05/02/49/05024902.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195629,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cocina",
                            "Comedor",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Utensilios de cocina, platos y tazas",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195631,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "2 Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195633,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Horno",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195637,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195638,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/yg8npI53woIEgZpt7AVji23cOwc=/720x480/05/02/49/05024910.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195642,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195649,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Bañera",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195651,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195662,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195668,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195675,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195678,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Comedor",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10195681,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074409,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074416,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Bañera de hidromasaje",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Cocina",
                            "Comedor",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Utensilios de cocina, platos y tazas",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074434,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Albornoces",
                            "Amueblada individualmente",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Private hot tub",
                            "Private hot tub (outdoor)",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16148767,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, 1 habitación (Master)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Albornoces",
                            "Amueblada individualmente",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan productos de limpieza ecológicos",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (horario limitado)",
                            "Sofá cama",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16148771,
                        "kidsFreeTo": 0,
                        "name": "Suite junior, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar o Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460189,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460223,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460256,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460289,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460323,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460357,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460391,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460425,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460461,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460497,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460534,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460570,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460606,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460642,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460678,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460714,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460750,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460783,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460816,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460849,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460880,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460911,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460943,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18460973,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461005,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461035,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461068,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461099,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461129,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461158,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461187,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461216,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461245,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461274,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461302,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461330,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461358,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461387,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461416,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461446,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461477,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461510,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461543,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461577,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461612,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461646,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461680,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461715,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461751,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461787,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461823,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461859,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461895,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461932,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18461970,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462007,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462044,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462081,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462119,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462157,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462194,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462229,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462263,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462298,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462332,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462367,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462402,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462438,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462474,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462509,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462544,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462579,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462613,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18462648,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Bañera",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Habitaciones para fumadores",
                            "Secadora de ropa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962798,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Habitaciones para fumadores",
                            "Secadora de ropa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962809,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Habitaciones para fumadores",
                            "Secadora de ropa",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962818,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secadora de ropa",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962831,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962836,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18962840,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathroom",
                            "Bathtub",
                            "Cable TV",
                            "Clothes Dryer",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Individually adjustable air conditioning",
                            "Ironing set",
                            "Minibar",
                            "Number of bedrooms",
                            "Shower",
                            "Smoke detector",
                            "Smoking rooms",
                            "Toiletries",
                            "TV",
                            "Wake-up service",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sujeta a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20301027,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Basquetbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de baile",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de cocina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Fotógrafo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Pared de escalada",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tiro al arco y carabina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.9,
                    "totalSurveys": 927,
                    "valuesAverage": [
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido en la playa de Puerto Vallarta",
                "uri": "melia-puerto-vallarta-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        }
                    ],
                    "I": [
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye shows nocturnos realizados por el equipo de animación y música en vivo. También incluye la discoteca The Nitro Club con bebidas hasta las 2:00 de la mañana."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye desayuno, comida y cena a la carta, así como botanas en el área de alberca y playa, bebidas nacionales e importadas."
                    },
                    {
                        "title": "Deportes en Tierra",
                        "description": "Incluye tenis, futbol, basquetbol, voleibol, cancha de usos múltiples y uso del gimnasio."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Se requiere reservación en los restaurantes Paradise y Salvador's. Los tratamientos del spa tienen costo adicional. Servicio a la habitación las 24 horas con cargo extra."
                    }
                ],
                "description": "Crown Paradise Golden All Inclusive Resort, Adults Only es un hotel todo incluido sólo para adultos, localizado en una playa de la Bahía de Banderas, en la zona hotelera norte de Puerto Vallarta. El muelle principal de cruceros de la ciudad está a 350 metros del hotel y el Campo de Golf Marina Vallarta está a 3 kilómetros de distancia, mientras que el Centro Internacional de Convenciones y el centro de la ciudad están a 3 y 4 kilómetros respectivamente. La Zona Romántica de la ciudad está a 6 kilómetros del hotel y el aeropuerto internacional (PVR) a 3 kilómetros.\r\n\r\nEl hotel cuenta con 214 habitaciones y suites, todas ellas equipadas con un balcón, aire acondicionado, televisión por cable, plancha y tabla de planchar. Además ofrecen acceso a internet inalámbrico, cafetera, caja de seguridad, minibar, teléfono de marcado directo, baño privado con ducha y bañera, secador de pelo, espejo de tocador y amenidades para el baño.\r\n\r\nComo huésped del Crown Paradise Golden All Inclusive Resort, Adults Only podrás disfrutar de restaurantes a la carta de especialidades mediterránea e internacional, servicio a la habitación las 24 horas, además de varios bares y una discoteca. Las opciones de entretenimiento son extensas e incluyen canchas de tenis, una piscina tipo infinity, jacuzzi, gimnasio, programa de actividades diarias y shows nocturnos. Además, puedes relajarte y consentirte en el spa completamente equipado del hotel. Si necesitas organizar un evento social o de negocios, en el hotel encontrarás instalaciones para eventos de hasta 450 personas.\r\n\r\n***Reservaciones a partir de 10 habitaciones son consideradas grupo y les aplican políticas y condiciones especiales de grupo.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/13c263ad399337c0dc99ad5d513348d3038c8b6a0202d88298f2e546d8ca7cde_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/2c92d7d7e782f611e7924bb22e2dfc88a88032d1bd690eb8658b9d341ade71bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/374bf8e5fb322205c89eb1f7c55ec13ec1ee6a4f461a352fabc97562f855deb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/bbb72a5d260eabfe9019f55dec1fd6282067d774885c7c62b3a723128808e7b1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/63f944b2dbbef642efe7fb82b02a81ba9a0445357e06210650f8faa0d4f33195.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/1d8811d3e4540f3a71d211aa65c18badd406ddbeceb7b3eae38ba1ca053090e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/bac2245a9de55b18e9be1040d575e613098597e1fcc5ab72b1df7c0038c87ea7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/8a583ba41292b4975458ea945910420f76e594e8de6dc8419c4910bd7502e22d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/7cf9ffed3e4d23e29b67adc9f40a68cb4d41ddd023c6c165710714d363de5e72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/cc7c09fc90c57d5c51b4cc4fc73cb477a530c279510311a3a6484f7ec26b7aad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/f998a11557bc6107ac61ed9ef70bda1af243b28f3a1cde8573b992f5dab41bcf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/249c4dba3eeb7f704382bec001b95da84a87a77fb3a46166231783afa8edab9f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/825d7212bb2b8ca472a27025b387c4b44f198f69cd33ba7690be9ba0ea70e187.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/61f258e073dc0fe9a7112669f940b9cb13d12d42faf00883a6ef4786ba7f53af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/0ffb5b44656471d4a1c89a14e5779c37b44e7339f3eed2431f10b184dcf330d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/26e7dbd63e4e6c1618e61943324010e76f2aeb3ed8b4e8565585a7ead182d5b6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/2f7c0433d94492ef4c910c4e3eb5655daaebf86ef726ffe67fbc017697a57ff7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/28ed6ea0dd45f462b4e60fa125316336fc49a40d40c90e1451a5c5a51d6879d2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/4744bc5ab680d84bdedbf01d5752e4b1c6ea412507ea14aa1e9e1c0cdafce5b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/5b48576ca16c997683d60a0857e4873738f6566c9af256080baf813ecb9a1a90.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/c10b9fa82b0dc98c034c874fe0245aab8903a57da2adcab250f4998f0e4662c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/ce29b1eeb021d0fe9fe6b59e494e9bba7b806567416683351421eeeabd46e0da.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/9ee1d5821d85e66f5425627904bce846786c63d3616e05a0f14e6e8b95c6d734.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/4147d675e462b8545eac1b8dddab5d46fd9c7a376ca302fba9fa0b99f4c5b462.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/794ab0bc9897502fec8966d9fbb0e2a4c45ddda9d5a17c84376cf3b5206f646e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/a8757b1e9470ad9dac39d41138feae56e2164dc71e2467235c9c5a879bc9e689.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/c67abedf90df90cd8a15dfe7073c384be69316f62217a4bce6edabab876289b2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/93c4177ac05f5ad6fd908f1c19848e6edc7d234404747705e9648b7f3099a885.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/f2b6c93d12ba6a231f956118a510358258e146273a9c41d7137a80b015a0ab4b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/66930d58acd3758f689b01a95eddd7ef3e25dd749398f6746d1e258f14110211.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/cba7037f8f7eaba469dc5d6a2929dda71a3a56e6eed97474f6c54e6bb65ff417.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/39d8a7011334ac17e6d9d123059905064277de0673772d523990c166bfd65cb5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/dfaecdc2a3ae4dc402f332b7e7ac69405be4165c2e2fe4c4448387c918b00048.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/493d0f9fa8d683b65b4d5c96ffbb8adae387217be612a1fcb5e6954897177420.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/d72a22a6d18793abd3c166c711f8ba14ae07277a2bdcd0c14ad515b328042a0e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/3fc9d92a0f65a5bbc74d5be02b951da427ffad722430bbd3848aa9337707e0e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/d8062a0c359ebe2adfb01a1ad3211d848236e3355a9a3b40ce1506d6c8acf460.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/7acab620bbf46d342c662109189608939f721278e84a855ff1d7ebecead038e5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/87bf59b2dbcc0558aed64d3c8501d19a4874dd7fb2b1f143173dd817fa24cad2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/66ab39a13290eb20a472e4efe138169eb82fe90b72f65695295b11269f7ef7b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/0950c666444e0961e1fc4b131749b0dc0d20f91156c48fb8461b5f57a767381a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/6e7c0bc76562c9d2d4138aa4a361bb6a797e95662985f1abe784a264cf0548ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/31c9a5dde45d6aae9592f37facab3337ae4726eb25d755a49bae6cd41303c2f4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/14e3614864f7b2a40a6b59fa5e21a7f34a00d4f409de75d3393dce777bc2768e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100218/ce117b181816d3aaa7ebc21ad1a565dcf5f2612933d26a0d2006996faec3c8e5.png"
                    }
                ],
                "hotelID": 100218,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Internet inalámbrico gratuito",
                    "Solo para adultos"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.65159929804437",
                    "longitude": "-105.24312257766724",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "Av de las Garzas 3",
                    "countryCode": "MX"
                },
                "name": "Crown Paradise Golden All Inclusive Resort, Adults Only",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Bellavista",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Salvador’s",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Paradise",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Los Gallos",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Piazza",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Fujiyama",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sans Souçis",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Toka",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "The Breeze",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Trafalgar Pub",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Sky 7 Lounge",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062479,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062480,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062481,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062483,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062485,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062486,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062488,
                        "kidsFreeTo": 0,
                        "name": "Classic Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062490,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062492,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062494,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062495,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000061,
                        "kidsFreeTo": 0,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7f7j2vVv4TYoWC39Wqpl8jx270Q=/720x480/02/11/80/02118065.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7f7j2vVv4TYoWC39Wqpl8jx270Q=/720x480/02/11/80/02118065.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo completo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Puerto de datos",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000062,
                        "kidsFreeTo": 0,
                        "name": "De lujo frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/L76Bb8e_KbJTJxzLI2SGPKCl1Ns=/720x480/02/11/80/02118061.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/L76Bb8e_KbJTJxzLI2SGPKCl1Ns=/720x480/02/11/80/02118061.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Fumadores y no fumadores",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4022363,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7f7j2vVv4TYoWC39Wqpl8jx270Q=/720x480/02/11/80/02118065.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7f7j2vVv4TYoWC39Wqpl8jx270Q=/720x480/02/11/80/02118065.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4022364,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/mkidcw9utNNFjHSBjaFOyBmJ_x4=/720x480/00/51/59/00515905.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/mkidcw9utNNFjHSBjaFOyBmJ_x4=/720x480/00/51/59/00515905.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5779943,
                        "kidsFreeTo": 0,
                        "name": "Suite Crown Plus",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Bañera o ducha",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6884854,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6884855,
                        "kidsFreeTo": 0,
                        "name": "Suite Crown",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ue8X0Z88OePLlzbjkx32_Hxxv8o=/720x480/02/11/80/02118068.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para iPod®",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de 43 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6919173,
                        "kidsFreeTo": 0,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Interior o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_eri8EkwWVsZ2kR2_4I35Vse1O0=/720x480/12/84/12/12841226.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_eri8EkwWVsZ2kR2_4I35Vse1O0=/720x480/12/84/12/12841226.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para iPod®",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi interior",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de 43 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6919174,
                        "kidsFreeTo": 0,
                        "name": "Suite Crown",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/G76dww-2MwVw7H8hsDWG0LMwcdA=/720x480/03/76/51/03765130.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/G76dww-2MwVw7H8hsDWG0LMwcdA=/720x480/03/76/51/03765130.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Base para iPod®",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Jacuzzi interior",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "TV de 43 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 6919177,
                        "kidsFreeTo": 0,
                        "name": "Suite Crown plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/YQbknJqmnQMuZ5g6pPzNYxbwTsI=/720x480/03/76/51/03765129.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/YQbknJqmnQMuZ5g6pPzNYxbwTsI=/720x480/03/76/51/03765129.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565879,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565880,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565884,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565886,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565887,
                        "kidsFreeTo": 0,
                        "name": "Room With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565889,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565894,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Hot tub",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565895,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565899,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565900,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565902,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565903,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565905,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11565906,
                        "kidsFreeTo": 0,
                        "name": "Room Beach Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583352,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583355,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583358,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583359,
                        "kidsFreeTo": 0,
                        "name": "Suite Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11583362,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11600277,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260972,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260974,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260976,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260978,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260980,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260982,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260984,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260986,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260988,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260990,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260991,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260993,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260995,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260997,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14260999,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261001,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261003,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261005,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261007,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261009,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261011,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261013,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261015,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261017,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261021,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261024,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261026,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261029,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261032,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261035,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261038,
                        "kidsFreeTo": 0,
                        "name": "City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261041,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261044,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261048,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261050,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261053,
                        "kidsFreeTo": 0,
                        "name": "Classic Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261056,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261059,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261062,
                        "kidsFreeTo": 0,
                        "name": "Suite City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261065,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261068,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261070,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261073,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261076,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261079,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261082,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261085,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261087,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261089,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261091,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261093,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261095,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261097,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261099,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261101,
                        "kidsFreeTo": 0,
                        "name": "Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261103,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261105,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261107,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261108,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261110,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261112,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261114,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261116,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261119,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261120,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261122,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261124,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261127,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261129,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261130,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261132,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261135,
                        "kidsFreeTo": 0,
                        "name": "Deluxe City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261137,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261139,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261141,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261143,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261145,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261147,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261149,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261151,
                        "kidsFreeTo": 0,
                        "name": "Superior Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261153,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261158,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261163,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261165,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261166,
                        "kidsFreeTo": 0,
                        "name": "Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261167,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261168,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261169,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14261171,
                        "kidsFreeTo": 0,
                        "name": "Double Room Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051442,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051443,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051444,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051445,
                        "kidsFreeTo": 0,
                        "name": "Single Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051446,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051447,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051448,
                        "kidsFreeTo": 0,
                        "name": "Double Sea Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16117283,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16117286,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16117287,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215094,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215097,
                        "kidsFreeTo": 0,
                        "name": "Single Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215099,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215101,
                        "kidsFreeTo": 0,
                        "name": "Suite City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215103,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215105,
                        "kidsFreeTo": 0,
                        "name": "Suite Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215109,
                        "kidsFreeTo": 0,
                        "name": "Single With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215119,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215127,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215134,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215142,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215151,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215157,
                        "kidsFreeTo": 0,
                        "name": "Room City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215162,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215167,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215172,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215179,
                        "kidsFreeTo": 0,
                        "name": "Double Beach Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215185,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Resort View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215192,
                        "kidsFreeTo": 0,
                        "name": "Double With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215198,
                        "kidsFreeTo": 0,
                        "name": "Triple Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215204,
                        "kidsFreeTo": 0,
                        "name": "Room Resort View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215210,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215216,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215220,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215224,
                        "kidsFreeTo": 0,
                        "name": "Family Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215227,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215232,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215237,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215244,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215249,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215255,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215262,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215269,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215274,
                        "kidsFreeTo": 0,
                        "name": "Suite Classic City View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215281,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215287,
                        "kidsFreeTo": 0,
                        "name": "Single Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947200,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18004266,
                        "kidsFreeTo": 0,
                        "name": "Room Inner-Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062412,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062413,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062414,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062417,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062419,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062421,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062422,
                        "kidsFreeTo": 0,
                        "name": "Classic Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062424,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062426,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062427,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18062428,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190746,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190747,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190748,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18190749,
                        "kidsFreeTo": 0,
                        "name": "Suite With Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18227591,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18286364,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429805,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429806,
                        "kidsFreeTo": 0,
                        "name": "Triple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429807,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429808,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429809,
                        "kidsFreeTo": 0,
                        "name": "Single With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429810,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18429811,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18532452,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649005,
                        "kidsFreeTo": 0,
                        "name": "Double Executive King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649006,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649007,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649008,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649009,
                        "kidsFreeTo": 0,
                        "name": "Family Room Connecting Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649010,
                        "kidsFreeTo": 0,
                        "name": "Room Executive",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649011,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649012,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649013,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649014,
                        "kidsFreeTo": 0,
                        "name": "Suite With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649015,
                        "kidsFreeTo": 0,
                        "name": "Suite Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649016,
                        "kidsFreeTo": 0,
                        "name": "Twin Executive",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649017,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18649018,
                        "kidsFreeTo": 0,
                        "name": "Twin Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Cafetera a solicitud",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740214,
                        "kidsFreeTo": 0,
                        "name": "De lujo king",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Cafetera a solicitud",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740215,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8xKP-71cUxE4Udi2Mhtm2z9r5Uc=/720x480/12/84/12/12841225.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8xKP-71cUxE4Udi2Mhtm2z9r5Uc=/720x480/12/84/12/12841225.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera o ducha",
                            "Cafetera a solicitud",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18740216,
                        "kidsFreeTo": 0,
                        "name": "De lujo king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Au3_wS0PBGoyowSYdHch9y3lhcU=/720x480/12/84/12/12841224.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Au3_wS0PBGoyowSYdHch9y3lhcU=/720x480/12/84/12/12841224.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18773810,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18779430,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18842168,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18842169,
                        "kidsFreeTo": 0,
                        "name": "Suite estudio romántica, 1 cama de matrimonio grande, vistas al mar",
                        "isActive": true,
                        "view": "Sujeta a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870230,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870232,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18870233,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View Honeymoon",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18925374,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 42",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18925375,
                        "kidsFreeTo": 0,
                        "name": "Habitación de luna de miel, 1 cama de matrimonio grande, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solo adultos mayores de 18 años",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spinning",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.6,
                    "totalSurveys": 1353,
                    "valuesAverage": [
                        4.4,
                        4.3,
                        4.2
                    ]
                },
                "title": "Resort todo incluido solo para adultos en Puerto Vallarta",
                "uri": "crown-paradise-golden-all-inclusive-resort-adults-only",
                "tags": [
                    {
                        "name": "Solo adultos"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Deportes Acuáticos",
                        "description": "Incluye kayaks y boogie boards."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos. Abierto diariamente de 09:00 a 17:00 horas."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye distintos espectáculos nocturnos. Espectáculo mexicano cada martes."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y botanas, comprende desayuno y comida bufet, además de cena a elegir entre bufet o a la carta. Las bebidas nacionales también están incluidas. Las reservaciones para los restaurantes de especialidad deben hacerse con 24 horas de antelación."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol de playa."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Mariscos y cortes finos no están incluidos. Minibar y servicios a la habitación no están incluidos. Servicios e instalaciones sujetas a disponibilidad y horarios."
                    },
                    {
                        "title": "Otros",
                        "description": "Uso diurno del gimnasio en cortesía y descuento especial en masajes."
                    }
                ],
                "description": "Krystal Vallarta Hotel &amp; Resort es un complejo familiar que ofrece planes con todo incluido, ubicado en una playa de la zona hotelera de Puerto Vallarta, a 4 kilómetros del Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR) y a 3 kilómetros de la marina y del Campo de Golf Marina Vallarta. El área del centro y del Malecón están a 4 kilómetros de distancia. Construido en el estilo tradicional de una hacienda, el hotel parece un típico pueblo mexicano con ocho hectáreas de jardines, paseos y fuentes.\r\n\r\nEste hotel en Puerto Vallarta cuenta con 260 habitaciones equipadas con aire acondicionado, caja de seguridad, teléfono de marcado directo, internet inalámbrico y minibar (cargo adicional). Las habitaciones de lujo además tienen pisos de mármol, ducha tipo lluvia, amenidades especiales y un área de descanso con diván. El hotel cuenta con habitaciones especialmente habilitadas para personas con discapacidad (previa solicitud).\r\n\r\nEl hotel cuenta con dos bares y cuatro restaurantes que sirven especialidades orientales, internacionales y de mariscos. El complejo tiene tres piscinas, seis jacuzzis y gimnasio, también cuenta con facilidades para realizar distintos deportes acuáticos como kayaks y boogie boards. El complejo cuenta con actividades de entretenimiento diario y una diversidad de espectáculos temáticos nocturnos. Los pequeños podrán hacer uso del club de niños que ofrece actividades y comidas con un área de juegos interior y un salón de baile, área para manualidades, amplia selección de juegos de video y de mesa, así como un área para televisión con tiendas de campaña para ver películas. Además, cuenta con 10 salones de usos múltiples con capacidad de 2,000 personas así como áreas al aire libre para la realización de eventos. El hotel tiene un spa, salón de belleza, tienda de regalos y estacionamiento privado, con cargo extra.\r\n\r\n***Al detectar bloqueo de varias habitaciones para las mismas fechas de viaje, se cobrará al momento del check in un suplemento de $800.00 MXN por persona (a partir de 6 años). Queremos evitar las molestias que les ocasionan a aquellos clientes que les ofrecen el servicio como grupo, cuando en realidad son reservas individuales y no cuentan con los lineamientos que se adquieren al firmar un contrato de grupo.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/df8de6dc66b92501b09579b0b9dcd0c0fa09820541ca747bdd17633b9c3ab832_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/38674bf97dff35b0dd2f3cfe8be9d6e935a8afda776cb38393c92c569996ec61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/5da014d1d92c87c31f5391908d31992614578be9a4df284403e5d6f8c54734ef.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/33354359ffc1f7df6bcc190fa2af70d069e43084ecc727229531ccf62c884a1c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/96b5eca3adc4e6efa63e2722e19eba753e89fb006811540f6083b8a9190c9dcb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/0da8aee22b8bc8589c56fd67e39be990d5f96898e8d72fecfca5f36e80455cda.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble con vistas al jardín",
                        "cloudUri": "https://img.cdnpth.com/media/100417/164e2b9e64736df4b691c5b86912b7e6527791c21cfd44ff5850a127318836e3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/787aea6d78857449579e0225af952994d64cde1df0fbe50385ca1fce9b22b74b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/3780534c775bd7adffffdad76b903246109e860e4ebf8c58d5ceef1695a7165f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/5d44c28f035f4ffcd812c49690364761fd3983dbad61989b8816dc01a53f709b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/edc2f05f09e5c38f81892c27415769eb513ea10d12a44c7c58e008025a8fa2ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/357ce0e6aaeb5c03600d37d159e0253c514693f42858cca539dfce2a91016bb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/9aa686d43a203b500e4d33c72689fdbda2763f06dc5ae613449c8879e17556a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/aec7375280f70cd3a4df575a47c26c2228675e986970e05787d6fc5484d40df2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/4efdf3765e505facff8c2f66531d4d8cd81aeb03239e95815f02e9ece06b8ee2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/cf4ae1e6c61b9ffcbd20bf1029d9d9837d121f847826f5644f5f9a16c52cfa2b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/7b6a70b2652abb86b661949b5034091ddad87820334142254aa24f9084896948.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/db3e527062af61a8098a0f89efbdfb595a238d00bd5eee849bb14d7611fa35fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/f3502327979e651c9e0f8e713b302391de19f60be5770c073cae2441f41bcbb9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/83b06b85f5cee90b20a6f111f90d82d83e9a818a15cae6f12c959e36b74e400d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/f0931e126003f70576808d989416ba7ce97131e647b102e3697ac870b9c4bdf3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/71fa6264e84e099db36d2c10119d4c32fd92712bf3565e96589ae6f08383c74a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/9d5d125e042fcf3fdf351eefa5ccc9424524a1f9e1ce24a527159cb367459a70.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/e79ba3d6fbdd192c1a47e0e73e456c885fb645f584aa55b3bc65e947b3121346.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/3712708c3a9dd77230d20e3f4ec9191029567b52bc5014fa7b55472b8f7fdcc1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/e48dce2176a3cb35677997eddccee224aa0cfe50e34ca08908d78821877c57b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/bc841939a1bbcb4261b04c3fe3cc5cbf332b94974490bd2af5ffa7ce0d65c63e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/1c2bd7911dd6359904f61259104de7079ec26b73ee90c747cfe9598437c0cd18.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/932ccccc64aa36406a89b7b5fba21528c01ec58dd921ca6a0c849fee0db8483c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/9116ee2e84cc634ef3c4e858bca7c612bcf67591bde8af109d96315b02d56bd4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/9565f909aac2246597297379c63eaf05e04fa92464fe98bf614c5d7f9d06d939.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/32ece402ce3da02240ad5f44851c92097174d0ab684907958d978419ac6ea9fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/8808aa6c1690d8927d765f2985bdbd1b7cc9474dd5dc40f40fce3fe940747365.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Deluxe con vistas a las montañas",
                        "cloudUri": "https://img.cdnpth.com/media/100417/7a6fa814b77a6d18623e88888ee96ed0f2f32e6d6061e11b0bac2b0a49be46ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/f41a487d327c638e96a1ef4023c2ad841aa294ae7977dfcb499a710a98601654.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/875de40d4c1f1149fbd9115a7aa785bd604a750ddb647ce0fd02b676cabd3cf8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/f9f10bf1a0a15780cc89afe14cda243b72be5ec7a8b0eb1c72ffa94fd9032400.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/abe515db041ca42713486547dbe65c78a6eb3ca614fcf270f1f46838a142fd66.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande y vistas al jardín ",
                        "cloudUri": "https://img.cdnpth.com/media/100417/7a47ccb74f77a7e0614fe2aa81bee33af9487cce3d8a6672fdf6643f010fb1f2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande y vistas al jardín ",
                        "cloudUri": "https://img.cdnpth.com/media/100417/21f46633baa03d2c35ffba373c0e57fe04b46042d0f3859d1cf816e8f5bf1841.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande y vistas al jardín ",
                        "cloudUri": "https://img.cdnpth.com/media/100417/935083ce857fa7fef7443b121320cc0fe42410a6fd4a6c5f5ab80f7d457921ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/1fa997a4034fd1c02a69a025710e8a2058df1159a1a61f57b815bb857e3984a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/06febe974561a8779f60d2611a36c1a73598bd892f6f6b4f583786a17633234a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/b4752670c600bdc8170bc85bc293b5c8ad794299e6826cc415915d816a35df46.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100417/f9debead22107e7fde8e1d096bb24f5267a37aaed265de44de4c310fa4b4d0a3.png"
                    }
                ],
                "hotelID": 100417,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.647884665160664",
                    "longitude": "-105.23976445198059",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Av de las Garzas s/n, Zona Hotelera",
                    "countryCode": "MX"
                },
                "name": "Krystal Vallarta Hotel & Resort",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Sports Bar La Chopería",
                        "type": "Bar"
                    },
                    {
                        "name": "Crazy Crab Snack Shack",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Kamakura",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Las Velas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Le Caffe Lobby Coffee Bar",
                        "type": "Lobby Bar"
                    },
                    {
                        "name": "Cinque Terre",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387157,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387185,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387213,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387240,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387269,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387298,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387326,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387356,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387386,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387416,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387446,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387479,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387510,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387540,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387569,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387598,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387627,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387656,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387685,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387715,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387746,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387779,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387811,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387843,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387874,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387907,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387939,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387969,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18387999,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388029,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388059,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388089,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388119,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388150,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388181,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388211,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388238,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388267,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388295,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388322,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388349,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388376,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388402,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388429,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388456,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388483,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388510,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388537,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388564,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388591,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388618,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388647,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388673,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388700,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388724,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388750,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388775,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388800,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388825,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388849,
                        "kidsFreeTo": 0,
                        "name": "Double Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388875,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388900,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388925,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388949,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388974,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18388997,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389021,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389044,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389067,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389089,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389112,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389135,
                        "kidsFreeTo": 0,
                        "name": "Single Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389158,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389181,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389204,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389227,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389250,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389273,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389296,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389318,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389340,
                        "kidsFreeTo": 0,
                        "name": "Club Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389362,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389385,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389408,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389431,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389453,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389475,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389498,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389521,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389545,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389569,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389593,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389618,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389643,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389668,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389692,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389716,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389741,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389766,
                        "kidsFreeTo": 0,
                        "name": "Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18389790,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515856,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515889,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515923,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515957,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515989,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516021,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516051,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516084,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516115,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516145,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516177,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516209,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516242,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516275,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516307,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516341,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516373,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516406,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516439,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516472,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516505,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516538,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516575,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516608,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516639,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516670,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516700,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516730,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516759,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516789,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516820,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516848,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516875,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516905,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516932,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516958,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18516983,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517008,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517032,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517056,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517080,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517104,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517128,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517151,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517176,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517200,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517225,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517248,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517271,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517294,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517317,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517340,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517362,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517384,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517405,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517427,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517448,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517469,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517490,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517512,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517534,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517556,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517577,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18517599,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Rociadores",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1002058,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico de alta velocidad",
                            "Plancha y tabla de planchar",
                            "TV LED de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1002059,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Rociadores",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1003179,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Internet inalámbrico de alta velocidad",
                            "Plancha y tabla de planchar",
                            "TV LED de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1003180,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista a la montaña",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Combinación ducha/bañera",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Medida del tamaño del televisor: pulgadas",
                            "Number of beds - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Room service (limited hours)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4022301,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Cable TV service",
                            "Cable/satellite TV service",
                            "Cepillo y pasta de dientes no disponibles",
                            "Cerrojos/cerradura a baja altura",
                            "Champú",
                            "Cortinas opacas",
                            "Free bottled water",
                            "Free toiletries",
                            "Hair dryer",
                            "In-room safe",
                            "Iron/ironing board",
                            "Limpieza de habitaciones diaria",
                            "Lowered locks/deadbolt",
                            "Number of beds - 1",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Room service (limited hours)",
                            "Shampoo",
                            "Shower/tub combination",
                            "Smart TV",
                            "Soap",
                            "Toilet paper",
                            "Toothbrush and toothpaste not available",
                            "TV size measurement: inch",
                            "TV size: 42",
                            "Wheelchair accessible"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4022304,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4996461,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas a la montaña",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4996462,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7282635,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598245,
                        "kidsFreeTo": 0,
                        "name": "Double One Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zU790xnrFtfaUQCbuDBryhZzlSk=/720x480/03/01/96/03019630.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zU790xnrFtfaUQCbuDBryhZzlSk=/720x480/03/01/96/03019630.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598247,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598249,
                        "kidsFreeTo": 0,
                        "name": "Twin Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598251,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598256,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598258,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598262,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598265,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598268,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Toiletries",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598277,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598280,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Toiletries",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598282,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598285,
                        "kidsFreeTo": 0,
                        "name": "Double Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598289,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598294,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zU790xnrFtfaUQCbuDBryhZzlSk=/720x480/03/01/96/03019630.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zU790xnrFtfaUQCbuDBryhZzlSk=/720x480/03/01/96/03019630.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598299,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598303,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Toiletries",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598308,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598315,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598327,
                        "kidsFreeTo": 0,
                        "name": "Twin Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N40_CWdz25ZppMUplLleTjwUcSg=/720x480/03/01/96/03019629.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Toiletries",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598338,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598345,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Sofá",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10671089,
                        "kidsFreeTo": 5,
                        "name": "Estándar king vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Sofá",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10671090,
                        "kidsFreeTo": 5,
                        "name": "Estándar king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZjRhgzRLQg5Js6KCpYM3IgdirIE=/720x480/04/82/37/04823750.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico de alta velocidad",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV LED de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10671091,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista a la montaña",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/wHSLZqG5SlqZiSTnQdaaRYPonbI=/720x480/04/82/37/04823748.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico de alta velocidad",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV LED de 42 pulgadas",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10671415,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BC1qXyywIW_lMrnq_5qqrUUeoDg=/720x480/04/82/37/04823751.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645147,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645150,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645151,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11645157,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087032,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Mountain View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087033,
                        "kidsFreeTo": 0,
                        "name": "Double Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087034,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087035,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087036,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087037,
                        "kidsFreeTo": 0,
                        "name": "Room Golf View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087038,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087039,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087040,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087041,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087042,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087043,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087044,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16087045,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110605,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Resort View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110608,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110610,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110612,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110614,
                        "kidsFreeTo": 0,
                        "name": "Room Resort View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110616,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110617,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110618,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110620,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110621,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón amueblado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149724,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149725,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149726,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas a la montaña",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149727,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas al mar",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Rociadores",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16985096,
                        "kidsFreeTo": 5,
                        "name": "Estándar vista al jardín - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Sofá",
                            "Teléfono de marcado directo",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16985097,
                        "kidsFreeTo": 5,
                        "name": "Estándar king vista al jardín - no reembolsable",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zf5mx4gvQvMhiYFxlQKzReK6Guo=/720x480/04/82/37/04823749.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18211310,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Balcón amueblado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Smart TV",
                            "Solo ducha",
                            "Tamaño del televisor: 42",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18211311,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384212,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384242,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384274,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384306,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384338,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384370,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384402,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384435,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384468,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384499,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384532,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384565,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384598,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384631,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384663,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384696,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384729,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384760,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384791,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384823,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384854,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384886,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384917,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384948,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18384979,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385010,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385041,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385071,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385101,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385129,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385158,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385187,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385216,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385245,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385274,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385303,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385333,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385362,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385391,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385421,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385451,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385480,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385509,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385538,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385568,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385597,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385625,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385653,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385681,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385709,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385737,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385765,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385794,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385824,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385852,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385883,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18385911,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513871,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513895,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513919,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513944,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513969,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18513995,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514019,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514044,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514072,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514129,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514156,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514182,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514208,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514235,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514263,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514291,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514318,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514346,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514371,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514396,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514423,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514452,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514482,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514539,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514568,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514597,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514625,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514653,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514681,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514707,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514732,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514757,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514785,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514814,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514843,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514875,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514904,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514933,
                        "kidsFreeTo": 0,
                        "name": "Club Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514959,
                        "kidsFreeTo": 0,
                        "name": "Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18514985,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18515012,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.2,
                    "totalSurveys": 926,
                    "valuesAverage": [
                        4.1,
                        4.4,
                        4.2
                    ]
                },
                "title": "Hotel familiar en la zona hotelera",
                "uri": "krystal-vallarta-hotel-resort",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Espectáculos nocturnos todos los viernes y sábado del año y todos los días en temporadas altas."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno, comida y cena tipo buffet. Y cena a la carta en Restaurante de especialidades con previa reservación."
                    }
                ],
                "description": "Costa Club Punta Arena - All Inclusive es un hotel todo incluido ubicado sobre la avenida principal de la ciudad, a corta distancia del centro de Puerto Vallarta. En los alrededores podrás encontrar centros comerciales o dar un paseo por el Malecón, uno de los sitios obligados en la ciudad. El aeropuerto internacional de Puerto Vallarta (PVR) está a 7 kilómetros de distancia.\r\n\r\nEl hotel ofrece 234 habitaciones equipadas con aire acondicionado, televisión con canales por cable, teléfono de marcado directo, caja de seguridad y baño privado con ducha. Las suites cuentan con área de descanso y balcón o terraza en algunas de ellas.\r\n\r\nEsta propiedad con acceso directo a la playa cuenta con cuatro piscinas y estacionamiento. El hotel también ofrece servicios médicos y acceso a internet en las áreas públicas. Uno de los restaurante ofrece servicio bufet y el otro sirve comida italiana (posee código de vestir elegante casual, se requiere previa reservación y es solo para personas mayores de 13 años).\r\n\r\n***En caso de reservaciones de 5 habitaciones o más, el hotel se pondrá en contacto con PriceTravel para gestionar políticas de pago y de cancelación especiales.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/9c9b866f386956f8cc34c07501588aad1e7ca83d82eee1269fe2999fb205adfc_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/2fa227ab9f05e2910d07bd7d8b96f5bd198b662b11fc392bbf7a1610d381337d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/69e9024dc212627f1e7d591b5975a1924b0b84ce8420bc2b8dd2e36bbef600c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/0b058977e6f43ee1ef2f69c7b5b8cedf770c3b5144e3050cd4cb8bfb9a3ca31b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/18b93ecfc6f4128a4e61b298c6eecfb50a4782c9f721d599efc2f3d860964461.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/c57028f5b49a339e916cde81874beff98581efba366ba75d4026a9f917cd4eab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/d4003692b0a4a70b2df82c336cf699b276dba29c61460589484eddb0b624fec8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/72fdc0059f325fa0b625c82af89ac2e0f6f4b568cf5d34ea5876f0738f49684d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/f2b0620df5f1b27ab3130302e7dd6b945663711881b357d77c552bc494ccde0f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/7e56fa254f7764668c9ec0c1652a2e32abd0a66a0292752d8bec915f495ef80a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/2d5a954d2fb1cf28217688bd69befd57acf8203a908fe25b63e207c11f3192c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/881669d00b5e3c8b19b3d5c876c04116ccdd2ba90a4cfeda0d288330b8fcd1eb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/4678a04dcfdfc3f64df1d51265fb381e3a9e146e2bcb235c15dde1ca671f5ff2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/8e08bbae4f6e591680bdee3bdd9e5f1a2a56e1c79325134dfc1e1551f29e7ac2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/b40ebd91c153efdf2c623215e22807df7eba2b7a71ffcbac24b1af5de332ee19.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/1caa31da9f224614a2917a91cd8158b102e8ec683c61a8789dc669b0857d3dd1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/20501fcd05c3dc8534df5f64a1b5c30aca349a8ccc8a890016e84511d767aa8b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/078388f2def026a49c22849837a54df1a9ad4a2dd9ebc7015c8b0bf19ded6444.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/6a2ee13b23ee9a2de28766bfb920db9adf980d6de35eb6b8b08d884411945ccc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/5000bf335224170f1a897ab540563bea42d5b3ef3077c83a20e510a85c0fe051.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/bbeae4c7950874da4f3d09159e7f54326e435c1806fea6e47b34fcd53bfe5c6e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/57bd3d4e48cd048c2682d02bc908ce1e974233f459be24f5cb260cd80c8c8fe0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/0df3665b59660cc2c5ad0578712955112e4cf6dcc727c2e55a8136e79828e5ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/d66df991d35ce69ed9f9044709337cc944ec54052a9ba9b9e0cbf83d2c7d2812.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/83c3723972034bf1f610c0ea50e7991d41574f3a70566d6038ab345939130621.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/8f001da5b7ad1304e041b57669417fcf8b59cb633d93de9c3d864b9c2b19eba6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/97d3915cdeeb3b91ba667441af5cc57a772cecba11b8fbd514d282678141fa22.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/321a214ebdc0c07d8f43cac9e098030d88ce6bb7f7e3e70198b99e5b65f5eb81.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/608e15d490feac2207d992403da4f5fd84afbd8bf47693dad157e88f8525943d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/987cad8f422666508539dfed01954217c2b41e32cd9f82cce4fa66f20b94cef4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/438b506eacea6b7bd4702895b5b43b430e084bd960cdb9f182c39d504e6d0c5c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/1eaa5fbc8531430b984a240ed42858687bcd98bf7e6ab114d017ffada435b6ef.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/5b79f66657bb59fe9cdfcfb2de5ef32a636a43d3543d4de72433e62d804d3319.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/4cf728897a8ac6703e96043f4de9cffc1918c759d9b264e9f23b76e2ea5c4ed8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/e177a3d83af0d87cadcd090b22aedb7273aa229ebf01a1bfd02bb068797e059e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/b4f1d5d18da659f89cbec22bd88989e36975a6b642ed21be5f3b15fd931d2a4c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/c0afadd7231f794060ef583db9f951bc0332e603b62a0232a1c6847cfe5a7f5e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/3a7d8692462b0c75ea6813b28a1696817efde14f5eac95130373331d2418319f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/a5a51f225d4e0e4713523aedf6bce461361aec2c0d1d655c35f8ea6df5d79687.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/d48f1b4f501c70db81fa16515a396199ad0319bd00ae27a55e3ee9b7224702c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/f3fe46f7638bb47a7d3613efe1803656026afe800de7c73887ba3a462cccfdc5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/2ad181b67aa0088577107ce7e4f09e2401be70c7e4426f8f46c1cc3485765107.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/a1dc5aff3694bf8eb113cf59e73d3f6d2a5d52bcd6eaaba9ad1dbbebc511ed48.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/0a3a513b191240c670867e2174b41176b05ff0ecb9026a919952a8f955010a82.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100160/786c844eba6fd791456130a6b2639e68a0a3f62a97ca5d2c54ec135c0c55fe8d.png"
                    }
                ],
                "hotelID": 100160,
                "importantFacilities": [
                    "Estacionamiento gratuito con vigilancia las 24 horas",
                    "Shows en vivo todos los viernes y sábados (todos los días en temporadas altas)"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.628055022412486",
                    "longitude": "-105.23021042346954",
                    "postalCode": "48310",
                    "state": "Jalisco",
                    "street": "Blvr Francisco Medina Ascencio 1737-21",
                    "countryCode": "MX"
                },
                "name": "Costa Club Punta Arena - All Inclusive",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Los Cocos (Área de bebidas)",
                        "type": "Bar"
                    },
                    {
                        "name": "Los Helechos (Restaurante buffet)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Costa Vita (Especialidad italiana)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar (Área de bebidas)",
                        "type": "Bar"
                    },
                    {
                        "name": "Snack Bar La Iguana",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10598434,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088141,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088142,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088144,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088145,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088146,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088148,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088149,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088150,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Cuarto De Baño Compartido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088152,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088153,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088154,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088155,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088156,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088157,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088159,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088160,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088162,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088163,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088164,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088165,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088166,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088167,
                        "kidsFreeTo": 0,
                        "name": "Doble Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088169,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088171,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088172,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16088248,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16106978,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16350356,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215689,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215696,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215714,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407386,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410248,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410272,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410296,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410319,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410342,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410365,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410388,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410410,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410433,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410456,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410478,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410499,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410520,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410540,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410560,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410580,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410600,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410620,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410640,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410660,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410680,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410701,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410721,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410740,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410760,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410780,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410798,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410816,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410834,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410852,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410870,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410887,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410905,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410923,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410941,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410959,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410977,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18410995,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411013,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411031,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411049,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411067,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411086,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411105,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411124,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411141,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411159,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411177,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411195,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411213,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411231,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411249,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411267,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411284,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411300,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411317,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411333,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411349,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411365,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411380,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411396,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411408,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411424,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411440,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411456,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411472,
                        "kidsFreeTo": 0,
                        "name": "Superior Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411489,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Beds 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411506,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411523,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411538,
                        "kidsFreeTo": 0,
                        "name": "Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411552,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411567,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411581,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411596,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411611,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411626,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411641,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411656,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411670,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411684,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411698,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Double Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411712,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411726,
                        "kidsFreeTo": 0,
                        "name": "Family With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411740,
                        "kidsFreeTo": 0,
                        "name": "Suite Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411753,
                        "kidsFreeTo": 0,
                        "name": "Suite Sextuple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411765,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411776,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411786,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411796,
                        "kidsFreeTo": 0,
                        "name": "Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411804,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411808,
                        "kidsFreeTo": 0,
                        "name": "Family Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411812,
                        "kidsFreeTo": 0,
                        "name": "Suite Quintuple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411816,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411820,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411824,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411828,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411832,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411836,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite Separate Rooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411840,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506051,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506074,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506097,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506119,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506142,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506165,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506187,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506210,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506234,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506257,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506281,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506303,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506324,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506345,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506366,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506385,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506405,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506425,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506445,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506468,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506488,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506507,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506527,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506547,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506568,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506590,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506612,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506635,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506661,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506685,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506709,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506735,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506761,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506786,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506812,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506838,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506864,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506891,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506920,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506948,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18506976,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507004,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507033,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507062,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507090,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507117,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507145,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507172,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507199,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507226,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507254,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507281,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507307,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507333,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507359,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507386,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507408,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507433,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507455,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507478,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507502,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507526,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507550,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507573,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507596,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507620,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507643,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507667,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507690,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507712,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507732,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507752,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507773,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507794,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507816,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507840,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507862,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507885,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507910,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507935,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507961,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18507987,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508015,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508044,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508073,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508102,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508132,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508161,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508190,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508220,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508249,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508278,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18508309,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18827184,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18827185,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18827187,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20357122,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20357125,
                        "kidsFreeTo": 0,
                        "name": "Suite Tres Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono de marcado directo",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Baño privado",
                            "Caja de seguridad",
                            "Comedor",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1002325,
                        "kidsFreeTo": 5,
                        "name": "Suite mexicana de 2 recámaras",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Tca_uUYy2DTgOS-SLokAsXxHO54=/720x480/03/20/27/03202752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Tca_uUYy2DTgOS-SLokAsXxHO54=/720x480/03/20/27/03202752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "No fumadores",
                            "Number of beds - 3",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3953270,
                        "kidsFreeTo": 0,
                        "name": "Suite tradicional, 2 habitaciones",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Tca_uUYy2DTgOS-SLokAsXxHO54=/720x480/03/20/27/03202752.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Tca_uUYy2DTgOS-SLokAsXxHO54=/720x480/03/20/27/03202752.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Caja de seguridad",
                            "Comedor",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 4772536,
                        "kidsFreeTo": 5,
                        "name": "Suite contemporánea de 2 recámaras",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0sQ-eCJJbAZShsIMP-rDhm37phA=/720x480/05/20/50/05205048.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0sQ-eCJJbAZShsIMP-rDhm37phA=/720x480/05/20/50/05205048.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7959887,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado",
                            "Caja de seguridad",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9473673,
                        "kidsFreeTo": 5,
                        "name": "Superior 2 camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/tUtTvbBLj4KQMd0mhKj8rMPFtCo=/720x480/04/81/37/04813798.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/tUtTvbBLj4KQMd0mhKj8rMPFtCo=/720x480/04/81/37/04813798.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado",
                            "Caja de seguridad",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9473674,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Number of beds - 3",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9482138,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 1 habitación",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 3",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9482139,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, balcón, vistas a la piscina",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/lBy5o1355oUDeZvyBtp92VIcRm4=/720x480/05/02/34/05023459.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono de marcado directo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado",
                            "Caja de seguridad",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 9902557,
                        "kidsFreeTo": 5,
                        "name": "De lujo 2 camas vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/SkfEeDWbQdNTMbTAiPPfrNjoXWo=/720x480/05/02/34/05023460.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/SkfEeDWbQdNTMbTAiPPfrNjoXWo=/720x480/05/02/34/05023460.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 3",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149684,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, balcón, vistas a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Balcón o patio",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "No fumadores",
                            "Number of beds - 3",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de baldosas en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16490773,
                        "kidsFreeTo": 0,
                        "name": "Suite superior, 2 habitaciones",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407165,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407184,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407207,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407238,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407276,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407312,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407349,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407433,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407478,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407515,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407552,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407588,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407624,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407660,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407695,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407730,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407764,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407799,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407833,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407866,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407899,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407933,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18407967,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408001,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408035,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408070,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408104,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408139,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408173,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408207,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408241,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408275,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408309,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408343,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408377,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408411,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408445,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408479,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408513,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408546,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408579,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408612,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408645,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408677,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408709,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408742,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408774,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408805,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408836,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408866,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408897,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408928,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408960,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18408992,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409023,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409054,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409085,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409115,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409146,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409175,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409205,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409234,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409263,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409292,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18409320,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Pool View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18411880,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504536,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504556,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504577,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504600,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504622,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504644,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504667,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504689,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504711,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504733,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504754,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504777,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504797,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504817,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504840,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504863,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504887,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504912,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504936,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504960,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18504983,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505006,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505029,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505054,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505077,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505102,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505125,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505148,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505172,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505196,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505220,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505243,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18505266,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Teléfono",
                            "3 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Comedor",
                            "Servicio de despertador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 4 Matrimoniales",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20119078,
                        "kidsFreeTo": 5,
                        "name": "Suite familiar de 3 dormitorios",
                        "isActive": true,
                        "view": "Mar o Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/QrBd9v6aFiZ18VWV2oO1SXfivU4=/720x480/13/39/93/13399370.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/QrBd9v6aFiZ18VWV2oO1SXfivU4=/720x480/13/39/93/13399370.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "4 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas (sujeto a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico en áreas comunes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de masajes",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.3,
                    "totalSurveys": 708,
                    "valuesAverage": [
                        4,
                        4.3,
                        4.2
                    ]
                },
                "title": "Hotel de playa todo incluido en Puerto Vallarta",
                "uri": "costa-club-punta-arena-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Actividades",
                            "description": "Programa de actividades diarias organizado por el personal de animación. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye elección de la habitación."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        }
                    ],
                    "I": [
                        {
                            "type": "Actividades",
                            "description": "Programa de actividades diarias organizado por el personal de animación. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye elección de la habitación."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y almuerzo y cena a elegir entre bufet o a la carta. Cuenta con siete restaurantes, cinco bares y servicio a la habitación las 24 horas sin costo."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Aplican cargos adicionales para platos de langosta y camarones gigantes, así como para botellas de vino y de licor."
                    }
                ],
                "description": "Hilton Vallarta Riviera es un hotel de playa todo incluido con vistas únicas a la Bahía de Banderas y la Sierra Madre. Este hotel en Puerto Vallarta ofrece una atmósfera cosmopolita, dos piscinas panorámicas, spa y centro de convenciones. Las instalaciones incluyen siete restaurantes y cinco bares para degustar comida, mexicana, italiana, asiática, mariscos, sushis y una selección de bebidas y licores.\r\n\r\nEste hotel cuenta con centro de negocios, asistencia del concierge, gimnasio, estacionamiento y acceso a internet inalámbrico. Sus 444 habitaciones y suites con balcón privado gozan de vistas totales o parciales al mar, Smart TV de 65 pulgadas, cafetera Nespresso y minibar.\r\n\r\nLa propiedad se localiza al sur de la zona hotelera de Puerto Vallarta, a 3 kilómetros de la playa Conchas Chinas y a 5 kilómetros del muelle de playa Los Muertos. El Malecón y el centro se localizan a 6 kilómetros, mientras que el Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR) está a 14 kilómetros de distancia.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 13386488,
                        "description": "Hilton Vallarta Riviera - All Inclusive",
                        "cloudUri": "https://img.cdnpth.com/media/T2n5qAnZFyWoj_kk0QhhWl8IFlA=/720x480/13/38/64/13386488.jpg"
                    },
                    {
                        "photoID": 13386523,
                        "description": "Vista de una habitación Premium",
                        "cloudUri": "https://img.cdnpth.com/media/q9PQJPb7JoaWgtpieapOxDZYTig=/720x480/13/38/65/13386523.jpg"
                    },
                    {
                        "photoID": 13387163,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/i08D776jZtW_dnZu66shl30ZVYM=/720x480/13/38/71/13387163.jpg"
                    },
                    {
                        "photoID": 13387164,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                    },
                    {
                        "photoID": 13387165,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                    },
                    {
                        "photoID": 13387166,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                    },
                    {
                        "photoID": 13387167,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/LlsFZ2kvvGv7eLAa8BW6X4bVBwc=/720x480/13/38/71/13387167.jpg"
                    },
                    {
                        "photoID": 13387168,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/BizoPsAmLSBK3XBWeTIwSKpnmFU=/720x480/13/38/71/13387168.jpg"
                    },
                    {
                        "photoID": 13387169,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/0zxptRzMblIRoi3txrsSm6244G4=/720x480/13/38/71/13387169.jpg"
                    },
                    {
                        "photoID": 13387170,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/84VAeMksz4dfWDQiQ9QwNRVbl68=/720x480/13/38/71/13387170.jpg"
                    },
                    {
                        "photoID": 13387171,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/JbU5AY7jEg4dHhjfwJmRohzZkXQ=/720x480/13/38/71/13387171.jpg"
                    },
                    {
                        "photoID": 13387172,
                        "description": null,
                        "cloudUri": "https://img.cdnpth.com/media/-uZN8jilvdQgfEJu1XEnr6aTf8A=/720x480/13/38/71/13387172.jpg"
                    },
                    {
                        "photoID": 13386490,
                        "description": "Lobby",
                        "cloudUri": "https://img.cdnpth.com/media/NBFIxf6jt7Y7-k6d4z8mqk4P-FA=/720x480/13/38/64/13386490.jpg"
                    },
                    {
                        "photoID": 13386489,
                        "description": "Vista del lobby",
                        "cloudUri": "https://img.cdnpth.com/media/VVXoAwZgPtKhTYcUkKDOWfz2ME4=/720x480/13/38/64/13386489.jpg"
                    },
                    {
                        "photoID": 13386491,
                        "description": "Panorama de las instalaciones",
                        "cloudUri": "https://img.cdnpth.com/media/t2_OVh5rDuQutUq-73v9v6Cnem4=/720x480/13/38/64/13386491.jpg"
                    },
                    {
                        "photoID": 13386492,
                        "description": "Vista aérea",
                        "cloudUri": "https://img.cdnpth.com/media/wSR-J3gUdTExkTKXHnJv7yfvQys=/720x480/13/38/64/13386492.jpg"
                    },
                    {
                        "photoID": 13386494,
                        "description": "Piscina",
                        "cloudUri": "https://img.cdnpth.com/media/wtOdfU9vwNq3p-Gkf4mmFHTIV_8=/720x480/13/38/64/13386494.jpg"
                    },
                    {
                        "photoID": 13386493,
                        "description": "Piscina familiar",
                        "cloudUri": "https://img.cdnpth.com/media/WdgkO4Wu4qbgPgnp0beiyYxJlR0=/720x480/13/38/64/13386493.jpg"
                    },
                    {
                        "photoID": 13386507,
                        "description": "Cama balinesa junto a la piscina",
                        "cloudUri": "https://img.cdnpth.com/media/lttEb4fJxClgJilbJEMgHCnnefo=/720x480/13/38/65/13386507.jpg"
                    },
                    {
                        "photoID": 13386496,
                        "description": "Pool Bar",
                        "cloudUri": "https://img.cdnpth.com/media/I1RFejbLe0wa8oR6rWzHT-aZQ94=/720x480/13/38/64/13386496.jpg"
                    },
                    {
                        "photoID": 13386495,
                        "description": "Sky Bar",
                        "cloudUri": "https://img.cdnpth.com/media/m4qSECyQJ7JcznvCWMZQ-BW91mc=/720x480/13/38/64/13386495.jpg"
                    },
                    {
                        "photoID": 13386497,
                        "description": "Bar Mojito",
                        "cloudUri": "https://img.cdnpth.com/media/eGCx2Lzf28Pvp9EuJQehsToevwA=/720x480/13/38/64/13386497.jpg"
                    },
                    {
                        "photoID": 13386498,
                        "description": "Restaurante bufet Vela Food Hall",
                        "cloudUri": "https://img.cdnpth.com/media/wmGceJ0W3VrgJGf_SAd1jrl0Gz8=/720x480/13/38/64/13386498.jpg"
                    },
                    {
                        "photoID": 13386499,
                        "description": "Restaurante Sea Salt",
                        "cloudUri": "https://img.cdnpth.com/media/b7_0r-YRpWOAxa0Ah2ntRCUfOMg=/720x480/13/38/64/13386499.jpg"
                    },
                    {
                        "photoID": 13386504,
                        "description": "Restaurante asiático Sunan",
                        "cloudUri": "https://img.cdnpth.com/media/is4rYLh04QesI6Rc3P45iVn9kxA=/720x480/13/38/65/13386504.jpg"
                    },
                    {
                        "photoID": 13386503,
                        "description": "El restaurante Sunan prepara sushi",
                        "cloudUri": "https://img.cdnpth.com/media/QdHcpq6tdfjl6JYjn4Li3kyZuYc=/720x480/13/38/65/13386503.jpg"
                    },
                    {
                        "photoID": 13386505,
                        "description": "Restaurante mexicano Maxal",
                        "cloudUri": "https://img.cdnpth.com/media/BL7lVcdSfHkSthZ1wr6NhNQiBZs=/720x480/13/38/65/13386505.jpg"
                    },
                    {
                        "photoID": 13386506,
                        "description": "Restaurante italiano La Luce",
                        "cloudUri": "https://img.cdnpth.com/media/LxWDbOfhU35eux57us7wojyNJsM=/720x480/13/38/65/13386506.jpg"
                    },
                    {
                        "photoID": 13386508,
                        "description": "Gimnasio",
                        "cloudUri": "https://img.cdnpth.com/media/qTBpx7LGkXxgj9oOsix25Wbz6aY=/720x480/13/38/65/13386508.jpg"
                    },
                    {
                        "photoID": 13386509,
                        "description": "Club de niños",
                        "cloudUri": "https://img.cdnpth.com/media/DXiBr5_H-0tp_IXcGWLuWKTMZpg=/720x480/13/38/65/13386509.jpg"
                    },
                    {
                        "photoID": 13386510,
                        "description": "Cocinita en el club de niños",
                        "cloudUri": "https://img.cdnpth.com/media/_raLjD-tHzgTd9Wefc1uvog5d3s=/720x480/13/38/65/13386510.jpg"
                    },
                    {
                        "photoID": 13386512,
                        "description": "Lounge",
                        "cloudUri": "https://img.cdnpth.com/media/K3CGitH7MOoXr-OvIXmjMDS2RbQ=/720x480/13/38/65/13386512.jpg"
                    },
                    {
                        "photoID": 13386511,
                        "description": "Área de descanso en el lounge",
                        "cloudUri": "https://img.cdnpth.com/media/JJBU57n7iDJOQKMBm7SvAJDX_N8=/720x480/13/38/65/13386511.jpg"
                    },
                    {
                        "photoID": 13386513,
                        "description": "Sala de lectura con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/iomU144NQBjMZcR-tnNrPsgde1A=/720x480/13/38/65/13386513.jpg"
                    },
                    {
                        "photoID": 13386515,
                        "description": "Entrada al centro de convenciones del hotel",
                        "cloudUri": "https://img.cdnpth.com/media/yDhO97b4mNvpzig5dwQSqhpbNgY=/720x480/13/38/65/13386515.jpg"
                    },
                    {
                        "photoID": 13386516,
                        "description": "Vestíbulo en el centro de convenciones",
                        "cloudUri": "https://img.cdnpth.com/media/XJwNCyZTJubBbu4xHSJDrxwmqG0=/720x480/13/38/65/13386516.jpg"
                    },
                    {
                        "photoID": 13386514,
                        "description": "Montaje para recepción en un salón de eventos",
                        "cloudUri": "https://img.cdnpth.com/media/joTYPmICadt-H_MMRzE80iGpPdY=/720x480/13/38/65/13386514.jpg"
                    },
                    {
                        "photoID": 13386517,
                        "description": "Montaje para banquete",
                        "cloudUri": "https://img.cdnpth.com/media/G_jXq8mgDAkKpPgzf5B9KcnIons=/720x480/13/38/65/13386517.jpg"
                    },
                    {
                        "photoID": 13386518,
                        "description": "Hay servicio para bodas en la playa",
                        "cloudUri": "https://img.cdnpth.com/media/c4kZzsdORv5aos8t2jub4c18ep0=/720x480/13/38/65/13386518.jpg"
                    },
                    {
                        "photoID": 13386519,
                        "description": "Montaje para una boda",
                        "cloudUri": "https://img.cdnpth.com/media/gkHvnwNkideY3o9nwOaIjtXU8qg=/720x480/13/38/65/13386519.jpg"
                    },
                    {
                        "photoID": 13386521,
                        "description": "Habitación king con vista parcial al mar",
                        "cloudUri": "https://img.cdnpth.com/media/X_Y5gC4Kl_qZuhHLPfOxgxHrs5U=/720x480/13/38/65/13386521.jpg"
                    },
                    {
                        "photoID": 13386520,
                        "description": "Habitación Premium king frente al mar",
                        "cloudUri": "https://img.cdnpth.com/media/50KslcQOaRqGZPogFJWUzKHHVz0=/720x480/13/38/65/13386520.jpg"
                    },
                    {
                        "photoID": 13386522,
                        "description": "Habitación Premium con dos camas queen",
                        "cloudUri": "https://img.cdnpth.com/media/Blm5EkUlzZ4ss-ywQ4bkKDRUKwU=/720x480/13/38/65/13386522.jpg"
                    }
                ],
                "hotelID": 447452,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.568590779339036",
                    "longitude": "-105.2507346868515",
                    "postalCode": "48390",
                    "state": "Jalisco",
                    "street": "Carre Barra de Navdad km 4.5, Zona Hotelera Sur",
                    "countryCode": "MX"
                },
                "name": "Hilton Vallarta Riviera - All Inclusive",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Vela Food Hall",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sea Salt",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Cocomar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Luce",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Maxal",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sunan",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Auma",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Martini",
                        "type": "Bar"
                    },
                    {
                        "name": "Mojito",
                        "type": "Bar"
                    },
                    {
                        "name": "Sky Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465368,
                        "kidsFreeTo": 4,
                        "name": "Vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465496,
                        "kidsFreeTo": 4,
                        "name": "2 queens vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465497,
                        "kidsFreeTo": 4,
                        "name": "King frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465498,
                        "kidsFreeTo": 4,
                        "name": "2 queens frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465499,
                        "kidsFreeTo": 4,
                        "name": "Superior king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465500,
                        "kidsFreeTo": 4,
                        "name": "Superior 2 queens frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465501,
                        "kidsFreeTo": 4,
                        "name": "Premium king frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/65C2-Dio90Sh4XRnJVZ8BrJ4DL0=/720x480/04/84/83/04848306.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Mesa y sillas",
                            "Minibar",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465502,
                        "kidsFreeTo": 4,
                        "name": "Premium 2 queens frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Paraguas",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Smart TV de 65 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11465503,
                        "kidsFreeTo": 0,
                        "name": "Master suite king frente al mar - Enclave",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/UtaJjV6rkylA7lEtC4lHMi7iDik=/720x480/05/16/40/05164030.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/UtaJjV6rkylA7lEtC4lHMi7iDik=/720x480/05/16/40/05164030.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Rollaway"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121269,
                        "kidsFreeTo": 17,
                        "name": "Enclave Presidential - 1Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/84VAeMksz4dfWDQiQ9QwNRVbl68=/720x480/13/38/71/13387170.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/84VAeMksz4dfWDQiQ9QwNRVbl68=/720x480/13/38/71/13387170.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Electrical current voltage"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121270,
                        "kidsFreeTo": 17,
                        "name": "Part Ocean View Rm - 2 Qn",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/i08D776jZtW_dnZu66shl30ZVYM=/720x480/13/38/71/13387163.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/i08D776jZtW_dnZu66shl30ZVYM=/720x480/13/38/71/13387163.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Pay-per-view movies"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121271,
                        "kidsFreeTo": 17,
                        "name": "Prem Ocean Frnt Adults Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Telephone"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121272,
                        "kidsFreeTo": 17,
                        "name": "Ocean Frnt Adults - Kg Bed",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Electrical current voltage"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121273,
                        "kidsFreeTo": 17,
                        "name": "Access Kg Bd Roll In Shwr",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "HD Flat-screen TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121274,
                        "kidsFreeTo": 17,
                        "name": "Ocean Front Room - 2 Qn Bd",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Telephone"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121275,
                        "kidsFreeTo": 17,
                        "name": "Enclave Governor Ste- 1Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JbU5AY7jEg4dHhjfwJmRohzZkXQ=/720x480/13/38/71/13387171.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JbU5AY7jEg4dHhjfwJmRohzZkXQ=/720x480/13/38/71/13387171.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Telephone"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121276,
                        "kidsFreeTo": 17,
                        "name": "Super Ocean Front Adult-Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/LlsFZ2kvvGv7eLAa8BW6X4bVBwc=/720x480/13/38/71/13387167.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/LlsFZ2kvvGv7eLAa8BW6X4bVBwc=/720x480/13/38/71/13387167.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Rollaway"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121277,
                        "kidsFreeTo": 17,
                        "name": "Enclave Ocean View- King",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/BizoPsAmLSBK3XBWeTIwSKpnmFU=/720x480/13/38/71/13387168.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/BizoPsAmLSBK3XBWeTIwSKpnmFU=/720x480/13/38/71/13387168.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Telephone"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121278,
                        "kidsFreeTo": 17,
                        "name": "Part Ocean Vw Adult- Kg Bd",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0zxptRzMblIRoi3txrsSm6244G4=/720x480/13/38/71/13387169.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0zxptRzMblIRoi3txrsSm6244G4=/720x480/13/38/71/13387169.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Coffeemaker"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121279,
                        "kidsFreeTo": 17,
                        "name": "Enclave Ocean View - 2 Qn",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Luxurious bed linens"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121280,
                        "kidsFreeTo": 17,
                        "name": "Superior Ocean Frnt - 2 Qn",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Rollaway"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121281,
                        "kidsFreeTo": 17,
                        "name": "Ocean Front Room - King Bd",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Y6DLzyoN11J42NZa-KQp1bdqA8Q=/720x480/13/38/71/13387166.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Electrical current voltage"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121282,
                        "kidsFreeTo": 17,
                        "name": "Enclave Master Suite 1 Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-uZN8jilvdQgfEJu1XEnr6aTf8A=/720x480/13/38/71/13387172.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-uZN8jilvdQgfEJu1XEnr6aTf8A=/720x480/13/38/71/13387172.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Cable/satellite TV"
                        ],
                        "bedding": "1 Queen",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121283,
                        "kidsFreeTo": 17,
                        "name": "Premium Ocean Frt Rm-2 Qn",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KeIMIB64GnYvg0KEKcZBgf0kQYA=/720x480/13/02/45/13024505.jpg"
                            },
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dKrFYQs0v8kGyPoVuPpC5h9vMdM=/720x480/13/38/71/13387164.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Black-out drapes"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121284,
                        "kidsFreeTo": 17,
                        "name": "Premium Ocean Frt Rm-Kg Bd",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Iron and board"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121285,
                        "kidsFreeTo": 17,
                        "name": "Superior Ocean Front - Kg",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/LlsFZ2kvvGv7eLAa8BW6X4bVBwc=/720x480/13/38/71/13387167.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/LlsFZ2kvvGv7eLAa8BW6X4bVBwc=/720x480/13/38/71/13387167.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "In-room safe (fits laptop)"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16121286,
                        "kidsFreeTo": 17,
                        "name": "Part Ocean Vw Rm - Kg Bed",
                        "isActive": true,
                        "view": "De acuerdo a la hab reservada",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0zxptRzMblIRoi3txrsSm6244G4=/720x480/13/38/71/13387169.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Sxm_sBdl7KRcdu4ocRUrTGiHwpA=/720x480/13/02/45/13024530.jpg"
                            },
                            {
                                "cloudUri": "https://img.cdnpth.com/media/RTuZH2Acjm8LFU5cbjO9a3KYD9g=/720x480/13/38/71/13387165.jpg"
                            },
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0zxptRzMblIRoi3txrsSm6244G4=/720x480/13/38/71/13387169.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265644,
                        "kidsFreeTo": 0,
                        "name": "Double Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265645,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265646,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265647,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265648,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265649,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265650,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265651,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265652,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265655,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265656,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265657,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265658,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265659,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265660,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265661,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible King Size Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265662,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265663,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265665,
                        "kidsFreeTo": 0,
                        "name": "Double Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265666,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265667,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265668,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265669,
                        "kidsFreeTo": 0,
                        "name": "Double Premium Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265670,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265671,
                        "kidsFreeTo": 0,
                        "name": "Room Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265672,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265673,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265674,
                        "kidsFreeTo": 0,
                        "name": "Twin Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265675,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265676,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265677,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265678,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Baño para personas de movilidad reducida",
                            "Bathroom",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "Welcome pack",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265679,
                        "kidsFreeTo": 0,
                        "name": "Suite Honeymoon",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265680,
                        "kidsFreeTo": 0,
                        "name": "Twin Superior Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265681,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16265682,
                        "kidsFreeTo": 0,
                        "name": "Twin Partial Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Baño privado con ducha tipo lluvia",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Paraguas",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Smart TV de 65 pulgadas",
                            "Terraza con jacuzzi"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16283067,
                        "kidsFreeTo": 0,
                        "name": "King con jacuzzi frente al mar - Enclave",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/p8TABMR6KYmMc01kWXb8dkxNAnY=/720x480/05/16/40/05164032.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/p8TABMR6KYmMc01kWXb8dkxNAnY=/720x480/05/16/40/05164032.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Baño privado con ducha tipo lluvia",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Minibar",
                            "Paraguas",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Smart TV de 65 pulgadas",
                            "Terraza con jacuzzi"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16283068,
                        "kidsFreeTo": 4,
                        "name": "2 queens con jacuzzi vista al mar - Enclave",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oLy9XnB0wk-tv8k0daI9lCF1LNU=/720x480/05/16/40/05164031.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oLy9XnB0wk-tv8k0daI9lCF1LNU=/720x480/05/16/40/05164031.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Acceso al salón ejecutivo",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Áreas exclusivas",
                            "Baño privado con ducha tipo lluvia",
                            "Bolsa de playa",
                            "Cafetera",
                            "Caja de seguridad",
                            "Check in y check out privados",
                            "Comedor",
                            "Cortesía nocturna",
                            "Internet inalámbrico",
                            "Minibar",
                            "Paraguas",
                            "Reservas preferenciales en restaurantes de especialidades",
                            "Smart TV de 65 pulgadas",
                            "Terraza con jacuzzi"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16283069,
                        "kidsFreeTo": 0,
                        "name": "Suite gobernador king con jacuzzi vista al mar - Enclave",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gIFXsCq9SjQ-EwDcH7LAUL2Mt48=/720x480/05/16/40/05164033.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gIFXsCq9SjQ-EwDcH7LAUL2Mt48=/720x480/05/16/40/05164033.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361336,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta baja",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361337,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta baja",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361338,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361339,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande, vistas parciales al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361340,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha adaptada",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361341,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande, vistas parciales al mar (Roll-In Shower)",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361342,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361343,
                        "kidsFreeTo": 0,
                        "name": "ENCLAVE OCEAN VW ROOM 1 KING BED W/ JET TUB",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361344,
                        "kidsFreeTo": 0,
                        "name": "ENCLAVE OCEAN FRONT MASTER SUITE - KING BED",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361345,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361346,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361347,
                        "kidsFreeTo": 0,
                        "name": "ENCLAVE OCEANVIEW GOVERNOR STE 1KG W/JET TUB",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361348,
                        "kidsFreeTo": 0,
                        "name": "ENCLAVE PRESIDENTIALSTE 1KG- LG WALKOUT TERR",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361349,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 2 camas de matrimonio, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "El tipo de habitación y cama elegidos están sujetos a disponibilidad",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361350,
                        "kidsFreeTo": 0,
                        "name": "Habitación, 2 camas de matrimonio",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361351,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium, 2 camas de matrimonio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361352,
                        "kidsFreeTo": 0,
                        "name": "ENCLAVE OCEAN VIEW - 2 QUEEN BEDS W/ JET TUB",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Balcón",
                            "Bañera accesible",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Conexión a Internet por cable gratis",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Silla de oficina",
                            "Tamaño del televisor: 50",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16361353,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, 2 camas de matrimonio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409439,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "DVD player",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409440,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409441,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409442,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409443,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409444,
                        "kidsFreeTo": 0,
                        "name": "Room Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16409445,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Mesa y sillas",
                            "Smart TV de 65 pulgadas",
                            "Tocador"
                        ],
                        "bedding": "2 Queens",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16968878,
                        "kidsFreeTo": 4,
                        "name": "2 queens frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-s8KmfRwSq76ZccAmvBcowAjIbA=/720x480/04/84/83/04848301.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077515,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077516,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077517,
                        "kidsFreeTo": 0,
                        "name": "Single Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077518,
                        "kidsFreeTo": 0,
                        "name": "Single Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077519,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077520,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Premium Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077521,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077522,
                        "kidsFreeTo": 0,
                        "name": "Single Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077524,
                        "kidsFreeTo": 0,
                        "name": "Suite With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077525,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077526,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077527,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077528,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077529,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077530,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077531,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077532,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077533,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077534,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077535,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077536,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077537,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077538,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077539,
                        "kidsFreeTo": 0,
                        "name": "Single Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077540,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077541,
                        "kidsFreeTo": 0,
                        "name": "Room Premium Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077542,
                        "kidsFreeTo": 0,
                        "name": "Double Side Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077543,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077544,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077545,
                        "kidsFreeTo": 0,
                        "name": "Room Accessible",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077546,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077547,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077548,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077549,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077550,
                        "kidsFreeTo": 0,
                        "name": "Single Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077551,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Centrally regulated air conditioning",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wake-up service",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077552,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077553,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077554,
                        "kidsFreeTo": 0,
                        "name": "Double Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077555,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077556,
                        "kidsFreeTo": 0,
                        "name": "Double Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077557,
                        "kidsFreeTo": 0,
                        "name": "Double Premium King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077558,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17077559,
                        "kidsFreeTo": 0,
                        "name": "Single Side Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214470,
                        "kidsFreeTo": 0,
                        "name": "Room Queen Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214480,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214490,
                        "kidsFreeTo": 0,
                        "name": "Room Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214499,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Premium Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214507,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View Two Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214516,
                        "kidsFreeTo": 0,
                        "name": "Room Two Queen Beds With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214525,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214530,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Superior Ocean Front",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214535,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214541,
                        "kidsFreeTo": 0,
                        "name": "Room Club Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214547,
                        "kidsFreeTo": 0,
                        "name": "Double Club King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214554,
                        "kidsFreeTo": 0,
                        "name": "Tent Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214564,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214574,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214586,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214598,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17214609,
                        "kidsFreeTo": 0,
                        "name": "Room Two Double Beds With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17909374,
                        "kidsFreeTo": 0,
                        "name": "Room Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17950049,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17950050,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean View Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17950051,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18228244,
                        "kidsFreeTo": 0,
                        "name": "Room With Balcony",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18228250,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18482552,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18531997,
                        "kidsFreeTo": 0,
                        "name": "Double Two Queen Beds Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18531998,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18602557,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645986,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645988,
                        "kidsFreeTo": 0,
                        "name": "Room Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645990,
                        "kidsFreeTo": 0,
                        "name": "Suite Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645991,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645992,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Accessible King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645993,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645994,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Queen Beds Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645995,
                        "kidsFreeTo": 0,
                        "name": "Double Grand",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645996,
                        "kidsFreeTo": 0,
                        "name": "Double Accessible",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18645999,
                        "kidsFreeTo": 0,
                        "name": "Room Accessible King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646000,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Queen Beds One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18646001,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18698780,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Premium",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/oMjWpIOfZjSdzAKolqCuIyTgbjo=/720x480/13/02/44/13024499.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4.2,
                    "totalSurveys": 932,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Moderno hotel de playa todo incluido",
                "uri": "hilton-vallarta-riviera-all-inclusive",
                "tags": [
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye entretenimiento nocturno, noches temáticas y shows en vivo."
                    },
                    {
                        "title": "Deportes en Tierra",
                        "description": "Incluye tenis, ping pong, billar y voleibol de playa."
                    },
                    {
                        "title": "Deportes Acuáticos",
                        "description": "Incluye kayaks, clases de natación, clases de buceo y aeróbicos acuáticos."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye desayuno, comida y cena bufet o a la carta, botanas  por la tarde y noche, bebidas alcohólicas y no alcohólicas, vino de la casa y cervezas nacionales ilimitadas."
                    },
                    {
                        "title": "Club de Niños y Adolescentes",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos. Abierto diariamente de 10:00 a 17:00 hrs. También tiene un club de adolescentes con juegos de Xbox, futbolito y ping pong."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Se requiere reservación para los restaurantes a la carta."
                    }
                ],
                "description": "Friendly Fun Vallarta Different Experiences es un hotel reinventado para disfrutar momentos únicos y experiencias memorables y divertidas. Ubicado a la orilla de la playa, en plena zona hotelera de Puerto Vallarta, cuenta con piscina familiar, piscina solo para adultos y una para niños, jacuzzi, gimnasio con instructor y spa con baño de vapor y sauna. Asimismo, ofrece clases diarias de yoga, aeróbicos acuáticos, clases de baile, natación y de buceo, y cabinas y servicio de meseros en la playa.\r\n\r\nEste hotel en Puerto Vallarta dispone de club de niños y adolescentes, así como siete restaurantes de diferentes especialidades, un snack bar que prepara pizzas a la leña, hot dogs y hamburguesas, un café con menú de postres y tres bares. También posee salones para eventos con capacidad para 600 invitados y áreas para celebrar bodas. Sus 300 habitaciones están equipadas con balcón privado, aire acondicionado, televisión con canales por cable y caja de seguridad. Convenientemente, tiene habitaciones libres de humo, para fumadores y para personas con discapacidad. El hotel acepta hasta 2 mascotas (aplican cargos y restricciones).\r\n\r\nLa propiedad está en un área donde abundan hospitales, restaurantes, bares y plazas comerciales, a 4 kilómetros del centro de la ciudad y a solo 5 kilómetros del Aeropuerto Internacional de Puerto Vallarta (PVR).\r\n\r\n***El servicio de estacionamiento del hotel para razers, motos de ruta, cuatrimotos y similares, tendrá un cargo de $400.00 MXN por noche, por unidad a pagar directamente al momento del check in.\r\n\r\n***Es posible que en caso de una ocupación inusualmente baja se vea afectada la operación de bares y restaurantes.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/f9b2304b47e0beb8b8265d57960ac2b074f177e12978bc0b15ac36fad0daadbb_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/258148c969e0f82629faeaac87b56240263482a520df17d92f30ae7c225084ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/05f1ce52c69fccbec5b8eac5c33586f54869fb3276f8dc4d4511ba716659f9cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/313a139c87a199b48d429a4b06f18a13fd0e91db0c598c1a1c0588c1d0121cfd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/fe1962bbd4096c632de8bcfff71e09f691814f09683c0b616e8daf1bbe7e3e70.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/364a31e9a4e1175ad95231901fc600ca87ce0f9f907fd344e4c395f9261db8ae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/3ddccbb05b0dc7234f0f41e94ef2728384a777448c9f44dccb95b6917eca9860.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/e466a8419708a013f231603ee08e9f60bf6d8ff1483741df77804c69a4583140.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/a864a901e0a43f033317a09719263fd3a555f974fd767a548fd7f5513edc68bc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/61ce9d15bd7726ce3ec91fa3e1eeb2d6580cbf7d7fb415f34f6e7850c6a3d359.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/52b2efc9790ebe2c849192078bc13553debd7f7b3ad33e169805d22c118f7bc9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/d21953c1131f4ea34d3db01b46b3d167577ff76959f8eb40ffac7b49ca23866d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/0cd8f6f0782e4613051d7e45092099a101c74b66e30930ca511186c2b9f9923a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/c627f40fd9030db9ef5db59011ab138b3b2d28900af03a9ee86c8bc340b0de0b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/e81259b9251844bc5daa75e8126805d781ce74203d36ae97c39193a0ba262c23.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/73f3dac4b37f6ad57b1fbf5822f5e690e9bc2af4c6d5694d6e07ce0636f21d06.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/f53493a2828500e210541e1a77b03cd774b26158812b5b8a4f738b3c778c2da3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/60b3d483e4bc12dc017c71109bba51998df1a09e8196b74c0c66375dd2f42cff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/702ec2d7790e4d9c1fd73825621b3609a3f20a34dae240a3df71306c2475032f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/525a04a74ec67b905f5631cec9114f6037fe979d3d8e686fc608e3ade475d880.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/89783921daec7da561efbe70cfecd1d14eaec509f771a52d6d1820a552ab0d26.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/53c94286592ded001568fd6954f9fe845516b16995ac2b788942fbeb8c95c408.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/eeb0a31fda51ea00f950a4f824c8cc8b33c365016367029984357a7d9ac8d1f7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/2db773185b9757411b5e544679d85336e060797e528b7ecebc38e4721b9e498a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/54eceb479e97fed726900f9e2594bce6b4534b6ebe033fb4985a0fc0b866b016.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/b3c657f8f41816da77a79510ec105596d3baf1bc867276c604b0f950bcd95064.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/a0efbe7d44787697fbe897da64bfc06320e6b3b3f38a733945ab628e116a2f8b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/2079f17eeff1e527c37fbeedc1cf755e9516deb5acfd1ed28faa53ece9a6f87b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/dc17868578312d0f31ade1aa129a5220159b3efae3799e3ca5fd87e389b3b45d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/8283e995f6803472267439c1e9a6e884ba8c187f6d263ab4a9ee2d33d565b0b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/a9b6a5ce4861a9288b76c8d46d12dd9160d8f0ee7e0803b614474b0517962119.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/35a967a903dee70924bb3c4af51f8460f504eee1b8e9e932e0265c757ace1b45.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/eea9a1eb7b103089af6f43bd2d0096a8d32d0b4b474c4a7ea318ef2a5aafcd27.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/bc5b5fd3f4efbf15094eb579b7e25a133941e28a799ab947fc90c6816692ad77.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/858ab01a00c62f48c885dac2d56a6124ec11c588016d23b2928d3cac223381e7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/921af9386216d349eae9f667579ba137d7d6565602a7af896d5acf16d2de971d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/eb213e88fb84f5500d1e96ebefafd610c4f86ced38e70d10f94ae1e232be66dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100248/6d4efa4ee5d28dbd9afaecf3e3f0dada7d490753c894268f35c4281c08132926.png"
                    }
                ],
                "hotelID": 100248,
                "importantFacilities": [
                    "Espectáculos nocturnos",
                    "Estacionamiento",
                    "Gimnasio"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.641238257723945",
                    "longitude": "-105.23717880249023",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Blvr Francisco Medina Ascencio km 2.5",
                    "countryCode": "MX"
                },
                "name": "Friendly Fun Vallarta Different Experiences",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "La Fiesta",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Villalinda",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Friendly Coffee",
                        "type": "Cafetería"
                    },
                    {
                        "name": "Frida",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Akío Asian",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Palmar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Azul",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Pool bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Bar El Palmar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059583,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059585,
                        "kidsFreeTo": 0,
                        "name": "Single Superior With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059587,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059589,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 1",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059590,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059591,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059592,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059593,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059594,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 4",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059595,
                        "kidsFreeTo": 0,
                        "name": "Room Capacity 3",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059596,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059597,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059791,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059792,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059793,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059794,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059795,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059796,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059797,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059798,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059799,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059800,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059801,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059802,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059804,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059806,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059808,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059809,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059810,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059811,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059812,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059813,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059814,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059815,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059816,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059817,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059818,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059820,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059822,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059823,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059824,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059825,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059826,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059827,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059828,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059830,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059831,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059833,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059835,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059837,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059838,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059840,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059842,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059843,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059845,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059847,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059849,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059850,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059852,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059854,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059855,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059857,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059859,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059860,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059861,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059862,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059863,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059864,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059865,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059866,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059867,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059868,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059869,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059870,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059871,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059872,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059873,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059874,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059875,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059876,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059877,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059878,
                        "kidsFreeTo": 0,
                        "name": "Partial View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059879,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059881,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059883,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059885,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059887,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059889,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059891,
                        "kidsFreeTo": 0,
                        "name": "Superior House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059893,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059895,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059896,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059897,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059898,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059899,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059900,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059901,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059902,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059903,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059904,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059905,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059906,
                        "kidsFreeTo": 0,
                        "name": "Superior With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059907,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059908,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059909,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059910,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059911,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059913,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059915,
                        "kidsFreeTo": 0,
                        "name": "Superior Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059917,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059918,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059920,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18532358,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606494,
                        "kidsFreeTo": 0,
                        "name": "Single Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699059,
                        "kidsFreeTo": 0,
                        "name": "Room Semidouble",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699061,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699062,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699063,
                        "kidsFreeTo": 0,
                        "name": "Twin Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699065,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699066,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699067,
                        "kidsFreeTo": 0,
                        "name": "Triple Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699069,
                        "kidsFreeTo": 0,
                        "name": "Double Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699073,
                        "kidsFreeTo": 0,
                        "name": "Single Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18699075,
                        "kidsFreeTo": 0,
                        "name": "Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890864,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18890865,
                        "kidsFreeTo": 0,
                        "name": "Single With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953362,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Cama Doble",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953368,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953373,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18953380,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000558,
                        "kidsFreeTo": 6,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtcNFuyCZ9zm9HZfi5bH0br_724=/720x480/05/41/29/05412961.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtcNFuyCZ9zm9HZfi5bH0br_724=/720x480/05/41/29/05412961.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Detectores de humo",
                            "Internet inalámbrico",
                            "Mesa de centro",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá",
                            "Teléfono",
                            "Tocador",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 3952198,
                        "kidsFreeTo": 6,
                        "name": "Superior vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/56vR62HIoGXYLyzwUcUm9tID0Gs=/720x480/05/41/29/05412962.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/56vR62HIoGXYLyzwUcUm9tID0Gs=/720x480/05/41/29/05412962.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Conexión a Internet gratuita",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitación apta para mascotas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7879661,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/dtcNFuyCZ9zm9HZfi5bH0br_724=/720x480/05/41/29/05412961.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/dtcNFuyCZ9zm9HZfi5bH0br_724=/720x480/05/41/29/05412961.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Conexión a Internet gratuita",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7879662,
                        "kidsFreeTo": 0,
                        "name": "Habitación superior, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/56vR62HIoGXYLyzwUcUm9tID0Gs=/720x480/05/41/29/05412962.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/56vR62HIoGXYLyzwUcUm9tID0Gs=/720x480/05/41/29/05412962.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10192678,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10192681,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10192687,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13450410,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13450411,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13450412,
                        "kidsFreeTo": 0,
                        "name": "Triple Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151022,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151023,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151024,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151025,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151026,
                        "kidsFreeTo": 0,
                        "name": "Twin Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151028,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151029,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151030,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151031,
                        "kidsFreeTo": 0,
                        "name": "Triple Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151032,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151033,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151034,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151035,
                        "kidsFreeTo": 0,
                        "name": "Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151036,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151037,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16151038,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Bathtub",
                            "Caja fuerte",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Escritorio",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Number of bedrooms",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16268880,
                        "kidsFreeTo": 0,
                        "name": "Single Superior",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Balcón",
                            "Baño",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16268881,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Champú",
                            "Conexión a Internet gratuita",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16782123,
                        "kidsFreeTo": 0,
                        "name": "Estandar Solo Adultos",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059661,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059663,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059665,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059667,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059669,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059671,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059673,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059675,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059677,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059679,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059681,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059683,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059685,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059686,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059687,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059688,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059689,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059690,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059691,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059692,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059693,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059694,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059695,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059696,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059697,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059698,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059699,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059700,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059701,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059702,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059703,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059704,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059705,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059706,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059707,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059708,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059709,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059710,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059711,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059712,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059713,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059714,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059715,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059716,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059717,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059718,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059719,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059720,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059721,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059722,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059723,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059724,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059725,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059726,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059727,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059728,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059729,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059730,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059731,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059732,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059733,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059734,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059735,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059736,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059737,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059738,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059739,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059740,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059741,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059742,
                        "kidsFreeTo": 0,
                        "name": "Partial View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059743,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059744,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059745,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059747,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059749,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059751,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059753,
                        "kidsFreeTo": 0,
                        "name": "Superior House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059755,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059757,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059759,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059761,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059762,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059763,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059764,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059765,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059766,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059767,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059768,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059769,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059770,
                        "kidsFreeTo": 0,
                        "name": "Superior With View Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059771,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059772,
                        "kidsFreeTo": 0,
                        "name": "Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059773,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059775,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059777,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059779,
                        "kidsFreeTo": 0,
                        "name": "Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059781,
                        "kidsFreeTo": 0,
                        "name": "Superior Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059783,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059785,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18059787,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Aeróbicos acuáticos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de baile",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Clases de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Clases de natación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de jóvenes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (4-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbolito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet de alta velocidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Karaoke",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina solo para adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de café en el lobby",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.9,
                    "totalSurveys": 972,
                    "valuesAverage": [
                        4.5,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido frente a la playa en Puerto Vallarta",
                "uri": "friendly-fun-vallarta-different-experiences",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    },
                    {
                        "name": "Acepta mascotas"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Club de niños con actividades programadas y supervisadas en horario establecido."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los incluidos en el programa de actividades y una hora diaria de tenis por habitación (previa reservación)."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Deportes acuáticos no motorizados."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Hotel libre de humo."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Tres piscinas climatizadas, mini parque acuático infantil, seis canchas de tenis y gimnasio."
                    },
                    {
                        "title": "Actividades",
                        "description": "Amplio programa de actividades para cada día de la semana, entretenimiento nocturno y actividades al aire libre."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                    }
                ],
                "description": "Canto del Sol Puerto Vallarta All Inclusive es un hotel todo incluido ubicado en la parte norte de la Zona Hotelera de Puerto Vallarta, a 1.5 kilómetros del Malecón. El aeropuerto internacional de Puerto Vallarta (PVR) está a 4 kilómetros de distancia. Dispone de 285 habitaciones equipadas con aire acondicionado, caja de seguridad, secador de pelo, teléfono, televisión de pantalla plana y baño privado con ducha. \r\n\r\nEs hotel familiar con plan todo incluido cuenta con seis restaurantes, uno de ellos bufet, y los demás de especialidades mexicanas, italianas, orientales, de cortes y marisco, e incluso uno con 11 tipos diferentes de ceviche. También tiene dos bares que sirven bebidas nacionales y snacks. Además tiene tres piscinas climatizadas, mini parque acuático infantil, cuatro canchas de tenis, gimnasio, área de spa, salones para bodas y eventos, y un amplio programa de actividades para cada día de la semana, así como entretenimiento nocturno y actividades al aire libre.\r\n\r\n***La Sección Montaña no es apta para personas con capacidades diferentes, movilidad limitada y/o adultos mayores.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/18629e7a2f60e12ab95a317b0ce8b51c45ad8914587e3bd236a64336887986c0_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe con vistas laterales al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100112/ce668f716d95f6e8e2025c723c84e1c7808edcecd9732370f5670cf28a944d97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/9e63293892a65a6b39f9e17e2e8740c315788759e66e0a410b32cecf71eab058.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/3d880882bf6e574b09af1f13c9177573733cdfea515b1695e783a46bdcc9a3a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/6899e043671ff21ce44a32f2b50a6f3a46aca34ef7313be37faed2c2db2e6b3a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/5d1760fa1b09211886b379857b217dabf20cde57491a4e55bbd523f77094b371.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/967d8b3434772ef2cfe3b5b2cc15dc22bb3296df69f72cbafe9b530d4c342bc2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe con vistas laterales al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100112/9598734b2e28d15b09f1a68e9cf945b490223956a2009d93615e1770ef51c926.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/058af42c3031fa9bdf4856958872be7d286edb05d6ac092b12efdfcab989763b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe con vistas laterales al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100112/ee99e65ce4467911f7d932f0e182dd2d1bddc5c3b8cdeb1b9eb8e57746e8e3a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Estándar - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/46e2212f454c93a19a86789681023e1bc4274561ee571c99d67166f5dcd676bf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Estándar - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/96925e54779c54a7afe2c861d1956a320266f3882f7406304fb02cc48fa3f1f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Estándar - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/120b8482bf7eac823e7396c9660218fc0995541b610b4d361d7b9ab700d532ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Alojamiento Estándar - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/d265cb255d47b2e04ad1cc157ce9220ac84b4b5e622fafc8d9250f1ad6fa346a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/d883cd364b5913e3664e302e96d6a98050d48cb9b33ebda60205231cd573ffda.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/b89586949ec7ac3f8802f807834752aec6a96076e7216fb5ceb96215e65c3a0b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/7a2cc30b06f08ff31705a1c5c4c4a84208706c5e8686ef15f1bb06eeeaae60b1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/c3a7ee3e9337d23e4610c28b4efd7f09fee2fc45376b0e8949bd6813481aa92e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/7c3353a29331cb237918abfddbb27a7426eacd37a0d3175ea4f4ada886f99c7f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/97be783b9a91add2261577c9d31c676a08c5a1dfe5023b57c33a5554a5e4faf0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estudio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/e7576417353daa24e4a4642d9cc394434fca55c54cb2fb7b702e29a6e510475b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estudio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/8da6d57d942f6edfaf9c9e3f29c273f9210b72daf7d8b8788c6afb961ff6d494.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estudio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/79b2719c5b89818e2cdb199b910845ec876ce39b0bf5c855abebc7b3cbd793e6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estudio - Sección de montaña",
                        "cloudUri": "https://img.cdnpth.com/media/100112/14500f289086be3910c7ef480f7d65cc8f16d3b16a56246deb19b123e8434d5d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/0ee7ec127109e514e14cb546b6da8eeb4544d0ad6ba8ea259dc99a672231887a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/e5024a7430455f74eb6d1db0c9b383866cca5bb71141d64addfe63d1d26dc045.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/1dbf64b2ab8ccd81014c797eb18c78df429e7f9e615d8750c41a57599bda173c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/100112/36276d2660c512fc9dfa83fba1d057b79c4ba8802943fe07b6198bac0028c761.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe",
                        "cloudUri": "https://img.cdnpth.com/media/100112/0751e92277450f43b73dea6d410a376e0bd91d81dce6e6bb0d01830fb1e3bda1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/5f64cc44108f52db5d3933b24590d8a15c48122e7c3ce5dbce2c1eb4375a2e80.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estudio Estándar",
                        "cloudUri": "https://img.cdnpth.com/media/100112/0d8967b6810a584bf87933e9efc76c11d9e19b64c85e495392cab8e41d2e2f3d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Deluxe con vistas laterales al mar",
                        "cloudUri": "https://img.cdnpth.com/media/100112/fd46e75ece0152318179f1a1af995805d163d7d08f573b10710e9e188a29535a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/7406d0582ece188fa2759a7eb9a62fa571a748227548605bbd01f5ff115e96c6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/bfb94f14a1aa8caa4329e9ffe86db040eddc8fe32f5d14909d2659e1852c8fdf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/ab24f98bfc7242d95f3343973bf9aecebdf1b8989c89716bcf4ce8c43a9536bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de lujo de 1 dormitorio ",
                        "cloudUri": "https://img.cdnpth.com/media/100112/fe431ac26d9612f7e4cfe306a296fd5268ff4f51348937cf81e4dc9d78399bdc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de lujo de 1 dormitorio ",
                        "cloudUri": "https://img.cdnpth.com/media/100112/37006d26d4a53c6d85f04fccbd6be7c2885d226b568cf458560c627e74ed85cd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de lujo de 1 dormitorio ",
                        "cloudUri": "https://img.cdnpth.com/media/100112/faac179b5ac99cf988c888a813b8a7abbdf539b14cd68135f68325d60cdf0016.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/b395aeaca847798c2ef56d1c079469697ee8a46d3f0e6a21b1cf075f9411cfa9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/c5bbfd741c21cf1e12f08b650d93ca0d365d57bc6e370a73aa1cb8dbd5e7f0c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/035f0e2d2fc08b106dd1d458457fc2ef386a867a03246eb3c9ee2b285d6b092d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/fa9cfde280b38071523f407fd498b7902757e0c2387f33c6a1e5c1f6af9d2691.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/f3716fd6e3e4e4e17165e7aa40360933d82c5741396206e4e3a8ce00eec7d351.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/eb8119997228cb8756bd5067885402f23f1a035ecbc99972dc1cdade60b093ed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100112/c2123a43ce28917a44a64c0aba52b26a43b556103e21f9d1749d45ddf4b57868.png"
                    }
                ],
                "hotelID": 100112,
                "importantFacilities": [
                    "Sección Luxury con piscina para adultos y piscina para niños con juegos",
                    "Seis canchas de tenis iluminadas (1 hora gratis por día)",
                    "Wifi en cortesía"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.632924819671075",
                    "longitude": "-105.23228645324707",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "José Clemente Orozco 125, Zona Hotelera Norte",
                    "countryCode": "MX"
                },
                "name": "Canto del Sol Puerto Vallarta All Inclusive",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "El Pescador",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Cevichería (Sección Montaña)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Mi Morenita (Sección Montaña)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Il Cantico",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Akita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Mar y Tierra (por temporadas)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack Peces",
                        "type": "Bar"
                    },
                    {
                        "name": "Aqua-Bar Papagayo",
                        "type": "Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477350,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477380,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477411,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477444,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477477,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477510,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477542,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477572,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477605,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477639,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477670,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477701,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477731,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477765,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477799,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477837,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477873,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477909,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477943,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477977,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478009,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478041,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478072,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478103,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478135,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478167,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478199,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478231,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478262,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478294,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478325,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478355,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478388,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478421,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478452,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478482,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478514,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478547,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478580,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478612,
                        "kidsFreeTo": 0,
                        "name": "Penthouse 3 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478642,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478672,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478703,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478739,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478770,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478801,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478831,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478861,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478892,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478921,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478950,
                        "kidsFreeTo": 0,
                        "name": "Studio Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18478979,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479008,
                        "kidsFreeTo": 0,
                        "name": "Shared Room Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479038,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479068,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479097,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479122,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479149,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479180,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479211,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479239,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479267,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479296,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479322,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479350,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479376,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479403,
                        "kidsFreeTo": 0,
                        "name": "Park View",
                        "isActive": true,
                        "view": "Parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479431,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479459,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479488,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479517,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479542,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479568,
                        "kidsFreeTo": 0,
                        "name": "Without Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479592,
                        "kidsFreeTo": 0,
                        "name": "Single Room Park View",
                        "isActive": true,
                        "view": "Parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479615,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479638,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479665,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479690,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479714,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479742,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479772,
                        "kidsFreeTo": 0,
                        "name": "Studio Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479799,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479829,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479857,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479879,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479901,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479924,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18479947,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581423,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581441,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581459,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581478,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581497,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581516,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581534,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581551,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581569,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581588,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581607,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581627,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581647,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581668,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581689,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581710,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581731,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581753,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581775,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581797,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581818,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581839,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581861,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581882,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581903,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581925,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581947,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581969,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18581990,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582011,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582033,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582055,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582077,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582102,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582124,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582146,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582168,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18582189,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Rociadores",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000871,
                        "kidsFreeTo": 4,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ajwbPYhp0l-yGUd0Gk53u8z7rAU=/720x480/02/10/96/02109640.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ajwbPYhp0l-yGUd0Gk53u8z7rAU=/720x480/02/10/96/02109640.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Rociadores",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1003287,
                        "kidsFreeTo": 5,
                        "name": "Estándar Sección Playa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-6m9fNFwg7fFmGEE4uLwsDhe-kM=/720x480/02/10/96/02109644.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-6m9fNFwg7fFmGEE4uLwsDhe-kM=/720x480/02/10/96/02109644.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952932,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, vistas parciales al mar",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0quuwhWdn7Sp3-XZobIU6V7s_n0=/720x480/02/10/96/02109646.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0quuwhWdn7Sp3-XZobIU6V7s_n0=/720x480/02/10/96/02109646.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Oven",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Separate bedroom",
                            "Sofá cama",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952933,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom Luxury Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3y1lmAC281BrjYuSWhFvgesyi8U=/720x480/02/10/96/02109660.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3y1lmAC281BrjYuSWhFvgesyi8U=/720x480/02/10/96/02109660.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Free bottled water",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Oven",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Sofá cama",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952934,
                        "kidsFreeTo": 0,
                        "name": "2 Bedroom Luxury Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/LIecDMEbC5BpTh5LJXH6ZwdE0jg=/720x480/02/10/96/02109663.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/LIecDMEbC5BpTh5LJXH6ZwdE0jg=/720x480/02/10/96/02109663.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Bedsheets provided",
                            "Cable TV service",
                            "Cable/satellite TV service",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Flat-panel TV",
                            "Free bottled water",
                            "Free toiletries",
                            "Hair dryer",
                            "In-room safe",
                            "Iron/ironing board",
                            "Limpieza de habitaciones diaria",
                            "Lowered locks/deadbolt",
                            "Lowered peephole/view port in door",
                            "Low-height counters/sink",
                            "Low-height desk",
                            "No cribs (infant beds)",
                            "No fumadores",
                            "Plancha o tabla de planchar",
                            "Private bathroom",
                            "Productos de higiene personal gratis",
                            "Secador de pelo",
                            "Shower only",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Towels provided",
                            "TV size measurement: inch",
                            "Wheelchair accessible"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952935,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-6m9fNFwg7fFmGEE4uLwsDhe-kM=/720x480/02/10/96/02109644.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-6m9fNFwg7fFmGEE4uLwsDhe-kM=/720x480/02/10/96/02109644.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3994984,
                        "kidsFreeTo": 5,
                        "name": "Superior vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0quuwhWdn7Sp3-XZobIU6V7s_n0=/720x480/02/10/96/02109646.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0quuwhWdn7Sp3-XZobIU6V7s_n0=/720x480/02/10/96/02109646.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Espejo de tocador",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3994985,
                        "kidsFreeTo": 5,
                        "name": "Estudio estándar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/I2dZh4tc3l64KOPzLCdkBK7tl3Q=/720x480/02/10/96/02109648.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/I2dZh4tc3l64KOPzLCdkBK7tl3Q=/720x480/02/10/96/02109648.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Espejo de tocador",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3994986,
                        "kidsFreeTo": 5,
                        "name": "Estudio lujoso",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8pvHTFLq-QmoFFDidrJSqr4HUx0=/720x480/02/10/96/02109650.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8pvHTFLq-QmoFFDidrJSqr4HUx0=/720x480/02/10/96/02109650.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "2 baños",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Espejo de tocador",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3994987,
                        "kidsFreeTo": 5,
                        "name": "Suite lujosa de 1 dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/3y1lmAC281BrjYuSWhFvgesyi8U=/720x480/02/10/96/02109660.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/3y1lmAC281BrjYuSWhFvgesyi8U=/720x480/02/10/96/02109660.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Comedor",
                            "Espejo de tocador",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales y 1 Sofá cama",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3994988,
                        "kidsFreeTo": 5,
                        "name": "Suite lujosa de 2 dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/LIecDMEbC5BpTh5LJXH6ZwdE0jg=/720x480/02/10/96/02109663.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/LIecDMEbC5BpTh5LJXH6ZwdE0jg=/720x480/02/10/96/02109663.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039921,
                        "kidsFreeTo": 0,
                        "name": "Studio Standar",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/I2dZh4tc3l64KOPzLCdkBK7tl3Q=/720x480/02/10/96/02109648.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/I2dZh4tc3l64KOPzLCdkBK7tl3Q=/720x480/02/10/96/02109648.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Free bottled water",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minibar (surtido, artículos gratis)",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Oven",
                            "Placa de cocina",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4039922,
                        "kidsFreeTo": 0,
                        "name": "Studio Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8pvHTFLq-QmoFFDidrJSqr4HUx0=/720x480/02/10/96/02109650.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8pvHTFLq-QmoFFDidrJSqr4HUx0=/720x480/02/10/96/02109650.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Mesa y sillas",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7555331,
                        "kidsFreeTo": 5,
                        "name": "Estándar sección montaña",
                        "isActive": true,
                        "view": "Interior o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/h2FECtdkY4_p0nLXQTBmRPBdxpM=/720x480/04/21/33/04213368.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/h2FECtdkY4_p0nLXQTBmRPBdxpM=/720x480/04/21/33/04213368.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Cocineta",
                            "Mesa y sillas",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7555332,
                        "kidsFreeTo": 0,
                        "name": "Estudio sección montaña",
                        "isActive": true,
                        "view": "Calle o Interior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/r9Hh_xx1KkXG-QeJbAqPIH94pP0=/720x480/04/21/33/04213376.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/r9Hh_xx1KkXG-QeJbAqPIH94pP0=/720x480/04/21/33/04213376.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Cocina equipada",
                            "Comedor",
                            "Mesa y sillas para cuatro",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7555333,
                        "kidsFreeTo": 5,
                        "name": "Suite de 1 dormitorio sección montaña",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/DG6cj5Z3rc1jWPqowXKIx0kp50g=/720x480/04/21/33/04213370.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/DG6cj5Z3rc1jWPqowXKIx0kp50g=/720x480/04/21/33/04213370.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso con sofá cama",
                            "Baño privado con bañera y ducha",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocina equipada",
                            "Comedor",
                            "Mesa y sillas para seis",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7555334,
                        "kidsFreeTo": 5,
                        "name": "Suite de 2 dormitorios sección montaña",
                        "isActive": true,
                        "view": "Interior o Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/erz8nuGdgzxBrw-GsZIC-IQIuUE=/720x480/05/00/27/05002723.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/erz8nuGdgzxBrw-GsZIC-IQIuUE=/720x480/05/00/27/05002723.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7560877,
                        "kidsFreeTo": 0,
                        "name": "Standard Mountain Section (Antes Villas Vallarta)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/h2FECtdkY4_p0nLXQTBmRPBdxpM=/720x480/04/21/33/04213368.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/h2FECtdkY4_p0nLXQTBmRPBdxpM=/720x480/04/21/33/04213368.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minicocina",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7560878,
                        "kidsFreeTo": 0,
                        "name": "Studio Mountain Section (Antes Villas Vallarta)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/r9Hh_xx1KkXG-QeJbAqPIH94pP0=/720x480/04/21/33/04213376.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/r9Hh_xx1KkXG-QeJbAqPIH94pP0=/720x480/04/21/33/04213376.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minicocina",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7560879,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom, Mountain Section (Antes Villas Vallarta)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/DG6cj5Z3rc1jWPqowXKIx0kp50g=/720x480/04/21/33/04213370.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/DG6cj5Z3rc1jWPqowXKIx0kp50g=/720x480/04/21/33/04213370.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Microondas",
                            "Minicocina",
                            "Nevera",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Televisión por cable o satélite",
                            "Toallas",
                            "Vajilla y utensilios de cocina",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7560880,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms Mountain Section (Antes Villas Vallarta)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/erz8nuGdgzxBrw-GsZIC-IQIuUE=/720x480/05/00/27/05002723.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/erz8nuGdgzxBrw-GsZIC-IQIuUE=/720x480/05/00/27/05002723.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas Queen size de 150 a 154 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11565931,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360835,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360836,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Sofá-cama",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360837,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360838,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360839,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360840,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16360842,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16712673,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16712674,
                        "kidsFreeTo": 0,
                        "name": "Estudio Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17217532,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17217538,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949884,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949891,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949897,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949903,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17949908,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474718,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474741,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474762,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474783,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474805,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474827,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474848,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474869,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474889,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474909,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474929,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474949,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474972,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18474994,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475017,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475040,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475064,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475091,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475118,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475145,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475173,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475200,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475229,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475259,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475285,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475314,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475341,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475368,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475396,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475423,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475447,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475472,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475496,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475523,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475550,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475577,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475602,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475628,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 1 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475654,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Studio",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475677,
                        "kidsFreeTo": 0,
                        "name": "Penthouse 3 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475700,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475724,
                        "kidsFreeTo": 0,
                        "name": "Penthouse",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475750,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475774,
                        "kidsFreeTo": 0,
                        "name": "Suite 3 Bedroom",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475799,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475824,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475850,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475873,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475898,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475921,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475947,
                        "kidsFreeTo": 0,
                        "name": "Studio Single Room",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18475975,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476003,
                        "kidsFreeTo": 0,
                        "name": "Shared Room Shared Bathroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476029,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476057,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476085,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476114,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476143,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476171,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476200,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476230,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476260,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476289,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476321,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476353,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476383,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476413,
                        "kidsFreeTo": 0,
                        "name": "Park View",
                        "isActive": true,
                        "view": "Parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476440,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476467,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476495,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476522,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476549,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476576,
                        "kidsFreeTo": 0,
                        "name": "Without Balcony",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476604,
                        "kidsFreeTo": 0,
                        "name": "Single Room Park View",
                        "isActive": true,
                        "view": "Parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476634,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476665,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476696,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476726,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476753,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476776,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476799,
                        "kidsFreeTo": 0,
                        "name": "Studio Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476825,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Studio",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476851,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Vista al río",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476876,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476902,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476928,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476955,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18476982,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vista al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477011,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477036,
                        "kidsFreeTo": 0,
                        "name": "Suite Penthouse 3 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477062,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477089,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477117,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477149,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al valle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477178,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477206,
                        "kidsFreeTo": 0,
                        "name": "Studio Villa",
                        "isActive": true,
                        "view": "Vistas al valle",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477232,
                        "kidsFreeTo": 0,
                        "name": "Villa 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477258,
                        "kidsFreeTo": 0,
                        "name": "Villa Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477286,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18477316,
                        "kidsFreeTo": 0,
                        "name": "Villa",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20356367,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20356370,
                        "kidsFreeTo": 0,
                        "name": "Estudio Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20356372,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Camas extra (sujetas a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cancha de usos múltiples",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (4 a 11 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas (sujetas a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas (sujetas a disponibilidad)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 1980,
                    "valuesAverage": [
                        4.4,
                        4.2
                    ]
                },
                "title": "Hotel todo incluido en la zona norte de la ciudad",
                "uri": "canto-del-sol-puerto-vallarta-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        }
                    ],
                    "I": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        }
                    ]
                },
                "trace": null
            }, {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Deportes Acuáticos",
                        "description": "Los deportes acuáticos incluyen snorkeling y equipo para deportes no motorizados como kayaks."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye bebidas premium nacionales e internacionales por copeo, todos los alimentos y botanas, comprende desayuno y comida bufet y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Para los restaurantes de especialidad se requiere código de vestimenta casual - formal. A los caballeros no les está permitido el uso de pantalones cortos, sandalias o camisetas sin mangas. Las reservaciones se pueden hacer de la siguiente manera: una vez en estadías de tres noches; dos veces en estadías en cinco noches; tres veces en estadías de siete noches."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores, incluyendo bingo, waterpolo, voleibol en la alberca y la playa y aquaerobics. El programa varía diariamente."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen el uso del gimnasio, tenis de mesa, billar, aerobics y el uso de las canchas de tenis con reservación previa (una hora al día)."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 5 y 12 años, supervisado por adultos. Abierto diariamente de 10:00 a 18:00 hrs."
                    }
                ],
                "description": "Barceló Puerto Vallarta es un hotel todo incluido ubicado en la famosa Bahía de Mismaloya, al sur de Puerto Vallarta, rodeada de vegetación y que ha sido lugar de filmación de numerosas películas de Hollywood, incluyendo La Noche de la Iguana en 1964, que dio a conocer el destino a nivel mundial. En tu próxima visita a Puerto Vallarta puedes recorrer las cascadas de los alrededores, dar un paseo en velero y durante el invierno, el avistamiento de ballenas será una experiencia inolvidable. El aeropuerto internacional de Puerto Vallarta (PVR) está a 26 kilómetros de distancia.\r\n\r\nBarceló Puerto Vallarta cuenta con 316 suites equipadas con aire acondicionado, balcón o terraza, televisión de pantalla plana, caja de seguridad, teléfono y baño privado con regadera. Las habitaciones Club Premium cuentan con minibar VIP, área exclusiva de registro, servicio a la habitación sin cargo, internet inalámbrico gratuito en el salón privado y reservaciones ilimitadas en los restaurantes de especialidades. \r\n\r\nBarceló Puerto Vallarta ofrece club de niños, spa, gimnasio, tina de hidromasaje solo para adultos, cuatro albercas y centro de negocios. Además, cuenta con varios salones de eventos con capacidad para hasta 600 invitados. En Barceló Puerto Vallarta podrás elegir entre cinco restaurantes, además de disfrutar de espectáculos nocturnos a cargo del equipo de entretenimiento del hotel.\r\n\r\n***El uso de cubrebocas (mascarilla) es obligatorio para los huéspedes dentro del hotel, excepto en las áreas de piscina, playa y cuando consuman sus alimentos/bebidas.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/db6d5aaf6e82134775b623b5594263fe358fa5e556fa5e712c5c4d52476d7c5c_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/18fba588cd6a5fbe3c5f456b72a16d1264759d017a91a95fdbaaea2b11d75e7c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/7cd7530e6d138e8d2472f90b25edda77eae98f017b7a2ae3dfd12a39b3c9d666.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/e7bcd36f3dbddfededa3a012e7b163d49b64dc2e33c2c1c320fbc2d1167a209b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/70559bc00dc983885f8af26316f617b9b9626afeb7f1fab4512f00d829ed80d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/1eb5eee78c237f0383d8c9b882da6b6bcf71ad9af826c7f7087e763ff9cdbfbd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/19dc3ef3c2a7ed530840c70735b753df168f0bd275dff993260c4307cc0f9979.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/82556e09218bff37404b021680bf835f5999141e2fbe2e75ff18a118ec95c7af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/8751fec9ecf2100376dc594983629c530f8456b85ea0614f56d5dabad10719ba.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/59c89c24a667bf365d5208ae3952a284bd9cf769512d3ee2a869fa78b563f9f0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/7967bcf6bedace51795e4757a8ea350d2fc99730a335fc4c3dab02ea9225e12e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/d4016728a6f1d6f6b5a75defdd764805b4fc44cc15e45b4cc7464d4c885e1969.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/e74df94385fa2c2c588fe3f48d384499c8dc91e6951dbd6f121e97004231de82.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/3fc599589c7e21e997907e0cf1c97fb20211e2c304d7a8eac80ad245dd42bca2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/481c08c1f4659a07541ee50d1561345c1072736167f2302d1bae1ec9d77649e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/4af00eb976d2655b07eceb9b6ef4cef56825c9505fbecc0881485c2aa7f32390.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/524520643b982d5caf6cfe8487aaba71695aadfcecb8b39e5af60b6be8589e61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/8125758f1137280b36ed4c6e8f30ad85a397207fd8269df043faa41a9b054c25.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/4d0370972e60872051fd9e3afd8d0e5314fde59053b2620d9b2b22cc4b996bb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/644657be16ac918ad1d4f9dad6b8a11f41078312202de06db094b97879417e52.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/d63a58eedb5dec5d1ff07dc004510e4ee030702646bb9ef7ffa947088ae42863.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/07b4f4239a24d2f803384d651e147cb8f023f592614532ae957fceae050e029a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/b261f23f2d5acfe328bacc24db4295ec9d91a6d6c6b2f80364269c8a1e2c7961.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/1454f021dcd1dbb68a19542320e33e1e8f8970fba33096eebc8a9f8a1633512d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/4a2cd54425801d4716849ca555c9e0479552d3c6189eae9668fc0f5ef6dbb4c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/d770fd9657b9b4d9ffdade338165bda2dad8b4f0d9b72da440857be5346cb65a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/9c27b269946f9126f65f38151fc5bd18d98f64ed01b998623670c5070a5baa6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/3302308a8004c2cb2b6073c842bd2fced12846c199528ddaf84f7d981d615db9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/ac35fe014c2769c3022138930a3b267149701574f9f6d8cc99dbb6a325b55530.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/e85e8d7195388c1b794f979d307b8d7ef76038130546e538e329c4e40a65bc48.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/1ae45a81eaaa23f1f6df03d2d3533a0328b37b68327d779526f0f587d3da5aaf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/13e7ec604e41d31b3ee7d2337301dd50aaa148174ffa34d54c656718a9d6c559.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/968004f3b6ede90d6ce2f68db7fa8c7959fd1db0c55f90a0c276386d80f99657.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/352530e8f428b51be2a3388e09ce1e67adc009d595061a648bd28a20ee30a233.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/aac4e54cf78070d9a414563ba8fb4840e2caa41508044ae38c39933218c8d817.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/14f105e423b53ce9fb7b9601b426d9d799ef2cf6c7f9a7cab6c365dcd6ba663c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/9c595ae61894ce817016350ce608599ea5b3cbc03ea5d8fafda4624c2fe45ed2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/f664d1d693aac9cac27e4cf252b8a3e27858843733ebc7753e116852484626f3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/7f3e72ca05643ceb2245963bab0c8eedf8cbff18e9493dd4957caee7457ea581.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/d7abb8aa85f2cb1225be16e2fe6f175b84ea72dff43c8b32695b167b6cba5afd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/f450312ad9743c021863256dff2bfa34a30ca121de6372eb2f410fa72a624242.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/900b33a9171da62c85a76c4d72813179f73913834526b0deb6acbd9a12af226f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/6546a768c5b902996a079d866460db5435bb20518a2c86ed052435e835af8d86.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/aec50265fc25fde8ee266fb22556333755bbf94342d5c5468f9356d49a37b9c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100037/d434d696bb824d8d1e0074b40460effd1401092e4ec55b4233cb0fbf5211cd62.png"
                    }
                ],
                "hotelID": 100037,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.532585625821486",
                    "longitude": "-105.29099464416504",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Zona Hotelera Sur km 11.5",
                    "countryCode": "MX"
                },
                "name": "Barceló Puerto Vallarta",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Acqua Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Capri",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Don Quijote",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Fuente",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Cantina",
                        "type": "Bar"
                    },
                    {
                        "name": "Los Arcos Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Snack Los Arcos",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000774,
                        "kidsFreeTo": 1,
                        "name": "Suite de lujo",
                        "isActive": true,
                        "view": "Alberca|Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 TVs",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "2 Individuales y 1 King o 2 Kings",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000775,
                        "kidsFreeTo": 1,
                        "name": "Familiar",
                        "isActive": true,
                        "view": "Alberca|Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000776,
                        "kidsFreeTo": 1,
                        "name": "Suite de lujo - Premium Level",
                        "isActive": true,
                        "view": "Alberca|Jardín|Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "2 Individuales y 1 King o 2 Kings",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000777,
                        "kidsFreeTo": 1,
                        "name": "Familiar - Premium Level",
                        "isActive": true,
                        "view": "Alberca|Jardín|Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs de plasma",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1527919,
                        "kidsFreeTo": 0,
                        "name": "Master suite vista frontal al mar - Premium Level",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7jTLcfjvASgbngHD8ecC3ZNMujw=/720x480/13/24/92/13249216.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7jTLcfjvASgbngHD8ecC3ZNMujw=/720x480/13/24/92/13249216.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1527920,
                        "kidsFreeTo": 0,
                        "name": "Gran master suite vista frontal al mar - Premium Level",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "SI Habitaciones para fumadores",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7744352,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590865,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe (Premium Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590866,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, vistas al mar (Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590867,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar (Premium Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590868,
                        "kidsFreeTo": 0,
                        "name": "Habitación familiar",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590869,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium, vistas al mar (Level)",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Cepillo y pasta de dientes no disponibles",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Habitaciones insonorizadas",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reciclaje",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Solo ducha",
                            "Tamaño del televisor: 40",
                            "Teléfono",
                            "Televisión",
                            "Televisión de alta definición",
                            "Televisión LCD",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8590870,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10591022,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10591053,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581457,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11581459,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922691,
                        "kidsFreeTo": 1,
                        "name": "Suite de lujo - no reembolsable",
                        "isActive": true,
                        "view": "Alberca|Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 TVs",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "2 Individuales y 1 King o 2 Kings",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922692,
                        "kidsFreeTo": 1,
                        "name": "Familiar - no reembolsable",
                        "isActive": true,
                        "view": "Alberca|Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922693,
                        "kidsFreeTo": 1,
                        "name": "Suite de lujo - Premium Level no reembolsable",
                        "isActive": true,
                        "view": "Alberca|Jardín|Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "2 recámaras",
                            "2 TVs",
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo"
                        ],
                        "bedding": "2 Individuales y 1 King o 2 Kings",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922694,
                        "kidsFreeTo": 1,
                        "name": "Familiar - Premium Level no reembolsable",
                        "isActive": true,
                        "view": "Alberca|Jardín|Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs de plasma",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922695,
                        "kidsFreeTo": 0,
                        "name": "Master suite vista frontal al mar - Premium Level no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7jTLcfjvASgbngHD8ecC3ZNMujw=/720x480/13/24/92/13249216.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7jTLcfjvASgbngHD8ecC3ZNMujw=/720x480/13/24/92/13249216.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 TVs",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Comedor",
                            "Espejo de tocador",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono",
                            "Teléfono en el baño",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11922696,
                        "kidsFreeTo": 0,
                        "name": "Gran master suite vista frontal al mar - Premium Level no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12878596,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16723092,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886517,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": null,
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886541,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886543,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886562,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886578,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886597,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886614,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886632,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886643,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886658,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886672,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886688,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886701,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886718,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886736,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886753,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886771,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886787,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886803,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886821,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886837,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886854,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886867,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886886,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886902,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886919,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886937,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886952,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886968,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16886985,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887000,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887015,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887030,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887048,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887064,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887079,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887095,
                        "kidsFreeTo": 0,
                        "name": "Presidential Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887108,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887125,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887141,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887156,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887172,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887187,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887205,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887223,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887241,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887257,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887275,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887290,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887306,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887321,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887338,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887354,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887369,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887386,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887402,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887417,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887432,
                        "kidsFreeTo": 0,
                        "name": "Large Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887450,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887467,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887486,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887501,
                        "kidsFreeTo": 0,
                        "name": "Family Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887518,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887535,
                        "kidsFreeTo": 0,
                        "name": "Premium Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887548,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887567,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887585,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887596,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887613,
                        "kidsFreeTo": 0,
                        "name": "Romance",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887629,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887645,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887661,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887677,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887695,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 2 Beds 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887712,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887728,
                        "kidsFreeTo": 0,
                        "name": "Presidential Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887743,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887761,
                        "kidsFreeTo": 0,
                        "name": "Thematic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887776,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887791,
                        "kidsFreeTo": 0,
                        "name": "Presidential Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887806,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887822,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887836,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887851,
                        "kidsFreeTo": 0,
                        "name": "Premium Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887867,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887882,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887897,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 3 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887912,
                        "kidsFreeTo": 0,
                        "name": "Premium 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887926,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887944,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887957,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887972,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16887987,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888004,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888018,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888033,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888046,
                        "kidsFreeTo": 0,
                        "name": "Premium Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888060,
                        "kidsFreeTo": 0,
                        "name": "Family Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888075,
                        "kidsFreeTo": 0,
                        "name": "Presidential Deluxe Suite Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888088,
                        "kidsFreeTo": 0,
                        "name": "Family Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888101,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16888113,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219353,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219356,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219359,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_RURJFNXx-66OroGc3AfpVRpN-s=/720x480/13/24/89/13248909.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219362,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219365,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947254,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18004234,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18004235,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18004237,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18004238,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18211543,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18225471,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18225472,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VXe_2GlinTF5rE_HITOa7Ov3pck=/720x480/13/24/92/13249215.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18225473,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Con Cuarto De Baño Compartido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18225474,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JAZqjvKaoAAOAAOXhXhKolUe7rs=/720x480/13/24/89/13248943.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18225475,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Cuarto De Baño Compartido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18532378,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Qhq3sERekXk6We9MvlVd5Qvltkg=/720x480/13/24/92/13249214.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18801219,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Cama King Size No Fumadores",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VPQ_3Bykig1MyJsiylrsVGEYOQI=/720x480/13/24/89/13248942.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891448,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891451,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891453,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891456,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19891460,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "Tetera eléctrica",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20300851,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 2208,
                    "valuesAverage": [
                        4.5,
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel al sur de Puerto Vallarta, en la Bahía de Mismaloya",
                "uri": "barcelo-puerto-vallarta",
                "tags": [
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        }
                    ],
                    "I": [
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye bebidas nacionales, todos los alimentos y botanas, comprende desayuno bufet, y comida y cena a elegir entre bufet o a la carta, así como servicio a la habitación las 24 horas con cargo extra por servicio."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección y minibar con refrescos, agua embotellada y cerveza resurtido diariamente."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos. Abierto diariamente de 09:00 a 17:00 hrs."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol, fútbol, ping pong, estiramientos y caminatas por la playa."
                    },
                    {
                        "title": "Deportes acuáticos",
                        "description": "Incluye equipo no motorizado para deportes acuáticos como kayaks."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Las cenas a la carta requieren reservación y están sujetas a espacio."
                    },
                    {
                        "title": "Otros",
                        "description": "Acceso inalámbrico a internet en todo el hotel."
                    }
                ],
                "description": "Buenaventura Grand Hotel and Great Moments es un resort todo incluido en Puerto Vallarta, ubicado frente al mar, a corta distancia del famoso Malecón en la Playa Los Camarones. Además, el Aeropuerto Internacional de Puerto Vallarta (PVR) está a 7 kilómetros de distancia.\r\n\r\nLa propiedad cuenta con 231 habitaciones, todas equipadas con aire acondicionado, cafetera, internet inalámbrico en cortesía, caja de seguridad, minibar, televisión de pantalla plana, teléfono de marcación directa y baño privado con ducha. Además, las suites premiere lunamielera ofrecen espectaculares vistas de la bahía, bañera de hidromasaje y un estilo decorativo de tendencia actual.\r\n\r\nEl hotel tiene dos piscinas, gimnasio, centro de negocios las 24 horas, estacionamiento y tienda de regalos. También ofrece mesa de tours, concierge y resguardo de equipaje; además dispone de un completo spa. Asimismo, cuenta con tres restaurantes con servicio a la carta o bufet y tres bares.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/1cd93d9fe78fc682f20249040ac17143a0684d8f6868998b1063ed905e07452f_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/26e53b2180e0cfacc916c62baffae5f76fc1561e57ac6e3682ff0bcacee3257b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/e56ba3bd332d5c0aa4e1aca1a185398e049d7b9c07b42b842770cf3460ec55ad.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/593929473d130d247fa017758d6079a3cdd8fe2f651e3cdb8a2eeff59f2d2fdf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/cf4c47412406b74e47174168830bb33bffdd36962e537bf21ad2aa197a4aaacc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/489707003fbdcd95e77cd559e0324d6528c21e23a080afad897ba18d67e1b8f8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/e54dfbeb1e883de3930dddf03f6696d40c0c71df2349a54fcf0f1235091e0c3b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/b45698af2e845d14528938720ef042454c7d95104bf8faff8346d8cf22136760.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/ff323d2c9648b3d9c0b27c7a0b7edf45ab1c465f459412b7d556e181f86e675c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/77b60590a5d66beace872d5bb04332debf0b719241c9ea6731ce818c0015765e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/c398f184b533179fc29cdc4c608edbf9acc640c632ce04a05fd0dcadd1ea3863.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/1e18e4f210016e58df8f9e5901caa34c68339330497409d06f22709d95587d8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/ff209411f61853a0746b7f16b4b48db09f7d087207eb5c4ad97e5cf1912c58cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/13528de95a38e2a7b74f7d3aaa2c10f6bedf45197510c2bdc03750cc86eab9a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/7967bd42e32da15b952ba3608f2e0afe050aca950db1aca12b7bba928be9e347.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/2c78348e5697e4878af7a09bd3356e385bca27a5d72fd278d8668dbf20b607ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/21c261b4b93ca80f43c59878962abafd99cbd2dbda3d3ee1ccb232402fc487f3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/3f91fc08f239cdbb022db2877918978b074ac0ec8ff312f963cfb91876f175f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/d546a4dfc1aa3761cd017d17a7b7333a978d8163106970fb2230249ccb885968.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/aa30440f8d8753ce0f5db3e8ddb8bdd57138b3a9f3d48cd46d3f8e88d45fd724.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/22e4c73b77e8ff9724d30bc650c65e496140ded9021100397844b38a0f09f932.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/8e56227467879613f1dfdd15c617288d1c73d039f3291df3aca6b75c5b29dddc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/40c567c63302e710e6171e7651e59155bca1efb4de3e27a32d9970829e1aef7b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/3f29dc79373e6b34ba23537c6423c0a77e69110901decd5855bffb56d5818d49.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/db0c41e0301a51f46c47bb93680a0d7ada07a1b6ab8857633fba957961d4b87f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/0259dea0859573393bd55200b9a5d4ab4c8a667a65c5f28908d679e40c199c33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/19ba88fd882e50e6940ab6bcc516c50a3cf5ef40fea0fa4cab5e991371c2ef54.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/72064601a3c696f22313d5073f54e314b79962b3ad383b1a35a6ce385875e0f3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/edd9e792e7f7808cc4994748b4c5f734b6c91a12ec70d131128e2adcfa27769a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/e73c85e3daa3e140ed7adf154286d0c9f75323bffaa42bb94690fa6c1b179823.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/805b31e3d70b34cd30639043c2d29e5e4aa0080e5a25a857683da101c8daf61a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/b079816e57e48e65227613f3762faa5230d5ac6df2ef351f5d8025b0d120395e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/eed268160653995d85352599790258bcc4d16dfcc6320f2f39241b8aeb704929.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/83b8a8c7721f4b1be39decafeea8b6a13198b1ac60b761470a573c368d6bce38.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/2d9ab3321ef1d07ae2b6e7f507c3e2068e66f16cee7b13f402ecdeb00f489f92.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/66ea33a1fc2a59d962b2e9a77123b843670ba421678d1f815a83cb5a239eaa01.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/657904836f040e696c356fcda945ca7eb1199d9214d24aefdd49130dc9a9ddfd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/55303209f450749fa9c5b0cd450b170f4a9581ecf6bcb8184521177f0a50ac9e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/68a1ab622ebcb6e80565013ce7118a8146f64bf667cbab3016aef94109f16816.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/99eda489724a68c1c45134c8a49cb7f56518b552e35d614538b67d72c894829c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/105a20f8bd6b751ecde0ee7d7839c10452069657803e1c62d957a9fc4eb34bed.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/70c8d400de38d773b33019137796a50d21cc94809b02c352f439ccb182ca006e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/5240e1593d0e626e571063c629dccb7064be064ddd10326aecc7819d03635b58.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/1928cf54dc6a2fa1173be23ae8989632565cd0846dc63cc819df212bc0dee70e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100096/d6f45d77845efb78ef6c12cc7eef5a8eedaf189211a6fa15e343bbfdcc3c441a.png"
                    }
                ],
                "hotelID": 100096,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.62025298122745",
                    "longitude": "-105.23151397705078",
                    "postalCode": "48350",
                    "state": "Jalisco",
                    "street": "Av México 1301, Col 5 de diciembre",
                    "countryCode": "MX"
                },
                "name": "Buenaventura Grand Hotel & Great Moments",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Frutas y Flores",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Corazón Contento",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sunset",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490752,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490766,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490779,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490793,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490807,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490821,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490834,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490848,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490862,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490875,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490888,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490901,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490914,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490925,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490937,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490950,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490962,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490975,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490988,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491000,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491013,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491027,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491042,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491057,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491071,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491087,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491103,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491119,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491135,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491150,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491166,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491181,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491197,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491213,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491230,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491245,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491262,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491279,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491297,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491314,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491331,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491347,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491363,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491380,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491397,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491414,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491431,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491449,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491467,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491485,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491502,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491520,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491537,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491554,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491570,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491586,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491601,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491616,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491631,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491646,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491662,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491678,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491694,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491710,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491728,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491745,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491764,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491783,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491802,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491821,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491840,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491860,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491880,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491900,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491920,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491941,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491963,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491985,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492008,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492032,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492056,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492081,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492105,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492129,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492153,
                        "kidsFreeTo": 0,
                        "name": "Economic King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492177,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492202,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492227,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492253,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Honeymoon",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492281,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492309,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492337,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492365,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492394,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492422,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492449,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492476,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492503,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492530,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492555,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662591,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662602,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662612,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662622,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662632,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662641,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662650,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662661,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662671,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662681,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662691,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662700,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662709,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662719,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662729,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662738,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662747,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662755,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662765,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662775,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662785,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662795,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662804,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662815,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662825,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662835,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662845,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662857,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662868,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18662880,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Jacuzzi",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "TV de pantalla plana",
                            "TV por cable"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 1022109,
                        "kidsFreeTo": 0,
                        "name": "Suite lunamielera con vista al océano - wifi gratis",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/zrilYjMIt0rxo-nlzIzh9HBcF68=/720x480/12/35/28/12352878.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/zrilYjMIt0rxo-nlzIzh9HBcF68=/720x480/12/35/28/12352878.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Smart TV",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7557795,
                        "kidsFreeTo": 0,
                        "name": "De lujo king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VmFMnizpxAO8ZUDx3NXw37sp67s=/720x480/13/23/27/13232767.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VmFMnizpxAO8ZUDx3NXw37sp67s=/720x480/13/23/27/13232767.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Smart TV",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7557797,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7583907,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Complejo",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Armario o ropero",
                            "Bañera de hidromasaje privada",
                            "Bañera de hidromasaje privada (interior)",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cuna de viaje",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Edredón",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No hay camas supletorias",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7833297,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cuna de viaje",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Edredón",
                            "Guardería en habitación (de pago)",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7833300,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cuna de viaje",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Edredón",
                            "Guardería en habitación (de pago)",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión digital",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7833301,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368096,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Complejo",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368098,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368109,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368110,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368113,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8368114,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432596,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432599,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432603,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432614,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Bañera hidromasage",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432630,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432641,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432657,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432663,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8432671,
                        "kidsFreeTo": 0,
                        "name": "Habitación Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197475,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199258,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199259,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11582404,
                        "kidsFreeTo": 0,
                        "name": "Doble Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11582409,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11582412,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11582413,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11582414,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/PLLfsn8JiuCYByptyTxPmsJzOZk=/720x480/05/25/97/05259742.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12528836,
                        "kidsFreeTo": 6,
                        "name": "De lujo 2 dobles",
                        "isActive": true,
                        "view": "Interior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Internet inalámbrico",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV de pantalla plana"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 12528845,
                        "kidsFreeTo": 6,
                        "name": "De lujo 2 dobles vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086123,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OW8L4kIDzWV2yOl6BZK8jTXpYyk=/720x480/05/25/97/05259773.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086125,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16086131,
                        "kidsFreeTo": 0,
                        "name": "Suite Lunas De Miel",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uMZ1LQQZa0B-xPUaxmJWboS_uXw=/720x480/05/25/98/05259864.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cuna de viaje",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Edredón",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Televisión",
                            "Televisión digital",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110347,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/u7j-F3yR3X4g7M5VREcPDi4g-ak=/720x480/05/25/97/05259772.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cepillo y pasta de dientes no disponibles",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cuna de viaje",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Ducha efecto lluvia",
                            "Edredón",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "Número de camas - 1",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Televisión",
                            "Televisión digital",
                            "Televisión por cable o satélite",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16110348,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/88dKwsdo65MmVGP-IFwp4Pb5PN0=/720x480/05/25/97/05259771.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061219,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17061220,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219777,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219779,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219780,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219781,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17219783,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488257,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488291,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488325,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488359,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488392,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488424,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488456,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488488,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488521,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488553,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488585,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488615,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488646,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488677,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488709,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488741,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488772,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488803,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488833,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488864,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488895,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488926,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488956,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18488988,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489018,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489049,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489081,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489112,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489143,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489174,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489205,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489239,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489269,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489300,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489331,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489360,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489388,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489416,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489443,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489470,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489499,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489527,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489555,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489583,
                        "kidsFreeTo": 0,
                        "name": "Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489610,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489638,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489666,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489694,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489723,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489749,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489775,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489802,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489828,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489855,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489881,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Queen Beds Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489906,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489932,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489958,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18489984,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490010,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490036,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490063,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490089,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490115,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490141,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490168,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490194,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490220,
                        "kidsFreeTo": 0,
                        "name": "Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490246,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490273,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490298,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490322,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490344,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490365,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490385,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490407,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490425,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490442,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed Sea View",
                        "isActive": true,
                        "view": "Vistas parciales al lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490459,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490476,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490492,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490507,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490522,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Double Bed Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490535,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490546,
                        "kidsFreeTo": 0,
                        "name": "Economic King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490557,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490570,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490582,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490594,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Honeymoon",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490607,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Twin Bed",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490620,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490633,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490646,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490659,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490672,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490684,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490696,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490708,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Vistas al campo de golf",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490721,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18490734,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18531814,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606513,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606514,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606515,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606516,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606517,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18606518,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647079,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647083,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647086,
                        "kidsFreeTo": 0,
                        "name": "Doble No Fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647091,
                        "kidsFreeTo": 0,
                        "name": "Individual No Fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647096,
                        "kidsFreeTo": 0,
                        "name": "Triple No Fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647101,
                        "kidsFreeTo": 0,
                        "name": "Triple Comunicada",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647104,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual No Fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647107,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647110,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama Queen Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18647112,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas No Fumadores",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824478,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824482,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824486,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824492,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824498,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18824504,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Jacuzzi",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18883896,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898821,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18898822,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926699,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926700,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Kit de bienvenida",
                            "Mini nevera",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926701,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926702,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926703,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18926704,
                        "kidsFreeTo": 0,
                        "name": "Habitación Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Nevera",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19303586,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Actividades para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 895,
                    "valuesAverage": [
                        4.5,
                        4.4,
                        4.2
                    ]
                },
                "title": "Hotel todo incluido en Puerto Vallarta, cerca del Malecón",
                "uri": "buenaventura-grand-hotel-great-moments",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Otros",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Club de niños",
                        "description": "Incluye un programa de actividades para niños entre 3 a 12 años, supervisado por adultos. Abierto diariamente de 09:00 a 22:00 hrs."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como kayaks y snorkel."
                    }
                ],
                "description": "Dreams Vallarta Bay Resort and Spa es un elegante hotel de playa todo incluido en Bahía de Banderas, cerca del paseo marítimo El Malecón en Puerto Vallarta. Esta propiedad ideal para familias y parejas tiene playa, albercas y servicios de lujo. Se encuentra a 6 kilómetros del Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR) y además ofrece la novedosa aplicación Unlimited Connectivity que permite a sus huéspedes estar conectados vía internet desde su smartphone con todos los servicios del hotel, además de hacer y recibir llamadas gratuitas como si fuera el teléfono de su suite. La propiedad acepta perros de máximo 10 kg en las habitaciones y ofrece amenidades especiales para ellos (aplican cargos y restricciones).\r\n\r\nEn todas las 327 suites del hotel Dreams Vallarta Bay Resort and Spa hay jacuzzi, base para iPod®, minibar surtido diariamente y vistas al mar o al jardín desde el balcón o la terraza. Las habitaciones Preferred Club ofrecen servicios adicionales como acceso al salón Club Preferred donde se puede hacer uso de sus computadoras y disfrutar de un desayuno continental diariamente, al igual que canapés, postres y cocteles en las tardes. También cuentan con entrega de periódicos en inglés o español y préstamo de libros, CDs y DVDs.\r\n\r\nDreams Vallarta Bay Resort and Spa ofrece a sus huéspedes un spa completamente equipado con 14 cabinas de tratamientos, así como una suite nupcial y diversos servicios de salud y belleza. Además, tiene un centro de buceo y se puede practicar tiro con rifle y con arco. Este hotel cuenta con siete restaurantes bufet o a la carta de especialidad mexicana, italiana, así como comidas a la parrilla que se pueden disfrutar junto a las albercas, una de ellas solo para adultos. El Dreams Vallarta Bay Resort and Spa brinda acceso a dos restaurantes gourmet para cenas, ubicados en la propiedad hermana Secrets Vallarta Bay Puerto.\r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva.\r\n\r\n***Dreams Vallarta Bay Resort &amp; Spa ha sido catalogado por la asociación AAA de los Estados Unidos con Cuatro Diamantes.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/3bb7df2e619cb3c37ed5177f88fc0d9faf278d108ef3dd9f0c30feb4e051b486_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/5e472cebd0fb82f0d13c9f39f4320525eec0aa03be60255b1384ebbdee66e9f0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/49a5956ba5708d2755de67385b73302077236efeb5da0522048a90bdec787e9b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/5816c3bd070f0b2a317e167f2c1c7c3301e71e61506eb2bcf9a5d18f589b374d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/a824f0f3768af8a9574024645f9a4380e091ea065a7ac40d277aff5fe81294f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/039d091e155395c967699168dee41f8a69d1f39f8521148e0ee29de630510a96.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/9d54b4a1a49829ab228f17fa8a956941b5c47696dea22b6346955ca57010f27e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/da4ac971d025a61b00a8f4ea6cef23755b691f8251a81fcc02f25ce393713e76.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/dff4908fb70ca3b7e60edad463c67ad13624dd6c54486fc059642d02a3fcf4a4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/cd1aeeaab23b1648fe445eb84efcab4ef11f3f002cf4c3ff306eaed84967e297.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/af87d1c798dd32e4d457ccb9ba3748c724d50ae8266576b894fe9bc0f4342a04.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/307de389b6819ac1c602b37c5fa7adbeee2a089a2732241ef299fd2d82bc7edf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/4113abef72014d780af306a06daa9a6929d392c5d12aacf7604073b6da24ee26.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/1029ac87e8cb415cd93d4cce5fa3239928208dd53757c9cf8d4562ecfb2b141e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/02c1e4737bb8f8f74cb8222eae6549c2746027caa21efb9a3034f0e62a278ec3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/a145f29437b0943405c3afbd2d7ff5dbe36d599fbf72a9cb4a129f50aafd3518.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/fbba4c583fc2a028c5b549365cd46e585a45748b0715f014736b01c9eeeefeb7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/16f21f6e1106f7e6ce9607a532ba550e2b358978621b00079fa4ea4868730a00.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/4c1510b34ef6d8d39b0a32d0c0d4440b376384828e41e063636e0aa494ab2f7e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/07a1300235026ff522f98d94674e3cc2c7c76da6b5eb9bcce7c3d2188b3e1a4c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/69137f7019c80635b3b68a14fd3f2a12db0da43bcdeb1b88a6ddb715cc9c2b68.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/e0f3f6e26d8a66c3eb75a92ed57413cd8d0d149b14b7897954937d6b7b968a6f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/f0cd251f4de66168c199b9070e8cb5b85949961b11f6fac53a418d2a9a0acd55.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/41045b969db12bb8330afcd2222acc0a8887167dbaacf6c70454f8c0b7990019.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/7593a4ef274728440755c64b90fa2d6968db0d2207c8f3cb26acd86952f8807b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/2ba465f06cfcd9ee5db4f51c293eafff28d35c3c72bf6526562ef6bef1155eb6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/c56cf117b3a7c6732f04c5d8fbd68e52dca3bc99dfdf0e0f55b75fdc25f5c47b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/a1f1d6f29c6a3ab29f86222e8998b7b8560e041fbd4f5bf1e6bede54b27160c9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/a996f2b8eb951281653e15cc3ee4645bbc1477532d8a17c6933957a07854743a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/2c5228858350a2d6c8095a244e97996de6121133cd69e3e03674ffc00cc29449.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/85ca526425d7c9a4407d5266dc691a67fffa873d0ebd1daf1e37fdda24d0fbb6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/4cf84235cf14b1151880b41fc9a01415f3e5ef80ee238d7bcc5d7b170f37f5d6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/36c147afd23486e5de9a2b50cdc478d86540e012fdd4b134ef0e468e953bdcb3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/7348f67607d44cffb0247f52d3fc302fa0b8de8b5e930c5ac98cbc79844f054c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/104500/5b76742c79aa0d05be8b1f68894f6e8c2e41c81e99746ed5c2241b2c8f52ba47.png"
                    }
                ],
                "hotelID": 104500,
                "importantFacilities": [
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.63174001736303",
                    "longitude": "-105.23073077201843",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "David Alfaro Siqueiros 164, Zona Hotelera Las Glorias",
                    "countryCode": "MX"
                },
                "name": "Dreams Vallarta Bay Resort & Spa",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Carnaval",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Castaways",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Tamarindo",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Spice",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Capers",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Barefoot Grill",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Coco Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Moments Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Wet Bar The Reef",
                        "type": "Bar"
                    },
                    {
                        "name": "Eclipse Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Sand Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Showtime",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714413,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Double - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714414,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King - Room Only",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714415,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Partial Ocean View - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714416,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Double - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714417,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714418,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Garden View Double - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714419,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Garden View King - All Inclusive",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714420,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite - Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714421,
                        "kidsFreeTo": 0,
                        "name": "Club Junior Suite - Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714422,
                        "kidsFreeTo": 0,
                        "name": "Room - Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714423,
                        "kidsFreeTo": 0,
                        "name": "Club Room - Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714424,
                        "kidsFreeTo": 0,
                        "name": "Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714425,
                        "kidsFreeTo": 0,
                        "name": "Preffered Club Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714426,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714427,
                        "kidsFreeTo": 0,
                        "name": "Ocean View Double Non Refundable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714428,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Garden View King Non Refundable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714429,
                        "kidsFreeTo": 0,
                        "name": "Ocean View Double Nrf",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714430,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Garden View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 13714431,
                        "kidsFreeTo": 0,
                        "name": "Preffered Club Garden View Double Nrf",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Nevera",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971339,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Nevera",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971340,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcón",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Kit de baño",
                            "Microondas",
                            "Minibar",
                            "Nevera",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5971347,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127329,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127331,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Garden View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127332,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean View King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127336,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Double",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127338,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Garden View Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10127339,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Ocean View Double",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194567,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194570,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194573,
                        "kidsFreeTo": 0,
                        "name": "Double Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194576,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194580,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194586,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194591,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194595,
                        "kidsFreeTo": 0,
                        "name": "Double Club Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194599,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194603,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194606,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194609,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194613,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194616,
                        "kidsFreeTo": 0,
                        "name": "Double Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Outdoor swimming pool",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Dining Area",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194621,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194625,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194627,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194629,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194631,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194633,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194635,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "3 Outdoor swimming pool",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194637,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194639,
                        "kidsFreeTo": 0,
                        "name": "Suite With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194641,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194643,
                        "kidsFreeTo": 0,
                        "name": "Double Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "3 Outdoor swimming pool",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194645,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194646,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194647,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194648,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194650,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194652,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194656,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194658,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194661,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194662,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194663,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194665,
                        "kidsFreeTo": 0,
                        "name": "Double Club Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194666,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194667,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194669,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194671,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194674,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "7 Outdoor swimming pool",
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194676,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194678,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Double Beds Non Smoking",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194683,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194685,
                        "kidsFreeTo": 0,
                        "name": "Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Outdoor swimming pool",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194686,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194690,
                        "kidsFreeTo": 0,
                        "name": "Double Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194692,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194695,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194699,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194702,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194704,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Grand",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194705,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194706,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior With Views",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194707,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194708,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Mini fridge",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194710,
                        "kidsFreeTo": 0,
                        "name": "Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Dining Area",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Fridge",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Microwave",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "Terrace",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194711,
                        "kidsFreeTo": 0,
                        "name": "Suite Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194713,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Balcony",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Cot on demand",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Extra beds on demand",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Living room",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 10194714,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624719,
                        "kidsFreeTo": 0,
                        "name": "Room Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624720,
                        "kidsFreeTo": 0,
                        "name": "Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624722,
                        "kidsFreeTo": 0,
                        "name": "Room Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624724,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11624726,
                        "kidsFreeTo": 0,
                        "name": "Room Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075820,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075822,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075823,
                        "kidsFreeTo": 0,
                        "name": "Room Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075824,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Capacity 2",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16075825,
                        "kidsFreeTo": 0,
                        "name": "House Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149852,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Swim Out King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149853,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Swim Out King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149854,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Swim Out Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149855,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Ocean Front",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149856,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Swim Out Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149857,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Junior Suite Swim Out Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Camas supletorias gratuitas",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Diván cama",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "Number of beds - 1",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16149858,
                        "kidsFreeTo": 0,
                        "name": "Deal of the Day",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Almohadas a la carta",
                            "Bañera",
                            "Bañera hidromasage",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción individual",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Teléfono en el cuarto de baño",
                            "Televisión",
                            "TV por cable",
                            "TV vía satélite ",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16397377,
                        "kidsFreeTo": 0,
                        "name": "Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Albornoces",
                            "Balcón amueblado",
                            "Bañera con hidromasaje",
                            "Bañera y ducha separadas",
                            "Baño privado",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Estación de conexión iPod",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Minibar (surtido, artículos gratis)",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Películas de pago",
                            "Periódico gratuito",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Reproductor de DVD",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones (24 horas)",
                            "Tamaño del televisor: 32",
                            "Té o café instantáneo gratis",
                            "Teléfono",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por satélite",
                            "Toallas",
                            "Wifi gratis",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17177051,
                        "kidsFreeTo": 0,
                        "name": "Preferred Club Master Suite Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249765,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/weTA_xbWjbSZNKyNF95_cdmz8-Q=/720x480/13/06/60/13066076.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/weTA_xbWjbSZNKyNF95_cdmz8-Q=/720x480/13/06/60/13066076.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249767,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jLh7io5OqqdesWjkpxxMruNdsCA=/720x480/13/06/60/13066064.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jLh7io5OqqdesWjkpxxMruNdsCA=/720x480/13/06/60/13066064.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249768,
                        "kidsFreeTo": 2,
                        "name": "Junior suite swim-out doble",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cE6dvwai4sVkxww3UDLgQouP2fE=/720x480/02/91/80/02918083.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cE6dvwai4sVkxww3UDLgQouP2fE=/720x480/02/91/80/02918083.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249769,
                        "kidsFreeTo": 2,
                        "name": "Junior suite swim-out king",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/YydzscPGjKyjW3XUjvwkltFD0AM=/720x480/02/91/80/02918082.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/YydzscPGjKyjW3XUjvwkltFD0AM=/720x480/02/91/80/02918082.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249770,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al jardín - Preferred Club",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/MGZnKU9WsqIAAtmq8c9yKtmQ0dc=/720x480/02/91/80/02918080.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/MGZnKU9WsqIAAtmq8c9yKtmQ0dc=/720x480/02/91/80/02918080.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249771,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al jardín - Preferred Club",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gkd0JmjsMCNwMX1MbNeHdn2O1IQ=/720x480/13/05/68/13056831.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gkd0JmjsMCNwMX1MbNeHdn2O1IQ=/720x480/13/05/68/13056831.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249779,
                        "kidsFreeTo": 2,
                        "name": "Junior suite doble vista al mar - Preferred Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/tdCkN6MIQulSmz3ID5I5FuFFsUU=/720x480/02/91/80/02918085.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/tdCkN6MIQulSmz3ID5I5FuFFsUU=/720x480/02/91/80/02918085.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249793,
                        "kidsFreeTo": 2,
                        "name": "Junior suite king vista al mar - Preferred Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/JDb02gKArXv47eeixvXimtBH7aU=/720x480/13/05/68/13056890.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/JDb02gKArXv47eeixvXimtBH7aU=/720x480/13/05/68/13056890.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249798,
                        "kidsFreeTo": 2,
                        "name": "Junior suite swim-out doble - Preferred club",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cE6dvwai4sVkxww3UDLgQouP2fE=/720x480/02/91/80/02918083.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cE6dvwai4sVkxww3UDLgQouP2fE=/720x480/02/91/80/02918083.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249801,
                        "kidsFreeTo": 2,
                        "name": "Junior suite swim-out king - Preferred Club",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/B4Bnc7F4EbAUTILDKVXSezkGIqU=/720x480/13/05/68/13056897.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/B4Bnc7F4EbAUTILDKVXSezkGIqU=/720x480/13/05/68/13056897.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249805,
                        "kidsFreeTo": 0,
                        "name": "Master suite frente al mar - Preferred Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0er1n02k-OMDnT5nQqjFtgmcmGQ=/720x480/13/05/69/13056925.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0er1n02k-OMDnT5nQqjFtgmcmGQ=/720x480/13/05/69/13056925.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Área de descanso",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Jacuzzi",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249806,
                        "kidsFreeTo": 0,
                        "name": "Master suite vista parcial al mar - Preferred Club",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/KLERwURCIoP6TjJFUD2vS5mR1ts=/720x480/13/05/69/13056952.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/KLERwURCIoP6TjJFUD2vS5mR1ts=/720x480/13/05/69/13056952.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Acceso privado a la alberca",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con bañera de hidromasaje",
                            "Báscula",
                            "Base para iPod",
                            "Batas",
                            "Caja de seguridad",
                            "Canapés",
                            "Check in y check out privados",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Licores selectos",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Mesa de trabajo",
                            "Minibar",
                            "Pantuflas",
                            "Pisos de mármol",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Reproductor de DVD",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite",
                            "Ubicación preferencial"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17249807,
                        "kidsFreeTo": 0,
                        "name": "Master suite swim-out vista al jardín - Preferred Club",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/bzy8UAXl6QSR8kcRMapEMGS_Zy0=/720x480/13/05/69/13056951.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/bzy8UAXl6QSR8kcRMapEMGS_Zy0=/720x480/13/05/69/13056951.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con bañera y ducha",
                            "Caja de seguridad",
                            "Closet",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18814516,
                        "kidsFreeTo": 2,
                        "name": "Oferta del día",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Hsw1L0kTa5RAAbqc9Xz-GRpfzSo=/720x480/13/05/74/13057458.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Hsw1L0kTa5RAAbqc9Xz-GRpfzSo=/720x480/13/05/74/13057458.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boogie boards",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Botones",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de buceo",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Equipo para snorkel",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Euro bungee",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jet ski",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Water polo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Yoga",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4.1,
                    "totalSurveys": 946,
                    "valuesAverage": [
                        4.7,
                        4.6
                    ]
                },
                "title": "Hotel de playa todo incluido en Puerto Vallarta cerca de El Malecón",
                "uri": "dreams-vallarta-bay-resort-spa",
                "tags": [
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Ecológico"
                    },
                    {
                        "name": "Amigos & parejas"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [],
                "description": "Krystal Grand Puerto Vallarta All Inclusive es un hotel ubicado en la Zona Hotelera Norte de Puerto Vallarta, muy cerca de Marina Vallarta y su exclusivo campo de golf. A corta distancia se encuentra el centro comercial Galerías Vallarta y la Escuela Naval Militar. El tradicional Malecón está a 5 kilómetros de distancia, mientras que el Aeropuerto Internacional Gustavo Díaz Ordaz (PVR) está a 4 kilómetros.\r\n\r\nEl hotel ofrece 259 habitaciones y suites, todas equipadas con aire acondicionado, televisión de pantalla plana y caja de seguridad para laptop. Además, las habitaciones junior suite pueden contar con balcón o jacuzzi; algunas tienen piscina privada o incluso una terraza amplia en el segundo nivel con un jacuzzi. \r\n\r\nEn Krystal Grand Puerto Vallarta All Inclusive se puede elegir entre siete restaurantes, destacando uno de cocina mexicana y otro de especialidades francesas, así como tres bares y servicio a la habitación las 24 horas. El hotel cuenta con piscina, gimnasio y un spa. Asimismo tiene varios salones de eventos, el mayor con capacidad para 900 invitados, así como centro de negocios, cajero automático y cajas de seguridad en recepción.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/d7d94deca5a3d33536aab53e33d30f393b384a9fda182ca0459f176522502e22_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/aa3e0b7eb2eee063f25209f73f02df9835a3d8766866ae01f988702746c57057.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/8fa1406fb0cfdd60d5f1c1a3296655441b7381c51ca7083bc7c69b1499517a61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/2a7cec446c912679f843e2c885bf0b498581525fec0fff11021f726156ee966e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/bbbdfb493fd9dc7dd3da5b767c9c2cce444986e620120338e41a20eb4d7d8f37.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/d67d1a6b22a86f5e830b86c9c4133246a5e4839a8d0d125ddbed6861a0dab64d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/abb52e0d3a0f6cd20b1a703b4444b154b80d45e5883ff3ce5c8b186106dad0fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/a87c53d2d81b706d60048934b26f97a82fb9811bdbfaa7fd813a86cb574d1e14.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/84f3b3935b54af6fdd3d9039a04b2efa83054db4a6a73f83cbc8f6e9b8047cf9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/9d11f6546d126abcf2638e92d57205de4f3a489d805af9564c1c38e54e034294.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/a64d3b7a3ff734eaf5da9ed35326834c6cdcabfe9749ed67ddd7de08388e34fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/87bef92b32ae0a2e97bfcdbcb8492a5d067f89ef4c974b3c0c521aa0354c52cf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/174b4e8f0ee9b98114818df3410666ee69b92a33b62d7a16de2d2a057fb00a69.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/4ff25e60ecea93236d24562240cfda9f8f19769ef1799a847ca112ecacafcd38.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/81f44f7e6e5f9b4fa8d8cb8ff3ac4ec1c2ae73157f133c7e662323fc00170a1f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/cd038f65b63123de560c984730739fdfd1330910dded5a6ad22a51a7d134849d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/02ea751f75cf347a18d1ed586fcaaddf0947b5ec7d894fa4829b1c81816a9c33.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/db481a61859d9d1c79d844cdc69cee1f67ee6822f858b93075c1631ef37136c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/4fa03ed05a5aab93827203cfe5c29c7c0f6d797c257a4e9294260bf5fc376911.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/27368cef759e21488f7553cf4a6fb80fdd9839898cdd8cee1ce32204a7faef7f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/07c948437fe81b767e843dc8ad1c3f161f35e6d075b49470fd19f9c03572ea25.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/bfd94eb3b989c1be886a43c2949957b9a4a72442df42fd984a8e416090dcdcf4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/41ffe7d447eccd6879c6001d9115a557c685810dda5ffb0a0b2822374bea859b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/993414f333ea7766d17ccf9db78bf87fa851afc220e097fccdf85babc889449f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/cc6bf21ad1b6fe541fc44c3eb11cad1fca74b9fe74d7096a8b290d97709c5fd8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/0dd5fea37757ffcbffadee784bee4842b60dc35d317f226a341a78980d13348c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/63519ae27656ccb24aa2ad57dacec59f17f958151b6b63a931cb06448436b77b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/5ae559ac5a6bbc8d7fe2a185143eabd109899be73f489799128e8b09f8a67085.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/431dff30f4f4a84890429fa4d3eea251d4d634970071f8b9cf19a0ff9db8587c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/3188eeaa92dbb213e54bd916f2fc034b4af609bd81ba01080b26bb77243a56ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/ce43a82644ebe85ebb53d57423aea40d77ea82210b961dd7b25836f0c11f6791.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/02a70b261fa4cee19f47b22ed1ccc4ecbe147af94496b48720d782828d93baf8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/568a08f8e0c82445e0e37157fb3bf7be6c406eb68a3b6157f40d8290b8022420.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/923139eebced6afc87a9d648eb959de17ce9543ba700c6821a182f2b2d5ec9cb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/8e8604a354e647d6ff727c75f8cd11ee8733ea44362b8edb8ecc738661b922e6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/d8ac5794907542e0a6ef27b06e07edb384748e74d81bc49e1d3e952b7d92ba8c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/8390803d08ec905da86883aba47335c7ef7c411444fcf5afffc0a9ae1b5ed6e9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/d11f1ce2a43b1663baa30132323e1a5a6ab53aca5178c85b910434e519fdc7c0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/d8df7f0214456565ed88fc54932552844b924cc91dab13565e7df6df0fb8577f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/df2e551afc00339e3952ed944f958ac38387dbae7bc21722b23134db8267887d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/105984/8a2516388812e6be1788b3d088d57051370c60fb8121e916fc0ca2147dcc47e2.png"
                    }
                ],
                "hotelID": 105984,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.648848470520065",
                    "longitude": "-105.24184048175812",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Av de las Garzas s/n, Zona Hotelera Norte",
                    "countryCode": "MX"
                },
                "name": "Krystal Grand Puerto Vallarta All Inclusive",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Sea Fire",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Catrina",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Le Délice",
                        "type": "Restaurante"
                    },
                    {
                        "name": "O West",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "La Bonita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "The Beach",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Lounge",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1012682,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al resort",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1012683,
                        "kidsFreeTo": 5,
                        "name": "Junior suite doble con balcón",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ur7KEHd0ufwIyCuvRGjD6UEAwjs=/720x480/00/20/43/00204355.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ur7KEHd0ufwIyCuvRGjD6UEAwjs=/720x480/00/20/43/00204355.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1012684,
                        "kidsFreeTo": 5,
                        "name": "Junior suite doble con jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8edxaa7-5Y3OidgxgmIE-VT2Tts=/720x480/00/20/44/00204487.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8edxaa7-5Y3OidgxgmIE-VT2Tts=/720x480/00/20/44/00204487.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1013221,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/EH37iydSmn15hsbeErQoLKo_RtM=/720x480/00/20/44/00204485.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/EH37iydSmn15hsbeErQoLKo_RtM=/720x480/00/20/44/00204485.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1013222,
                        "kidsFreeTo": 5,
                        "name": "De lujo doble vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/99OEU0wqHgHrz6SFBJ8UA0owPHU=/720x480/00/20/44/00204484.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/99OEU0wqHgHrz6SFBJ8UA0owPHU=/720x480/00/20/44/00204484.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6744224,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista al resort",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6744225,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/szJ3mer4yHqP5zoOD_cq0d8V8Yk=/720x480/00/20/44/00204483.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6744226,
                        "kidsFreeTo": 5,
                        "name": "De lujo king vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/99OEU0wqHgHrz6SFBJ8UA0owPHU=/720x480/00/20/44/00204484.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/99OEU0wqHgHrz6SFBJ8UA0owPHU=/720x480/00/20/44/00204484.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6744227,
                        "kidsFreeTo": 5,
                        "name": "Junior suite king con balcón",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/izVxR5wowLgEhbk0SbVqLAk8TYU=/720x480/05/03/45/05034580.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/izVxR5wowLgEhbk0SbVqLAk8TYU=/720x480/05/03/45/05034580.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia y bañera",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Jacuzzi",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6744228,
                        "kidsFreeTo": 5,
                        "name": "Junior suite king con jacuzzi",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/8edxaa7-5Y3OidgxgmIE-VT2Tts=/720x480/00/20/44/00204487.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/8edxaa7-5Y3OidgxgmIE-VT2Tts=/720x480/00/20/44/00204487.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Ducha de mano",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6865829,
                        "kidsFreeTo": 0,
                        "name": "Junior suite Hacienda doble",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uRzLFEvvt-j6n37Ld6l1QEGf5pw=/720x480/05/03/45/05034579.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uRzLFEvvt-j6n37Ld6l1QEGf5pw=/720x480/05/03/45/05034579.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha tipo lluvia",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Ducha de mano",
                            "Minibar",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Teléfono",
                            "TV de 50 pulgadas"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6865830,
                        "kidsFreeTo": 0,
                        "name": "Junior suite Hacienda king",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uRzLFEvvt-j6n37Ld6l1QEGf5pw=/720x480/05/03/45/05034579.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uRzLFEvvt-j6n37Ld6l1QEGf5pw=/720x480/05/03/45/05034579.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Disability-friendly bathroom",
                            "Hairdryer",
                            "Housekeeping",
                            "Internet access",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6919839,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Resort View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Hairdryer",
                            "Housekeeping",
                            "Ironing set",
                            "Living room",
                            "Make-up mirror",
                            "Minibar",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6919840,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Disability-friendly bathroom",
                            "Double bed",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Ironing set",
                            "King-size bed 150-183 width",
                            "Living room",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Safe",
                            "Satellite / cable TV",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6919841,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Bathrobes",
                            "Hairdryer",
                            "Living room",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6919853,
                        "kidsFreeTo": 0,
                        "name": "Double Partial Ocean View Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Disability-friendly bathroom",
                            "Double bed",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Ironing set",
                            "King-size bed 150-183 width",
                            "Living room",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Safe",
                            "Satellite / cable TV",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 7118666,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe-Resort-View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Disability-friendly bathroom",
                            "Double bed",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Ironing set",
                            "King-size bed 150-183 width",
                            "Living room",
                            "Minibar",
                            "NO Disability-friendly bathroom",
                            "NO Smoking rooms",
                            "NO Wheelchair-accessible",
                            "Number of bedrooms",
                            "Safe",
                            "Satellite / cable TV",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 8431645,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe-Partial Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361263,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Resort View Double",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361264,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Resort View King",
                        "isActive": true,
                        "view": "Vistas al complejo turístico",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361265,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean View King",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361266,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Ocean view Double",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361267,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Ocean View King",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361268,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Ocean View Double",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361269,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Balcony King",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361270,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Balcony  Double",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361271,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Jacuzzi  Double",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361272,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Jacuzzi King",
                        "isActive": true,
                        "view": "Vista parcial al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361273,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Hacienda King",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Alarma antiincendios visual",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación (cabe un ordenador portátil)",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Cargadores o adaptadores eléctricos",
                            "Cepillo y pasta de dientes disponibles previa solicitud",
                            "Champú",
                            "Chef",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Entrada con dispositivo móvil",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Guías o recomendaciones",
                            "Jabón",
                            "Libros infantiles",
                            "Limpieza de habitaciones diaria",
                            "Mapas locales",
                            "Material para dibujar o colorear",
                            "Minibar (surtido, artículos gratis)",
                            "Mosquiteras",
                            "No fumadores",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Trona infantil",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zapatillas",
                            "Zapatillas infantiles"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16361274,
                        "kidsFreeTo": 0,
                        "name": "Jr. Suite Hacienda Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cajero automático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación las 24 horas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Valet parking",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 3.8,
                    "totalSurveys": 178,
                    "valuesAverage": [
                        4.5,
                        4.6
                    ]
                },
                "title": "Hotel todo incluido frente al mar en la zona norte de Puerto Vallarta",
                "uri": "krystal-altitude-vallarta-all-inclusive",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "De lujo"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {},
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye todos los alimentos y bebidas; cuenta con restaurante tipo buffet, 3 restaurantes de especialidades, snack, deli café y 4 bares."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Incluye actividades acuáticas no motorizadas como kayak."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen tenis y minigolf."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    }
                ],
                "description": "Sunscape Puerto Vallarta Resort and Spa es un hotel todo incluido que posee una piscina con vista al mar y gimnasio. El programa Unlimited Fun® que brinda el hotel permite disfrutar alimentos y bebidas las 24 horas, así como actividades y espectáculos. Las habitaciones tienen vista al mar o al jardín y algunas ofrecen amenidades especiales para niños. Las habitaciones Sun Club tienen amenidades especiales como batas y pantuflas, servicio a la habitación de 07:00 a 11:00 hrs, check in y check out privado y acceso a la sala lounge.\r\n\r\nEl hotel se localiza frente al mar en la Zona Hotelera Norte de Puerto Vallarta, a 5 kilómetros del Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR). A 4 kilómetros se encuentra el Malecón de Puerto Vallarta, el delfinario Vallarta Adventures y la Marina Vallarta, así como la Plaza de Armas que está a 5 kilómetros.\r\n\r\n***Toda reservación de 10 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/5783f659518c42c409e3eaa19efe9641f5d7e832a1f3d8b8dd6705923f3c1b7d_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/e532b83209757c84da3d9c83b71defc7611f04e75d3039687ca4ad21e154f0f1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/8da9fbd6486a4e3b69eaf732cd98998decd6ee3c56b7996291a0186bd5ea94ac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/0ee9403123c50b242d9cf25d79b7b4fd284492cd835bcb15fe79b8ffe9f5b110.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/b77e7722d225ad78db2a3b919a20082b3fb7515bbb64c59eec13e07e5b112807.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/1d94f1917e3bacff8156989ec892836888cc0e34d8bec4ab55c10ee89c4b52a6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/8c6da276b948d1d5f257c00206d337a0e3583086df34b6e652438ee7ee8b5e91.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/2e0ed890e1779504e5fd57333ce81bb1ca7626063d98098513b90b8cf554acdb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/dabd4ac42277241fc089515d2a91531a0fc95044d6bf670db82fc45a4fa8739b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/b64eb19d8f47a646ae9754593eaa629d06b55e40fadee77e351ea714bd3281f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/b6fa3694c2a5807dae4d9c2cd8ee9140d136ab6d4aeaff81696e3f3f5a455d0a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/eb0db07977657e4ee321bc6d8cb950229331c5e60074235db4fbccadbd777e95.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/36a9e5d48861578a94ed9ec0787405c0d7df910227c476231d30325452dbf4fb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/300debab06c1320cce02ad218cdc62e935db49a9c6ed51a9475a119b9766753e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/eb14d623a95a0b879571b91c1ecee8e19e64a781a363e9365b702d63dc1f7a21.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/f1feeca1f872f7d2931aa171ae8e239cea371de2722a6d6b850a171b061d3cf7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/76d4e42042b9f6542e8e58cc58b9d0aa3ee2fead8b3864cf10692619aba728b9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/568fff9427f94307621d528fc1dd6e029bc5490b710a9b0c2bce95075c7659a6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/6c322cdd538025f199e23a1f6d990e6d90a827fec3f080c0b896e42d9d3d9200.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/6b8e7c730957e8bc68961398420abb7942455196cf25930cf09f2485e8e8b314.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/1e5ba261073350695fd4566ba0d005cb5f436537fdd8df180e4b694b4f4f2437.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/8b5490b69d621cdb3772048534415b90c4147a834a54590953c74c3d9064da72.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/e2fb39bd8375fe4925c4bde531912a3400ccb0c5a25dcb589fe5645024c2bcc8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/368f38d3d82a370be5e0d477d1ad80c54487210f5b20fb1484a1dfc9da62e6c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/85b49ea4704d90c99708107296931d2ee2ca4765a758b587071e922fb5145297.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/aaf0ceeb4c0b5a13897825efa42686b395ff60d5ecde1f96d678704cdae2f070.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/1fd6f64bc58e60c585e6032e11271e1799614f3d56d4db0d117064dfe6b48d8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/1318a901ba7675938a4a691e7a7ebc8ab8b1ec6e4c059b03c2e5cf5d69cdacc7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/4ee08418d8057cc19e24f68b4e193baf13a83384a424185e7e58d6e26821f0b3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/4fc6093c1c4f9fd535006900d72dede8235defc20d7eb91edf293ecf30d2ad25.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/a583d53f2a62b396a16c3b4233814d317b7ae03221522fe53b9f051b610aac02.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/5f3e4fa0b98728369b36774d711146555bfe0bc623c64c4cbc226515557e349f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/982eab7c8f6d717ee3fde2f2570dcbd8f88d3d97554fcee80041af3fe8e9cf6c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/7fff0e25f452830cc17d3145be415c6df57143a2159d2ebbf46668848af9b64f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/61a14c0e37953eb67898234d90d3f1bcef24811806da230a2815471a4c7956e9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/b30111cd48b27b462bcf3250edddf0cc8ee694f7bb2ecbcef014fc582207d507.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/b64b2322c7e8a22f530b7bd263bb72c9ad579fedd6f6c27b457a67a359bcaece.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/92a255767ad6a01a4b505af9306908b956632e19f0b8741f3e522ed8e46aaa9a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/8098ce76097287f46ce49dec8aef138efede739e0df9c84a63633d901e53554f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/fd9a4a36b6a558add386231f7a7610a3bda26549acc24c5ca01db00032297c9a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/28c0d4748cf06202ae1d2056521d042b97f5efa24a1cda63070d652c9b6b8959.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/7653036057e5e49e4e10b6a258d032b3deb7b5b28db5ef80ed745ff758cea386.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/e09d94592c512bb06bf57496e435450bf88816ca440ff9262db361263fcd22f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/e2ebe45e05d86055e7e2c9c977c3d1cabc41fbd1e7cebae9ca7cc627779c5c3b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/238016/5577dd316ac9c185e3aa11cca7bca3de4c4ae4a1ee4edf84c2f5dc25a3c7ccb1.png"
                    }
                ],
                "hotelID": 238016,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.642478206227014",
                    "longitude": "-105.23880958557129",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "Francisco Medina Ascencio km 3.5 s/n",
                    "countryCode": "MX"
                },
                "name": "Sunscape Puerto Vallarta Resort & Spa",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Da Mario",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Tiki Tacos",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Sea Side",
                        "type": "Restaurante"
                    },
                    {
                        "name": "World Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255600,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255601,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255602,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255603,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255604,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255605,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255607,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255608,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255609,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255610,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255611,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255613,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255614,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255615,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255616,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255617,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255618,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255620,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255621,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255623,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255624,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255625,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255626,
                        "kidsFreeTo": 0,
                        "name": "Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255627,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255628,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255629,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255630,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255631,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255632,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255633,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255634,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255635,
                        "kidsFreeTo": 0,
                        "name": "Club Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255636,
                        "kidsFreeTo": 0,
                        "name": "Club Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255637,
                        "kidsFreeTo": 0,
                        "name": "Club Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255638,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255639,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255640,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255641,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255642,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255644,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255645,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 14255646,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 17177199,
                        "kidsFreeTo": 0,
                        "name": "-",
                        "isActive": true,
                        "view": null,
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680569,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680569,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680570,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680570,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680573,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7680573,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681594,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681594,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681595,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681595,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681609,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7681609,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Juegos de video",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 1 Litera",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297781,
                        "kidsFreeTo": 2,
                        "name": "Familiar de lujo para niños",
                        "isActive": true,
                        "view": "Exterior",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1ih1AD7sLG4SRDAjhUsqwBn92eo=/720x480/11/98/07/11980784.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1ih1AD7sLG4SRDAjhUsqwBn92eo=/720x480/11/98/07/11980784.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297783,
                        "kidsFreeTo": 2,
                        "name": "Junior suite de lujo doble vista a la bahía",
                        "isActive": true,
                        "view": "Bahía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1Ayvl-ekSVpaup6APcK7vlnKlcI=/720x480/11/48/06/11480602.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1Ayvl-ekSVpaup6APcK7vlnKlcI=/720x480/11/48/06/11480602.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297784,
                        "kidsFreeTo": 2,
                        "name": "De lujo doble vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/cPN9A450x8JlCtmLpppx3hCTAUQ=/720x480/11/48/06/11480688.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/cPN9A450x8JlCtmLpppx3hCTAUQ=/720x480/11/48/06/11480688.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297786,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista parcial al mar",
                        "isActive": true,
                        "view": "Parcial al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/jOOB-8imuSv9cPEKTpPD8j_8eqU=/720x480/11/48/08/11480886.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/jOOB-8imuSv9cPEKTpPD8j_8eqU=/720x480/11/48/08/11480886.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297787,
                        "kidsFreeTo": 2,
                        "name": "De lujo doble vista al resort",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kKt1xgYvknSmdGdAhVnFM-fBwp8=/720x480/11/48/09/11480969.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kKt1xgYvknSmdGdAhVnFM-fBwp8=/720x480/11/48/09/11480969.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Control individual del clima",
                            "Mesa y sillas",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297788,
                        "kidsFreeTo": 0,
                        "name": "De lujo king vista al resort",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1ih1AD7sLG4SRDAjhUsqwBn92eo=/720x480/11/98/07/11980784.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1ih1AD7sLG4SRDAjhUsqwBn92eo=/720x480/11/98/07/11980784.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 balcones",
                            "Acceso al salón ejecutivo",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canapés",
                            "Control individual del clima",
                            "Desayuno continental incluido",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297790,
                        "kidsFreeTo": 0,
                        "name": "Sun Club suite de lujo romántica frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/nYV1xY2_knyp2HMRe5MYm_wCPP4=/720x480/11/48/10/11481066.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/nYV1xY2_knyp2HMRe5MYm_wCPP4=/720x480/11/48/10/11481066.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Área de descanso con sofá cama",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canapés",
                            "Control individual del clima",
                            "Desayuno continental incluido",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297791,
                        "kidsFreeTo": 2,
                        "name": "Sun Club junior suite vista a la bahía",
                        "isActive": true,
                        "view": "Bahía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7Ed4o0jJg3zBexUEgCsxt95SYCg=/720x480/11/48/11/11481168.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7Ed4o0jJg3zBexUEgCsxt95SYCg=/720x480/11/48/11/11481168.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canapés",
                            "Control individual del clima",
                            "Desayuno continental incluido",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297794,
                        "kidsFreeTo": 0,
                        "name": "Sun Club suite romántica vista a la bahía",
                        "isActive": true,
                        "view": "Bahía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uokV2fyZCt8GSdq3bcihtlJofDE=/720x480/11/48/04/11480429.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uokV2fyZCt8GSdq3bcihtlJofDE=/720x480/11/48/04/11480429.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso al salón ejecutivo",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Canapés",
                            "Control individual del clima",
                            "Desayuno continental incluido",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Terraza",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8297795,
                        "kidsFreeTo": 0,
                        "name": "Sun Club suite romántica con terraza vista a la bahía",
                        "isActive": true,
                        "view": "Bahía",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uokV2fyZCt8GSdq3bcihtlJofDE=/720x480/11/48/04/11480429.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uokV2fyZCt8GSdq3bcihtlJofDE=/720x480/11/48/04/11480429.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089202,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089204,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089206,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089207,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089208,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089209,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089210,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089212,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089213,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089214,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089215,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089216,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089217,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089218,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089219,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089220,
                        "kidsFreeTo": 0,
                        "name": "Suite Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089221,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089222,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089223,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089224,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089226,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089228,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089229,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089230,
                        "kidsFreeTo": 0,
                        "name": "Individual Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089231,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Detector de humos",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089232,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089233,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089234,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089235,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089236,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089237,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089238,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089239,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089240,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089241,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089242,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089243,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089244,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089245,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089246,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Escritorio",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089247,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089249,
                        "kidsFreeTo": 0,
                        "name": "Suite Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089250,
                        "kidsFreeTo": 0,
                        "name": "Habitación Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089251,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089252,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089253,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089254,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089255,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089256,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089257,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089260,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089261,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089263,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089264,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089265,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089266,
                        "kidsFreeTo": 0,
                        "name": "Habitación Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Albornoz",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Reproductor de DVD's",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089267,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089268,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089269,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Cuarto De Baño Compartido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Video consola",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089270,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089271,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089272,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16089273,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales o 1 King",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18814522,
                        "kidsFreeTo": 2,
                        "name": "Oferta del día",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ZSyLsARzT-6RASL9LeEoN03wEFw=/720x480/02/11/01/02110131.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ZSyLsARzT-6RASL9LeEoN03wEFw=/720x480/02/11/01/02110131.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359006,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359011,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359015,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359018,
                        "kidsFreeTo": 0,
                        "name": "Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359020,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359025,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Parciales Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359026,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359027,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359030,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359033,
                        "kidsFreeTo": 0,
                        "name": "Doble Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359037,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359042,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359044,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359048,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359051,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359054,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359056,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359059,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359061,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359062,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359063,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359064,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359066,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359068,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359072,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359076,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359079,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Capacidad 4",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359081,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359085,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359088,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359090,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359093,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359095,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359099,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359105,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359108,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359113,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359119,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359124,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359126,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359130,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359133,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359137,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359139,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359144,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359147,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359151,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359156,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359159,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359163,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359168,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359173,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359181,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359188,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359196,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359201,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359209,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359215,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359219,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Parciales Al Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359222,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359225,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359227,
                        "kidsFreeTo": 0,
                        "name": "Individual Club Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359230,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Parciales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359233,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359235,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359237,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359241,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359243,
                        "kidsFreeTo": 0,
                        "name": "Individual Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359247,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359250,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359252,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Bahía",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 Número de dormitorios",
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Detector de humos",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Reproductor de CD's ",
                            "Reproductor de DVD's",
                            "Sala de estar",
                            "Secador",
                            "Servicio de buenas noches",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "1 Sofá-cama",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359253,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359254,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359255,
                        "kidsFreeTo": 0,
                        "name": "Suite Club Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359257,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359258,
                        "kidsFreeTo": 0,
                        "name": "Suite Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359260,
                        "kidsFreeTo": 0,
                        "name": "Suite Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359262,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359263,
                        "kidsFreeTo": 0,
                        "name": "Tienda Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Minibar",
                            "Reloj despertador",
                            "Secador",
                            "Servicio despertador",
                            "Televisión",
                            "TV por cable"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20359265,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Espectáculos nocturnos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Minisúper",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Programa de actividades diario",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de masajes",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Teatro",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tiendas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4.1,
                    "totalSurveys": 212,
                    "valuesAverage": [
                        4,
                        4.1,
                        4.4
                    ]
                },
                "title": "Hotel frente al mar ideal para familias",
                "uri": "sunscape-puerto-vallarta-resort-spa",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        }
                    ],
                    "I": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores de 10:00 a 17:00 hrs."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 4 y 12 años, supervisado por adultos. Abierto diariamente de 10:00 a 17:00 hrs. Ten en cuenta que las actividades para niños se basan en el número de niños que hay en el hotel en ese momento, no en un horario regular establecido."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye shows y fiestas nocturnos."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen cancha de tenis y voleibol en la playa."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno bufet, almuerzo y cena diario en el restaurante El Huerto. Aperitivos diarios de 12:00 a 17:00 hrs. Bebidas nacionales de 10:00 a 23:30 hrs (horarios sujetos a cambios)."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Los clientes de este hotel usan sólo el restaurante El Huerto. La elección del restaurante a la carta Caruso está limitada, se requiere reservación y aplica código de vestir. Los huéspedes tienen acceso a las instalaciones del club de playa del complejo hotelero, pero no a la sección Grand. El estacionamiento es exclusivo para automóviles y no se permite el acceso a otros vehículos como autobuses, remolques, buggies, motos, razers, cuatrimotos, etc. Por cada 3 noches de estancia se brindará un acceso a cena de especialidad (sujeto a disponibilidad y reservación)."
                    }
                ],
                "description": "Plaza Pelícanos Club Beach Resort es un hotel todo incluido en Puerto Vallarta, a 3 kilómetros del centro de la ciudad donde se encuentra la famosa escultura del Caballito, la Plaza de Armas, la iglesia de Nuestra Señora de Guadalupe y el malecón, zona de bares y restaurantes. Otros sitios de interés, como la marina, está a 4 kilómetros de distancia, el Centro Internacional de Convenciones a 8 kilómetros, mientras que el Aeropuerto Internacional Gustavo Díaz Ordaz (PVR) está a 5 kilómetros.\r\n\r\nLas 200 habitaciones del hotel Plaza Pelicanos Club Beach Resort cuentan con una decoración casual mexicana. Todas las habitaciones cuentan con amenidades como aire acondicionado, televisión por cable, baño privado con ducha y secadora de pelo y plancha a solicitud. Las habitaciones conectadas están sujetas a disponibilidad.\r\n\r\nPlaza Pelicanos Club Beach Resort ofrece servicio de concierge, programa de actividades para niños de 4 a 12 años, voleibol y tenis. Este hotel tiene una piscina climatizada y un club de playa donde se encuentra otra piscina. Además, también cuenta con variedad de restaurantes, bares y un café. Para comodidad, este hotel en playa Las Glorias ofrece servicio de ama de llaves, de lavandería, estacionamiento y acepta tarjetas de crédito.\r\n\r\n***Las reservas de 5 habitaciones o más se considerarán como un grupo. En caso de reservas de grupo, el hotel se pondrá en contacto con el huésped y/o la agencia para gestionar las condiciones especiales de depósito y cancelación para el grupo. Si el hotel no puede comunicarse con el huésped y/o la agencia y el depósito no se realiza bajo las condiciones del grupo, las reservas se cancelarán automáticamente. Para obtener más información, póngase en contacto con el establecimiento.\r\n\r\n***Se requiere identificación oficial (INE) o pasaporte del titular para realizar el proceso de check-in.\r\n\r\n***El servicio a la habitación tiene un horario de 7:00 a 16:00 hrs con cargo adicional del 17% del total del pedido. NO se cuenta con servicio a la habitación de 16:01 a 6:59 hrs.\r\n\r\n***El estacionamiento es exclusivo para automóviles. No se permite el acceso a otros vehículos como autobuses, remolques, buggies, motos, razers, cuatrimotos, etc.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/b55d65f7b6d27056497d59ffd727a7fba00c42118001a3da8ec773db346fe147_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/26675cf407ff8d40365ac23fe7455fc4588134979feda1920d0d94576892b1c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/4d3a92921c5ff5c16cf6063bc4bb3bef254cf24db54ec90af106127e0bda9c8b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/2ae1352f8e568764da802a3efdb3163fb77ee775fc2f793f8923d867bf311149.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/5818530d5bb58d32592129c76e4ac72eda3893ef7e9ef2fbb1eeeef59526dc6a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/988fe6101d81bb10542dc923b60397ae4b8fc140fe1c281c7cac984d4a568fc5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/d83603b4b81e943f227bc8310fd36f19d907a2c2b98d774c717e68aee4f44fd2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/95846c5b95e3ca913501cc195190d5976007c733170674fb5bcf50bb4b42bafc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite",
                        "cloudUri": "https://img.cdnpth.com/media/100474/25b9d09923055b18a96b7cd0ee7b357fc41be0bc0c24a95040bacfd2a5b191cb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble Superior",
                        "cloudUri": "https://img.cdnpth.com/media/100474/a0e80ebd3badfc6a2248bcec86504775f7012258cf0483e5c3e7552a114989e3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/8117011844a41065a127a1ce598ddce6ad4a0c379a701de3a9a2219bfcc7b725.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/80380da7d9a5572e05e3d7fb9b5d90ee625886279ed7adf71974cfb8f73c35a7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/57680848d840a833b028b8c367378b3256f3d2ba627d1bb08912c97377614f63.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/956026ce620fd88b9b3766d6f7bdb0ad67f149afa888011ef34916f32a2a25d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/7dd5aade4be9db5fc275624d056b89e68d50947c23e0b89d110e7bb75d275d13.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/143c6ecfe702e7d2deb7066e427fb3177f9502f34e558633d1f09b90329a282b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/925d2dfaf2c98a4e4d454883ac9a3f4b718a878616083ab89ac625151c4925be.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/0fd7ee60ee7114db45c81866891a85873d9c2d9d1666fd25c0b1d76323571c5c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/13d2ec0bfc453920559bdb4e0e8e7babe04a06b9a0b1c0923ab285a77a046c89.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/2c82d161a346229c875ea38c553e85bb6f0b58090107e99c75ade0d6461ebfba.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/c6ee14824454caeb6a9f7ffac5585c58e9cab9b387dff89d36c7a5d7a74834b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/acb1a89397aba9e92ae82fc4c3349298940fdc25900c8488058dd4b70e5eab78.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/b46f4214076181e1cf16b419cde64404f4ed76e4865850a818f8811ce873d172.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/b72a2af920932817b2852603f2b9af8319d585d2f56a3ba1bca99b2da8bf31fa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/4ca815909932ebdb9a251a97ab17985509eb315ed022e4eb83f60ebd81a88869.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/b529191acbc867367acc89b10fcbe3e75091075252b63799c429ecef1bcc7f50.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/3a6662925a6a45541cc42b7769930bc48fd6ad8edf21cd6a05e6ce90ef5fd4d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/3139dddf38d08e2d5cfcf0edf526d2381a087288a67cfa5b0382b49a846e4703.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/3932a2d2dd289ed83b06ae52327cd69db8d882571eb6e22fa0123d9138a71a2e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/acc72bf59dc81d5bded9fc5d96b00cf1616e1645e72fe43140be6e68f8427479.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100474/0bd3cc0f421ad5c9bd51a66260791ba8e3eea0c0f9ecfbe521a3fa21a072cccc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/4550a84ff93343bf6af3ebe756b56fb9552f4e75296eb51d5b96fa13fa9e84b6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/a879278ba2be57ad24a642d26330b228cb49778603268394e2710d7048316367.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/b397e47889d015687a058be457e1c03dd0be13f8b1c3819b591b8a7ea917227e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/d0fccfeec5d6fcc2a2f2bede0dc7aac7c09ffc567ef69e4682976b060157b1c8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/9726ccd3e9b4118dd0856a2fe36cfa8f1817dff353a37989b4991158ebeb029c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/3a9e55aa9817856d58e71815f54bf929957cb9253348a6a9cae278a595c87eb1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/cafde3abfabdbaa0d1235983e07bbb78edc6220a97c49e3ec0c8678925f8ca08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Doble",
                        "cloudUri": "https://img.cdnpth.com/media/100474/65d264d37d8e504c4d86c51d965d345532d0f19685cb57d98fb1bdeff582471e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/1ad794b05f462689d89efd61fd3ab1df6674e2f8401cf602af312aba787ea1f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/26b12d87f068c40f0e68775ec578c769f78b945b66a889a83e2620711f5ec398.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/d694beafd835d19990789a4277b32d2a4302f01143c4b2c34c2f23dd5deab17c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/7c9023c09d38241db824322bf55ec1c5f7e5cea53c129a94a3231426ed760a3d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/57547d910cda225213f7ef41e38e923528a8f2f7599fc80968eb44dac7db5deb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación con cama extragrande.",
                        "cloudUri": "https://img.cdnpth.com/media/100474/a54b0c0349d035eaf30d54f616f2152544c8fe3905e30c8858ab4b2559da2f94.png"
                    }
                ],
                "hotelID": 100474,
                "importantFacilities": [
                    "Alto estándar de limpieza"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.636920949253145",
                    "longitude": "-105.2328872680664",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Diego Rivera #120 , Playa Las Glorias",
                    "countryCode": "MX"
                },
                "name": "Plaza Pelícanos Club Beach Resort",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Caruso",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar Colibrí",
                        "type": "Bar"
                    },
                    {
                        "name": "El Huerto",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Pizzería",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Bar Gaviotas",
                        "type": "Bar"
                    },
                    {
                        "name": "Sorbo de Café",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Tequilas Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553420,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553435,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553450,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553464,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553478,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553491,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553504,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553516,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553529,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553542,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553555,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553568,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553580,
                        "kidsFreeTo": 0,
                        "name": "Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553592,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553605,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553618,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553632,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553647,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553662,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553679,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553695,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553712,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553728,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553745,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553762,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553779,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553798,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553816,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553835,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553854,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553873,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553891,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553909,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553927,
                        "kidsFreeTo": 0,
                        "name": "City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553946,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553966,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553988,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554008,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554028,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554048,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554068,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554088,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554108,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554130,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554150,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554171,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554193,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554215,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554237,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554259,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554282,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554304,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554326,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554347,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554369,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554390,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554413,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554438,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554462,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554485,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554508,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554530,
                        "kidsFreeTo": 0,
                        "name": "Accessibility",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554552,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554574,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554596,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554618,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554641,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554664,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554687,
                        "kidsFreeTo": 0,
                        "name": "Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554709,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554731,
                        "kidsFreeTo": 0,
                        "name": "Superior Accessibility",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554752,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554774,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554797,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554820,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554843,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554867,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554890,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554915,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554939,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554963,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18554987,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555011,
                        "kidsFreeTo": 0,
                        "name": "Superior Partial Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555035,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555059,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555083,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555107,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555130,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555156,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555182,
                        "kidsFreeTo": 0,
                        "name": "Suite Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555208,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555234,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555261,
                        "kidsFreeTo": 0,
                        "name": "Superior Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555288,
                        "kidsFreeTo": 0,
                        "name": "King Or 2 Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555316,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555342,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555368,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555392,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555417,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18555441,
                        "kidsFreeTo": 0,
                        "name": "Apartment City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676636,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676646,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676657,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676666,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676675,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676684,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676693,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676702,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676711,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676720,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676729,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676738,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676747,
                        "kidsFreeTo": 0,
                        "name": "Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676756,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676765,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676775,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676784,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676793,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676803,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676814,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676825,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676837,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676849,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676861,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676873,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676884,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18676895,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Plancha a solicitud",
                            "Secadora de cabello a solicitud",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000626,
                        "kidsFreeTo": 5,
                        "name": "Estándar 2 dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/ktBHIrqVIK7kcCAZpPK7jO9iIdI=/720x480/12/84/01/12840129.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/ktBHIrqVIK7kcCAZpPK7jO9iIdI=/720x480/12/84/01/12840129.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Plancha a solicitud",
                            "Secadora de cabello a solicitud",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1001730,
                        "kidsFreeTo": 5,
                        "name": "Estándar king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/CXRAfjNKXjIm66tRtkSYLZ71cWo=/720x480/12/84/01/12840125.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/CXRAfjNKXjIm66tRtkSYLZ71cWo=/720x480/12/84/01/12840125.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Baño privado",
                            "Cortinas opacas",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953426,
                        "kidsFreeTo": 0,
                        "name": "Suite, 1 habitación",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6078996,
                        "kidsFreeTo": 0,
                        "name": "Superior Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6078997,
                        "kidsFreeTo": 0,
                        "name": "Superior King Size Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Baño privado",
                            "Cortinas opacas",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6104459,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 1 cama de matrimonio grande",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Baño privado",
                            "Cortinas opacas",
                            "Ducha adaptada",
                            "Guardería en habitación (de pago)",
                            "Guía de restaurantes",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No hay cunas",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Solo ducha",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6104462,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar, 2 camas dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Caja de seguridad",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV LCD de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6129058,
                        "kidsFreeTo": 5,
                        "name": "Suite de 1 dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-7qyvEyUBYGpKqBWTMdZ969cWp0=/720x480/12/84/01/12840126.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-7qyvEyUBYGpKqBWTMdZ969cWp0=/720x480/12/84/01/12840126.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Terraza",
                            "TV LCD de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6129063,
                        "kidsFreeTo": 5,
                        "name": "Superior king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/92Y9fFevTE9OvldcFw7LpFGqlMk=/720x480/12/84/01/12840128.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/92Y9fFevTE9OvldcFw7LpFGqlMk=/720x480/12/84/01/12840128.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Botella de agua",
                            "Cafetera",
                            "Caja de seguridad",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Terraza",
                            "TV LCD de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6129064,
                        "kidsFreeTo": 5,
                        "name": "Superior 2 dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0InNOELQgo1-oPgDlWwoRpCm1fs=/720x480/12/84/01/12840127.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0InNOELQgo1-oPgDlWwoRpCm1fs=/720x480/12/84/01/12840127.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080205,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080209,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080217,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080220,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080223,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080224,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Vistas Laterales Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080225,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080227,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080230,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080232,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080234,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080235,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080240,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080242,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080243,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080244,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080245,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama doble de 131-150 de ancho",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080247,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080248,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080251,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080252,
                        "kidsFreeTo": 0,
                        "name": "Suite One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080253,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080254,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080258,
                        "kidsFreeTo": 0,
                        "name": "Twin Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cot on demand",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16080259,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16554444,
                        "kidsFreeTo": 0,
                        "name": "Room Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723106,
                        "kidsFreeTo": 0,
                        "name": "Single Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723107,
                        "kidsFreeTo": 0,
                        "name": "Triple Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723108,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723109,
                        "kidsFreeTo": 0,
                        "name": "Single Capacity 1 One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723110,
                        "kidsFreeTo": 0,
                        "name": "Single King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723111,
                        "kidsFreeTo": 0,
                        "name": "Double Capacity 2 One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723112,
                        "kidsFreeTo": 0,
                        "name": "Triple Capacity 3 One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723113,
                        "kidsFreeTo": 0,
                        "name": "Single Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 16723114,
                        "kidsFreeTo": 0,
                        "name": "Triple Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219338,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cot on demand",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Living room",
                            "Number of bedrooms",
                            "Private Beach Area",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219342,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219344,
                        "kidsFreeTo": 0,
                        "name": "Room Run Of House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219346,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219351,
                        "kidsFreeTo": 0,
                        "name": "Double Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219354,
                        "kidsFreeTo": 0,
                        "name": "Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219357,
                        "kidsFreeTo": 0,
                        "name": "Apartment Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219360,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17219363,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18326754,
                        "kidsFreeTo": 0,
                        "name": "Room Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532495,
                        "kidsFreeTo": 0,
                        "name": "Triple Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532496,
                        "kidsFreeTo": 0,
                        "name": "Double One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18551991,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552008,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552024,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552040,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552057,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552073,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552089,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552105,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552121,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552137,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552153,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552167,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552181,
                        "kidsFreeTo": 0,
                        "name": "Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552196,
                        "kidsFreeTo": 0,
                        "name": "Double Room Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552211,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552224,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552237,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552250,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552263,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552275,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552287,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552301,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552314,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552327,
                        "kidsFreeTo": 0,
                        "name": "Superior For Non-Smokers",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552339,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552352,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552365,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552378,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552392,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552406,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552421,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552436,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552450,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552465,
                        "kidsFreeTo": 0,
                        "name": "City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552478,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552493,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552508,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552524,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552539,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Queen Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552554,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552568,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552583,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552599,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552614,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552629,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552643,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552657,
                        "kidsFreeTo": 0,
                        "name": "Shared Bathroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552671,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552685,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552699,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552713,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552727,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552741,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552755,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552769,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552783,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552798,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552814,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552831,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552847,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552863,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552879,
                        "kidsFreeTo": 0,
                        "name": "Accessibility",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552895,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552911,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552927,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552943,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552959,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552975,
                        "kidsFreeTo": 0,
                        "name": "Resort View",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18552991,
                        "kidsFreeTo": 0,
                        "name": "Double Room City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553007,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553023,
                        "kidsFreeTo": 0,
                        "name": "Superior Accessibility",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553039,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553054,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553069,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553083,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553096,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553108,
                        "kidsFreeTo": 0,
                        "name": "Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553120,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553133,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553146,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553159,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553171,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553182,
                        "kidsFreeTo": 0,
                        "name": "Superior Partial Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553193,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553205,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553218,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553232,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553246,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553260,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553272,
                        "kidsFreeTo": 0,
                        "name": "Suite Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553285,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553297,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553309,
                        "kidsFreeTo": 0,
                        "name": "Superior Mountain View",
                        "isActive": true,
                        "view": "Montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553322,
                        "kidsFreeTo": 0,
                        "name": "King Or 2 Double",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553335,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553348,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553361,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553373,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553385,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18553399,
                        "kidsFreeTo": 0,
                        "name": "Apartment City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18646028,
                        "kidsFreeTo": 0,
                        "name": "Suite Executive",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18646029,
                        "kidsFreeTo": 0,
                        "name": "Suite Presidential",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18646030,
                        "kidsFreeTo": 0,
                        "name": "Twin Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18886723,
                        "kidsFreeTo": 0,
                        "name": "Double Single Use Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18886725,
                        "kidsFreeTo": 0,
                        "name": "Room Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350498,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350505,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350512,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350517,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350522,
                        "kidsFreeTo": 0,
                        "name": "Habitación Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350527,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350534,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350541,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350548,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Complejo",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350557,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 20350566,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Montaña",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico en lobby y áreas comunes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Piscina exterior climatizada",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.5,
                    "totalSurveys": 921,
                    "valuesAverage": [
                        4.3
                    ]
                },
                "title": "Hotel todo incluido con club de playa en Puerto Vallarta",
                "uri": "plaza-pelicanos-club-beach-resort",
                "tags": [
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Restaurante bufet con noches temáticas; 3 restaurantes de especialidades a la carta: italiana, del mar y mexicana; servicio de snacks; cafetería; y 5 bares con bebidas ilimitadas."
                    },
                    {
                        "title": "Actividades",
                        "description": "Programa de actividades recreativas todos los días en el área de piscina y playa."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen voleibol y fútbol de playa."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Noches de música en vivo en el lobby bar."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye la habitación de tu elección con vista al mar y amenidades especiales."
                    },
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    }
                ],
                "description": "Grand Park Royal Puerto Vallarta es un hotel todo incluido ubicado frente a playa Las Gemelas, en el sur de la Zona Hotelera de Puerto Vallarta que promete una experiencia de lujo, confort y exclusividad. Es idóneo para familias y grupos de amigos ya que cuenta con 222 habitaciones equipadas con internet inalámbrico, televisión de pantalla plana con canales por cable, aire acondicionado, minibar, amenidades de baño exclusivas 100% orgánicas y caja de seguridad. Además, la propiedad cuenta con concierge y servicio a la habitación las 24 horas. \r\n\r\nGracias a su plan Todo Incluido se dispone de alimentos y bebidas ilimitadas en cualquiera de sus restaurantes y bares. El Café Sole ofrece bebidas y postres para todos los gustos. Así mismo, se puede disfrutar del programa de actividades recreativas para toda la familia en cualquiera de sus instalaciones como playa, piscina o solárium. Para los más pequeños se encuentra el club de niños que cuenta con un divertido parque acuático. En el hotel hay salones de eventos y se brindan servicios de spa y organización de bodas. \r\n\r\nA 3 kilómetros del hotel se encuentra la playa de Mismaloya, famosa por su oleaje tranquilo, ideal para la práctica de snorkel y buceo. El centro, el malecón de Puerto Vallarta, un corredor turístico con restaurantes, bares y tiendas, se localizan a 9 kilómetros. El Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR) se localiza a 19 kilómetros.\r\n\r\n***Park Royal Hotels and Resorts obtuvo el Distintivo ESR®.\r\n\r\n***Certificación Cristal International Standards por sus estándares de calidad, seguridad e higiene.\r\n\r\n***Compromiso Global Tourism Plastics Initiative para la disminución y/o eliminación de plásticos de un solo uso.\r\n\r\n***Para registrarte en el hotel, deberás presentar una identificación oficial de tu país, INE o pasaporte vigente. Para los menores de edad es necesario presentar acta de nacimiento, CURP o credencial de estudiante con foto.\r\n\r\n***El bar lounge Equinox es exclusivo para adultos, abierto de 08:00 a 19:00 hrs, que ofrece vista completa a la bahía, piscina techada, jacuzzi, camas bali, servicio de barra Premium y canapés durante el día. Las reservaciones con categorías de habitación Premier Ocean Front y Royal Deluxe Ocean Front tienen acceso ilimitado durante la estancia. En otras categorías de habitación costo adicional por persona, por día, a pagar directamente en la recepción.  \r\n\r\n***Toda reservación de 5 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva.\r\n\r\n***Park Royal Hotels and Resorts no acepta reservaciones “bloqueo” bajo el mismo nombre o bajo las mismas fechas que puedan reflejarse claramente como “bloqueo”. En caso de recibir cancelaciones de dichas reservaciones “bloqueo”, existirá la penalidad del 100% de la estancia en cualquier temporada.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/dc9bea43d0bddd93e613da17429214465d342a9f9f94e07cff606c7e5d925ca8_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/fce5c6bd5758a59b2744f35422bc99eba41be2e90a427f51e765b1b540196016.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/cb386bb47c9492a11c3d6580006492794b6739c26748ad75b04408d228477990.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/fdde947a917ea872d8b99b5710a17fb80ff3f137c2eae5c3eda36f8c2bee48d9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/b2098a0c20a57cc50399408b77ec9c29e391c5dbd1b69c507ab5309d0551f1f6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/4bca17a020c76b933f2674375f1b05d5cc89458772d933dab8ade71749fcdedd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/a75e27f3f227b111060d0dde2c51f513a678bf96ed5709dc2d696e5d11d4dcfe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/ca400c57b14a305a615377810fc3153393fadceb3e379dc1724b74b7c05287f9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/2764a901088cde67e23c6b1fee53032b67a6351ea5f53d1215b14f945cca4263.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/407f6698d8848188da99d08f98e8e5c925c4dc4622d8bdd1075813efff62c5f8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/e98e538e6eb433bbe22caf4bba1a035a6607e89e8334f98b0209d7ebbf8d8a5c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/c6b14d9ae3c56f7d6a967f56d2ee55cc0e9188a6afec19053d52efdf079fc885.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/a44e463f6e5273d18ff73c61562c57aaca0811e9e1b6b1d37a9cbcc583cb8848.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/2600b89edeb0b35090080380ecb39661f8f3c44f3dba4b3d9bf4e2a745fbb716.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/30e74873b0248363458284fe791e7a3a66eb63a17a66283ae7e1a566deca4e7e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/d0101a7bd59f3c8feec73594a43f222c781f349ef5383e2fbded65e0bbed18af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/80b8e6634c8dfd114715764547322b95ceff642a3e63a4fd61b7551c232a2057.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/77a0be3d177d6144627be4ceb8140ec9a63e66444510ed032b563f1f2a5eb630.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/8d7633ffa1db01f6c5b2f80557b70402893e48c9f4bfa3dcacafaee5016f6806.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/48840542d83157dbe1b80ec34cda7471b8f97f9ef5ceb9dd4d05b9443fea00ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/8ad5fed0f0c1b66621362101e98b53c8da560a9b0dd764f6e3cd1bd06e519008.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/bdb85aea805b35345c456e9e145df9e91fe2cd61e129a16d2d2ca54598d9f5aa.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/1d9e90bb0ce453680dfa86bb2c6c439acb14e2dde3b348d55437dd1efbdad504.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/4f6b34f2f21e2cc264bc01b1506b3ba0f8ebe65d071a054bd0eedd7b29ab73ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/32d4f5ee6c14c688353a35f18aea1ae9a3b6812fcf3d8e107d3bae0d63c36850.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/f053e033fdf060e0740ee8df2c59c01450b59369cc1004bbc1464450b1aee86c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/5cbe8ee2e4004d01065966771dc099cac132519e10f70f454815f179e15c648d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/0695192f84f2767169ec7d28bcee0e8ffced54ae110f8b09bc079a7fa8a69681.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/7aa80d2b7b0c7744559c66d5dd568bdf05a7814d275eb3f8e083b7038d0808c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/1c37a3ae47513cf3b4a02c35566c3ac272635e8fce3915758f33907556ff60f2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/cc12087b09e9c57603bd3520c7bf0dad478fdeb4b10499bf30f65681c78c153d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/69cdfc29465de2a430ad8a733512ccb9ea73ec450b2a8ce2c4f776b1b7dcc73b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/fafcaca786a8494db5752a9e599066d9d7975f81866f951638db4f33f1d51475.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/1701e1f922c6d4957f6772c8cc59321c1ee8513ce26a684b7e991ec50ae53c63.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/dc4664f2f56eb0ca7a51b730bca1bf77224dcda4d364f08e2a6345a108b9df93.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/6716f00e8815106433b63108ef8ee2240c0a6daebd8a885ffbedbd79f9504e66.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/f8ffaa1ec5c42dc09fa0c60c13990ce572a4c675995160106831d9b8dfe3e7e2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/505c613cf75396a7b99b7fe69d4601b5d51cb741208a490146fb29ad7bf9c095.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/4a340ca19409ba145047a5224d02f98e085ec00d9eb1cfde084f9ccb16b9cdc7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/00e8eaa9983b0c2bb60c525dc0ed655a4cb99dc1b04bb92ca8825b3b2dcb7cb8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/9e6191e411f54bb3d726d5e1374e8fb478f4d9e51aeef2135286ee8c215d6e19.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/c119d923756304b9a997bbb63647709e91fe9c9d515eb0f9d0007e31e6b47795.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/8445761b796ee6d7c442c72b1ac834c03381930018d3905f3846997cebc3855d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/158759146c23f83b4df7b710fe1b4d2e461ad740d5d9a433307d46bb70c33353.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/319926/6bdabc313090be8c5a9af0d29cd196151b94c06360349cf103446fc39204e1ca.png"
                    }
                ],
                "hotelID": 319926,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.548439386426384",
                    "longitude": "-105.27324914932251",
                    "postalCode": "43300",
                    "state": "Jalisco",
                    "street": "Carr a Barra de Navidad km 8.5., Zona Hotelera Sur",
                    "countryCode": "MX"
                },
                "name": "Grand Park Royal Puerto Vallarta",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Veranda (bufet internacional)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Andiamo (cocina italiana a la carta)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Frida (cocina mexicana a la carta)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Pescador (cocina del mar a la carta)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Munchies (snack bar)",
                        "type": "Botanas"
                    },
                    {
                        "name": "Kipuri (lobby bar)",
                        "type": "Bar"
                    },
                    {
                        "name": "Solé, café & gelato",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493606,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493636,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493665,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493694,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493722,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493750,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493778,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493806,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493834,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493863,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493892,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493920,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493947,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493975,
                        "kidsFreeTo": 0,
                        "name": "Royal Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494002,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494028,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494054,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494080,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494106,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494132,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494158,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494184,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494210,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494237,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494264,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494291,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494318,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494343,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494368,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494394,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494419,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494445,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494471,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494497,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494525,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494552,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494579,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494606,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494633,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494659,
                        "kidsFreeTo": 0,
                        "name": "Classic Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494686,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494713,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494741,
                        "kidsFreeTo": 0,
                        "name": "Thematic Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494769,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494796,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494825,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494854,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494883,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494912,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494941,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494970,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18494998,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495024,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495052,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495080,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495107,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495134,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495161,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495188,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495215,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495241,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495268,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495295,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495320,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495346,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495370,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495395,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495420,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495448,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495473,
                        "kidsFreeTo": 0,
                        "name": "Royal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495498,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495523,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495548,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495573,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495599,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495625,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495651,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495677,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495703,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495729,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495756,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Royal Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495784,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495810,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495836,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495861,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495887,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495913,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495939,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495964,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18495989,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496014,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496039,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496065,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496089,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496113,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496136,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496159,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496181,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496203,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18496224,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 cama doble y 1 sofá cama individual grande o 2 camas individuales y 2 Sofás cama individuales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5546681,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5546682,
                        "kidsFreeTo": 6,
                        "name": "De lujo frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5546682,
                        "kidsFreeTo": 6,
                        "name": "De lujo frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5546684,
                        "kidsFreeTo": 0,
                        "name": "Premier frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales y 1 Sofá cama individual",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 5546686,
                        "kidsFreeTo": 6,
                        "name": "Premier doble frente al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Access via exterior corridors",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7705408,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Access via exterior corridors",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7705409,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Ubicación: planta superior",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7705410,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier, vistas al mar, frente a la playa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Access via exterior corridors",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitación en planta Club",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Phone",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7705411,
                        "kidsFreeTo": 0,
                        "name": "Suite estudio Royal, frente al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión por cable",
                            "Televisor LED",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7710924,
                        "kidsFreeTo": 0,
                        "name": "Super Saver",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7756501,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7756502,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7819234,
                        "kidsFreeTo": 0,
                        "name": "Family Room Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 7930899,
                        "kidsFreeTo": 0,
                        "name": "Room Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439864,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Two Double Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8439950,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Cama doble",
                            "Cama king size 150-183 ancho",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "NO Accesible para minusválidos",
                            "NO Baño para minusválidos",
                            "NO Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Superficie habitación (m²)",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 8440006,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 cama doble y 1 sofá cama individual grande o 2 camas individuales y 2 Sofás cama individuales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11472844,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11472845,
                        "kidsFreeTo": 6,
                        "name": "De lujo frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11472846,
                        "kidsFreeTo": 0,
                        "name": "Premier frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Minibar",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King y 2 Matrimoniales y 1 Sofá cama individual",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 11472847,
                        "kidsFreeTo": 6,
                        "name": "Premier doble frente al mar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074422,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074427,
                        "kidsFreeTo": 0,
                        "name": "Habitación Lunas De Miel",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074432,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074437,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Dos Camas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074439,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Frente A La Playa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074442,
                        "kidsFreeTo": 0,
                        "name": "Estudio Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074446,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074448,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074450,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074453,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074456,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074457,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074460,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074463,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074466,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074470,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074472,
                        "kidsFreeTo": 0,
                        "name": "Doble Classic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074475,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074479,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074488,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074492,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074497,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074500,
                        "kidsFreeTo": 0,
                        "name": "Doble Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074503,
                        "kidsFreeTo": 0,
                        "name": "Doble Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074506,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074509,
                        "kidsFreeTo": 0,
                        "name": "Apartamento Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074512,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074515,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074521,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074525,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074528,
                        "kidsFreeTo": 0,
                        "name": "Suite Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074530,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074534,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Deluxe Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074535,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074536,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074538,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074539,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074540,
                        "kidsFreeTo": 0,
                        "name": "Suite Premier",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074541,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074542,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074543,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074544,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074545,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074546,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074547,
                        "kidsFreeTo": 0,
                        "name": "Suite Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074548,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074554,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074556,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074558,
                        "kidsFreeTo": 0,
                        "name": "Suite Premier Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074560,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074562,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074565,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074569,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074572,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074575,
                        "kidsFreeTo": 0,
                        "name": "Habitación Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074578,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074581,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074583,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074585,
                        "kidsFreeTo": 0,
                        "name": "Habitación Grand Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074588,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074591,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074594,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074595,
                        "kidsFreeTo": 0,
                        "name": "Suite Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074596,
                        "kidsFreeTo": 0,
                        "name": "Doble Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074597,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074598,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074599,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074600,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074601,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Frente Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074602,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074603,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074604,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074605,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Luxury",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16074606,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 16420772,
                        "kidsFreeTo": 0,
                        "name": "Family Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491243,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491260,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491277,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491295,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491312,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491329,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491346,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491364,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491381,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491398,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491416,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491434,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491452,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491470,
                        "kidsFreeTo": 0,
                        "name": "Royal Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491488,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491506,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491523,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491540,
                        "kidsFreeTo": 0,
                        "name": "Premium Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491557,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491573,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491588,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491603,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491619,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491635,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491650,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491666,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491682,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491698,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491716,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491735,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491754,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491773,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491792,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491811,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Balcony",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491829,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491849,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Vistas al océano",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491869,
                        "kidsFreeTo": 0,
                        "name": "Classic Single Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491889,
                        "kidsFreeTo": 0,
                        "name": "Classic Double Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491909,
                        "kidsFreeTo": 0,
                        "name": "Classic",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491929,
                        "kidsFreeTo": 0,
                        "name": "Classic Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491951,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491973,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18491995,
                        "kidsFreeTo": 0,
                        "name": "Thematic Suite",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492019,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492044,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492070,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492095,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492121,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492146,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492171,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vista a la playa",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492196,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492220,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492246,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492274,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492302,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492330,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492359,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492388,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492416,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492443,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492470,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Vista al patio",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492498,
                        "kidsFreeTo": 0,
                        "name": "Premium Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492524,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room King Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492552,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492578,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492605,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Suite",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492631,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492658,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492685,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Vista al desierto",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492712,
                        "kidsFreeTo": 0,
                        "name": "Royal",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492740,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Double Room",
                        "isActive": true,
                        "view": "Vista a la montaña",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492768,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492796,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492824,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492852,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492881,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492910,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492940,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492969,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18492998,
                        "kidsFreeTo": 0,
                        "name": "Honeymoon Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493026,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Royal Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493056,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493085,
                        "kidsFreeTo": 0,
                        "name": "Presidential",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493116,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493143,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493173,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Plus",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493203,
                        "kidsFreeTo": 0,
                        "name": "Premium Single Room Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493232,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493258,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Single Room",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493286,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493313,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493339,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493366,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493393,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Suite",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493420,
                        "kidsFreeTo": 0,
                        "name": "Premium King Bed Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493447,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493475,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493503,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493530,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin Sea View",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18493559,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Vistas al parque",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 2 Sofás cama individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528823,
                        "kidsFreeTo": 0,
                        "name": "Junior suite - solo adultos",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528825,
                        "kidsFreeTo": 0,
                        "name": "De lujo frente al mar - solo adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528828,
                        "kidsFreeTo": 0,
                        "name": "Premier frente al mar - solo adultos",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales y 2 Sofás cama individuales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528834,
                        "kidsFreeTo": 0,
                        "name": "Junior suite - solo adultos no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/FBH8IDfzbHXkecX8Gpq6yRME9po=/720x480/05/41/62/05416229.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Minibar",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528835,
                        "kidsFreeTo": 0,
                        "name": "De lujo frente al mar - solo adultos no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/81QJMnXVA49LMKLZYA5bG18EFdg=/720x480/03/28/07/03280776.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Internet inalámbrico",
                            "Mesa de trabajo",
                            "Minibar",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18528837,
                        "kidsFreeTo": 0,
                        "name": "Premier frente al mar - solo adultos no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/uJ3TJ7sZFVi2byojtyIsAj7U8c4=/720x480/03/28/07/03280795.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Amueblada individualmente",
                            "Armario o ropero",
                            "Artículos de higiene personal ecológicos",
                            "Balcón",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Cambio de sábanas (previa solicitud)",
                            "Cambio de toallas (previa solicitud)",
                            "Champú",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Disponibilidad de habitaciones comunicadas/contiguas",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitaciones insonorizadas",
                            "Jabón",
                            "Limpieza de habitaciones diaria",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 2",
                            "Papel higiénico",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Solo ducha",
                            "Teléfono",
                            "Toallas",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18925462,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, frente al mar",
                        "isActive": true,
                        "view": "Vista al mar",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973705,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973708,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973712,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Balcón",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973714,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Albornoz",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973718,
                        "kidsFreeTo": 0,
                        "name": "Suite Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973721,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Living room",
                            "Number of bedrooms",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 King-size bed 150-183 width",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973722,
                        "kidsFreeTo": 0,
                        "name": "Doble Premier",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973723,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Living room",
                            "Minibar",
                            "Number of bedrooms",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973724,
                        "kidsFreeTo": 0,
                        "name": "Habitacion Familiar Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathrobes",
                            "Bathroom",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Desk",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Hairdryer",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973725,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Standard",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973726,
                        "kidsFreeTo": 0,
                        "name": "Habitación Premier Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973727,
                        "kidsFreeTo": 0,
                        "name": "Estudio Vistas Al Mar",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973728,
                        "kidsFreeTo": 0,
                        "name": "Estudio Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973729,
                        "kidsFreeTo": 0,
                        "name": "Suite Con Balcón",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973730,
                        "kidsFreeTo": 0,
                        "name": "Suite Premium",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Balcony",
                            "Cable TV",
                            "Centrally regulated air conditioning",
                            "Desk",
                            "Direct dial telephone",
                            "Hairdryer",
                            "Smoking rooms",
                            "Terrace",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Run of the house",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 18973731,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sea view",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Access via exterior corridors",
                            "Air conditioning",
                            "Balcony",
                            "Bedsheets provided",
                            "Blackout drapes/curtains",
                            "Change of bed sheets (on request)",
                            "Change of towels (on request)",
                            "Coffee/tea maker",
                            "Connecting/adjoining rooms available",
                            "Daily housekeeping",
                            "Desk",
                            "Eco-friendly toiletries",
                            "Free bottled water",
                            "Free toiletries",
                            "Free WiFi",
                            "Hair dryer",
                            "Individually decorated",
                            "Individually furnished",
                            "In-room safe",
                            "Iron/ironing board",
                            "Laptop-friendly workspace",
                            "Minibar",
                            "No cribs (infant beds)",
                            "Non-Smoking",
                            "Number of beds - 4",
                            "Phone",
                            "Premium bedding",
                            "Private bathroom",
                            "Room service (24 hours)",
                            "Shampoo",
                            "Shower only",
                            "Soap",
                            "Soundproofed rooms",
                            "Toilet paper",
                            "Towels provided",
                            "Wardrobe or closet",
                            "Wheelchair accessible"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 19303610,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Adults Only",
                        "isActive": true,
                        "view": null,
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Minibar",
                            "Secadora de cabello",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160776,
                        "kidsFreeTo": 6,
                        "name": "De lujo",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fMiD777kXhYjiQK9bAezMENa9og=/720x480/13/55/98/13559889.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fMiD777kXhYjiQK9bAezMENa9og=/720x480/13/55/98/13559889.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Minibar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Individuales y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160777,
                        "kidsFreeTo": 6,
                        "name": "Junior suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Xg2iBW0X4_ChvU2UfJu1vamE4ec=/720x480/13/55/98/13559890.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Xg2iBW0X4_ChvU2UfJu1vamE4ec=/720x480/13/55/98/13559890.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Minibar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Individuales y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160778,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar vista al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/61P4kH6IGXEgATi8Ba8GT3DoZwM=/720x480/13/55/98/13559891.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/61P4kH6IGXEgATi8Ba8GT3DoZwM=/720x480/13/55/98/13559891.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Minibar",
                            "Secadora de cabello",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160799,
                        "kidsFreeTo": 6,
                        "name": "De lujo - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fMiD777kXhYjiQK9bAezMENa9og=/720x480/13/55/98/13559889.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fMiD777kXhYjiQK9bAezMENa9og=/720x480/13/55/98/13559889.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Minibar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Individuales y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160800,
                        "kidsFreeTo": 6,
                        "name": "Junior suite - no reembolsable",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Xg2iBW0X4_ChvU2UfJu1vamE4ec=/720x480/13/55/98/13559890.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Xg2iBW0X4_ChvU2UfJu1vamE4ec=/720x480/13/55/98/13559890.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Acceso a internet",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha tipo lluvia",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Minibar",
                            "Secadora de cabello",
                            "TV de pantalla plana",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Individuales y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "12:00",
                        "roomID": 20160801,
                        "kidsFreeTo": 6,
                        "name": "Suite familiar vista al mar - no reembolsable",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/61P4kH6IGXEgATi8Ba8GT3DoZwM=/720x480/13/55/98/13559891.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/61P4kH6IGXEgATi8Ba8GT3DoZwM=/720x480/13/55/98/13559891.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Máquina de hielo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Parque acuático",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina exterior",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Solo adultos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 686,
                    "valuesAverage": [
                        0
                    ]
                },
                "title": "Hotel todo incluido frente a la playa en el sur de la zona hotelera",
                "uri": "grand-park-royal-puerto-vallarta",
                "tags": [
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    },
                    {
                        "name": "Solo adultos"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        }
                    ],
                    "I": [
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Impuestos y propinas",
                        "description": "Todos los impuestos y propinas están incluidos."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye todos los alimentos y botanas, incluyendo desayuno, almuerzo y cena bufet, y una cena a la carta en el restaurante Guacamajazz por una estadía de siete noches. También incluye bebidas nacionales de selección de la casa de 11:00 a 23:00 hrs."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Disponibilidad de servicios e instalaciones de acuerdo a los horarios establecidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    }
                ],
                "description": "Las Palmas by the Sea All Inclusive, Puerto Vallarta es un bello hotel ubicado en la playa, en el corazón de la zona hotelera de Puerto Vallarta, a sólo cinco kilómetros del aeropuerto internacional de Puerto Vallarta (PVR) y muy cerca del centro y el famoso Malecón de la ciudad.\r\n\r\nEl hotel tiene 225 amplias y cómodas habitaciones decoradas en un estilo típico mexicano, la mayoría de ellas con balcón privado. Todas cuentan con amenidades que incluyen televisión por cable/satélite, teléfono de marcado directo y baño privado con regadera. Hay habitaciones con vista al jardín y otras al mar, desde las que puedes contemplar uno de los mejores atardeceres de todo México.\r\n\r\nLas Palmas by the Sea ofrece dos restaurantes con vista al mar donde podrás disfrutar de deliciosos platillos mexicanos e internacionales. Además, este hotel cuenta con dos bares, dos piscinas, una de ellas con jacuzzi frente al mar, actividades diarias en la playa y área de piscina, un club de niños, servicios de lavandería, resguardo de equipaje y servicio médico, entre otros. Las Palmas by the Sea brinda acceso a internet inalámbrico en las áreas comunes.  **Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/59e0ab78912e45f6ec9456317afeded61d65e7b41079b3cc1684c614ed3f536a_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/4741d4d71874ea13433be2a45ca7235a1ced124786ac87eb805ea55c32d83a3f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/02cd965806a5574b805e7781112c4e2cb284aa3f359535f381ef5483943c04bb.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/fff52b8b0caca3e2ee9ab3a3ee2c661b1151cafa9f9a999e6f0949212d230bbf.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/98b2663f2ff8044aa03c941f663dddcac75737a3fd38c6571eff473b99468c58.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/9a84b45c998cdebbe5d42e50fdfca391ed98269ca6447bf494310e8d90f52fd5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/6633a636da00e9b7efadaec07b9c457cc36e7e791eeefcc734b547191608d359.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/1f8816116fc105058aa5eadb76a067ab88aef3af81bf95ced1d5c5e20823440f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/629325c77b3225ff615c112dc5be11d9a83efd437d79aa57e2166412fb886858.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/787f758725970d482e8e84d221ef8dadc54dce62b14deb80bcde1b3da7de1a08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/e56db7d281c905d4ed62324f0df4342c4264e8e443d55f46803f157cf2d8ab2e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/cce4cc62adf0ac6505d89d1fb19730e1345903ca7766d83cc6c97fc6a5c1401e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/c688180f50dddef189a4cbe6dc2e2869ec01a8126ef5d2d0d06214b8c6e10de7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/3da08a02e6e4a202141a016589fe25be474b715de5879954a13cbe45408c20ef.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/a16fd67b537419beb0eeaa9ed27923c5f6cd772e92610cca5be9b27e7410ae49.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/adc48e93f70639e1c38f76fbb6f6302b961a43401ad831e5b8a4098703dbc19f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/09a9d86b29b539c8cd51a50068a7248c4ab4936efa1af7b4e6f06de4b1174a7f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/360a95e5af3aa148b418d55acf607ba9ef45d1a03082a0770ce890971d4001ac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/276cbb4baecc3e83cac3dabb2e01274206c4b9e180fbdcbe8e3c6f744aff3084.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/66aa65208722680fadcb5eb6aacb1949fd4e59626050404db0402351a6b520e8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/6c4fd75cef38137ef46cff98ecbcb653e69706c03c5d1e851e49a6e48c04baea.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/17529a801ad02e7752ce02a173f931c21c1ec6c51b2cbbcecd7d349b3df6f3d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/4614fa84b984da745fb4cd314b51d2577d2d54cd7e81b3fd551da7158bbef69e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/a006e4e2f5910df9cc147e7c9ab40523f2353bab522d41753466d540e5c9da8b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/a4596f52c5f1cd3713d58c1e9d18f130aa3fb79f1b3d7e4fe236ab47f7daf331.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/df9831dcb4da33252ad1154219ec5dc4edee43fa979d48a9f53209f565c7a289.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/33540aa0232e9a075c26c7577b3ddc628594ff4f9d3f49bc045c40a8759bf58a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/b1cf59c6b673262e64a09a4f753fc9179acd6fbff9a5410ea61f22fb8599b1f7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/5f1ed07312f72da2a0fb924b6fbdc00e9ff257e16b2b16cef037356efcd04da6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/21ef717396fd2506092d8b193f633b5e75bf5e9bb4044d3ef0ae8c418e9b4780.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/c9ae472992f27c9d08ca81ca7b33c63f2b89777a5876fb4aa9d9db494de1d68a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/c02d86d32cfaa066b7838e273bac59cd3ebfc6a09d57cfb7dc0afeabd973dfe4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/af4d480c1cf797f70390df8be44df8ddceefcc96a03423b06d4cb2c89a3c9ecd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/91861110ca4ff1f7b22291f62075affe81a8b062d9e19a3c1e7538f28c57ac8e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/f3952992527c6f5cb97bf21d18c48e0dcf802e73d40d856c5d71e47e36e3d280.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/1aef8218d055a668ce1aa2e7d6f75841d0fab5f1fe694e4ae322916cf116a47a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/19ea046f6c0de5d643f26927f491393694738f7f21fee013c6cf74184ce2d926.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/8aacd58d9151a8e88d078ed02118c69439e734fb05f8e781c28b97edfd42a9c0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/a0d36b65a10efbefe26300bd9a88005ce9d621cedd315121acdf38a5ca6e651a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/d5c228482ea76ee6f6d2afbca78b9471bb20c24aae7c98aaa3c109be7a467c4b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/b1ca8ae89aca1e6179edb4d97d26bd229ba8ea2bc5fbcf9ec0f40723d8446086.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/9387c64e397eaa8b048bd478b98628a311d64e1b5317d1b33f3d2d1ba77f9d28.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/d0ab62bf9fa699e5c56091762074d10f180560f79720674ad0c00f6dfa625c70.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/038045680155e36a9ff2776aeaa1b295c024a019bf2eeba68599a909882842e1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100345/adf9a7ae3819eb3f6a099a64472d4876c7b66e41e43c066f2f4378f479052be0.png"
                    }
                ],
                "hotelID": 100345,
                "importantFacilities": [
                    "Alto estándar de limpieza",
                    "Descuentos en el spa",
                    "Restaurante de especialidades"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.636047432403807",
                    "longitude": "-105.23316621780396",
                    "postalCode": "48333",
                    "state": "Jalisco",
                    "street": "Pablo Picasso 126, Zona Hotelera Las Glorias",
                    "countryCode": "MX"
                },
                "name": "Las Palmas by the Sea All Inclusive, Puerto Vallarta",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Coco Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Guacamajazz",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Hurakenna Beach Bar",
                        "type": "Bar de playa"
                    },
                    {
                        "name": "Snack Bar by the Sea",
                        "type": "Botanas"
                    },
                    {
                        "name": "Aire del Mar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Fusión Gourmet",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512521,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512547,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512572,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512597,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512622,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512648,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512673,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512699,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512725,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512750,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512773,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512796,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512820,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512845,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512869,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512892,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512916,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512937,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512959,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512978,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512997,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513016,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513035,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513055,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513075,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513094,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513114,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513135,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513155,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513176,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513196,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513216,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513235,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513254,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513274,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513294,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513312,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513330,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513348,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513367,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513386,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513406,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513432,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513455,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513478,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513503,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513527,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513552,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513580,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513605,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513629,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513652,
                        "kidsFreeTo": 0,
                        "name": "Golden Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513675,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513700,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513722,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513742,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513765,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513787,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513810,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513833,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513858,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513882,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513905,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513929,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513953,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18513979,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514004,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514029,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514055,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514083,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514111,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514139,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514165,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514190,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514216,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514243,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514270,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514298,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514325,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514354,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514379,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514403,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514433,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514463,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514490,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514519,
                        "kidsFreeTo": 0,
                        "name": "Golden Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514547,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514575,
                        "kidsFreeTo": 0,
                        "name": "King Or 2 Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514604,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514631,
                        "kidsFreeTo": 0,
                        "name": "King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514658,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514686,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514712,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514737,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514763,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View For Non-Smokers",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514790,
                        "kidsFreeTo": 0,
                        "name": "Romance",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514819,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514849,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514880,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18514909,
                        "kidsFreeTo": 0,
                        "name": "King Bed 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574584,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574600,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574617,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574634,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574650,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574665,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574681,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574698,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574714,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574731,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574748,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574764,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574781,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574798,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574816,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574834,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574852,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574870,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574888,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574906,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574924,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574942,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574960,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574979,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18574998,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575017,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575038,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575060,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575083,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575108,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575133,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575159,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575185,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575211,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575236,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575263,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575290,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575316,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575340,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575366,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575391,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575416,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575441,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575466,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575489,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575512,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575535,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575558,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575581,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575605,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575628,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575651,
                        "kidsFreeTo": 0,
                        "name": "Golden Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575674,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575696,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575718,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575739,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575760,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575782,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575803,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575824,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575843,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575864,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575885,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575906,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575927,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575948,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575968,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18575988,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000588,
                        "kidsFreeTo": 4,
                        "name": "Estándar",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/qXYjspiFveRVBhOjMWZI9jogF3s=/720x480/04/98/38/04983871.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/qXYjspiFveRVBhOjMWZI9jogF3s=/720x480/04/98/38/04983871.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1005190,
                        "kidsFreeTo": 4,
                        "name": "Vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gepgRyNeOU6kH56jNeWIclVs23w=/720x480/04/98/38/04983872.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gepgRyNeOU6kH56jNeWIclVs23w=/720x480/04/98/38/04983872.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952242,
                        "kidsFreeTo": 0,
                        "name": "Ocean View Room with Balcony Two Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Escritorio",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3952243,
                        "kidsFreeTo": 0,
                        "name": "Standard Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4715360,
                        "kidsFreeTo": 0,
                        "name": "Ocean View with Balcony King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Batas",
                            "Caja de seguridad",
                            "Pantuflas",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4716690,
                        "kidsFreeTo": 0,
                        "name": "Frente al mar",
                        "isActive": true,
                        "view": "Mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/MrCc0-gjojXF1dN04Y8GYAEAH0w=/720x480/04/98/54/04985449.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/MrCc0-gjojXF1dN04Y8GYAEAH0w=/720x480/04/98/54/04985449.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 5968347,
                        "kidsFreeTo": 0,
                        "name": "Estándar king con terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N0ZJOvCJoB3NhagOYsZcw-f8sKk=/720x480/04/98/39/04983921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N0ZJOvCJoB3NhagOYsZcw-f8sKk=/720x480/04/98/39/04983921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Secadora de cabello",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 5968348,
                        "kidsFreeTo": 0,
                        "name": "Estándar con terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/qXYjspiFveRVBhOjMWZI9jogF3s=/720x480/04/98/38/04983871.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/qXYjspiFveRVBhOjMWZI9jogF3s=/720x480/04/98/38/04983871.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6089227,
                        "kidsFreeTo": 4,
                        "name": "Estándar king",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/N0ZJOvCJoB3NhagOYsZcw-f8sKk=/720x480/04/98/39/04983921.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/N0ZJOvCJoB3NhagOYsZcw-f8sKk=/720x480/04/98/39/04983921.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Caja de seguridad",
                            "Aire acondicionado",
                            "Balcón o terraza",
                            "Baño privado con ducha",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6089228,
                        "kidsFreeTo": 4,
                        "name": "Vista al mar king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/MrCc0-gjojXF1dN04Y8GYAEAH0w=/720x480/04/98/54/04985449.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/MrCc0-gjojXF1dN04Y8GYAEAH0w=/720x480/04/98/54/04985449.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6104494,
                        "kidsFreeTo": 0,
                        "name": "Standard Room King Size bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Albornoces",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "No hay camas supletorias",
                            "No rollaway/extra beds",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "Zapatillas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6104495,
                        "kidsFreeTo": 0,
                        "name": "Ocean Front",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6862974,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6862976,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6862978,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 6862979,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín Dos Camas Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Balcón",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7664332,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 12878573,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 12878574,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076186,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076188,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076190,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076195,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076199,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076210,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076230,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16076233,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Escritorio",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "No fumadores",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148580,
                        "kidsFreeTo": 0,
                        "name": "Standar Room King Bed, Terrace",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Agua mineral gratuita",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Escritorio",
                            "Fumadores y no fumadores",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Number of beds - 2",
                            "Número de camas - 2",
                            "Productos de higiene personal gratis",
                            "Reloj despertador",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Solo ducha",
                            "Teléfono",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148582,
                        "kidsFreeTo": 0,
                        "name": "Standar Room 2 Doble Beds Terrace",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16428144,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216586,
                        "kidsFreeTo": 0,
                        "name": "Habitación Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216593,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216599,
                        "kidsFreeTo": 0,
                        "name": "Individual Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216605,
                        "kidsFreeTo": 0,
                        "name": "Triple Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216612,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216618,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216625,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216631,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216636,
                        "kidsFreeTo": 0,
                        "name": "Triple Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216641,
                        "kidsFreeTo": 0,
                        "name": "Individual Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216646,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216650,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216654,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216657,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216660,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216663,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Luxury Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216668,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216676,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Mar Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216684,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216693,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216698,
                        "kidsFreeTo": 0,
                        "name": "Individual Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216705,
                        "kidsFreeTo": 0,
                        "name": "Cama En Habitación Compartida Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216712,
                        "kidsFreeTo": 0,
                        "name": "Individual Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216718,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216725,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216732,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216739,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216746,
                        "kidsFreeTo": 0,
                        "name": "Tienda Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216752,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17216757,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947277,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947278,
                        "kidsFreeTo": 0,
                        "name": "Doble Frente Al Mar Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947279,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510179,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510203,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510227,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510251,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510275,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510299,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510324,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510351,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510380,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510407,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510435,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510459,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510483,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510507,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510531,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510555,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510578,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510601,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510624,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510647,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510672,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510697,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510722,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510748,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510774,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510800,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510825,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510850,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510875,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510898,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510923,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510947,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510972,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18510996,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511022,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511046,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511069,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511092,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511115,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511137,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511159,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511180,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511201,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511224,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511245,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511267,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511287,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511307,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511327,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511347,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511367,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511388,
                        "kidsFreeTo": 0,
                        "name": "Golden Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511409,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511430,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511450,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511470,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511490,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511510,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511530,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511549,
                        "kidsFreeTo": 0,
                        "name": "Single Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511570,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511590,
                        "kidsFreeTo": 0,
                        "name": "Lake View",
                        "isActive": true,
                        "view": "Lago",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511612,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511636,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511659,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511682,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511705,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511728,
                        "kidsFreeTo": 0,
                        "name": "Deluxe King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511751,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511774,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511797,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511820,
                        "kidsFreeTo": 0,
                        "name": "1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511844,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511866,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511888,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511912,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511935,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511957,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18511979,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512002,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512026,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512050,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512073,
                        "kidsFreeTo": 0,
                        "name": "2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512095,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512120,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512144,
                        "kidsFreeTo": 0,
                        "name": "Golden Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512170,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512196,
                        "kidsFreeTo": 0,
                        "name": "King Or 2 Double Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512222,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512247,
                        "kidsFreeTo": 0,
                        "name": "King Bed With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512271,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512293,
                        "kidsFreeTo": 0,
                        "name": "2 Queen Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512315,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512338,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512361,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View For Non-Smokers",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512385,
                        "kidsFreeTo": 0,
                        "name": "Romance",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512411,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18512436,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18516269,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18573803,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834455,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Mar Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834458,
                        "kidsFreeTo": 0,
                        "name": "Habitación",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834461,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente Océano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834464,
                        "kidsFreeTo": 0,
                        "name": "Triple Capacidad 3",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834467,
                        "kidsFreeTo": 0,
                        "name": "Triple Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18905596,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Radio",
                            "Sala de estar",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18905599,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Terrace",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "2 2 Double bed 131-150 width",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18980814,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19316561,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Centrally regulated air conditioning",
                            "Cot on demand",
                            "Direct dial telephone",
                            "Disability-friendly bathroom",
                            "Extra beds on demand",
                            "Internet access",
                            "Living room",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 19316562,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Oceano Cama King Size",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Hotel libre de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico en áreas comunes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 3,
                "surveyAverage": {
                    "averageValue": 3.6,
                    "totalSurveys": 796,
                    "valuesAverage": [
                        4.1,
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel familiar todo incluido frente a la playa en Puerto Vallarta",
                "uri": "las-palmas-by-the-sea-all-inclusive-puerto-vallarta",
                "tags": [
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        }
                    ],
                    "I": [
                        {
                            "type": "Impuestos y Propinas",
                            "description": "Todos los impuestos y propinas estan incluidos."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye alojamiento a elección."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Fiesta Mexicana los jueves, se requieren reservaciones."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades supervisado para niños de entre 4 y 12 años en el Club de Niños Sheratoon."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Las bebidas están incluidas de 11:00 a 23:00 hrs. La Fiesta Mexicana se realiza los jueves, se requiere reservación. Se requiere reservaciones para algunos restaurantes. Incluye Brunch Dominical con Champagne y música de mariachi. Restaurante Gaviotas 4 Diamantes."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias en la alberca, una hora de tenis diaria, 30 minutos de acceso a internet durante tu estancia."
                    }
                ],
                "description": "Sheraton Buganvilias Resort and Convention Center está ubicado sobre una playa de 300 metros de extensión en Puerto Vallarta, a corta distancia del malecón y del centro de la ciudad. El aeropuerto se ubica a 5 kilómetros del hotel. \r\n\r\nCada una de las 473 habitaciones totalmente renovadas en este resort de estilo mexicano contemporáneo cuenta con aire acondicionado, televisión por cable, caja de seguridad, teléfono de marcación directa con buzón de voz y baño privado con ducha. Las habitaciones de lujo vista al mar y categorías superiores ofrecen vista a la Bahía de Banderas. Además de las amenidades estándar, las habitaciones nivel Club brindan desayuno en cortesía y canapés por la tarde. El hotel acepta perros de hasta 18 kilos (previa solicitud, aplican cargos y restricciones)\r\n\r\nComo huésped del hotel Sheraton Puerto Vallarta disfruta de dos piscinas, cuatro canchas de tenis iluminadas, gimnasio, spa y un centro de compras. Los más pequeños se divertirán en el Club de Niños Sheratoon con actividades supervisadas diarias y videojuegos. El centro de negocios ofrece computadoras con acceso a internet así como wifi sin costo. Además, ofrece dos bares y tres restaurantes. El hotel organiza una Fiesta Mexicana y un Brunch Dominical cada semana. Esta propiedad es la única que tiene instalaciones para conferencias en el centro de la ciudad, con 518 metros cuadrados de espacio divisible.\r\n\r\n*** El plan todo incluido incluye desayuno, comida, cena y refrigerios, bebidas premium de 11:00 a 23:00 hrs así como una cena en el restaurante gourmet por estancia (se requiere reservar con el concierge). Bandas de mariachi y marimba en vivo, brunch dominical, servicio a la habitación las 24 horas (aplica cargo por envío de $150.00 MXN), gimnasio, dos canchas de tenis (previa reservación, equipo disponible a la renta), club de niños (5-12 años), programa recreativo, impuestos y propinas.\r\n\r\n***Todas las reservaciones de 5 habitaciones o más, creadas bajo el mismo nombre, serán consideradas como un grupo. En caso de reservación grupal favor de contactar al hotel, para establecer políticas especiales de cancelación y pagos.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 4815123,
                        "description": "Sheraton Buganvilias Resort and Convention Center",
                        "cloudUri": "https://img.cdnpth.com/media/4rpJ3sZPLAkcOMKYfQvKK9gH43I=/720x480/04/81/51/04815123.jpg"
                    },
                    {
                        "photoID": 4820053,
                        "description": "Vista del resort",
                        "cloudUri": "https://img.cdnpth.com/media/AhrL6DqWZmVY1TaIS-R7a9LW1Vw=/720x480/04/82/00/04820053.jpg"
                    },
                    {
                        "photoID": 3408819,
                        "description": "Recepción",
                        "cloudUri": "https://img.cdnpth.com/media/ThQPT1MSkZQcda9pUioa7VTKJXs=/720x480/03/40/88/03408819.jpg"
                    },
                    {
                        "photoID": 3408818,
                        "description": "Vista general del lobby",
                        "cloudUri": "https://img.cdnpth.com/media/rQPMZm1WFLgsUBdsGsAVx77kaoM=/720x480/03/40/88/03408818.jpg"
                    },
                    {
                        "photoID": 3408826,
                        "description": "El hotel tiene dos piscinas",
                        "cloudUri": "https://img.cdnpth.com/media/bVRt3WxmvlyBdAA322qwa5KAePQ=/720x480/03/40/88/03408826.jpg"
                    },
                    {
                        "photoID": 3408816,
                        "description": "Restaurante La Villita con servicio de bufet",
                        "cloudUri": "https://img.cdnpth.com/media/TpJL1AcyvI947DwvjINc3WI7AXE=/720x480/03/40/88/03408816.jpg"
                    },
                    {
                        "photoID": 3408814,
                        "description": "Restaurante Gaviotas de comida mexicana de autor",
                        "cloudUri": "https://img.cdnpth.com/media/wBYWxc8yRQrobquPGk5O0KPwu5c=/720x480/03/40/88/03408814.jpg"
                    },
                    {
                        "photoID": 3408817,
                        "description": "Restaurante bar Embarcadero",
                        "cloudUri": "https://img.cdnpth.com/media/xZi3QRBTrQb8KSjiwZ9u1JQqcQs=/720x480/03/40/88/03408817.jpg"
                    },
                    {
                        "photoID": 3408827,
                        "description": "Trattoria Alfresco",
                        "cloudUri": "https://img.cdnpth.com/media/Q8B5_xoxvMN0aJeH3PDSzb48EIc=/720x480/03/40/88/03408827.jpg"
                    },
                    {
                        "photoID": 3408822,
                        "description": "Salón del Club Level",
                        "cloudUri": "https://img.cdnpth.com/media/7ICwN5ieG9UgRO13OfeKIRO2Spk=/720x480/03/40/88/03408822.jpg"
                    },
                    {
                        "photoID": 3408815,
                        "description": "Gimnasio",
                        "cloudUri": "https://img.cdnpth.com/media/0rGZMp_XCmI8cUVUuonksBQwoBY=/720x480/03/40/88/03408815.jpg"
                    },
                    {
                        "photoID": 3408823,
                        "description": "Áreas húmedas del Maiavé Spa",
                        "cloudUri": "https://img.cdnpth.com/media/t1l-rPypWkAcBA2WlUQO1-kcbWY=/720x480/03/40/88/03408823.jpg"
                    },
                    {
                        "photoID": 3408824,
                        "description": "Sala de tratamientos",
                        "cloudUri": "https://img.cdnpth.com/media/BHH80r1oQ-__I5cStbAPWOtD-IQ=/720x480/03/40/88/03408824.jpg"
                    },
                    {
                        "photoID": 3408831,
                        "description": "Salón de belleza",
                        "cloudUri": "https://img.cdnpth.com/media/Mpgf6yw7l3-ZtOAtfWKeXLzpBQk=/720x480/03/40/88/03408831.jpg"
                    },
                    {
                        "photoID": 3408821,
                        "description": "Playa del resort",
                        "cloudUri": "https://img.cdnpth.com/media/U-UmRk9_2_9TqDGaO2lmmFCzEGk=/720x480/03/40/88/03408821.jpg"
                    },
                    {
                        "photoID": 3408833,
                        "description": "Montaje para evento en el jardín",
                        "cloudUri": "https://img.cdnpth.com/media/kdUiJqrnDHVuPAxuZ5_LihZFhmI=/720x480/03/40/88/03408833.jpg"
                    },
                    {
                        "photoID": 3408820,
                        "description": "Sala de reuniones",
                        "cloudUri": "https://img.cdnpth.com/media/RZImkW6Szl2zmNtfWN2K_p_fL7w=/720x480/03/40/88/03408820.jpg"
                    },
                    {
                        "photoID": 3408825,
                        "description": "El hotel tiene salones para convenciones",
                        "cloudUri": "https://img.cdnpth.com/media/BVOfxexyploqxTaMT1EMKjsaOBc=/720x480/03/40/88/03408825.jpg"
                    },
                    {
                        "photoID": 3408834,
                        "description": "Habitación vista al jardín",
                        "cloudUri": "https://img.cdnpth.com/media/bViY2ctaJu_uMkd56iKV-K4Y3BE=/720x480/03/40/88/03408834.jpg"
                    },
                    {
                        "photoID": 3408830,
                        "description": "Habitación vista al jardín con dos camas",
                        "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                    },
                    {
                        "photoID": 3408811,
                        "description": "Habitación de lujo con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/N7x0fdVN29_BgGM_RfhPKA1l8nE=/720x480/03/40/88/03408811.jpg"
                    },
                    {
                        "photoID": 3408809,
                        "description": "Habitación de lujo Grand con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/xrj-FCrZA-KCCNGfYePkTUseJmA=/720x480/03/40/88/03408809.jpg"
                    },
                    {
                        "photoID": 3408810,
                        "description": "Habitación de lujo Grand con dos camas",
                        "cloudUri": "https://img.cdnpth.com/media/0aPA-Y2J6hMvdM1nMd0Pot5uVJo=/720x480/03/40/88/03408810.jpg"
                    },
                    {
                        "photoID": 3408813,
                        "description": "Área de descanso en una habitación de lujo",
                        "cloudUri": "https://img.cdnpth.com/media/jfCN4Brl-ERVpsKN8DY1inHC38Q=/720x480/03/40/88/03408813.jpg"
                    },
                    {
                        "photoID": 3408828,
                        "description": "Habitación Club Level con vista al mar",
                        "cloudUri": "https://img.cdnpth.com/media/nUGDvl-KjvJou19fTMbksSHtAC8=/720x480/03/40/88/03408828.jpg"
                    },
                    {
                        "photoID": 3408829,
                        "description": "Habitación Club Level con dos camas",
                        "cloudUri": "https://img.cdnpth.com/media/GQtXB_1oKL2BBjdbGFH6Q7bDH2Y=/720x480/03/40/88/03408829.jpg"
                    },
                    {
                        "photoID": 3408808,
                        "description": "Baño de huéspedes",
                        "cloudUri": "https://img.cdnpth.com/media/e3ChJh9-1oBvD4TxQXdBgYqrmQ8=/720x480/03/40/88/03408808.jpg"
                    }
                ],
                "hotelID": 100552,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.624711339437198",
                    "longitude": "-105.23136377334595",
                    "postalCode": "48330",
                    "state": "Jalisco",
                    "street": "Blvr Francisco Medina Ascencio 999",
                    "countryCode": "MX"
                },
                "name": "Sheraton Buganvilias Resort and Convention Center",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Embarcadero",
                        "type": "Bar"
                    },
                    {
                        "name": "Gaviotas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Palapa Bar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Pergola Snack Bar",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Villita",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Lobby bar",
                        "type": "Bar"
                    },
                    {
                        "name": "La Carreta Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Trattoria Al Fresco",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251152,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251154,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251156,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251158,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251160,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251162,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251164,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251166,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251168,
                        "kidsFreeTo": 0,
                        "name": "Club",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251171,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251174,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251177,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251180,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251183,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251186,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251189,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251192,
                        "kidsFreeTo": 0,
                        "name": "Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251195,
                        "kidsFreeTo": 0,
                        "name": "Deluxe 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251198,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251201,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251204,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251207,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251210,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251215,
                        "kidsFreeTo": 0,
                        "name": "Single Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251217,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251219,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251222,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251225,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251228,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251232,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251234,
                        "kidsFreeTo": 0,
                        "name": "Economic",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251239,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251242,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251245,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251249,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251252,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251254,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251257,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251260,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251263,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251266,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251269,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251273,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251276,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251280,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251282,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251285,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251288,
                        "kidsFreeTo": 0,
                        "name": "Economic Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251291,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251294,
                        "kidsFreeTo": 0,
                        "name": "Deluxe For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251298,
                        "kidsFreeTo": 0,
                        "name": "Club Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251301,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251304,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251306,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251308,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251310,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251312,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251314,
                        "kidsFreeTo": 0,
                        "name": "Club Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251316,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251318,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251320,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251322,
                        "kidsFreeTo": 0,
                        "name": "Economic Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251324,
                        "kidsFreeTo": 0,
                        "name": "Signature",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251326,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251328,
                        "kidsFreeTo": 0,
                        "name": "Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251330,
                        "kidsFreeTo": 0,
                        "name": "With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251332,
                        "kidsFreeTo": 0,
                        "name": "King Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251334,
                        "kidsFreeTo": 0,
                        "name": "King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251336,
                        "kidsFreeTo": 0,
                        "name": "Superior Deluxe Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251338,
                        "kidsFreeTo": 0,
                        "name": "Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251340,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251342,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251344,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251346,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251348,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251350,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251351,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251354,
                        "kidsFreeTo": 0,
                        "name": "Single Room Sea View With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251355,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 14251357,
                        "kidsFreeTo": 0,
                        "name": "Club King Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Patio",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000861,
                        "kidsFreeTo": 5,
                        "name": "Vista al jardín",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gQqYFvGM5rq8P7X6B-g2eA1hs20=/720x480/03/07/40/03074034.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gQqYFvGM5rq8P7X6B-g2eA1hs20=/720x480/03/07/40/03074034.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000862,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kEtPmeivJRxAfDuVEzJKr4U-KWk=/720x480/03/40/91/03409177.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kEtPmeivJRxAfDuVEzJKr4U-KWk=/720x480/03/40/91/03409177.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Patio",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000863,
                        "kidsFreeTo": 5,
                        "name": "Vista al jardín - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/gQqYFvGM5rq8P7X6B-g2eA1hs20=/720x480/03/07/40/03074034.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/gQqYFvGM5rq8P7X6B-g2eA1hs20=/720x480/03/07/40/03074034.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Baño con ducha",
                            "Batas",
                            "Cafetera",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1000865,
                        "kidsFreeTo": 5,
                        "name": "De lujo vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/kEtPmeivJRxAfDuVEzJKr4U-KWk=/720x480/03/40/91/03409177.jpeg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/kEtPmeivJRxAfDuVEzJKr4U-KWk=/720x480/03/40/91/03409177.jpeg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1003488,
                        "kidsFreeTo": 5,
                        "name": "Grand de lujo vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/xrj-FCrZA-KCCNGfYePkTUseJmA=/720x480/03/40/88/03408809.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/xrj-FCrZA-KCCNGfYePkTUseJmA=/720x480/03/40/88/03408809.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Aire acondicionado",
                            "Baño privado",
                            "Batas",
                            "Cafetera",
                            "Espejo de tocador",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1003489,
                        "kidsFreeTo": 5,
                        "name": "Grand de lujo vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/xrj-FCrZA-KCCNGfYePkTUseJmA=/720x480/03/40/88/03408809.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/xrj-FCrZA-KCCNGfYePkTUseJmA=/720x480/03/40/88/03408809.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Baño privado",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Hors d'oeuvres",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de mayordomo",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1003491,
                        "kidsFreeTo": 0,
                        "name": "Club Level vista al mar - todo incluido",
                        "isActive": true,
                        "view": "Mar|Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/nUGDvl-KjvJou19fTMbksSHtAC8=/720x480/03/40/88/03408828.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/nUGDvl-KjvJou19fTMbksSHtAC8=/720x480/03/40/88/03408828.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Amenidades VIP",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Cortesía nocturna",
                            "Espejo de tocador",
                            "Hors d'oeuvres",
                            "Internet inalámbrico",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de mayordomo",
                            "Teléfono de marcado directo con buzón de voz",
                            "TV de pantalla plana de 32 pulgadas",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 1005600,
                        "kidsFreeTo": 0,
                        "name": "Club Level vista al mar",
                        "isActive": true,
                        "view": "Mar|Montaña",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/nUGDvl-KjvJou19fTMbksSHtAC8=/720x480/03/40/88/03408828.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/nUGDvl-KjvJou19fTMbksSHtAC8=/720x480/03/40/88/03408828.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031082,
                        "kidsFreeTo": 0,
                        "name": "Doble Guest Room Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031084,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Bahía",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0aPA-Y2J6hMvdM1nMd0Pot5uVJo=/720x480/03/40/88/03408810.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0aPA-Y2J6hMvdM1nMd0Pot5uVJo=/720x480/03/40/88/03408810.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031086,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031087,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas A La Piscina",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/VP07mk5dU1XcEp3biHFDdGdDQdU=/720x480/03/40/88/03408830.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031088,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Vistas Al Oceano",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/0aPA-Y2J6hMvdM1nMd0Pot5uVJo=/720x480/03/40/88/03408810.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/0aPA-Y2J6hMvdM1nMd0Pot5uVJo=/720x480/03/40/88/03408810.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031089,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Terraza",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ohhsor0RL8ECVetksxTSRDl4WPc=/720x480/03/07/40/03074038.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ohhsor0RL8ECVetksxTSRDl4WPc=/720x480/03/07/40/03074038.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031090,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar Con Terraza",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/Ohhsor0RL8ECVetksxTSRDl4WPc=/720x480/03/07/40/03074038.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/Ohhsor0RL8ECVetksxTSRDl4WPc=/720x480/03/07/40/03074038.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Calefacción individual",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Películas de pago",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 6031091,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/V04LR7CBDbLqRd6opoD8u_GIEok=/720x480/03/07/40/03074035.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/V04LR7CBDbLqRd6opoD8u_GIEok=/720x480/03/07/40/03074035.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7069313,
                        "kidsFreeTo": 0,
                        "name": "Habitación Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta baja",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713206,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, terraza, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713209,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, no fumadores, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713210,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, terraza, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713211,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, terraza, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713212,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, no fumadores, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta baja",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713218,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, vistas al jardín, planta baja",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta baja",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7713219,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, vistas al jardín, planta baja",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7731455,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7733463,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7833950,
                        "kidsFreeTo": 0,
                        "name": "Habitación Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 7977564,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8347115,
                        "kidsFreeTo": 0,
                        "name": "Habitación Frente A La Playa",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8347116,
                        "kidsFreeTo": 0,
                        "name": "Room Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370313,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe Con Vistas",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370327,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370332,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370355,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín Cama King Size",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370363,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370373,
                        "kidsFreeTo": 0,
                        "name": "Triple Con Terraza",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370380,
                        "kidsFreeTo": 0,
                        "name": "Individual Deluxe Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370390,
                        "kidsFreeTo": 0,
                        "name": "Doble Club Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370392,
                        "kidsFreeTo": 0,
                        "name": "Triple Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370395,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Mar Con Terraza",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370396,
                        "kidsFreeTo": 0,
                        "name": "Triple Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370399,
                        "kidsFreeTo": 0,
                        "name": "Doble Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370400,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370402,
                        "kidsFreeTo": 0,
                        "name": "Single Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8370403,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445321,
                        "kidsFreeTo": 0,
                        "name": "Triple Sea View With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445324,
                        "kidsFreeTo": 0,
                        "name": "Single Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445325,
                        "kidsFreeTo": 0,
                        "name": "Triple Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445326,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445327,
                        "kidsFreeTo": 0,
                        "name": "Single Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8445330,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8797981,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8797982,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8797983,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 8797984,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 9067617,
                        "kidsFreeTo": 0,
                        "name": "Double Luxury Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197669,
                        "kidsFreeTo": 0,
                        "name": "Double Guest Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197671,
                        "kidsFreeTo": 0,
                        "name": "Suite Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197677,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe Guest Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197680,
                        "kidsFreeTo": 0,
                        "name": "Double Beach Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197683,
                        "kidsFreeTo": 0,
                        "name": "Double Guest Room King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197684,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197685,
                        "kidsFreeTo": 0,
                        "name": "Double Guest Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197686,
                        "kidsFreeTo": 0,
                        "name": "Double One Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197726,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197728,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197729,
                        "kidsFreeTo": 0,
                        "name": "Quadruple With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10197730,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199104,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10199105,
                        "kidsFreeTo": 0,
                        "name": "Double With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10602309,
                        "kidsFreeTo": 0,
                        "name": "Double Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Alarm clock",
                            "Balcony",
                            "Bañera",
                            "Baño",
                            "Bathrobes",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Desk",
                            "Detector de humos",
                            "Ducha",
                            "Fitness room",
                            "Habitaciones para fumadores",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Make-up mirror",
                            "Mini fridge",
                            "Minibar",
                            "Número de dormitorios",
                            "Pay movies",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Radio",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Slippers",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 10602310,
                        "kidsFreeTo": 0,
                        "name": "Double Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 11635308,
                        "kidsFreeTo": 0,
                        "name": "Twin Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 11635309,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Bay View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 11635312,
                        "kidsFreeTo": 0,
                        "name": "Twin Guest Room Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Alarm clock",
                            "Balcony",
                            "Bañera",
                            "Baño",
                            "Bathrobes",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Cot on demand",
                            "Desk",
                            "Detector de humos",
                            "Disability-friendly bathroom",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Individually adjustable heating ",
                            "Internet access",
                            "Minibar",
                            "Número de dormitorios",
                            "Pay movies",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite ",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 11635381,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 11635385,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Balcón",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Terraza",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta baja",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051672,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, terraza, vistas al jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051673,
                        "kidsFreeTo": 0,
                        "name": "Habitación Signature, 1 cama de matrimonio grande, no fumadores",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "No hay cunas",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16051674,
                        "kidsFreeTo": 0,
                        "name": "Habitación Signature, 2 camas dobles, no fumadores",
                        "isActive": true,
                        "view": "Vistas a la bahía",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16146487,
                        "kidsFreeTo": 0,
                        "name": "Room Club Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16146488,
                        "kidsFreeTo": 0,
                        "name": "Room With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16146489,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16146490,
                        "kidsFreeTo": 0,
                        "name": "Room Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16146491,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 16702636,
                        "kidsFreeTo": 0,
                        "name": "Room Pool View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17212999,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 1 cama de matrimonio grande, no fumadores, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Agua mineral gratuita",
                            "Alarma antiincendios visual",
                            "Armario o ropero",
                            "Baño privado",
                            "Bombillas LED",
                            "Caja fuerte en la habitación",
                            "Camas supletorias gratuitas",
                            "Cambio de sábanas (previa solicitud)",
                            "Canales de televisión prémium",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Colchón Sleep Number de Select Comfort",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Dispositivos de ahorro de energía",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Habitación apta para mascotas",
                            "Kit de accesibilidad para el teléfono",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Máquina de café expreso",
                            "Medida del tamaño del televisor: pulgadas",
                            "Menú de almohadas",
                            "Minibar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Puertas con manilla",
                            "Reciclaje",
                            "Ropa de cama de alta calidad",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (24 horas)",
                            "Servicio de limpieza a petición",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ubicación: planta superior",
                            "Velocidad del wifi - 25\u00A0Mbps o más",
                            "Wifi (de pago)"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17213000,
                        "kidsFreeTo": 0,
                        "name": "Habitación Deluxe, 2 camas dobles, no fumadores, vistas al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215444,
                        "kidsFreeTo": 0,
                        "name": "Room Guest Room Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215451,
                        "kidsFreeTo": 0,
                        "name": "Single Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215458,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Club Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215466,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215474,
                        "kidsFreeTo": 0,
                        "name": "Double King Bed Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215479,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215484,
                        "kidsFreeTo": 0,
                        "name": "Single Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215490,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215496,
                        "kidsFreeTo": 0,
                        "name": "Room Guest Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215502,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Deluxe Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215509,
                        "kidsFreeTo": 0,
                        "name": "Single Club Ocean View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215517,
                        "kidsFreeTo": 0,
                        "name": "Room Bay View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215523,
                        "kidsFreeTo": 0,
                        "name": "Room Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215528,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Club",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215536,
                        "kidsFreeTo": 0,
                        "name": "Room Club Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215543,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215552,
                        "kidsFreeTo": 0,
                        "name": "Room Deluxe Guest Room",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215561,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Deluxe Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215569,
                        "kidsFreeTo": 0,
                        "name": "Room Club With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215577,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215584,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Grand Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215591,
                        "kidsFreeTo": 0,
                        "name": "Double Deluxe King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17215598,
                        "kidsFreeTo": 0,
                        "name": "Double Two Double Beds Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17282322,
                        "kidsFreeTo": 0,
                        "name": "Double Club With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947074,
                        "kidsFreeTo": 0,
                        "name": "Single With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947085,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947099,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin With Terrace",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947106,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Club Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947111,
                        "kidsFreeTo": 0,
                        "name": "Single Club Ocean Front",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 17947113,
                        "kidsFreeTo": 0,
                        "name": "Single Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18255746,
                        "kidsFreeTo": 0,
                        "name": "Double Club Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18255747,
                        "kidsFreeTo": 0,
                        "name": "Room Club Deluxe",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18299881,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18532439,
                        "kidsFreeTo": 0,
                        "name": "Twin Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18636708,
                        "kidsFreeTo": 0,
                        "name": "Single Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18756295,
                        "kidsFreeTo": 0,
                        "name": "Room Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834508,
                        "kidsFreeTo": 0,
                        "name": "Double Queen Bed Non Smoking",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18834510,
                        "kidsFreeTo": 0,
                        "name": "Room With Views",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979893,
                        "kidsFreeTo": 0,
                        "name": "Doble Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979903,
                        "kidsFreeTo": 0,
                        "name": "Doble Deluxe",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979910,
                        "kidsFreeTo": 0,
                        "name": "Doble Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979916,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Deluxe Vistas Al Mar",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979923,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979931,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979935,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979939,
                        "kidsFreeTo": 0,
                        "name": "Individual Club",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979943,
                        "kidsFreeTo": 0,
                        "name": "Individual Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Calefacción central",
                            "Camas supletorias bajo petición",
                            "Detector de humos",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Minibar",
                            "Número de dormitorios",
                            "Piscina exterior",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "TV vía satélite "
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "16:00",
                        "checkOutTime": "12:00",
                        "roomID": 18979947,
                        "kidsFreeTo": 0,
                        "name": "Triple Vistas Al Jardín",
                        "isActive": true,
                        "view": "Vistas al jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "2 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Baño de vapor",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Boutique",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Centro de negocios",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (5 a 12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Joyería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Mascotas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Mesa de tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Minisúper",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sauna",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sitio de taxis",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tabaquería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tienda de regalos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 5,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 951,
                    "valuesAverage": [
                        4.5,
                        4.4
                    ]
                },
                "title": "Resort de estilo mexicano contemporáneo a pasos del malecón",
                "uri": "sheraton-buganvilias-resort-and-convention-center",
                "tags": [
                    {
                        "name": "Negocios"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Acepta mascotas"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [
                    {
                        "alterId": 8206,
                        "priority": 100,
                        "startDate": "2024-04-26T06:00:00+00:00",
                        "endDate": "2027-09-01T06:00:00+00:00",
                        "title": "Remodelación",
                        "description": "El hotel estará iniciando trabajos de remodelación en abril de 2024 para la apertura del nuevo Villa del Palmar en otoño de 2027. Durante este periodo algunas instalaciones estarán fuera de servicio y podría haber ruido de construcción en horario laboral."
                    }
                ],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias para adultos y niños conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños supervisado por adultos en el club de niños."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye espectaculares shows nocturnos en el teatro."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno, comida, cena, botanas, así como bebidas alcohólicas y no alcohólicas ilimitadas (marcas nacionales). También está disponible una selección de vinos por copeo."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Incluye acceso al gimnasio equipado y canchas de pádel."
                    },
                    {
                        "title": "Otros",
                        "description": "Acceso a las palapas y jacuzzi."
                    },
                    {
                        "title": "Restricciones",
                        "description": "Ciertos platillos como cortes finos y mariscos tienen cargo extra. Algunas bebidas alcohólicas no enlistadas tienen cargo extra. El servicio a la habitación no está incluido. Los vinos y licores por botella no están incluidos. Las llamadas telefónicas no están incluidas."
                    }
                ],
                "description": "Villa del Palmar Beach Resort &amp; Spa está ubicado en la Bahía de Banderas, a corta distancia de la Marina Vallarta. El centro de Puerto Vallarta, famoso por sus restaurantes y vida nocturna está a 5 kilómetros del hotel. También podrás visitar algunos de los atractivos de la ciudad, como las playas de Yelapa y Majahuitas, ideales para practicar snorkel. El aeropuerto Internacional de Puerto Vallarta (PVR) está a 5 kilómetros de distancia.\r\n\r\nVilla del Palmar Beach Resort &amp; Spa cuenta 395 habitaciones equipadas con aire acondicionado, televisión por cable, baño privado con ducha y una cocineta completa. Las suites son ideales para familias numerosas.\r\n\r\nVilla del Palmar Beach Resort &amp; Spa, ofrece dentro de sus instalaciones un bar, dos piscinas, jacuzzi, gimnasio y canchas de pádel. Asimismo ofrece servicios como cajas de seguridad en recepción, alquiler de autos, salón de belleza, servicio a la habitación y servicios médicos. El hotel cuenta con dos restaurantes disponibles, un bar deportivo y un completo minisúper con un internet café a un lado y lavandería de autoservicio.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/50e9b93291f71c207febed0928d83b4883c1302d90c56d8e0acbda4ae1685749_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/fee60e4a1d1035c44bbb4b26deb752bc003e9a64216e66d440ffdd86bf26ae60.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio",
                        "cloudUri": "https://img.cdnpth.com/media/100594/df68ac0488e16a4d673bc92a2d7f35dd065931ae70504ea977bf29a1db8e2ae6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/0f8baa51dcf14726e1aa9ffbc2f62b127ab605ebab448c5bc16ab89c0f84c8c3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio",
                        "cloudUri": "https://img.cdnpth.com/media/100594/e542b929dd2228ed0b11e3f17ac02410354ff79c04fe5ca1db44315a2914371d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/c79bb77ed283507ea255422823cc82992b219d48e3075dbd211d1f15d5e93a45.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/eb0e7cde028d74650494682d59adfa23382b62ea1e3d76c0ad6f159e4179171c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/49376d91f7c4ea274a5a526e2dd9ce71ed5cb70cb54a128cd073a83212c2f7d9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/a5e1e5c5ed6488107127a80f9351f88f21c62cde0249faffd67325293b95aef1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/7257f120fcca1e9041876bf3c4eb8782c8d6c86a9dc2ad0ef7e85b57f59ceaa9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/fadabda86cec405c3908c986bce11c36f9493becd843d7eaf114a98b255628d9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/d9dea40f14589c5605f2b9d4a949991c2b0c73cb66b882fc8b601f2822954034.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/4884e3f8e194bd2cedc5f6fa35addb6008bcb48533872be79eefb0d53c766bc2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/e427ed8a9b73d67141114523553eab95a2a48e277c0ab6e1ca3291667f03acf6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/e29e6d7736363836919109ee67becc3cc8af15812989bc9f272d069f9f174c08.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/ea296b743fdb9abd89ad73d63b33a1b5cd820111e99b5e5464cda9618c90489e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/a46152c4b491bfcb2a7ef1a70711b749e57c35f3351577ddfff60b0454a8895f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/397a2e80104087d15ae083a762d8c7ab5fcff10104c7067d077429bac3038d64.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/1cf764dc30be976f3f24657df17f867847087f95859de4b331781609d1ba0973.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/377b26528330c0f1c4ab632220a03de0cad8ad58e1644e53feef93b3caea4af0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/76675f61f5008cf12792ece2efb8662904846300a86bb16d030f87d528d2ab42.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/100594/256107e67aec705d2cd0cc6c50ae4e3195cd541ed3870334f0308a1fbccd68ae.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/6280c1bcbecd287f1e099b9f4d4eb4a2c947e640b1abf7c3ce30cbde85242098.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/a26826f1e1dc894b9ac948e97f499027984c07f977d6f1df1b3eabf8cd1e44d6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/2ec4aa28544f68c73f65213b71bbdf41104fc244a641b8ab9f4ff3746763bf65.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/86816ed192549686ba75bdc30ec8cf43ad4a4740ae6addf763d475e901bc14df.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/514499aebfa3183c41ca1ab05888c6e7d9339cf0217a00daf8c2e53c106c2c34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/100594/f8ad49992f44a896e1cd4586c78a2a9c5f7850db1a77d7811b3d7e813ec9e291.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/36489354ead19edaeb5a3d1499bf4e6c7f970e29b75bef39c69ddaef5d8ff8f8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/a340d24751c61df8171405c1b6208958995fbec5a494a4b537ce008d91d2c16e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/0a04137d0cc8a330422b6480052d52127c5bea3e1b61cac873da2eee36dd6710.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/3146bea8fcc41d98a8d051f1fbfe24b26b31d57ee7aef90f43d604807bd338bc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/dad098d6cf8ea13095d2f50cfc321100a4180edf95d48724c41342d6d5f96c17.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/df56b25dabdf1c2973a61a235bdea76d9039a53d271ab4be0629896a0c7432c1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/4054f905ec53ffaafc95620ac490ee80ab5d0bb467211cdb424a308360ac78d1.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/47a532e1cfa0ec4ce8710e9bc243606d676eef0134d0aca4712dcfc043214097.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/3084f525ec467a0273554f5cc928ce82409ea9f3b4ed10850c47d06ca58029cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/f4ddb49582692fbaa9d58566637b5725f95bd691cb6edcae9cdae9e186e8f7d8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/9ed0ad188f4c809471a27d9faf5976ac60bb145c1120601de87bbb990a97ebe0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite Junior",
                        "cloudUri": "https://img.cdnpth.com/media/100594/ab512951729a64e9c9b72feb0a577c0af9d0221a7c2a7bff1e77579fbe7b038f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio",
                        "cloudUri": "https://img.cdnpth.com/media/100594/2f1c33fae0dab907657b1e0d5bf20bef4b016c4db5945f6b649d883972d24e9e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio",
                        "cloudUri": "https://img.cdnpth.com/media/100594/5463fe8698b4d432b0bc7b8a7b49d58b9de511f3907988758b3113d0236343d3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Suite de 1 dormitorio",
                        "cloudUri": "https://img.cdnpth.com/media/100594/d34b97f116f8ed244110ecab572ff43189dacb2d63d81b61aea9a66cd77c2526.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/a4e914943ea295a2a462ee8cdaddb0845353c64b53bc898f4a0d4b6b286f4a38.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100594/0818a7a7015d46a1e61656d934520ce1282c05d6e4f4b07c2b4ec3e68e66348a.png"
                    }
                ],
                "hotelID": 100594,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.642021384270357",
                    "longitude": "-105.2375864982605",
                    "postalCode": "48300",
                    "state": "Jalisco",
                    "street": "Blvr Francisco Medina Ascencio km 2.5, Zona Hotelera Norte",
                    "countryCode": "MX"
                },
                "name": "Villa del Palmar Beach Resort and Spa Puerto Vallarta",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Palmita Deli",
                        "type": "Restaurante"
                    },
                    {
                        "name": "El Patrón",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Trattoria",
                        "type": "Restaurante"
                    },
                    {
                        "name": "The Market",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Jalisco Sport Bar",
                        "type": "Restaurante Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093778,
                        "kidsFreeTo": 0,
                        "name": "Apartment Garden View Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093780,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Double Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093782,
                        "kidsFreeTo": 0,
                        "name": "Double Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093783,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093785,
                        "kidsFreeTo": 0,
                        "name": "Apartment Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093786,
                        "kidsFreeTo": 0,
                        "name": "Bed In Dormitory Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093787,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior King Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093788,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Queen Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093789,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093790,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093791,
                        "kidsFreeTo": 0,
                        "name": "Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093792,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093793,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093794,
                        "kidsFreeTo": 0,
                        "name": "Apartment Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093795,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093796,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093797,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093798,
                        "kidsFreeTo": 0,
                        "name": "Double Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093799,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093800,
                        "kidsFreeTo": 0,
                        "name": "Double Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093802,
                        "kidsFreeTo": 0,
                        "name": "Apartment Superior Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093803,
                        "kidsFreeTo": 0,
                        "name": "Double Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093804,
                        "kidsFreeTo": 0,
                        "name": "Double King Size Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093805,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093806,
                        "kidsFreeTo": 0,
                        "name": "Suite Two King Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093807,
                        "kidsFreeTo": 0,
                        "name": "Suite Grand",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093808,
                        "kidsFreeTo": 0,
                        "name": "Double Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093809,
                        "kidsFreeTo": 0,
                        "name": "Room Luxury",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093810,
                        "kidsFreeTo": 0,
                        "name": "Suite One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093811,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Two Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093812,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093813,
                        "kidsFreeTo": 0,
                        "name": "Apartment Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093814,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093815,
                        "kidsFreeTo": 0,
                        "name": "Apartment Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093817,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Grand Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16093819,
                        "kidsFreeTo": 0,
                        "name": "Room Classic",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16350350,
                        "kidsFreeTo": 0,
                        "name": "Double Superior Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16702504,
                        "kidsFreeTo": 0,
                        "name": "Studio Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218474,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Standard",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218481,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Capacity 2",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218489,
                        "kidsFreeTo": 0,
                        "name": "Room Superior One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218499,
                        "kidsFreeTo": 0,
                        "name": "Suite Two Double Beds",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218504,
                        "kidsFreeTo": 0,
                        "name": "Single Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17218509,
                        "kidsFreeTo": 0,
                        "name": "Single Superior Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058657,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058659,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058662,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058664,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058667,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058669,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058672,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058675,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058677,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058680,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058683,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058685,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058688,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058691,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058693,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058696,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058698,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058701,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058703,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058706,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058709,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058712,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058714,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058717,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058719,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058722,
                        "kidsFreeTo": 0,
                        "name": "Superior Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058725,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058728,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058730,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058732,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058734,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058735,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058737,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058739,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058741,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058743,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058745,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058746,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058748,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058750,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058752,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058754,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058756,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058758,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058760,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058761,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058763,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058765,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058767,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058768,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058770,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058772,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058773,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058775,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058777,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058779,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058780,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058782,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058784,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058786,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058788,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058789,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058791,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058793,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058795,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058797,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058799,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058801,
                        "kidsFreeTo": 0,
                        "name": "Garden View With Balcony",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058803,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058804,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058806,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058808,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058810,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058811,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058813,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058815,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058817,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058819,
                        "kidsFreeTo": 0,
                        "name": "Apartment Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058821,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058823,
                        "kidsFreeTo": 0,
                        "name": "Classic Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058824,
                        "kidsFreeTo": 0,
                        "name": "Apartment Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058826,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058828,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058830,
                        "kidsFreeTo": 0,
                        "name": "Deluxe House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058832,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058833,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058834,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058835,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058836,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058837,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058838,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058839,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058840,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058841,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058842,
                        "kidsFreeTo": 0,
                        "name": "Apartment With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058843,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sofabed Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058844,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058845,
                        "kidsFreeTo": 0,
                        "name": "King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058846,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sofabed Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058915,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058916,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058917,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058918,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058919,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058920,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058921,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058922,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058923,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058924,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058925,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058926,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058927,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058928,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058929,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058930,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058931,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058932,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058933,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058934,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058935,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058936,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058937,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058938,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058939,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058940,
                        "kidsFreeTo": 0,
                        "name": "Superior Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058941,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058942,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058943,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058944,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058945,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058946,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058947,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058948,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058949,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058950,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058951,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058953,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058954,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058956,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058958,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058959,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058961,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058963,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058965,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058967,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058969,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058971,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058973,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058975,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058976,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058977,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058978,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058979,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058980,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058981,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058982,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058983,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058984,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058985,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058986,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058987,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058988,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058989,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058990,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058992,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058994,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058996,
                        "kidsFreeTo": 0,
                        "name": "Garden View With Balcony",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058997,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058999,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059001,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059003,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059004,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059006,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059007,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059008,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059009,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059010,
                        "kidsFreeTo": 0,
                        "name": "Apartment Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059011,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059012,
                        "kidsFreeTo": 0,
                        "name": "Classic Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059013,
                        "kidsFreeTo": 0,
                        "name": "Apartment Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059014,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059015,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059016,
                        "kidsFreeTo": 0,
                        "name": "Deluxe House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059017,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059018,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059019,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059020,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059022,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059024,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059026,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059028,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059030,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059031,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059033,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059035,
                        "kidsFreeTo": 0,
                        "name": "King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18428049,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Superior",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834480,
                        "kidsFreeTo": 0,
                        "name": "Apartment Superior One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834482,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834483,
                        "kidsFreeTo": 0,
                        "name": "Double Or Twin Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834484,
                        "kidsFreeTo": 0,
                        "name": "Room Economy",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834485,
                        "kidsFreeTo": 0,
                        "name": "Room Sea View",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834489,
                        "kidsFreeTo": 0,
                        "name": "Suite One Bed",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocina equipada",
                            "Horno de microondas",
                            "Licuadora",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000754,
                        "kidsFreeTo": 3,
                        "name": "Junior suite superior",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IvKqnfvNPPjai5m9-7o6EVNTUo0=/720x480/04/81/45/04814546.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IvKqnfvNPPjai5m9-7o6EVNTUo0=/720x480/04/81/45/04814546.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocineta Completa",
                            "Horno de microondas",
                            "Licuadora",
                            "Mesa para cuatro",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 1 Matrimonial",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000756,
                        "kidsFreeTo": 3,
                        "name": "Suite superior de 1 dormitorio",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/16pP9pmwJVcWE09ACeQaXl8TgPQ=/720x480/04/81/45/04814549.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/16pP9pmwJVcWE09ACeQaXl8TgPQ=/720x480/04/81/45/04814549.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocineta Completa",
                            "Horno de microondas",
                            "Licuadora",
                            "Mesa para seis",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 Cama Murphy matrimonial y 1 King y 2 Twins",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 1000757,
                        "kidsFreeTo": 3,
                        "name": "Suite superior de 2 dormitorios",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-qbOhhp1B8hcvHBDeA_fIXpE05c=/720x480/04/81/45/04814550.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-qbOhhp1B8hcvHBDeA_fIXpE05c=/720x480/04/81/45/04814550.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Armario o ropero",
                            "Artículos de limpieza",
                            "Balcón",
                            "Balcón amueblado",
                            "Balcón o patio",
                            "Balcón o patio amueblado",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Batidora",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Licuadora",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Microondas",
                            "Nevera",
                            "No fumadores",
                            "Papel absorbente",
                            "Papel higiénico",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Patio",
                            "Placa de cocina",
                            "Plancha",
                            "Plancha o tabla de planchar",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Servicio de habitaciones (horario limitado)",
                            "Silla de oficina",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Terraza o patio",
                            "Toallas",
                            "Tostadora",
                            "TV con subtítulos",
                            "Vajilla y utensilios de cocina",
                            "Ventilador de techo",
                            "Wifi gratis"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4030232,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/b1PX9d7S7-uAkZCwRv48sRoHp68=/720x480/00/22/02/00220210.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/b1PX9d7S7-uAkZCwRv48sRoHp68=/720x480/00/22/02/00220210.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Armario o ropero",
                            "Artículos de limpieza",
                            "Balcón",
                            "Balcón amueblado",
                            "Balcón o patio",
                            "Balcón o patio amueblado",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Batidora",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Jabón",
                            "Licuadora",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Menú de almohadas",
                            "Mesa de comedor",
                            "Microondas",
                            "Nevera",
                            "No fumadores",
                            "Papel absorbente",
                            "Papel higiénico",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Patio",
                            "Placa de cocina",
                            "Plancha",
                            "Plancha o tabla de planchar",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Servicio de habitaciones (horario limitado)",
                            "Silla de oficina",
                            "Sofá cama",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Terraza o patio",
                            "Toallas",
                            "Tostadora",
                            "TV con subtítulos",
                            "Vajilla y utensilios de cocina",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4030233,
                        "kidsFreeTo": 0,
                        "name": "Superior Two Bed Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/1KxRtNqZdKnqkHxUHnm6F0NOPHQ=/720x480/00/22/01/00220194.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/1KxRtNqZdKnqkHxUHnm6F0NOPHQ=/720x480/00/22/01/00220194.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Acceso a través de pasillos exteriores",
                            "Armario o ropero",
                            "Artículos de limpieza",
                            "Balcón",
                            "Balcón amueblado",
                            "Balcón o patio",
                            "Balcón o patio amueblado",
                            "Bañera o ducha",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Batidora",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Canales de televisión prémium",
                            "Champú",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cocina",
                            "Combinación ducha/bañera",
                            "Conexión a Internet de pago",
                            "Conexión a Internet wifi",
                            "Cortinas opacas",
                            "Decorada individualmente",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Habitación separada",
                            "Jabón",
                            "Licuadora",
                            "Limpieza de habitaciones diaria",
                            "Llamadas locales gratuitas",
                            "Menú de almohadas",
                            "Mesa de comedor",
                            "Microondas",
                            "Nevera",
                            "No fumadores",
                            "Papel absorbente",
                            "Papel higiénico",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Patio",
                            "Placa de cocina",
                            "Plancha",
                            "Plancha o tabla de planchar",
                            "Salón independiente",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de descubierta",
                            "Servicio de habitaciones",
                            "Servicio de habitaciones (horario limitado)",
                            "Silla de oficina",
                            "Sofá cama",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión por cable",
                            "Terraza o patio",
                            "Toallas",
                            "Tostadora",
                            "TV con subtítulos",
                            "Vajilla y utensilios de cocina",
                            "Ventilador de techo",
                            "Wifi gratis",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4030234,
                        "kidsFreeTo": 0,
                        "name": "Superior One Bedroom Suite",
                        "isActive": true,
                        "view": "Vistas parciales al mar",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/xSozxTitjp7xZM10OBfOB4DLT-o=/720x480/00/22/01/00220193.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/xSozxTitjp7xZM10OBfOB4DLT-o=/720x480/00/22/01/00220193.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058489,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058490,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058491,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058493,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058495,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058497,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058499,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058501,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058503,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058505,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058507,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058509,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058511,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058513,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058515,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058517,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058519,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058521,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058523,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058524,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058525,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058526,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058527,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058528,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058529,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058530,
                        "kidsFreeTo": 0,
                        "name": "Superior Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058531,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058532,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058533,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058534,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058535,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058536,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058537,
                        "kidsFreeTo": 0,
                        "name": "Double Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058538,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058539,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058540,
                        "kidsFreeTo": 0,
                        "name": "Triple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058541,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058542,
                        "kidsFreeTo": 0,
                        "name": "Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058544,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058546,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058548,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058550,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058552,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058554,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058556,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058558,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058560,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058562,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058564,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058565,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058566,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Junior Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058567,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058568,
                        "kidsFreeTo": 0,
                        "name": "Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058569,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058570,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058571,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058572,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058573,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058574,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058575,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058576,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058577,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058578,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058579,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058580,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058581,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058582,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058583,
                        "kidsFreeTo": 0,
                        "name": "Garden View With Balcony",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058584,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058585,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058586,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058587,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058588,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058589,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058590,
                        "kidsFreeTo": 0,
                        "name": "Superior Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058592,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058594,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058596,
                        "kidsFreeTo": 0,
                        "name": "Apartment Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058598,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Queen Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058600,
                        "kidsFreeTo": 0,
                        "name": "Classic Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058602,
                        "kidsFreeTo": 0,
                        "name": "Apartment Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058604,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058606,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058608,
                        "kidsFreeTo": 0,
                        "name": "Deluxe House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058610,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058612,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058614,
                        "kidsFreeTo": 0,
                        "name": "Superior Junior Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058616,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058618,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058620,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058622,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058624,
                        "kidsFreeTo": 0,
                        "name": "Grand Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058626,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058628,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058630,
                        "kidsFreeTo": 0,
                        "name": "Apartment With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058632,
                        "kidsFreeTo": 0,
                        "name": "King Bed Sofabed Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058634,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058636,
                        "kidsFreeTo": 0,
                        "name": "King Bed 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18058638,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed Sofabed Double",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059069,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059070,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18059071,
                        "kidsFreeTo": 0,
                        "name": "Superior Suite King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathtub",
                            "Cable TV",
                            "Direct dial telephone",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Ironing set",
                            "Kitchen",
                            "Kitchenette",
                            "Microwave",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toaster",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18429782,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior Two Bedrooms",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Alarm clock",
                            "Balcony",
                            "Bathtub",
                            "Cable TV",
                            "Direct dial telephone",
                            "Fridge",
                            "Hairdryer",
                            "Individually adjustable air conditioning",
                            "Ironing set",
                            "Kitchen",
                            "Kitchenette",
                            "Microwave",
                            "Radio",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Terrace",
                            "Toaster",
                            "TV",
                            "Wheelchair-accessible",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18834488,
                        "kidsFreeTo": 0,
                        "name": "Suite Superior One Bedroom",
                        "isActive": true,
                        "view": "Vistas a la ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocina equipada",
                            "Horno de microondas",
                            "Licuadora",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18956230,
                        "kidsFreeTo": 3,
                        "name": "Junior suite superior - con desayuno",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/IvKqnfvNPPjai5m9-7o6EVNTUo0=/720x480/04/81/45/04814546.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/IvKqnfvNPPjai5m9-7o6EVNTUo0=/720x480/04/81/45/04814546.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 baños",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocineta Completa",
                            "Horno de microondas",
                            "Licuadora",
                            "Mesa para seis",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 Cama Murphy matrimonial y 1 King y 2 Twins",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18956231,
                        "kidsFreeTo": 3,
                        "name": "Suite superior de 2 dormitorios - con desayuno",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/-qbOhhp1B8hcvHBDeA_fIXpE05c=/720x480/04/81/45/04814550.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/-qbOhhp1B8hcvHBDeA_fIXpE05c=/720x480/04/81/45/04814550.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Cafetera",
                            "Cocineta Completa",
                            "Horno de microondas",
                            "Licuadora",
                            "Mesa para cuatro",
                            "Parrilla eléctrica",
                            "Platos",
                            "Radio reloj despertador",
                            "Refrigerador",
                            "Sala con sofá cama",
                            "Secadora de cabello",
                            "Teléfono de marcado directo",
                            "Tostador",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 1 Matrimonial",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18956232,
                        "kidsFreeTo": 3,
                        "name": "Suite superior de 1 dormitorio - con desayuno",
                        "isActive": true,
                        "view": "Hotel",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/16pP9pmwJVcWE09ACeQaXl8TgPQ=/720x480/04/81/45/04814549.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/16pP9pmwJVcWE09ACeQaXl8TgPQ=/720x480/04/81/45/04814549.jpg"
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Canchas de pádel",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños (5-12 años)",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cunas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Deportes terrestres",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Habitación de hospitalidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Jacuzzi",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de belleza",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Sillas de ruedas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Spa",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 4,
                    "totalSurveys": 1581,
                    "valuesAverage": [
                        4.4,
                        4.6
                    ]
                },
                "title": "Hotel de playa cerca de la Marina Vallarta",
                "uri": "villa-del-palmar-beach-resort-and-spa-puerto-vallarta",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores de 10:00 a 17:00 hrs."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños entre 5 y 12 años, supervisado por adultos. Abierto diariamente de 10:00 a 17:00 hrs. Ten en cuenta que las actividades para niños se basan en el número de niños que hay en el hotel en ese momento, no en un horario regular establecido."
                    },
                    {
                        "title": "Entretenimiento",
                        "description": "Incluye shows y fiestas nocturnos."
                    },
                    {
                        "title": "Alimentos y bebidas",
                        "description": "Incluye desayuno y almuerzo bufet o a la carta. Reservaciones en 2 de los restaurantes al registrarse. Aperitivos diarios de 11:30 a 18:00 hrs."
                    },
                    {
                        "title": "Deportes en tierra",
                        "description": "Los deportes en tierra incluyen cancha de tenis y voleibol en la playa."
                    },
                    {
                        "title": "Otros",
                        "description": "Facilidades para el cuidado del infante disponibles, como refrigerador, microondas y estación para esterilización de botellas. Uso del gimnasio de 07:00 a 20:00 hrs y del cuarto de juegos de 09:00 a 20:00 hrs (jóvenes de 14 años en adelante)."
                    },
                    {
                        "title": "Restricciones",
                        "description": "El estacionamiento es exclusivo para automóviles y no se permite el acceso a otros vehículos como autobuses, remolques, buggies, motos, razers, cuatrimotos, etc."
                    }
                ],
                "description": "Plaza Pelícanos Grand Beach Resort es un hotel todo incluido ubicado en la playa Las Glorias en Puerto Vallarta. El hotel está situado a 5 minutos de distancia del centro y de la vida nocturna de la ciudad. Adicionalmente, el Aeropuerto Internacional Licenciado Gustavo Díaz Ordaz (PVR) se localiza a sólo 6 kilómetros del hotel. \r\n\r\nPlaza Pelícanos Grand Beach Resort ofrece 100 habitaciones distribuidas a lo largo de tres edificios. Las habitaciones están equipadas con aire acondicionado, ventilador de techo, caja de seguridad, televisión por cable, batas de baño, pantuflas, plancha y tabla de planchar, secadora de pelo, así como baño privado con ducha. \r\n\r\nPlaza Pelícanos Grand Beach Resort cuenta con acceso directo a la playa, una piscina panorámica y gimnasio. Las familias podrán disfrutar una sala de juegos, un club de niños y numerosos deportes terrestres. Para deleitar el paladar, el hotel tiene una pizzería, dos restaurantes de especialidades internacionales, y uno cuenta con servicio tipo bufet; un snack bar y un bar. El hotel además ofrece servicio a la habitación.\r\n\r\n***El servicio a la habitación tiene un horario de 07:00 a 18:00 hrs con cargo adicional del 17% del total del pedido. El servicio a la habitación tiene costo total del “menú a la carta” en horario nocturno de 18:01 a 06:59 hrs.\r\n\r\n***Las reservas de 5 habitaciones o más se considerarán como un grupo. En caso de reservas de grupo, el hotel se pondrá en contacto con el huésped y/o la agencia para gestionar las condiciones especiales de depósito y cancelación para el grupo. Si el hotel no puede comunicarse con el huésped y/o la agencia y el depósito no se realiza bajo las condiciones del grupo, las reservas se cancelarán automáticamente. Para obtener más información, póngase en contacto con el establecimiento.\r\n\r\n***Se requiere identificación oficial (INE) o pasaporte del titular para realizar el proceso de check-in.\r\n\r\n***El estacionamiento es exclusivo para automóviles. No se permite el acceso a otros vehículos como autobuses, remolques, buggies, motos, razers, cuatrimotos, etc.\r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/d624a812aaa557a7dfac0061cb3202b5b630a0ef23828d9f3af4ae6e8b0ae838_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/68a3577df7fb632f057168a5f2953f0c08f7b30a09a32c90df8136f109281825.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/fa69af1d38646e013e7d6967106852a4eb781f6e85e24d3f3a56424000a361ce.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/edbb98edda761f160f8a8921aed78c27ab7d64e4212ad36e0d3ef8de17a022ac.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/b56c8a0fc0201e8f0b03e7a6c75d1dbb2e18c0d5a36dc2088f38176417f3fcb4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/ffab1e6bd802c707d6fd3588bb1e99c4e3a320a5b476ece44cfbe1d3f5abb67f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/97a4a3266854f2a26f3285e0a4533b025c36896e95eb502fd2f77e2a91b4bf7d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/99b79cf52cedabea4f0406bd74b67085372ed469ad608c25858d98c2d0dab599.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/59d9249f80f0d8f955ac5b51f1788600c724187db25153356d6a7f9fd43bad0a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/7519c8f50e30b828fbf288d923803cade3fb1f52ec1333c3cf063664be6b5922.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/cb9f77bd29a77f90d82850c646b6af2f05c468519f360f15c4c1057292462799.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/33a44309ae6d97fdb6c453205c4433eea2c6da12aa2891bfd32dcd84b8ea0d34.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/57b7c5bb684b1c52f32490408061ae25d0938353ae4886d6e26de4c946a17ccd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/5a12a2ac566e0c1ca579a6b0200a41401978748ec4d717383a32648e5ad7e3ee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/9e14d8edcb3fd439ef01321678ca6be8d97fe9f704ac1e5d4dd4afc8ad256de6.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/f12d9e14a19b05356de5d49374b4fdf1a03e764e390bb9ad79bdbdeef30ca4cc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/ff292f5840ce059143e9064df3ab61e1caf14203903de9b30db3e3c4fcc57508.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/0fef9b996f6d2e0bad33d3c51e255db3da45576750e3dab52c38edc87429ee61.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/2a8ba86e1ebd26887562f9675d363dc38ed442b0749004ec686ab300b883a0a2.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/37a30dacd4304660cb96e7f4f1ca3fbe453829dc25237afcb923e36f3d2b6ec0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/1a31f7e2c1c1300d065320b056d87bd90eb1d83a20b340e618c7a7919ebc4762.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/9d61847ab8ade5032d46e3efde3f7d03fbe590a1d63ba928c31997c5a6f0ee5c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/5761d96f34aeeb650f173e210f256b2d4254d473b936cef37c1ced3904fdc14a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/a33e6e9ed4fad3d58c70944569f94be2ed951b117e0a2a993822317c3a695c3e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/112b2dc775721716ffdb0bfdcc738d7fb5a80403ca0a970b294f370948077991.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/df07efff7d1f624c3f16e429f5886cf3020f180603fe439a9f8aaf8f351a2b47.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/294c307d1b78c2a10afdc5b2a88c625d9872918e8a87aec718353189884d2a4f.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/a494121d8df1ef48d955ff41eff545625dcede62a452ba6b42cf094f25d7f8dd.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/5edab6431da6ca1c58ea2c5b5dcb2e9d902d3d9803703423090471ee1e58ea53.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/8a948823a1560e82b644ff4423d40194180db4df689aa13ad331efa3d6ecd42d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/613edf4d33f7e6a5dacee8824fea4dc10cc00d9b81d90d837e2d5891d85f4aef.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/9835873c2f6ca5911bfc5a0568df79a463d09152bb9119180e7fd3f2315be789.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/0bd756a75acf58c47773750331c6822d37a1e859248cc646d1ed5a5d10bcd97e.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/3974e5f14e424b225fbf33e71eeb6cb47fdda327467509ac24405bed25ee21dc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/b8bc1c4bd8f1815f5a1afe30e190988e72af0c1b02e7763543ce4b7f029eb6db.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/eeefacd9b2629bf74f50290dee710b0ea32b0119e024e42c31db7a632b13dee7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/1c91530362e4d3497ae4c70e72b48e833bbdf101c333deb1ec3bb02831003e74.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/40ae91db5733dd2a26bfac7164834c262847eb4e3d11f5c9d7224e484217d9f0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/c93c67f7b4a47cde2c223f5e67e4ee16672a81832e2b9b0ac2e50bda031ec4d5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/0816f9d2374d81e22e2fa1145112b26362309883f9ed592c88293a12281d1f46.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/c79a127aa47d9c6a1892fe39a0ba53e172338f5b9242ac8455f8499483079f0d.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/ca0d0619626239d406eb12d8a53a9811642af81d032e59069d1ee5681cc256d9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/8a6acf2658651a11a942dc9235386e95c699f1735c1f349d571c2aee2b001d15.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/e77b8a228d8466a3e2288419da89c5572a544c1aa9b970872b945292f25e44da.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/102541/24ddced367210ddc96d350dacbdc71ed0f58b981f22c3549b2b03355cc47f8c8.png"
                    }
                ],
                "hotelID": 102541,
                "importantFacilities": [
                    "Estacionamiento",
                    "Gimnasio",
                    "Wi-Fi"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.633868638637153",
                    "longitude": "-105.23300528526306",
                    "postalCode": "48330",
                    "state": "Jalisco",
                    "street": "José Clemente Orozco #131",
                    "countryCode": "MX"
                },
                "name": "Plaza Pelícanos Grand Beach Resort",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Pérgolas",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Flor de Calabaza",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Aqua Bar Calandria",
                        "type": "Bar"
                    },
                    {
                        "name": "Sky Bar Lounge",
                        "type": "Bar"
                    },
                    {
                        "name": "Pizzería Snack",
                        "type": "Restaurante"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065920,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065922,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065923,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065924,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065925,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065926,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065927,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065928,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065929,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065930,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065931,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065932,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065933,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065934,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065935,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065936,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065937,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065938,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065939,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065940,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065941,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065942,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065943,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065944,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065945,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065946,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065947,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065948,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065949,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065950,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065951,
                        "kidsFreeTo": 0,
                        "name": "Studio City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065952,
                        "kidsFreeTo": 0,
                        "name": "Studio With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065953,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065954,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065955,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065956,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065957,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065958,
                        "kidsFreeTo": 0,
                        "name": "Studio Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065959,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065960,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065961,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065962,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065963,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065964,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065965,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065966,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065967,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065968,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065969,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065970,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065971,
                        "kidsFreeTo": 0,
                        "name": "Executive Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065972,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065973,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065974,
                        "kidsFreeTo": 0,
                        "name": "Studio Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065975,
                        "kidsFreeTo": 0,
                        "name": "Studio 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065976,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065977,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065978,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065979,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065980,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065981,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065982,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065983,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065985,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065987,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065988,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065990,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065992,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065994,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065996,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065998,
                        "kidsFreeTo": 0,
                        "name": "Studio With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065999,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066000,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066001,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066002,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066003,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066004,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066005,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066006,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066007,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066008,
                        "kidsFreeTo": 0,
                        "name": "Studio Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066009,
                        "kidsFreeTo": 0,
                        "name": "2 King Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066011,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066013,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066015,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066016,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066018,
                        "kidsFreeTo": 0,
                        "name": "Premium Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066020,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066021,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066023,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066025,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066027,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066029,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066032,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066034,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066037,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066040,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066043,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066046,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18066048,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18883553,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18920086,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad (tamaño laptop)",
                            "Closet",
                            "Coctel de bienvenida",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Mesa de centro",
                            "Mesa y sillas",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Radio reloj despertador",
                            "Secadora de cabello",
                            "Servicio de concierge",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King o 2 Matrimoniales",
                        "capacity": 3,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 1005971,
                        "kidsFreeTo": 5,
                        "name": "Estándar doble",
                        "isActive": true,
                        "view": "Calle",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/7U0ovsWDthBTHTw0azdCXoleuEY=/720x480/10/33/49/10334932.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/7U0ovsWDthBTHTw0azdCXoleuEY=/720x480/10/33/49/10334932.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Barra de apoyo en la ducha",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Cama a baja altura",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha adaptada",
                            "Guardería en habitación (de pago)",
                            "Lavabo a baja altura",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 3954156,
                        "kidsFreeTo": 0,
                        "name": "Habitación estándar doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/bqP8bTX1gqvG4bpZ53kQy_fw_gc=/720x480/03/24/85/03248548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/bqP8bTX1gqvG4bpZ53kQy_fw_gc=/720x480/03/24/85/03248548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6030815,
                        "kidsFreeTo": 0,
                        "name": "Standard King Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/bqP8bTX1gqvG4bpZ53kQy_fw_gc=/720x480/03/24/85/03248548.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/bqP8bTX1gqvG4bpZ53kQy_fw_gc=/720x480/03/24/85/03248548.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Coctel de bienvenida",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Llave electrónica",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904881,
                        "kidsFreeTo": 5,
                        "name": "Estándar king",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/OIY_14KMhcUlgpbLkUttOFRi6io=/720x480/10/33/49/10334934.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/OIY_14KMhcUlgpbLkUttOFRi6io=/720x480/10/33/49/10334934.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cocina equipada",
                            "Coctel de bienvenida",
                            "Cubiertos",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Estufa de 4 quemadores",
                            "Horno de microondas",
                            "Licuadora",
                            "Llave electrónica",
                            "Menú de almohadas",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Platos",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina"
                        ],
                        "bedding": "1 King",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904883,
                        "kidsFreeTo": 5,
                        "name": "Estudio con cocineta",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/4nqwsqxbUqPuZSX21VNccY375NI=/720x480/10/33/49/10334935.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/4nqwsqxbUqPuZSX21VNccY375NI=/720x480/10/33/49/10334935.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cocina equipada",
                            "Coctel de bienvenida",
                            "Cubiertos",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Estufa de 4 quemadores",
                            "Horno de microondas",
                            "Licuadora",
                            "Llave electrónica",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Platos",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904902,
                        "kidsFreeTo": 5,
                        "name": "Suite de 1 dormitorio vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/h0ja-4viBvjy1dUYbM3y0RDfD0g=/720x480/10/33/49/10334938.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/h0ja-4viBvjy1dUYbM3y0RDfD0g=/720x480/10/33/49/10334938.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "1 recámara",
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cocina equipada",
                            "Coctel de bienvenida",
                            "Cubiertos",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Estufa de 4 quemadores",
                            "Horno de microondas",
                            "Licuadora",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Platos",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Sofá cama",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904906,
                        "kidsFreeTo": 5,
                        "name": "Suite de 1 dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/_DToeCsLeg7VuwxCcEaQ9QbexX8=/720x480/10/33/49/10334936.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/_DToeCsLeg7VuwxCcEaQ9QbexX8=/720x480/10/33/49/10334936.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cocina equipada",
                            "Coctel de bienvenida",
                            "Cubiertos",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Estufa de 4 quemadores",
                            "Horno de microondas",
                            "Licuadora",
                            "Llave electrónica",
                            "Mesa y sillas",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Platos",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904917,
                        "kidsFreeTo": 5,
                        "name": "Suite familiar de 2 dormitorios vista a la piscina",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/vZ58jCKQ5xnQ98Jbx0bfBxly9jU=/720x480/10/33/49/10334937.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/vZ58jCKQ5xnQ98Jbx0bfBxly9jU=/720x480/10/33/49/10334937.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "2 recámaras",
                            "Aire acondicionado",
                            "Área de descanso",
                            "Baño privado con bañera y ducha",
                            "Batas",
                            "Cafetera",
                            "Caja de seguridad",
                            "Closet",
                            "Cocina equipada",
                            "Cubiertos",
                            "Detectores de humo",
                            "Espejo de tocador",
                            "Estufa de 4 quemadores",
                            "Horno de microondas",
                            "Licuadora",
                            "Llave electrónica",
                            "Pantuflas",
                            "Plancha y tabla de planchar",
                            "Platos",
                            "Refrigerador",
                            "Secadora de cabello",
                            "Servicio de despertador",
                            "Teléfono de marcado directo",
                            "TV de pantalla plana",
                            "TV por cable/satélite",
                            "Utensilios de cocina",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 2 Matrimoniales",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6904925,
                        "kidsFreeTo": 5,
                        "name": "Suite familiar de 2 dormitorios vista al mar",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/L61x9NrMANfJv4LpLmH4NZhYmBg=/720x480/10/33/49/10334939.png"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/L61x9NrMANfJv4LpLmH4NZhYmBg=/720x480/10/33/49/10334939.png"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6970729,
                        "kidsFreeTo": 0,
                        "name": "Studio with Kitchenette",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minicocina",
                            "Nevera/congelador tamaño estándar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6970735,
                        "kidsFreeTo": 0,
                        "name": "One Bedroom Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minicocina",
                            "Nevera/congelador tamaño estándar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6970736,
                        "kidsFreeTo": 0,
                        "name": "One Bedroom Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minicocina",
                            "Nevera/congelador tamaño estándar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6970737,
                        "kidsFreeTo": 0,
                        "name": "Two Bedroom Family Suite Pool View",
                        "isActive": true,
                        "view": "Vistas a la piscina",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Armario o ropero",
                            "Baño privado",
                            "Cafetera y tetera",
                            "Caja fuerte en la habitación",
                            "Calefacción",
                            "Champú",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Escritorio",
                            "Espacio para trabajar con ordenador portátil",
                            "Guardería en habitación (de pago)",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "Mesa de comedor",
                            "Minicocina",
                            "Nevera/congelador tamaño estándar",
                            "No fumadores",
                            "Número de camas - 1",
                            "Plancha o tabla de planchar",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo",
                            "Servicio de habitaciones (horario limitado)",
                            "Solo ducha",
                            "Suelo de acabado liso en la habitación",
                            "Tamaño del televisor: 32",
                            "Teléfono",
                            "Televisión",
                            "Televisión de pantalla plana",
                            "Televisión por cable",
                            "Toallas",
                            "TV con subtítulos",
                            "Ventilador de techo",
                            "Zona de comedor independiente"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 6970738,
                        "kidsFreeTo": 0,
                        "name": "Two Bedroom Family Suite Ocean View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 8443213,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 8443215,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 17947136,
                        "kidsFreeTo": 0,
                        "name": "Estudio Con Cocina Americana",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065707,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065709,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065713,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065716,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065719,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065722,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065725,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065727,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065729,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065731,
                        "kidsFreeTo": 0,
                        "name": "Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065733,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065736,
                        "kidsFreeTo": 0,
                        "name": "Shared Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065738,
                        "kidsFreeTo": 0,
                        "name": "Suite Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065742,
                        "kidsFreeTo": 0,
                        "name": "Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065745,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065748,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065752,
                        "kidsFreeTo": 0,
                        "name": "Double Room Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065755,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065757,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065760,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065763,
                        "kidsFreeTo": 0,
                        "name": "Single Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065767,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065769,
                        "kidsFreeTo": 0,
                        "name": "Premium",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065771,
                        "kidsFreeTo": 0,
                        "name": "Executive Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065774,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065776,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065779,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065782,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065786,
                        "kidsFreeTo": 0,
                        "name": "Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065789,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065791,
                        "kidsFreeTo": 0,
                        "name": "Studio City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065793,
                        "kidsFreeTo": 0,
                        "name": "Studio With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065794,
                        "kidsFreeTo": 0,
                        "name": "Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065795,
                        "kidsFreeTo": 0,
                        "name": "For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065796,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065797,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065798,
                        "kidsFreeTo": 0,
                        "name": "King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065799,
                        "kidsFreeTo": 0,
                        "name": "Studio Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065801,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065803,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065805,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065807,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065809,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065811,
                        "kidsFreeTo": 0,
                        "name": "Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065813,
                        "kidsFreeTo": 0,
                        "name": "Double Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065815,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065817,
                        "kidsFreeTo": 0,
                        "name": "2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065819,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065821,
                        "kidsFreeTo": 0,
                        "name": "Suite For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065822,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065824,
                        "kidsFreeTo": 0,
                        "name": "Executive Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065826,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065828,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065830,
                        "kidsFreeTo": 0,
                        "name": "Studio Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065832,
                        "kidsFreeTo": 0,
                        "name": "Studio 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065833,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065835,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065837,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065839,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065841,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065843,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065845,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065847,
                        "kidsFreeTo": 0,
                        "name": "Queen Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065849,
                        "kidsFreeTo": 0,
                        "name": "2 Beds Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065851,
                        "kidsFreeTo": 0,
                        "name": "Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065853,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065855,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065856,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065858,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed 1 Bedroom For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065860,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065862,
                        "kidsFreeTo": 0,
                        "name": "Studio With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065864,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065866,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Beds 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065868,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed For Non-Smokers",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065870,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065872,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065874,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065876,
                        "kidsFreeTo": 0,
                        "name": "Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065878,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065880,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065882,
                        "kidsFreeTo": 0,
                        "name": "Studio Apartment",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065884,
                        "kidsFreeTo": 0,
                        "name": "2 King Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065886,
                        "kidsFreeTo": 0,
                        "name": "Apartment 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065888,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065890,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065892,
                        "kidsFreeTo": 0,
                        "name": "Double Bed Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065894,
                        "kidsFreeTo": 0,
                        "name": "Premium Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065896,
                        "kidsFreeTo": 0,
                        "name": "Suite 2 Bedrooms Pool View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065898,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms City View",
                        "isActive": true,
                        "view": "Ciudad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065900,
                        "kidsFreeTo": 0,
                        "name": "Double Room Studio Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065902,
                        "kidsFreeTo": 0,
                        "name": "Apartment 2 Bedrooms With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065903,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065905,
                        "kidsFreeTo": 0,
                        "name": "Suite Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065907,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065909,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065911,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065913,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065915,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065916,
                        "kidsFreeTo": 0,
                        "name": "Studio King Bed With Kitchen",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18065917,
                        "kidsFreeTo": 0,
                        "name": "Apartment Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18637655,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Cama Queen Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18637657,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado individual",
                            "Baño",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Ducha",
                            "Escritorio",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Nevera",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Plancha con tabla",
                            "Sala de estar",
                            "Secador",
                            "Servicio de limpieza",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Ventilador"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18637659,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Secador",
                            "Televisión"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18739774,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Albornoz",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Cafetera / Tetera",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Espejo de aumento",
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Lavadora",
                            "Minibar",
                            "Número de dormitorios",
                            "Plancha con tabla",
                            "Radio",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Servicio despertador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Ventilador",
                            "Wi-fi",
                            "Zapatillas"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18739780,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Secador",
                            "Televisión"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800590,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas A La Piscina Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Habitaciones para fumadores",
                            "Kit de baño",
                            "Secador",
                            "Televisión"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 18800592,
                        "kidsFreeTo": 0,
                        "name": "Suite Vistas Al Oceano",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Bathroom",
                            "Cable TV",
                            "Desk",
                            "Direct dial telephone",
                            "Fan",
                            "Fridge",
                            "Hairdryer",
                            "Housekeeping",
                            "Individually adjustable air conditioning",
                            "Ironing set",
                            "Kitchenette",
                            "Living room",
                            "Number of bedrooms",
                            "Safe",
                            "Shower",
                            "Smoking rooms",
                            "Tea and coffee making facilities ",
                            "Toiletries",
                            "TV",
                            "Wheelchair-accessible"
                        ],
                        "bedding": "Subject to availability",
                        "capacity": 2,
                        "checkInTime": "16:00",
                        "checkOutTime": "11:00",
                        "roomID": 19408585,
                        "kidsFreeTo": 0,
                        "name": "Suite King Bed One Bedroom",
                        "isActive": true,
                        "view": "Subject to availability",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Billar",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bodas",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Chapoteadero",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Especial de lunamieleros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Gimnasio",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones conectadas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones libres de humo",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Habitaciones para personas con discapacidad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Juegos de mesa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Pesca",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Ping pong",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Piscina",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Playa",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Rampas para silla de ruedas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salón de juegos",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio a la habitación",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de spa",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Transportación",
                        "hasExtraCharge": true
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.7,
                    "totalSurveys": 769,
                    "valuesAverage": [
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel todo incluido en Puerto Vallarta ideal para familias",
                "uri": "plaza-pelicanos-grand-beach-resort",
                "tags": [
                    {
                        "name": "Luna de miel & romance"
                    },
                    {
                        "name": "Spa"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ],
                    "I": [
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de tu elección."
                        },
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Otros",
                            "description": null
                        },
                        {
                            "type": "Restricciones",
                            "description": null
                        }
                    ]
                },
                "trace": null
            },
            {
                "isActive": true,
                "alerts": [],
                "allInclusivePlan": [
                    {
                        "title": "Actividades",
                        "description": "Actividades diarias conducidas por animadores. El programa varía diariamente."
                    },
                    {
                        "title": "Impuestos",
                        "description": "Todos los impuestos están incluidos."
                    },
                    {
                        "title": "Habitaciones",
                        "description": "Incluye las habitaciones de tu elección."
                    },
                    {
                        "title": "Deportes en Tierra",
                        "description": "Los deportes terrestres incluyen fútbol, básquetbol y tenis."
                    },
                    {
                        "title": "Club de Niños",
                        "description": "Incluye un programa de actividades para niños supervisado por adultos."
                    },
                    {
                        "title": "Entretenimiento nocturno",
                        "description": "Incluye entretenimiento nocturno, como noches de bingo y karaoke."
                    },
                    {
                        "title": "Alimentos y Bebidas",
                        "description": "Incluye desayuno de 7:30 a 11:00 a.m., almuerzo de 12:00 a 5:00 p.m., cena de 7:00 a 10:30 p.m. y bebidas nacionales e internacionales ilimitadas."
                    },
                    {
                        "title": "Deportes acuáticos no motorizados",
                        "description": "Los deportes acuáticos no motorizados incluyen paddle."
                    }
                ],
                "description": "Vamar Vallarta All Inclusive Marina and Beach Resort es un hotel con un estilo mediterráneo ubicado en la exclusiva zona de Marina Vallarta. Este hotel cerca de la marina de la ciudad, se encuentra a sólo 3 kilómetros del aeropuerto internacional de Puerto Vallarta (PVR). El hotel Vamar Vallarta Marina también se localiza a 5 kilómetros del centro de convenciones de la ciudad y a 7 kilómetros del centro de Puerto Vallarta.\r\n \r\nEste hotel en Puerto Vallarta ofrece 253 cómodas habitaciones equipadas con baño privado con regadera, aire acondicionado, ventilador de techo, televisión, teléfono de marcación directa y caja de seguridad. Adicionalmente, las habitaciones superiores cuentan con mayor espacio, un sofá cama y balcón con vistas a la marina, las albercas y el jardín. También este hotel tiene villas de 1, 2 o 3 recámaras con cocineta y comedor.\r\n\r\nVamar Vallarta All Inclusive Marina and Beach Resort ofrece 3 piscinas familiares y 1 piscina para adultos, acceso a internet inalámbrico en áreas comunes, una amplia variedad de actividades, deportes acuáticos no motorizados, al igual que un restaurante con servicio de desayuno, comida y cena bufet, restaurante de mariscos La Villa, restaurante italiano Magallanes (solo para adultos) y bares. Además, este hotel dispone de salones de reuniones con capacidad hasta para 250 invitados, resguardo de equipaje, renta de autos, servicios de lavandería y concierge, entre otros.\r\n\r\n***Toda reservación de 5 o más habitaciones será considerada un grupo, por lo que aplicarán condiciones especiales que debes consultar con nuestro departamento de servicio al cliente. Los datos de contacto aparecerán en tu itinerario una vez hecha la reserva.  \r\n\r\n***Antes de tu viaje, te recomendamos consultar los requisitos de entrada y estancia del país que visites directamente con las autoridades nacionales correspondientes. Te recordamos que es\u00A0responsabilidad del viajero cumplir con las normas y reglas establecidas en el país de destino.",
                "gallery": [
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/763b88b092abf38fe53096cebb7b2887a6019b6bbcaa3cf0c7f0cd2d100cf24b_main.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/5d7f63d1c7d1a3a6f47e20f89d494706c496779d219a515746adff62f8bf1e48.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/66d68d0c8c3c0f9b7e364e2aff9ff80a18260721599272c2b5794042fda426ca.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/8aeb0b51ca14134a6c09b6af790b5fe91d0203f4a342bcebf7fc2821c3e794c5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/60fc573cb353a7ee071b4aa39f18495602b52a768ee681c80a15a68bc33698c3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Habitación Superior con balcón - Todo incluido",
                        "cloudUri": "https://img.cdnpth.com/media/100142/3c9e7794cd62fa1c1c4695c3b065bdf46ecef593ea7f78451b7d3a15fdcf3f68.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/e9c054bd160b73b2d4da127f189efc07bfa5f652ed7d537d2dd6d07c2863bc41.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/37c19915a448605c909b9ed9cf9e4e47c4ceb36b8254a50b87d7233ee1879685.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/5fad1c6d43ff1f40e107acc41ad8c631f9aa3401cdd543fefccf80c0c1ffd069.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/bf0153789de495cb692fb2415050e8cc1eb8a8ba8b72f35273f2e87ef57131fe.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/4d818c8d4e43336439fddb2706ebb3637b48a21a60f2f48f1d0785850a0f5eee.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/7585cd2ceb869ef440fd65a108a3298f160cb9ad459af683e3d336cfaa85194c.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/0f180125cf5810ae656734141894c20d33c770f9f0f7ce1cf3cc147d0971a383.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/3f616f394ae869d091f5c1801bd871849de9c6c25e697aae3e154271ea2da7d4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/fc38e22639a61700113a0cc89c15c3d089816235f30241a3a32c53dc0b695da9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/c61e180d7f652c44d55c42c12072e620709985bcc974f562aaa18c5d06a77a58.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/8d761b7a1f58f9f9389703f7ab36ac8dd634881293a39040242cd3224fb09b75.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/3c67f8cec5c92ceb38e61078e2983a30d5521e07814ddf1640498f985978bbe8.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/bdba900758fb714ce1a4e2016f1d5d35161ff24357fd49c7bc0d9e47df100f97.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/7f652fc9759a7b01d1a89b610455118ff76b7350ad47a045336872fbad287229.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/66d9d4279f071e4622f255f6fe7a79635affd712b9c39d7548f77812f9811198.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/ba5830455584540e5fe19b5cce3c1f9cf9cc772933cb0b4314ff91bc68d4a7af.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/7d0ec3f70cc0f7f58756d9115a16970ffe3a650eb27b3692995dc0f3a549c1a3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/929ed16896a27f8a8de12aa7833e23cd00ddc80096f0a55238dc2030855ce50b.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/9d4b369a061a434e8ad43b6ba6a3adf8e44628ed0e1fb642280a3b5651993769.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/20266e235e3cf1be5695a4b89f2251703c6092c3c12e99a9dc24c40fbddd7b49.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/13eeebe1b32865653a6259bdf50f1d82e6a57f389dcace0b5736cd3dad4de394.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/29e27d51faba621214f7c13074d70cf5075c47ae802c1808c99d1882ac2eaab3.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/99cf0b8a362319d9e24b528d603841231367272038c597ecd039a7c1e8ef4732.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/1a1b796c0296f2d8083cddb96a2dc84702094bb116bf8b3607901beb96319401.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/ebcd5b5a7cfc168d076b92dde3f5b8f2b71208aaed9648fd5c4e0fe8f0490aa4.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/b5095e8b8a84a188392753f6a05b99e3e92c5a1a2fb5798adf6adaeba3154a00.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/5fd4ebd543e9b9213aedce2c1566fd3b2d5def413aa5da876dfc2c8ddbcab7fc.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/cbcb23aa165eb7530772f6232e74172e6c0c14d390e7733a2f399a3b293713ff.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/970153a28d0c7baaf30750b91a0ad3c386e327a2ae0d0a7115baff36964b9141.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Estándar con todo incluido - 1 cama extragrande",
                        "cloudUri": "https://img.cdnpth.com/media/100142/902d1971a396cefde9caf8f4462d9c54c26eb347322390a56bfdea5362234889.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/930be31556c0bd4ff4124f562dd71f86b4e7bd000d120e026ccd536e18f9f4b5.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/76f3129f3a0228b114b9140418cab50598a0020b5748acbcb5c6693e9cac435a.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/85271baa1de9fe5de26ebd62ae87350ecd80a7a8395d0be7a3e006c306b960b0.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/9326f9c7e032ab07dc8e1a5b29f94337f2c7cb585631b435cf8a44913b29c9c7.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/e68d0f03509d3363c6e26a9592f23990fb6903a4e99b00c64bf619252fa90760.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/7c6d5aa325e028149ec18f82e0aa9049dfd0f8c8c4ada5e2e4784e53a3c70649.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/ba8149a526d7120f5e2d974b785ce87f201c5fbeeaa6f3cae9e4a6c5721ee2b9.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/a6a743b4a21811753e5fb899ec44d9f6bfe8279328af713e2a29517842bbf5ab.png"
                    },
                    {
                        "photoID": 0,
                        "description": "Imagen de la galería de este alojamiento",
                        "cloudUri": "https://img.cdnpth.com/media/100142/3ec3a05c92d4eaa2ed55904487c9521c93d1a588aae4c16966e1a3af2b6f3b4a.png"
                    }
                ],
                "hotelID": 100142,
                "importantFacilities": [
                    "Alimentos 24 horas y bebidas premium",
                    "Alto estándar de limpieza",
                    "Estacionamiento gratuito"
                ],
                "location": {
                    "city": "Puerto Vallarta",
                    "country": "Mexico",
                    "latitude": "20.661859244788666",
                    "longitude": "-105.24996757507324",
                    "postalCode": "48335",
                    "state": "Jalisco",
                    "street": "Av Paseo de la Marina Sur s/n esq Vela , Marina Vallarta",
                    "countryCode": "MX"
                },
                "name": "Vamar Vallarta All Inclusive Marina and Beach Resort",
                "placeContainers": [
                    {
                        "id": 673255,
                        "uri": "puerto-vallarta-jalisco-mexico-ciudad",
                        "displayText": "Puerto Vallarta, Jalisco, México.",
                        "type": 6,
                        "code": null
                    },
                    {
                        "id": 56252,
                        "uri": "puerto-vallarta",
                        "displayText": "Puerto Vallarta, Jalisco, México",
                        "type": 6,
                        "code": "141"
                    },
                    {
                        "id": 69384,
                        "uri": "puerto-vallarta-area",
                        "displayText": "Puerto Vallarta (y alrededores), Jalisco, México",
                        "type": 3,
                        "code": "32"
                    },
                    {
                        "id": 398684,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 11,
                        "code": "PVR"
                    },
                    {
                        "id": 404566,
                        "uri": "pvr-puerto-vallarta-jalisco-mexico-aeropuerto-internacional-licenciado-gustavo-diaz-ordaz-rng",
                        "displayText": "PVR Puerto Vallarta, Jalisco, México - Aeropuerto Internacional Licenciado Gustavo Diaz Ordaz",
                        "type": 10,
                        "code": "PVR"
                    }
                ],
                "restaurants": [
                    {
                        "name": "Bita",
                        "type": "Bar"
                    },
                    {
                        "name": "Café Marina (bufet)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "Caracol (snacks)",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Lobby Bar",
                        "type": "Bar"
                    },
                    {
                        "name": "Magallanes (italiano - solo para adultos)",
                        "type": "Restaurante"
                    },
                    {
                        "name": "La Villa (mariscos)",
                        "type": "Restaurante Bar"
                    },
                    {
                        "name": "Teatro Bar",
                        "type": "Bar"
                    }
                ],
                "rooms": [
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378722,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378750,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378778,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378807,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378835,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378863,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378891,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378919,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378947,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18378976,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379005,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379033,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379060,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379088,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379115,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379142,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379169,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379196,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379222,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379248,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379273,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379297,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379321,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379344,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379367,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379391,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379416,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379441,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379465,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379490,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379515,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379540,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379565,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379589,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379614,
                        "kidsFreeTo": 0,
                        "name": "Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379639,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379664,
                        "kidsFreeTo": 0,
                        "name": "Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379691,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379717,
                        "kidsFreeTo": 0,
                        "name": "Villa 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379744,
                        "kidsFreeTo": 0,
                        "name": "Villa Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379770,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379795,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379820,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379844,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379867,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379890,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379913,
                        "kidsFreeTo": 0,
                        "name": "Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379935,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379957,
                        "kidsFreeTo": 0,
                        "name": "Villa Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18379979,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380003,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380027,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380052,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380078,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380103,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380129,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380155,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380180,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380205,
                        "kidsFreeTo": 0,
                        "name": "Superior Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380230,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380255,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380280,
                        "kidsFreeTo": 0,
                        "name": "Villa Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380305,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380330,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380354,
                        "kidsFreeTo": 0,
                        "name": "Single Room House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380379,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380405,
                        "kidsFreeTo": 0,
                        "name": "Triple Room House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380431,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380457,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380483,
                        "kidsFreeTo": 0,
                        "name": "House 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380509,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380536,
                        "kidsFreeTo": 0,
                        "name": "Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380562,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380589,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380616,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed Sofa Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380644,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Single Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380670,
                        "kidsFreeTo": 0,
                        "name": "House With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380696,
                        "kidsFreeTo": 0,
                        "name": "Family With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380723,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380749,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380775,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380801,
                        "kidsFreeTo": 0,
                        "name": "Superior Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380827,
                        "kidsFreeTo": 0,
                        "name": "Superior Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380853,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380879,
                        "kidsFreeTo": 0,
                        "name": "Family",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380905,
                        "kidsFreeTo": 0,
                        "name": "House Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380931,
                        "kidsFreeTo": 0,
                        "name": "Water View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380959,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18380988,
                        "kidsFreeTo": 0,
                        "name": "Superior Family Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381017,
                        "kidsFreeTo": 0,
                        "name": "Single Room Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381046,
                        "kidsFreeTo": 0,
                        "name": "Double Room Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381074,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381103,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom Garden View With View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381132,
                        "kidsFreeTo": 0,
                        "name": "2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381161,
                        "kidsFreeTo": 0,
                        "name": "Double Room 2 Beds 2 Twin Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381191,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed 2 Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381221,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sofa Bed Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381251,
                        "kidsFreeTo": 0,
                        "name": "Villa Sofa Bed Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381282,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa Sofa Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18381313,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Twin Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491215,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491232,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491249,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491266,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491282,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491301,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491318,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491333,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491350,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491367,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491384,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491401,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491419,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491437,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491455,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491472,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491490,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491508,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491524,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491541,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491558,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491574,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491589,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491604,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491618,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491633,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491648,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491664,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491680,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491696,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491714,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491732,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491751,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491769,
                        "kidsFreeTo": 0,
                        "name": "Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491788,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491807,
                        "kidsFreeTo": 0,
                        "name": "Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491826,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491846,
                        "kidsFreeTo": 0,
                        "name": "Villa Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491866,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491886,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491906,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491926,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491948,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491970,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18491992,
                        "kidsFreeTo": 0,
                        "name": "Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492015,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492040,
                        "kidsFreeTo": 0,
                        "name": "Villa Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492064,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492089,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492112,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492135,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492160,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492184,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492209,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492234,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492262,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492290,
                        "kidsFreeTo": 0,
                        "name": "Superior Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492318,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492346,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492375,
                        "kidsFreeTo": 0,
                        "name": "Villa Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492404,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492431,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492458,
                        "kidsFreeTo": 0,
                        "name": "Single Room House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492485,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492512,
                        "kidsFreeTo": 0,
                        "name": "Triple Room House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492539,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492564,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492590,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492616,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492643,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492669,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492696,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492723,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492751,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492779,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492807,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492835,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492863,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492892,
                        "kidsFreeTo": 0,
                        "name": "Villa 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492921,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492950,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18492979,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493008,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493037,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493066,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493094,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493123,
                        "kidsFreeTo": 0,
                        "name": "Villa King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493152,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493182,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493211,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493240,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493268,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493296,
                        "kidsFreeTo": 0,
                        "name": "Villa Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493321,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493346,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493372,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493399,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493424,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493451,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18493479,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3637863,
                        "kidsFreeTo": 4,
                        "name": "Estándar 2 dobles - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/fA3zTI1pMeDsxlte7qOy5iJXLB0=/720x480/05/02/06/05020683.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/fA3zTI1pMeDsxlte7qOy5iJXLB0=/720x480/05/02/06/05020683.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "2 Matrimoniales y 1 Sofá cama",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3637864,
                        "kidsFreeTo": 4,
                        "name": "Superior con balcón - todo incluido",
                        "isActive": true,
                        "view": "Puerto marino",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/W1YuvLch5-XlZTbPdunbGi5Pc64=/720x480/13/40/93/13409324.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/W1YuvLch5-XlZTbPdunbGi5Pc64=/720x480/13/40/93/13409324.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Área de descanso",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Cocineta",
                            "Comedor",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King y 1 Sofá cama",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3637865,
                        "kidsFreeTo": 4,
                        "name": "Villa de 1 dormitorio - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/eE7f7HE_oNyi0nG5AQSQEUHNsy4=/720x480/00/21/88/00218891.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/eE7f7HE_oNyi0nG5AQSQEUHNsy4=/720x480/00/21/88/00218891.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953069,
                        "kidsFreeTo": 0,
                        "name": "Estandar 2 camas Matrimoniales",
                        "isActive": true,
                        "view": "Vistas al puerto deportivo",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Balcón",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Climatizador en la habitación (aire acondicionado)",
                            "Cortinas opacas",
                            "Cunas o camas infantiles gratis",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "Pasillos de ancho adecuado para sillas de ruedas",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 3953070,
                        "kidsFreeTo": 0,
                        "name": "Superior con Balcón",
                        "isActive": true,
                        "view": "Vistas al puerto deportivo",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4198391,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo"
                        ],
                        "bedding": "Sujeto a disponibilidad",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 4543386,
                        "kidsFreeTo": 0,
                        "name": "1 Bedroom Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 7557235,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Acceso a internet",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Balcón",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Cuna bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Pequeña cocina",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "Terraza",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "2 Camas dobles de 131-150 de ancho",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 11582596,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Aire acondicionado",
                            "Baño privado con ducha",
                            "Caja de seguridad",
                            "Teléfono de marcado directo",
                            "TV por cable/satélite",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 King",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 15666688,
                        "kidsFreeTo": 4,
                        "name": "Estándar 1 king - todo incluido",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": "https://img.cdnpth.com/media/r13qx-AmzAeuZPTLK9eLYDkJbKs=/720x480/04/56/14/04561481.jpg"
                        },
                        "pictures": [
                            {
                                "cloudUri": "https://img.cdnpth.com/media/r13qx-AmzAeuZPTLK9eLYDkJbKs=/720x480/04/56/14/04561481.jpg"
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073310,
                        "kidsFreeTo": 0,
                        "name": "Villa Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073312,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073316,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073322,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073327,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073330,
                        "kidsFreeTo": 0,
                        "name": "Villa Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073331,
                        "kidsFreeTo": 0,
                        "name": "Doble Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073333,
                        "kidsFreeTo": 0,
                        "name": "Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073335,
                        "kidsFreeTo": 0,
                        "name": "Doble Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073336,
                        "kidsFreeTo": 0,
                        "name": "Individual Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073338,
                        "kidsFreeTo": 0,
                        "name": "Cuadruple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073340,
                        "kidsFreeTo": 0,
                        "name": "Triple Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073342,
                        "kidsFreeTo": 0,
                        "name": "Villa Con Cama Doble",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073344,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073346,
                        "kidsFreeTo": 0,
                        "name": "Doble Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073349,
                        "kidsFreeTo": 0,
                        "name": "Habitación Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073353,
                        "kidsFreeTo": 0,
                        "name": "Suite Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073356,
                        "kidsFreeTo": 0,
                        "name": "Villa Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073359,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073362,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073365,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Superior Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073366,
                        "kidsFreeTo": 0,
                        "name": "Habitación Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 5,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073367,
                        "kidsFreeTo": 0,
                        "name": "Triple Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073368,
                        "kidsFreeTo": 0,
                        "name": "Doble Dos Camas Dobles",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16073369,
                        "kidsFreeTo": 0,
                        "name": "Habitación Con Vistas",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible en silla de ruedas",
                            "Aire acondicionado",
                            "Baño privado",
                            "Caja fuerte en la habitación",
                            "Cortinas opacas",
                            "Ducha efecto lluvia",
                            "Escritorio",
                            "Limpieza de habitaciones diaria",
                            "Medida del tamaño del televisor: pulgadas",
                            "No fumadores",
                            "No hay cunas",
                            "Plancha o tabla de planchar (previa solicitud)",
                            "Productos de higiene personal gratis",
                            "Se proporcionan sábanas",
                            "Secador de pelo (previa solicitud)",
                            "Solo ducha",
                            "Televisión",
                            "Televisión de plasma",
                            "Televisión por cable",
                            "Toallas",
                            "Ventilador de techo"
                        ],
                        "bedding": "1 cama de matrimonio grande o 1 cama de matrimonio y 2 camas individuales",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16148137,
                        "kidsFreeTo": 0,
                        "name": "Estándar 1 cama King Size",
                        "isActive": true,
                        "view": "Vistas al puerto deportivo",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 7,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 16350600,
                        "kidsFreeTo": 0,
                        "name": "Tienda Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17214996,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior Con Balcón",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215014,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Vistas Al Jardín",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 2,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215030,
                        "kidsFreeTo": 0,
                        "name": "Doble Uso Individual Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 6,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215036,
                        "kidsFreeTo": 0,
                        "name": "Doble 1 O 2 Camas Economy",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215041,
                        "kidsFreeTo": 0,
                        "name": "Habitación Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 10,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 17215045,
                        "kidsFreeTo": 0,
                        "name": "Habitación Superior Con Terraza",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375538,
                        "kidsFreeTo": 0,
                        "name": "Double Room King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375562,
                        "kidsFreeTo": 0,
                        "name": "King Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375586,
                        "kidsFreeTo": 0,
                        "name": "Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375611,
                        "kidsFreeTo": 0,
                        "name": "Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375637,
                        "kidsFreeTo": 0,
                        "name": "Run Of House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375664,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375693,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375726,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375790,
                        "kidsFreeTo": 0,
                        "name": "Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375822,
                        "kidsFreeTo": 0,
                        "name": "Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375854,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375886,
                        "kidsFreeTo": 0,
                        "name": "With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375919,
                        "kidsFreeTo": 0,
                        "name": "Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375953,
                        "kidsFreeTo": 0,
                        "name": "Double Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18375989,
                        "kidsFreeTo": 0,
                        "name": "Triple Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376022,
                        "kidsFreeTo": 0,
                        "name": "Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376056,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376090,
                        "kidsFreeTo": 0,
                        "name": "2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376124,
                        "kidsFreeTo": 0,
                        "name": "Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376157,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376190,
                        "kidsFreeTo": 0,
                        "name": "Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376222,
                        "kidsFreeTo": 0,
                        "name": "Superior 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376255,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376288,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376321,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376354,
                        "kidsFreeTo": 0,
                        "name": "Suite Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376387,
                        "kidsFreeTo": 0,
                        "name": "House",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376420,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376453,
                        "kidsFreeTo": 0,
                        "name": "Double Room Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376488,
                        "kidsFreeTo": 0,
                        "name": "Single Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376526,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376563,
                        "kidsFreeTo": 0,
                        "name": "Superior Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376599,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376635,
                        "kidsFreeTo": 0,
                        "name": "Superior With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376670,
                        "kidsFreeTo": 0,
                        "name": "Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376705,
                        "kidsFreeTo": 0,
                        "name": "Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376739,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376811,
                        "kidsFreeTo": 0,
                        "name": "Villa Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376845,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376880,
                        "kidsFreeTo": 0,
                        "name": "Single Room With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376916,
                        "kidsFreeTo": 0,
                        "name": "Family Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376950,
                        "kidsFreeTo": 0,
                        "name": "Superior With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18376985,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377019,
                        "kidsFreeTo": 0,
                        "name": "Superior Triple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377055,
                        "kidsFreeTo": 0,
                        "name": "Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377091,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Villa",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377125,
                        "kidsFreeTo": 0,
                        "name": "Villa Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377160,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377195,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377229,
                        "kidsFreeTo": 0,
                        "name": "Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377263,
                        "kidsFreeTo": 0,
                        "name": "Superior King Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377297,
                        "kidsFreeTo": 0,
                        "name": "Family Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377331,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377363,
                        "kidsFreeTo": 0,
                        "name": "Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377395,
                        "kidsFreeTo": 0,
                        "name": "Villa Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377427,
                        "kidsFreeTo": 0,
                        "name": "Villa 1 Bedroom Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377459,
                        "kidsFreeTo": 0,
                        "name": "Superior Port View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377490,
                        "kidsFreeTo": 0,
                        "name": "Superior Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377521,
                        "kidsFreeTo": 0,
                        "name": "Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377552,
                        "kidsFreeTo": 0,
                        "name": "Villa Quadruple Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18377582,
                        "kidsFreeTo": 0,
                        "name": "Superior Sofa Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427051,
                        "kidsFreeTo": 0,
                        "name": "Deluxe",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427079,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427107,
                        "kidsFreeTo": 0,
                        "name": "Double Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427137,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room 2 Beds",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427166,
                        "kidsFreeTo": 0,
                        "name": "Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427196,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427226,
                        "kidsFreeTo": 0,
                        "name": "Matrimonial Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427258,
                        "kidsFreeTo": 0,
                        "name": "Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427289,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427320,
                        "kidsFreeTo": 0,
                        "name": "Deluxe Suite Single Room",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427351,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427381,
                        "kidsFreeTo": 0,
                        "name": "King Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427410,
                        "kidsFreeTo": 0,
                        "name": "Junior Suite Quadruple Room Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427439,
                        "kidsFreeTo": 0,
                        "name": "Villa 2 Bedrooms",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427467,
                        "kidsFreeTo": 0,
                        "name": "Double Room Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427495,
                        "kidsFreeTo": 0,
                        "name": "King Bed Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427523,
                        "kidsFreeTo": 0,
                        "name": "Premium Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427551,
                        "kidsFreeTo": 0,
                        "name": "Deluxe With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427579,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427606,
                        "kidsFreeTo": 0,
                        "name": "Double Room Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427632,
                        "kidsFreeTo": 0,
                        "name": "Superior Single Room With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427658,
                        "kidsFreeTo": 0,
                        "name": "Villa King Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427684,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427709,
                        "kidsFreeTo": 0,
                        "name": "Double Room Sofa Bed Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427734,
                        "kidsFreeTo": 0,
                        "name": "Premium Double Room Suite 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427758,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427782,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Double Bed 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427805,
                        "kidsFreeTo": 0,
                        "name": "Villa Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427828,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite Single Room 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427851,
                        "kidsFreeTo": 0,
                        "name": "Premium Junior Suite Garden View",
                        "isActive": true,
                        "view": "Jardín",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427874,
                        "kidsFreeTo": 0,
                        "name": "Triple Room Villa 1 Bedroom",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427897,
                        "kidsFreeTo": 0,
                        "name": "Sea View With View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427920,
                        "kidsFreeTo": 0,
                        "name": "Premium Suite 1 Bedroom Sea View",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427943,
                        "kidsFreeTo": 0,
                        "name": "Superior 1 Twin Bed",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18427970,
                        "kidsFreeTo": 0,
                        "name": "Superior Double Room Double Bed With Balcony",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532427,
                        "kidsFreeTo": 0,
                        "name": "Habitación 2 Camas Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 1,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18532428,
                        "kidsFreeTo": 0,
                        "name": "Individual Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "($)Acceso a internet",
                            "Agua caliente",
                            "Aire acondicionado",
                            "Amenidades para el baño",
                            "Baño privado con ducha",
                            "Closet",
                            "Espejo de tocador",
                            "Mesa de trabajo",
                            "Servicio de despertador",
                            "Teléfono",
                            "TV por cable/satélite"
                        ],
                        "bedding": "1 Cama o 2 Camas o 3 Camas o 4 Camas",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18563648,
                        "kidsFreeTo": 0,
                        "name": "Double Twin",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "1 Cama king size 150-183 ancho",
                        "capacity": 3,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18827167,
                        "kidsFreeTo": 0,
                        "name": "Habitación Cama King Size",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18890785,
                        "kidsFreeTo": 0,
                        "name": "Villa Dos Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18977511,
                        "kidsFreeTo": 0,
                        "name": "Doble Standard",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 4,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18977514,
                        "kidsFreeTo": 0,
                        "name": "Doble Superior",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 8,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18977517,
                        "kidsFreeTo": 0,
                        "name": "Suite Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Camas",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 18977563,
                        "kidsFreeTo": 0,
                        "name": "Villa Cama King Size Un Dormitorio",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    },
                    {
                        "amenities": [
                            "Accesible para personas de movilidad reducida",
                            "Aire acondicionado central",
                            "Aire acondicionado individual",
                            "Bañera",
                            "Baño",
                            "Baño para personas de movilidad reducida",
                            "Caja fuerte",
                            "Camas supletorias bajo petición",
                            "Ducha",
                            "Habitaciones para fumadores",
                            "Número de dormitorios",
                            "Reloj despertador",
                            "Sala de estar",
                            "Secador",
                            "Teléfono de línea directa",
                            "Televisión",
                            "TV por cable",
                            "Wi-fi"
                        ],
                        "bedding": "Sujetas a disponibilidad",
                        "capacity": 20,
                        "checkInTime": "15:00",
                        "checkOutTime": "11:00",
                        "roomID": 20356357,
                        "kidsFreeTo": 0,
                        "name": "Villa Tres Dormitorios",
                        "isActive": true,
                        "view": "Sujeto a disponibilidad",
                        "picture": {
                            "cloudUri": null
                        },
                        "pictures": [
                            {
                                "cloudUri": null
                            }
                        ]
                    }
                ],
                "services": [
                    {
                        "name": "4 piscinas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Alto estándar de limpieza",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Área para niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Basquetbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Bicicletas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Caja de seguridad",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camas extra",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Camastros",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Cambio de divisas",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Club de niños",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Concierge",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Deportes acuáticos no motorizados",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Elevador",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Entretenimiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Estacionamiento",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Futbol",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Internet inalámbrico áreas comunes",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Kayaks",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Niñera",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Playa privada",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Renta de autos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Resguardo de equipaje",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Salones de eventos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Se aceptan tarjetas de crédito",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de ama de llaves",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Servicio de masajes",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios de lavandería",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios ejecutivos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Servicios médicos",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Solárium",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tenis",
                        "hasExtraCharge": false
                    },
                    {
                        "name": "Tours",
                        "hasExtraCharge": true
                    },
                    {
                        "name": "Voleibol",
                        "hasExtraCharge": false
                    }
                ],
                "stars": 4,
                "surveyAverage": {
                    "averageValue": 3.3,
                    "totalSurveys": 942,
                    "valuesAverage": [
                        4.1,
                        4.4,
                        4.3
                    ]
                },
                "title": "Hotel cerca de la marina de Puerto Vallarta",
                "uri": "vamar-vallarta-all-inclusive-marina-and-beach-resort",
                "tags": [
                    {
                        "name": "Familiar"
                    },
                    {
                        "name": "Playa"
                    },
                    {
                        "name": "Alto estándar de limpieza"
                    }
                ],
                "mealPlans": {
                    "AZ": [
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varia diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        }
                    ],
                    "I": [
                        {
                            "type": "Actividades",
                            "description": "Actividades diarias conducidas por animadores. El programa varia diariamente."
                        },
                        {
                            "type": "Impuestos y propinas",
                            "description": "Todos los impuestos y propinas están incluidos."
                        },
                        {
                            "type": "Habitaciones",
                            "description": "Incluye las habitaciones de su elección"
                        },
                        {
                            "type": "Deportes en tierra",
                            "description": "Los deportes en tierra incluyen...."
                        },
                        {
                            "type": "Club de niños",
                            "description": "Incluye un programa de actividades para niños entre X y X años, supervisado por adultos. Abierto diariamente de YY:00 a ZZ:00 hrs."
                        },
                        {
                            "type": "Entretenimiento",
                            "description": "Incluye espectaculares shows nocturnos. El programa varía diariamente."
                        },
                        {
                            "type": "Alimentos y bebidas",
                            "description": "Incluye todos los alimentos y bebidas. Comprende desayuno bufet y comida y cena a elegir entre bufet o a la carta."
                        },
                        {
                            "type": "Deportes acuáticos no motorizados",
                            "description": "Incluye actividades acuáticas no motorizadas como..."
                        }
                    ]
                },
                "trace": null
            }
        ]
    },
    {
        "destinoId": 6,
        titulo: "Hoteles en Cancún y Riviera Maya",
        destino: "Huatulco",
        hoteles: [
            { name: "Coral Blue Huatulco All Inclusive" },
            { name: "Binniguenda Huatulco and Beach Club" },
            { name: "Park Royal Beach Huatulco" },
            { name: "Las Brisas Huatulco All Inclusive" },
            { name: "Dreams Huatulco Resort and Spa" },
            { name: "Isla Natura Beach Huatulco" },
            { name: "Castillo Huatulco" },
        ]
    },
    {
        "destinoId": 7,
        titulo: "Tequisquiapan",
        destino: "Tequisquiapan",
        hoteles: [
            { name: "Hotel Río" },
        ]
    },
    {
        "destinoId": 8,
        titulo: "Multidestino",
        destino: "Huatulco, Los Cabos o Riviera Maya",
        hoteles: [
            { name: "Hotel Coral Blue Huatulco" },
            { name: "Posada Real Los Cabos" },
            { name: "Allegro Playacar Riviera Maya" },
            { name: "Bluebay Grand Esmeralda Riviera Maya" },
            { name: "Catalonia Yucatán Beach" }]
    },
    {
        "destinoId": 9,
        titulo: "Riviera Nayarit",
        destino: "Riviera Nayarit y Nuevo Vallarta",
        hoteles: [
            { name: "Decameron Isla Coral, Ramada All-Inclusive Resort" },
            { name: "Samba Vallarta All Inclusive Beach Resort by Emporio Hotels" },
            { name: "Wyndham Alltra Vallarta, All-Inclusive Resort" },
            { name: "Riu Jalisco All Inclusive" }]
    },
    {
        "destinoId": 10,
        titulo: "Mérida",
        destino: "Mérida",
        hoteles: [
            { name: "Reef Yucatan Hotel and Convention Center All Inclusive" }]
    },
    {
        "destinoId": 11,
        titulo: "Ixtapa Zihuatanejo",
        destino: "Ixtapa Zihuatanejo",
        hoteles: [
            { name: "Tesoro Ixtapa All Inclusive" },
            
            { name: "Radison Resort Ixtapa" },
            
            { name: "Sheraton Ixtapa" },
            
            { name: "Enna Inn Ixtapa Rooms" },
            
            { name: "Barceló Ixtapa" },
        ]
    },
    {
        "destinoId": 12,
        titulo: "Cancún y Riviera Maya",
        destino: "Cancún y Riviera Maya",
        hoteles: [
            { name: "Residence Inn by Marriott Cancun Hotel Zone" },
            
            { name: "Radison Resort Ixtapa" },
            
            { name: "Sheraton Ixtapa" },
            
            { name: "Enna Inn Ixtapa Rooms" },
            
            { name: "Barceló Ixtapa" },
        ]
    },

]

export default destinos;
